(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired063"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired063"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("89wqa", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $5ef850295e0236ca$export$ffb0004e005737fa, (v) => $5ef850295e0236ca$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $5ef850295e0236ca$export$34b9dba7ce09269b, (v) => $5ef850295e0236ca$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $5ef850295e0236ca$export$25062201e9e25d76, (v) => $5ef850295e0236ca$export$25062201e9e25d76 = v);
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5ef850295e0236ca$export$ffb0004e005737fa;
var $5ef850295e0236ca$export$34b9dba7ce09269b;
var $5ef850295e0236ca$export$25062201e9e25d76;
"use strict";
parcelRequire("k1s95");

var $8NFma = parcelRequire("8NFma");
var $5ef850295e0236ca$var$g = 60103;
$5ef850295e0236ca$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $5ef850295e0236ca$var$h = Symbol.for;
    $5ef850295e0236ca$var$g = $5ef850295e0236ca$var$h("react.element");
    $5ef850295e0236ca$export$ffb0004e005737fa = $5ef850295e0236ca$var$h("react.fragment");
}
var $5ef850295e0236ca$var$m = $8NFma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $5ef850295e0236ca$var$n = Object.prototype.hasOwnProperty, $5ef850295e0236ca$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $5ef850295e0236ca$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$5ef850295e0236ca$var$n.call(a, b) && !$5ef850295e0236ca$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $5ef850295e0236ca$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $5ef850295e0236ca$var$m.current
    };
}
$5ef850295e0236ca$export$34b9dba7ce09269b = $5ef850295e0236ca$var$q;
$5ef850295e0236ca$export$25062201e9e25d76 = $5ef850295e0236ca$var$q;

});
parcelRegister("k1s95", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $e939bbc6f2d9bc5d$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $e939bbc6f2d9bc5d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $e939bbc6f2d9bc5d$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $e939bbc6f2d9bc5d$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $e939bbc6f2d9bc5d$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $e939bbc6f2d9bc5d$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $e939bbc6f2d9bc5d$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($e939bbc6f2d9bc5d$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($e939bbc6f2d9bc5d$var$getOwnPropertySymbols) {
            symbols = $e939bbc6f2d9bc5d$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($e939bbc6f2d9bc5d$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("8NFma", function(module, exports) {
"use strict";

module.exports = (parcelRequire("j1rj6"));

});
parcelRegister("j1rj6", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $dd934af551f44020$export$ffb0004e005737fa, (v) => $dd934af551f44020$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "StrictMode", () => $dd934af551f44020$export$5f8d39834fd61797, (v) => $dd934af551f44020$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Profiler", () => $dd934af551f44020$export$e2c29f18771995cb, (v) => $dd934af551f44020$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "Suspense", () => $dd934af551f44020$export$74bf444e3cd11ea5, (v) => $dd934af551f44020$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "Children", () => $dd934af551f44020$export$dca3b0875bd9a954, (v) => $dd934af551f44020$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $dd934af551f44020$export$16fa2f45be04daa8, (v) => $dd934af551f44020$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "PureComponent", () => $dd934af551f44020$export$221d75b3f55bb0bd, (v) => $dd934af551f44020$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $dd934af551f44020$export$ae55be85d98224ed, (v) => $dd934af551f44020$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $dd934af551f44020$export$e530037191fcd5d7, (v) => $dd934af551f44020$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $dd934af551f44020$export$fd42f52fd3ae1109, (v) => $dd934af551f44020$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $dd934af551f44020$export$c8a8987d4410bf2d, (v) => $dd934af551f44020$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $dd934af551f44020$export$d38cd72104c1f0e9, (v) => $dd934af551f44020$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $dd934af551f44020$export$7d1e3a5e95ceca43, (v) => $dd934af551f44020$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $dd934af551f44020$export$257a8862b851cb5b, (v) => $dd934af551f44020$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $dd934af551f44020$export$a8257692ac88316c, (v) => $dd934af551f44020$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $dd934af551f44020$export$488013bae63b21da, (v) => $dd934af551f44020$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $dd934af551f44020$export$7c73462e0d25e514, (v) => $dd934af551f44020$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $dd934af551f44020$export$35808ee640e87ca7, (v) => $dd934af551f44020$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $dd934af551f44020$export$fae74005e78b1a27, (v) => $dd934af551f44020$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $dd934af551f44020$export$dc8fbce3eb94dc1e, (v) => $dd934af551f44020$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $dd934af551f44020$export$6d9c69b0de29b591, (v) => $dd934af551f44020$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $dd934af551f44020$export$d5a552a76deda3c2, (v) => $dd934af551f44020$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $dd934af551f44020$export$e5c5a5f917a5871c, (v) => $dd934af551f44020$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $dd934af551f44020$export$1538c33de8887b59, (v) => $dd934af551f44020$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $dd934af551f44020$export$13e3392192263954, (v) => $dd934af551f44020$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $dd934af551f44020$export$b8f5890fc79d6aca, (v) => $dd934af551f44020$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $dd934af551f44020$export$60241385465d0a34, (v) => $dd934af551f44020$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $dd934af551f44020$export$83d89fbfd8236492, (v) => $dd934af551f44020$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd934af551f44020$export$ffb0004e005737fa;
var $dd934af551f44020$export$5f8d39834fd61797;
var $dd934af551f44020$export$e2c29f18771995cb;
var $dd934af551f44020$export$74bf444e3cd11ea5;
var $dd934af551f44020$export$dca3b0875bd9a954;
var $dd934af551f44020$export$16fa2f45be04daa8;
var $dd934af551f44020$export$221d75b3f55bb0bd;
var $dd934af551f44020$export$ae55be85d98224ed;
var $dd934af551f44020$export$e530037191fcd5d7;
var $dd934af551f44020$export$fd42f52fd3ae1109;
var $dd934af551f44020$export$c8a8987d4410bf2d;
var $dd934af551f44020$export$d38cd72104c1f0e9;
var $dd934af551f44020$export$7d1e3a5e95ceca43;
var $dd934af551f44020$export$257a8862b851cb5b;
var $dd934af551f44020$export$a8257692ac88316c;
var $dd934af551f44020$export$488013bae63b21da;
var $dd934af551f44020$export$7c73462e0d25e514;
var $dd934af551f44020$export$35808ee640e87ca7;
var $dd934af551f44020$export$fae74005e78b1a27;
var $dd934af551f44020$export$dc8fbce3eb94dc1e;
var $dd934af551f44020$export$6d9c69b0de29b591;
var $dd934af551f44020$export$d5a552a76deda3c2;
var $dd934af551f44020$export$e5c5a5f917a5871c;
var $dd934af551f44020$export$1538c33de8887b59;
var $dd934af551f44020$export$13e3392192263954;
var $dd934af551f44020$export$b8f5890fc79d6aca;
var $dd934af551f44020$export$60241385465d0a34;
var $dd934af551f44020$export$83d89fbfd8236492;
"use strict";

var $k1s95 = parcelRequire("k1s95");
var $dd934af551f44020$var$n = 60103, $dd934af551f44020$var$p = 60106;
$dd934af551f44020$export$ffb0004e005737fa = 60107;
$dd934af551f44020$export$5f8d39834fd61797 = 60108;
$dd934af551f44020$export$e2c29f18771995cb = 60114;
var $dd934af551f44020$var$q = 60109, $dd934af551f44020$var$r = 60110, $dd934af551f44020$var$t = 60112;
$dd934af551f44020$export$74bf444e3cd11ea5 = 60113;
var $dd934af551f44020$var$u = 60115, $dd934af551f44020$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $dd934af551f44020$var$w = Symbol.for;
    $dd934af551f44020$var$n = $dd934af551f44020$var$w("react.element");
    $dd934af551f44020$var$p = $dd934af551f44020$var$w("react.portal");
    $dd934af551f44020$export$ffb0004e005737fa = $dd934af551f44020$var$w("react.fragment");
    $dd934af551f44020$export$5f8d39834fd61797 = $dd934af551f44020$var$w("react.strict_mode");
    $dd934af551f44020$export$e2c29f18771995cb = $dd934af551f44020$var$w("react.profiler");
    $dd934af551f44020$var$q = $dd934af551f44020$var$w("react.provider");
    $dd934af551f44020$var$r = $dd934af551f44020$var$w("react.context");
    $dd934af551f44020$var$t = $dd934af551f44020$var$w("react.forward_ref");
    $dd934af551f44020$export$74bf444e3cd11ea5 = $dd934af551f44020$var$w("react.suspense");
    $dd934af551f44020$var$u = $dd934af551f44020$var$w("react.memo");
    $dd934af551f44020$var$v = $dd934af551f44020$var$w("react.lazy");
}
var $dd934af551f44020$var$x = "function" === typeof Symbol && Symbol.iterator;
function $dd934af551f44020$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $dd934af551f44020$var$x && a[$dd934af551f44020$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $dd934af551f44020$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $dd934af551f44020$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $dd934af551f44020$var$B = {};
function $dd934af551f44020$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $dd934af551f44020$var$B;
    this.updater = c || $dd934af551f44020$var$A;
}
$dd934af551f44020$var$C.prototype.isReactComponent = {};
$dd934af551f44020$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($dd934af551f44020$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$dd934af551f44020$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $dd934af551f44020$var$D() {}
$dd934af551f44020$var$D.prototype = $dd934af551f44020$var$C.prototype;
function $dd934af551f44020$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $dd934af551f44020$var$B;
    this.updater = c || $dd934af551f44020$var$A;
}
var $dd934af551f44020$var$F = $dd934af551f44020$var$E.prototype = new $dd934af551f44020$var$D;
$dd934af551f44020$var$F.constructor = $dd934af551f44020$var$E;
$k1s95($dd934af551f44020$var$F, $dd934af551f44020$var$C.prototype);
$dd934af551f44020$var$F.isPureReactComponent = !0;
var $dd934af551f44020$var$G = {
    current: null
}, $dd934af551f44020$var$H = Object.prototype.hasOwnProperty, $dd934af551f44020$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $dd934af551f44020$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$dd934af551f44020$var$H.call(b, e) && !$dd934af551f44020$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $dd934af551f44020$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $dd934af551f44020$var$G.current
    };
}
function $dd934af551f44020$var$K(a, b) {
    return {
        $$typeof: $dd934af551f44020$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $dd934af551f44020$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $dd934af551f44020$var$n;
}
function $dd934af551f44020$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $dd934af551f44020$var$M = /\/+/g;
function $dd934af551f44020$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $dd934af551f44020$var$escape("" + a.key) : b.toString(36);
}
function $dd934af551f44020$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $dd934af551f44020$var$n:
                case $dd934af551f44020$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $dd934af551f44020$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($dd934af551f44020$var$M, "$&/") + "/"), $dd934af551f44020$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($dd934af551f44020$var$L(d) && (d = $dd934af551f44020$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($dd934af551f44020$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $dd934af551f44020$var$N(k, g);
        h += $dd934af551f44020$var$O(k, b, c, f, d);
    }
    else if (f = $dd934af551f44020$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $dd934af551f44020$var$N(k, g++), h += $dd934af551f44020$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($dd934af551f44020$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $dd934af551f44020$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $dd934af551f44020$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $dd934af551f44020$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $dd934af551f44020$var$R = {
    current: null
};
function $dd934af551f44020$var$S() {
    var a = $dd934af551f44020$var$R.current;
    if (null === a) throw Error($dd934af551f44020$var$z(321));
    return a;
}
var $dd934af551f44020$var$T = {
    ReactCurrentDispatcher: $dd934af551f44020$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $dd934af551f44020$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $k1s95
};
$dd934af551f44020$export$dca3b0875bd9a954 = {
    map: $dd934af551f44020$var$P,
    forEach: function(a, b, c) {
        $dd934af551f44020$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $dd934af551f44020$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $dd934af551f44020$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$dd934af551f44020$var$L(a)) throw Error($dd934af551f44020$var$z(143));
        return a;
    }
};
$dd934af551f44020$export$16fa2f45be04daa8 = $dd934af551f44020$var$C;
$dd934af551f44020$export$221d75b3f55bb0bd = $dd934af551f44020$var$E;
$dd934af551f44020$export$ae55be85d98224ed = $dd934af551f44020$var$T;
$dd934af551f44020$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($dd934af551f44020$var$z(267, a));
    var e = $k1s95({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $dd934af551f44020$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$dd934af551f44020$var$H.call(b, f) && !$dd934af551f44020$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $dd934af551f44020$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$dd934af551f44020$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $dd934af551f44020$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $dd934af551f44020$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$dd934af551f44020$export$c8a8987d4410bf2d = $dd934af551f44020$var$J;
$dd934af551f44020$export$d38cd72104c1f0e9 = function(a) {
    var b = $dd934af551f44020$var$J.bind(null, a);
    b.type = a;
    return b;
};
$dd934af551f44020$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$dd934af551f44020$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $dd934af551f44020$var$t,
        render: a
    };
};
$dd934af551f44020$export$a8257692ac88316c = $dd934af551f44020$var$L;
$dd934af551f44020$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $dd934af551f44020$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $dd934af551f44020$var$Q
    };
};
$dd934af551f44020$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $dd934af551f44020$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$dd934af551f44020$export$35808ee640e87ca7 = function(a, b) {
    return $dd934af551f44020$var$S().useCallback(a, b);
};
$dd934af551f44020$export$fae74005e78b1a27 = function(a, b) {
    return $dd934af551f44020$var$S().useContext(a, b);
};
$dd934af551f44020$export$dc8fbce3eb94dc1e = function() {};
$dd934af551f44020$export$6d9c69b0de29b591 = function(a, b) {
    return $dd934af551f44020$var$S().useEffect(a, b);
};
$dd934af551f44020$export$d5a552a76deda3c2 = function(a, b, c) {
    return $dd934af551f44020$var$S().useImperativeHandle(a, b, c);
};
$dd934af551f44020$export$e5c5a5f917a5871c = function(a, b) {
    return $dd934af551f44020$var$S().useLayoutEffect(a, b);
};
$dd934af551f44020$export$1538c33de8887b59 = function(a, b) {
    return $dd934af551f44020$var$S().useMemo(a, b);
};
$dd934af551f44020$export$13e3392192263954 = function(a, b, c) {
    return $dd934af551f44020$var$S().useReducer(a, b, c);
};
$dd934af551f44020$export$b8f5890fc79d6aca = function(a) {
    return $dd934af551f44020$var$S().useRef(a);
};
$dd934af551f44020$export$60241385465d0a34 = function(a) {
    return $dd934af551f44020$var$S().useState(a);
};
$dd934af551f44020$export$83d89fbfd8236492 = "17.0.2";

});



parcelRegister("23wBm", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $8NFma = parcelRequire("8NFma");

var $k1s95 = parcelRequire("k1s95");

var $clk2u = parcelRequire("clk2u");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$8NFma) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $8NFma.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $k1s95({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $8NFma.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $k1s95({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $k1s95({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $k1s95({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $clk2u.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $clk2u.unstable_scheduleCallback($clk2u.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $clk2u.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $clk2u.unstable_UserBlockingPriority, ed = $clk2u.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $k1s95(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $k1s95({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $k1s95({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $k1s95({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $k1s95({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $k1s95({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $k1s95({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $k1s95({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $k1s95({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $k1s95({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $k1s95({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $k1s95({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $k1s95({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $k1s95({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $clk2u.unstable_runWithPriority, Of = $clk2u.unstable_scheduleCallback, Pf = $clk2u.unstable_cancelCallback, Qf = $clk2u.unstable_shouldYield, Rf = $clk2u.unstable_requestPaint, Sf = $clk2u.unstable_now, Tf = $clk2u.unstable_getCurrentPriorityLevel, Uf = $clk2u.unstable_ImmediatePriority, Vf = $clk2u.unstable_UserBlockingPriority, Wf = $clk2u.unstable_NormalPriority, Xf = $clk2u.unstable_LowPriority, Yf = $clk2u.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $k1s95({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $k1s95({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $8NFma.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $k1s95({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $k1s95({}, e, {
                    value: void 0
                });
                d = $k1s95({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $k1s95({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("clk2u", function(module, exports) {
"use strict";

module.exports = (parcelRequire("5fXYF"));

});
parcelRegister("5fXYF", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $3d3ce0c592af0505$export$c4744153514ff05d, (v) => $3d3ce0c592af0505$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $3d3ce0c592af0505$export$b5836b71941fa3ed, (v) => $3d3ce0c592af0505$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $3d3ce0c592af0505$export$d66a1c1c77bd778b, (v) => $3d3ce0c592af0505$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $3d3ce0c592af0505$export$3e506c1ccc9cc1a7, (v) => $3d3ce0c592af0505$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $3d3ce0c592af0505$export$e26fe2ed2fa76875, (v) => $3d3ce0c592af0505$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $3d3ce0c592af0505$export$502329bbf4b505b1, (v) => $3d3ce0c592af0505$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $3d3ce0c592af0505$export$6e3807111c4874c4, (v) => $3d3ce0c592af0505$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $3d3ce0c592af0505$export$c27134553091fb3a, (v) => $3d3ce0c592af0505$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $3d3ce0c592af0505$export$33ee1acdc04fd2a2, (v) => $3d3ce0c592af0505$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $3d3ce0c592af0505$export$b00a404bbd5edef2, (v) => $3d3ce0c592af0505$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $3d3ce0c592af0505$export$8352ce38b91d0c62, (v) => $3d3ce0c592af0505$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $3d3ce0c592af0505$export$d3dfb8e4810cb555, (v) => $3d3ce0c592af0505$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $3d3ce0c592af0505$export$839f9183b0465a69, (v) => $3d3ce0c592af0505$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $3d3ce0c592af0505$export$72fdf0e06517287b, (v) => $3d3ce0c592af0505$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $3d3ce0c592af0505$export$4b844e58a3e414b4, (v) => $3d3ce0c592af0505$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $3d3ce0c592af0505$export$816d2913ae6b83b1, (v) => $3d3ce0c592af0505$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $3d3ce0c592af0505$export$61bcfe829111a1d0, (v) => $3d3ce0c592af0505$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $3d3ce0c592af0505$export$7ee8c9beb337bc3f, (v) => $3d3ce0c592af0505$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $3d3ce0c592af0505$export$cf845f2c119da08a, (v) => $3d3ce0c592af0505$export$cf845f2c119da08a = v);
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3d3ce0c592af0505$export$c4744153514ff05d;
var $3d3ce0c592af0505$export$b5836b71941fa3ed;
var $3d3ce0c592af0505$export$d66a1c1c77bd778b;
var $3d3ce0c592af0505$export$3e506c1ccc9cc1a7;
var $3d3ce0c592af0505$export$e26fe2ed2fa76875;
var $3d3ce0c592af0505$export$502329bbf4b505b1;
var $3d3ce0c592af0505$export$6e3807111c4874c4;
var $3d3ce0c592af0505$export$c27134553091fb3a;
var $3d3ce0c592af0505$export$33ee1acdc04fd2a2;
var $3d3ce0c592af0505$export$b00a404bbd5edef2;
var $3d3ce0c592af0505$export$8352ce38b91d0c62;
var $3d3ce0c592af0505$export$d3dfb8e4810cb555;
var $3d3ce0c592af0505$export$839f9183b0465a69;
var $3d3ce0c592af0505$export$72fdf0e06517287b;
var $3d3ce0c592af0505$export$4b844e58a3e414b4;
var $3d3ce0c592af0505$export$816d2913ae6b83b1;
var $3d3ce0c592af0505$export$61bcfe829111a1d0;
var $3d3ce0c592af0505$export$7ee8c9beb337bc3f;
var $3d3ce0c592af0505$export$cf845f2c119da08a;
"use strict";
var $3d3ce0c592af0505$var$f, $3d3ce0c592af0505$var$g, $3d3ce0c592af0505$var$h, $3d3ce0c592af0505$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $3d3ce0c592af0505$var$l = performance;
    $3d3ce0c592af0505$export$c4744153514ff05d = function() {
        return $3d3ce0c592af0505$var$l.now();
    };
} else {
    var $3d3ce0c592af0505$var$p = Date, $3d3ce0c592af0505$var$q = $3d3ce0c592af0505$var$p.now();
    $3d3ce0c592af0505$export$c4744153514ff05d = function() {
        return $3d3ce0c592af0505$var$p.now() - $3d3ce0c592af0505$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $3d3ce0c592af0505$var$t = null, $3d3ce0c592af0505$var$u = null, $3d3ce0c592af0505$var$w = function() {
        if (null !== $3d3ce0c592af0505$var$t) try {
            var a = $3d3ce0c592af0505$export$c4744153514ff05d();
            $3d3ce0c592af0505$var$t(!0, a);
            $3d3ce0c592af0505$var$t = null;
        } catch (b) {
            throw setTimeout($3d3ce0c592af0505$var$w, 0), b;
        }
    };
    $3d3ce0c592af0505$var$f = function(a) {
        null !== $3d3ce0c592af0505$var$t ? setTimeout($3d3ce0c592af0505$var$f, 0, a) : ($3d3ce0c592af0505$var$t = a, setTimeout($3d3ce0c592af0505$var$w, 0));
    };
    $3d3ce0c592af0505$var$g = function(a, b) {
        $3d3ce0c592af0505$var$u = setTimeout(a, b);
    };
    $3d3ce0c592af0505$var$h = function() {
        clearTimeout($3d3ce0c592af0505$var$u);
    };
    $3d3ce0c592af0505$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $3d3ce0c592af0505$var$k = $3d3ce0c592af0505$export$d66a1c1c77bd778b = function() {};
} else {
    var $3d3ce0c592af0505$var$x = window.setTimeout, $3d3ce0c592af0505$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $3d3ce0c592af0505$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $3d3ce0c592af0505$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $3d3ce0c592af0505$var$A = !1, $3d3ce0c592af0505$var$B = null, $3d3ce0c592af0505$var$C = -1, $3d3ce0c592af0505$var$D = 5, $3d3ce0c592af0505$var$E = 0;
    $3d3ce0c592af0505$export$b5836b71941fa3ed = function() {
        return $3d3ce0c592af0505$export$c4744153514ff05d() >= $3d3ce0c592af0505$var$E;
    };
    $3d3ce0c592af0505$var$k = function() {};
    $3d3ce0c592af0505$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $3d3ce0c592af0505$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $3d3ce0c592af0505$var$F = new MessageChannel, $3d3ce0c592af0505$var$G = $3d3ce0c592af0505$var$F.port2;
    $3d3ce0c592af0505$var$F.port1.onmessage = function() {
        if (null !== $3d3ce0c592af0505$var$B) {
            var a = $3d3ce0c592af0505$export$c4744153514ff05d();
            $3d3ce0c592af0505$var$E = a + $3d3ce0c592af0505$var$D;
            try {
                $3d3ce0c592af0505$var$B(!0, a) ? $3d3ce0c592af0505$var$G.postMessage(null) : ($3d3ce0c592af0505$var$A = !1, $3d3ce0c592af0505$var$B = null);
            } catch (b) {
                throw $3d3ce0c592af0505$var$G.postMessage(null), b;
            }
        } else $3d3ce0c592af0505$var$A = !1;
    };
    $3d3ce0c592af0505$var$f = function(a) {
        $3d3ce0c592af0505$var$B = a;
        $3d3ce0c592af0505$var$A || ($3d3ce0c592af0505$var$A = !0, $3d3ce0c592af0505$var$G.postMessage(null));
    };
    $3d3ce0c592af0505$var$g = function(a, b) {
        $3d3ce0c592af0505$var$C = $3d3ce0c592af0505$var$x(function() {
            a($3d3ce0c592af0505$export$c4744153514ff05d());
        }, b);
    };
    $3d3ce0c592af0505$var$h = function() {
        $3d3ce0c592af0505$var$y($3d3ce0c592af0505$var$C);
        $3d3ce0c592af0505$var$C = -1;
    };
}
function $3d3ce0c592af0505$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $3d3ce0c592af0505$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $3d3ce0c592af0505$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $3d3ce0c592af0505$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $3d3ce0c592af0505$var$I(n, c)) void 0 !== r && 0 > $3d3ce0c592af0505$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $3d3ce0c592af0505$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $3d3ce0c592af0505$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $3d3ce0c592af0505$var$L = [], $3d3ce0c592af0505$var$M = [], $3d3ce0c592af0505$var$N = 1, $3d3ce0c592af0505$var$O = null, $3d3ce0c592af0505$var$P = 3, $3d3ce0c592af0505$var$Q = !1, $3d3ce0c592af0505$var$R = !1, $3d3ce0c592af0505$var$S = !1;
function $3d3ce0c592af0505$var$T(a) {
    for(var b = $3d3ce0c592af0505$var$J($3d3ce0c592af0505$var$M); null !== b;){
        if (null === b.callback) $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$M);
        else if (b.startTime <= a) $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$M), b.sortIndex = b.expirationTime, $3d3ce0c592af0505$var$H($3d3ce0c592af0505$var$L, b);
        else break;
        b = $3d3ce0c592af0505$var$J($3d3ce0c592af0505$var$M);
    }
}
function $3d3ce0c592af0505$var$U(a) {
    $3d3ce0c592af0505$var$S = !1;
    $3d3ce0c592af0505$var$T(a);
    if (!$3d3ce0c592af0505$var$R) {
        if (null !== $3d3ce0c592af0505$var$J($3d3ce0c592af0505$var$L)) $3d3ce0c592af0505$var$R = !0, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$V);
        else {
            var b = $3d3ce0c592af0505$var$J($3d3ce0c592af0505$var$M);
            null !== b && $3d3ce0c592af0505$var$g($3d3ce0c592af0505$var$U, b.startTime - a);
        }
    }
}
function $3d3ce0c592af0505$var$V(a, b) {
    $3d3ce0c592af0505$var$R = !1;
    $3d3ce0c592af0505$var$S && ($3d3ce0c592af0505$var$S = !1, $3d3ce0c592af0505$var$h());
    $3d3ce0c592af0505$var$Q = !0;
    var c = $3d3ce0c592af0505$var$P;
    try {
        $3d3ce0c592af0505$var$T(b);
        for($3d3ce0c592af0505$var$O = $3d3ce0c592af0505$var$J($3d3ce0c592af0505$var$L); null !== $3d3ce0c592af0505$var$O && (!($3d3ce0c592af0505$var$O.expirationTime > b) || a && !$3d3ce0c592af0505$export$b5836b71941fa3ed());){
            var d = $3d3ce0c592af0505$var$O.callback;
            if ("function" === typeof d) {
                $3d3ce0c592af0505$var$O.callback = null;
                $3d3ce0c592af0505$var$P = $3d3ce0c592af0505$var$O.priorityLevel;
                var e = d($3d3ce0c592af0505$var$O.expirationTime <= b);
                b = $3d3ce0c592af0505$export$c4744153514ff05d();
                "function" === typeof e ? $3d3ce0c592af0505$var$O.callback = e : $3d3ce0c592af0505$var$O === $3d3ce0c592af0505$var$J($3d3ce0c592af0505$var$L) && $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$L);
                $3d3ce0c592af0505$var$T(b);
            } else $3d3ce0c592af0505$var$K($3d3ce0c592af0505$var$L);
            $3d3ce0c592af0505$var$O = $3d3ce0c592af0505$var$J($3d3ce0c592af0505$var$L);
        }
        if (null !== $3d3ce0c592af0505$var$O) var m = !0;
        else {
            var n = $3d3ce0c592af0505$var$J($3d3ce0c592af0505$var$M);
            null !== n && $3d3ce0c592af0505$var$g($3d3ce0c592af0505$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $3d3ce0c592af0505$var$O = null, $3d3ce0c592af0505$var$P = c, $3d3ce0c592af0505$var$Q = !1;
    }
}
var $3d3ce0c592af0505$var$W = $3d3ce0c592af0505$var$k;
$3d3ce0c592af0505$export$3e506c1ccc9cc1a7 = 5;
$3d3ce0c592af0505$export$e26fe2ed2fa76875 = 1;
$3d3ce0c592af0505$export$502329bbf4b505b1 = 4;
$3d3ce0c592af0505$export$6e3807111c4874c4 = 3;
$3d3ce0c592af0505$export$c27134553091fb3a = null;
$3d3ce0c592af0505$export$33ee1acdc04fd2a2 = 2;
$3d3ce0c592af0505$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$3d3ce0c592af0505$export$8352ce38b91d0c62 = function() {
    $3d3ce0c592af0505$var$R || $3d3ce0c592af0505$var$Q || ($3d3ce0c592af0505$var$R = !0, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$V));
};
$3d3ce0c592af0505$export$d3dfb8e4810cb555 = function() {
    return $3d3ce0c592af0505$var$P;
};
$3d3ce0c592af0505$export$839f9183b0465a69 = function() {
    return $3d3ce0c592af0505$var$J($3d3ce0c592af0505$var$L);
};
$3d3ce0c592af0505$export$72fdf0e06517287b = function(a) {
    switch($3d3ce0c592af0505$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $3d3ce0c592af0505$var$P;
    }
    var c = $3d3ce0c592af0505$var$P;
    $3d3ce0c592af0505$var$P = b;
    try {
        return a();
    } finally{
        $3d3ce0c592af0505$var$P = c;
    }
};
$3d3ce0c592af0505$export$4b844e58a3e414b4 = function() {};
$3d3ce0c592af0505$export$816d2913ae6b83b1 = $3d3ce0c592af0505$var$W;
$3d3ce0c592af0505$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $3d3ce0c592af0505$var$P;
    $3d3ce0c592af0505$var$P = a;
    try {
        return b();
    } finally{
        $3d3ce0c592af0505$var$P = c;
    }
};
$3d3ce0c592af0505$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $3d3ce0c592af0505$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $3d3ce0c592af0505$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $3d3ce0c592af0505$var$H($3d3ce0c592af0505$var$M, a), null === $3d3ce0c592af0505$var$J($3d3ce0c592af0505$var$L) && a === $3d3ce0c592af0505$var$J($3d3ce0c592af0505$var$M) && ($3d3ce0c592af0505$var$S ? $3d3ce0c592af0505$var$h() : $3d3ce0c592af0505$var$S = !0, $3d3ce0c592af0505$var$g($3d3ce0c592af0505$var$U, c - d))) : (a.sortIndex = e, $3d3ce0c592af0505$var$H($3d3ce0c592af0505$var$L, a), $3d3ce0c592af0505$var$R || $3d3ce0c592af0505$var$Q || ($3d3ce0c592af0505$var$R = !0, $3d3ce0c592af0505$var$f($3d3ce0c592af0505$var$V)));
    return a;
};
$3d3ce0c592af0505$export$cf845f2c119da08a = function(a) {
    var b = $3d3ce0c592af0505$var$P;
    return function() {
        var c = $3d3ce0c592af0505$var$P;
        $3d3ce0c592af0505$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $3d3ce0c592af0505$var$P = c;
        }
    };
};

});



parcelRegister("81tj9", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");

var $cG9HX = parcelRequire("cG9HX");

var $hBrVA = parcelRequire("hBrVA");

var $2PhsF = parcelRequire("2PhsF");

var $1nuTH = parcelRequire("1nuTH");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $5d7526a7a1e5b3fb$var$createInstance(defaultConfig) {
    var context = new $hBrVA(defaultConfig);
    var instance = $cG9HX($hBrVA.prototype.request, context);
    // Copy axios.prototype to instance
    $eFc3n.extend(instance, $hBrVA.prototype, context);
    // Copy context to instance
    $eFc3n.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $5d7526a7a1e5b3fb$var$createInstance($2PhsF(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $5d7526a7a1e5b3fb$var$axios = $5d7526a7a1e5b3fb$var$createInstance($1nuTH);
// Expose Axios class to allow class inheritance
$5d7526a7a1e5b3fb$var$axios.Axios = $hBrVA;

// Expose Cancel & CancelToken
$5d7526a7a1e5b3fb$var$axios.Cancel = (parcelRequire("anxHC"));

$5d7526a7a1e5b3fb$var$axios.CancelToken = (parcelRequire("4iFhx"));

$5d7526a7a1e5b3fb$var$axios.isCancel = (parcelRequire("lCgfr"));

$5d7526a7a1e5b3fb$var$axios.VERSION = (parcelRequire("6yYtd")).version;
// Expose all/spread
$5d7526a7a1e5b3fb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$5d7526a7a1e5b3fb$var$axios.spread = (parcelRequire("albzn"));

// Expose isAxiosError
$5d7526a7a1e5b3fb$var$axios.isAxiosError = (parcelRequire("1YbHN"));
module.exports = $5d7526a7a1e5b3fb$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $5d7526a7a1e5b3fb$var$axios;

});
parcelRegister("eFc3n", function(module, exports) {
"use strict";

var $cG9HX = parcelRequire("cG9HX");
// utils is a library of generic helper functions non-specific to axios
var $aace3e920a0f1e4d$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $aace3e920a0f1e4d$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $aace3e920a0f1e4d$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isBuffer(val) {
    return val !== null && !$aace3e920a0f1e4d$var$isUndefined(val) && val.constructor !== null && !$aace3e920a0f1e4d$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isArrayBuffer(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $aace3e920a0f1e4d$var$isFormData(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === "[object FormData]";
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $aace3e920a0f1e4d$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $aace3e920a0f1e4d$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $aace3e920a0f1e4d$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $aace3e920a0f1e4d$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $aace3e920a0f1e4d$var$isPlainObject(val) {
    if ($aace3e920a0f1e4d$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $aace3e920a0f1e4d$var$isDate(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $aace3e920a0f1e4d$var$isFile(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $aace3e920a0f1e4d$var$isBlob(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $aace3e920a0f1e4d$var$isFunction(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $aace3e920a0f1e4d$var$isStream(val) {
    return $aace3e920a0f1e4d$var$isObject(val) && $aace3e920a0f1e4d$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $aace3e920a0f1e4d$var$isURLSearchParams(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === "[object URLSearchParams]";
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $aace3e920a0f1e4d$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $aace3e920a0f1e4d$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $aace3e920a0f1e4d$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($aace3e920a0f1e4d$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $aace3e920a0f1e4d$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($aace3e920a0f1e4d$var$isPlainObject(result[key]) && $aace3e920a0f1e4d$var$isPlainObject(val)) result[key] = $aace3e920a0f1e4d$var$merge(result[key], val);
        else if ($aace3e920a0f1e4d$var$isPlainObject(val)) result[key] = $aace3e920a0f1e4d$var$merge({}, val);
        else if ($aace3e920a0f1e4d$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$aace3e920a0f1e4d$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $aace3e920a0f1e4d$var$extend(a, b, thisArg) {
    $aace3e920a0f1e4d$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $cG9HX(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $aace3e920a0f1e4d$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $aace3e920a0f1e4d$var$isArray,
    isArrayBuffer: $aace3e920a0f1e4d$var$isArrayBuffer,
    isBuffer: $aace3e920a0f1e4d$var$isBuffer,
    isFormData: $aace3e920a0f1e4d$var$isFormData,
    isArrayBufferView: $aace3e920a0f1e4d$var$isArrayBufferView,
    isString: $aace3e920a0f1e4d$var$isString,
    isNumber: $aace3e920a0f1e4d$var$isNumber,
    isObject: $aace3e920a0f1e4d$var$isObject,
    isPlainObject: $aace3e920a0f1e4d$var$isPlainObject,
    isUndefined: $aace3e920a0f1e4d$var$isUndefined,
    isDate: $aace3e920a0f1e4d$var$isDate,
    isFile: $aace3e920a0f1e4d$var$isFile,
    isBlob: $aace3e920a0f1e4d$var$isBlob,
    isFunction: $aace3e920a0f1e4d$var$isFunction,
    isStream: $aace3e920a0f1e4d$var$isStream,
    isURLSearchParams: $aace3e920a0f1e4d$var$isURLSearchParams,
    isStandardBrowserEnv: $aace3e920a0f1e4d$var$isStandardBrowserEnv,
    forEach: $aace3e920a0f1e4d$var$forEach,
    merge: $aace3e920a0f1e4d$var$merge,
    extend: $aace3e920a0f1e4d$var$extend,
    trim: $aace3e920a0f1e4d$var$trim,
    stripBOM: $aace3e920a0f1e4d$var$stripBOM
};

});
parcelRegister("cG9HX", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("hBrVA", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");

var $iOHZJ = parcelRequire("iOHZJ");

var $9ltoJ = parcelRequire("9ltoJ");

var $cUzFg = parcelRequire("cUzFg");

var $2PhsF = parcelRequire("2PhsF");

var $8zXsW = parcelRequire("8zXsW");
var $cd0b8e3cbef64068$var$validators = $8zXsW.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $cd0b8e3cbef64068$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $9ltoJ(),
        response: new $9ltoJ()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $cd0b8e3cbef64068$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    if (!config.url) throw new Error("Provided config url is not valid");
    config = $2PhsF(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $8zXsW.assertOptions(transitional, {
        silentJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
        forcedJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
        clarifyTimeoutError: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $cUzFg,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $cUzFg(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$cd0b8e3cbef64068$var$Axios.prototype.getUri = function getUri(config) {
    if (!config.url) throw new Error("Provided config url is not valid");
    config = $2PhsF(this.defaults, config);
    return $iOHZJ(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$eFc3n.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $cd0b8e3cbef64068$var$Axios.prototype[method] = function(url, config) {
        return this.request($2PhsF(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$eFc3n.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $cd0b8e3cbef64068$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($2PhsF(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $cd0b8e3cbef64068$var$Axios;

});
parcelRegister("iOHZJ", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");
function $db2f05ec923f2ee7$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($eFc3n.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $eFc3n.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($eFc3n.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $eFc3n.forEach(val, function parseValue(v) {
                if ($eFc3n.isDate(v)) v = v.toISOString();
                else if ($eFc3n.isObject(v)) v = JSON.stringify(v);
                parts.push($db2f05ec923f2ee7$var$encode(key) + "=" + $db2f05ec923f2ee7$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("9ltoJ", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");
function $01c17f80085c95b1$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $01c17f80085c95b1$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $01c17f80085c95b1$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $01c17f80085c95b1$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $eFc3n.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $01c17f80085c95b1$var$InterceptorManager;

});

parcelRegister("cUzFg", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");

var $kgh03 = parcelRequire("kgh03");

var $lCgfr = parcelRequire("lCgfr");

var $1nuTH = parcelRequire("1nuTH");

var $anxHC = parcelRequire("anxHC");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $96666136aaccd2e5$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $anxHC("canceled");
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $96666136aaccd2e5$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $kgh03.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $eFc3n.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $eFc3n.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $1nuTH.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $96666136aaccd2e5$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $kgh03.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$lCgfr(reason)) {
            $96666136aaccd2e5$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $kgh03.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("kgh03", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");

var $1nuTH = parcelRequire("1nuTH");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $1nuTH;
    /*eslint no-param-reassign:0*/ $eFc3n.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("1nuTH", function(module, exports) {

var $ibaza = parcelRequire("ibaza");
"use strict";

var $eFc3n = parcelRequire("eFc3n");

var $elOvr = parcelRequire("elOvr");

var $fEfFg = parcelRequire("fEfFg");
var $100fe7fc4c7b4810$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $100fe7fc4c7b4810$var$setContentTypeIfUnset(headers, value) {
    if (!$eFc3n.isUndefined(headers) && $eFc3n.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $100fe7fc4c7b4810$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("8nTSD"));
    else if (typeof $ibaza !== "undefined" && Object.prototype.toString.call($ibaza) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("8nTSD"));
    return adapter;
}
function $100fe7fc4c7b4810$var$stringifySafely(rawValue, parser, encoder) {
    if ($eFc3n.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $eFc3n.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $100fe7fc4c7b4810$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $100fe7fc4c7b4810$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $elOvr(headers, "Accept");
            $elOvr(headers, "Content-Type");
            if ($eFc3n.isFormData(data) || $eFc3n.isArrayBuffer(data) || $eFc3n.isBuffer(data) || $eFc3n.isStream(data) || $eFc3n.isFile(data) || $eFc3n.isBlob(data)) return data;
            if ($eFc3n.isArrayBufferView(data)) return data.buffer;
            if ($eFc3n.isURLSearchParams(data)) {
                $100fe7fc4c7b4810$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($eFc3n.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $100fe7fc4c7b4810$var$setContentTypeIfUnset(headers, "application/json");
                return $100fe7fc4c7b4810$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $100fe7fc4c7b4810$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $eFc3n.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $fEfFg(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
$eFc3n.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $100fe7fc4c7b4810$var$defaults.headers[method] = {};
});
$eFc3n.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $100fe7fc4c7b4810$var$defaults.headers[method] = $eFc3n.merge($100fe7fc4c7b4810$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $100fe7fc4c7b4810$var$defaults;

});
parcelRegister("ibaza", function(module, exports) {
// shim for using process in browser
var $d3c1734dacb01657$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3c1734dacb01657$var$cachedSetTimeout;
var $d3c1734dacb01657$var$cachedClearTimeout;
function $d3c1734dacb01657$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $d3c1734dacb01657$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        else $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        else $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    }
})();
function $d3c1734dacb01657$var$runTimeout(fun) {
    if ($d3c1734dacb01657$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedSetTimeout === $d3c1734dacb01657$var$defaultSetTimout || !$d3c1734dacb01657$var$cachedSetTimeout) && setTimeout) {
        $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3c1734dacb01657$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3c1734dacb01657$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3c1734dacb01657$var$runClearTimeout(marker) {
    if ($d3c1734dacb01657$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedClearTimeout === $d3c1734dacb01657$var$defaultClearTimeout || !$d3c1734dacb01657$var$cachedClearTimeout) && clearTimeout) {
        $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3c1734dacb01657$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3c1734dacb01657$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3c1734dacb01657$var$queue = [];
var $d3c1734dacb01657$var$draining = false;
var $d3c1734dacb01657$var$currentQueue;
var $d3c1734dacb01657$var$queueIndex = -1;
function $d3c1734dacb01657$var$cleanUpNextTick() {
    if (!$d3c1734dacb01657$var$draining || !$d3c1734dacb01657$var$currentQueue) return;
    $d3c1734dacb01657$var$draining = false;
    if ($d3c1734dacb01657$var$currentQueue.length) $d3c1734dacb01657$var$queue = $d3c1734dacb01657$var$currentQueue.concat($d3c1734dacb01657$var$queue);
    else $d3c1734dacb01657$var$queueIndex = -1;
    if ($d3c1734dacb01657$var$queue.length) $d3c1734dacb01657$var$drainQueue();
}
function $d3c1734dacb01657$var$drainQueue() {
    if ($d3c1734dacb01657$var$draining) return;
    var timeout = $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$cleanUpNextTick);
    $d3c1734dacb01657$var$draining = true;
    var len = $d3c1734dacb01657$var$queue.length;
    while(len){
        $d3c1734dacb01657$var$currentQueue = $d3c1734dacb01657$var$queue;
        $d3c1734dacb01657$var$queue = [];
        while(++$d3c1734dacb01657$var$queueIndex < len)if ($d3c1734dacb01657$var$currentQueue) $d3c1734dacb01657$var$currentQueue[$d3c1734dacb01657$var$queueIndex].run();
        $d3c1734dacb01657$var$queueIndex = -1;
        len = $d3c1734dacb01657$var$queue.length;
    }
    $d3c1734dacb01657$var$currentQueue = null;
    $d3c1734dacb01657$var$draining = false;
    $d3c1734dacb01657$var$runClearTimeout(timeout);
}
$d3c1734dacb01657$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3c1734dacb01657$var$queue.push(new $d3c1734dacb01657$var$Item(fun, args));
    if ($d3c1734dacb01657$var$queue.length === 1 && !$d3c1734dacb01657$var$draining) $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$drainQueue);
};
// v8 likes predictible objects
function $d3c1734dacb01657$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3c1734dacb01657$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3c1734dacb01657$var$process.title = "browser";
$d3c1734dacb01657$var$process.browser = true;
$d3c1734dacb01657$var$process.env = {};
$d3c1734dacb01657$var$process.argv = [];
$d3c1734dacb01657$var$process.version = ""; // empty string to avoid regexp issues
$d3c1734dacb01657$var$process.versions = {};
function $d3c1734dacb01657$var$noop() {}
$d3c1734dacb01657$var$process.on = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.addListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.once = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.off = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeAllListeners = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.emit = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependOnceListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.listeners = function(name) {
    return [];
};
$d3c1734dacb01657$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$d3c1734dacb01657$var$process.cwd = function() {
    return "/";
};
$d3c1734dacb01657$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$d3c1734dacb01657$var$process.umask = function() {
    return 0;
};

});

parcelRegister("elOvr", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $eFc3n.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("fEfFg", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    };
    return error;
};

});

parcelRegister("8nTSD", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");

var $gyIfz = parcelRequire("gyIfz");

var $6D8uh = parcelRequire("6D8uh");

var $iOHZJ = parcelRequire("iOHZJ");

var $cgfHI = parcelRequire("cgfHI");

var $4Ik1V = parcelRequire("4Ik1V");

var $4YUSN = parcelRequire("4YUSN");

var $hYe4p = parcelRequire("hYe4p");

var $1nuTH = parcelRequire("1nuTH");

var $anxHC = parcelRequire("anxHC");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ($eFc3n.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $cgfHI(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $iOHZJ(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $4Ik1V(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $gyIfz(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($hYe4p("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($hYe4p("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = config.transitional || $1nuTH.transitional;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($hYe4p(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($eFc3n.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $4YUSN(fullPath)) && config.xsrfCookieName ? $6D8uh.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $eFc3n.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$eFc3n.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $anxHC("canceled") : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("gyIfz", function(module, exports) {
"use strict";

var $hYe4p = parcelRequire("hYe4p");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($hYe4p("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("hYe4p", function(module, exports) {
"use strict";

var $fEfFg = parcelRequire("fEfFg");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $fEfFg(error, config, code, request, response);
};

});


parcelRegister("6D8uh", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");
module.exports = $eFc3n.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($eFc3n.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($eFc3n.isString(path)) cookie.push("path=" + path);
            if ($eFc3n.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("cgfHI", function(module, exports) {
"use strict";

var $uAxSn = parcelRequire("uAxSn");

var $aFAjA = parcelRequire("aFAjA");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$uAxSn(requestedURL)) return $aFAjA(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("uAxSn", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRegister("aFAjA", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("4Ik1V", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $36eacf0f5ae88424$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $eFc3n.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $eFc3n.trim(line.substr(0, i)).toLowerCase();
        val = $eFc3n.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $36eacf0f5ae88424$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("4YUSN", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");
module.exports = $eFc3n.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $eFc3n.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("anxHC", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $78e631f68b7e223f$var$Cancel(message) {
    this.message = message;
}
$78e631f68b7e223f$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$78e631f68b7e223f$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $78e631f68b7e223f$var$Cancel;

});




parcelRegister("lCgfr", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("2PhsF", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($eFc3n.isPlainObject(target) && $eFc3n.isPlainObject(source)) return $eFc3n.merge(target, source);
        else if ($eFc3n.isPlainObject(source)) return $eFc3n.merge({}, source);
        else if ($eFc3n.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$eFc3n.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$eFc3n.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$eFc3n.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$eFc3n.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$eFc3n.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
    };
    $eFc3n.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $eFc3n.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("8zXsW", function(module, exports) {
"use strict";

var $6yYtd = parcelRequire("6yYtd");
var $63efb8494987aa98$require$VERSION = $6yYtd.version;
var $63efb8494987aa98$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $63efb8494987aa98$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $63efb8494987aa98$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $63efb8494987aa98$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + $63efb8494987aa98$require$VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed" + (version ? " in " + version : "")));
        if (version && !$63efb8494987aa98$var$deprecatedWarnings[opt]) {
            $63efb8494987aa98$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $63efb8494987aa98$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    assertOptions: $63efb8494987aa98$var$assertOptions,
    validators: $63efb8494987aa98$var$validators
};

});
parcelRegister("6yYtd", function(module, exports) {
module.exports = {
    "version": "0.25.0"
};

});



parcelRegister("4iFhx", function(module, exports) {
"use strict";

var $anxHC = parcelRequire("anxHC");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $3218dd97b5460664$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $anxHC(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $3218dd97b5460664$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $3218dd97b5460664$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $3218dd97b5460664$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $3218dd97b5460664$var$CancelToken.source = function source() {
    var cancel;
    var token = new $3218dd97b5460664$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $3218dd97b5460664$var$CancelToken;

});

parcelRegister("albzn", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("1YbHN", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $eFc3n.isObject(payload) && payload.isAxiosError === true;
};

});


parcelRegister("6AbVD", function(module, exports) {
module.exports = JSON.parse('[{"artifact.ingress.title":"Fra Reine i Lofoten [Maleri]","artifact.uniqueId":"021046909815","artifact.ingress.license":["CC pdm"],"artifact.publishedDate":"2017-03-03T06:01:21.534Z","artifact.ingress.producerRole":"Kunstner","identifier.id":"STO.K.DEP.102","artifact.type":"Fineart","identifier.owner":"STO","artifact.uuid":"2B4C6C38-31D7-41BF-897E-9D5125E945D7","artifact.pictureCount":1,"artifact.updatedDate":"2017-08-27T04:01:26.870Z","artifact.hasPictures":true,"artifact.ingress.production.toYear":1883,"artifact.defaultPictureIndex":1171,"artifact.ingress.producer":"Sinding, Otto","artifact.hasChildren":false,"artifact.defaultMediaIdentifier":"032yjV9Ws55Y","artifact.ingress.production.fromYear":1883,"artifact.ingress.subjects":["Bildende kunst"]},{"artifact.ingress.title":"Innseilingen til Christiania [Maleri]","artifact.uniqueId":"021046909823","artifact.ingress.license":["CC pdm"],"artifact.publishedDate":"2017-03-03T06:01:26.516Z","artifact.ingress.producerRole":"Kunstner","identifier.id":"STO.K.DEP.101","artifact.type":"Fineart","identifier.owner":"STO","artifact.uuid":"E607C707-6805-4671-97EB-06C4E0C56DA4","artifact.pictureCount":1,"artifact.updatedDate":"2017-08-27T04:01:28.781Z","artifact.hasPictures":true,"artifact.ingress.production.toYear":1874,"artifact.defaultPictureIndex":1170,"artifact.ingress.producer":"Gude, Hans","artifact.hasChildren":false,"artifact.defaultMediaIdentifier":"022yjV9Ws5EF","artifact.ingress.production.fromYear":1874,"artifact.ingress.subjects":["Bildende kunst"]},{"artifact.ingress.title":"Stortingspresident Carl Joachim Hambro [Bronse]","artifact.uniqueId":"021046902766","artifact.ingress.license":["AC 1"],"artifact.publishedDate":"2017-02-21T06:01:23.758Z","artifact.ingress.producerRole":"Kunstner","identifier.id":"STO.K.04626","artifact.type":"Fineart","identifier.owner":"STO","artifact.uuid":"A084510E-6422-4A09-A82F-3B78796B06C5","artifact.pictureCount":1,"artifact.updatedDate":"2017-08-21T04:01:59.483Z","artifact.hasPictures":true,"artifact.ingress.production.toYear":1994,"artifact.defaultPictureIndex":627,"artifact.ingress.producer":"Christensen, Kjell Grette","artifact.hasChildren":false,"artifact.defaultMediaIdentifier":"022yjV2ttcLt","artifact.ingress.production.fromYear":1992,"artifact.ingress.subjects":["Stortingspresident"]},{"artifact.ingress.title":"Konfirmasjonsgilde [Maleri]","artifact.uniqueId":"021046909813","artifact.ingress.license":["CC pdm"],"artifact.publishedDate":"2017-03-03T06:01:17.101Z","artifact.ingress.producerRole":"Kunstner","identifier.id":"STO.K.DEP.103","identifier.owner":"STO","artifact.type":"Fineart","artifact.uuid":"76AB533C-DE3C-41C3-BA16-E9D699488EE1","artifact.updatedDate":"2017-08-18T04:03:22.728Z","artifact.hasPictures":true,"artifact.pictureCount":1,"artifact.ingress.production.toYear":1887,"artifact.defaultPictureIndex":1172,"artifact.ingress.production.fromYear":1887,"artifact.ingress.producer":"Wentzel, Gustav","artifact.hasChildren":false,"artifact.defaultMediaIdentifier":"032yjV9Ws55V"},{"artifact.ingress.title":"Emil Stang [Byste]","artifact.uniqueId":"021046898528","artifact.ingress.license":["CC pdm"],"artifact.publishedDate":"2017-02-13T06:01:45.260Z","artifact.ingress.producerRole":"Kunstner","identifier.id":"STO.K.02230","artifact.type":"Fineart","identifier.owner":"STO","artifact.uuid":"4E8A3CAF-D5F0-49F8-B0A5-B1008F233691","artifact.pictureCount":1,"artifact.updatedDate":"2017-08-18T04:04:24.366Z","artifact.hasPictures":true,"artifact.ingress.production.toYear":1922,"artifact.defaultPictureIndex":109,"artifact.ingress.producer":"Visdal, Jo","artifact.hasChildren":false,"artifact.defaultMediaIdentifier":"022yjUvQKRWg","artifact.ingress.production.fromYear":1922,"artifact.ingress.subjects":["Bildende kunst"]},{"artifact.ingress.producer":"Rasmussen, Wilhelm","artifact.uuid":"3341DA45-154B-4AC8-BFBE-40473199B31E","artifact.pictureCount":1,"artifact.defaultPictureIndex":111,"artifact.type":"Fineart","artifact.defaultMediaIdentifier":"032yjUvJRpq6","artifact.hasPictures":true,"artifact.uniqueId":"021046896593","artifact.ingress.title":"Wollert Konow [Byste]","artifact.ingress.producerRole":"Kunstner","artifact.publishedDate":"2017-02-09T06:02:04.084Z","artifact.ingress.license":["AC 1"],"identifier.id":"STO.K.02232","artifact.hasChildren":false,"identifier.owner":"STO","artifact.updatedDate":"2017-08-18T04:04:28.378Z","artifact.ingress.subjects":["Bildende kunst"]},{"artifact.ingress.title":"Wollert Konow  [Byste]","artifact.uniqueId":"021046898538","artifact.ingress.license":["CC pdm"],"artifact.publishedDate":"2017-02-13T06:01:51.694Z","artifact.ingress.producerRole":"Kunstner","identifier.id":"STO.K.02236","artifact.type":"Fineart","identifier.owner":"STO","artifact.uuid":"47F2BB5A-B70D-4F56-B8CB-11B48D71504C","artifact.pictureCount":1,"artifact.updatedDate":"2017-08-18T04:04:29.805Z","artifact.hasPictures":true,"artifact.ingress.production.toYear":1924,"artifact.defaultPictureIndex":113,"artifact.ingress.producer":"Svor, Anders Rasmussen","artifact.hasChildren":false,"artifact.defaultMediaIdentifier":"032yjUvQKRb6","artifact.ingress.production.fromYear":1924,"artifact.ingress.subjects":["Bildende kunst"]},{"artifact.ingress.title":"A Flower [Olje p\xe5 lerret]","artifact.uniqueId":"021046896548","artifact.ingress.license":["AC 1"],"artifact.publishedDate":"2017-02-09T06:01:49.509Z","artifact.ingress.producerRole":"Kunstner","identifier.id":"STO.K.02587","artifact.type":"Fineart","identifier.owner":"STO","artifact.uuid":"64D88011-4FBF-4584-9CDF-CF295CFE8023","artifact.pictureCount":1,"artifact.updatedDate":"2017-08-18T04:02:41.837Z","artifact.hasPictures":true,"artifact.ingress.production.toYear":1993,"artifact.defaultPictureIndex":72,"artifact.ingress.producer":"Johansen, Svein","artifact.hasChildren":false,"artifact.defaultMediaIdentifier":"032yjUvJRVaP","artifact.ingress.production.fromYear":1993,"artifact.ingress.subjects":["Bildende kunst"]},{"artifact.ingress.title":"Cave Canem [Olje p\xe5 lerret]","artifact.uniqueId":"021046896560","artifact.ingress.license":["AC 1"],"artifact.publishedDate":"2017-02-09T06:01:52.398Z","artifact.ingress.producerRole":"Kunstner","identifier.id":"STO.K.02586","artifact.type":"Fineart","identifier.owner":"STO","artifact.uuid":"BA5918D3-2DB9-4AC6-A27D-2B88338EBBE0","artifact.pictureCount":1,"artifact.updatedDate":"2017-08-18T04:02:40.253Z","artifact.hasPictures":true,"artifact.ingress.production.toYear":1993,"artifact.defaultPictureIndex":71,"artifact.ingress.producer":"Johansen, Svein","artifact.hasChildren":false,"artifact.defaultMediaIdentifier":"032yjUvJRVeu","artifact.ingress.production.fromYear":1993,"artifact.ingress.subjects":["Bildende kunst"]},{"artifact.ingress.title":"Mesna fabrikker, Lillehammer [Olje p\xe5 lerret]","artifact.uniqueId":"021046899449","artifact.ingress.license":["CC pdm"],"artifact.publishedDate":"2017-02-15T06:02:17.875Z","artifact.ingress.producerRole":"Kunstner","identifier.id":"STO.K.02597","artifact.type":"Fineart","identifier.owner":"STO","artifact.uuid":"C26CD8DE-CA77-41B8-9363-03746C9F9FCC","artifact.pictureCount":1,"artifact.updatedDate":"2017-08-18T04:02:49.115Z","artifact.hasPictures":true,"artifact.ingress.production.toYear":1908,"artifact.defaultPictureIndex":95,"artifact.ingress.producer":"Jorde, Lars","artifact.hasChildren":false,"artifact.defaultMediaIdentifier":"022yjUvRqRTL","artifact.ingress.production.fromYear":1908,"artifact.ingress.subjects":["Bildende kunst"]}]');

});

parcelRegister("O6tRJ", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("49an4", function(module, exports) {
//! openseadragon 2.4.0
//! Built on 2018-07-20
//! Git commit: v2.4.0-0-446af4d
//! http://openseadragon.github.io
//! License: http://openseadragon.github.io/license/
/*
 * OpenSeadragon
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /*
 * Portions of this source file taken from jQuery:
 *
 * Copyright 2011 John Resig
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ /*
 * Portions of this source file taken from mattsnider.com:
 *
 * Copyright (c) 2006-2013 Matt Snider
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT
 * OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR
 * THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ /**
 * @namespace OpenSeadragon
 * @version openseadragon 2.4.0
 * @classdesc The root namespace for OpenSeadragon.  All utility methods
 * and classes are defined on or below this namespace.
 *
 */ // Typedefs
/**
  * All required and optional settings for instantiating a new instance of an OpenSeadragon image viewer.
  *
  * @typedef {Object} Options
  * @memberof OpenSeadragon
  *
  * @property {String} id
  *     Id of the element to append the viewer's container element to. If not provided, the 'element' property must be provided.
  *     If both the element and id properties are specified, the viewer is appended to the element provided in the element property.
  *
  * @property {Element} element
  *     The element to append the viewer's container element to. If not provided, the 'id' property must be provided.
  *     If both the element and id properties are specified, the viewer is appended to the element provided in the element property.
  *
  * @property {Array|String|Function|Object} [tileSources=null]
  *     Tile source(s) to open initially. This is a complex parameter; see
  *     {@link OpenSeadragon.Viewer#open} for details.
  *
  * @property {Number} [tabIndex=0]
  *     Tabbing order index to assign to the viewer element. Positive values are selected in increasing order. When tabIndex is 0
  *     source order is used. A negative value omits the viewer from the tabbing order.
  *
  * @property {Array} overlays Array of objects defining permanent overlays of
  *     the viewer. The overlays added via this option and later removed with
  *     {@link OpenSeadragon.Viewer#removeOverlay} will be added back when a new
  *     image is opened.
  *     To add overlays which can be definitively removed, one must use
  *     {@link OpenSeadragon.Viewer#addOverlay}
  *     If displaying a sequence of images, the overlays can be associated
  *     with a specific page by passing the overlays array to the page's
  *     tile source configuration.
  *     Expected properties:
  *     * x, y, (or px, py for pixel coordinates) to define the location.
  *     * width, height in point if using x,y or in pixels if using px,py. If width
  *       and height are specified, the overlay size is adjusted when zooming,
  *       otherwise the size stays the size of the content (or the size defined by CSS).
  *     * className to associate a class to the overlay
  *     * id to set the overlay element. If an element with this id already exists,
  *       it is reused, otherwise it is created. If not specified, a new element is
  *       created.
  *     * placement a string to define the relative position to the viewport.
  *       Only used if no width and height are specified. Default: 'TOP_LEFT'.
  *       See {@link OpenSeadragon.Placement} for possible values.
  *
  * @property {String} [xmlPath=null]
  *     <strong>DEPRECATED</strong>. A relative path to load a DZI file from the server.
  *     Prefer the newer Options.tileSources.
  *
  * @property {String} [prefixUrl='/images/']
  *     Prepends the prefixUrl to navImages paths, which is very useful
  *     since the default paths are rarely useful for production
  *     environments.
  *
  * @property {OpenSeadragon.NavImages} [navImages]
  *     An object with a property for each button or other built-in navigation
  *     control, eg the current 'zoomIn', 'zoomOut', 'home', and 'fullpage'.
  *     Each of those in turn provides an image path for each state of the button
  *     or navigation control, eg 'REST', 'GROUP', 'HOVER', 'PRESS'. Finally the
  *     image paths, by default assume there is a folder on the servers root path
  *     called '/images', eg '/images/zoomin_rest.png'.  If you need to adjust
  *     these paths, prefer setting the option.prefixUrl rather than overriding
  *     every image path directly through this setting.
  *
  * @property {Boolean} [debugMode=false]
  *     TODO: provide an in-screen panel providing event detail feedback.
  *
  * @property {String} [debugGridColor=['#437AB2', '#1B9E77', '#D95F02', '#7570B3', '#E7298A', '#66A61E', '#E6AB02', '#A6761D', '#666666']]
  *     The colors of grids in debug mode. Each tiled image's grid uses a consecutive color.
  *     If there are more tiled images than provided colors, the color vector is recycled.
  *
  * @property {Number} [blendTime=0]
  *     Specifies the duration of animation as higher or lower level tiles are
  *     replacing the existing tile.
  *
  * @property {Boolean} [alwaysBlend=false]
  *     Forces the tile to always blend.  By default the tiles skip blending
  *     when the blendTime is surpassed and the current animation frame would
  *     not complete the blend.
  *
  * @property {Boolean} [autoHideControls=true]
  *     If the user stops interacting with the viewport, fade the navigation
  *     controls.  Useful for presentation since the controls are by default
  *     floated on top of the image the user is viewing.
  *
  * @property {Boolean} [immediateRender=false]
  *     Render the best closest level first, ignoring the lowering levels which
  *     provide the effect of very blurry to sharp. It is recommended to change
  *     setting to true for mobile devices.
  *
  * @property {Number} [defaultZoomLevel=0]
  *     Zoom level to use when image is first opened or the home button is clicked.
  *     If 0, adjusts to fit viewer.
  *
  * @property {Number} [opacity=1]
  *     Default proportional opacity of the tiled images (1=opaque, 0=hidden)
  *     Hidden images do not draw and only load when preloading is allowed.
  *
  * @property {Boolean} [preload=false]
  *     Default switch for loading hidden images (true loads, false blocks)
  *
  * @property {String} [compositeOperation=null]
  *     Valid values are 'source-over', 'source-atop', 'source-in', 'source-out',
  *     'destination-over', 'destination-atop', 'destination-in',
  *     'destination-out', 'lighter', 'copy' or 'xor'
  *
  * @property {String|CanvasGradient|CanvasPattern|Function} [placeholderFillStyle=null]
  *     Draws a colored rectangle behind the tile if it is not loaded yet.
  *     You can pass a CSS color value like "#FF8800".
  *     When passing a function the tiledImage and canvas context are available as argument which is useful when you draw a gradient or pattern.
  *
  * @property {Number} [degrees=0]
  *     Initial rotation.
  *
  * @property {Boolean} [flipped=false]
  *     Initial flip state.
  *
  * @property {Number} [minZoomLevel=null]
  *
  * @property {Number} [maxZoomLevel=null]
  *
  * @property {Boolean} [homeFillsViewer=false]
  *     Make the 'home' button fill the viewer and clip the image, instead
  *     of fitting the image to the viewer and letterboxing.
  *
  * @property {Boolean} [panHorizontal=true]
  *     Allow horizontal pan.
  *
  * @property {Boolean} [panVertical=true]
  *     Allow vertical pan.
  *
  * @property {Boolean} [constrainDuringPan=false]
  *
  * @property {Boolean} [wrapHorizontal=false]
  *     Set to true to force the image to wrap horizontally within the viewport.
  *     Useful for maps or images representing the surface of a sphere or cylinder.
  *
  * @property {Boolean} [wrapVertical=false]
  *     Set to true to force the image to wrap vertically within the viewport.
  *     Useful for maps or images representing the surface of a sphere or cylinder.
  *
  * @property {Number} [minZoomImageRatio=0.9]
  *     The minimum percentage ( expressed as a number between 0 and 1 ) of
  *     the viewport height or width at which the zoom out will be constrained.
  *     Setting it to 0, for example will allow you to zoom out infinity.
  *
  * @property {Number} [maxZoomPixelRatio=1.1]
  *     The maximum ratio to allow a zoom-in to affect the highest level pixel
  *     ratio. This can be set to Infinity to allow 'infinite' zooming into the
  *     image though it is less effective visually if the HTML5 Canvas is not
  *     availble on the viewing device.
  *
  * @property {Number} [smoothTileEdgesMinZoom=1.1]
  *     A zoom percentage ( where 1 is 100% ) of the highest resolution level.
  *     When zoomed in beyond this value alternative compositing will be used to
  *     smooth out the edges between tiles. This will have a performance impact.
  *     Can be set to Infinity to turn it off.
  *     Note: This setting is ignored on iOS devices due to a known bug (See {@link https://github.com/openseadragon/openseadragon/issues/952})
  *
  * @property {Boolean} [iOSDevice=?]
  *     True if running on an iOS device, false otherwise.
  *     Used to disable certain features that behave differently on iOS devices.
  *
  * @property {Boolean} [autoResize=true]
  *     Set to false to prevent polling for viewer size changes. Useful for providing custom resize behavior.
  *
  * @property {Boolean} [preserveImageSizeOnResize=false]
  *     Set to true to have the image size preserved when the viewer is resized. This requires autoResize=true (default).
  *
  * @property {Number} [minScrollDeltaTime=50]
  *     Number of milliseconds between canvas-scroll events. This value helps normalize the rate of canvas-scroll
  *     events between different devices, causing the faster devices to slow down enough to make the zoom control
  *     more manageable.
  *
  * @property {Number} [pixelsPerWheelLine=40]
  *     For pixel-resolution scrolling devices, the number of pixels equal to one scroll line.
  *
  * @property {Number} [pixelsPerArrowPress=40]
  *     The number of pixels viewport moves when an arrow key is pressed.
  *
  * @property {Number} [visibilityRatio=0.5]
  *     The percentage ( as a number from 0 to 1 ) of the source image which
  *     must be kept within the viewport.  If the image is dragged beyond that
  *     limit, it will 'bounce' back until the minimum visibility ratio is
  *     achieved.  Setting this to 0 and wrapHorizontal ( or wrapVertical ) to
  *     true will provide the effect of an infinitely scrolling viewport.
  *
  * @property {Object} [viewportMargins={}]
  *     Pushes the "home" region in from the sides by the specified amounts.
  *     Possible subproperties (Numbers, in screen coordinates): left, top, right, bottom.
  *
  * @property {Number} [imageLoaderLimit=0]
  *     The maximum number of image requests to make concurrently. By default
  *     it is set to 0 allowing the browser to make the maximum number of
  *     image requests in parallel as allowed by the browsers policy.
  *
  * @property {Number} [clickTimeThreshold=300]
  *      The number of milliseconds within which a pointer down-up event combination
  *      will be treated as a click gesture.
  *
  * @property {Number} [clickDistThreshold=5]
  *      The maximum distance allowed between a pointer down event and a pointer up event
  *      to be treated as a click gesture.
  *
  * @property {Number} [dblClickTimeThreshold=300]
  *      The number of milliseconds within which two pointer down-up event combinations
  *      will be treated as a double-click gesture.
  *
  * @property {Number} [dblClickDistThreshold=20]
  *      The maximum distance allowed between two pointer click events
  *      to be treated as a double-click gesture.
  *
  * @property {Number} [springStiffness=6.5]
  *
  * @property {Number} [animationTime=1.2]
  *     Specifies the animation duration per each {@link OpenSeadragon.Spring}
  *     which occur when the image is dragged or zoomed.
  *
  * @property {OpenSeadragon.GestureSettings} [gestureSettingsMouse]
  *     Settings for gestures generated by a mouse pointer device. (See {@link OpenSeadragon.GestureSettings})
  * @property {Boolean} [gestureSettingsMouse.scrollToZoom=true] - Zoom on scroll gesture
  * @property {Boolean} [gestureSettingsMouse.clickToZoom=true] - Zoom on click gesture
  * @property {Boolean} [gestureSettingsMouse.dblClickToZoom=false] - Zoom on double-click gesture. Note: If set to true
  *     then clickToZoom should be set to false to prevent multiple zooms.
  * @property {Boolean} [gestureSettingsMouse.pinchToZoom=false] - Zoom on pinch gesture
  * @property {Boolean} [gestureSettingsMouse.zoomToRefPoint=true] - If zoomToRefPoint is true, the zoom is centered at the pointer position. Otherwise,
  *     the zoom is centered at the canvas center.
  * @property {Boolean} [gestureSettingsMouse.flickEnabled=false] - Enable flick gesture
  * @property {Number} [gestureSettingsMouse.flickMinSpeed=120] - If flickEnabled is true, the minimum speed to initiate a flick gesture (pixels-per-second)
  * @property {Number} [gestureSettingsMouse.flickMomentum=0.25] - If flickEnabled is true, the momentum factor for the flick gesture
  * @property {Boolean} [gestureSettingsMouse.pinchRotate=false] - If pinchRotate is true, the user will have the ability to rotate the image using their fingers.
  *
  * @property {OpenSeadragon.GestureSettings} [gestureSettingsTouch]
  *     Settings for gestures generated by a touch pointer device. (See {@link OpenSeadragon.GestureSettings})
  * @property {Boolean} [gestureSettingsTouch.scrollToZoom=false] - Zoom on scroll gesture
  * @property {Boolean} [gestureSettingsTouch.clickToZoom=false] - Zoom on click gesture
  * @property {Boolean} [gestureSettingsTouch.dblClickToZoom=true] - Zoom on double-click gesture. Note: If set to true
  *     then clickToZoom should be set to false to prevent multiple zooms.
  * @property {Boolean} [gestureSettingsTouch.pinchToZoom=true] - Zoom on pinch gesture
  * @property {Boolean} [gestureSettingsTouch.zoomToRefPoint=true] - If zoomToRefPoint is true, the zoom is centered at the pointer position. Otherwise,
  *     the zoom is centered at the canvas center.
  * @property {Boolean} [gestureSettingsTouch.flickEnabled=true] - Enable flick gesture
  * @property {Number} [gestureSettingsTouch.flickMinSpeed=120] - If flickEnabled is true, the minimum speed to initiate a flick gesture (pixels-per-second)
  * @property {Number} [gestureSettingsTouch.flickMomentum=0.25] - If flickEnabled is true, the momentum factor for the flick gesture
  * @property {Boolean} [gestureSettingsTouch.pinchRotate=false] - If pinchRotate is true, the user will have the ability to rotate the image using their fingers.
  *
  * @property {OpenSeadragon.GestureSettings} [gestureSettingsPen]
  *     Settings for gestures generated by a pen pointer device. (See {@link OpenSeadragon.GestureSettings})
  * @property {Boolean} [gestureSettingsPen.scrollToZoom=false] - Zoom on scroll gesture
  * @property {Boolean} [gestureSettingsPen.clickToZoom=true] - Zoom on click gesture
  * @property {Boolean} [gestureSettingsPen.dblClickToZoom=false] - Zoom on double-click gesture. Note: If set to true
  *     then clickToZoom should be set to false to prevent multiple zooms.
  * @property {Boolean} [gestureSettingsPen.pinchToZoom=false] - Zoom on pinch gesture
  * @property {Boolean} [gestureSettingsPan.zoomToRefPoint=true] - If zoomToRefPoint is true, the zoom is centered at the pointer position. Otherwise,
  *     the zoom is centered at the canvas center.
  * @property {Boolean} [gestureSettingsPen.flickEnabled=false] - Enable flick gesture
  * @property {Number} [gestureSettingsPen.flickMinSpeed=120] - If flickEnabled is true, the minimum speed to initiate a flick gesture (pixels-per-second)
  * @property {Number} [gestureSettingsPen.flickMomentum=0.25] - If flickEnabled is true, the momentum factor for the flick gesture
  * @property {Boolean} [gestureSettingsPen.pinchRotate=false] - If pinchRotate is true, the user will have the ability to rotate the image using their fingers.
  *
  * @property {OpenSeadragon.GestureSettings} [gestureSettingsUnknown]
  *     Settings for gestures generated by unknown pointer devices. (See {@link OpenSeadragon.GestureSettings})
  * @property {Boolean} [gestureSettingsUnknown.scrollToZoom=true] - Zoom on scroll gesture
  * @property {Boolean} [gestureSettingsUnknown.clickToZoom=false] - Zoom on click gesture
  * @property {Boolean} [gestureSettingsUnknown.dblClickToZoom=true] - Zoom on double-click gesture. Note: If set to true
  *     then clickToZoom should be set to false to prevent multiple zooms.
  * @property {Boolean} [gestureSettingsUnknown.pinchToZoom=true] - Zoom on pinch gesture
  * @property {Boolean} [gestureSettingsUnknown.zoomToRefPoint=true] - If zoomToRefPoint is true, the zoom is centered at the pointer position. Otherwise,
  *     the zoom is centered at the canvas center.
  * @property {Boolean} [gestureSettingsUnknown.flickEnabled=true] - Enable flick gesture
  * @property {Number} [gestureSettingsUnknown.flickMinSpeed=120] - If flickEnabled is true, the minimum speed to initiate a flick gesture (pixels-per-second)
  * @property {Number} [gestureSettingsUnknown.flickMomentum=0.25] - If flickEnabled is true, the momentum factor for the flick gesture
  * @property {Boolean} [gestureSettingsUnknown.pinchRotate=false] - If pinchRotate is true, the user will have the ability to rotate the image using their fingers.
  *
  * @property {Number} [zoomPerClick=2.0]
  *     The "zoom distance" per mouse click or touch tap. <em><strong>Note:</strong> Setting this to 1.0 effectively disables the click-to-zoom feature (also see gestureSettings[Mouse|Touch|Pen].clickToZoom/dblClickToZoom).</em>
  *
  * @property {Number} [zoomPerScroll=1.2]
  *     The "zoom distance" per mouse scroll or touch pinch. <em><strong>Note:</strong> Setting this to 1.0 effectively disables the mouse-wheel zoom feature (also see gestureSettings[Mouse|Touch|Pen].scrollToZoom}).</em>
  *
  * @property {Number} [zoomPerSecond=1.0]
  *     The number of seconds to animate a single zoom event over.
  *
  * @property {Boolean} [showNavigator=false]
  *     Set to true to make the navigator minimap appear.
  *
  * @property {String} [navigatorId=navigator-GENERATED DATE]
  *     The ID of a div to hold the navigator minimap.
  *     If an ID is specified, the navigatorPosition, navigatorSizeRatio, navigatorMaintainSizeRatio, navigator[Top|Left|Height|Width] and navigatorAutoFade options will be ignored.
  *     If an ID is not specified, a div element will be generated and placed on top of the main image.
  *
  * @property {String} [navigatorPosition='TOP_RIGHT']
  *     Valid values are 'TOP_LEFT', 'TOP_RIGHT', 'BOTTOM_LEFT', 'BOTTOM_RIGHT', or 'ABSOLUTE'.<br>
  *     If 'ABSOLUTE' is specified, then navigator[Top|Left|Height|Width] determines the size and position of the navigator minimap in the viewer, and navigatorSizeRatio and navigatorMaintainSizeRatio are ignored.<br>
  *     For 'TOP_LEFT', 'TOP_RIGHT', 'BOTTOM_LEFT', and 'BOTTOM_RIGHT', the navigatorSizeRatio or navigator[Height|Width] values determine the size of the navigator minimap.
  *
  * @property {Number} [navigatorSizeRatio=0.2]
  *     Ratio of navigator size to viewer size. Ignored if navigator[Height|Width] are specified.
  *
  * @property {Boolean} [navigatorMaintainSizeRatio=false]
  *     If true, the navigator minimap is resized (using navigatorSizeRatio) when the viewer size changes.
  *
  * @property {Number|String} [navigatorTop=null]
  *     Specifies the location of the navigator minimap (see navigatorPosition).
  *
  * @property {Number|String} [navigatorLeft=null]
  *     Specifies the location of the navigator minimap (see navigatorPosition).
  *
  * @property {Number|String} [navigatorHeight=null]
  *     Specifies the size of the navigator minimap (see navigatorPosition).
  *     If specified, navigatorSizeRatio and navigatorMaintainSizeRatio are ignored.
  *
  * @property {Number|String} [navigatorWidth=null]
  *     Specifies the size of the navigator minimap (see navigatorPosition).
  *     If specified, navigatorSizeRatio and navigatorMaintainSizeRatio are ignored.
  *
  * @property {Boolean} [navigatorAutoResize=true]
  *     Set to false to prevent polling for navigator size changes. Useful for providing custom resize behavior.
  *     Setting to false can also improve performance when the navigator is configured to a fixed size.
  *
  * @property {Boolean} [navigatorAutoFade=true]
  *     If the user stops interacting with the viewport, fade the navigator minimap.
  *     Setting to false will make the navigator minimap always visible.
  *
  * @property {Boolean} [navigatorRotate=true]
  *     If true, the navigator will be rotated together with the viewer.
  *
  * @property {String} [navigatorBackground='#000']
  *     Specifies the background color of the navigator minimap
  *
  * @property {Number} [navigatorOpacity=0.8]
  *     Specifies the opacity of the navigator minimap.
  *
  * @property {String} [navigatorBorderColor='#555']
  *     Specifies the border color of the navigator minimap
  *
  * @property {String} [navigatorDisplayRegionColor='#900']
  *     Specifies the border color of the display region rectangle of the navigator minimap
  *
  * @property {Number} [controlsFadeDelay=2000]
  *     The number of milliseconds to wait once the user has stopped interacting
  *     with the interface before begining to fade the controls. Assumes
  *     showNavigationControl and autoHideControls are both true.
  *
  * @property {Number} [controlsFadeLength=1500]
  *     The number of milliseconds to animate the controls fading out.
  *
  * @property {Number} [maxImageCacheCount=200]
  *     The max number of images we should keep in memory (per drawer).
  *
  * @property {Number} [timeout=30000]
  *     The max number of milliseconds that an image job may take to complete.
  *
  * @property {Boolean} [useCanvas=true]
  *     Set to false to not use an HTML canvas element for image rendering even if canvas is supported.
  *
  * @property {Number} [minPixelRatio=0.5]
  *     The higher the minPixelRatio, the lower the quality of the image that
  *     is considered sufficient to stop rendering a given zoom level.  For
  *     example, if you are targeting mobile devices with less bandwith you may
  *     try setting this to 1.5 or higher.
  *
  * @property {Boolean} [mouseNavEnabled=true]
  *     Is the user able to interact with the image via mouse or touch. Default
  *     interactions include draging the image in a plane, and zooming in toward
  *     and away from the image.
  *
  * @property {Boolean} [showNavigationControl=true]
  *     Set to false to prevent the appearance of the default navigation controls.<br>
  *     Note that if set to false, the customs buttons set by the options
  *     zoomInButton, zoomOutButton etc, are rendered inactive.
  *
  * @property {OpenSeadragon.ControlAnchor} [navigationControlAnchor=TOP_LEFT]
  *     Placement of the default navigation controls.
  *     To set the placement of the sequence controls, see the
  *     sequenceControlAnchor option.
  *
  * @property {Boolean} [showZoomControl=true]
  *     If true then + and - buttons to zoom in and out are displayed.<br>
  *     Note: {@link OpenSeadragon.Options.showNavigationControl} is overriding
  *     this setting when set to false.
  *
  * @property {Boolean} [showHomeControl=true]
  *     If true then the 'Go home' button is displayed to go back to the original
  *     zoom and pan.<br>
  *     Note: {@link OpenSeadragon.Options.showNavigationControl} is overriding
  *     this setting when set to false.
  *
  * @property {Boolean} [showFullPageControl=true]
  *     If true then the 'Toggle full page' button is displayed to switch
  *     between full page and normal mode.<br>
  *     Note: {@link OpenSeadragon.Options.showNavigationControl} is overriding
  *     this setting when set to false.
  *
  * @property {Boolean} [showRotationControl=false]
  *     If true then the rotate left/right controls will be displayed as part of the
  *     standard controls. This is also subject to the browser support for rotate
  *     (e.g. viewer.drawer.canRotate()).<br>
  *     Note: {@link OpenSeadragon.Options.showNavigationControl} is overriding
  *     this setting when set to false.
  *
  * @property {Boolean} [showFlipControl=false]
  *     If true then the flip controls will be displayed as part of the
  *     standard controls.
  *
  * @property {Boolean} [showSequenceControl=true]
  *     If sequenceMode is true, then provide buttons for navigating forward and
  *     backward through the images.
  *
  * @property {OpenSeadragon.ControlAnchor} [sequenceControlAnchor=TOP_LEFT]
  *     Placement of the default sequence controls.
  *
  * @property {Boolean} [navPrevNextWrap=false]
  *     If true then the 'previous' button will wrap to the last image when
  *     viewing the first image and the 'next' button will wrap to the first
  *     image when viewing the last image.
  *
  * @property {String} zoomInButton
  *     Set the id of the custom 'Zoom in' button to use.
  *     This is useful to have a custom button anywhere in the web page.<br>
  *     To only change the button images, consider using
  *     {@link OpenSeadragon.Options.navImages}
  *
  * @property {String} zoomOutButton
  *     Set the id of the custom 'Zoom out' button to use.
  *     This is useful to have a custom button anywhere in the web page.<br>
  *     To only change the button images, consider using
  *     {@link OpenSeadragon.Options.navImages}
  *
  * @property {String} homeButton
  *     Set the id of the custom 'Go home' button to use.
  *     This is useful to have a custom button anywhere in the web page.<br>
  *     To only change the button images, consider using
  *     {@link OpenSeadragon.Options.navImages}
  *
  * @property {String} fullPageButton
  *     Set the id of the custom 'Toggle full page' button to use.
  *     This is useful to have a custom button anywhere in the web page.<br>
  *     To only change the button images, consider using
  *     {@link OpenSeadragon.Options.navImages}
  *
  * @property {String} rotateLeftButton
  *     Set the id of the custom 'Rotate left' button to use.
  *     This is useful to have a custom button anywhere in the web page.<br>
  *     To only change the button images, consider using
  *     {@link OpenSeadragon.Options.navImages}
  *
  * @property {String} rotateRightButton
  *     Set the id of the custom 'Rotate right' button to use.
  *     This is useful to have a custom button anywhere in the web page.<br>
  *     To only change the button images, consider using
  *     {@link OpenSeadragon.Options.navImages}
  *
  * @property {String} previousButton
  *     Set the id of the custom 'Previous page' button to use.
  *     This is useful to have a custom button anywhere in the web page.<br>
  *     To only change the button images, consider using
  *     {@link OpenSeadragon.Options.navImages}
  *
  * @property {String} nextButton
  *     Set the id of the custom 'Next page' button to use.
  *     This is useful to have a custom button anywhere in the web page.<br>
  *     To only change the button images, consider using
  *     {@link OpenSeadragon.Options.navImages}
  *
  * @property {Boolean} [sequenceMode=false]
  *     Set to true to have the viewer treat your tilesources as a sequence of images to
  *     be opened one at a time rather than all at once.
  *
  * @property {Number} [initialPage=0]
  *     If sequenceMode is true, display this page initially.
  *
  * @property {Boolean} [preserveViewport=false]
  *     If sequenceMode is true, then normally navigating through each image resets the
  *     viewport to 'home' position.  If preserveViewport is set to true, then the viewport
  *     position is preserved when navigating between images in the sequence.
  *
  * @property {Boolean} [preserveOverlays=false]
  *     If sequenceMode is true, then normally navigating through each image
  *     resets the overlays.
  *     If preserveOverlays is set to true, then the overlays added with {@link OpenSeadragon.Viewer#addOverlay}
  *     are preserved when navigating between images in the sequence.
  *     Note: setting preserveOverlays overrides any overlays specified in the global
  *     "overlays" option for the Viewer. It's also not compatible with specifying
  *     per-tileSource overlays via the options, as those overlays will persist
  *     even after the tileSource is closed.
  *
  * @property {Boolean} [showReferenceStrip=false]
  *     If sequenceMode is true, then display a scrolling strip of image thumbnails for
  *     navigating through the images.
  *
  * @property {String} [referenceStripScroll='horizontal']
  *
  * @property {Element} [referenceStripElement=null]
  *
  * @property {Number} [referenceStripHeight=null]
  *
  * @property {Number} [referenceStripWidth=null]
  *
  * @property {String} [referenceStripPosition='BOTTOM_LEFT']
  *
  * @property {Number} [referenceStripSizeRatio=0.2]
  *
  * @property {Boolean} [collectionMode=false]
  *     Set to true to have the viewer arrange your TiledImages in a grid or line.
  *
  * @property {Number} [collectionRows=3]
  *     If collectionMode is true, specifies how many rows the grid should have. Use 1 to make a line.
  *     If collectionLayout is 'vertical', specifies how many columns instead.
  *
  * @property {Number} [collectionColumns=0]
  *     If collectionMode is true, specifies how many columns the grid should have. Use 1 to make a line.
  *     If collectionLayout is 'vertical', specifies how many rows instead. Ignored if collectionRows is not set to a falsy value.
  *
  * @property {String} [collectionLayout='horizontal']
  *     If collectionMode is true, specifies whether to arrange vertically or horizontally.
  *
  * @property {Number} [collectionTileSize=800]
  *     If collectionMode is true, specifies the size, in viewport coordinates, for each TiledImage to fit into.
  *     The TiledImage will be centered within a square of the specified size.
  *
  * @property {Number} [collectionTileMargin=80]
  *     If collectionMode is true, specifies the margin, in viewport coordinates, between each TiledImage.
  *
  * @property {String|Boolean} [crossOriginPolicy=false]
  *     Valid values are 'Anonymous', 'use-credentials', and false. If false, canvas requests will
  *     not use CORS, and the canvas will be tainted.
  *
  * @property {Boolean} [ajaxWithCredentials=false]
  *     Whether to set the withCredentials XHR flag for AJAX requests.
  *     Note that this can be overridden at the {@link OpenSeadragon.TileSource} level.
  *
  * @property {Boolean} [loadTilesWithAjax=false]
  *     Whether to load tile data using AJAX requests.
  *     Note that this can be overridden at the {@link OpenSeadragon.TileSource} level.
  *
  * @property {Object} [ajaxHeaders={}]
  *     A set of headers to include when making AJAX requests for tile sources or tiles.
  *
  */ /**
  * Settings for gestures generated by a pointer device.
  *
  * @typedef {Object} GestureSettings
  * @memberof OpenSeadragon
  *
  * @property {Boolean} scrollToZoom
  *     Set to false to disable zooming on scroll gestures.
  *
  * @property {Boolean} clickToZoom
  *     Set to false to disable zooming on click gestures.
  *
  * @property {Boolean} dblClickToZoom
  *     Set to false to disable zooming on double-click gestures. Note: If set to true
  *     then clickToZoom should be set to false to prevent multiple zooms.
  *
  * @property {Boolean} pinchToZoom
  *     Set to false to disable zooming on pinch gestures.
  *
  * @property {Boolean} flickEnabled
  *     Set to false to disable the kinetic panning effect (flick) at the end of a drag gesture.
  *
  * @property {Number} flickMinSpeed
  *     If flickEnabled is true, the minimum speed (in pixels-per-second) required to cause the kinetic panning effect (flick) at the end of a drag gesture.
  *
  * @property {Number} flickMomentum
  *     If flickEnabled is true, a constant multiplied by the velocity to determine the distance of the kinetic panning effect (flick) at the end of a drag gesture.
  *     A larger value will make the flick feel "lighter", while a smaller value will make the flick feel "heavier".
  *     Note: springStiffness and animationTime also affect the "spring" used to stop the flick animation.
  *
  */ /**
  * The names for the image resources used for the image navigation buttons.
  *
  * @typedef {Object} NavImages
  * @memberof OpenSeadragon
  *
  * @property {Object} zoomIn - Images for the zoom-in button.
  * @property {String} zoomIn.REST
  * @property {String} zoomIn.GROUP
  * @property {String} zoomIn.HOVER
  * @property {String} zoomIn.DOWN
  *
  * @property {Object} zoomOut - Images for the zoom-out button.
  * @property {String} zoomOut.REST
  * @property {String} zoomOut.GROUP
  * @property {String} zoomOut.HOVER
  * @property {String} zoomOut.DOWN
  *
  * @property {Object} home - Images for the home button.
  * @property {String} home.REST
  * @property {String} home.GROUP
  * @property {String} home.HOVER
  * @property {String} home.DOWN
  *
  * @property {Object} fullpage - Images for the full-page button.
  * @property {String} fullpage.REST
  * @property {String} fullpage.GROUP
  * @property {String} fullpage.HOVER
  * @property {String} fullpage.DOWN
  *
  * @property {Object} rotateleft - Images for the rotate left button.
  * @property {String} rotateleft.REST
  * @property {String} rotateleft.GROUP
  * @property {String} rotateleft.HOVER
  * @property {String} rotateleft.DOWN
  *
  * @property {Object} rotateright - Images for the rotate right button.
  * @property {String} rotateright.REST
  * @property {String} rotateright.GROUP
  * @property {String} rotateright.HOVER
  * @property {String} rotateright.DOWN
  *
  * @property {Object} flip - Images for the flip button.
  * @property {String} flip.REST
  * @property {String} flip.GROUP
  * @property {String} flip.HOVER
  * @property {String} flip.DOWN
  *
  * @property {Object} previous - Images for the previous button.
  * @property {String} previous.REST
  * @property {String} previous.GROUP
  * @property {String} previous.HOVER
  * @property {String} previous.DOWN
  *
  * @property {Object} next - Images for the next button.
  * @property {String} next.REST
  * @property {String} next.GROUP
  * @property {String} next.HOVER
  * @property {String} next.DOWN
  *
  */ function OpenSeadragon(options11) {
    return new OpenSeadragon.Viewer(options11);
}
(function($11) {
    /**
     * The OpenSeadragon version.
     *
     * @member {Object} OpenSeadragon.version
     * @property {String} versionStr - The version number as a string ('major.minor.revision').
     * @property {Number} major - The major version number.
     * @property {Number} minor - The minor version number.
     * @property {Number} revision - The revision number.
     * @since 1.0.0
     */ $11.version = {
        versionStr: "2.4.0",
        major: parseInt("2", 10),
        minor: parseInt("4", 10),
        revision: parseInt("0", 10)
    };
    /**
     * Taken from jquery 1.6.1
     * [[Class]] -> type pairs
     * @private
     */ var class2type11 = {
        "[object Boolean]": "boolean",
        "[object Number]": "number",
        "[object String]": "string",
        "[object Function]": "function",
        "[object Array]": "array",
        "[object Date]": "date",
        "[object RegExp]": "regexp",
        "[object Object]": "object"
    }, // Save a reference to some core methods
    toString11 = Object.prototype.toString, hasOwn11 = Object.prototype.hasOwnProperty;
    /**
     * Taken from jQuery 1.6.1
     * @function isFunction
     * @memberof OpenSeadragon
     * @see {@link http://www.jquery.com/ jQuery}
     */ $11.isFunction = function(obj11) {
        return $11.type(obj11) === "function";
    };
    /**
     * Taken from jQuery 1.6.1
     * @function isArray
     * @memberof OpenSeadragon
     * @see {@link http://www.jquery.com/ jQuery}
     */ $11.isArray = Array.isArray || function(obj11) {
        return $11.type(obj11) === "array";
    };
    /**
     * A crude way of determining if an object is a window.
     * Taken from jQuery 1.6.1
     * @function isWindow
     * @memberof OpenSeadragon
     * @see {@link http://www.jquery.com/ jQuery}
     */ $11.isWindow = function(obj11) {
        return obj11 && typeof obj11 === "object" && "setInterval" in obj11;
    };
    /**
     * Taken from jQuery 1.6.1
     * @function type
     * @memberof OpenSeadragon
     * @see {@link http://www.jquery.com/ jQuery}
     */ $11.type = function(obj11) {
        return obj11 === null || obj11 === undefined ? String(obj11) : class2type11[toString11.call(obj11)] || "object";
    };
    /**
     * Taken from jQuery 1.6.1
     * @function isPlainObject
     * @memberof OpenSeadragon
     * @see {@link http://www.jquery.com/ jQuery}
     */ $11.isPlainObject = function(obj11) {
        // Must be an Object.
        // Because of IE, we also have to check the presence of the constructor property.
        // Make sure that DOM nodes and window objects don't pass through, as well
        if (!obj11 || OpenSeadragon.type(obj11) !== "object" || obj11.nodeType || $11.isWindow(obj11)) return false;
        // Not own constructor property must be Object
        if (obj11.constructor && !hasOwn11.call(obj11, "constructor") && !hasOwn11.call(obj11.constructor.prototype, "isPrototypeOf")) return false;
        // Own properties are enumerated firstly, so to speed up,
        // if last one is own, then all properties are own.
        var lastKey11;
        for(var key11 in obj11)lastKey11 = key11;
        return lastKey11 === undefined || hasOwn11.call(obj11, lastKey11);
    };
    /**
     * Taken from jQuery 1.6.1
     * @function isEmptyObject
     * @memberof OpenSeadragon
     * @see {@link http://www.jquery.com/ jQuery}
     */ $11.isEmptyObject = function(obj11) {
        for(var name11 in obj11)return false;
        return true;
    };
    /**
     * Shim around Object.freeze. Does nothing if Object.freeze is not supported.
     * @param {Object} obj The object to freeze.
     * @return {Object} obj The frozen object.
     */ $11.freezeObject = function(obj11) {
        if (Object.freeze) $11.freezeObject = Object.freeze;
        else $11.freezeObject = function(obj11) {
            return obj11;
        };
        return $11.freezeObject(obj11);
    };
    /**
     * True if the browser supports the HTML5 canvas element
     * @member {Boolean} supportsCanvas
     * @memberof OpenSeadragon
     */ $11.supportsCanvas = function() {
        var canvasElement11 = document.createElement("canvas");
        return !!($11.isFunction(canvasElement11.getContext) && canvasElement11.getContext("2d"));
    }();
    /**
     * Test whether the submitted canvas is tainted or not.
     * @argument {Canvas} canvas The canvas to test.
     * @returns {Boolean} True if the canvas is tainted.
     */ $11.isCanvasTainted = function(canvas11) {
        var isTainted11 = false;
        try {
            // We test if the canvas is tainted by retrieving data from it.
            // An exception will be raised if the canvas is tainted.
            canvas11.getContext("2d").getImageData(0, 0, 1, 1);
        } catch (e11) {
            isTainted11 = true;
        }
        return isTainted11;
    };
    /**
     * A ratio comparing the device screen's pixel density to the canvas's backing store pixel density,
     * clamped to a minimum of 1. Defaults to 1 if canvas isn't supported by the browser.
     * @member {Number} pixelDensityRatio
     * @memberof OpenSeadragon
     */ $11.pixelDensityRatio = function() {
        if ($11.supportsCanvas) {
            var context11 = document.createElement("canvas").getContext("2d");
            var devicePixelRatio11 = window.devicePixelRatio || 1;
            var backingStoreRatio11 = context11.webkitBackingStorePixelRatio || context11.mozBackingStorePixelRatio || context11.msBackingStorePixelRatio || context11.oBackingStorePixelRatio || context11.backingStorePixelRatio || 1;
            return Math.max(devicePixelRatio11, 1) / backingStoreRatio11;
        } else return 1;
    }();
})(OpenSeadragon);
/**
 *  This closure defines all static methods available to the OpenSeadragon
 *  namespace.  Many, if not most, are taked directly from jQuery for use
 *  to simplify and reduce common programming patterns.  More static methods
 *  from jQuery may eventually make their way into this though we are
 *  attempting to avoid an explicit dependency on jQuery only because
 *  OpenSeadragon is a broadly useful code base and would be made less broad
 *  by requiring jQuery fully.
 *
 *  Some static methods have also been refactored from the original OpenSeadragon
 *  project.
 */ (function($) {
    /**
     * Taken from jQuery 1.6.1
     * @function extend
     * @memberof OpenSeadragon
     * @see {@link http://www.jquery.com/ jQuery}
     */ $.extend = function() {
        var options11, name11, src11, copy11, copyIsArray11, clone11, target11 = arguments[0] || {}, length11 = arguments.length, deep11 = false, i11 = 1;
        // Handle a deep copy situation
        if (typeof target11 === "boolean") {
            deep11 = target11;
            target11 = arguments[1] || {};
            // skip the boolean and the target
            i11 = 2;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target11 !== "object" && !OpenSeadragon.isFunction(target11)) target11 = {};
        // extend jQuery itself if only one argument is passed
        if (length11 === i11) {
            target11 = this;
            --i11;
        }
        for(; i11 < length11; i11++){
            // Only deal with non-null/undefined values
            options11 = arguments[i11];
            if (options11 !== null || options11 !== undefined) // Extend the base object
            for(name11 in options11){
                src11 = target11[name11];
                copy11 = options11[name11];
                // Prevent never-ending loop
                if (target11 === copy11) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep11 && copy11 && (OpenSeadragon.isPlainObject(copy11) || (copyIsArray11 = OpenSeadragon.isArray(copy11)))) {
                    if (copyIsArray11) {
                        copyIsArray11 = false;
                        clone11 = src11 && OpenSeadragon.isArray(src11) ? src11 : [];
                    } else clone11 = src11 && OpenSeadragon.isPlainObject(src11) ? src11 : {};
                    // Never move original objects, clone them
                    target11[name11] = OpenSeadragon.extend(deep11, clone11, copy11);
                // Don't bring in undefined values
                } else if (copy11 !== undefined) target11[name11] = copy11;
            }
        }
        // Return the modified object
        return target11;
    };
    var isIOSDevice = function() {
        if (typeof navigator !== "object") return false;
        var userAgent11 = navigator.userAgent;
        if (typeof userAgent11 !== "string") return false;
        return userAgent11.indexOf("iPhone") !== -1 || userAgent11.indexOf("iPad") !== -1 || userAgent11.indexOf("iPod") !== -1;
    };
    $.extend($, /** @lends OpenSeadragon */ {
        /**
         * The default values for the optional settings documented at {@link OpenSeadragon.Options}.
         * @static
         * @type {Object}
         */ DEFAULT_SETTINGS: {
            //DATA SOURCE DETAILS
            xmlPath: null,
            tileSources: null,
            tileHost: null,
            initialPage: 0,
            crossOriginPolicy: false,
            ajaxWithCredentials: false,
            loadTilesWithAjax: false,
            ajaxHeaders: {},
            //PAN AND ZOOM SETTINGS AND CONSTRAINTS
            panHorizontal: true,
            panVertical: true,
            constrainDuringPan: false,
            wrapHorizontal: false,
            wrapVertical: false,
            visibilityRatio: 0.5,
            minPixelRatio: 0.5,
            defaultZoomLevel: 0,
            minZoomLevel: null,
            maxZoomLevel: null,
            homeFillsViewer: false,
            //UI RESPONSIVENESS AND FEEL
            clickTimeThreshold: 300,
            clickDistThreshold: 5,
            dblClickTimeThreshold: 300,
            dblClickDistThreshold: 20,
            springStiffness: 6.5,
            animationTime: 1.2,
            gestureSettingsMouse: {
                scrollToZoom: true,
                clickToZoom: true,
                dblClickToZoom: false,
                pinchToZoom: false,
                zoomToRefPoint: true,
                flickEnabled: false,
                flickMinSpeed: 120,
                flickMomentum: 0.25,
                pinchRotate: false
            },
            gestureSettingsTouch: {
                scrollToZoom: false,
                clickToZoom: false,
                dblClickToZoom: true,
                pinchToZoom: true,
                zoomToRefPoint: true,
                flickEnabled: true,
                flickMinSpeed: 120,
                flickMomentum: 0.25,
                pinchRotate: false
            },
            gestureSettingsPen: {
                scrollToZoom: false,
                clickToZoom: true,
                dblClickToZoom: false,
                pinchToZoom: false,
                zoomToRefPoint: true,
                flickEnabled: false,
                flickMinSpeed: 120,
                flickMomentum: 0.25,
                pinchRotate: false
            },
            gestureSettingsUnknown: {
                scrollToZoom: false,
                clickToZoom: false,
                dblClickToZoom: true,
                pinchToZoom: true,
                zoomToRefPoint: true,
                flickEnabled: true,
                flickMinSpeed: 120,
                flickMomentum: 0.25,
                pinchRotate: false
            },
            zoomPerClick: 2,
            zoomPerScroll: 1.2,
            zoomPerSecond: 1.0,
            blendTime: 0,
            alwaysBlend: false,
            autoHideControls: true,
            immediateRender: false,
            minZoomImageRatio: 0.9,
            maxZoomPixelRatio: 1.1,
            smoothTileEdgesMinZoom: 1.1,
            iOSDevice: isIOSDevice(),
            pixelsPerWheelLine: 40,
            pixelsPerArrowPress: 40,
            autoResize: true,
            preserveImageSizeOnResize: false,
            minScrollDeltaTime: 50,
            //DEFAULT CONTROL SETTINGS
            showSequenceControl: true,
            sequenceControlAnchor: null,
            preserveViewport: false,
            preserveOverlays: false,
            navPrevNextWrap: false,
            showNavigationControl: true,
            navigationControlAnchor: null,
            showZoomControl: true,
            showHomeControl: true,
            showFullPageControl: true,
            showRotationControl: false,
            showFlipControl: false,
            controlsFadeDelay: 2000,
            controlsFadeLength: 1500,
            mouseNavEnabled: true,
            //VIEWPORT NAVIGATOR SETTINGS
            showNavigator: false,
            navigatorId: null,
            navigatorPosition: null,
            navigatorSizeRatio: 0.2,
            navigatorMaintainSizeRatio: false,
            navigatorTop: null,
            navigatorLeft: null,
            navigatorHeight: null,
            navigatorWidth: null,
            navigatorAutoResize: true,
            navigatorAutoFade: true,
            navigatorRotate: true,
            navigatorBackground: "#000",
            navigatorOpacity: 0.8,
            navigatorBorderColor: "#555",
            navigatorDisplayRegionColor: "#900",
            // INITIAL ROTATION
            degrees: 0,
            // INITIAL FLIP STATE
            flipped: false,
            // APPEARANCE
            opacity: 1,
            preload: false,
            compositeOperation: null,
            placeholderFillStyle: null,
            //REFERENCE STRIP SETTINGS
            showReferenceStrip: false,
            referenceStripScroll: "horizontal",
            referenceStripElement: null,
            referenceStripHeight: null,
            referenceStripWidth: null,
            referenceStripPosition: "BOTTOM_LEFT",
            referenceStripSizeRatio: 0.2,
            //COLLECTION VISUALIZATION SETTINGS
            collectionRows: 3,
            collectionColumns: 0,
            collectionLayout: "horizontal",
            collectionMode: false,
            collectionTileSize: 800,
            collectionTileMargin: 80,
            //PERFORMANCE SETTINGS
            imageLoaderLimit: 0,
            maxImageCacheCount: 200,
            timeout: 30000,
            useCanvas: true,
            //INTERFACE RESOURCE SETTINGS
            prefixUrl: "/images/",
            navImages: {
                zoomIn: {
                    REST: "zoomin_rest.png",
                    GROUP: "zoomin_grouphover.png",
                    HOVER: "zoomin_hover.png",
                    DOWN: "zoomin_pressed.png"
                },
                zoomOut: {
                    REST: "zoomout_rest.png",
                    GROUP: "zoomout_grouphover.png",
                    HOVER: "zoomout_hover.png",
                    DOWN: "zoomout_pressed.png"
                },
                home: {
                    REST: "home_rest.png",
                    GROUP: "home_grouphover.png",
                    HOVER: "home_hover.png",
                    DOWN: "home_pressed.png"
                },
                fullpage: {
                    REST: "fullpage_rest.png",
                    GROUP: "fullpage_grouphover.png",
                    HOVER: "fullpage_hover.png",
                    DOWN: "fullpage_pressed.png"
                },
                rotateleft: {
                    REST: "rotateleft_rest.png",
                    GROUP: "rotateleft_grouphover.png",
                    HOVER: "rotateleft_hover.png",
                    DOWN: "rotateleft_pressed.png"
                },
                rotateright: {
                    REST: "rotateright_rest.png",
                    GROUP: "rotateright_grouphover.png",
                    HOVER: "rotateright_hover.png",
                    DOWN: "rotateright_pressed.png"
                },
                flip: {
                    REST: "flip_rest.png",
                    GROUP: "flip_grouphover.png",
                    HOVER: "flip_hover.png",
                    DOWN: "flip_pressed.png"
                },
                previous: {
                    REST: "previous_rest.png",
                    GROUP: "previous_grouphover.png",
                    HOVER: "previous_hover.png",
                    DOWN: "previous_pressed.png"
                },
                next: {
                    REST: "next_rest.png",
                    GROUP: "next_grouphover.png",
                    HOVER: "next_hover.png",
                    DOWN: "next_pressed.png"
                }
            },
            //DEVELOPER SETTINGS
            debugMode: false,
            debugGridColor: [
                "#437AB2",
                "#1B9E77",
                "#D95F02",
                "#7570B3",
                "#E7298A",
                "#66A61E",
                "#E6AB02",
                "#A6761D",
                "#666666"
            ]
        },
        /**
         * TODO: get rid of this.  I can't see how it's required at all.  Looks
         *       like an early legacy code artifact.
         * @static
         * @ignore
         */ SIGNAL: "----seadragon----",
        /**
         * Returns a function which invokes the method as if it were a method belonging to the object.
         * @function
         * @param {Object} object
         * @param {Function} method
         * @returns {Function}
         */ delegate: function(object11, method11) {
            return function() {
                var args11 = arguments;
                if (args11 === undefined) args11 = [];
                return method11.apply(object11, args11);
            };
        },
        /**
         * An enumeration of Browser vendors.
         * @static
         * @type {Object}
         * @property {Number} UNKNOWN
         * @property {Number} IE
         * @property {Number} FIREFOX
         * @property {Number} SAFARI
         * @property {Number} CHROME
         * @property {Number} OPERA
         */ BROWSERS: {
            UNKNOWN: 0,
            IE: 1,
            FIREFOX: 2,
            SAFARI: 3,
            CHROME: 4,
            OPERA: 5
        },
        /**
         * Returns a DOM Element for the given id or element.
         * @function
         * @param {String|Element} element Accepts an id or element.
         * @returns {Element} The element with the given id, null, or the element itself.
         */ getElement: function(element11) {
            if (typeof element11 == "string") element11 = document.getElementById(element11);
            return element11;
        },
        /**
         * Determines the position of the upper-left corner of the element.
         * @function
         * @param {Element|String} element - the elemenet we want the position for.
         * @returns {OpenSeadragon.Point} - the position of the upper left corner of the element.
         */ getElementPosition: function(element11) {
            var result11 = new $.Point(), isFixed11, offsetParent11;
            element11 = $.getElement(element11);
            isFixed11 = $.getElementStyle(element11).position == "fixed";
            offsetParent11 = getOffsetParent(element11, isFixed11);
            while(offsetParent11){
                result11.x += element11.offsetLeft;
                result11.y += element11.offsetTop;
                if (isFixed11) result11 = result11.plus($.getPageScroll());
                element11 = offsetParent11;
                isFixed11 = $.getElementStyle(element11).position == "fixed";
                offsetParent11 = getOffsetParent(element11, isFixed11);
            }
            return result11;
        },
        /**
         * Determines the position of the upper-left corner of the element adjusted for current page and/or element scroll.
         * @function
         * @param {Element|String} element - the element we want the position for.
         * @returns {OpenSeadragon.Point} - the position of the upper left corner of the element adjusted for current page and/or element scroll.
         */ getElementOffset: function(element11) {
            element11 = $.getElement(element11);
            var doc11 = element11 && element11.ownerDocument, docElement11, win11, boundingRect11 = {
                top: 0,
                left: 0
            };
            if (!doc11) return new $.Point();
            docElement11 = doc11.documentElement;
            if (typeof element11.getBoundingClientRect !== "undefined") boundingRect11 = element11.getBoundingClientRect();
            win11 = doc11 == doc11.window ? doc11 : doc11.nodeType === 9 ? doc11.defaultView || doc11.parentWindow : false;
            return new $.Point(boundingRect11.left + (win11.pageXOffset || docElement11.scrollLeft) - (docElement11.clientLeft || 0), boundingRect11.top + (win11.pageYOffset || docElement11.scrollTop) - (docElement11.clientTop || 0));
        },
        /**
         * Determines the height and width of the given element.
         * @function
         * @param {Element|String} element
         * @returns {OpenSeadragon.Point}
         */ getElementSize: function(element11) {
            element11 = $.getElement(element11);
            return new $.Point(element11.clientWidth, element11.clientHeight);
        },
        /**
         * Returns the CSSStyle object for the given element.
         * @function
         * @param {Element|String} element
         * @returns {CSSStyle}
         */ getElementStyle: document.documentElement.currentStyle ? function(element11) {
            element11 = $.getElement(element11);
            return element11.currentStyle;
        } : function(element11) {
            element11 = $.getElement(element11);
            return window.getComputedStyle(element11, "");
        },
        /**
         * Returns the property with the correct vendor prefix appended.
         * @param {String} property the property name
         * @returns {String} the property with the correct prefix or null if not
         * supported.
         */ getCssPropertyWithVendorPrefix: function(property11) {
            var memo11 = {};
            $.getCssPropertyWithVendorPrefix = function(property11) {
                if (memo11[property11] !== undefined) return memo11[property11];
                var style11 = document.createElement("div").style;
                var result11 = null;
                if (style11[property11] !== undefined) result11 = property11;
                else {
                    var prefixes11 = [
                        "Webkit",
                        "Moz",
                        "MS",
                        "O",
                        "webkit",
                        "moz",
                        "ms",
                        "o"
                    ];
                    var suffix11 = $.capitalizeFirstLetter(property11);
                    for(var i11 = 0; i11 < prefixes11.length; i11++){
                        var prop11 = prefixes11[i11] + suffix11;
                        if (style11[prop11] !== undefined) {
                            result11 = prop11;
                            break;
                        }
                    }
                }
                memo11[property11] = result11;
                return result11;
            };
            return $.getCssPropertyWithVendorPrefix(property11);
        },
        /**
         * Capitalizes the first letter of a string
         * @param {String} string
         * @returns {String} The string with the first letter capitalized
         */ capitalizeFirstLetter: function(string11) {
            return string11.charAt(0).toUpperCase() + string11.slice(1);
        },
        /**
         * Compute the modulo of a number but makes sure to always return
         * a positive value.
         * @param {Number} number the number to computes the modulo of
         * @param {Number} modulo the modulo
         * @returns {Number} the result of the modulo of number
         */ positiveModulo: function(number11, modulo11) {
            var result11 = number11 % modulo11;
            if (result11 < 0) result11 += modulo11;
            return result11;
        },
        /**
         * Determines if a point is within the bounding rectangle of the given element (hit-test).
         * @function
         * @param {Element|String} element
         * @param {OpenSeadragon.Point} point
         * @returns {Boolean}
         */ pointInElement: function(element11, point31) {
            element11 = $.getElement(element11);
            var offset11 = $.getElementOffset(element11), size11 = $.getElementSize(element11);
            return point31.x >= offset11.x && point31.x < offset11.x + size11.x && point31.y < offset11.y + size11.y && point31.y >= offset11.y;
        },
        /**
         * Gets the latest event, really only useful internally since its
         * specific to IE behavior.
         * @function
         * @param {Event} [event]
         * @returns {Event}
         * @deprecated For internal use only
         * @private
         */ getEvent: function(event11) {
            if (event11) $.getEvent = function(event11) {
                return event11;
            };
            else $.getEvent = function() {
                return window.event;
            };
            return $.getEvent(event11);
        },
        /**
         * Gets the position of the mouse on the screen for a given event.
         * @function
         * @param {Event} [event]
         * @returns {OpenSeadragon.Point}
         */ getMousePosition: function(event11) {
            if (typeof event11.pageX == "number") $.getMousePosition = function(event11) {
                var result11 = new $.Point();
                event11 = $.getEvent(event11);
                result11.x = event11.pageX;
                result11.y = event11.pageY;
                return result11;
            };
            else if (typeof event11.clientX == "number") $.getMousePosition = function(event11) {
                var result11 = new $.Point();
                event11 = $.getEvent(event11);
                result11.x = event11.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
                result11.y = event11.clientY + document.body.scrollTop + document.documentElement.scrollTop;
                return result11;
            };
            else throw new Error("Unknown event mouse position, no known technique.");
            return $.getMousePosition(event11);
        },
        /**
         * Determines the page's current scroll position.
         * @function
         * @returns {OpenSeadragon.Point}
         */ getPageScroll: function() {
            var docElement11 = document.documentElement || {}, body11 = document.body || {};
            if (typeof window.pageXOffset == "number") $.getPageScroll = function() {
                return new $.Point(window.pageXOffset, window.pageYOffset);
            };
            else if (body11.scrollLeft || body11.scrollTop) $.getPageScroll = function() {
                return new $.Point(document.body.scrollLeft, document.body.scrollTop);
            };
            else if (docElement11.scrollLeft || docElement11.scrollTop) $.getPageScroll = function() {
                return new $.Point(document.documentElement.scrollLeft, document.documentElement.scrollTop);
            };
            else // We can't reassign the function yet, as there was no scroll.
            return new $.Point(0, 0);
            return $.getPageScroll();
        },
        /**
         * Set the page scroll position.
         * @function
         * @returns {OpenSeadragon.Point}
         */ setPageScroll: function(scroll11) {
            if (typeof window.scrollTo !== "undefined") $.setPageScroll = function(scroll11) {
                window.scrollTo(scroll11.x, scroll11.y);
            };
            else {
                var originalScroll11 = $.getPageScroll();
                if (originalScroll11.x === scroll11.x && originalScroll11.y === scroll11.y) // We are already correctly positioned and there
                // is no way to detect the correct method.
                return;
                document.body.scrollLeft = scroll11.x;
                document.body.scrollTop = scroll11.y;
                var currentScroll11 = $.getPageScroll();
                if (currentScroll11.x !== originalScroll11.x && currentScroll11.y !== originalScroll11.y) {
                    $.setPageScroll = function(scroll11) {
                        document.body.scrollLeft = scroll11.x;
                        document.body.scrollTop = scroll11.y;
                    };
                    return;
                }
                document.documentElement.scrollLeft = scroll11.x;
                document.documentElement.scrollTop = scroll11.y;
                currentScroll11 = $.getPageScroll();
                if (currentScroll11.x !== originalScroll11.x && currentScroll11.y !== originalScroll11.y) {
                    $.setPageScroll = function(scroll11) {
                        document.documentElement.scrollLeft = scroll11.x;
                        document.documentElement.scrollTop = scroll11.y;
                    };
                    return;
                }
                // We can't find anything working, so we do nothing.
                $.setPageScroll = function(scroll11) {};
            }
            return $.setPageScroll(scroll11);
        },
        /**
         * Determines the size of the browsers window.
         * @function
         * @returns {OpenSeadragon.Point}
         */ getWindowSize: function() {
            var docElement11 = document.documentElement || {}, body11 = document.body || {};
            if (typeof window.innerWidth == "number") $.getWindowSize = function() {
                return new $.Point(window.innerWidth, window.innerHeight);
            };
            else if (docElement11.clientWidth || docElement11.clientHeight) $.getWindowSize = function() {
                return new $.Point(document.documentElement.clientWidth, document.documentElement.clientHeight);
            };
            else if (body11.clientWidth || body11.clientHeight) $.getWindowSize = function() {
                return new $.Point(document.body.clientWidth, document.body.clientHeight);
            };
            else throw new Error("Unknown window size, no known technique.");
            return $.getWindowSize();
        },
        /**
         * Wraps the given element in a nest of divs so that the element can
         * be easily centered using CSS tables
         * @function
         * @param {Element|String} element
         * @returns {Element} outermost wrapper element
         */ makeCenteredNode: function(element11) {
            // Convert a possible ID to an actual HTMLElement
            element11 = $.getElement(element11);
            /*
                CSS tables require you to have a display:table/row/cell hierarchy so we need to create
                three nested wrapper divs:
             */ var wrappers11 = [
                $.makeNeutralElement("div"),
                $.makeNeutralElement("div"),
                $.makeNeutralElement("div")
            ];
            // It feels like we should be able to pass style dicts to makeNeutralElement:
            $.extend(wrappers11[0].style, {
                display: "table",
                height: "100%",
                width: "100%"
            });
            $.extend(wrappers11[1].style, {
                display: "table-row"
            });
            $.extend(wrappers11[2].style, {
                display: "table-cell",
                verticalAlign: "middle",
                textAlign: "center"
            });
            wrappers11[0].appendChild(wrappers11[1]);
            wrappers11[1].appendChild(wrappers11[2]);
            wrappers11[2].appendChild(element11);
            return wrappers11[0];
        },
        /**
         * Creates an easily positionable element of the given type that therefor
         * serves as an excellent container element.
         * @function
         * @param {String} tagName
         * @returns {Element}
         */ makeNeutralElement: function(tagName11) {
            var element11 = document.createElement(tagName11), style11 = element11.style;
            style11.background = "transparent none";
            style11.border = "none";
            style11.margin = "0px";
            style11.padding = "0px";
            style11.position = "static";
            return element11;
        },
        /**
         * Returns the current milliseconds, using Date.now() if available
         * @function
         */ now: function() {
            if (Date.now) $.now = Date.now;
            else $.now = function() {
                return new Date().getTime();
            };
            return $.now();
        },
        /**
         * Ensures an image is loaded correctly to support alpha transparency.
         * Generally only IE has issues doing this correctly for formats like
         * png.
         * @function
         * @param {String} src
         * @returns {Element}
         */ makeTransparentImage: function(src11) {
            $.makeTransparentImage = function(src11) {
                var img11 = $.makeNeutralElement("img");
                img11.src = src11;
                return img11;
            };
            if ($.Browser.vendor == $.BROWSERS.IE && $.Browser.version < 7) $.makeTransparentImage = function(src11) {
                var img11 = $.makeNeutralElement("img"), element11 = null;
                element11 = $.makeNeutralElement("span");
                element11.style.display = "inline-block";
                img11.onload = function() {
                    element11.style.width = element11.style.width || img11.width + "px";
                    element11.style.height = element11.style.height || img11.height + "px";
                    img11.onload = null;
                    img11 = null; // to prevent memory leaks in IE
                };
                img11.src = src11;
                element11.style.filter = "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='" + src11 + "', sizingMethod='scale')";
                return element11;
            };
            return $.makeTransparentImage(src11);
        },
        /**
         * Sets the opacity of the specified element.
         * @function
         * @param {Element|String} element
         * @param {Number} opacity
         * @param {Boolean} [usesAlpha]
         */ setElementOpacity: function(element11, opacity11, usesAlpha11) {
            var ieOpacity11, ieFilter11;
            element11 = $.getElement(element11);
            if (usesAlpha11 && !$.Browser.alpha) opacity11 = Math.round(opacity11);
            if ($.Browser.opacity) element11.style.opacity = opacity11 < 1 ? opacity11 : "";
            else if (opacity11 < 1) {
                ieOpacity11 = Math.round(100 * opacity11);
                ieFilter11 = "alpha(opacity=" + ieOpacity11 + ")";
                element11.style.filter = ieFilter11;
            } else element11.style.filter = "";
        },
        /**
         * Sets the specified element's touch-action style attribute to 'none'.
         * @function
         * @param {Element|String} element
         */ setElementTouchActionNone: function(element11) {
            element11 = $.getElement(element11);
            if (typeof element11.style.touchAction !== "undefined") element11.style.touchAction = "none";
            else if (typeof element11.style.msTouchAction !== "undefined") element11.style.msTouchAction = "none";
        },
        /**
         * Add the specified CSS class to the element if not present.
         * @function
         * @param {Element|String} element
         * @param {String} className
         */ addClass: function(element11, className11) {
            element11 = $.getElement(element11);
            if (!element11.className) element11.className = className11;
            else if ((" " + element11.className + " ").indexOf(" " + className11 + " ") === -1) element11.className += " " + className11;
        },
        /**
         * Find the first index at which an element is found in an array or -1
         * if not present.
         *
         * Code taken and adapted from
         * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf#Compatibility
         *
         * @function
         * @param {Array} array The array from which to find the element
         * @param {Object} searchElement The element to find
         * @param {Number} [fromIndex=0] Index to start research.
         * @returns {Number} The index of the element in the array.
         */ indexOf: function(array11, searchElement11, fromIndex11) {
            if (Array.prototype.indexOf) this.indexOf = function(array11, searchElement11, fromIndex11) {
                return array11.indexOf(searchElement11, fromIndex11);
            };
            else this.indexOf = function(array11, searchElement11, fromIndex11) {
                var i11, pivot11 = fromIndex11 ? fromIndex11 : 0, length11;
                if (!array11) throw new TypeError();
                length11 = array11.length;
                if (length11 === 0 || pivot11 >= length11) return -1;
                if (pivot11 < 0) pivot11 = length11 - Math.abs(pivot11);
                for(i11 = pivot11; i11 < length11; i11++){
                    if (array11[i11] === searchElement11) return i11;
                }
                return -1;
            };
            return this.indexOf(array11, searchElement11, fromIndex11);
        },
        /**
         * Remove the specified CSS class from the element.
         * @function
         * @param {Element|String} element
         * @param {String} className
         */ removeClass: function(element11, className11) {
            var oldClasses11, newClasses11 = [], i11;
            element11 = $.getElement(element11);
            oldClasses11 = element11.className.split(/\s+/);
            for(i11 = 0; i11 < oldClasses11.length; i11++)if (oldClasses11[i11] && oldClasses11[i11] !== className11) newClasses11.push(oldClasses11[i11]);
            element11.className = newClasses11.join(" ");
        },
        /**
         * Adds an event listener for the given element, eventName and handler.
         * @function
         * @param {Element|String} element
         * @param {String} eventName
         * @param {Function} handler
         * @param {Boolean} [useCapture]
         */ addEvent: function() {
            if (window.addEventListener) return function(element11, eventName11, handler11, useCapture11) {
                element11 = $.getElement(element11);
                element11.addEventListener(eventName11, handler11, useCapture11);
            };
            else if (window.attachEvent) return function(element11, eventName11, handler11, useCapture11) {
                element11 = $.getElement(element11);
                element11.attachEvent("on" + eventName11, handler11);
            };
            else throw new Error("No known event model.");
        }(),
        /**
         * Remove a given event listener for the given element, event type and
         * handler.
         * @function
         * @param {Element|String} element
         * @param {String} eventName
         * @param {Function} handler
         * @param {Boolean} [useCapture]
         */ removeEvent: function() {
            if (window.removeEventListener) return function(element11, eventName11, handler11, useCapture11) {
                element11 = $.getElement(element11);
                element11.removeEventListener(eventName11, handler11, useCapture11);
            };
            else if (window.detachEvent) return function(element11, eventName11, handler11, useCapture11) {
                element11 = $.getElement(element11);
                element11.detachEvent("on" + eventName11, handler11);
            };
            else throw new Error("No known event model.");
        }(),
        /**
         * Cancels the default browser behavior had the event propagated all
         * the way up the DOM to the window object.
         * @function
         * @param {Event} [event]
         */ cancelEvent: function(event11) {
            event11 = $.getEvent(event11);
            if (event11.preventDefault) $.cancelEvent = function(event11) {
                // W3C for preventing default
                event11.preventDefault();
            };
            else $.cancelEvent = function(event11) {
                event11 = $.getEvent(event11);
                // legacy for preventing default
                event11.cancel = true;
                // IE for preventing default
                event11.returnValue = false;
            };
            $.cancelEvent(event11);
        },
        /**
         * Stops the propagation of the event up the DOM.
         * @function
         * @param {Event} [event]
         */ stopEvent: function(event11) {
            event11 = $.getEvent(event11);
            if (event11.stopPropagation) // W3C for stopping propagation
            $.stopEvent = function(event11) {
                event11.stopPropagation();
            };
            else // IE for stopping propagation
            $.stopEvent = function(event11) {
                event11 = $.getEvent(event11);
                event11.cancelBubble = true;
            };
            $.stopEvent(event11);
        },
        /**
         * Similar to OpenSeadragon.delegate, but it does not immediately call
         * the method on the object, returning a function which can be called
         * repeatedly to delegate the method. It also allows additonal arguments
         * to be passed during construction which will be added during each
         * invocation, and each invocation can add additional arguments as well.
         *
         * @function
         * @param {Object} object
         * @param {Function} method
         * @param [args] any additional arguments are passed as arguments to the
         *  created callback
         * @returns {Function}
         */ createCallback: function(object11, method11) {
            //TODO: This pattern is painful to use and debug.  It's much cleaner
            //      to use pinning plus anonymous functions.  Get rid of this
            //      pattern!
            var initialArgs11 = [], i11;
            for(i11 = 2; i11 < arguments.length; i11++)initialArgs11.push(arguments[i11]);
            return function() {
                var args11 = initialArgs11.concat([]), i11;
                for(i11 = 0; i11 < arguments.length; i11++)args11.push(arguments[i11]);
                return method11.apply(object11, args11);
            };
        },
        /**
         * Retreives the value of a url parameter from the window.location string.
         * @function
         * @param {String} key
         * @returns {String} The value of the url parameter or null if no param matches.
         */ getUrlParameter: function(key11) {
            // eslint-disable-next-line no-use-before-define
            var value11 = URLPARAMS[key11];
            return value11 ? value11 : null;
        },
        /**
         * Retrieves the protocol used by the url. The url can either be absolute
         * or relative.
         * @function
         * @private
         * @param {String} url The url to retrieve the protocol from.
         * @return {String} The protocol (http:, https:, file:, ftp: ...)
         */ getUrlProtocol: function(url11) {
            var match11 = url11.match(/^([a-z]+:)\/\//i);
            if (match11 === null) // Relative URL, retrive the protocol from window.location
            return window.location.protocol;
            return match11[1].toLowerCase();
        },
        /**
         * Create an XHR object
         * @private
         * @param {type} [local] If set to true, the XHR will be file: protocol
         * compatible if possible (but may raise a warning in the browser).
         * @returns {XMLHttpRequest}
         */ createAjaxRequest: function(local11) {
            // IE11 does not support window.ActiveXObject so we just try to
            // create one to see if it is supported.
            // See: http://msdn.microsoft.com/en-us/library/ie/dn423948%28v=vs.85%29.aspx
            var supportActiveX11;
            try {
                /* global ActiveXObject:true */ supportActiveX11 = (new ActiveXObject("Microsoft.XMLHTTP"), true);
            } catch (e11) {
                supportActiveX11 = false;
            }
            if (supportActiveX11) {
                if (window.XMLHttpRequest) $.createAjaxRequest = function(local11) {
                    if (local11) return new ActiveXObject("Microsoft.XMLHTTP");
                    return new XMLHttpRequest();
                };
                else $.createAjaxRequest = function() {
                    return new ActiveXObject("Microsoft.XMLHTTP");
                };
            } else if (window.XMLHttpRequest) $.createAjaxRequest = function() {
                return new XMLHttpRequest();
            };
            else throw new Error("Browser doesn't support XMLHttpRequest.");
            return $.createAjaxRequest(local11);
        },
        /**
         * Makes an AJAX request.
         * @param {Object} options
         * @param {String} options.url - the url to request
         * @param {Function} options.success - a function to call on a successful response
         * @param {Function} options.error - a function to call on when an error occurs
         * @param {Object} options.headers - headers to add to the AJAX request
         * @param {String} options.responseType - the response type of the the AJAX request
         * @param {Boolean} [options.withCredentials=false] - whether to set the XHR's withCredentials
         * @throws {Error}
         * @returns {XMLHttpRequest}
         */ makeAjaxRequest: function(url11, onSuccess11, onError11) {
            var withCredentials11;
            var headers11;
            var responseType11;
            // Note that our preferred API is that you pass in a single object; the named
            // arguments are for legacy support.
            if ($.isPlainObject(url11)) {
                onSuccess11 = url11.success;
                onError11 = url11.error;
                withCredentials11 = url11.withCredentials;
                headers11 = url11.headers;
                responseType11 = url11.responseType || null;
                url11 = url11.url;
            }
            var protocol11 = $.getUrlProtocol(url11);
            var request11 = $.createAjaxRequest(protocol11 === "file:");
            if (!$.isFunction(onSuccess11)) throw new Error("makeAjaxRequest requires a success callback");
            request11.onreadystatechange = function() {
                // 4 = DONE (https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#Properties)
                if (request11.readyState == 4) {
                    request11.onreadystatechange = function() {};
                    // With protocols other than http/https, a successful request status is in
                    // the 200's on Firefox and 0 on other browsers
                    if (request11.status >= 200 && request11.status < 300 || request11.status === 0 && protocol11 !== "http:" && protocol11 !== "https:") onSuccess11(request11);
                    else {
                        $.console.log("AJAX request returned %d: %s", request11.status, url11);
                        if ($.isFunction(onError11)) onError11(request11);
                    }
                }
            };
            try {
                request11.open("GET", url11, true);
                if (responseType11) request11.responseType = responseType11;
                if (headers11) {
                    for(var headerName11 in headers11)if (headers11.hasOwnProperty(headerName11) && headers11[headerName11]) request11.setRequestHeader(headerName11, headers11[headerName11]);
                }
                if (withCredentials11) request11.withCredentials = true;
                request11.send(null);
            } catch (e11) {
                var msg11 = e11.message;
                /*
                    IE < 10 does not support CORS and an XHR request to a different origin will fail as soon
                    as send() is called. This is particularly easy to miss during development and appear in
                    production if you use a CDN or domain sharding and the security policy is likely to break
                    exception handlers since any attempt to access a property of the request object will
                    raise an access denied TypeError inside the catch block.

                    To be friendlier, we'll check for this specific error and add a documentation pointer
                    to point developers in the right direction. We test the exception number because IE's
                    error messages are localized.
                */ var oldIE11 = $.Browser.vendor == $.BROWSERS.IE && $.Browser.version < 10;
                if (oldIE11 && typeof e11.number != "undefined" && e11.number == -2147024891) msg11 += "\nSee http://msdn.microsoft.com/en-us/library/ms537505(v=vs.85).aspx#xdomain";
                $.console.log("%s while making AJAX request: %s", e11.name, msg11);
                request11.onreadystatechange = function() {};
                if (window.XDomainRequest) {
                    var xdr11 = new XDomainRequest();
                    if (xdr11) {
                        xdr11.onload = function(e11) {
                            if ($.isFunction(onSuccess11)) onSuccess11({
                                responseText: xdr11.responseText,
                                status: 200,
                                statusText: "OK"
                            });
                        };
                        xdr11.onerror = function(e11) {
                            if ($.isFunction(onError11)) onError11({
                                responseText: xdr11.responseText,
                                status: 444,
                                statusText: "An error happened. Due to an XDomainRequest deficiency we can not extract any information about this error. Upgrade your browser."
                            });
                        };
                        try {
                            xdr11.open("GET", url11);
                            xdr11.send();
                        } catch (e211) {
                            if ($.isFunction(onError11)) onError11(request11, e11);
                        }
                    }
                } else if ($.isFunction(onError11)) onError11(request11, e11);
            }
            return request11;
        },
        /**
         * Taken from jQuery 1.6.1
         * @function
         * @param {Object} options
         * @param {String} options.url
         * @param {Function} options.callback
         * @param {String} [options.param='callback'] The name of the url parameter
         *      to request the jsonp provider with.
         * @param {String} [options.callbackName=] The name of the callback to
         *      request the jsonp provider with.
         */ jsonp: function(options11) {
            var script11, url11 = options11.url, head11 = document.head || document.getElementsByTagName("head")[0] || document.documentElement, jsonpCallback11 = options11.callbackName || "openseadragon" + $.now(), previous11 = window[jsonpCallback11], replace11 = "$1" + jsonpCallback11 + "$2", callbackParam11 = options11.param || "callback", callback11 = options11.callback;
            url11 = url11.replace(/(\=)\?(&|$)|\?\?/i, replace11);
            // Add callback manually
            url11 += (/\?/.test(url11) ? "&" : "?") + callbackParam11 + "=" + jsonpCallback11;
            // Install callback
            window[jsonpCallback11] = function(response11) {
                if (!previous11) try {
                    delete window[jsonpCallback11];
                } catch (e11) {
                //swallow
                }
                else window[jsonpCallback11] = previous11;
                if (callback11 && $.isFunction(callback11)) callback11(response11);
            };
            script11 = document.createElement("script");
            //TODO: having an issue with async info requests
            if (undefined !== options11.async || false !== options11.async) script11.async = "async";
            if (options11.scriptCharset) script11.charset = options11.scriptCharset;
            script11.src = url11;
            // Attach handlers for all browsers
            script11.onload = script11.onreadystatechange = function(_11, isAbort11) {
                if (isAbort11 || !script11.readyState || /loaded|complete/.test(script11.readyState)) {
                    // Handle memory leak in IE
                    script11.onload = script11.onreadystatechange = null;
                    // Remove the script
                    if (head11 && script11.parentNode) head11.removeChild(script11);
                    // Dereference the script
                    script11 = undefined;
                }
            };
            // Use insertBefore instead of appendChild  to circumvent an IE6 bug.
            // This arises when a base node is used (#2709 and #4378).
            head11.insertBefore(script11, head11.firstChild);
        },
        /**
         * Fully deprecated. Will throw an error.
         * @function
         * @deprecated use {@link OpenSeadragon.Viewer#open}
         */ createFromDZI: function() {
            throw "OpenSeadragon.createFromDZI is deprecated, use Viewer.open.";
        },
        /**
         * Parses an XML string into a DOM Document.
         * @function
         * @param {String} string
         * @returns {Document}
         */ parseXml: function(string11) {
            if (window.DOMParser) $.parseXml = function(string11) {
                var xmlDoc11 = null, parser11;
                parser11 = new DOMParser();
                xmlDoc11 = parser11.parseFromString(string11, "text/xml");
                return xmlDoc11;
            };
            else if (window.ActiveXObject) $.parseXml = function(string11) {
                var xmlDoc11 = null;
                xmlDoc11 = new ActiveXObject("Microsoft.XMLDOM");
                xmlDoc11.async = false;
                xmlDoc11.loadXML(string11);
                return xmlDoc11;
            };
            else throw new Error("Browser doesn't support XML DOM.");
            return $.parseXml(string11);
        },
        /**
         * Parses a JSON string into a Javascript object.
         * @function
         * @param {String} string
         * @returns {Object}
         */ parseJSON: function(string) {
            if (window.JSON && window.JSON.parse) $.parseJSON = window.JSON.parse;
            else // Should only be used by IE8 in non standards mode
            $.parseJSON = function(string) {
                /*jshint evil:true*/ //eslint-disable-next-line no-eval
                return eval("(" + string + ")");
            };
            return $.parseJSON(string);
        },
        /**
         * Reports whether the image format is supported for tiling in this
         * version.
         * @function
         * @param {String} [extension]
         * @returns {Boolean}
         */ imageFormatSupported: function(extension11) {
            extension11 = extension11 ? extension11 : "";
            // eslint-disable-next-line no-use-before-define
            return !!FILEFORMATS[extension11.toLowerCase()];
        }
    });
    /**
     * The current browser vendor, version, and related information regarding detected features.
     * @member {Object} Browser
     * @memberof OpenSeadragon
     * @static
     * @type {Object}
     * @property {OpenSeadragon.BROWSERS} vendor - One of the {@link OpenSeadragon.BROWSERS} enumeration values.
     * @property {Number} version
     * @property {Boolean} alpha - Does the browser support image alpha transparency.
     */ $.Browser = {
        vendor: $.BROWSERS.UNKNOWN,
        version: 0,
        alpha: true
    };
    var FILEFORMATS = {
        "bmp": false,
        "jpeg": true,
        "jpg": true,
        "png": true,
        "tif": false,
        "wdp": false
    }, URLPARAMS = {};
    (function() {
        //A small auto-executing routine to determine the browser vendor,
        //version and supporting feature sets.
        var ver11 = navigator.appVersion, ua11 = navigator.userAgent, regex11;
        //console.error( 'appName: ' + navigator.appName );
        //console.error( 'appVersion: ' + navigator.appVersion );
        //console.error( 'userAgent: ' + navigator.userAgent );
        switch(navigator.appName){
            case "Microsoft Internet Explorer":
                if (!!window.attachEvent && !!window.ActiveXObject) {
                    $.Browser.vendor = $.BROWSERS.IE;
                    $.Browser.version = parseFloat(ua11.substring(ua11.indexOf("MSIE") + 5, ua11.indexOf(";", ua11.indexOf("MSIE"))));
                }
                break;
            case "Netscape":
                if (window.addEventListener) {
                    if (ua11.indexOf("Firefox") >= 0) {
                        $.Browser.vendor = $.BROWSERS.FIREFOX;
                        $.Browser.version = parseFloat(ua11.substring(ua11.indexOf("Firefox") + 8));
                    } else if (ua11.indexOf("Safari") >= 0) {
                        $.Browser.vendor = ua11.indexOf("Chrome") >= 0 ? $.BROWSERS.CHROME : $.BROWSERS.SAFARI;
                        $.Browser.version = parseFloat(ua11.substring(ua11.substring(0, ua11.indexOf("Safari")).lastIndexOf("/") + 1, ua11.indexOf("Safari")));
                    } else {
                        regex11 = new RegExp("Trident/.*rv:([0-9]{1,}[.0-9]{0,})");
                        if (regex11.exec(ua11) !== null) {
                            $.Browser.vendor = $.BROWSERS.IE;
                            $.Browser.version = parseFloat(RegExp.$1);
                        }
                    }
                }
                break;
            case "Opera":
                $.Browser.vendor = $.BROWSERS.OPERA;
                $.Browser.version = parseFloat(ver11);
                break;
        }
        // ignore '?' portion of query string
        var query11 = window.location.search.substring(1), parts11 = query11.split("&"), part11, sep11, i11;
        for(i11 = 0; i11 < parts11.length; i11++){
            part11 = parts11[i11];
            sep11 = part11.indexOf("=");
            if (sep11 > 0) URLPARAMS[part11.substring(0, sep11)] = decodeURIComponent(part11.substring(sep11 + 1));
        }
        //determine if this browser supports image alpha transparency
        $.Browser.alpha = !($.Browser.vendor == $.BROWSERS.IE && $.Browser.version < 9 || $.Browser.vendor == $.BROWSERS.CHROME && $.Browser.version < 2);
        //determine if this browser supports element.style.opacity
        $.Browser.opacity = !($.Browser.vendor == $.BROWSERS.IE && $.Browser.version < 9);
    })();
    //TODO: $.console is often used inside a try/catch block which generally
    //      prevents allowings errors to occur with detection until a debugger
    //      is attached.  Although I've been guilty of the same anti-pattern
    //      I eventually was convinced that errors should naturally propogate in
    //      all but the most special cases.
    /**
     * A convenient alias for console when available, and a simple null
     * function when console is unavailable.
     * @static
     * @private
     */ var nullfunction = function(msg11) {
    //document.location.hash = msg;
    };
    $.console = window.console || {
        log: nullfunction,
        debug: nullfunction,
        info: nullfunction,
        warn: nullfunction,
        error: nullfunction,
        assert: nullfunction
    };
    // Adding support for HTML5's requestAnimationFrame as suggested by acdha.
    // Implementation taken from matt synder's post here:
    // http://mattsnider.com/cross-browser-and-legacy-supported-requestframeanimation/
    (function(w11) {
        // most browsers have an implementation
        var requestAnimationFrame11 = w11.requestAnimationFrame || w11.mozRequestAnimationFrame || w11.webkitRequestAnimationFrame || w11.msRequestAnimationFrame;
        var cancelAnimationFrame11 = w11.cancelAnimationFrame || w11.mozCancelAnimationFrame || w11.webkitCancelAnimationFrame || w11.msCancelAnimationFrame;
        // polyfill, when necessary
        if (requestAnimationFrame11 && cancelAnimationFrame11) {
            // We can't assign these window methods directly to $ because they
            // expect their "this" to be "window", so we call them in wrappers.
            $.requestAnimationFrame = function() {
                return requestAnimationFrame11.apply(w11, arguments);
            };
            $.cancelAnimationFrame = function() {
                return cancelAnimationFrame11.apply(w11, arguments);
            };
        } else {
            var aAnimQueue11 = [], processing11 = [], iRequestId11 = 0, iIntervalId11;
            // create a mock requestAnimationFrame function
            $.requestAnimationFrame = function(callback11) {
                aAnimQueue11.push([
                    ++iRequestId11,
                    callback11
                ]);
                if (!iIntervalId11) iIntervalId11 = setInterval(function() {
                    if (aAnimQueue11.length) {
                        var time11 = $.now();
                        // Process all of the currently outstanding frame
                        // requests, but none that get added during the
                        // processing.
                        // Swap the arrays so we don't have to create a new
                        // array every frame.
                        var temp11 = processing11;
                        processing11 = aAnimQueue11;
                        aAnimQueue11 = temp11;
                        while(processing11.length)processing11.shift()[1](time11);
                    } else {
                        // don't continue the interval, if unnecessary
                        clearInterval(iIntervalId11);
                        iIntervalId11 = undefined;
                    }
                }, 20); // estimating support for 50 frames per second
                return iRequestId11;
            };
            // create a mock cancelAnimationFrame function
            $.cancelAnimationFrame = function(requestId11) {
                // find the request ID and remove it
                var i11, j11;
                for(i11 = 0, j11 = aAnimQueue11.length; i11 < j11; i11 += 1)if (aAnimQueue11[i11][0] === requestId11) {
                    aAnimQueue11.splice(i11, 1);
                    return;
                }
                // If it's not in the queue, it may be in the set we're currently
                // processing (if cancelAnimationFrame is called from within a
                // requestAnimationFrame callback).
                for(i11 = 0, j11 = processing11.length; i11 < j11; i11 += 1)if (processing11[i11][0] === requestId11) {
                    processing11.splice(i11, 1);
                    return;
                }
            };
        }
    })(window);
    /**
     * @private
     * @inner
     * @function
     * @param {Element} element
     * @param {Boolean} [isFixed]
     * @returns {Element}
     */ function getOffsetParent(element11, isFixed11) {
        if (isFixed11 && element11 != document.body) return document.body;
        else return element11.offsetParent;
    }
})(OpenSeadragon);
// Universal Module Definition, supports CommonJS, AMD and simple script tag
(function(root11, factory11) {
    if (typeof define === "function" && define.amd) // expose as amd module
    define([], factory11);
    else if (0, module.exports) // expose as commonjs module
    module.exports = factory11();
    else // expose as window.OpenSeadragon
    root11.OpenSeadragon = factory11();
})(this, function() {
    return OpenSeadragon;
});
/*
 * OpenSeadragon - full-screen support functions
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    /**
     * Determine native full screen support we can get from the browser.
     * @member fullScreenApi
     * @memberof OpenSeadragon
     * @type {object}
     * @property {Boolean} supportsFullScreen Return true if full screen API is supported.
     * @property {Function} isFullScreen Return true if currently in full screen mode.
     * @property {Function} getFullScreenElement Return the element currently in full screen mode.
     * @property {Function} requestFullScreen Make a request to go in full screen mode.
     * @property {Function} exitFullScreen Make a request to exit full screen mode.
     * @property {Function} cancelFullScreen Deprecated, use exitFullScreen instead.
     * @property {String} fullScreenEventName Event fired when the full screen mode change.
     * @property {String} fullScreenErrorEventName Event fired when a request to go
     * in full screen mode failed.
     */ var fullScreenApi11 = {
        supportsFullScreen: false,
        isFullScreen: function() {
            return false;
        },
        getFullScreenElement: function() {
            return null;
        },
        requestFullScreen: function() {},
        exitFullScreen: function() {},
        cancelFullScreen: function() {},
        fullScreenEventName: "",
        fullScreenErrorEventName: ""
    };
    // check for native support
    if (document.exitFullscreen) {
        // W3C standard
        fullScreenApi11.supportsFullScreen = true;
        fullScreenApi11.getFullScreenElement = function() {
            return document.fullscreenElement;
        };
        fullScreenApi11.requestFullScreen = function(element11) {
            return element11.requestFullscreen();
        };
        fullScreenApi11.exitFullScreen = function() {
            document.exitFullscreen();
        };
        fullScreenApi11.fullScreenEventName = "fullscreenchange";
        fullScreenApi11.fullScreenErrorEventName = "fullscreenerror";
    } else if (document.msExitFullscreen) {
        // IE 11
        fullScreenApi11.supportsFullScreen = true;
        fullScreenApi11.getFullScreenElement = function() {
            return document.msFullscreenElement;
        };
        fullScreenApi11.requestFullScreen = function(element11) {
            return element11.msRequestFullscreen();
        };
        fullScreenApi11.exitFullScreen = function() {
            document.msExitFullscreen();
        };
        fullScreenApi11.fullScreenEventName = "MSFullscreenChange";
        fullScreenApi11.fullScreenErrorEventName = "MSFullscreenError";
    } else if (document.webkitExitFullscreen) {
        // Recent webkit
        fullScreenApi11.supportsFullScreen = true;
        fullScreenApi11.getFullScreenElement = function() {
            return document.webkitFullscreenElement;
        };
        fullScreenApi11.requestFullScreen = function(element11) {
            return element11.webkitRequestFullscreen();
        };
        fullScreenApi11.exitFullScreen = function() {
            document.webkitExitFullscreen();
        };
        fullScreenApi11.fullScreenEventName = "webkitfullscreenchange";
        fullScreenApi11.fullScreenErrorEventName = "webkitfullscreenerror";
    } else if (document.webkitCancelFullScreen) {
        // Old webkit
        fullScreenApi11.supportsFullScreen = true;
        fullScreenApi11.getFullScreenElement = function() {
            return document.webkitCurrentFullScreenElement;
        };
        fullScreenApi11.requestFullScreen = function(element11) {
            return element11.webkitRequestFullScreen();
        };
        fullScreenApi11.exitFullScreen = function() {
            document.webkitCancelFullScreen();
        };
        fullScreenApi11.fullScreenEventName = "webkitfullscreenchange";
        fullScreenApi11.fullScreenErrorEventName = "webkitfullscreenerror";
    } else if (document.mozCancelFullScreen) {
        // Firefox
        fullScreenApi11.supportsFullScreen = true;
        fullScreenApi11.getFullScreenElement = function() {
            return document.mozFullScreenElement;
        };
        fullScreenApi11.requestFullScreen = function(element11) {
            return element11.mozRequestFullScreen();
        };
        fullScreenApi11.exitFullScreen = function() {
            document.mozCancelFullScreen();
        };
        fullScreenApi11.fullScreenEventName = "mozfullscreenchange";
        fullScreenApi11.fullScreenErrorEventName = "mozfullscreenerror";
    }
    fullScreenApi11.isFullScreen = function() {
        return fullScreenApi11.getFullScreenElement() !== null;
    };
    fullScreenApi11.cancelFullScreen = function() {
        $11.console.error("cancelFullScreen is deprecated. Use exitFullScreen instead.");
        fullScreenApi11.exitFullScreen();
    };
    // export api
    $11.extend($11, fullScreenApi11);
})(OpenSeadragon);
/*
 * OpenSeadragon - EventSource
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    /**
 * Event handler method signature used by all OpenSeadragon events.
 *
 * @callback EventHandler
 * @memberof OpenSeadragon
 * @param {Object} event - See individual events for event-specific properties.
 */ /**
 * @class EventSource
 * @classdesc For use by classes which want to support custom, non-browser events.
 *
 * @memberof OpenSeadragon
 */ $11.EventSource = function() {
        this.events = {};
    };
    /** @lends OpenSeadragon.EventSource.prototype */ $11.EventSource.prototype = {
        /**
     * Add an event handler to be triggered only once (or a given number of times)
     * for a given event.
     * @function
     * @param {String} eventName - Name of event to register.
     * @param {OpenSeadragon.EventHandler} handler - Function to call when event
     * is triggered.
     * @param {Object} [userData=null] - Arbitrary object to be passed unchanged
     * to the handler.
     * @param {Number} [times=1] - The number of times to handle the event
     * before removing it.
     */ addOnceHandler: function(eventName11, handler11, userData11, times11) {
            var self11 = this;
            times11 = times11 || 1;
            var count11 = 0;
            var onceHandler11 = function(event11) {
                count11++;
                if (count11 === times11) self11.removeHandler(eventName11, onceHandler11);
                handler11(event11);
            };
            this.addHandler(eventName11, onceHandler11, userData11);
        },
        /**
     * Add an event handler for a given event.
     * @function
     * @param {String} eventName - Name of event to register.
     * @param {OpenSeadragon.EventHandler} handler - Function to call when event is triggered.
     * @param {Object} [userData=null] - Arbitrary object to be passed unchanged to the handler.
     */ addHandler: function(eventName11, handler11, userData11) {
            var events11 = this.events[eventName11];
            if (!events11) this.events[eventName11] = events11 = [];
            if (handler11 && $11.isFunction(handler11)) events11[events11.length] = {
                handler: handler11,
                userData: userData11 || null
            };
        },
        /**
     * Remove a specific event handler for a given event.
     * @function
     * @param {String} eventName - Name of event for which the handler is to be removed.
     * @param {OpenSeadragon.EventHandler} handler - Function to be removed.
     */ removeHandler: function(eventName11, handler11) {
            var events11 = this.events[eventName11], handlers11 = [], i11;
            if (!events11) return;
            if ($11.isArray(events11)) {
                for(i11 = 0; i11 < events11.length; i11++)if (events11[i11].handler !== handler11) handlers11.push(events11[i11]);
                this.events[eventName11] = handlers11;
            }
        },
        /**
     * Remove all event handlers for a given event type. If no type is given all
     * event handlers for every event type are removed.
     * @function
     * @param {String} eventName - Name of event for which all handlers are to be removed.
     */ removeAllHandlers: function(eventName11) {
            if (eventName11) this.events[eventName11] = [];
            else for(var eventType11 in this.events)this.events[eventType11] = [];
        },
        /**
     * Get a function which iterates the list of all handlers registered for a given event, calling the handler for each.
     * @function
     * @param {String} eventName - Name of event to get handlers for.
     */ getHandler: function(eventName11) {
            var events11 = this.events[eventName11];
            if (!events11 || !events11.length) return null;
            events11 = events11.length === 1 ? [
                events11[0]
            ] : Array.apply(null, events11);
            return function(source11, args11) {
                var i11, length11 = events11.length;
                for(i11 = 0; i11 < length11; i11++)if (events11[i11]) {
                    args11.eventSource = source11;
                    args11.userData = events11[i11].userData;
                    events11[i11].handler(args11);
                }
            };
        },
        /**
     * Trigger an event, optionally passing additional information.
     * @function
     * @param {String} eventName - Name of event to register.
     * @param {Object} eventArgs - Event-specific data.
     */ raiseEvent: function(eventName11, eventArgs11) {
            //uncomment if you want to get a log of all events
            //$.console.log( eventName );
            var handler11 = this.getHandler(eventName11);
            if (handler11) {
                if (!eventArgs11) eventArgs11 = {};
                handler11(this, eventArgs11);
            }
        }
    };
})(OpenSeadragon);
/*
 * OpenSeadragon - MouseTracker
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    // All MouseTracker instances
    var MOUSETRACKERS11 = [];
    // dictionary from hash to private properties
    var THIS11 = {};
    /**
     * @class MouseTracker
     * @classdesc Provides simplified handling of common pointer device (mouse, touch, pen, etc.) gestures
     *            and keyboard events on a specified element.
     * @memberof OpenSeadragon
     * @param {Object} options
     *      Allows configurable properties to be entirely specified by passing
     *      an options object to the constructor.  The constructor also supports
     *      the original positional arguments 'element', 'clickTimeThreshold',
     *      and 'clickDistThreshold' in that order.
     * @param {Element|String} options.element
     *      A reference to an element or an element id for which the pointer/key
     *      events will be monitored.
     * @param {Boolean} [options.startDisabled=false]
     *      If true, event tracking on the element will not start until
     *      {@link OpenSeadragon.MouseTracker.setTracking|setTracking} is called.
     * @param {Number} options.clickTimeThreshold
     *      The number of milliseconds within which a pointer down-up event combination
     *      will be treated as a click gesture.
     * @param {Number} options.clickDistThreshold
     *      The maximum distance allowed between a pointer down event and a pointer up event
     *      to be treated as a click gesture.
     * @param {Number} options.dblClickTimeThreshold
     *      The number of milliseconds within which two pointer down-up event combinations
     *      will be treated as a double-click gesture.
     * @param {Number} options.dblClickDistThreshold
     *      The maximum distance allowed between two pointer click events
     *      to be treated as a click gesture.
     * @param {Number} [options.stopDelay=50]
     *      The number of milliseconds without pointer move before the stop
     *      event is fired.
     * @param {OpenSeadragon.EventHandler} [options.enterHandler=null]
     *      An optional handler for pointer enter.
     * @param {OpenSeadragon.EventHandler} [options.exitHandler=null]
     *      An optional handler for pointer exit.
     * @param {OpenSeadragon.EventHandler} [options.pressHandler=null]
     *      An optional handler for pointer press.
     * @param {OpenSeadragon.EventHandler} [options.nonPrimaryPressHandler=null]
     *      An optional handler for pointer non-primary button press.
     * @param {OpenSeadragon.EventHandler} [options.releaseHandler=null]
     *      An optional handler for pointer release.
     * @param {OpenSeadragon.EventHandler} [options.nonPrimaryReleaseHandler=null]
     *      An optional handler for pointer non-primary button release.
     * @param {OpenSeadragon.EventHandler} [options.moveHandler=null]
     *      An optional handler for pointer move.
     * @param {OpenSeadragon.EventHandler} [options.scrollHandler=null]
     *      An optional handler for mouse wheel scroll.
     * @param {OpenSeadragon.EventHandler} [options.clickHandler=null]
     *      An optional handler for pointer click.
     * @param {OpenSeadragon.EventHandler} [options.dblClickHandler=null]
     *      An optional handler for pointer double-click.
     * @param {OpenSeadragon.EventHandler} [options.dragHandler=null]
     *      An optional handler for the drag gesture.
     * @param {OpenSeadragon.EventHandler} [options.dragEndHandler=null]
     *      An optional handler for after a drag gesture.
     * @param {OpenSeadragon.EventHandler} [options.pinchHandler=null]
     *      An optional handler for the pinch gesture.
     * @param {OpenSeadragon.EventHandler} [options.keyDownHandler=null]
     *      An optional handler for keydown.
     * @param {OpenSeadragon.EventHandler} [options.keyUpHandler=null]
     *      An optional handler for keyup.
     * @param {OpenSeadragon.EventHandler} [options.keyHandler=null]
     *      An optional handler for keypress.
     * @param {OpenSeadragon.EventHandler} [options.focusHandler=null]
     *      An optional handler for focus.
     * @param {OpenSeadragon.EventHandler} [options.blurHandler=null]
     *      An optional handler for blur.
     * @param {Object} [options.userData=null]
     *      Arbitrary object to be passed unchanged to any attached handler methods.
     */ $11.MouseTracker = function(options11) {
        MOUSETRACKERS11.push(this);
        var args11 = arguments;
        if (!$11.isPlainObject(options11)) options11 = {
            element: args11[0],
            clickTimeThreshold: args11[1],
            clickDistThreshold: args11[2]
        };
        this.hash = Math.random(); // An unique hash for this tracker.
        /**
         * The element for which pointer events are being monitored.
         * @member {Element} element
         * @memberof OpenSeadragon.MouseTracker#
         */ this.element = $11.getElement(options11.element);
        /**
         * The number of milliseconds within which a pointer down-up event combination
         * will be treated as a click gesture.
         * @member {Number} clickTimeThreshold
         * @memberof OpenSeadragon.MouseTracker#
         */ this.clickTimeThreshold = options11.clickTimeThreshold || $11.DEFAULT_SETTINGS.clickTimeThreshold;
        /**
         * The maximum distance allowed between a pointer down event and a pointer up event
         * to be treated as a click gesture.
         * @member {Number} clickDistThreshold
         * @memberof OpenSeadragon.MouseTracker#
         */ this.clickDistThreshold = options11.clickDistThreshold || $11.DEFAULT_SETTINGS.clickDistThreshold;
        /**
         * The number of milliseconds within which two pointer down-up event combinations
         * will be treated as a double-click gesture.
         * @member {Number} dblClickTimeThreshold
         * @memberof OpenSeadragon.MouseTracker#
         */ this.dblClickTimeThreshold = options11.dblClickTimeThreshold || $11.DEFAULT_SETTINGS.dblClickTimeThreshold;
        /**
         * The maximum distance allowed between two pointer click events
         * to be treated as a click gesture.
         * @member {Number} clickDistThreshold
         * @memberof OpenSeadragon.MouseTracker#
         */ this.dblClickDistThreshold = options11.dblClickDistThreshold || $11.DEFAULT_SETTINGS.dblClickDistThreshold;
        /*eslint-disable no-multi-spaces*/ this.userData = options11.userData || null;
        this.stopDelay = options11.stopDelay || 50;
        this.enterHandler = options11.enterHandler || null;
        this.exitHandler = options11.exitHandler || null;
        this.pressHandler = options11.pressHandler || null;
        this.nonPrimaryPressHandler = options11.nonPrimaryPressHandler || null;
        this.releaseHandler = options11.releaseHandler || null;
        this.nonPrimaryReleaseHandler = options11.nonPrimaryReleaseHandler || null;
        this.moveHandler = options11.moveHandler || null;
        this.scrollHandler = options11.scrollHandler || null;
        this.clickHandler = options11.clickHandler || null;
        this.dblClickHandler = options11.dblClickHandler || null;
        this.dragHandler = options11.dragHandler || null;
        this.dragEndHandler = options11.dragEndHandler || null;
        this.pinchHandler = options11.pinchHandler || null;
        this.stopHandler = options11.stopHandler || null;
        this.keyDownHandler = options11.keyDownHandler || null;
        this.keyUpHandler = options11.keyUpHandler || null;
        this.keyHandler = options11.keyHandler || null;
        this.focusHandler = options11.focusHandler || null;
        this.blurHandler = options11.blurHandler || null;
        /*eslint-enable no-multi-spaces*/ //Store private properties in a scope sealed hash map
        var _this11 = this;
        /**
         * @private
         * @property {Boolean} tracking
         *      Are we currently tracking pointer events for this element.
         */ THIS11[this.hash] = {
            click: function(event11) {
                onClick11(_this11, event11);
            },
            dblclick: function(event11) {
                onDblClick11(_this11, event11);
            },
            keydown: function(event11) {
                onKeyDown11(_this11, event11);
            },
            keyup: function(event11) {
                onKeyUp11(_this11, event11);
            },
            keypress: function(event11) {
                onKeyPress11(_this11, event11);
            },
            focus: function(event11) {
                onFocus11(_this11, event11);
            },
            blur: function(event11) {
                onBlur11(_this11, event11);
            },
            wheel: function(event11) {
                onWheel11(_this11, event11);
            },
            mousewheel: function(event11) {
                onMouseWheel11(_this11, event11);
            },
            DOMMouseScroll: function(event11) {
                onMouseWheel11(_this11, event11);
            },
            MozMousePixelScroll: function(event11) {
                onMouseWheel11(_this11, event11);
            },
            mouseenter: function(event11) {
                onMouseEnter11(_this11, event11);
            },
            mouseleave: function(event11) {
                onMouseLeave11(_this11, event11);
            },
            mouseover: function(event11) {
                onMouseOver11(_this11, event11);
            },
            mouseout: function(event11) {
                onMouseOut11(_this11, event11);
            },
            mousedown: function(event11) {
                onMouseDown11(_this11, event11);
            },
            mouseup: function(event11) {
                onMouseUp11(_this11, event11);
            },
            mouseupcaptured: function(event11) {
                onMouseUpCaptured11(_this11, event11);
            },
            mousemove: function(event11) {
                onMouseMove11(_this11, event11);
            },
            mousemovecaptured: function(event11) {
                onMouseMoveCaptured11(_this11, event11);
            },
            touchstart: function(event11) {
                onTouchStart11(_this11, event11);
            },
            touchend: function(event11) {
                onTouchEnd11(_this11, event11);
            },
            touchendcaptured: function(event11) {
                onTouchEndCaptured11(_this11, event11);
            },
            touchmove: function(event11) {
                onTouchMove11(_this11, event11);
            },
            touchmovecaptured: function(event11) {
                onTouchMoveCaptured11(_this11, event11);
            },
            touchcancel: function(event11) {
                onTouchCancel11(_this11, event11);
            },
            gesturestart: function(event11) {
                onGestureStart11(_this11, event11);
            },
            gesturechange: function(event11) {
                onGestureChange11(_this11, event11);
            },
            pointerover: function(event11) {
                onPointerOver11(_this11, event11);
            },
            MSPointerOver: function(event11) {
                onPointerOver11(_this11, event11);
            },
            pointerout: function(event11) {
                onPointerOut11(_this11, event11);
            },
            MSPointerOut: function(event11) {
                onPointerOut11(_this11, event11);
            },
            pointerdown: function(event11) {
                onPointerDown11(_this11, event11);
            },
            MSPointerDown: function(event11) {
                onPointerDown11(_this11, event11);
            },
            pointerup: function(event11) {
                onPointerUp11(_this11, event11);
            },
            MSPointerUp: function(event11) {
                onPointerUp11(_this11, event11);
            },
            pointermove: function(event11) {
                onPointerMove11(_this11, event11);
            },
            MSPointerMove: function(event11) {
                onPointerMove11(_this11, event11);
            },
            pointercancel: function(event11) {
                onPointerCancel11(_this11, event11);
            },
            MSPointerCancel: function(event11) {
                onPointerCancel11(_this11, event11);
            },
            pointerupcaptured: function(event11) {
                onPointerUpCaptured11(_this11, event11);
            },
            pointermovecaptured: function(event11) {
                onPointerMoveCaptured11(_this11, event11);
            },
            tracking: false,
            // Active pointers lists. Array of GesturePointList objects, one for each pointer device type.
            // GesturePointList objects are added each time a pointer is tracked by a new pointer device type (see getActivePointersListByType()).
            // Active pointers are any pointer being tracked for this element which are in the hit-test area
            //     of the element (for hover-capable devices) and/or have contact or a button press initiated in the element.
            activePointersLists: [],
            // Tracking for double-click gesture
            lastClickPos: null,
            dblClickTimeOut: null,
            // Tracking for pinch gesture
            pinchGPoints: [],
            lastPinchDist: 0,
            currentPinchDist: 0,
            lastPinchCenter: null,
            currentPinchCenter: null
        };
        if (!options11.startDisabled) this.setTracking(true);
    };
    /** @lends OpenSeadragon.MouseTracker.prototype */ $11.MouseTracker.prototype = {
        /**
         * Clean up any events or objects created by the tracker.
         * @function
         */ destroy: function() {
            var i11;
            stopTracking11(this);
            this.element = null;
            for(i11 = 0; i11 < MOUSETRACKERS11.length; i11++)if (MOUSETRACKERS11[i11] === this) {
                MOUSETRACKERS11.splice(i11, 1);
                break;
            }
            THIS11[this.hash] = null;
            delete THIS11[this.hash];
        },
        /**
         * Are we currently tracking events on this element.
         * @deprecated Just use this.tracking
         * @function
         * @returns {Boolean} Are we currently tracking events on this element.
         */ isTracking: function() {
            return THIS11[this.hash].tracking;
        },
        /**
         * Enable or disable whether or not we are tracking events on this element.
         * @function
         * @param {Boolean} track True to start tracking, false to stop tracking.
         * @returns {OpenSeadragon.MouseTracker} Chainable.
         */ setTracking: function(track11) {
            if (track11) startTracking11(this);
            else stopTracking11(this);
            //chain
            return this;
        },
        /**
         * Returns the {@link OpenSeadragon.MouseTracker.GesturePointList|GesturePointList} for all but the given pointer device type.
         * @function
         * @param {String} type - The pointer device type: "mouse", "touch", "pen", etc.
         * @returns {Array.<OpenSeadragon.MouseTracker.GesturePointList>}
         */ getActivePointersListsExceptType: function(type11) {
            var delegate11 = THIS11[this.hash];
            var listArray11 = [];
            for(var i11 = 0; i11 < delegate11.activePointersLists.length; ++i11)if (delegate11.activePointersLists[i11].type !== type11) listArray11.push(delegate11.activePointersLists[i11]);
            return listArray11;
        },
        /**
         * Returns the {@link OpenSeadragon.MouseTracker.GesturePointList|GesturePointList} for the given pointer device type,
         * creating and caching a new {@link OpenSeadragon.MouseTracker.GesturePointList|GesturePointList} if one doesn't already exist for the type.
         * @function
         * @param {String} type - The pointer device type: "mouse", "touch", "pen", etc.
         * @returns {OpenSeadragon.MouseTracker.GesturePointList}
         */ getActivePointersListByType: function(type11) {
            var delegate11 = THIS11[this.hash], i11, len11 = delegate11.activePointersLists.length, list11;
            for(i11 = 0; i11 < len11; i11++){
                if (delegate11.activePointersLists[i11].type === type11) return delegate11.activePointersLists[i11];
            }
            list11 = new $11.MouseTracker.GesturePointList(type11);
            delegate11.activePointersLists.push(list11);
            return list11;
        },
        /**
         * Returns the total number of pointers currently active on the tracked element.
         * @function
         * @returns {Number}
         */ getActivePointerCount: function() {
            var delegate11 = THIS11[this.hash], i11, len11 = delegate11.activePointersLists.length, count11 = 0;
            for(i11 = 0; i11 < len11; i11++)count11 += delegate11.activePointersLists[i11].getLength();
            return count11;
        },
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Number} event.pointers
         *      Number of pointers (all types) active in the tracked element.
         * @param {Boolean} event.insideElementPressed
         *      True if the left mouse button is currently being pressed and was
         *      initiated inside the tracked element, otherwise false.
         * @param {Boolean} event.buttonDownAny
         *      Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */ enterHandler: function() {},
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Number} event.pointers
         *      Number of pointers (all types) active in the tracked element.
         * @param {Boolean} event.insideElementPressed
         *      True if the left mouse button is currently being pressed and was
         *      initiated inside the tracked element, otherwise false.
         * @param {Boolean} event.buttonDownAny
         *      Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */ exitHandler: function() {},
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */ pressHandler: function() {},
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.button
         *      Button which caused the event.
         *      -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */ nonPrimaryPressHandler: function() {},
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Boolean} event.insideElementPressed
         *      True if the left mouse button is currently being pressed and was
         *      initiated inside the tracked element, otherwise false.
         * @param {Boolean} event.insideElementReleased
         *      True if the cursor inside the tracked element when the button was released.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */ releaseHandler: function() {},
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.button
         *      Button which caused the event.
         *      -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */ nonPrimaryReleaseHandler: function() {},
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */ moveHandler: function() {},
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.scroll
         *      The scroll delta for the event.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead. Touch devices no longer generate scroll event.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */ scrollHandler: function() {},
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Boolean} event.quick
         *      True only if the clickDistThreshold and clickTimeThreshold are both passed. Useful for ignoring drag events.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */ clickHandler: function() {},
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */ dblClickHandler: function() {},
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {OpenSeadragon.Point} event.delta
         *      The x,y components of the difference between the current position and the last drag event position.  Useful for ignoring or weighting the events.
         * @param {Number} event.speed
         *     Current computed speed, in pixels per second.
         * @param {Number} event.direction
         *     Current computed direction, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */ dragHandler: function() {},
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.speed
         *     Speed at the end of a drag gesture, in pixels per second.
         * @param {Number} event.direction
         *     Direction at the end of a drag gesture, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */ dragEndHandler: function() {},
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} event.gesturePoints
         *      Gesture points associated with the gesture. Velocity data can be found here.
         * @param {OpenSeadragon.Point} event.lastCenter
         *      The previous center point of the two pinch contact points relative to the tracked element.
         * @param {OpenSeadragon.Point} event.center
         *      The center point of the two pinch contact points relative to the tracked element.
         * @param {Number} event.lastDistance
         *      The previous distance between the two pinch contact points in CSS pixels.
         * @param {Number} event.distance
         *      The distance between the two pinch contact points in CSS pixels.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */ pinchHandler: function() {},
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */ stopHandler: function() {},
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {Number} event.keyCode
         *      The key code that was pressed.
         * @param {Boolean} event.ctrl
         *      True if the ctrl key was pressed during this event.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Boolean} event.alt
         *      True if the alt key was pressed during this event.
         * @param {Boolean} event.meta
         *      True if the meta key was pressed during this event.
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */ keyDownHandler: function() {},
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {Number} event.keyCode
         *      The key code that was pressed.
         * @param {Boolean} event.ctrl
         *      True if the ctrl key was pressed during this event.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Boolean} event.alt
         *      True if the alt key was pressed during this event.
         * @param {Boolean} event.meta
         *      True if the meta key was pressed during this event.
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */ keyUpHandler: function() {},
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {Number} event.keyCode
         *      The key code that was pressed.
         * @param {Boolean} event.ctrl
         *      True if the ctrl key was pressed during this event.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Boolean} event.alt
         *      True if the alt key was pressed during this event.
         * @param {Boolean} event.meta
         *      True if the meta key was pressed during this event.
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */ keyHandler: function() {},
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */ focusHandler: function() {},
        /**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */ blurHandler: function() {}
    };
    /**
     * Resets all active mousetrakers. (Added to patch issue #697 "Mouse up outside map will cause "canvas-drag" event to stick")
     *
     * @private
     * @member resetAllMouseTrackers
     * @memberof OpenSeadragon.MouseTracker
     */ $11.MouseTracker.resetAllMouseTrackers = function() {
        for(var i11 = 0; i11 < MOUSETRACKERS11.length; i11++)if (MOUSETRACKERS11[i11].isTracking()) {
            MOUSETRACKERS11[i11].setTracking(false);
            MOUSETRACKERS11[i11].setTracking(true);
        }
    };
    /**
     * Provides continuous computation of velocity (speed and direction) of active pointers.
     * This is a singleton, used by all MouseTracker instances, as it is unlikely there will ever be more than
     * two active gesture pointers at a time.
     *
     * @private
     * @member gesturePointVelocityTracker
     * @memberof OpenSeadragon.MouseTracker
     */ $11.MouseTracker.gesturePointVelocityTracker = function() {
        var trackerPoints11 = [], intervalId11 = 0, lastTime11 = 0;
        // Generates a unique identifier for a tracked gesture point
        var _generateGuid11 = function(tracker11, gPoint11) {
            return tracker11.hash.toString() + gPoint11.type + gPoint11.id.toString();
        };
        // Interval timer callback. Computes velocity for all tracked gesture points.
        var _doTracking11 = function() {
            var i11, len11 = trackerPoints11.length, trackPoint11, gPoint11, now11 = $11.now(), elapsedTime11, distance11, speed11;
            elapsedTime11 = now11 - lastTime11;
            lastTime11 = now11;
            for(i11 = 0; i11 < len11; i11++){
                trackPoint11 = trackerPoints11[i11];
                gPoint11 = trackPoint11.gPoint;
                // Math.atan2 gives us just what we need for a velocity vector, as we can simply
                //   use cos()/sin() to extract the x/y velocity components.
                gPoint11.direction = Math.atan2(gPoint11.currentPos.y - trackPoint11.lastPos.y, gPoint11.currentPos.x - trackPoint11.lastPos.x);
                // speed = distance / elapsed time
                distance11 = trackPoint11.lastPos.distanceTo(gPoint11.currentPos);
                trackPoint11.lastPos = gPoint11.currentPos;
                speed11 = 1000 * distance11 / (elapsedTime11 + 1);
                // Simple biased average, favors the most recent speed computation. Smooths out erratic gestures a bit.
                gPoint11.speed = 0.75 * speed11 + 0.25 * gPoint11.speed;
            }
        };
        // Public. Add a gesture point to be tracked
        var addPoint11 = function(tracker11, gPoint11) {
            var guid11 = _generateGuid11(tracker11, gPoint11);
            trackerPoints11.push({
                guid: guid11,
                gPoint: gPoint11,
                lastPos: gPoint11.currentPos
            });
            // Only fire up the interval timer when there's gesture pointers to track
            if (trackerPoints11.length === 1) {
                lastTime11 = $11.now();
                intervalId11 = window.setInterval(_doTracking11, 50);
            }
        };
        // Public. Stop tracking a gesture point
        var removePoint11 = function(tracker11, gPoint11) {
            var guid11 = _generateGuid11(tracker11, gPoint11), i11, len11 = trackerPoints11.length;
            for(i11 = 0; i11 < len11; i11++)if (trackerPoints11[i11].guid === guid11) {
                trackerPoints11.splice(i11, 1);
                // Only run the interval timer if theres gesture pointers to track
                len11--;
                if (len11 === 0) window.clearInterval(intervalId11);
                break;
            }
        };
        return {
            addPoint: addPoint11,
            removePoint: removePoint11
        };
    }();
    ///////////////////////////////////////////////////////////////////////////////
    // Pointer event model and feature detection
    ///////////////////////////////////////////////////////////////////////////////
    $11.MouseTracker.captureElement = document;
    /**
     * Detect available mouse wheel event name.
     */ $11.MouseTracker.wheelEventName = $11.Browser.vendor == $11.BROWSERS.IE && $11.Browser.version > 8 || "onwheel" in document.createElement("div") ? "wheel" : document.onmousewheel !== undefined ? "mousewheel" : "DOMMouseScroll"; // Assume old Firefox
    /**
     * Detect legacy mouse capture support.
     */ $11.MouseTracker.supportsMouseCapture = function() {
        var divElement11 = document.createElement("div");
        return $11.isFunction(divElement11.setCapture) && $11.isFunction(divElement11.releaseCapture);
    }();
    /**
     * Detect browser pointer device event model(s) and build appropriate list of events to subscribe to.
     */ $11.MouseTracker.subscribeEvents = [
        "click",
        "dblclick",
        "keydown",
        "keyup",
        "keypress",
        "focus",
        "blur",
        $11.MouseTracker.wheelEventName
    ];
    if ($11.MouseTracker.wheelEventName == "DOMMouseScroll") // Older Firefox
    $11.MouseTracker.subscribeEvents.push("MozMousePixelScroll");
    // Note: window.navigator.pointerEnable is deprecated on IE 11 and not part of W3C spec.
    if (window.PointerEvent && (window.navigator.pointerEnabled || $11.Browser.vendor !== $11.BROWSERS.IE)) {
        // IE11 and other W3C Pointer Event implementations (see http://www.w3.org/TR/pointerevents)
        $11.MouseTracker.havePointerEvents = true;
        $11.MouseTracker.subscribeEvents.push("pointerover", "pointerout", "pointerdown", "pointerup", "pointermove", "pointercancel");
        $11.MouseTracker.unprefixedPointerEvents = true;
        if (navigator.maxTouchPoints) $11.MouseTracker.maxTouchPoints = navigator.maxTouchPoints;
        else $11.MouseTracker.maxTouchPoints = 0;
        $11.MouseTracker.haveMouseEnter = false;
    } else if (window.MSPointerEvent && window.navigator.msPointerEnabled) {
        // IE10
        $11.MouseTracker.havePointerEvents = true;
        $11.MouseTracker.subscribeEvents.push("MSPointerOver", "MSPointerOut", "MSPointerDown", "MSPointerUp", "MSPointerMove", "MSPointerCancel");
        $11.MouseTracker.unprefixedPointerEvents = false;
        if (navigator.msMaxTouchPoints) $11.MouseTracker.maxTouchPoints = navigator.msMaxTouchPoints;
        else $11.MouseTracker.maxTouchPoints = 0;
        $11.MouseTracker.haveMouseEnter = false;
    } else {
        // Legacy W3C mouse events
        $11.MouseTracker.havePointerEvents = false;
        if ($11.Browser.vendor === $11.BROWSERS.IE && $11.Browser.version < 9) {
            $11.MouseTracker.subscribeEvents.push("mouseenter", "mouseleave");
            $11.MouseTracker.haveMouseEnter = true;
        } else {
            $11.MouseTracker.subscribeEvents.push("mouseover", "mouseout");
            $11.MouseTracker.haveMouseEnter = false;
        }
        $11.MouseTracker.subscribeEvents.push("mousedown", "mouseup", "mousemove");
        if ("ontouchstart" in window) // iOS, Android, and other W3c Touch Event implementations
        //    (see http://www.w3.org/TR/touch-events/)
        //    (see https://developer.apple.com/library/ios/documentation/AppleApplications/Reference/SafariWebContent/HandlingEvents/HandlingEvents.html)
        //    (see https://developer.apple.com/library/safari/documentation/AppleApplications/Reference/SafariWebContent/HandlingEvents/HandlingEvents.html)
        $11.MouseTracker.subscribeEvents.push("touchstart", "touchend", "touchmove", "touchcancel");
        if ("ongesturestart" in window) // iOS (see https://developer.apple.com/library/ios/documentation/AppleApplications/Reference/SafariWebContent/HandlingEvents/HandlingEvents.html)
        //   Subscribe to these to prevent default gesture handling
        $11.MouseTracker.subscribeEvents.push("gesturestart", "gesturechange");
        $11.MouseTracker.mousePointerId = "legacy-mouse";
        $11.MouseTracker.maxTouchPoints = 10;
    }
    ///////////////////////////////////////////////////////////////////////////////
    // Classes and typedefs
    ///////////////////////////////////////////////////////////////////////////////
    /**
     * Represents a point of contact on the screen made by a mouse cursor, pen, touch, or other pointer device.
     *
     * @typedef {Object} GesturePoint
     * @memberof OpenSeadragon.MouseTracker
     *
     * @property {Number} id
     *     Identifier unique from all other active GesturePoints for a given pointer device.
     * @property {String} type
     *     The pointer device type: "mouse", "touch", "pen", etc.
     * @property {Boolean} captured
     *     True if events for the gesture point are captured to the tracked element.
     * @property {Boolean} isPrimary
     *     True if the gesture point is a master pointer amongst the set of active pointers for each pointer type. True for mouse and primary (first) touch/pen pointers.
     * @property {Boolean} insideElementPressed
     *     True if button pressed or contact point initiated inside the screen area of the tracked element.
     * @property {Boolean} insideElement
     *     True if pointer or contact point is currently inside the bounds of the tracked element.
     * @property {Number} speed
     *     Current computed speed, in pixels per second.
     * @property {Number} direction
     *     Current computed direction, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
     * @property {OpenSeadragon.Point} contactPos
     *     The initial pointer contact position, relative to the page including any scrolling. Only valid if the pointer has contact (pressed, touch contact, pen contact).
     * @property {Number} contactTime
     *     The initial pointer contact time, in milliseconds. Only valid if the pointer has contact (pressed, touch contact, pen contact).
     * @property {OpenSeadragon.Point} lastPos
     *     The last pointer position, relative to the page including any scrolling.
     * @property {Number} lastTime
     *     The last pointer contact time, in milliseconds.
     * @property {OpenSeadragon.Point} currentPos
     *     The current pointer position, relative to the page including any scrolling.
     * @property {Number} currentTime
     *     The current pointer contact time, in milliseconds.
     */ /**
     * @class GesturePointList
     * @classdesc Provides an abstraction for a set of active {@link OpenSeadragon.MouseTracker.GesturePoint|GesturePoint} objects for a given pointer device type.
     *            Active pointers are any pointer being tracked for this element which are in the hit-test area
     *            of the element (for hover-capable devices) and/or have contact or a button press initiated in the element.
     * @memberof OpenSeadragon.MouseTracker
     * @param {String} type - The pointer device type: "mouse", "touch", "pen", etc.
     */ $11.MouseTracker.GesturePointList = function(type11) {
        this._gPoints = [];
        /**
         * The pointer device type: "mouse", "touch", "pen", etc.
         * @member {String} type
         * @memberof OpenSeadragon.MouseTracker.GesturePointList#
         */ this.type = type11;
        /**
         * Current buttons pressed for the device.
         * Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @member {Number} buttons
         * @memberof OpenSeadragon.MouseTracker.GesturePointList#
         */ this.buttons = 0;
        /**
         * Current number of contact points (touch points, mouse down, etc.) for the device.
         * @member {Number} contacts
         * @memberof OpenSeadragon.MouseTracker.GesturePointList#
         */ this.contacts = 0;
        /**
         * Current number of clicks for the device. Used for multiple click gesture tracking.
         * @member {Number} clicks
         * @memberof OpenSeadragon.MouseTracker.GesturePointList#
         */ this.clicks = 0;
        /**
         * Current number of captured pointers for the device.
         * @member {Number} captureCount
         * @memberof OpenSeadragon.MouseTracker.GesturePointList#
         */ this.captureCount = 0;
    };
    /** @lends OpenSeadragon.MouseTracker.GesturePointList.prototype */ $11.MouseTracker.GesturePointList.prototype = {
        /**
         * @function
         * @returns {Number} Number of gesture points in the list.
         */ getLength: function() {
            return this._gPoints.length;
        },
        /**
         * @function
         * @returns {Array.<OpenSeadragon.MouseTracker.GesturePoint>} The list of gesture points in the list as an array (read-only).
         */ asArray: function() {
            return this._gPoints;
        },
        /**
         * @function
         * @param {OpenSeadragon.MouseTracker.GesturePoint} gesturePoint - A gesture point to add to the list.
         * @returns {Number} Number of gesture points in the list.
         */ add: function(gp11) {
            return this._gPoints.push(gp11);
        },
        /**
         * @function
         * @param {Number} id - The id of the gesture point to remove from the list.
         * @returns {Number} Number of gesture points in the list.
         */ removeById: function(id11) {
            var i11, len11 = this._gPoints.length;
            for(i11 = 0; i11 < len11; i11++)if (this._gPoints[i11].id === id11) {
                this._gPoints.splice(i11, 1);
                break;
            }
            return this._gPoints.length;
        },
        /**
         * @function
         * @param {Number} index - The index of the gesture point to retrieve from the list.
         * @returns {OpenSeadragon.MouseTracker.GesturePoint|null} The gesture point at the given index, or null if not found.
         */ getByIndex: function(index11) {
            if (index11 < this._gPoints.length) return this._gPoints[index11];
            return null;
        },
        /**
         * @function
         * @param {Number} id - The id of the gesture point to retrieve from the list.
         * @returns {OpenSeadragon.MouseTracker.GesturePoint|null} The gesture point with the given id, or null if not found.
         */ getById: function(id11) {
            var i11, len11 = this._gPoints.length;
            for(i11 = 0; i11 < len11; i11++){
                if (this._gPoints[i11].id === id11) return this._gPoints[i11];
            }
            return null;
        },
        /**
         * @function
         * @returns {OpenSeadragon.MouseTracker.GesturePoint|null} The primary gesture point in the list, or null if not found.
         */ getPrimary: function(id11) {
            var i11, len11 = this._gPoints.length;
            for(i11 = 0; i11 < len11; i11++){
                if (this._gPoints[i11].isPrimary) return this._gPoints[i11];
            }
            return null;
        },
        /**
         * Increment this pointer's contact count.
         * It will evaluate whether this pointer type is allowed to have multiple contacts.
         * @function
         */ addContact: function() {
            ++this.contacts;
            if (this.contacts > 1 && (this.type === "mouse" || this.type === "pen")) this.contacts = 1;
        },
        /**
         * Decrement this pointer's contact count.
         * It will make sure the count does not go below 0.
         * @function
         */ removeContact: function() {
            --this.contacts;
            if (this.contacts < 0) this.contacts = 0;
        }
    };
    ///////////////////////////////////////////////////////////////////////////////
    // Utility functions
    ///////////////////////////////////////////////////////////////////////////////
    /**
     * Removes all tracked pointers.
     * @private
     * @inner
     */ function clearTrackedPointers11(tracker11) {
        var delegate11 = THIS11[tracker11.hash], i11, pointerListCount11 = delegate11.activePointersLists.length;
        for(i11 = 0; i11 < pointerListCount11; i11++)if (delegate11.activePointersLists[i11].captureCount > 0) {
            $11.removeEvent($11.MouseTracker.captureElement, "mousemove", delegate11.mousemovecaptured, true);
            $11.removeEvent($11.MouseTracker.captureElement, "mouseup", delegate11.mouseupcaptured, true);
            $11.removeEvent($11.MouseTracker.captureElement, $11.MouseTracker.unprefixedPointerEvents ? "pointermove" : "MSPointerMove", delegate11.pointermovecaptured, true);
            $11.removeEvent($11.MouseTracker.captureElement, $11.MouseTracker.unprefixedPointerEvents ? "pointerup" : "MSPointerUp", delegate11.pointerupcaptured, true);
            $11.removeEvent($11.MouseTracker.captureElement, "touchmove", delegate11.touchmovecaptured, true);
            $11.removeEvent($11.MouseTracker.captureElement, "touchend", delegate11.touchendcaptured, true);
            delegate11.activePointersLists[i11].captureCount = 0;
        }
        for(i11 = 0; i11 < pointerListCount11; i11++)delegate11.activePointersLists.pop();
    }
    /**
     * Starts tracking pointer events on the tracked element.
     * @private
     * @inner
     */ function startTracking11(tracker11) {
        var delegate11 = THIS11[tracker11.hash], event11, i11;
        if (!delegate11.tracking) {
            for(i11 = 0; i11 < $11.MouseTracker.subscribeEvents.length; i11++){
                event11 = $11.MouseTracker.subscribeEvents[i11];
                $11.addEvent(tracker11.element, event11, delegate11[event11], false);
            }
            clearTrackedPointers11(tracker11);
            delegate11.tracking = true;
        }
    }
    /**
     * Stops tracking pointer events on the tracked element.
     * @private
     * @inner
     */ function stopTracking11(tracker11) {
        var delegate11 = THIS11[tracker11.hash], event11, i11;
        if (delegate11.tracking) {
            for(i11 = 0; i11 < $11.MouseTracker.subscribeEvents.length; i11++){
                event11 = $11.MouseTracker.subscribeEvents[i11];
                $11.removeEvent(tracker11.element, event11, delegate11[event11], false);
            }
            clearTrackedPointers11(tracker11);
            delegate11.tracking = false;
        }
    }
    /**
     * @private
     * @inner
     */ function getCaptureEventParams11(tracker11, pointerType11) {
        var delegate11 = THIS11[tracker11.hash];
        if (pointerType11 === "pointerevent") return {
            upName: $11.MouseTracker.unprefixedPointerEvents ? "pointerup" : "MSPointerUp",
            upHandler: delegate11.pointerupcaptured,
            moveName: $11.MouseTracker.unprefixedPointerEvents ? "pointermove" : "MSPointerMove",
            moveHandler: delegate11.pointermovecaptured
        };
        else if (pointerType11 === "mouse") return {
            upName: "mouseup",
            upHandler: delegate11.mouseupcaptured,
            moveName: "mousemove",
            moveHandler: delegate11.mousemovecaptured
        };
        else if (pointerType11 === "touch") return {
            upName: "touchend",
            upHandler: delegate11.touchendcaptured,
            moveName: "touchmove",
            moveHandler: delegate11.touchmovecaptured
        };
        else throw new Error("MouseTracker.getCaptureEventParams: Unknown pointer type.");
    }
    /**
     * Begin capturing pointer events to the tracked element.
     * @private
     * @inner
     */ function capturePointer11(tracker11, pointerType11, pointerCount11) {
        var pointsList11 = tracker11.getActivePointersListByType(pointerType11), eventParams11;
        pointsList11.captureCount += pointerCount11 || 1;
        if (pointsList11.captureCount === 1) {
            if ($11.Browser.vendor === $11.BROWSERS.IE && $11.Browser.version < 9) tracker11.element.setCapture(true);
            else {
                eventParams11 = getCaptureEventParams11(tracker11, $11.MouseTracker.havePointerEvents ? "pointerevent" : pointerType11);
                // We emulate mouse capture by hanging listeners on the document object.
                //    (Note we listen on the capture phase so the captured handlers will get called first)
                // eslint-disable-next-line no-use-before-define
                if (isInIframe11 && canAccessEvents11(window.top)) $11.addEvent(window.top, eventParams11.upName, eventParams11.upHandler, true);
                $11.addEvent($11.MouseTracker.captureElement, eventParams11.upName, eventParams11.upHandler, true);
                $11.addEvent($11.MouseTracker.captureElement, eventParams11.moveName, eventParams11.moveHandler, true);
            }
        }
    }
    /**
     * Stop capturing pointer events to the tracked element.
     * @private
     * @inner
     */ function releasePointer11(tracker11, pointerType11, pointerCount11) {
        var pointsList11 = tracker11.getActivePointersListByType(pointerType11), eventParams11;
        pointsList11.captureCount -= pointerCount11 || 1;
        if (pointsList11.captureCount === 0) {
            if ($11.Browser.vendor === $11.BROWSERS.IE && $11.Browser.version < 9) tracker11.element.releaseCapture();
            else {
                eventParams11 = getCaptureEventParams11(tracker11, $11.MouseTracker.havePointerEvents ? "pointerevent" : pointerType11);
                // We emulate mouse capture by hanging listeners on the document object.
                //    (Note we listen on the capture phase so the captured handlers will get called first)
                // eslint-disable-next-line no-use-before-define
                if (isInIframe11 && canAccessEvents11(window.top)) $11.removeEvent(window.top, eventParams11.upName, eventParams11.upHandler, true);
                $11.removeEvent($11.MouseTracker.captureElement, eventParams11.moveName, eventParams11.moveHandler, true);
                $11.removeEvent($11.MouseTracker.captureElement, eventParams11.upName, eventParams11.upHandler, true);
            }
        }
    }
    /**
     * Gets a W3C Pointer Events model compatible pointer type string from a DOM pointer event.
     * IE10 used a long integer value, but the W3C specification (and IE11+) use a string "mouse", "touch", "pen", etc.
     * @private
     * @inner
     */ function getPointerType11(event11) {
        var pointerTypeStr11;
        if ($11.MouseTracker.unprefixedPointerEvents) pointerTypeStr11 = event11.pointerType;
        else // IE10
        //  MSPOINTER_TYPE_TOUCH: 0x00000002
        //  MSPOINTER_TYPE_PEN:   0x00000003
        //  MSPOINTER_TYPE_MOUSE: 0x00000004
        switch(event11.pointerType){
            case 0x00000002:
                pointerTypeStr11 = "touch";
                break;
            case 0x00000003:
                pointerTypeStr11 = "pen";
                break;
            case 0x00000004:
                pointerTypeStr11 = "mouse";
                break;
            default:
                pointerTypeStr11 = "";
        }
        return pointerTypeStr11;
    }
    /**
     * @private
     * @inner
     */ function getMouseAbsolute11(event11) {
        return $11.getMousePosition(event11);
    }
    /**
     * @private
     * @inner
     */ function getMouseRelative11(event11, element11) {
        return getPointRelativeToAbsolute11(getMouseAbsolute11(event11), element11);
    }
    /**
     * @private
     * @inner
     */ function getPointRelativeToAbsolute11(point31, element11) {
        var offset11 = $11.getElementOffset(element11);
        return point31.minus(offset11);
    }
    /**
     * @private
     * @inner
     */ function getCenterPoint11(point111, point211) {
        return new $11.Point((point111.x + point211.x) / 2, (point111.y + point211.y) / 2);
    }
    ///////////////////////////////////////////////////////////////////////////////
    // Device-specific DOM event handlers
    ///////////////////////////////////////////////////////////////////////////////
    /**
     * @private
     * @inner
     */ function onClick11(tracker11, event11) {
        if (tracker11.clickHandler) $11.cancelEvent(event11);
    }
    /**
     * @private
     * @inner
     */ function onDblClick11(tracker11, event11) {
        if (tracker11.dblClickHandler) $11.cancelEvent(event11);
    }
    /**
     * @private
     * @inner
     */ function onKeyDown11(tracker11, event11) {
        //$.console.log( "keydown %s %s %s %s %s", event.keyCode, event.charCode, event.ctrlKey, event.shiftKey, event.altKey );
        var propagate11;
        if (tracker11.keyDownHandler) {
            event11 = $11.getEvent(event11);
            propagate11 = tracker11.keyDownHandler({
                eventSource: tracker11,
                keyCode: event11.keyCode ? event11.keyCode : event11.charCode,
                ctrl: event11.ctrlKey,
                shift: event11.shiftKey,
                alt: event11.altKey,
                meta: event11.metaKey,
                originalEvent: event11,
                preventDefaultAction: false,
                userData: tracker11.userData
            });
            if (!propagate11) $11.cancelEvent(event11);
        }
    }
    /**
     * @private
     * @inner
     */ function onKeyUp11(tracker11, event11) {
        //$.console.log( "keyup %s %s %s %s %s", event.keyCode, event.charCode, event.ctrlKey, event.shiftKey, event.altKey );
        var propagate11;
        if (tracker11.keyUpHandler) {
            event11 = $11.getEvent(event11);
            propagate11 = tracker11.keyUpHandler({
                eventSource: tracker11,
                keyCode: event11.keyCode ? event11.keyCode : event11.charCode,
                ctrl: event11.ctrlKey,
                shift: event11.shiftKey,
                alt: event11.altKey,
                meta: event11.metaKey,
                originalEvent: event11,
                preventDefaultAction: false,
                userData: tracker11.userData
            });
            if (!propagate11) $11.cancelEvent(event11);
        }
    }
    /**
     * @private
     * @inner
     */ function onKeyPress11(tracker11, event11) {
        //$.console.log( "keypress %s %s %s %s %s", event.keyCode, event.charCode, event.ctrlKey, event.shiftKey, event.altKey );
        var propagate11;
        if (tracker11.keyHandler) {
            event11 = $11.getEvent(event11);
            propagate11 = tracker11.keyHandler({
                eventSource: tracker11,
                keyCode: event11.keyCode ? event11.keyCode : event11.charCode,
                ctrl: event11.ctrlKey,
                shift: event11.shiftKey,
                alt: event11.altKey,
                meta: event11.metaKey,
                originalEvent: event11,
                preventDefaultAction: false,
                userData: tracker11.userData
            });
            if (!propagate11) $11.cancelEvent(event11);
        }
    }
    /**
     * @private
     * @inner
     */ function onFocus11(tracker11, event11) {
        //console.log( "focus %s", event );
        var propagate11;
        if (tracker11.focusHandler) {
            event11 = $11.getEvent(event11);
            propagate11 = tracker11.focusHandler({
                eventSource: tracker11,
                originalEvent: event11,
                preventDefaultAction: false,
                userData: tracker11.userData
            });
            if (propagate11 === false) $11.cancelEvent(event11);
        }
    }
    /**
     * @private
     * @inner
     */ function onBlur11(tracker11, event11) {
        //console.log( "blur %s", event );
        var propagate11;
        if (tracker11.blurHandler) {
            event11 = $11.getEvent(event11);
            propagate11 = tracker11.blurHandler({
                eventSource: tracker11,
                originalEvent: event11,
                preventDefaultAction: false,
                userData: tracker11.userData
            });
            if (propagate11 === false) $11.cancelEvent(event11);
        }
    }
    /**
     * Handler for 'wheel' events
     *
     * @private
     * @inner
     */ function onWheel11(tracker11, event11) {
        handleWheelEvent11(tracker11, event11, event11);
    }
    /**
     * Handler for 'mousewheel', 'DOMMouseScroll', and 'MozMousePixelScroll' events
     *
     * @private
     * @inner
     */ function onMouseWheel11(tracker11, event11) {
        event11 = $11.getEvent(event11);
        // Simulate a 'wheel' event
        var simulatedEvent11 = {
            target: event11.target || event11.srcElement,
            type: "wheel",
            shiftKey: event11.shiftKey || false,
            clientX: event11.clientX,
            clientY: event11.clientY,
            pageX: event11.pageX ? event11.pageX : event11.clientX,
            pageY: event11.pageY ? event11.pageY : event11.clientY,
            deltaMode: event11.type == "MozMousePixelScroll" ? 0 : 1,
            deltaX: 0,
            deltaZ: 0
        };
        // Calculate deltaY
        if ($11.MouseTracker.wheelEventName == "mousewheel") simulatedEvent11.deltaY = -event11.wheelDelta / $11.DEFAULT_SETTINGS.pixelsPerWheelLine;
        else simulatedEvent11.deltaY = event11.detail;
        handleWheelEvent11(tracker11, simulatedEvent11, event11);
    }
    /**
     * Handles 'wheel' events.
     * The event may be simulated by the legacy mouse wheel event handler (onMouseWheel()).
     *
     * @private
     * @inner
     */ function handleWheelEvent11(tracker11, event11, originalEvent11) {
        var nDelta11 = 0, propagate11;
        // The nDelta variable is gated to provide smooth z-index scrolling
        //   since the mouse wheel allows for substantial deltas meant for rapid
        //   y-index scrolling.
        // event.deltaMode: 0=pixel, 1=line, 2=page
        // TODO: Deltas in pixel mode should be accumulated then a scroll value computed after $.DEFAULT_SETTINGS.pixelsPerWheelLine threshold reached
        nDelta11 = event11.deltaY < 0 ? 1 : -1;
        if (tracker11.scrollHandler) {
            propagate11 = tracker11.scrollHandler({
                eventSource: tracker11,
                pointerType: "mouse",
                position: getMouseRelative11(event11, tracker11.element),
                scroll: nDelta11,
                shift: event11.shiftKey,
                isTouchEvent: false,
                originalEvent: originalEvent11,
                preventDefaultAction: false,
                userData: tracker11.userData
            });
            if (propagate11 === false) $11.cancelEvent(originalEvent11);
        }
    }
    /**
     * @private
     * @inner
     */ function isParentChild11(parent11, child11) {
        if (parent11 === child11) return false;
        while(child11 && child11 !== parent11)child11 = child11.parentNode;
        return child11 === parent11;
    }
    /**
     * Only used on IE 8
     *
     * @private
     * @inner
     */ function onMouseEnter11(tracker11, event11) {
        event11 = $11.getEvent(event11);
        handleMouseEnter11(tracker11, event11);
    }
    /**
     * @private
     * @inner
     */ function onMouseOver11(tracker11, event11) {
        event11 = $11.getEvent(event11);
        if (event11.currentTarget === event11.relatedTarget || isParentChild11(event11.currentTarget, event11.relatedTarget)) return;
        handleMouseEnter11(tracker11, event11);
    }
    /**
     * @private
     * @inner
     */ function handleMouseEnter11(tracker11, event11) {
        var gPoint11 = {
            id: $11.MouseTracker.mousePointerId,
            type: "mouse",
            isPrimary: true,
            currentPos: getMouseAbsolute11(event11),
            currentTime: $11.now()
        };
        updatePointersEnter11(tracker11, event11, [
            gPoint11
        ]);
    }
    /**
     * Only used on IE 8
     *
     * @private
     * @inner
     */ function onMouseLeave11(tracker11, event11) {
        event11 = $11.getEvent(event11);
        handleMouseExit11(tracker11, event11);
    }
    /**
     * @private
     * @inner
     */ function onMouseOut11(tracker11, event11) {
        event11 = $11.getEvent(event11);
        if (event11.currentTarget === event11.relatedTarget || isParentChild11(event11.currentTarget, event11.relatedTarget)) return;
        handleMouseExit11(tracker11, event11);
    }
    /**
     * @private
     * @inner
     */ function handleMouseExit11(tracker11, event11) {
        var gPoint11 = {
            id: $11.MouseTracker.mousePointerId,
            type: "mouse",
            isPrimary: true,
            currentPos: getMouseAbsolute11(event11),
            currentTime: $11.now()
        };
        updatePointersExit11(tracker11, event11, [
            gPoint11
        ]);
    }
    /**
     * Returns a W3C DOM level 3 standard button value given an event.button property:
     *   -1 == none, 0 == primary/left, 1 == middle, 2 == secondary/right, 3 == X1/back, 4 == X2/forward, 5 == eraser (pen)
     * @private
     * @inner
     */ function getStandardizedButton11(button11) {
        if ($11.Browser.vendor === $11.BROWSERS.IE && $11.Browser.version < 9) {
            // On IE 8, 0 == none, 1 == left, 2 == right, 3 == left and right, 4 == middle, 5 == left and middle, 6 == right and middle, 7 == all three
            // TODO: Support chorded (multiple) button presses on IE 8?
            if (button11 === 1) return 0;
            else if (button11 === 2) return 2;
            else if (button11 === 4) return 1;
            else return -1;
        } else return button11;
    }
    /**
     * @private
     * @inner
     */ function onMouseDown11(tracker11, event11) {
        var gPoint11;
        event11 = $11.getEvent(event11);
        gPoint11 = {
            id: $11.MouseTracker.mousePointerId,
            type: "mouse",
            isPrimary: true,
            currentPos: getMouseAbsolute11(event11),
            currentTime: $11.now()
        };
        if (updatePointersDown11(tracker11, event11, [
            gPoint11
        ], getStandardizedButton11(event11.button))) {
            $11.stopEvent(event11);
            capturePointer11(tracker11, "mouse");
        }
        if (tracker11.clickHandler || tracker11.dblClickHandler || tracker11.pressHandler || tracker11.dragHandler || tracker11.dragEndHandler) $11.cancelEvent(event11);
    }
    /**
     * @private
     * @inner
     */ function onMouseUp11(tracker11, event11) {
        handleMouseUp11(tracker11, event11);
    }
    /**
     * This handler is attached to the window object (on the capture phase) to emulate mouse capture.
     * onMouseUp is still attached to the tracked element, so stop propagation to avoid processing twice.
     *
     * @private
     * @inner
     */ function onMouseUpCaptured11(tracker11, event11) {
        handleMouseUp11(tracker11, event11);
        $11.stopEvent(event11);
    }
    /**
     * @private
     * @inner
     */ function handleMouseUp11(tracker11, event11) {
        var gPoint11;
        event11 = $11.getEvent(event11);
        gPoint11 = {
            id: $11.MouseTracker.mousePointerId,
            type: "mouse",
            isPrimary: true,
            currentPos: getMouseAbsolute11(event11),
            currentTime: $11.now()
        };
        if (updatePointersUp11(tracker11, event11, [
            gPoint11
        ], getStandardizedButton11(event11.button))) releasePointer11(tracker11, "mouse");
    }
    /**
     * @private
     * @inner
     */ function onMouseMove11(tracker11, event11) {
        handleMouseMove11(tracker11, event11);
    }
    /**
     * This handler is attached to the window object (on the capture phase) to emulate mouse capture.
     * onMouseMove is still attached to the tracked element, so stop propagation to avoid processing twice.
     *
     * @private
     * @inner
     */ function onMouseMoveCaptured11(tracker11, event11) {
        handleMouseMove11(tracker11, event11);
        $11.stopEvent(event11);
    }
    /**
     * @private
     * @inner
     */ function handleMouseMove11(tracker11, event11) {
        var gPoint11;
        event11 = $11.getEvent(event11);
        gPoint11 = {
            id: $11.MouseTracker.mousePointerId,
            type: "mouse",
            isPrimary: true,
            currentPos: getMouseAbsolute11(event11),
            currentTime: $11.now()
        };
        updatePointersMove11(tracker11, event11, [
            gPoint11
        ]);
    }
    /**
     * @private
     * @inner
     */ function abortContacts11(tracker11, event11, pointsList11) {
        var i11, gPointCount11 = pointsList11.getLength(), abortGPoints11 = [];
        // Check contact count for hoverable pointer types before aborting
        if (pointsList11.type === "touch" || pointsList11.contacts > 0) {
            for(i11 = 0; i11 < gPointCount11; i11++)abortGPoints11.push(pointsList11.getByIndex(i11));
            if (abortGPoints11.length > 0) {
                // simulate touchend/mouseup
                updatePointersUp11(tracker11, event11, abortGPoints11, 0); // 0 means primary button press/release or touch contact
                // release pointer capture
                pointsList11.captureCount = 1;
                releasePointer11(tracker11, pointsList11.type);
                // simulate touchleave/mouseout
                updatePointersExit11(tracker11, event11, abortGPoints11);
            }
        }
    }
    /**
     * @private
     * @inner
     */ function onTouchStart11(tracker11, event11) {
        var time11, i11, j11, touchCount11 = event11.changedTouches.length, gPoints11 = [], parentGPoints11, pointsList11 = tracker11.getActivePointersListByType("touch");
        time11 = $11.now();
        if (pointsList11.getLength() > event11.touches.length - touchCount11) {
            $11.console.warn("Tracked touch contact count doesn't match event.touches.length. Removing all tracked touch pointers.");
            abortContacts11(tracker11, event11, pointsList11);
        }
        for(i11 = 0; i11 < touchCount11; i11++)gPoints11.push({
            id: event11.changedTouches[i11].identifier,
            type: "touch",
            // isPrimary not set - let the updatePointers functions determine it
            currentPos: getMouseAbsolute11(event11.changedTouches[i11]),
            currentTime: time11
        });
        // simulate touchenter on our tracked element
        updatePointersEnter11(tracker11, event11, gPoints11);
        // simulate touchenter on our tracked element's tracked ancestor elements
        for(i11 = 0; i11 < MOUSETRACKERS11.length; i11++)if (MOUSETRACKERS11[i11] !== tracker11 && MOUSETRACKERS11[i11].isTracking() && isParentChild11(MOUSETRACKERS11[i11].element, tracker11.element)) {
            parentGPoints11 = [];
            for(j11 = 0; j11 < touchCount11; j11++)parentGPoints11.push({
                id: event11.changedTouches[j11].identifier,
                type: "touch",
                // isPrimary not set - let the updatePointers functions determine it
                currentPos: getMouseAbsolute11(event11.changedTouches[j11]),
                currentTime: time11
            });
            updatePointersEnter11(MOUSETRACKERS11[i11], event11, parentGPoints11);
        }
        if (updatePointersDown11(tracker11, event11, gPoints11, 0)) {
            $11.stopEvent(event11);
            capturePointer11(tracker11, "touch", touchCount11);
        }
        $11.cancelEvent(event11);
    }
    /**
     * @private
     * @inner
     */ function onTouchEnd11(tracker11, event11) {
        handleTouchEnd11(tracker11, event11);
    }
    /**
     * This handler is attached to the window object (on the capture phase) to emulate pointer capture.
     * onTouchEnd is still attached to the tracked element, so stop propagation to avoid processing twice.
     *
     * @private
     * @inner
     */ function onTouchEndCaptured11(tracker11, event11) {
        handleTouchEnd11(tracker11, event11);
        $11.stopEvent(event11);
    }
    /**
     * @private
     * @inner
     */ function handleTouchEnd11(tracker11, event11) {
        var time11, i11, j11, touchCount11 = event11.changedTouches.length, gPoints11 = [], parentGPoints11;
        time11 = $11.now();
        for(i11 = 0; i11 < touchCount11; i11++)gPoints11.push({
            id: event11.changedTouches[i11].identifier,
            type: "touch",
            // isPrimary not set - let the updatePointers functions determine it
            currentPos: getMouseAbsolute11(event11.changedTouches[i11]),
            currentTime: time11
        });
        if (updatePointersUp11(tracker11, event11, gPoints11, 0)) releasePointer11(tracker11, "touch", touchCount11);
        // simulate touchleave on our tracked element
        updatePointersExit11(tracker11, event11, gPoints11);
        // simulate touchleave on our tracked element's tracked ancestor elements
        for(i11 = 0; i11 < MOUSETRACKERS11.length; i11++)if (MOUSETRACKERS11[i11] !== tracker11 && MOUSETRACKERS11[i11].isTracking() && isParentChild11(MOUSETRACKERS11[i11].element, tracker11.element)) {
            parentGPoints11 = [];
            for(j11 = 0; j11 < touchCount11; j11++)parentGPoints11.push({
                id: event11.changedTouches[j11].identifier,
                type: "touch",
                // isPrimary not set - let the updatePointers functions determine it
                currentPos: getMouseAbsolute11(event11.changedTouches[j11]),
                currentTime: time11
            });
            updatePointersExit11(MOUSETRACKERS11[i11], event11, parentGPoints11);
        }
        $11.cancelEvent(event11);
    }
    /**
     * @private
     * @inner
     */ function onTouchMove11(tracker11, event11) {
        handleTouchMove11(tracker11, event11);
    }
    /**
     * This handler is attached to the window object (on the capture phase) to emulate pointer capture.
     * onTouchMove is still attached to the tracked element, so stop propagation to avoid processing twice.
     *
     * @private
     * @inner
     */ function onTouchMoveCaptured11(tracker11, event11) {
        handleTouchMove11(tracker11, event11);
        $11.stopEvent(event11);
    }
    /**
     * @private
     * @inner
     */ function handleTouchMove11(tracker11, event11) {
        var i11, touchCount11 = event11.changedTouches.length, gPoints11 = [];
        for(i11 = 0; i11 < touchCount11; i11++)gPoints11.push({
            id: event11.changedTouches[i11].identifier,
            type: "touch",
            // isPrimary not set - let the updatePointers functions determine it
            currentPos: getMouseAbsolute11(event11.changedTouches[i11]),
            currentTime: $11.now()
        });
        updatePointersMove11(tracker11, event11, gPoints11);
        $11.cancelEvent(event11);
    }
    /**
     * @private
     * @inner
     */ function onTouchCancel11(tracker11, event11) {
        var pointsList11 = tracker11.getActivePointersListByType("touch");
        abortContacts11(tracker11, event11, pointsList11);
    }
    /**
     * @private
     * @inner
     */ function onGestureStart11(tracker11, event11) {
        event11.stopPropagation();
        event11.preventDefault();
        return false;
    }
    /**
     * @private
     * @inner
     */ function onGestureChange11(tracker11, event11) {
        event11.stopPropagation();
        event11.preventDefault();
        return false;
    }
    /**
     * @private
     * @inner
     */ function onPointerOver11(tracker11, event11) {
        var gPoint11;
        if (event11.currentTarget === event11.relatedTarget || isParentChild11(event11.currentTarget, event11.relatedTarget)) return;
        gPoint11 = {
            id: event11.pointerId,
            type: getPointerType11(event11),
            isPrimary: event11.isPrimary,
            currentPos: getMouseAbsolute11(event11),
            currentTime: $11.now()
        };
        updatePointersEnter11(tracker11, event11, [
            gPoint11
        ]);
    }
    /**
     * @private
     * @inner
     */ function onPointerOut11(tracker11, event11) {
        var gPoint11;
        if (event11.currentTarget === event11.relatedTarget || isParentChild11(event11.currentTarget, event11.relatedTarget)) return;
        gPoint11 = {
            id: event11.pointerId,
            type: getPointerType11(event11),
            isPrimary: event11.isPrimary,
            currentPos: getMouseAbsolute11(event11),
            currentTime: $11.now()
        };
        updatePointersExit11(tracker11, event11, [
            gPoint11
        ]);
    }
    /**
     * @private
     * @inner
     */ function onPointerDown11(tracker11, event11) {
        var gPoint11;
        gPoint11 = {
            id: event11.pointerId,
            type: getPointerType11(event11),
            isPrimary: event11.isPrimary,
            currentPos: getMouseAbsolute11(event11),
            currentTime: $11.now()
        };
        if (updatePointersDown11(tracker11, event11, [
            gPoint11
        ], event11.button)) {
            $11.stopEvent(event11);
            capturePointer11(tracker11, gPoint11.type);
        }
        if (tracker11.clickHandler || tracker11.dblClickHandler || tracker11.pressHandler || tracker11.dragHandler || tracker11.dragEndHandler || tracker11.pinchHandler) $11.cancelEvent(event11);
    }
    /**
     * @private
     * @inner
     */ function onPointerUp11(tracker11, event11) {
        handlePointerUp11(tracker11, event11);
    }
    /**
     * This handler is attached to the window object (on the capture phase) to emulate mouse capture.
     * onPointerUp is still attached to the tracked element, so stop propagation to avoid processing twice.
     *
     * @private
     * @inner
     */ function onPointerUpCaptured11(tracker11, event11) {
        var pointsList11 = tracker11.getActivePointersListByType(getPointerType11(event11));
        if (pointsList11.getById(event11.pointerId)) handlePointerUp11(tracker11, event11);
        $11.stopEvent(event11);
    }
    /**
     * @private
     * @inner
     */ function handlePointerUp11(tracker11, event11) {
        var gPoint11;
        gPoint11 = {
            id: event11.pointerId,
            type: getPointerType11(event11),
            isPrimary: event11.isPrimary,
            currentPos: getMouseAbsolute11(event11),
            currentTime: $11.now()
        };
        if (updatePointersUp11(tracker11, event11, [
            gPoint11
        ], event11.button)) releasePointer11(tracker11, gPoint11.type);
    }
    /**
     * @private
     * @inner
     */ function onPointerMove11(tracker11, event11) {
        handlePointerMove11(tracker11, event11);
    }
    /**
     * This handler is attached to the window object (on the capture phase) to emulate mouse capture.
     * onPointerMove is still attached to the tracked element, so stop propagation to avoid processing twice.
     *
     * @private
     * @inner
     */ function onPointerMoveCaptured11(tracker11, event11) {
        var pointsList11 = tracker11.getActivePointersListByType(getPointerType11(event11));
        if (pointsList11.getById(event11.pointerId)) handlePointerMove11(tracker11, event11);
        $11.stopEvent(event11);
    }
    /**
     * @private
     * @inner
     */ function handlePointerMove11(tracker11, event11) {
        // Pointer changed coordinates, button state, pressure, tilt, or contact geometry (e.g. width and height)
        var gPoint11;
        gPoint11 = {
            id: event11.pointerId,
            type: getPointerType11(event11),
            isPrimary: event11.isPrimary,
            currentPos: getMouseAbsolute11(event11),
            currentTime: $11.now()
        };
        updatePointersMove11(tracker11, event11, [
            gPoint11
        ]);
    }
    /**
     * @private
     * @inner
     */ function onPointerCancel11(tracker11, event11) {
        var gPoint11;
        gPoint11 = {
            id: event11.pointerId,
            type: getPointerType11(event11)
        };
        updatePointersCancel11(tracker11, event11, [
            gPoint11
        ]);
    }
    ///////////////////////////////////////////////////////////////////////////////
    // Device-agnostic DOM event handlers
    ///////////////////////////////////////////////////////////////////////////////
    /**
     * @function
     * @private
     * @inner
     * @param {OpenSeadragon.MouseTracker.GesturePointList} pointsList
     *     The GesturePointList to track the pointer in.
     * @param {OpenSeadragon.MouseTracker.GesturePoint} gPoint
     *      Gesture point to track.
     * @returns {Number} Number of gesture points in pointsList.
     */ function startTrackingPointer11(pointsList11, gPoint11) {
        // If isPrimary is not known for the pointer then set it according to our rules:
        //    true if the first pointer in the gesture, otherwise false
        if (!gPoint11.hasOwnProperty("isPrimary")) {
            if (pointsList11.getLength() === 0) gPoint11.isPrimary = true;
            else gPoint11.isPrimary = false;
        }
        gPoint11.speed = 0;
        gPoint11.direction = 0;
        gPoint11.contactPos = gPoint11.currentPos;
        gPoint11.contactTime = gPoint11.currentTime;
        gPoint11.lastPos = gPoint11.currentPos;
        gPoint11.lastTime = gPoint11.currentTime;
        return pointsList11.add(gPoint11);
    }
    /**
     * @function
     * @private
     * @inner
     * @param {OpenSeadragon.MouseTracker.GesturePointList} pointsList
     *     The GesturePointList to stop tracking the pointer on.
     * @param {OpenSeadragon.MouseTracker.GesturePoint} gPoint
     *      Gesture point to stop tracking.
     * @returns {Number} Number of gesture points in pointsList.
     */ function stopTrackingPointer11(pointsList11, gPoint11) {
        var listLength11, primaryPoint11;
        if (pointsList11.getById(gPoint11.id)) {
            listLength11 = pointsList11.removeById(gPoint11.id);
            // If isPrimary is not known for the pointer and we just removed the primary pointer from the list then we need to set another pointer as primary
            if (!gPoint11.hasOwnProperty("isPrimary")) {
                primaryPoint11 = pointsList11.getPrimary();
                if (!primaryPoint11) {
                    primaryPoint11 = pointsList11.getByIndex(0);
                    if (primaryPoint11) primaryPoint11.isPrimary = true;
                }
            }
        } else listLength11 = pointsList11.getLength();
        return listLength11;
    }
    /**
     * @function
     * @private
     * @inner
     * @param {OpenSeadragon.MouseTracker} tracker
     *     A reference to the MouseTracker instance.
     * @param {Object} event
     *     A reference to the originating DOM event.
     * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gPoints
     *      Gesture points associated with the event.
     */ function updatePointersEnter11(tracker11, event11, gPoints11) {
        var pointsList11 = tracker11.getActivePointersListByType(gPoints11[0].type), i11, gPointCount11 = gPoints11.length, curGPoint11, updateGPoint11, propagate11;
        for(i11 = 0; i11 < gPointCount11; i11++){
            curGPoint11 = gPoints11[i11];
            updateGPoint11 = pointsList11.getById(curGPoint11.id);
            if (updateGPoint11) {
                // Already tracking the pointer...update it
                updateGPoint11.insideElement = true;
                updateGPoint11.lastPos = updateGPoint11.currentPos;
                updateGPoint11.lastTime = updateGPoint11.currentTime;
                updateGPoint11.currentPos = curGPoint11.currentPos;
                updateGPoint11.currentTime = curGPoint11.currentTime;
                curGPoint11 = updateGPoint11;
            } else {
                // Initialize for tracking and add to the tracking list
                curGPoint11.captured = false;
                curGPoint11.insideElementPressed = false;
                curGPoint11.insideElement = true;
                startTrackingPointer11(pointsList11, curGPoint11);
            }
            // Enter
            if (tracker11.enterHandler) {
                propagate11 = tracker11.enterHandler({
                    eventSource: tracker11,
                    pointerType: curGPoint11.type,
                    position: getPointRelativeToAbsolute11(curGPoint11.currentPos, tracker11.element),
                    buttons: pointsList11.buttons,
                    pointers: tracker11.getActivePointerCount(),
                    insideElementPressed: curGPoint11.insideElementPressed,
                    buttonDownAny: pointsList11.buttons !== 0,
                    isTouchEvent: curGPoint11.type === "touch",
                    originalEvent: event11,
                    preventDefaultAction: false,
                    userData: tracker11.userData
                });
                if (propagate11 === false) $11.cancelEvent(event11);
            }
        }
    }
    /**
     * @function
     * @private
     * @inner
     * @param {OpenSeadragon.MouseTracker} tracker
     *     A reference to the MouseTracker instance.
     * @param {Object} event
     *     A reference to the originating DOM event.
     * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gPoints
     *      Gesture points associated with the event.
     */ function updatePointersExit11(tracker11, event11, gPoints11) {
        var pointsList11 = tracker11.getActivePointersListByType(gPoints11[0].type), i11, gPointCount11 = gPoints11.length, curGPoint11, updateGPoint11, propagate11;
        for(i11 = 0; i11 < gPointCount11; i11++){
            curGPoint11 = gPoints11[i11];
            updateGPoint11 = pointsList11.getById(curGPoint11.id);
            if (updateGPoint11) {
                // Already tracking the pointer. If captured then update it, else stop tracking it
                if (updateGPoint11.captured) {
                    updateGPoint11.insideElement = false;
                    updateGPoint11.lastPos = updateGPoint11.currentPos;
                    updateGPoint11.lastTime = updateGPoint11.currentTime;
                    updateGPoint11.currentPos = curGPoint11.currentPos;
                    updateGPoint11.currentTime = curGPoint11.currentTime;
                } else stopTrackingPointer11(pointsList11, updateGPoint11);
                curGPoint11 = updateGPoint11;
            }
            // Exit
            if (tracker11.exitHandler) {
                propagate11 = tracker11.exitHandler({
                    eventSource: tracker11,
                    pointerType: curGPoint11.type,
                    position: getPointRelativeToAbsolute11(curGPoint11.currentPos, tracker11.element),
                    buttons: pointsList11.buttons,
                    pointers: tracker11.getActivePointerCount(),
                    insideElementPressed: updateGPoint11 ? updateGPoint11.insideElementPressed : false,
                    buttonDownAny: pointsList11.buttons !== 0,
                    isTouchEvent: curGPoint11.type === "touch",
                    originalEvent: event11,
                    preventDefaultAction: false,
                    userData: tracker11.userData
                });
                if (propagate11 === false) $11.cancelEvent(event11);
            }
        }
    }
    /**
     * @function
     * @private
     * @inner
     * @param {OpenSeadragon.MouseTracker} tracker
     *     A reference to the MouseTracker instance.
     * @param {Object} event
     *     A reference to the originating DOM event.
     * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gPoints
     *      Gesture points associated with the event.
     * @param {Number} buttonChanged
     *      The button involved in the event: -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
     *      Note on chorded button presses (a button pressed when another button is already pressed): In the W3C Pointer Events model,
     *      only one pointerdown/pointerup event combo is fired. Chorded button state changes instead fire pointermove events.
     *
     * @returns {Boolean} True if pointers should be captured to the tracked element, otherwise false.
     */ function updatePointersDown11(tracker11, event11, gPoints11, buttonChanged11) {
        var delegate11 = THIS11[tracker11.hash], propagate11, pointsList11 = tracker11.getActivePointersListByType(gPoints11[0].type), i11, gPointCount11 = gPoints11.length, curGPoint11, updateGPoint11;
        if (typeof event11.buttons !== "undefined") pointsList11.buttons = event11.buttons;
        else if ($11.Browser.vendor === $11.BROWSERS.IE && $11.Browser.version < 9) {
            if (buttonChanged11 === 0) // Primary
            pointsList11.buttons += 1;
            else if (buttonChanged11 === 1) // Aux
            pointsList11.buttons += 4;
            else if (buttonChanged11 === 2) // Secondary
            pointsList11.buttons += 2;
            else if (buttonChanged11 === 3) // X1 (Back)
            pointsList11.buttons += 8;
            else if (buttonChanged11 === 4) // X2 (Forward)
            pointsList11.buttons += 16;
            else if (buttonChanged11 === 5) // Pen Eraser
            pointsList11.buttons += 32;
        } else {
            if (buttonChanged11 === 0) // Primary
            pointsList11.buttons |= 1;
            else if (buttonChanged11 === 1) // Aux
            pointsList11.buttons |= 4;
            else if (buttonChanged11 === 2) // Secondary
            pointsList11.buttons |= 2;
            else if (buttonChanged11 === 3) // X1 (Back)
            pointsList11.buttons |= 8;
            else if (buttonChanged11 === 4) // X2 (Forward)
            pointsList11.buttons |= 16;
            else if (buttonChanged11 === 5) // Pen Eraser
            pointsList11.buttons |= 32;
        }
        // Some pointers may steal control from another pointer without firing the appropriate release events
        // e.g. Touching a screen while click-dragging with certain mice.
        var otherPointsLists11 = tracker11.getActivePointersListsExceptType(gPoints11[0].type);
        for(i11 = 0; i11 < otherPointsLists11.length; i11++)//If another pointer has contact, simulate the release
        abortContacts11(tracker11, event11, otherPointsLists11[i11]); // No-op if no active pointer
        // Only capture and track primary button, pen, and touch contacts
        if (buttonChanged11 !== 0) {
            // Aux Press
            if (tracker11.nonPrimaryPressHandler) {
                propagate11 = tracker11.nonPrimaryPressHandler({
                    eventSource: tracker11,
                    pointerType: gPoints11[0].type,
                    position: getPointRelativeToAbsolute11(gPoints11[0].currentPos, tracker11.element),
                    button: buttonChanged11,
                    buttons: pointsList11.buttons,
                    isTouchEvent: gPoints11[0].type === "touch",
                    originalEvent: event11,
                    preventDefaultAction: false,
                    userData: tracker11.userData
                });
                if (propagate11 === false) $11.cancelEvent(event11);
            }
            return false;
        }
        for(i11 = 0; i11 < gPointCount11; i11++){
            curGPoint11 = gPoints11[i11];
            updateGPoint11 = pointsList11.getById(curGPoint11.id);
            if (updateGPoint11) {
                // Already tracking the pointer...update it
                updateGPoint11.captured = true;
                updateGPoint11.insideElementPressed = true;
                updateGPoint11.insideElement = true;
                updateGPoint11.contactPos = curGPoint11.currentPos;
                updateGPoint11.contactTime = curGPoint11.currentTime;
                updateGPoint11.lastPos = updateGPoint11.currentPos;
                updateGPoint11.lastTime = updateGPoint11.currentTime;
                updateGPoint11.currentPos = curGPoint11.currentPos;
                updateGPoint11.currentTime = curGPoint11.currentTime;
                curGPoint11 = updateGPoint11;
            } else {
                // Initialize for tracking and add to the tracking list (no pointerover or pointermove event occurred before this)
                curGPoint11.captured = true;
                curGPoint11.insideElementPressed = true;
                curGPoint11.insideElement = true;
                startTrackingPointer11(pointsList11, curGPoint11);
            }
            pointsList11.addContact();
            //$.console.log('contacts++ ', pointsList.contacts);
            if (tracker11.dragHandler || tracker11.dragEndHandler || tracker11.pinchHandler) $11.MouseTracker.gesturePointVelocityTracker.addPoint(tracker11, curGPoint11);
            if (pointsList11.contacts === 1) // Press
            {
                if (tracker11.pressHandler) {
                    propagate11 = tracker11.pressHandler({
                        eventSource: tracker11,
                        pointerType: curGPoint11.type,
                        position: getPointRelativeToAbsolute11(curGPoint11.contactPos, tracker11.element),
                        buttons: pointsList11.buttons,
                        isTouchEvent: curGPoint11.type === "touch",
                        originalEvent: event11,
                        preventDefaultAction: false,
                        userData: tracker11.userData
                    });
                    if (propagate11 === false) $11.cancelEvent(event11);
                }
            } else if (pointsList11.contacts === 2) {
                if (tracker11.pinchHandler && curGPoint11.type === "touch") {
                    // Initialize for pinch
                    delegate11.pinchGPoints = pointsList11.asArray();
                    delegate11.lastPinchDist = delegate11.currentPinchDist = delegate11.pinchGPoints[0].currentPos.distanceTo(delegate11.pinchGPoints[1].currentPos);
                    delegate11.lastPinchCenter = delegate11.currentPinchCenter = getCenterPoint11(delegate11.pinchGPoints[0].currentPos, delegate11.pinchGPoints[1].currentPos);
                }
            }
        }
        return true;
    }
    /**
     * @function
     * @private
     * @inner
     * @param {OpenSeadragon.MouseTracker} tracker
     *     A reference to the MouseTracker instance.
     * @param {Object} event
     *     A reference to the originating DOM event.
     * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gPoints
     *      Gesture points associated with the event.
     * @param {Number} buttonChanged
     *      The button involved in the event: -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
     *      Note on chorded button presses (a button pressed when another button is already pressed): In the W3C Pointer Events model,
     *      only one pointerdown/pointerup event combo is fired. Chorded button state changes instead fire pointermove events.
     *
     * @returns {Boolean} True if pointer capture should be released from the tracked element, otherwise false.
     */ function updatePointersUp11(tracker11, event11, gPoints11, buttonChanged11) {
        var delegate11 = THIS11[tracker11.hash], pointsList11 = tracker11.getActivePointersListByType(gPoints11[0].type), propagate11, releasePoint11, releaseTime11, i11, gPointCount11 = gPoints11.length, curGPoint11, updateGPoint11, releaseCapture11 = false, wasCaptured11 = false, quick11;
        if (typeof event11.buttons !== "undefined") pointsList11.buttons = event11.buttons;
        else if ($11.Browser.vendor === $11.BROWSERS.IE && $11.Browser.version < 9) {
            if (buttonChanged11 === 0) // Primary
            pointsList11.buttons -= 1;
            else if (buttonChanged11 === 1) // Aux
            pointsList11.buttons -= 4;
            else if (buttonChanged11 === 2) // Secondary
            pointsList11.buttons -= 2;
            else if (buttonChanged11 === 3) // X1 (Back)
            pointsList11.buttons -= 8;
            else if (buttonChanged11 === 4) // X2 (Forward)
            pointsList11.buttons -= 16;
            else if (buttonChanged11 === 5) // Pen Eraser
            pointsList11.buttons -= 32;
        } else {
            if (buttonChanged11 === 0) // Primary
            pointsList11.buttons ^= -2;
            else if (buttonChanged11 === 1) // Aux
            pointsList11.buttons ^= -5;
            else if (buttonChanged11 === 2) // Secondary
            pointsList11.buttons ^= -3;
            else if (buttonChanged11 === 3) // X1 (Back)
            pointsList11.buttons ^= -9;
            else if (buttonChanged11 === 4) // X2 (Forward)
            pointsList11.buttons ^= -17;
            else if (buttonChanged11 === 5) // Pen Eraser
            pointsList11.buttons ^= -33;
        }
        // Only capture and track primary button, pen, and touch contacts
        if (buttonChanged11 !== 0) {
            // Aux Release
            if (tracker11.nonPrimaryReleaseHandler) {
                propagate11 = tracker11.nonPrimaryReleaseHandler({
                    eventSource: tracker11,
                    pointerType: gPoints11[0].type,
                    position: getPointRelativeToAbsolute11(gPoints11[0].currentPos, tracker11.element),
                    button: buttonChanged11,
                    buttons: pointsList11.buttons,
                    isTouchEvent: gPoints11[0].type === "touch",
                    originalEvent: event11,
                    preventDefaultAction: false,
                    userData: tracker11.userData
                });
                if (propagate11 === false) $11.cancelEvent(event11);
            }
            // A primary mouse button may have been released while the non-primary button was down
            var otherPointsList11 = tracker11.getActivePointersListByType("mouse");
            // Stop tracking the mouse; see https://github.com/openseadragon/openseadragon/pull/1223
            abortContacts11(tracker11, event11, otherPointsList11); // No-op if no active pointer
            return false;
        }
        for(i11 = 0; i11 < gPointCount11; i11++){
            curGPoint11 = gPoints11[i11];
            updateGPoint11 = pointsList11.getById(curGPoint11.id);
            if (updateGPoint11) {
                // Update the pointer, stop tracking it if not still in this element
                if (updateGPoint11.captured) {
                    updateGPoint11.captured = false;
                    releaseCapture11 = true;
                    wasCaptured11 = true;
                }
                updateGPoint11.lastPos = updateGPoint11.currentPos;
                updateGPoint11.lastTime = updateGPoint11.currentTime;
                updateGPoint11.currentPos = curGPoint11.currentPos;
                updateGPoint11.currentTime = curGPoint11.currentTime;
                if (!updateGPoint11.insideElement) stopTrackingPointer11(pointsList11, updateGPoint11);
                releasePoint11 = updateGPoint11.currentPos;
                releaseTime11 = updateGPoint11.currentTime;
                if (wasCaptured11) {
                    // Pointer was activated in our element but could have been removed in any element since events are captured to our element
                    pointsList11.removeContact();
                    //$.console.log('contacts-- ', pointsList.contacts);
                    if (tracker11.dragHandler || tracker11.dragEndHandler || tracker11.pinchHandler) $11.MouseTracker.gesturePointVelocityTracker.removePoint(tracker11, updateGPoint11);
                    if (pointsList11.contacts === 0) {
                        // Release (pressed in our element)
                        if (tracker11.releaseHandler) {
                            propagate11 = tracker11.releaseHandler({
                                eventSource: tracker11,
                                pointerType: updateGPoint11.type,
                                position: getPointRelativeToAbsolute11(releasePoint11, tracker11.element),
                                buttons: pointsList11.buttons,
                                insideElementPressed: updateGPoint11.insideElementPressed,
                                insideElementReleased: updateGPoint11.insideElement,
                                isTouchEvent: updateGPoint11.type === "touch",
                                originalEvent: event11,
                                preventDefaultAction: false,
                                userData: tracker11.userData
                            });
                            if (propagate11 === false) $11.cancelEvent(event11);
                        }
                        // Drag End
                        if (tracker11.dragEndHandler && !updateGPoint11.currentPos.equals(updateGPoint11.contactPos)) {
                            propagate11 = tracker11.dragEndHandler({
                                eventSource: tracker11,
                                pointerType: updateGPoint11.type,
                                position: getPointRelativeToAbsolute11(updateGPoint11.currentPos, tracker11.element),
                                speed: updateGPoint11.speed,
                                direction: updateGPoint11.direction,
                                shift: event11.shiftKey,
                                isTouchEvent: updateGPoint11.type === "touch",
                                originalEvent: event11,
                                preventDefaultAction: false,
                                userData: tracker11.userData
                            });
                            if (propagate11 === false) $11.cancelEvent(event11);
                        }
                        // Click / Double-Click
                        if ((tracker11.clickHandler || tracker11.dblClickHandler) && updateGPoint11.insideElement) {
                            quick11 = releaseTime11 - updateGPoint11.contactTime <= tracker11.clickTimeThreshold && updateGPoint11.contactPos.distanceTo(releasePoint11) <= tracker11.clickDistThreshold;
                            // Click
                            if (tracker11.clickHandler) {
                                propagate11 = tracker11.clickHandler({
                                    eventSource: tracker11,
                                    pointerType: updateGPoint11.type,
                                    position: getPointRelativeToAbsolute11(updateGPoint11.currentPos, tracker11.element),
                                    quick: quick11,
                                    shift: event11.shiftKey,
                                    isTouchEvent: updateGPoint11.type === "touch",
                                    originalEvent: event11,
                                    preventDefaultAction: false,
                                    userData: tracker11.userData
                                });
                                if (propagate11 === false) $11.cancelEvent(event11);
                            }
                            // Double-Click
                            if (tracker11.dblClickHandler && quick11) {
                                pointsList11.clicks++;
                                if (pointsList11.clicks === 1) {
                                    delegate11.lastClickPos = releasePoint11;
                                    /*jshint loopfunc:true*/ delegate11.dblClickTimeOut = setTimeout(function() {
                                        pointsList11.clicks = 0;
                                    }, tracker11.dblClickTimeThreshold);
                                /*jshint loopfunc:false*/ } else if (pointsList11.clicks === 2) {
                                    clearTimeout(delegate11.dblClickTimeOut);
                                    pointsList11.clicks = 0;
                                    if (delegate11.lastClickPos.distanceTo(releasePoint11) <= tracker11.dblClickDistThreshold) {
                                        propagate11 = tracker11.dblClickHandler({
                                            eventSource: tracker11,
                                            pointerType: updateGPoint11.type,
                                            position: getPointRelativeToAbsolute11(updateGPoint11.currentPos, tracker11.element),
                                            shift: event11.shiftKey,
                                            isTouchEvent: updateGPoint11.type === "touch",
                                            originalEvent: event11,
                                            preventDefaultAction: false,
                                            userData: tracker11.userData
                                        });
                                        if (propagate11 === false) $11.cancelEvent(event11);
                                    }
                                    delegate11.lastClickPos = null;
                                }
                            }
                        }
                    } else if (pointsList11.contacts === 2) {
                        if (tracker11.pinchHandler && updateGPoint11.type === "touch") {
                            // Reset for pinch
                            delegate11.pinchGPoints = pointsList11.asArray();
                            delegate11.lastPinchDist = delegate11.currentPinchDist = delegate11.pinchGPoints[0].currentPos.distanceTo(delegate11.pinchGPoints[1].currentPos);
                            delegate11.lastPinchCenter = delegate11.currentPinchCenter = getCenterPoint11(delegate11.pinchGPoints[0].currentPos, delegate11.pinchGPoints[1].currentPos);
                        }
                    }
                } else // Pointer was activated in another element but removed in our element
                // Release (pressed in another element)
                if (tracker11.releaseHandler) {
                    propagate11 = tracker11.releaseHandler({
                        eventSource: tracker11,
                        pointerType: updateGPoint11.type,
                        position: getPointRelativeToAbsolute11(releasePoint11, tracker11.element),
                        buttons: pointsList11.buttons,
                        insideElementPressed: updateGPoint11.insideElementPressed,
                        insideElementReleased: updateGPoint11.insideElement,
                        isTouchEvent: updateGPoint11.type === "touch",
                        originalEvent: event11,
                        preventDefaultAction: false,
                        userData: tracker11.userData
                    });
                    if (propagate11 === false) $11.cancelEvent(event11);
                }
            }
        }
        return releaseCapture11;
    }
    /**
     * Call when pointer(s) change coordinates, button state, pressure, tilt, or contact geometry (e.g. width and height)
     *
     * @function
     * @private
     * @inner
     * @param {OpenSeadragon.MouseTracker} tracker
     *     A reference to the MouseTracker instance.
     * @param {Object} event
     *     A reference to the originating DOM event.
     * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gPoints
     *      Gesture points associated with the event.
     */ function updatePointersMove11(tracker11, event11, gPoints11) {
        var delegate11 = THIS11[tracker11.hash], pointsList11 = tracker11.getActivePointersListByType(gPoints11[0].type), i11, gPointCount11 = gPoints11.length, curGPoint11, updateGPoint11, gPointArray11, delta11, propagate11;
        if (typeof event11.buttons !== "undefined") pointsList11.buttons = event11.buttons;
        for(i11 = 0; i11 < gPointCount11; i11++){
            curGPoint11 = gPoints11[i11];
            updateGPoint11 = pointsList11.getById(curGPoint11.id);
            if (updateGPoint11) {
                // Already tracking the pointer...update it
                if (curGPoint11.hasOwnProperty("isPrimary")) updateGPoint11.isPrimary = curGPoint11.isPrimary;
                updateGPoint11.lastPos = updateGPoint11.currentPos;
                updateGPoint11.lastTime = updateGPoint11.currentTime;
                updateGPoint11.currentPos = curGPoint11.currentPos;
                updateGPoint11.currentTime = curGPoint11.currentTime;
            } else {
                // Initialize for tracking and add to the tracking list (no pointerover or pointerdown event occurred before this)
                curGPoint11.captured = false;
                curGPoint11.insideElementPressed = false;
                curGPoint11.insideElement = true;
                startTrackingPointer11(pointsList11, curGPoint11);
            }
        }
        // Stop (mouse only)
        if (tracker11.stopHandler && gPoints11[0].type === "mouse") {
            clearTimeout(tracker11.stopTimeOut);
            tracker11.stopTimeOut = setTimeout(function() {
                handlePointerStop11(tracker11, event11, gPoints11[0].type);
            }, tracker11.stopDelay);
        }
        if (pointsList11.contacts === 0) // Move (no contacts: hovering mouse or other hover-capable device)
        {
            if (tracker11.moveHandler) {
                propagate11 = tracker11.moveHandler({
                    eventSource: tracker11,
                    pointerType: gPoints11[0].type,
                    position: getPointRelativeToAbsolute11(gPoints11[0].currentPos, tracker11.element),
                    buttons: pointsList11.buttons,
                    isTouchEvent: gPoints11[0].type === "touch",
                    originalEvent: event11,
                    preventDefaultAction: false,
                    userData: tracker11.userData
                });
                if (propagate11 === false) $11.cancelEvent(event11);
            }
        } else if (pointsList11.contacts === 1) {
            // Move (1 contact)
            if (tracker11.moveHandler) {
                updateGPoint11 = pointsList11.asArray()[0];
                propagate11 = tracker11.moveHandler({
                    eventSource: tracker11,
                    pointerType: updateGPoint11.type,
                    position: getPointRelativeToAbsolute11(updateGPoint11.currentPos, tracker11.element),
                    buttons: pointsList11.buttons,
                    isTouchEvent: updateGPoint11.type === "touch",
                    originalEvent: event11,
                    preventDefaultAction: false,
                    userData: tracker11.userData
                });
                if (propagate11 === false) $11.cancelEvent(event11);
            }
            // Drag
            if (tracker11.dragHandler) {
                updateGPoint11 = pointsList11.asArray()[0];
                delta11 = updateGPoint11.currentPos.minus(updateGPoint11.lastPos);
                propagate11 = tracker11.dragHandler({
                    eventSource: tracker11,
                    pointerType: updateGPoint11.type,
                    position: getPointRelativeToAbsolute11(updateGPoint11.currentPos, tracker11.element),
                    buttons: pointsList11.buttons,
                    delta: delta11,
                    speed: updateGPoint11.speed,
                    direction: updateGPoint11.direction,
                    shift: event11.shiftKey,
                    isTouchEvent: updateGPoint11.type === "touch",
                    originalEvent: event11,
                    preventDefaultAction: false,
                    userData: tracker11.userData
                });
                if (propagate11 === false) $11.cancelEvent(event11);
            }
        } else if (pointsList11.contacts === 2) {
            // Move (2 contacts, use center)
            if (tracker11.moveHandler) {
                gPointArray11 = pointsList11.asArray();
                propagate11 = tracker11.moveHandler({
                    eventSource: tracker11,
                    pointerType: gPointArray11[0].type,
                    position: getPointRelativeToAbsolute11(getCenterPoint11(gPointArray11[0].currentPos, gPointArray11[1].currentPos), tracker11.element),
                    buttons: pointsList11.buttons,
                    isTouchEvent: gPointArray11[0].type === "touch",
                    originalEvent: event11,
                    preventDefaultAction: false,
                    userData: tracker11.userData
                });
                if (propagate11 === false) $11.cancelEvent(event11);
            }
            // Pinch
            if (tracker11.pinchHandler && gPoints11[0].type === "touch") {
                delta11 = delegate11.pinchGPoints[0].currentPos.distanceTo(delegate11.pinchGPoints[1].currentPos);
                if (delta11 != delegate11.currentPinchDist) {
                    delegate11.lastPinchDist = delegate11.currentPinchDist;
                    delegate11.currentPinchDist = delta11;
                    delegate11.lastPinchCenter = delegate11.currentPinchCenter;
                    delegate11.currentPinchCenter = getCenterPoint11(delegate11.pinchGPoints[0].currentPos, delegate11.pinchGPoints[1].currentPos);
                    propagate11 = tracker11.pinchHandler({
                        eventSource: tracker11,
                        pointerType: "touch",
                        gesturePoints: delegate11.pinchGPoints,
                        lastCenter: getPointRelativeToAbsolute11(delegate11.lastPinchCenter, tracker11.element),
                        center: getPointRelativeToAbsolute11(delegate11.currentPinchCenter, tracker11.element),
                        lastDistance: delegate11.lastPinchDist,
                        distance: delegate11.currentPinchDist,
                        shift: event11.shiftKey,
                        originalEvent: event11,
                        preventDefaultAction: false,
                        userData: tracker11.userData
                    });
                    if (propagate11 === false) $11.cancelEvent(event11);
                }
            }
        }
    }
    /**
     * @function
     * @private
     * @inner
     * @param {OpenSeadragon.MouseTracker} tracker
     *     A reference to the MouseTracker instance.
     * @param {Object} event
     *     A reference to the originating DOM event.
     * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gPoints
     *      Gesture points associated with the event.
     */ function updatePointersCancel11(tracker11, event11, gPoints11) {
        updatePointersUp11(tracker11, event11, gPoints11, 0);
        updatePointersExit11(tracker11, event11, gPoints11);
    }
    /**
     * @private
     * @inner
     */ function handlePointerStop11(tracker11, originalMoveEvent11, pointerType11) {
        if (tracker11.stopHandler) tracker11.stopHandler({
            eventSource: tracker11,
            pointerType: pointerType11,
            position: getMouseRelative11(originalMoveEvent11, tracker11.element),
            buttons: tracker11.getActivePointersListByType(pointerType11).buttons,
            isTouchEvent: pointerType11 === "touch",
            originalEvent: originalMoveEvent11,
            preventDefaultAction: false,
            userData: tracker11.userData
        });
    }
    /**
     * True if inside an iframe, otherwise false.
     * @member {Boolean} isInIframe
     * @private
     * @inner
     */ var isInIframe11 = function() {
        try {
            return window.self !== window.top;
        } catch (e11) {
            return true;
        }
    }();
    /**
     * @function
     * @private
     * @inner
     * @returns {Boolean} True if the target has access rights to events, otherwise false.
     */ function canAccessEvents11(target11) {
        try {
            return target11.addEventListener && target11.removeEventListener;
        } catch (e11) {
            return false;
        }
    }
})(OpenSeadragon);
/*
 * OpenSeadragon - Control
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    /**
 * An enumeration of supported locations where controls can be anchored.
 * The anchoring is always relative to the container.
 * @member ControlAnchor
 * @memberof OpenSeadragon
 * @static
 * @type {Object}
 * @property {Number} NONE
 * @property {Number} TOP_LEFT
 * @property {Number} TOP_RIGHT
 * @property {Number} BOTTOM_LEFT
 * @property {Number} BOTTOM_RIGHT
 * @property {Number} ABSOLUTE
 */ $11.ControlAnchor = {
        NONE: 0,
        TOP_LEFT: 1,
        TOP_RIGHT: 2,
        BOTTOM_RIGHT: 3,
        BOTTOM_LEFT: 4,
        ABSOLUTE: 5
    };
    /**
 * @class Control
 * @classdesc A Control represents any interface element which is meant to allow the user
 * to interact with the zoomable interface. Any control can be anchored to any
 * element.
 *
 * @memberof OpenSeadragon
 * @param {Element} element - the control element to be anchored in the container.
 * @param {Object } options - All required and optional settings for configuring a control element.
 * @param {OpenSeadragon.ControlAnchor} [options.anchor=OpenSeadragon.ControlAnchor.NONE] - the position of the control
 *  relative to the container.
 * @param {Boolean} [options.attachToViewer=true] - Whether the control should be added directly to the viewer, or
 *  directly to the container
 * @param {Boolean} [options.autoFade=true] - Whether the control should have the autofade behavior
 * @param {Element} container - the element to control will be anchored too.
 */ $11.Control = function(element11, options11, container11) {
        var parent11 = element11.parentNode;
        if (typeof options11 === "number") {
            $11.console.error("Passing an anchor directly into the OpenSeadragon.Control constructor is deprecated; please use an options object instead.  Support for this deprecated variant is scheduled for removal in December 2013");
            options11 = {
                anchor: options11
            };
        }
        options11.attachToViewer = typeof options11.attachToViewer === "undefined" ? true : options11.attachToViewer;
        /**
     * True if the control should have autofade behavior.
     * @member {Boolean} autoFade
     * @memberof OpenSeadragon.Control#
     */ this.autoFade = typeof options11.autoFade === "undefined" ? true : options11.autoFade;
        /**
     * The element providing the user interface with some type of control (e.g. a zoom-in button).
     * @member {Element} element
     * @memberof OpenSeadragon.Control#
     */ this.element = element11;
        /**
     * The position of the Control relative to its container.
     * @member {OpenSeadragon.ControlAnchor} anchor
     * @memberof OpenSeadragon.Control#
     */ this.anchor = options11.anchor;
        /**
     * The Control's containing element.
     * @member {Element} container
     * @memberof OpenSeadragon.Control#
     */ this.container = container11;
        /**
     * A neutral element surrounding the control element.
     * @member {Element} wrapper
     * @memberof OpenSeadragon.Control#
     */ if (this.anchor == $11.ControlAnchor.ABSOLUTE) {
            this.wrapper = $11.makeNeutralElement("div");
            this.wrapper.style.position = "absolute";
            this.wrapper.style.top = typeof options11.top == "number" ? options11.top + "px" : options11.top;
            this.wrapper.style.left = typeof options11.left == "number" ? options11.left + "px" : options11.left;
            this.wrapper.style.height = typeof options11.height == "number" ? options11.height + "px" : options11.height;
            this.wrapper.style.width = typeof options11.width == "number" ? options11.width + "px" : options11.width;
            this.wrapper.style.margin = "0px";
            this.wrapper.style.padding = "0px";
            this.element.style.position = "relative";
            this.element.style.top = "0px";
            this.element.style.left = "0px";
            this.element.style.height = "100%";
            this.element.style.width = "100%";
        } else {
            this.wrapper = $11.makeNeutralElement("div");
            this.wrapper.style.display = "inline-block";
            if (this.anchor == $11.ControlAnchor.NONE) // IE6 fix
            this.wrapper.style.width = this.wrapper.style.height = "100%";
        }
        this.wrapper.appendChild(this.element);
        if (options11.attachToViewer) {
            if (this.anchor == $11.ControlAnchor.TOP_RIGHT || this.anchor == $11.ControlAnchor.BOTTOM_RIGHT) this.container.insertBefore(this.wrapper, this.container.firstChild);
            else this.container.appendChild(this.wrapper);
        } else parent11.appendChild(this.wrapper);
    };
    /** @lends OpenSeadragon.Control.prototype */ $11.Control.prototype = {
        /**
     * Removes the control from the container.
     * @function
     */ destroy: function() {
            this.wrapper.removeChild(this.element);
            this.container.removeChild(this.wrapper);
        },
        /**
     * Determines if the control is currently visible.
     * @function
     * @return {Boolean} true if currenly visible, false otherwise.
     */ isVisible: function() {
            return this.wrapper.style.display != "none";
        },
        /**
     * Toggles the visibility of the control.
     * @function
     * @param {Boolean} visible - true to make visible, false to hide.
     */ setVisible: function(visible11) {
            this.wrapper.style.display = visible11 ? this.anchor == $11.ControlAnchor.ABSOLUTE ? "block" : "inline-block" : "none";
        },
        /**
     * Sets the opacity level for the control.
     * @function
     * @param {Number} opactiy - a value between 1 and 0 inclusively.
     */ setOpacity: function(opacity11) {
            if (this.element[$11.SIGNAL] && $11.Browser.vendor == $11.BROWSERS.IE) $11.setElementOpacity(this.element, opacity11, true);
            else $11.setElementOpacity(this.wrapper, opacity11, true);
        }
    };
})(OpenSeadragon);
/*
 * OpenSeadragon - ControlDock
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    /**
     * @class ControlDock
     * @classdesc Provides a container element (a &lt;form&gt; element) with support for the layout of control elements.
     *
     * @memberof OpenSeadragon
     */ $11.ControlDock = function(options11) {
        var layouts11 = [
            "topleft",
            "topright",
            "bottomright",
            "bottomleft"
        ], layout11, i11;
        $11.extend(true, this, {
            id: "controldock-" + $11.now() + "-" + Math.floor(Math.random() * 1000000),
            container: $11.makeNeutralElement("div"),
            controls: []
        }, options11);
        // Disable the form's submit; otherwise button clicks and return keys
        // can trigger it.
        this.container.onsubmit = function() {
            return false;
        };
        if (this.element) {
            this.element = $11.getElement(this.element);
            this.element.appendChild(this.container);
            this.element.style.position = "relative";
            this.container.style.width = "100%";
            this.container.style.height = "100%";
        }
        for(i11 = 0; i11 < layouts11.length; i11++){
            layout11 = layouts11[i11];
            this.controls[layout11] = $11.makeNeutralElement("div");
            this.controls[layout11].style.position = "absolute";
            if (layout11.match("left")) this.controls[layout11].style.left = "0px";
            if (layout11.match("right")) this.controls[layout11].style.right = "0px";
            if (layout11.match("top")) this.controls[layout11].style.top = "0px";
            if (layout11.match("bottom")) this.controls[layout11].style.bottom = "0px";
        }
        this.container.appendChild(this.controls.topleft);
        this.container.appendChild(this.controls.topright);
        this.container.appendChild(this.controls.bottomright);
        this.container.appendChild(this.controls.bottomleft);
    };
    /** @lends OpenSeadragon.ControlDock.prototype */ $11.ControlDock.prototype = {
        /**
         * @function
         */ addControl: function(element11, controlOptions11) {
            element11 = $11.getElement(element11);
            var div11 = null;
            if (getControlIndex11(this, element11) >= 0) return; // they're trying to add a duplicate control
            switch(controlOptions11.anchor){
                case $11.ControlAnchor.TOP_RIGHT:
                    div11 = this.controls.topright;
                    element11.style.position = "relative";
                    element11.style.paddingRight = "0px";
                    element11.style.paddingTop = "0px";
                    break;
                case $11.ControlAnchor.BOTTOM_RIGHT:
                    div11 = this.controls.bottomright;
                    element11.style.position = "relative";
                    element11.style.paddingRight = "0px";
                    element11.style.paddingBottom = "0px";
                    break;
                case $11.ControlAnchor.BOTTOM_LEFT:
                    div11 = this.controls.bottomleft;
                    element11.style.position = "relative";
                    element11.style.paddingLeft = "0px";
                    element11.style.paddingBottom = "0px";
                    break;
                case $11.ControlAnchor.TOP_LEFT:
                    div11 = this.controls.topleft;
                    element11.style.position = "relative";
                    element11.style.paddingLeft = "0px";
                    element11.style.paddingTop = "0px";
                    break;
                case $11.ControlAnchor.ABSOLUTE:
                    div11 = this.container;
                    element11.style.margin = "0px";
                    element11.style.padding = "0px";
                    break;
                default:
                case $11.ControlAnchor.NONE:
                    div11 = this.container;
                    element11.style.margin = "0px";
                    element11.style.padding = "0px";
                    break;
            }
            this.controls.push(new $11.Control(element11, controlOptions11, div11));
            element11.style.display = "inline-block";
        },
        /**
         * @function
         * @return {OpenSeadragon.ControlDock} Chainable.
         */ removeControl: function(element11) {
            element11 = $11.getElement(element11);
            var i11 = getControlIndex11(this, element11);
            if (i11 >= 0) {
                this.controls[i11].destroy();
                this.controls.splice(i11, 1);
            }
            return this;
        },
        /**
         * @function
         * @return {OpenSeadragon.ControlDock} Chainable.
         */ clearControls: function() {
            while(this.controls.length > 0)this.controls.pop().destroy();
            return this;
        },
        /**
         * @function
         * @return {Boolean}
         */ areControlsEnabled: function() {
            var i11;
            for(i11 = this.controls.length - 1; i11 >= 0; i11--){
                if (this.controls[i11].isVisible()) return true;
            }
            return false;
        },
        /**
         * @function
         * @return {OpenSeadragon.ControlDock} Chainable.
         */ setControlsEnabled: function(enabled11) {
            var i11;
            for(i11 = this.controls.length - 1; i11 >= 0; i11--)this.controls[i11].setVisible(enabled11);
            return this;
        }
    };
    ///////////////////////////////////////////////////////////////////////////////
    // Utility methods
    ///////////////////////////////////////////////////////////////////////////////
    function getControlIndex11(dock11, element11) {
        var controls11 = dock11.controls, i11;
        for(i11 = controls11.length - 1; i11 >= 0; i11--){
            if (controls11[i11].element == element11) return i11;
        }
        return -1;
    }
})(OpenSeadragon);
/*
 * OpenSeadragon - Placement
 *
 * Copyright (C) 2010-2016 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    /**
     * An enumeration of positions to anchor an element.
     * @member Placement
     * @memberOf OpenSeadragon
     * @static
     * @readonly
     * @property {OpenSeadragon.Placement} CENTER
     * @property {OpenSeadragon.Placement} TOP_LEFT
     * @property {OpenSeadragon.Placement} TOP
     * @property {OpenSeadragon.Placement} TOP_RIGHT
     * @property {OpenSeadragon.Placement} RIGHT
     * @property {OpenSeadragon.Placement} BOTTOM_RIGHT
     * @property {OpenSeadragon.Placement} BOTTOM
     * @property {OpenSeadragon.Placement} BOTTOM_LEFT
     * @property {OpenSeadragon.Placement} LEFT
     */ $11.Placement = $11.freezeObject({
        CENTER: 0,
        TOP_LEFT: 1,
        TOP: 2,
        TOP_RIGHT: 3,
        RIGHT: 4,
        BOTTOM_RIGHT: 5,
        BOTTOM: 6,
        BOTTOM_LEFT: 7,
        LEFT: 8,
        properties: {
            0: {
                isLeft: false,
                isHorizontallyCentered: true,
                isRight: false,
                isTop: false,
                isVerticallyCentered: true,
                isBottom: false
            },
            1: {
                isLeft: true,
                isHorizontallyCentered: false,
                isRight: false,
                isTop: true,
                isVerticallyCentered: false,
                isBottom: false
            },
            2: {
                isLeft: false,
                isHorizontallyCentered: true,
                isRight: false,
                isTop: true,
                isVerticallyCentered: false,
                isBottom: false
            },
            3: {
                isLeft: false,
                isHorizontallyCentered: false,
                isRight: true,
                isTop: true,
                isVerticallyCentered: false,
                isBottom: false
            },
            4: {
                isLeft: false,
                isHorizontallyCentered: false,
                isRight: true,
                isTop: false,
                isVerticallyCentered: true,
                isBottom: false
            },
            5: {
                isLeft: false,
                isHorizontallyCentered: false,
                isRight: true,
                isTop: false,
                isVerticallyCentered: false,
                isBottom: true
            },
            6: {
                isLeft: false,
                isHorizontallyCentered: true,
                isRight: false,
                isTop: false,
                isVerticallyCentered: false,
                isBottom: true
            },
            7: {
                isLeft: true,
                isHorizontallyCentered: false,
                isRight: false,
                isTop: false,
                isVerticallyCentered: false,
                isBottom: true
            },
            8: {
                isLeft: true,
                isHorizontallyCentered: false,
                isRight: false,
                isTop: false,
                isVerticallyCentered: true,
                isBottom: false
            }
        }
    });
})(OpenSeadragon);
/*
 * OpenSeadragon - Viewer
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    // dictionary from hash to private properties
    var THIS11 = {};
    var nextHash11 = 1;
    /**
 *
 * The main point of entry into creating a zoomable image on the page.<br>
 * <br>
 * We have provided an idiomatic javascript constructor which takes
 * a single object, but still support the legacy positional arguments.<br>
 * <br>
 * The options below are given in order that they appeared in the constructor
 * as arguments and we translate a positional call into an idiomatic call.<br>
 * <br>
 * To create a viewer, you can use either of this methods:<br>
 * <ul>
 * <li><code>var viewer = new OpenSeadragon.Viewer(options);</code></li>
 * <li><code>var viewer = OpenSeadragon(options);</code></li>
 * </ul>
 * @class Viewer
 * @classdesc The main OpenSeadragon viewer class.
 *
 * @memberof OpenSeadragon
 * @extends OpenSeadragon.EventSource
 * @extends OpenSeadragon.ControlDock
 * @param {OpenSeadragon.Options} options - Viewer options.
 *
 **/ $11.Viewer = function(options11) {
        var args11 = arguments, _this11 = this, i11;
        //backward compatibility for positional args while prefering more
        //idiomatic javascript options object as the only argument
        if (!$11.isPlainObject(options11)) options11 = {
            id: args11[0],
            xmlPath: args11.length > 1 ? args11[1] : undefined,
            prefixUrl: args11.length > 2 ? args11[2] : undefined,
            controls: args11.length > 3 ? args11[3] : undefined,
            overlays: args11.length > 4 ? args11[4] : undefined
        };
        //options.config and the general config argument are deprecated
        //in favor of the more direct specification of optional settings
        //being pass directly on the options object
        if (options11.config) {
            $11.extend(true, options11, options11.config);
            delete options11.config;
        }
        //Public properties
        //Allow the options object to override global defaults
        $11.extend(true, this, {
            //internal state and dom identifiers
            id: options11.id,
            hash: options11.hash || nextHash11++,
            /**
         * Index for page to be shown first next time open() is called (only used in sequenceMode).
         * @member {Number} initialPage
         * @memberof OpenSeadragon.Viewer#
         */ initialPage: 0,
            //dom nodes
            /**
         * The parent element of this Viewer instance, passed in when the Viewer was created.
         * @member {Element} element
         * @memberof OpenSeadragon.Viewer#
         */ element: null,
            /**
         * A &lt;div&gt; element (provided by {@link OpenSeadragon.ControlDock}), the base element of this Viewer instance.<br><br>
         * Child element of {@link OpenSeadragon.Viewer#element}.
         * @member {Element} container
         * @memberof OpenSeadragon.Viewer#
         */ container: null,
            /**
         * A &lt;div&gt; element, the element where user-input events are handled for panning and zooming.<br><br>
         * Child element of {@link OpenSeadragon.Viewer#container},
         * positioned on top of {@link OpenSeadragon.Viewer#keyboardCommandArea}.<br><br>
         * The parent of {@link OpenSeadragon.Drawer#canvas} instances.
         * @member {Element} canvas
         * @memberof OpenSeadragon.Viewer#
         */ canvas: null,
            // Overlays list. An overlay allows to add html on top of the viewer.
            overlays: [],
            // Container inside the canvas where overlays are drawn.
            overlaysContainer: null,
            //private state properties
            previousBody: [],
            //This was originally initialized in the constructor and so could never
            //have anything in it.  now it can because we allow it to be specified
            //in the options and is only empty by default if not specified. Also
            //this array was returned from get_controls which I find confusing
            //since this object has a controls property which is treated in other
            //functions like clearControls.  I'm removing the accessors.
            customControls: [],
            //These are originally not part options but declared as members
            //in initialize.  It's still considered idiomatic to put them here
            //source is here for backwards compatibility. It is not an official
            //part of the API and should not be relied upon.
            source: null,
            /**
         * Handles rendering of tiles in the viewer. Created for each TileSource opened.
         * @member {OpenSeadragon.Drawer} drawer
         * @memberof OpenSeadragon.Viewer#
         */ drawer: null,
            /**
         * Keeps track of all of the tiled images in the scene.
         * @member {OpenSeadragon.Drawer} world
         * @memberof OpenSeadragon.Viewer#
         */ world: null,
            /**
         * Handles coordinate-related functionality - zoom, pan, rotation, etc. Created for each TileSource opened.
         * @member {OpenSeadragon.Viewport} viewport
         * @memberof OpenSeadragon.Viewer#
         */ viewport: null,
            /**
         * @member {OpenSeadragon.Navigator} navigator
         * @memberof OpenSeadragon.Viewer#
         */ navigator: null,
            //A collection viewport is a separate viewport used to provide
            //simultaneous rendering of sets of tiles
            collectionViewport: null,
            collectionDrawer: null,
            //UI image resources
            //TODO: rename navImages to uiImages
            navImages: null,
            //interface button controls
            buttons: null,
            //TODO: this is defunct so safely remove it
            profiler: null
        }, $11.DEFAULT_SETTINGS, options11);
        if (typeof this.hash === "undefined") throw new Error("A hash must be defined, either by specifying options.id or options.hash.");
        if (typeof THIS11[this.hash] !== "undefined") // We don't want to throw an error here, as the user might have discarded
        // the previous viewer with the same hash and now want to recreate it.
        $11.console.warn("Hash " + this.hash + " has already been used.");
        //Private state properties
        THIS11[this.hash] = {
            "fsBoundsDelta": new $11.Point(1, 1),
            "prevContainerSize": null,
            "animating": false,
            "forceRedraw": false,
            "mouseInside": false,
            "group": null,
            // whether we should be continuously zooming
            "zooming": false,
            // how much we should be continuously zooming by
            "zoomFactor": null,
            "lastZoomTime": null,
            "fullPage": false,
            "onfullscreenchange": null
        };
        this._sequenceIndex = 0;
        this._firstOpen = true;
        this._updateRequestId = null;
        this._loadQueue = [];
        this.currentOverlays = [];
        this._lastScrollTime = $11.now(); // variable used to help normalize the scroll event speed of different devices
        //Inherit some behaviors and properties
        $11.EventSource.call(this);
        this.addHandler("open-failed", function(event11) {
            var msg11 = $11.getString("Errors.OpenFailed", event11.eventSource, event11.message);
            _this11._showMessage(msg11);
        });
        $11.ControlDock.call(this, options11);
        //Deal with tile sources
        if (this.xmlPath) //Deprecated option.  Now it is preferred to use the tileSources option
        this.tileSources = [
            this.xmlPath
        ];
        this.element = this.element || document.getElementById(this.id);
        this.canvas = $11.makeNeutralElement("div");
        this.canvas.className = "openseadragon-canvas";
        (function(style11) {
            style11.width = "100%";
            style11.height = "100%";
            style11.overflow = "hidden";
            style11.position = "absolute";
            style11.top = "0px";
            style11.left = "0px";
        })(this.canvas.style);
        $11.setElementTouchActionNone(this.canvas);
        if (options11.tabIndex !== "") this.canvas.tabIndex = options11.tabIndex === undefined ? 0 : options11.tabIndex;
        //the container is created through applying the ControlDock constructor above
        this.container.className = "openseadragon-container";
        (function(style11) {
            style11.width = "100%";
            style11.height = "100%";
            style11.position = "relative";
            style11.overflow = "hidden";
            style11.left = "0px";
            style11.top = "0px";
            style11.textAlign = "left"; // needed to protect against
        })(this.container.style);
        this.container.insertBefore(this.canvas, this.container.firstChild);
        this.element.appendChild(this.container);
        //Used for toggling between fullscreen and default container size
        //TODO: these can be closure private and shared across Viewer
        //      instances.
        this.bodyWidth = document.body.style.width;
        this.bodyHeight = document.body.style.height;
        this.bodyOverflow = document.body.style.overflow;
        this.docOverflow = document.documentElement.style.overflow;
        this.innerTracker = new $11.MouseTracker({
            element: this.canvas,
            startDisabled: !this.mouseNavEnabled,
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold,
            dblClickTimeThreshold: this.dblClickTimeThreshold,
            dblClickDistThreshold: this.dblClickDistThreshold,
            keyDownHandler: $11.delegate(this, onCanvasKeyDown11),
            keyHandler: $11.delegate(this, onCanvasKeyPress11),
            clickHandler: $11.delegate(this, onCanvasClick11),
            dblClickHandler: $11.delegate(this, onCanvasDblClick11),
            dragHandler: $11.delegate(this, onCanvasDrag11),
            dragEndHandler: $11.delegate(this, onCanvasDragEnd11),
            enterHandler: $11.delegate(this, onCanvasEnter11),
            exitHandler: $11.delegate(this, onCanvasExit11),
            pressHandler: $11.delegate(this, onCanvasPress11),
            releaseHandler: $11.delegate(this, onCanvasRelease11),
            nonPrimaryPressHandler: $11.delegate(this, onCanvasNonPrimaryPress11),
            nonPrimaryReleaseHandler: $11.delegate(this, onCanvasNonPrimaryRelease11),
            scrollHandler: $11.delegate(this, onCanvasScroll11),
            pinchHandler: $11.delegate(this, onCanvasPinch11)
        });
        this.outerTracker = new $11.MouseTracker({
            element: this.container,
            startDisabled: !this.mouseNavEnabled,
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold,
            dblClickTimeThreshold: this.dblClickTimeThreshold,
            dblClickDistThreshold: this.dblClickDistThreshold,
            enterHandler: $11.delegate(this, onContainerEnter11),
            exitHandler: $11.delegate(this, onContainerExit11)
        });
        if (this.toolbar) this.toolbar = new $11.ControlDock({
            element: this.toolbar
        });
        this.bindStandardControls();
        THIS11[this.hash].prevContainerSize = _getSafeElemSize11(this.container);
        // Create the world
        this.world = new $11.World({
            viewer: this
        });
        this.world.addHandler("add-item", function(event11) {
            // For backwards compatibility, we maintain the source property
            _this11.source = _this11.world.getItemAt(0).source;
            THIS11[_this11.hash].forceRedraw = true;
            if (!_this11._updateRequestId) _this11._updateRequestId = scheduleUpdate11(_this11, updateMulti11);
        });
        this.world.addHandler("remove-item", function(event11) {
            // For backwards compatibility, we maintain the source property
            if (_this11.world.getItemCount()) _this11.source = _this11.world.getItemAt(0).source;
            else _this11.source = null;
            THIS11[_this11.hash].forceRedraw = true;
        });
        this.world.addHandler("metrics-change", function(event11) {
            if (_this11.viewport) _this11.viewport._setContentBounds(_this11.world.getHomeBounds(), _this11.world.getContentFactor());
        });
        this.world.addHandler("item-index-change", function(event11) {
            // For backwards compatibility, we maintain the source property
            _this11.source = _this11.world.getItemAt(0).source;
        });
        // Create the viewport
        this.viewport = new $11.Viewport({
            containerSize: THIS11[this.hash].prevContainerSize,
            springStiffness: this.springStiffness,
            animationTime: this.animationTime,
            minZoomImageRatio: this.minZoomImageRatio,
            maxZoomPixelRatio: this.maxZoomPixelRatio,
            visibilityRatio: this.visibilityRatio,
            wrapHorizontal: this.wrapHorizontal,
            wrapVertical: this.wrapVertical,
            defaultZoomLevel: this.defaultZoomLevel,
            minZoomLevel: this.minZoomLevel,
            maxZoomLevel: this.maxZoomLevel,
            viewer: this,
            degrees: this.degrees,
            flipped: this.flipped,
            navigatorRotate: this.navigatorRotate,
            homeFillsViewer: this.homeFillsViewer,
            margins: this.viewportMargins
        });
        this.viewport._setContentBounds(this.world.getHomeBounds(), this.world.getContentFactor());
        // Create the image loader
        this.imageLoader = new $11.ImageLoader({
            jobLimit: this.imageLoaderLimit,
            timeout: options11.timeout
        });
        // Create the tile cache
        this.tileCache = new $11.TileCache({
            maxImageCacheCount: this.maxImageCacheCount
        });
        // Create the drawer
        this.drawer = new $11.Drawer({
            viewer: this,
            viewport: this.viewport,
            element: this.canvas,
            debugGridColor: this.debugGridColor
        });
        // Overlay container
        this.overlaysContainer = $11.makeNeutralElement("div");
        this.canvas.appendChild(this.overlaysContainer);
        // Now that we have a drawer, see if it supports rotate. If not we need to remove the rotate buttons
        if (!this.drawer.canRotate()) {
            // Disable/remove the rotate left/right buttons since they aren't supported
            if (this.rotateLeft) {
                i11 = this.buttons.buttons.indexOf(this.rotateLeft);
                this.buttons.buttons.splice(i11, 1);
                this.buttons.element.removeChild(this.rotateLeft.element);
            }
            if (this.rotateRight) {
                i11 = this.buttons.buttons.indexOf(this.rotateRight);
                this.buttons.buttons.splice(i11, 1);
                this.buttons.element.removeChild(this.rotateRight.element);
            }
        }
        //Instantiate a navigator if configured
        if (this.showNavigator) this.navigator = new $11.Navigator({
            id: this.navigatorId,
            position: this.navigatorPosition,
            sizeRatio: this.navigatorSizeRatio,
            maintainSizeRatio: this.navigatorMaintainSizeRatio,
            top: this.navigatorTop,
            left: this.navigatorLeft,
            width: this.navigatorWidth,
            height: this.navigatorHeight,
            autoResize: this.navigatorAutoResize,
            autoFade: this.navigatorAutoFade,
            prefixUrl: this.prefixUrl,
            viewer: this,
            navigatorRotate: this.navigatorRotate,
            background: this.navigatorBackground,
            opacity: this.navigatorOpacity,
            borderColor: this.navigatorBorderColor,
            displayRegionColor: this.navigatorDisplayRegionColor,
            crossOriginPolicy: this.crossOriginPolicy
        });
        // Sequence mode
        if (this.sequenceMode) this.bindSequenceControls();
        // Open initial tilesources
        if (this.tileSources) this.open(this.tileSources);
        // Add custom controls
        for(i11 = 0; i11 < this.customControls.length; i11++)this.addControl(this.customControls[i11].id, {
            anchor: this.customControls[i11].anchor
        });
        // Initial fade out
        $11.requestAnimationFrame(function() {
            beginControlsAutoHide11(_this11);
        });
    };
    $11.extend($11.Viewer.prototype, $11.EventSource.prototype, $11.ControlDock.prototype, /** @lends OpenSeadragon.Viewer.prototype */ {
        /**
     * @function
     * @return {Boolean}
     */ isOpen: function() {
            return !!this.world.getItemCount();
        },
        // deprecated
        openDzi: function(dzi11) {
            $11.console.error("[Viewer.openDzi] this function is deprecated; use Viewer.open() instead.");
            return this.open(dzi11);
        },
        // deprecated
        openTileSource: function(tileSource11) {
            $11.console.error("[Viewer.openTileSource] this function is deprecated; use Viewer.open() instead.");
            return this.open(tileSource11);
        },
        /**
     * Open tiled images into the viewer, closing any others.
     * To get the TiledImage instance created by open, add an event listener for
     * {@link OpenSeadragon.Viewer.html#.event:open}, which when fired can be used to get access
     * to the instance, i.e., viewer.world.getItemAt(0).
     * @function
     * @param {Array|String|Object|Function} tileSources - This can be a TiledImage
     * specifier, a TileSource specifier, or an array of either. A TiledImage specifier
     * is the same as the options parameter for {@link OpenSeadragon.Viewer#addTiledImage},
     * except for the index property; images are added in sequence.
     * A TileSource specifier is anything you could pass as the tileSource property
     * of the options parameter for {@link OpenSeadragon.Viewer#addTiledImage}.
     * @param {Number} initialPage - If sequenceMode is true, display this page initially
     * for the given tileSources. If specified, will overwrite the Viewer's existing initialPage property.
     * @return {OpenSeadragon.Viewer} Chainable.
     * @fires OpenSeadragon.Viewer.event:open
     * @fires OpenSeadragon.Viewer.event:open-failed
     */ open: function(tileSources11, initialPage11) {
            var _this11 = this;
            this.close();
            if (!tileSources11) return;
            if (this.sequenceMode && $11.isArray(tileSources11)) {
                if (this.referenceStrip) {
                    this.referenceStrip.destroy();
                    this.referenceStrip = null;
                }
                if (typeof initialPage11 != "undefined" && !isNaN(initialPage11)) this.initialPage = initialPage11;
                this.tileSources = tileSources11;
                this._sequenceIndex = Math.max(0, Math.min(this.tileSources.length - 1, this.initialPage));
                if (this.tileSources.length) {
                    this.open(this.tileSources[this._sequenceIndex]);
                    if (this.showReferenceStrip) this.addReferenceStrip();
                }
                this._updateSequenceButtons(this._sequenceIndex);
                return;
            }
            if (!$11.isArray(tileSources11)) tileSources11 = [
                tileSources11
            ];
            if (!tileSources11.length) return;
            this._opening = true;
            var expected11 = tileSources11.length;
            var successes11 = 0;
            var failures11 = 0;
            var failEvent11;
            var checkCompletion11 = function() {
                if (successes11 + failures11 === expected11) {
                    if (successes11) {
                        if (_this11._firstOpen || !_this11.preserveViewport) {
                            _this11.viewport.goHome(true);
                            _this11.viewport.update();
                        }
                        _this11._firstOpen = false;
                        var source11 = tileSources11[0];
                        if (source11.tileSource) source11 = source11.tileSource;
                        // Global overlays
                        if (_this11.overlays && !_this11.preserveOverlays) for(var i11 = 0; i11 < _this11.overlays.length; i11++)_this11.currentOverlays[i11] = getOverlayObject11(_this11, _this11.overlays[i11]);
                        _this11._drawOverlays();
                        _this11._opening = false;
                        /**
                     * Raised when the viewer has opened and loaded one or more TileSources.
                     *
                     * @event open
                     * @memberof OpenSeadragon.Viewer
                     * @type {object}
                     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
                     * @property {OpenSeadragon.TileSource} source - The tile source that was opened.
                     * @property {?Object} userData - Arbitrary subscriber-defined object.
                     */ // TODO: what if there are multiple sources?
                        _this11.raiseEvent("open", {
                            source: source11
                        });
                    } else {
                        _this11._opening = false;
                        /**
                     * Raised when an error occurs loading a TileSource.
                     *
                     * @event open-failed
                     * @memberof OpenSeadragon.Viewer
                     * @type {object}
                     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
                     * @property {String} message - Information about what failed.
                     * @property {String} source - The tile source that failed.
                     * @property {?Object} userData - Arbitrary subscriber-defined object.
                     */ _this11.raiseEvent("open-failed", failEvent11);
                    }
                }
            };
            var doOne11 = function(options11) {
                if (!$11.isPlainObject(options11) || !options11.tileSource) options11 = {
                    tileSource: options11
                };
                if (options11.index !== undefined) {
                    $11.console.error("[Viewer.open] setting indexes here is not supported; use addTiledImage instead");
                    delete options11.index;
                }
                if (options11.collectionImmediately === undefined) options11.collectionImmediately = true;
                var originalSuccess11 = options11.success;
                options11.success = function(event11) {
                    successes11++;
                    // TODO: now that options has other things besides tileSource, the overlays
                    // should probably be at the options level, not the tileSource level.
                    if (options11.tileSource.overlays) for(var i11 = 0; i11 < options11.tileSource.overlays.length; i11++)_this11.addOverlay(options11.tileSource.overlays[i11]);
                    if (originalSuccess11) originalSuccess11(event11);
                    checkCompletion11();
                };
                var originalError11 = options11.error;
                options11.error = function(event11) {
                    failures11++;
                    if (!failEvent11) failEvent11 = event11;
                    if (originalError11) originalError11(event11);
                    checkCompletion11();
                };
                _this11.addTiledImage(options11);
            };
            // TileSources
            for(var i11 = 0; i11 < tileSources11.length; i11++)doOne11(tileSources11[i11]);
            return this;
        },
        /**
     * @function
     * @return {OpenSeadragon.Viewer} Chainable.
     * @fires OpenSeadragon.Viewer.event:close
     */ close: function() {
            if (!THIS11[this.hash]) //this viewer has already been destroyed: returning immediately
            return this;
            this._opening = false;
            if (this.navigator) this.navigator.close();
            if (!this.preserveOverlays) {
                this.clearOverlays();
                this.overlaysContainer.innerHTML = "";
            }
            THIS11[this.hash].animating = false;
            this.world.removeAll();
            this.imageLoader.clear();
            /**
         * Raised when the viewer is closed (see {@link OpenSeadragon.Viewer#close}).
         *
         * @event close
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */ this.raiseEvent("close");
            return this;
        },
        /**
     * Function to destroy the viewer and clean up everything created by OpenSeadragon.
     *
     * Example:
     * var viewer = OpenSeadragon({
     *   [...]
     * });
     *
     * //when you are done with the viewer:
     * viewer.destroy();
     * viewer = null; //important
     *
     * @function
     */ destroy: function() {
            if (!THIS11[this.hash]) //this viewer has already been destroyed: returning immediately
            return;
            this.close();
            this.clearOverlays();
            this.overlaysContainer.innerHTML = "";
            //TODO: implement this...
            //this.unbindSequenceControls()
            //this.unbindStandardControls()
            if (this.referenceStrip) {
                this.referenceStrip.destroy();
                this.referenceStrip = null;
            }
            if (this._updateRequestId !== null) {
                $11.cancelAnimationFrame(this._updateRequestId);
                this._updateRequestId = null;
            }
            if (this.drawer) this.drawer.destroy();
            this.removeAllHandlers();
            // Go through top element (passed to us) and remove all children
            // Use removeChild to make sure it handles SVG or any non-html
            // also it performs better - http://jsperf.com/innerhtml-vs-removechild/15
            if (this.element) while(this.element.firstChild)this.element.removeChild(this.element.firstChild);
            // destroy the mouse trackers
            if (this.innerTracker) this.innerTracker.destroy();
            if (this.outerTracker) this.outerTracker.destroy();
            THIS11[this.hash] = null;
            delete THIS11[this.hash];
            // clear all our references to dom objects
            this.canvas = null;
            this.container = null;
            // clear our reference to the main element - they will need to pass it in again, creating a new viewer
            this.element = null;
        },
        /**
     * @function
     * @return {Boolean}
     */ isMouseNavEnabled: function() {
            return this.innerTracker.isTracking();
        },
        /**
     * @function
     * @param {Boolean} enabled - true to enable, false to disable
     * @return {OpenSeadragon.Viewer} Chainable.
     * @fires OpenSeadragon.Viewer.event:mouse-enabled
     */ setMouseNavEnabled: function(enabled11) {
            this.innerTracker.setTracking(enabled11);
            this.outerTracker.setTracking(enabled11);
            /**
         * Raised when mouse/touch navigation is enabled or disabled (see {@link OpenSeadragon.Viewer#setMouseNavEnabled}).
         *
         * @event mouse-enabled
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
         * @property {Boolean} enabled
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */ this.raiseEvent("mouse-enabled", {
                enabled: enabled11
            });
            return this;
        },
        /**
     * @function
     * @return {Boolean}
     */ areControlsEnabled: function() {
            var enabled11 = this.controls.length, i11;
            for(i11 = 0; i11 < this.controls.length; i11++)enabled11 = enabled11 && this.controls[i11].isVisibile();
            return enabled11;
        },
        /**
     * Shows or hides the controls (e.g. the default navigation buttons).
     *
     * @function
     * @param {Boolean} true to show, false to hide.
     * @return {OpenSeadragon.Viewer} Chainable.
     * @fires OpenSeadragon.Viewer.event:controls-enabled
     */ setControlsEnabled: function(enabled11) {
            if (enabled11) abortControlsAutoHide11(this);
            else beginControlsAutoHide11(this);
            /**
         * Raised when the navigation controls are shown or hidden (see {@link OpenSeadragon.Viewer#setControlsEnabled}).
         *
         * @event controls-enabled
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
         * @property {Boolean} enabled
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */ this.raiseEvent("controls-enabled", {
                enabled: enabled11
            });
            return this;
        },
        /**
     * Turns debugging mode on or off for this viewer.
     *
     * @function
     * @param {Boolean} true to turn debug on, false to turn debug off.
     */ setDebugMode: function(debugMode11) {
            for(var i11 = 0; i11 < this.world.getItemCount(); i11++)this.world.getItemAt(i11).debugMode = debugMode11;
            this.debugMode = debugMode11;
            this.forceRedraw();
        },
        /**
     * @function
     * @return {Boolean}
     */ isFullPage: function() {
            return THIS11[this.hash].fullPage;
        },
        /**
     * Toggle full page mode.
     * @function
     * @param {Boolean} fullPage
     *      If true, enter full page mode.  If false, exit full page mode.
     * @return {OpenSeadragon.Viewer} Chainable.
     * @fires OpenSeadragon.Viewer.event:pre-full-page
     * @fires OpenSeadragon.Viewer.event:full-page
     */ setFullPage: function(fullPage11) {
            var body11 = document.body, bodyStyle11 = body11.style, docStyle11 = document.documentElement.style, _this11 = this, nodes11, i11;
            //dont bother modifying the DOM if we are already in full page mode.
            if (fullPage11 == this.isFullPage()) return this;
            var fullPageEventArgs11 = {
                fullPage: fullPage11,
                preventDefaultAction: false
            };
            /**
         * Raised when the viewer is about to change to/from full-page mode (see {@link OpenSeadragon.Viewer#setFullPage}).
         *
         * @event pre-full-page
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
         * @property {Boolean} fullPage - True if entering full-page mode, false if exiting full-page mode.
         * @property {Boolean} preventDefaultAction - Set to true to prevent full-page mode change. Default: false.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */ this.raiseEvent("pre-full-page", fullPageEventArgs11);
            if (fullPageEventArgs11.preventDefaultAction) return this;
            if (fullPage11) {
                this.elementSize = $11.getElementSize(this.element);
                this.pageScroll = $11.getPageScroll();
                this.elementMargin = this.element.style.margin;
                this.element.style.margin = "0";
                this.elementPadding = this.element.style.padding;
                this.element.style.padding = "0";
                this.bodyMargin = bodyStyle11.margin;
                this.docMargin = docStyle11.margin;
                bodyStyle11.margin = "0";
                docStyle11.margin = "0";
                this.bodyPadding = bodyStyle11.padding;
                this.docPadding = docStyle11.padding;
                bodyStyle11.padding = "0";
                docStyle11.padding = "0";
                this.bodyWidth = bodyStyle11.width;
                this.docWidth = docStyle11.width;
                bodyStyle11.width = "100%";
                docStyle11.width = "100%";
                this.bodyHeight = bodyStyle11.height;
                this.docHeight = docStyle11.height;
                bodyStyle11.height = "100%";
                docStyle11.height = "100%";
                //when entering full screen on the ipad it wasnt sufficient to leave
                //the body intact as only only the top half of the screen would
                //respond to touch events on the canvas, while the bottom half treated
                //them as touch events on the document body.  Thus we remove and store
                //the bodies elements and replace them when we leave full screen.
                this.previousBody = [];
                THIS11[this.hash].prevElementParent = this.element.parentNode;
                THIS11[this.hash].prevNextSibling = this.element.nextSibling;
                THIS11[this.hash].prevElementWidth = this.element.style.width;
                THIS11[this.hash].prevElementHeight = this.element.style.height;
                nodes11 = body11.childNodes.length;
                for(i11 = 0; i11 < nodes11; i11++){
                    this.previousBody.push(body11.childNodes[0]);
                    body11.removeChild(body11.childNodes[0]);
                }
                //If we've got a toolbar, we need to enable the user to use css to
                //preserve it in fullpage mode
                if (this.toolbar && this.toolbar.element) {
                    //save a reference to the parent so we can put it back
                    //in the long run we need a better strategy
                    this.toolbar.parentNode = this.toolbar.element.parentNode;
                    this.toolbar.nextSibling = this.toolbar.element.nextSibling;
                    body11.appendChild(this.toolbar.element);
                    //Make sure the user has some ability to style the toolbar based
                    //on the mode
                    $11.addClass(this.toolbar.element, "fullpage");
                }
                $11.addClass(this.element, "fullpage");
                body11.appendChild(this.element);
                this.element.style.height = $11.getWindowSize().y + "px";
                this.element.style.width = $11.getWindowSize().x + "px";
                if (this.toolbar && this.toolbar.element) this.element.style.height = $11.getElementSize(this.element).y - $11.getElementSize(this.toolbar.element).y + "px";
                THIS11[this.hash].fullPage = true;
                // mouse will be inside container now
                $11.delegate(this, onContainerEnter11)({});
            } else {
                this.element.style.margin = this.elementMargin;
                this.element.style.padding = this.elementPadding;
                bodyStyle11.margin = this.bodyMargin;
                docStyle11.margin = this.docMargin;
                bodyStyle11.padding = this.bodyPadding;
                docStyle11.padding = this.docPadding;
                bodyStyle11.width = this.bodyWidth;
                docStyle11.width = this.docWidth;
                bodyStyle11.height = this.bodyHeight;
                docStyle11.height = this.docHeight;
                body11.removeChild(this.element);
                nodes11 = this.previousBody.length;
                for(i11 = 0; i11 < nodes11; i11++)body11.appendChild(this.previousBody.shift());
                $11.removeClass(this.element, "fullpage");
                THIS11[this.hash].prevElementParent.insertBefore(this.element, THIS11[this.hash].prevNextSibling);
                //If we've got a toolbar, we need to enable the user to use css to
                //reset it to its original state
                if (this.toolbar && this.toolbar.element) {
                    body11.removeChild(this.toolbar.element);
                    //Make sure the user has some ability to style the toolbar based
                    //on the mode
                    $11.removeClass(this.toolbar.element, "fullpage");
                    this.toolbar.parentNode.insertBefore(this.toolbar.element, this.toolbar.nextSibling);
                    delete this.toolbar.parentNode;
                    delete this.toolbar.nextSibling;
                }
                this.element.style.width = THIS11[this.hash].prevElementWidth;
                this.element.style.height = THIS11[this.hash].prevElementHeight;
                // After exiting fullPage or fullScreen, it can take some time
                // before the browser can actually set the scroll.
                var restoreScrollCounter11 = 0;
                var restoreScroll11 = function() {
                    $11.setPageScroll(_this11.pageScroll);
                    var pageScroll11 = $11.getPageScroll();
                    restoreScrollCounter11++;
                    if (restoreScrollCounter11 < 10 && (pageScroll11.x !== _this11.pageScroll.x || pageScroll11.y !== _this11.pageScroll.y)) $11.requestAnimationFrame(restoreScroll11);
                };
                $11.requestAnimationFrame(restoreScroll11);
                THIS11[this.hash].fullPage = false;
                // mouse will likely be outside now
                $11.delegate(this, onContainerExit11)({});
            }
            if (this.navigator && this.viewport) this.navigator.update(this.viewport);
            /**
         * Raised when the viewer has changed to/from full-page mode (see {@link OpenSeadragon.Viewer#setFullPage}).
         *
         * @event full-page
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
         * @property {Boolean} fullPage - True if changed to full-page mode, false if exited full-page mode.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */ this.raiseEvent("full-page", {
                fullPage: fullPage11
            });
            return this;
        },
        /**
     * Toggle full screen mode if supported. Toggle full page mode otherwise.
     * @function
     * @param {Boolean} fullScreen
     *      If true, enter full screen mode.  If false, exit full screen mode.
     * @return {OpenSeadragon.Viewer} Chainable.
     * @fires OpenSeadragon.Viewer.event:pre-full-screen
     * @fires OpenSeadragon.Viewer.event:full-screen
     */ setFullScreen: function(fullScreen11) {
            var _this11 = this;
            if (!$11.supportsFullScreen) return this.setFullPage(fullScreen11);
            if ($11.isFullScreen() === fullScreen11) return this;
            var fullScreeEventArgs11 = {
                fullScreen: fullScreen11,
                preventDefaultAction: false
            };
            /**
         * Raised when the viewer is about to change to/from full-screen mode (see {@link OpenSeadragon.Viewer#setFullScreen}).
         * Note: the pre-full-screen event is not raised when the user is exiting
         * full-screen mode by pressing the Esc key. In that case, consider using
         * the full-screen, pre-full-page or full-page events.
         *
         * @event pre-full-screen
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
         * @property {Boolean} fullScreen - True if entering full-screen mode, false if exiting full-screen mode.
         * @property {Boolean} preventDefaultAction - Set to true to prevent full-screen mode change. Default: false.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */ this.raiseEvent("pre-full-screen", fullScreeEventArgs11);
            if (fullScreeEventArgs11.preventDefaultAction) return this;
            if (fullScreen11) {
                this.setFullPage(true);
                // If the full page mode is not actually entered, we need to prevent
                // the full screen mode.
                if (!this.isFullPage()) return this;
                this.fullPageStyleWidth = this.element.style.width;
                this.fullPageStyleHeight = this.element.style.height;
                this.element.style.width = "100%";
                this.element.style.height = "100%";
                var onFullScreenChange11 = function() {
                    var isFullScreen11 = $11.isFullScreen();
                    if (!isFullScreen11) {
                        $11.removeEvent(document, $11.fullScreenEventName, onFullScreenChange11);
                        $11.removeEvent(document, $11.fullScreenErrorEventName, onFullScreenChange11);
                        _this11.setFullPage(false);
                        if (_this11.isFullPage()) {
                            _this11.element.style.width = _this11.fullPageStyleWidth;
                            _this11.element.style.height = _this11.fullPageStyleHeight;
                        }
                    }
                    if (_this11.navigator && _this11.viewport) _this11.navigator.update(_this11.viewport);
                    /**
                 * Raised when the viewer has changed to/from full-screen mode (see {@link OpenSeadragon.Viewer#setFullScreen}).
                 *
                 * @event full-screen
                 * @memberof OpenSeadragon.Viewer
                 * @type {object}
                 * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
                 * @property {Boolean} fullScreen - True if changed to full-screen mode, false if exited full-screen mode.
                 * @property {?Object} userData - Arbitrary subscriber-defined object.
                 */ _this11.raiseEvent("full-screen", {
                        fullScreen: isFullScreen11
                    });
                };
                $11.addEvent(document, $11.fullScreenEventName, onFullScreenChange11);
                $11.addEvent(document, $11.fullScreenErrorEventName, onFullScreenChange11);
                $11.requestFullScreen(document.body);
            } else $11.exitFullScreen();
            return this;
        },
        /**
     * @function
     * @return {Boolean}
     */ isVisible: function() {
            return this.container.style.visibility != "hidden";
        },
        /**
     * @function
     * @param {Boolean} visible
     * @return {OpenSeadragon.Viewer} Chainable.
     * @fires OpenSeadragon.Viewer.event:visible
     */ setVisible: function(visible11) {
            this.container.style.visibility = visible11 ? "" : "hidden";
            /**
         * Raised when the viewer is shown or hidden (see {@link OpenSeadragon.Viewer#setVisible}).
         *
         * @event visible
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
         * @property {Boolean} visible
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */ this.raiseEvent("visible", {
                visible: visible11
            });
            return this;
        },
        /**
     * Add a tiled image to the viewer.
     * options.tileSource can be anything that {@link OpenSeadragon.Viewer#open}
     *  supports except arrays of images.
     * Note that you can specify options.width or options.height, but not both.
     * The other dimension will be calculated according to the item's aspect ratio.
     * If collectionMode is on (see {@link OpenSeadragon.Options}), the new image is
     * automatically arranged with the others.
     * @function
     * @param {Object} options
     * @param {String|Object|Function} options.tileSource - The TileSource specifier.
     * A String implies a url used to determine the tileSource implementation
     *      based on the file extension of url. JSONP is implied by *.js,
     *      otherwise the url is retrieved as text and the resulting text is
     *      introspected to determine if its json, xml, or text and parsed.
     * An Object implies an inline configuration which has a single
     *      property sufficient for being able to determine tileSource
     *      implementation. If the object has a property which is a function
     *      named 'getTileUrl', it is treated as a custom TileSource.
     * @param {Number} [options.index] The index of the item. Added on top of
     * all other items if not specified.
     * @param {Boolean} [options.replace=false] If true, the item at options.index will be
     * removed and the new item is added in its place. options.tileSource will be
     * interpreted and fetched if necessary before the old item is removed to avoid leaving
     * a gap in the world.
     * @param {Number} [options.x=0] The X position for the image in viewport coordinates.
     * @param {Number} [options.y=0] The Y position for the image in viewport coordinates.
     * @param {Number} [options.width=1] The width for the image in viewport coordinates.
     * @param {Number} [options.height] The height for the image in viewport coordinates.
     * @param {OpenSeadragon.Rect} [options.fitBounds] The bounds in viewport coordinates
     * to fit the image into. If specified, x, y, width and height get ignored.
     * @param {OpenSeadragon.Placement} [options.fitBoundsPlacement=OpenSeadragon.Placement.CENTER]
     * How to anchor the image in the bounds if options.fitBounds is set.
     * @param {OpenSeadragon.Rect} [options.clip] - An area, in image pixels, to clip to
     * (portions of the image outside of this area will not be visible). Only works on
     * browsers that support the HTML5 canvas.
     * @param {Number} [options.opacity=1] Proportional opacity of the tiled images (1=opaque, 0=hidden)
     * @param {Boolean} [options.preload=false]  Default switch for loading hidden images (true loads, false blocks)
     * @param {Number} [options.degrees=0] Initial rotation of the tiled image around
     * its top left corner in degrees.
     * @param {String} [options.compositeOperation] How the image is composited onto other images.
     * @param {String} [options.crossOriginPolicy] The crossOriginPolicy for this specific image,
     * overriding viewer.crossOriginPolicy.
     * @param {Boolean} [options.ajaxWithCredentials] Whether to set withCredentials on tile AJAX
     * @param {Boolean} [options.loadTilesWithAjax]
     *      Whether to load tile data using AJAX requests.
     *      Defaults to the setting in {@link OpenSeadragon.Options}.
     * @param {Object} [options.ajaxHeaders]
     *      A set of headers to include when making tile AJAX requests.
     *      Note that these headers will be merged over any headers specified in {@link OpenSeadragon.Options}.
     *      Specifying a falsy value for a header will clear its existing value set at the Viewer level (if any).
     * requests.
     * @param {Function} [options.success] A function that gets called when the image is
     * successfully added. It's passed the event object which contains a single property:
     * "item", which is the resulting instance of TiledImage.
     * @param {Function} [options.error] A function that gets called if the image is
     * unable to be added. It's passed the error event object, which contains "message"
     * and "source" properties.
     * @param {Boolean} [options.collectionImmediately=false] If collectionMode is on,
     * specifies whether to snap to the new arrangement immediately or to animate to it.
     * @param {String|CanvasGradient|CanvasPattern|Function} [options.placeholderFillStyle] - See {@link OpenSeadragon.Options}.
     * @fires OpenSeadragon.World.event:add-item
     * @fires OpenSeadragon.Viewer.event:add-item-failed
     */ addTiledImage: function(options11) {
            $11.console.assert(options11, "[Viewer.addTiledImage] options is required");
            $11.console.assert(options11.tileSource, "[Viewer.addTiledImage] options.tileSource is required");
            $11.console.assert(!options11.replace || options11.index > -1 && options11.index < this.world.getItemCount(), "[Viewer.addTiledImage] if options.replace is used, options.index must be a valid index in Viewer.world");
            var _this11 = this;
            if (options11.replace) options11.replaceItem = _this11.world.getItemAt(options11.index);
            this._hideMessage();
            if (options11.placeholderFillStyle === undefined) options11.placeholderFillStyle = this.placeholderFillStyle;
            if (options11.opacity === undefined) options11.opacity = this.opacity;
            if (options11.preload === undefined) options11.preload = this.preload;
            if (options11.compositeOperation === undefined) options11.compositeOperation = this.compositeOperation;
            if (options11.crossOriginPolicy === undefined) options11.crossOriginPolicy = options11.tileSource.crossOriginPolicy !== undefined ? options11.tileSource.crossOriginPolicy : this.crossOriginPolicy;
            if (options11.ajaxWithCredentials === undefined) options11.ajaxWithCredentials = this.ajaxWithCredentials;
            if (options11.loadTilesWithAjax === undefined) options11.loadTilesWithAjax = this.loadTilesWithAjax;
            if (options11.ajaxHeaders === undefined || options11.ajaxHeaders === null) options11.ajaxHeaders = this.ajaxHeaders;
            else if ($11.isPlainObject(options11.ajaxHeaders) && $11.isPlainObject(this.ajaxHeaders)) options11.ajaxHeaders = $11.extend({}, this.ajaxHeaders, options11.ajaxHeaders);
            var myQueueItem11 = {
                options: options11
            };
            function raiseAddItemFailed11(event11) {
                for(var i11 = 0; i11 < _this11._loadQueue.length; i11++)if (_this11._loadQueue[i11] === myQueueItem11) {
                    _this11._loadQueue.splice(i11, 1);
                    break;
                }
                if (_this11._loadQueue.length === 0) refreshWorld11(myQueueItem11);
                /**
             * Raised when an error occurs while adding a item.
             * @event add-item-failed
             * @memberOf OpenSeadragon.Viewer
             * @type {object}
             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
             * @property {String} message
             * @property {String} source
             * @property {Object} options The options passed to the addTiledImage method.
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */ _this11.raiseEvent("add-item-failed", event11);
                if (options11.error) options11.error(event11);
            }
            function refreshWorld11(theItem11) {
                if (_this11.collectionMode) {
                    _this11.world.arrange({
                        immediately: theItem11.options.collectionImmediately,
                        rows: _this11.collectionRows,
                        columns: _this11.collectionColumns,
                        layout: _this11.collectionLayout,
                        tileSize: _this11.collectionTileSize,
                        tileMargin: _this11.collectionTileMargin
                    });
                    _this11.world.setAutoRefigureSizes(true);
                }
            }
            if ($11.isArray(options11.tileSource)) {
                setTimeout(function() {
                    raiseAddItemFailed11({
                        message: "[Viewer.addTiledImage] Sequences can not be added; add them one at a time instead.",
                        source: options11.tileSource,
                        options: options11
                    });
                });
                return;
            }
            this._loadQueue.push(myQueueItem11);
            function processReadyItems11() {
                var queueItem11, tiledImage11, optionsClone11;
                while(_this11._loadQueue.length){
                    queueItem11 = _this11._loadQueue[0];
                    if (!queueItem11.tileSource) break;
                    _this11._loadQueue.splice(0, 1);
                    if (queueItem11.options.replace) {
                        var newIndex11 = _this11.world.getIndexOfItem(queueItem11.options.replaceItem);
                        if (newIndex11 != -1) queueItem11.options.index = newIndex11;
                        _this11.world.removeItem(queueItem11.options.replaceItem);
                    }
                    tiledImage11 = new $11.TiledImage({
                        viewer: _this11,
                        source: queueItem11.tileSource,
                        viewport: _this11.viewport,
                        drawer: _this11.drawer,
                        tileCache: _this11.tileCache,
                        imageLoader: _this11.imageLoader,
                        x: queueItem11.options.x,
                        y: queueItem11.options.y,
                        width: queueItem11.options.width,
                        height: queueItem11.options.height,
                        fitBounds: queueItem11.options.fitBounds,
                        fitBoundsPlacement: queueItem11.options.fitBoundsPlacement,
                        clip: queueItem11.options.clip,
                        placeholderFillStyle: queueItem11.options.placeholderFillStyle,
                        opacity: queueItem11.options.opacity,
                        preload: queueItem11.options.preload,
                        degrees: queueItem11.options.degrees,
                        compositeOperation: queueItem11.options.compositeOperation,
                        springStiffness: _this11.springStiffness,
                        animationTime: _this11.animationTime,
                        minZoomImageRatio: _this11.minZoomImageRatio,
                        wrapHorizontal: _this11.wrapHorizontal,
                        wrapVertical: _this11.wrapVertical,
                        immediateRender: _this11.immediateRender,
                        blendTime: _this11.blendTime,
                        alwaysBlend: _this11.alwaysBlend,
                        minPixelRatio: _this11.minPixelRatio,
                        smoothTileEdgesMinZoom: _this11.smoothTileEdgesMinZoom,
                        iOSDevice: _this11.iOSDevice,
                        crossOriginPolicy: queueItem11.options.crossOriginPolicy,
                        ajaxWithCredentials: queueItem11.options.ajaxWithCredentials,
                        loadTilesWithAjax: queueItem11.options.loadTilesWithAjax,
                        ajaxHeaders: queueItem11.options.ajaxHeaders,
                        debugMode: _this11.debugMode
                    });
                    if (_this11.collectionMode) _this11.world.setAutoRefigureSizes(false);
                    _this11.world.addItem(tiledImage11, {
                        index: queueItem11.options.index
                    });
                    if (_this11._loadQueue.length === 0) //this restores the autoRefigureSizes flag to true.
                    refreshWorld11(queueItem11);
                    if (_this11.world.getItemCount() === 1 && !_this11.preserveViewport) _this11.viewport.goHome(true);
                    if (_this11.navigator) {
                        optionsClone11 = $11.extend({}, queueItem11.options, {
                            replace: false,
                            originalTiledImage: tiledImage11,
                            tileSource: queueItem11.tileSource
                        });
                        _this11.navigator.addTiledImage(optionsClone11);
                    }
                    if (queueItem11.options.success) queueItem11.options.success({
                        item: tiledImage11
                    });
                }
            }
            getTileSourceImplementation11(this, options11.tileSource, options11, function(tileSource11) {
                myQueueItem11.tileSource = tileSource11;
                // add everybody at the front of the queue that's ready to go
                processReadyItems11();
            }, function(event11) {
                event11.options = options11;
                raiseAddItemFailed11(event11);
                // add everybody at the front of the queue that's ready to go
                processReadyItems11();
            });
        },
        /**
     * Add a simple image to the viewer.
     * The options are the same as the ones in {@link OpenSeadragon.Viewer#addTiledImage}
     * except for options.tileSource which is replaced by options.url.
     * @function
     * @param {Object} options - See {@link OpenSeadragon.Viewer#addTiledImage}
     * for all the options
     * @param {String} options.url - The URL of the image to add.
     * @fires OpenSeadragon.World.event:add-item
     * @fires OpenSeadragon.Viewer.event:add-item-failed
     */ addSimpleImage: function(options11) {
            $11.console.assert(options11, "[Viewer.addSimpleImage] options is required");
            $11.console.assert(options11.url, "[Viewer.addSimpleImage] options.url is required");
            var opts11 = $11.extend({}, options11, {
                tileSource: {
                    type: "image",
                    url: options11.url
                }
            });
            delete opts11.url;
            this.addTiledImage(opts11);
        },
        // deprecated
        addLayer: function(options11) {
            var _this11 = this;
            $11.console.error("[Viewer.addLayer] this function is deprecated; use Viewer.addTiledImage() instead.");
            var optionsClone11 = $11.extend({}, options11, {
                success: function(event11) {
                    _this11.raiseEvent("add-layer", {
                        options: options11,
                        drawer: event11.item
                    });
                },
                error: function(event11) {
                    _this11.raiseEvent("add-layer-failed", event11);
                }
            });
            this.addTiledImage(optionsClone11);
            return this;
        },
        // deprecated
        getLayerAtLevel: function(level11) {
            $11.console.error("[Viewer.getLayerAtLevel] this function is deprecated; use World.getItemAt() instead.");
            return this.world.getItemAt(level11);
        },
        // deprecated
        getLevelOfLayer: function(drawer11) {
            $11.console.error("[Viewer.getLevelOfLayer] this function is deprecated; use World.getIndexOfItem() instead.");
            return this.world.getIndexOfItem(drawer11);
        },
        // deprecated
        getLayersCount: function() {
            $11.console.error("[Viewer.getLayersCount] this function is deprecated; use World.getItemCount() instead.");
            return this.world.getItemCount();
        },
        // deprecated
        setLayerLevel: function(drawer11, level11) {
            $11.console.error("[Viewer.setLayerLevel] this function is deprecated; use World.setItemIndex() instead.");
            return this.world.setItemIndex(drawer11, level11);
        },
        // deprecated
        removeLayer: function(drawer11) {
            $11.console.error("[Viewer.removeLayer] this function is deprecated; use World.removeItem() instead.");
            return this.world.removeItem(drawer11);
        },
        /**
     * Force the viewer to redraw its contents.
     * @returns {OpenSeadragon.Viewer} Chainable.
     */ forceRedraw: function() {
            THIS11[this.hash].forceRedraw = true;
            return this;
        },
        /**
     * @function
     * @return {OpenSeadragon.Viewer} Chainable.
     */ bindSequenceControls: function() {
            //////////////////////////////////////////////////////////////////////////
            // Image Sequence Controls
            //////////////////////////////////////////////////////////////////////////
            var onFocusHandler11 = $11.delegate(this, onFocus11), onBlurHandler11 = $11.delegate(this, onBlur11), onNextHandler11 = $11.delegate(this, onNext11), onPreviousHandler11 = $11.delegate(this, onPrevious11), navImages11 = this.navImages, useGroup11 = true;
            if (this.showSequenceControl) {
                if (this.previousButton || this.nextButton) //if we are binding to custom buttons then layout and
                //grouping is the responsibility of the page author
                useGroup11 = false;
                this.previousButton = new $11.Button({
                    element: this.previousButton ? $11.getElement(this.previousButton) : null,
                    clickTimeThreshold: this.clickTimeThreshold,
                    clickDistThreshold: this.clickDistThreshold,
                    tooltip: $11.getString("Tooltips.PreviousPage"),
                    srcRest: resolveUrl11(this.prefixUrl, navImages11.previous.REST),
                    srcGroup: resolveUrl11(this.prefixUrl, navImages11.previous.GROUP),
                    srcHover: resolveUrl11(this.prefixUrl, navImages11.previous.HOVER),
                    srcDown: resolveUrl11(this.prefixUrl, navImages11.previous.DOWN),
                    onRelease: onPreviousHandler11,
                    onFocus: onFocusHandler11,
                    onBlur: onBlurHandler11
                });
                this.nextButton = new $11.Button({
                    element: this.nextButton ? $11.getElement(this.nextButton) : null,
                    clickTimeThreshold: this.clickTimeThreshold,
                    clickDistThreshold: this.clickDistThreshold,
                    tooltip: $11.getString("Tooltips.NextPage"),
                    srcRest: resolveUrl11(this.prefixUrl, navImages11.next.REST),
                    srcGroup: resolveUrl11(this.prefixUrl, navImages11.next.GROUP),
                    srcHover: resolveUrl11(this.prefixUrl, navImages11.next.HOVER),
                    srcDown: resolveUrl11(this.prefixUrl, navImages11.next.DOWN),
                    onRelease: onNextHandler11,
                    onFocus: onFocusHandler11,
                    onBlur: onBlurHandler11
                });
                if (!this.navPrevNextWrap) this.previousButton.disable();
                if (!this.tileSources || !this.tileSources.length) this.nextButton.disable();
                if (useGroup11) {
                    this.paging = new $11.ButtonGroup({
                        buttons: [
                            this.previousButton,
                            this.nextButton
                        ],
                        clickTimeThreshold: this.clickTimeThreshold,
                        clickDistThreshold: this.clickDistThreshold
                    });
                    this.pagingControl = this.paging.element;
                    if (this.toolbar) this.toolbar.addControl(this.pagingControl, {
                        anchor: $11.ControlAnchor.BOTTOM_RIGHT
                    });
                    else this.addControl(this.pagingControl, {
                        anchor: this.sequenceControlAnchor || $11.ControlAnchor.TOP_LEFT
                    });
                }
            }
            return this;
        },
        /**
     * @function
     * @return {OpenSeadragon.Viewer} Chainable.
     */ bindStandardControls: function() {
            //////////////////////////////////////////////////////////////////////////
            // Navigation Controls
            //////////////////////////////////////////////////////////////////////////
            var beginZoomingInHandler11 = $11.delegate(this, beginZoomingIn11), endZoomingHandler11 = $11.delegate(this, endZooming11), doSingleZoomInHandler11 = $11.delegate(this, doSingleZoomIn11), beginZoomingOutHandler11 = $11.delegate(this, beginZoomingOut11), doSingleZoomOutHandler11 = $11.delegate(this, doSingleZoomOut11), onHomeHandler11 = $11.delegate(this, onHome11), onFullScreenHandler11 = $11.delegate(this, onFullScreen11), onRotateLeftHandler11 = $11.delegate(this, onRotateLeft11), onRotateRightHandler11 = $11.delegate(this, onRotateRight11), onFlipHandler11 = $11.delegate(this, onFlip11), onFocusHandler11 = $11.delegate(this, onFocus11), onBlurHandler11 = $11.delegate(this, onBlur11), navImages11 = this.navImages, buttons11 = [], useGroup11 = true;
            if (this.showNavigationControl) {
                if (this.zoomInButton || this.zoomOutButton || this.homeButton || this.fullPageButton || this.rotateLeftButton || this.rotateRightButton || this.flipButton) //if we are binding to custom buttons then layout and
                //grouping is the responsibility of the page author
                useGroup11 = false;
                if (this.showZoomControl) {
                    buttons11.push(this.zoomInButton = new $11.Button({
                        element: this.zoomInButton ? $11.getElement(this.zoomInButton) : null,
                        clickTimeThreshold: this.clickTimeThreshold,
                        clickDistThreshold: this.clickDistThreshold,
                        tooltip: $11.getString("Tooltips.ZoomIn"),
                        srcRest: resolveUrl11(this.prefixUrl, navImages11.zoomIn.REST),
                        srcGroup: resolveUrl11(this.prefixUrl, navImages11.zoomIn.GROUP),
                        srcHover: resolveUrl11(this.prefixUrl, navImages11.zoomIn.HOVER),
                        srcDown: resolveUrl11(this.prefixUrl, navImages11.zoomIn.DOWN),
                        onPress: beginZoomingInHandler11,
                        onRelease: endZoomingHandler11,
                        onClick: doSingleZoomInHandler11,
                        onEnter: beginZoomingInHandler11,
                        onExit: endZoomingHandler11,
                        onFocus: onFocusHandler11,
                        onBlur: onBlurHandler11
                    }));
                    buttons11.push(this.zoomOutButton = new $11.Button({
                        element: this.zoomOutButton ? $11.getElement(this.zoomOutButton) : null,
                        clickTimeThreshold: this.clickTimeThreshold,
                        clickDistThreshold: this.clickDistThreshold,
                        tooltip: $11.getString("Tooltips.ZoomOut"),
                        srcRest: resolveUrl11(this.prefixUrl, navImages11.zoomOut.REST),
                        srcGroup: resolveUrl11(this.prefixUrl, navImages11.zoomOut.GROUP),
                        srcHover: resolveUrl11(this.prefixUrl, navImages11.zoomOut.HOVER),
                        srcDown: resolveUrl11(this.prefixUrl, navImages11.zoomOut.DOWN),
                        onPress: beginZoomingOutHandler11,
                        onRelease: endZoomingHandler11,
                        onClick: doSingleZoomOutHandler11,
                        onEnter: beginZoomingOutHandler11,
                        onExit: endZoomingHandler11,
                        onFocus: onFocusHandler11,
                        onBlur: onBlurHandler11
                    }));
                }
                if (this.showHomeControl) buttons11.push(this.homeButton = new $11.Button({
                    element: this.homeButton ? $11.getElement(this.homeButton) : null,
                    clickTimeThreshold: this.clickTimeThreshold,
                    clickDistThreshold: this.clickDistThreshold,
                    tooltip: $11.getString("Tooltips.Home"),
                    srcRest: resolveUrl11(this.prefixUrl, navImages11.home.REST),
                    srcGroup: resolveUrl11(this.prefixUrl, navImages11.home.GROUP),
                    srcHover: resolveUrl11(this.prefixUrl, navImages11.home.HOVER),
                    srcDown: resolveUrl11(this.prefixUrl, navImages11.home.DOWN),
                    onRelease: onHomeHandler11,
                    onFocus: onFocusHandler11,
                    onBlur: onBlurHandler11
                }));
                if (this.showFullPageControl) buttons11.push(this.fullPageButton = new $11.Button({
                    element: this.fullPageButton ? $11.getElement(this.fullPageButton) : null,
                    clickTimeThreshold: this.clickTimeThreshold,
                    clickDistThreshold: this.clickDistThreshold,
                    tooltip: $11.getString("Tooltips.FullPage"),
                    srcRest: resolveUrl11(this.prefixUrl, navImages11.fullpage.REST),
                    srcGroup: resolveUrl11(this.prefixUrl, navImages11.fullpage.GROUP),
                    srcHover: resolveUrl11(this.prefixUrl, navImages11.fullpage.HOVER),
                    srcDown: resolveUrl11(this.prefixUrl, navImages11.fullpage.DOWN),
                    onRelease: onFullScreenHandler11,
                    onFocus: onFocusHandler11,
                    onBlur: onBlurHandler11
                }));
                if (this.showRotationControl) {
                    buttons11.push(this.rotateLeftButton = new $11.Button({
                        element: this.rotateLeftButton ? $11.getElement(this.rotateLeftButton) : null,
                        clickTimeThreshold: this.clickTimeThreshold,
                        clickDistThreshold: this.clickDistThreshold,
                        tooltip: $11.getString("Tooltips.RotateLeft"),
                        srcRest: resolveUrl11(this.prefixUrl, navImages11.rotateleft.REST),
                        srcGroup: resolveUrl11(this.prefixUrl, navImages11.rotateleft.GROUP),
                        srcHover: resolveUrl11(this.prefixUrl, navImages11.rotateleft.HOVER),
                        srcDown: resolveUrl11(this.prefixUrl, navImages11.rotateleft.DOWN),
                        onRelease: onRotateLeftHandler11,
                        onFocus: onFocusHandler11,
                        onBlur: onBlurHandler11
                    }));
                    buttons11.push(this.rotateRightButton = new $11.Button({
                        element: this.rotateRightButton ? $11.getElement(this.rotateRightButton) : null,
                        clickTimeThreshold: this.clickTimeThreshold,
                        clickDistThreshold: this.clickDistThreshold,
                        tooltip: $11.getString("Tooltips.RotateRight"),
                        srcRest: resolveUrl11(this.prefixUrl, navImages11.rotateright.REST),
                        srcGroup: resolveUrl11(this.prefixUrl, navImages11.rotateright.GROUP),
                        srcHover: resolveUrl11(this.prefixUrl, navImages11.rotateright.HOVER),
                        srcDown: resolveUrl11(this.prefixUrl, navImages11.rotateright.DOWN),
                        onRelease: onRotateRightHandler11,
                        onFocus: onFocusHandler11,
                        onBlur: onBlurHandler11
                    }));
                }
                if (this.showFlipControl) buttons11.push(this.flipButton = new $11.Button({
                    element: this.flipButton ? $11.getElement(this.flipButton) : null,
                    clickTimeThreshold: this.clickTimeThreshold,
                    clickDistThreshold: this.clickDistThreshold,
                    tooltip: $11.getString("Tooltips.Flip"),
                    srcRest: resolveUrl11(this.prefixUrl, navImages11.flip.REST),
                    srcGroup: resolveUrl11(this.prefixUrl, navImages11.flip.GROUP),
                    srcHover: resolveUrl11(this.prefixUrl, navImages11.flip.HOVER),
                    srcDown: resolveUrl11(this.prefixUrl, navImages11.flip.DOWN),
                    onRelease: onFlipHandler11,
                    onFocus: onFocusHandler11,
                    onBlur: onBlurHandler11
                }));
                if (useGroup11) {
                    this.buttons = new $11.ButtonGroup({
                        buttons: buttons11,
                        clickTimeThreshold: this.clickTimeThreshold,
                        clickDistThreshold: this.clickDistThreshold
                    });
                    this.navControl = this.buttons.element;
                    this.addHandler("open", $11.delegate(this, lightUp11));
                    if (this.toolbar) this.toolbar.addControl(this.navControl, {
                        anchor: this.navigationControlAnchor || $11.ControlAnchor.TOP_LEFT
                    });
                    else this.addControl(this.navControl, {
                        anchor: this.navigationControlAnchor || $11.ControlAnchor.TOP_LEFT
                    });
                }
            }
            return this;
        },
        /**
     * Gets the active page of a sequence
     * @function
     * @return {Number}
     */ currentPage: function() {
            return this._sequenceIndex;
        },
        /**
     * @function
     * @return {OpenSeadragon.Viewer} Chainable.
     * @fires OpenSeadragon.Viewer.event:page
     */ goToPage: function(page11) {
            if (this.tileSources && page11 >= 0 && page11 < this.tileSources.length) {
                this._sequenceIndex = page11;
                this._updateSequenceButtons(page11);
                this.open(this.tileSources[page11]);
                if (this.referenceStrip) this.referenceStrip.setFocus(page11);
                /**
             * Raised when the page is changed on a viewer configured with multiple image sources (see {@link OpenSeadragon.Viewer#goToPage}).
             *
             * @event page
             * @memberof OpenSeadragon.Viewer
             * @type {Object}
             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
             * @property {Number} page - The page index.
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */ this.raiseEvent("page", {
                    page: page11
                });
            }
            return this;
        },
        /**
     * Adds an html element as an overlay to the current viewport.  Useful for
     * highlighting words or areas of interest on an image or other zoomable
     * interface. The overlays added via this method are removed when the viewport
     * is closed which include when changing page.
     * @method
     * @param {Element|String|Object} element - A reference to an element or an id for
     *      the element which will be overlayed. Or an Object specifying the configuration for the overlay.
     *      If using an object, see {@link OpenSeadragon.Overlay} for a list of
     *      all available options.
     * @param {OpenSeadragon.Point|OpenSeadragon.Rect} location - The point or
     *      rectangle which will be overlayed. This is a viewport relative location.
     * @param {OpenSeadragon.Placement} placement - The position of the
     *      viewport which the location coordinates will be treated as relative
     *      to.
     * @param {function} onDraw - If supplied the callback is called when the overlay
     *      needs to be drawn. It it the responsibility of the callback to do any drawing/positioning.
     *      It is passed position, size and element.
     * @return {OpenSeadragon.Viewer} Chainable.
     * @fires OpenSeadragon.Viewer.event:add-overlay
     */ addOverlay: function(element11, location11, placement11, onDraw11) {
            var options11;
            if ($11.isPlainObject(element11)) options11 = element11;
            else options11 = {
                element: element11,
                location: location11,
                placement: placement11,
                onDraw: onDraw11
            };
            element11 = $11.getElement(options11.element);
            if (getOverlayIndex11(this.currentOverlays, element11) >= 0) // they're trying to add a duplicate overlay
            return this;
            var overlay11 = getOverlayObject11(this, options11);
            this.currentOverlays.push(overlay11);
            overlay11.drawHTML(this.overlaysContainer, this.viewport);
            /**
         * Raised when an overlay is added to the viewer (see {@link OpenSeadragon.Viewer#addOverlay}).
         *
         * @event add-overlay
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
         * @property {Element} element - The overlay element.
         * @property {OpenSeadragon.Point|OpenSeadragon.Rect} location
         * @property {OpenSeadragon.Placement} placement
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */ this.raiseEvent("add-overlay", {
                element: element11,
                location: options11.location,
                placement: options11.placement
            });
            return this;
        },
        /**
     * Updates the overlay represented by the reference to the element or
     * element id moving it to the new location, relative to the new placement.
     * @method
     * @param {Element|String} element - A reference to an element or an id for
     *      the element which is overlayed.
     * @param {OpenSeadragon.Point|OpenSeadragon.Rect} location - The point or
     *      rectangle which will be overlayed. This is a viewport relative location.
     * @param {OpenSeadragon.Placement} placement - The position of the
     *      viewport which the location coordinates will be treated as relative
     *      to.
     * @return {OpenSeadragon.Viewer} Chainable.
     * @fires OpenSeadragon.Viewer.event:update-overlay
     */ updateOverlay: function(element11, location11, placement11) {
            var i11;
            element11 = $11.getElement(element11);
            i11 = getOverlayIndex11(this.currentOverlays, element11);
            if (i11 >= 0) {
                this.currentOverlays[i11].update(location11, placement11);
                THIS11[this.hash].forceRedraw = true;
                /**
             * Raised when an overlay's location or placement changes
             * (see {@link OpenSeadragon.Viewer#updateOverlay}).
             *
             * @event update-overlay
             * @memberof OpenSeadragon.Viewer
             * @type {object}
             * @property {OpenSeadragon.Viewer} eventSource - A reference to the
             * Viewer which raised the event.
             * @property {Element} element
             * @property {OpenSeadragon.Point|OpenSeadragon.Rect} location
             * @property {OpenSeadragon.Placement} placement
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */ this.raiseEvent("update-overlay", {
                    element: element11,
                    location: location11,
                    placement: placement11
                });
            }
            return this;
        },
        /**
     * Removes an overlay identified by the reference element or element id
     * and schedules an update.
     * @method
     * @param {Element|String} element - A reference to the element or an
     *      element id which represent the ovelay content to be removed.
     * @return {OpenSeadragon.Viewer} Chainable.
     * @fires OpenSeadragon.Viewer.event:remove-overlay
     */ removeOverlay: function(element11) {
            var i11;
            element11 = $11.getElement(element11);
            i11 = getOverlayIndex11(this.currentOverlays, element11);
            if (i11 >= 0) {
                this.currentOverlays[i11].destroy();
                this.currentOverlays.splice(i11, 1);
                THIS11[this.hash].forceRedraw = true;
                /**
             * Raised when an overlay is removed from the viewer
             * (see {@link OpenSeadragon.Viewer#removeOverlay}).
             *
             * @event remove-overlay
             * @memberof OpenSeadragon.Viewer
             * @type {object}
             * @property {OpenSeadragon.Viewer} eventSource - A reference to the
             * Viewer which raised the event.
             * @property {Element} element - The overlay element.
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */ this.raiseEvent("remove-overlay", {
                    element: element11
                });
            }
            return this;
        },
        /**
     * Removes all currently configured Overlays from this Viewer and schedules
     * an update.
     * @method
     * @return {OpenSeadragon.Viewer} Chainable.
     * @fires OpenSeadragon.Viewer.event:clear-overlay
     */ clearOverlays: function() {
            while(this.currentOverlays.length > 0)this.currentOverlays.pop().destroy();
            THIS11[this.hash].forceRedraw = true;
            /**
         * Raised when all overlays are removed from the viewer (see {@link OpenSeadragon.Drawer#clearOverlays}).
         *
         * @event clear-overlay
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */ this.raiseEvent("clear-overlay", {});
            return this;
        },
        /**
     * Finds an overlay identified by the reference element or element id
     * and returns it as an object, return null if not found.
     * @method
     * @param {Element|String} element - A reference to the element or an
     *      element id which represents the overlay content.
     * @return {OpenSeadragon.Overlay} the matching overlay or null if none found.
     */ getOverlayById: function(element11) {
            var i11;
            element11 = $11.getElement(element11);
            i11 = getOverlayIndex11(this.currentOverlays, element11);
            if (i11 >= 0) return this.currentOverlays[i11];
            else return null;
        },
        /**
     * Updates the sequence buttons.
     * @function OpenSeadragon.Viewer.prototype._updateSequenceButtons
     * @private
     * @param {Number} Sequence Value
     */ _updateSequenceButtons: function(page11) {
            if (this.nextButton) {
                if (!this.tileSources || this.tileSources.length - 1 === page11) //Disable next button
                {
                    if (!this.navPrevNextWrap) this.nextButton.disable();
                } else this.nextButton.enable();
            }
            if (this.previousButton) {
                if (page11 > 0) //Enable previous button
                this.previousButton.enable();
                else if (!this.navPrevNextWrap) this.previousButton.disable();
            }
        },
        /**
     * Display a message in the viewport
     * @function OpenSeadragon.Viewer.prototype._showMessage
     * @private
     * @param {String} text message
     */ _showMessage: function(message11) {
            this._hideMessage();
            var div11 = $11.makeNeutralElement("div");
            div11.appendChild(document.createTextNode(message11));
            this.messageDiv = $11.makeCenteredNode(div11);
            $11.addClass(this.messageDiv, "openseadragon-message");
            this.container.appendChild(this.messageDiv);
        },
        /**
     * Hide any currently displayed viewport message
     * @function OpenSeadragon.Viewer.prototype._hideMessage
     * @private
     */ _hideMessage: function() {
            var div11 = this.messageDiv;
            if (div11) {
                div11.parentNode.removeChild(div11);
                delete this.messageDiv;
            }
        },
        /**
     * Gets this viewer's gesture settings for the given pointer device type.
     * @method
     * @param {String} type - The pointer device type to get the gesture settings for ("mouse", "touch", "pen", etc.).
     * @return {OpenSeadragon.GestureSettings}
     */ gestureSettingsByDeviceType: function(type11) {
            switch(type11){
                case "mouse":
                    return this.gestureSettingsMouse;
                case "touch":
                    return this.gestureSettingsTouch;
                case "pen":
                    return this.gestureSettingsPen;
                default:
                    return this.gestureSettingsUnknown;
            }
        },
        // private
        _drawOverlays: function() {
            var i11, length11 = this.currentOverlays.length;
            for(i11 = 0; i11 < length11; i11++)this.currentOverlays[i11].drawHTML(this.overlaysContainer, this.viewport);
        },
        /**
     * Cancel the "in flight" images.
     */ _cancelPendingImages: function() {
            this._loadQueue = [];
        },
        /**
     * Removes the reference strip and disables displaying it.
     * @function
     */ removeReferenceStrip: function() {
            this.showReferenceStrip = false;
            if (this.referenceStrip) {
                this.referenceStrip.destroy();
                this.referenceStrip = null;
            }
        },
        /**
     * Enables and displays the reference strip based on the currently set tileSources.
     * Works only when the Viewer has sequenceMode set to true.
     * @function
     */ addReferenceStrip: function() {
            this.showReferenceStrip = true;
            if (this.sequenceMode) {
                if (this.referenceStrip) return;
                if (this.tileSources.length && this.tileSources.length > 1) {
                    this.referenceStrip = new $11.ReferenceStrip({
                        id: this.referenceStripElement,
                        position: this.referenceStripPosition,
                        sizeRatio: this.referenceStripSizeRatio,
                        scroll: this.referenceStripScroll,
                        height: this.referenceStripHeight,
                        width: this.referenceStripWidth,
                        tileSources: this.tileSources,
                        prefixUrl: this.prefixUrl,
                        viewer: this
                    });
                    this.referenceStrip.setFocus(this._sequenceIndex);
                }
            } else $11.console.warn('Attempting to display a reference strip while "sequenceMode" is off.');
        }
    });
    /**
 * _getSafeElemSize is like getElementSize(), but refuses to return 0 for x or y,
 * which was causing some calling operations to return NaN.
 * @returns {Point}
 * @private
 */ function _getSafeElemSize11(oElement11) {
        oElement11 = $11.getElement(oElement11);
        return new $11.Point(oElement11.clientWidth === 0 ? 1 : oElement11.clientWidth, oElement11.clientHeight === 0 ? 1 : oElement11.clientHeight);
    }
    /**
 * @function
 * @private
 */ function getTileSourceImplementation11(viewer11, tileSource11, imgOptions11, successCallback11, failCallback11) {
        var _this11 = viewer11;
        //allow plain xml strings or json strings to be parsed here
        if ($11.type(tileSource11) == "string") {
            //xml should start with "<" and end with ">"
            if (tileSource11.match(/^\s*<.*>\s*$/)) tileSource11 = $11.parseXml(tileSource11);
            else if (tileSource11.match(/^\s*[\{\[].*[\}\]]\s*$/)) try {
                var tileSourceJ11 = $11.parseJSON(tileSource11);
                tileSource11 = tileSourceJ11;
            } catch (e11) {
            //tileSource = tileSource;
            }
        }
        function waitUntilReady11(tileSource11, originalTileSource11) {
            if (tileSource11.ready) successCallback11(tileSource11);
            else {
                tileSource11.addHandler("ready", function() {
                    successCallback11(tileSource11);
                });
                tileSource11.addHandler("open-failed", function(event11) {
                    failCallback11({
                        message: event11.message,
                        source: originalTileSource11
                    });
                });
            }
        }
        setTimeout(function() {
            if ($11.type(tileSource11) == "string") {
                //If its still a string it means it must be a url at this point
                tileSource11 = new $11.TileSource({
                    url: tileSource11,
                    crossOriginPolicy: imgOptions11.crossOriginPolicy !== undefined ? imgOptions11.crossOriginPolicy : viewer11.crossOriginPolicy,
                    ajaxWithCredentials: viewer11.ajaxWithCredentials,
                    ajaxHeaders: viewer11.ajaxHeaders,
                    useCanvas: viewer11.useCanvas,
                    success: function(event11) {
                        successCallback11(event11.tileSource);
                    }
                });
                tileSource11.addHandler("open-failed", function(event11) {
                    failCallback11(event11);
                });
            } else if ($11.isPlainObject(tileSource11) || tileSource11.nodeType) {
                if (tileSource11.crossOriginPolicy === undefined && (imgOptions11.crossOriginPolicy !== undefined || viewer11.crossOriginPolicy !== undefined)) tileSource11.crossOriginPolicy = imgOptions11.crossOriginPolicy !== undefined ? imgOptions11.crossOriginPolicy : viewer11.crossOriginPolicy;
                if (tileSource11.ajaxWithCredentials === undefined) tileSource11.ajaxWithCredentials = viewer11.ajaxWithCredentials;
                if (tileSource11.useCanvas === undefined) tileSource11.useCanvas = viewer11.useCanvas;
                if ($11.isFunction(tileSource11.getTileUrl)) {
                    //Custom tile source
                    var customTileSource11 = new $11.TileSource(tileSource11);
                    customTileSource11.getTileUrl = tileSource11.getTileUrl;
                    successCallback11(customTileSource11);
                } else {
                    //inline configuration
                    var $TileSource11 = $11.TileSource.determineType(_this11, tileSource11);
                    if (!$TileSource11) {
                        failCallback11({
                            message: "Unable to load TileSource",
                            source: tileSource11
                        });
                        return;
                    }
                    var options11 = $TileSource11.prototype.configure.apply(_this11, [
                        tileSource11
                    ]);
                    waitUntilReady11(new $TileSource11(options11), tileSource11);
                }
            } else //can assume it's already a tile source implementation
            waitUntilReady11(tileSource11, tileSource11);
        });
    }
    function getOverlayObject11(viewer11, overlay11) {
        if (overlay11 instanceof $11.Overlay) return overlay11;
        var element11 = null;
        if (overlay11.element) element11 = $11.getElement(overlay11.element);
        else {
            var id11 = overlay11.id ? overlay11.id : "openseadragon-overlay-" + Math.floor(Math.random() * 10000000);
            element11 = $11.getElement(overlay11.id);
            if (!element11) {
                element11 = document.createElement("a");
                element11.href = "#/overlay/" + id11;
            }
            element11.id = id11;
            $11.addClass(element11, overlay11.className ? overlay11.className : "openseadragon-overlay");
        }
        var location11 = overlay11.location;
        var width11 = overlay11.width;
        var height11 = overlay11.height;
        if (!location11) {
            var x11 = overlay11.x;
            var y11 = overlay11.y;
            if (overlay11.px !== undefined) {
                var rect11 = viewer11.viewport.imageToViewportRectangle(new $11.Rect(overlay11.px, overlay11.py, width11 || 0, height11 || 0));
                x11 = rect11.x;
                y11 = rect11.y;
                width11 = width11 !== undefined ? rect11.width : undefined;
                height11 = height11 !== undefined ? rect11.height : undefined;
            }
            location11 = new $11.Point(x11, y11);
        }
        var placement11 = overlay11.placement;
        if (placement11 && $11.type(placement11) === "string") placement11 = $11.Placement[overlay11.placement.toUpperCase()];
        return new $11.Overlay({
            element: element11,
            location: location11,
            placement: placement11,
            onDraw: overlay11.onDraw,
            checkResize: overlay11.checkResize,
            width: width11,
            height: height11,
            rotationMode: overlay11.rotationMode
        });
    }
    /**
 * @private
 * @inner
 * Determines the index of the given overlay in the given overlays array.
 */ function getOverlayIndex11(overlays11, element11) {
        var i11;
        for(i11 = overlays11.length - 1; i11 >= 0; i11--){
            if (overlays11[i11].element === element11) return i11;
        }
        return -1;
    }
    ///////////////////////////////////////////////////////////////////////////////
    // Schedulers provide the general engine for animation
    ///////////////////////////////////////////////////////////////////////////////
    function scheduleUpdate11(viewer11, updateFunc11) {
        return $11.requestAnimationFrame(function() {
            updateFunc11(viewer11);
        });
    }
    //provides a sequence in the fade animation
    function scheduleControlsFade11(viewer11) {
        $11.requestAnimationFrame(function() {
            updateControlsFade11(viewer11);
        });
    }
    //initiates an animation to hide the controls
    function beginControlsAutoHide11(viewer11) {
        if (!viewer11.autoHideControls) return;
        viewer11.controlsShouldFade = true;
        viewer11.controlsFadeBeginTime = $11.now() + viewer11.controlsFadeDelay;
        window.setTimeout(function() {
            scheduleControlsFade11(viewer11);
        }, viewer11.controlsFadeDelay);
    }
    //determines if fade animation is done or continues the animation
    function updateControlsFade11(viewer11) {
        var currentTime11, deltaTime11, opacity11, i11;
        if (viewer11.controlsShouldFade) {
            currentTime11 = $11.now();
            deltaTime11 = currentTime11 - viewer11.controlsFadeBeginTime;
            opacity11 = 1.0 - deltaTime11 / viewer11.controlsFadeLength;
            opacity11 = Math.min(1.0, opacity11);
            opacity11 = Math.max(0.0, opacity11);
            for(i11 = viewer11.controls.length - 1; i11 >= 0; i11--)if (viewer11.controls[i11].autoFade) viewer11.controls[i11].setOpacity(opacity11);
            if (opacity11 > 0) // fade again
            scheduleControlsFade11(viewer11);
        }
    }
    //stop the fade animation on the controls and show them
    function abortControlsAutoHide11(viewer11) {
        var i11;
        viewer11.controlsShouldFade = false;
        for(i11 = viewer11.controls.length - 1; i11 >= 0; i11--)viewer11.controls[i11].setOpacity(1.0);
    }
    ///////////////////////////////////////////////////////////////////////////////
    // Default view event handlers.
    ///////////////////////////////////////////////////////////////////////////////
    function onFocus11() {
        abortControlsAutoHide11(this);
    }
    function onBlur11() {
        beginControlsAutoHide11(this);
    }
    function onCanvasKeyDown11(event11) {
        var canvasKeyDownEventArgs11 = {
            originalEvent: event11.originalEvent,
            preventDefaultAction: event11.preventDefaultAction,
            preventVerticalPan: event11.preventVerticalPan,
            preventHorizontalPan: event11.preventHorizontalPan
        };
        /**
     * Raised when a keyboard key is pressed and the focus is on the {@link OpenSeadragon.Viewer#canvas} element.
     *
     * @event canvas-key
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {Object} originalEvent - The original DOM event.
     * @property {Boolean} preventDefaultAction - Set to true to prevent default keyboard behaviour. Default: false.
     * @property {Boolean} preventVerticalPan - Set to true to prevent keyboard vertical panning. Default: false.
     * @property {Boolean} preventHorizontalPan - Set to true to prevent keyboard horizontal panning. Default: false.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */ this.raiseEvent("canvas-key", canvasKeyDownEventArgs11);
        if (!canvasKeyDownEventArgs11.preventDefaultAction && !event11.ctrl && !event11.alt && !event11.meta) switch(event11.keyCode){
            case 38:
                if (!canvasKeyDownEventArgs11.preventVerticalPan) {
                    if (event11.shift) this.viewport.zoomBy(1.1);
                    else this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $11.Point(0, -this.pixelsPerArrowPress)));
                    this.viewport.applyConstraints();
                }
                return false;
            case 40:
                if (!canvasKeyDownEventArgs11.preventVerticalPan) {
                    if (event11.shift) this.viewport.zoomBy(0.9);
                    else this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $11.Point(0, this.pixelsPerArrowPress)));
                    this.viewport.applyConstraints();
                }
                return false;
            case 37:
                if (!canvasKeyDownEventArgs11.preventHorizontalPan) {
                    this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $11.Point(-this.pixelsPerArrowPress, 0)));
                    this.viewport.applyConstraints();
                }
                return false;
            case 39:
                if (!canvasKeyDownEventArgs11.preventHorizontalPan) {
                    this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $11.Point(this.pixelsPerArrowPress, 0)));
                    this.viewport.applyConstraints();
                }
                return false;
            default:
                //console.log( 'navigator keycode %s', event.keyCode );
                return true;
        }
        else return true;
    }
    function onCanvasKeyPress11(event11) {
        var canvasKeyPressEventArgs11 = {
            originalEvent: event11.originalEvent,
            preventDefaultAction: event11.preventDefaultAction,
            preventVerticalPan: event11.preventVerticalPan,
            preventHorizontalPan: event11.preventHorizontalPan
        };
        // This event is documented in onCanvasKeyDown
        this.raiseEvent("canvas-key", canvasKeyPressEventArgs11);
        if (!canvasKeyPressEventArgs11.preventDefaultAction && !event11.ctrl && !event11.alt && !event11.meta) switch(event11.keyCode){
            case 43:
            case 61:
                this.viewport.zoomBy(1.1);
                this.viewport.applyConstraints();
                return false;
            case 45:
                this.viewport.zoomBy(0.9);
                this.viewport.applyConstraints();
                return false;
            case 48:
                this.viewport.goHome();
                this.viewport.applyConstraints();
                return false;
            case 119:
            case 87:
                if (!canvasKeyPressEventArgs11.preventVerticalPan) {
                    if (event11.shift) this.viewport.zoomBy(1.1);
                    else this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $11.Point(0, -40)));
                    this.viewport.applyConstraints();
                }
                return false;
            case 115:
            case 83:
                if (!canvasKeyPressEventArgs11.preventVerticalPan) {
                    if (event11.shift) this.viewport.zoomBy(0.9);
                    else this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $11.Point(0, 40)));
                    this.viewport.applyConstraints();
                }
                return false;
            case 97:
                if (!canvasKeyPressEventArgs11.preventHorizontalPan) {
                    this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $11.Point(-40, 0)));
                    this.viewport.applyConstraints();
                }
                return false;
            case 100:
                if (!canvasKeyPressEventArgs11.preventHorizontalPan) {
                    this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $11.Point(40, 0)));
                    this.viewport.applyConstraints();
                }
                return false;
            case 114:
                if (this.viewport.flipped) this.viewport.setRotation(this.viewport.degrees - 90);
                else this.viewport.setRotation(this.viewport.degrees + 90);
                this.viewport.applyConstraints();
                return false;
            case 82:
                if (this.viewport.flipped) this.viewport.setRotation(this.viewport.degrees + 90);
                else this.viewport.setRotation(this.viewport.degrees - 90);
                this.viewport.applyConstraints();
                return false;
            case 102:
                this.viewport.toggleFlip();
                return false;
            default:
                // console.log( 'navigator keycode %s', event.keyCode );
                return true;
        }
        else return true;
    }
    function onCanvasClick11(event11) {
        var gestureSettings11;
        var haveKeyboardFocus11 = document.activeElement == this.canvas;
        // If we don't have keyboard focus, request it.
        if (!haveKeyboardFocus11) this.canvas.focus();
        if (this.viewport.flipped) event11.position.x = this.viewport.getContainerSize().x - event11.position.x;
        var canvasClickEventArgs11 = {
            tracker: event11.eventSource,
            position: event11.position,
            quick: event11.quick,
            shift: event11.shift,
            originalEvent: event11.originalEvent,
            preventDefaultAction: event11.preventDefaultAction
        };
        /**
     * Raised when a mouse press/release or touch/remove occurs on the {@link OpenSeadragon.Viewer#canvas} element.
     *
     * @event canvas-click
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {Boolean} quick - True only if the clickDistThreshold and clickTimeThreshold are both passed. Useful for differentiating between clicks and drags.
     * @property {Boolean} shift - True if the shift key was pressed during this event.
     * @property {Object} originalEvent - The original DOM event.
     * @property {Boolean} preventDefaultAction - Set to true to prevent default click to zoom behaviour. Default: false.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */ this.raiseEvent("canvas-click", canvasClickEventArgs11);
        if (!canvasClickEventArgs11.preventDefaultAction && this.viewport && event11.quick) {
            gestureSettings11 = this.gestureSettingsByDeviceType(event11.pointerType);
            if (gestureSettings11.clickToZoom) {
                this.viewport.zoomBy(event11.shift ? 1.0 / this.zoomPerClick : this.zoomPerClick, gestureSettings11.zoomToRefPoint ? this.viewport.pointFromPixel(event11.position, true) : null);
                this.viewport.applyConstraints();
            }
        }
    }
    function onCanvasDblClick11(event11) {
        var gestureSettings11;
        var canvasDblClickEventArgs11 = {
            tracker: event11.eventSource,
            position: event11.position,
            shift: event11.shift,
            originalEvent: event11.originalEvent,
            preventDefaultAction: event11.preventDefaultAction
        };
        /**
     * Raised when a double mouse press/release or touch/remove occurs on the {@link OpenSeadragon.Viewer#canvas} element.
     *
     * @event canvas-double-click
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {Boolean} shift - True if the shift key was pressed during this event.
     * @property {Object} originalEvent - The original DOM event.
     * @property {Boolean} preventDefaultAction - Set to true to prevent default double tap to zoom behaviour. Default: false.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */ this.raiseEvent("canvas-double-click", canvasDblClickEventArgs11);
        if (!canvasDblClickEventArgs11.preventDefaultAction && this.viewport) {
            gestureSettings11 = this.gestureSettingsByDeviceType(event11.pointerType);
            if (gestureSettings11.dblClickToZoom) {
                this.viewport.zoomBy(event11.shift ? 1.0 / this.zoomPerClick : this.zoomPerClick, gestureSettings11.zoomToRefPoint ? this.viewport.pointFromPixel(event11.position, true) : null);
                this.viewport.applyConstraints();
            }
        }
    }
    function onCanvasDrag11(event11) {
        var gestureSettings11;
        var canvasDragEventArgs11 = {
            tracker: event11.eventSource,
            position: event11.position,
            delta: event11.delta,
            speed: event11.speed,
            direction: event11.direction,
            shift: event11.shift,
            originalEvent: event11.originalEvent,
            preventDefaultAction: event11.preventDefaultAction
        };
        /**
     * Raised when a mouse or touch drag operation occurs on the {@link OpenSeadragon.Viewer#canvas} element.
     *
     * @event canvas-drag
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {OpenSeadragon.Point} delta - The x,y components of the difference between start drag and end drag.
     * @property {Number} speed - Current computed speed, in pixels per second.
     * @property {Number} direction - Current computed direction, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
     * @property {Boolean} shift - True if the shift key was pressed during this event.
     * @property {Object} originalEvent - The original DOM event.
     * @property {Boolean} preventDefaultAction - Set to true to prevent default drag behaviour. Default: false.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */ this.raiseEvent("canvas-drag", canvasDragEventArgs11);
        if (!canvasDragEventArgs11.preventDefaultAction && this.viewport) {
            gestureSettings11 = this.gestureSettingsByDeviceType(event11.pointerType);
            if (!this.panHorizontal) event11.delta.x = 0;
            if (!this.panVertical) event11.delta.y = 0;
            if (this.viewport.flipped) event11.delta.x = -event11.delta.x;
            if (this.constrainDuringPan) {
                var delta11 = this.viewport.deltaPointsFromPixels(event11.delta.negate());
                this.viewport.centerSpringX.target.value += delta11.x;
                this.viewport.centerSpringY.target.value += delta11.y;
                var bounds11 = this.viewport.getBounds();
                var constrainedBounds11 = this.viewport.getConstrainedBounds();
                this.viewport.centerSpringX.target.value -= delta11.x;
                this.viewport.centerSpringY.target.value -= delta11.y;
                if (bounds11.x != constrainedBounds11.x) event11.delta.x = 0;
                if (bounds11.y != constrainedBounds11.y) event11.delta.y = 0;
            }
            this.viewport.panBy(this.viewport.deltaPointsFromPixels(event11.delta.negate()), gestureSettings11.flickEnabled && !this.constrainDuringPan);
        }
    }
    function onCanvasDragEnd11(event11) {
        if (!event11.preventDefaultAction && this.viewport) {
            var gestureSettings11 = this.gestureSettingsByDeviceType(event11.pointerType);
            if (gestureSettings11.flickEnabled && event11.speed >= gestureSettings11.flickMinSpeed) {
                var amplitudeX11 = 0;
                if (this.panHorizontal) amplitudeX11 = gestureSettings11.flickMomentum * event11.speed * Math.cos(event11.direction);
                var amplitudeY11 = 0;
                if (this.panVertical) amplitudeY11 = gestureSettings11.flickMomentum * event11.speed * Math.sin(event11.direction);
                var center11 = this.viewport.pixelFromPoint(this.viewport.getCenter(true));
                var target11 = this.viewport.pointFromPixel(new $11.Point(center11.x - amplitudeX11, center11.y - amplitudeY11));
                this.viewport.panTo(target11, false);
            }
            this.viewport.applyConstraints();
        }
        /**
     * Raised when a mouse or touch drag operation ends on the {@link OpenSeadragon.Viewer#canvas} element.
     *
     * @event canvas-drag-end
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {Number} speed - Speed at the end of a drag gesture, in pixels per second.
     * @property {Number} direction - Direction at the end of a drag gesture, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
     * @property {Boolean} shift - True if the shift key was pressed during this event.
     * @property {Object} originalEvent - The original DOM event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */ this.raiseEvent("canvas-drag-end", {
            tracker: event11.eventSource,
            position: event11.position,
            speed: event11.speed,
            direction: event11.direction,
            shift: event11.shift,
            originalEvent: event11.originalEvent
        });
    }
    function onCanvasEnter11(event11) {
        /**
     * Raised when a pointer enters the {@link OpenSeadragon.Viewer#canvas} element.
     *
     * @event canvas-enter
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {String} pointerType - "mouse", "touch", "pen", etc.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {Number} buttons - Current buttons pressed. A combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
     * @property {Number} pointers - Number of pointers (all types) active in the tracked element.
     * @property {Boolean} insideElementPressed - True if the left mouse button is currently being pressed and was initiated inside the tracked element, otherwise false.
     * @property {Boolean} buttonDownAny - Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
     * @property {Object} originalEvent - The original DOM event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */ this.raiseEvent("canvas-enter", {
            tracker: event11.eventSource,
            pointerType: event11.pointerType,
            position: event11.position,
            buttons: event11.buttons,
            pointers: event11.pointers,
            insideElementPressed: event11.insideElementPressed,
            buttonDownAny: event11.buttonDownAny,
            originalEvent: event11.originalEvent
        });
    }
    function onCanvasExit11(event11) {
        if (window.location != window.parent.location) $11.MouseTracker.resetAllMouseTrackers();
        /**
     * Raised when a pointer leaves the {@link OpenSeadragon.Viewer#canvas} element.
     *
     * @event canvas-exit
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {String} pointerType - "mouse", "touch", "pen", etc.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {Number} buttons - Current buttons pressed. A combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
     * @property {Number} pointers - Number of pointers (all types) active in the tracked element.
     * @property {Boolean} insideElementPressed - True if the left mouse button is currently being pressed and was initiated inside the tracked element, otherwise false.
     * @property {Boolean} buttonDownAny - Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
     * @property {Object} originalEvent - The original DOM event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */ this.raiseEvent("canvas-exit", {
            tracker: event11.eventSource,
            pointerType: event11.pointerType,
            position: event11.position,
            buttons: event11.buttons,
            pointers: event11.pointers,
            insideElementPressed: event11.insideElementPressed,
            buttonDownAny: event11.buttonDownAny,
            originalEvent: event11.originalEvent
        });
    }
    function onCanvasPress11(event11) {
        /**
     * Raised when the primary mouse button is pressed or touch starts on the {@link OpenSeadragon.Viewer#canvas} element.
     *
     * @event canvas-press
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {String} pointerType - "mouse", "touch", "pen", etc.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {Boolean} insideElementPressed - True if the left mouse button is currently being pressed and was initiated inside the tracked element, otherwise false.
     * @property {Boolean} insideElementReleased - True if the cursor still inside the tracked element when the button was released.
     * @property {Object} originalEvent - The original DOM event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */ this.raiseEvent("canvas-press", {
            tracker: event11.eventSource,
            pointerType: event11.pointerType,
            position: event11.position,
            insideElementPressed: event11.insideElementPressed,
            insideElementReleased: event11.insideElementReleased,
            originalEvent: event11.originalEvent
        });
    }
    function onCanvasRelease11(event11) {
        /**
     * Raised when the primary mouse button is released or touch ends on the {@link OpenSeadragon.Viewer#canvas} element.
     *
     * @event canvas-release
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {String} pointerType - "mouse", "touch", "pen", etc.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {Boolean} insideElementPressed - True if the left mouse button is currently being pressed and was initiated inside the tracked element, otherwise false.
     * @property {Boolean} insideElementReleased - True if the cursor still inside the tracked element when the button was released.
     * @property {Object} originalEvent - The original DOM event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */ this.raiseEvent("canvas-release", {
            tracker: event11.eventSource,
            pointerType: event11.pointerType,
            position: event11.position,
            insideElementPressed: event11.insideElementPressed,
            insideElementReleased: event11.insideElementReleased,
            originalEvent: event11.originalEvent
        });
    }
    function onCanvasNonPrimaryPress11(event11) {
        /**
     * Raised when any non-primary pointer button is pressed on the {@link OpenSeadragon.Viewer#canvas} element.
     *
     * @event canvas-nonprimary-press
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {String} pointerType - "mouse", "touch", "pen", etc.
     * @property {Number} button - Button which caused the event.
     *      -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
     * @property {Number} buttons - Current buttons pressed.
     *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
     * @property {Object} originalEvent - The original DOM event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */ this.raiseEvent("canvas-nonprimary-press", {
            tracker: event11.eventSource,
            position: event11.position,
            pointerType: event11.pointerType,
            button: event11.button,
            buttons: event11.buttons,
            originalEvent: event11.originalEvent
        });
    }
    function onCanvasNonPrimaryRelease11(event11) {
        /**
     * Raised when any non-primary pointer button is released on the {@link OpenSeadragon.Viewer#canvas} element.
     *
     * @event canvas-nonprimary-release
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {String} pointerType - "mouse", "touch", "pen", etc.
     * @property {Number} button - Button which caused the event.
     *      -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
     * @property {Number} buttons - Current buttons pressed.
     *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
     * @property {Object} originalEvent - The original DOM event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */ this.raiseEvent("canvas-nonprimary-release", {
            tracker: event11.eventSource,
            position: event11.position,
            pointerType: event11.pointerType,
            button: event11.button,
            buttons: event11.buttons,
            originalEvent: event11.originalEvent
        });
    }
    function onCanvasPinch11(event11) {
        var gestureSettings11, centerPt11, lastCenterPt11, panByPt11;
        if (!event11.preventDefaultAction && this.viewport) {
            gestureSettings11 = this.gestureSettingsByDeviceType(event11.pointerType);
            if (gestureSettings11.pinchToZoom) {
                centerPt11 = this.viewport.pointFromPixel(event11.center, true);
                lastCenterPt11 = this.viewport.pointFromPixel(event11.lastCenter, true);
                panByPt11 = lastCenterPt11.minus(centerPt11);
                if (!this.panHorizontal) panByPt11.x = 0;
                if (!this.panVertical) panByPt11.y = 0;
                this.viewport.zoomBy(event11.distance / event11.lastDistance, centerPt11, true);
                if (gestureSettings11.zoomToRefPoint) this.viewport.panBy(panByPt11, true);
                this.viewport.applyConstraints();
            }
            if (gestureSettings11.pinchRotate) {
                // Pinch rotate
                var angle111 = Math.atan2(event11.gesturePoints[0].currentPos.y - event11.gesturePoints[1].currentPos.y, event11.gesturePoints[0].currentPos.x - event11.gesturePoints[1].currentPos.x);
                var angle211 = Math.atan2(event11.gesturePoints[0].lastPos.y - event11.gesturePoints[1].lastPos.y, event11.gesturePoints[0].lastPos.x - event11.gesturePoints[1].lastPos.x);
                this.viewport.setRotation(this.viewport.getRotation() + (angle111 - angle211) * (180 / Math.PI));
            }
        }
        /**
     * Raised when a pinch event occurs on the {@link OpenSeadragon.Viewer#canvas} element.
     *
     * @event canvas-pinch
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gesturePoints - Gesture points associated with the gesture. Velocity data can be found here.
     * @property {OpenSeadragon.Point} lastCenter - The previous center point of the two pinch contact points relative to the tracked element.
     * @property {OpenSeadragon.Point} center - The center point of the two pinch contact points relative to the tracked element.
     * @property {Number} lastDistance - The previous distance between the two pinch contact points in CSS pixels.
     * @property {Number} distance - The distance between the two pinch contact points in CSS pixels.
     * @property {Boolean} shift - True if the shift key was pressed during this event.
     * @property {Object} originalEvent - The original DOM event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */ this.raiseEvent("canvas-pinch", {
            tracker: event11.eventSource,
            gesturePoints: event11.gesturePoints,
            lastCenter: event11.lastCenter,
            center: event11.center,
            lastDistance: event11.lastDistance,
            distance: event11.distance,
            shift: event11.shift,
            originalEvent: event11.originalEvent
        });
        //cancels event
        return false;
    }
    function onCanvasScroll11(event11) {
        var gestureSettings11, factor11, thisScrollTime11, deltaScrollTime11;
        /* Certain scroll devices fire the scroll event way too fast so we are injecting a simple adjustment to keep things
     * partially normalized. If we have already fired an event within the last 'minScrollDelta' milliseconds we skip
     * this one and wait for the next event. */ thisScrollTime11 = $11.now();
        deltaScrollTime11 = thisScrollTime11 - this._lastScrollTime;
        if (deltaScrollTime11 > this.minScrollDeltaTime) {
            this._lastScrollTime = thisScrollTime11;
            if (this.viewport.flipped) event11.position.x = this.viewport.getContainerSize().x - event11.position.x;
            if (!event11.preventDefaultAction && this.viewport) {
                gestureSettings11 = this.gestureSettingsByDeviceType(event11.pointerType);
                if (gestureSettings11.scrollToZoom) {
                    factor11 = Math.pow(this.zoomPerScroll, event11.scroll);
                    this.viewport.zoomBy(factor11, gestureSettings11.zoomToRefPoint ? this.viewport.pointFromPixel(event11.position, true) : null);
                    this.viewport.applyConstraints();
                }
            }
            /**
         * Raised when a scroll event occurs on the {@link OpenSeadragon.Viewer#canvas} element (mouse wheel).
         *
         * @event canvas-scroll
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
         * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
         * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
         * @property {Number} scroll - The scroll delta for the event.
         * @property {Boolean} shift - True if the shift key was pressed during this event.
         * @property {Object} originalEvent - The original DOM event.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */ this.raiseEvent("canvas-scroll", {
                tracker: event11.eventSource,
                position: event11.position,
                scroll: event11.scroll,
                shift: event11.shift,
                originalEvent: event11.originalEvent
            });
            if (gestureSettings11 && gestureSettings11.scrollToZoom) //cancels event
            return false;
        } else {
            gestureSettings11 = this.gestureSettingsByDeviceType(event11.pointerType);
            if (gestureSettings11 && gestureSettings11.scrollToZoom) return false; // We are swallowing this event
        }
    }
    function onContainerEnter11(event11) {
        THIS11[this.hash].mouseInside = true;
        abortControlsAutoHide11(this);
        /**
     * Raised when the cursor enters the {@link OpenSeadragon.Viewer#container} element.
     *
     * @event container-enter
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {Number} buttons - Current buttons pressed. A combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
     * @property {Number} pointers - Number of pointers (all types) active in the tracked element.
     * @property {Boolean} insideElementPressed - True if the left mouse button is currently being pressed and was initiated inside the tracked element, otherwise false.
     * @property {Boolean} buttonDownAny - Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
     * @property {Object} originalEvent - The original DOM event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */ this.raiseEvent("container-enter", {
            tracker: event11.eventSource,
            position: event11.position,
            buttons: event11.buttons,
            pointers: event11.pointers,
            insideElementPressed: event11.insideElementPressed,
            buttonDownAny: event11.buttonDownAny,
            originalEvent: event11.originalEvent
        });
    }
    function onContainerExit11(event11) {
        if (event11.pointers < 1) {
            THIS11[this.hash].mouseInside = false;
            if (!THIS11[this.hash].animating) beginControlsAutoHide11(this);
        }
        /**
     * Raised when the cursor leaves the {@link OpenSeadragon.Viewer#container} element.
     *
     * @event container-exit
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {Number} buttons - Current buttons pressed. A combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
     * @property {Number} pointers - Number of pointers (all types) active in the tracked element.
     * @property {Boolean} insideElementPressed - True if the left mouse button is currently being pressed and was initiated inside the tracked element, otherwise false.
     * @property {Boolean} buttonDownAny - Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
     * @property {Object} originalEvent - The original DOM event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */ this.raiseEvent("container-exit", {
            tracker: event11.eventSource,
            position: event11.position,
            buttons: event11.buttons,
            pointers: event11.pointers,
            insideElementPressed: event11.insideElementPressed,
            buttonDownAny: event11.buttonDownAny,
            originalEvent: event11.originalEvent
        });
    }
    ///////////////////////////////////////////////////////////////////////////////
    // Page update routines ( aka Views - for future reference )
    ///////////////////////////////////////////////////////////////////////////////
    function updateMulti11(viewer11) {
        updateOnce11(viewer11);
        // Request the next frame, unless we've been closed
        if (viewer11.isOpen()) viewer11._updateRequestId = scheduleUpdate11(viewer11, updateMulti11);
        else viewer11._updateRequestId = false;
    }
    function updateOnce11(viewer11) {
        //viewer.profiler.beginUpdate();
        if (viewer11._opening) return;
        if (viewer11.autoResize) {
            var containerSize11 = _getSafeElemSize11(viewer11.container);
            var prevContainerSize11 = THIS11[viewer11.hash].prevContainerSize;
            if (!containerSize11.equals(prevContainerSize11)) {
                var viewport11 = viewer11.viewport;
                if (viewer11.preserveImageSizeOnResize) {
                    var resizeRatio11 = prevContainerSize11.x / containerSize11.x;
                    var zoom11 = viewport11.getZoom() * resizeRatio11;
                    var center11 = viewport11.getCenter();
                    viewport11.resize(containerSize11, false);
                    viewport11.zoomTo(zoom11, null, true);
                    viewport11.panTo(center11, true);
                } else {
                    // maintain image position
                    var oldBounds11 = viewport11.getBounds();
                    viewport11.resize(containerSize11, true);
                    viewport11.fitBoundsWithConstraints(oldBounds11, true);
                }
                THIS11[viewer11.hash].prevContainerSize = containerSize11;
                THIS11[viewer11.hash].forceRedraw = true;
            }
        }
        var viewportChange11 = viewer11.viewport.update();
        var animated11 = viewer11.world.update() || viewportChange11;
        if (viewportChange11) /**
         * Raised when any spring animation update occurs (zoom, pan, etc.),
         * before the viewer has drawn the new location.
         *
         * @event viewport-change
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */ viewer11.raiseEvent("viewport-change");
        if (viewer11.referenceStrip) animated11 = viewer11.referenceStrip.update(viewer11.viewport) || animated11;
        if (!THIS11[viewer11.hash].animating && animated11) {
            /**
         * Raised when any spring animation starts (zoom, pan, etc.).
         *
         * @event animation-start
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */ viewer11.raiseEvent("animation-start");
            abortControlsAutoHide11(viewer11);
        }
        if (animated11 || THIS11[viewer11.hash].forceRedraw || viewer11.world.needsDraw()) {
            drawWorld11(viewer11);
            viewer11._drawOverlays();
            if (viewer11.navigator) viewer11.navigator.update(viewer11.viewport);
            THIS11[viewer11.hash].forceRedraw = false;
            if (animated11) /**
             * Raised when any spring animation update occurs (zoom, pan, etc.),
             * after the viewer has drawn the new location.
             *
             * @event animation
             * @memberof OpenSeadragon.Viewer
             * @type {object}
             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */ viewer11.raiseEvent("animation");
        }
        if (THIS11[viewer11.hash].animating && !animated11) {
            /**
         * Raised when any spring animation ends (zoom, pan, etc.).
         *
         * @event animation-finish
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */ viewer11.raiseEvent("animation-finish");
            if (!THIS11[viewer11.hash].mouseInside) beginControlsAutoHide11(viewer11);
        }
        THIS11[viewer11.hash].animating = animated11;
    //viewer.profiler.endUpdate();
    }
    function drawWorld11(viewer11) {
        viewer11.imageLoader.clear();
        viewer11.drawer.clear();
        viewer11.world.draw();
        /**
     * <em>- Needs documentation -</em>
     *
     * @event update-viewport
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */ viewer11.raiseEvent("update-viewport", {});
    }
    ///////////////////////////////////////////////////////////////////////////////
    // Navigation Controls
    ///////////////////////////////////////////////////////////////////////////////
    function resolveUrl11(prefix11, url11) {
        return prefix11 ? prefix11 + url11 : url11;
    }
    function beginZoomingIn11() {
        THIS11[this.hash].lastZoomTime = $11.now();
        THIS11[this.hash].zoomFactor = this.zoomPerSecond;
        THIS11[this.hash].zooming = true;
        scheduleZoom11(this);
    }
    function beginZoomingOut11() {
        THIS11[this.hash].lastZoomTime = $11.now();
        THIS11[this.hash].zoomFactor = 1.0 / this.zoomPerSecond;
        THIS11[this.hash].zooming = true;
        scheduleZoom11(this);
    }
    function endZooming11() {
        THIS11[this.hash].zooming = false;
    }
    function scheduleZoom11(viewer11) {
        $11.requestAnimationFrame($11.delegate(viewer11, doZoom11));
    }
    function doZoom11() {
        var currentTime11, deltaTime11, adjustedFactor11;
        if (THIS11[this.hash].zooming && this.viewport) {
            currentTime11 = $11.now();
            deltaTime11 = currentTime11 - THIS11[this.hash].lastZoomTime;
            adjustedFactor11 = Math.pow(THIS11[this.hash].zoomFactor, deltaTime11 / 1000);
            this.viewport.zoomBy(adjustedFactor11);
            this.viewport.applyConstraints();
            THIS11[this.hash].lastZoomTime = currentTime11;
            scheduleZoom11(this);
        }
    }
    function doSingleZoomIn11() {
        if (this.viewport) {
            THIS11[this.hash].zooming = false;
            this.viewport.zoomBy(this.zoomPerClick / 1.0);
            this.viewport.applyConstraints();
        }
    }
    function doSingleZoomOut11() {
        if (this.viewport) {
            THIS11[this.hash].zooming = false;
            this.viewport.zoomBy(1.0 / this.zoomPerClick);
            this.viewport.applyConstraints();
        }
    }
    function lightUp11() {
        this.buttons.emulateEnter();
        this.buttons.emulateExit();
    }
    function onHome11() {
        if (this.viewport) this.viewport.goHome();
    }
    function onFullScreen11() {
        if (this.isFullPage() && !$11.isFullScreen()) // Is fullPage but not fullScreen
        this.setFullPage(false);
        else this.setFullScreen(!this.isFullPage());
        // correct for no mouseout event on change
        if (this.buttons) this.buttons.emulateExit();
        this.fullPageButton.element.focus();
        if (this.viewport) this.viewport.applyConstraints();
    }
    /**
 * Note: The current rotation feature is limited to 90 degree turns.
 */ function onRotateLeft11() {
        if (this.viewport) {
            var currRotation11 = this.viewport.getRotation();
            if (this.viewport.flipped) currRotation11 = $11.positiveModulo(currRotation11 + 90, 360);
            else currRotation11 = $11.positiveModulo(currRotation11 - 90, 360);
            this.viewport.setRotation(currRotation11);
        }
    }
    /**
 * Note: The current rotation feature is limited to 90 degree turns.
 */ function onRotateRight11() {
        if (this.viewport) {
            var currRotation11 = this.viewport.getRotation();
            if (this.viewport.flipped) currRotation11 = $11.positiveModulo(currRotation11 - 90, 360);
            else currRotation11 = $11.positiveModulo(currRotation11 + 90, 360);
            this.viewport.setRotation(currRotation11);
        }
    }
    /**
 * Note: When pressed flip control button
 */ function onFlip11() {
        this.viewport.toggleFlip();
    }
    function onPrevious11() {
        var previous11 = this._sequenceIndex - 1;
        if (this.navPrevNextWrap && previous11 < 0) previous11 += this.tileSources.length;
        this.goToPage(previous11);
    }
    function onNext11() {
        var next11 = this._sequenceIndex + 1;
        if (this.navPrevNextWrap && next11 >= this.tileSources.length) next11 = 0;
        this.goToPage(next11);
    }
})(OpenSeadragon);
/*
 * OpenSeadragon - Navigator
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    /**
 * @class Navigator
 * @classdesc The Navigator provides a small view of the current image as fixed
 * while representing the viewport as a moving box serving as a frame
 * of reference in the larger viewport as to which portion of the image
 * is currently being examined.  The navigator's viewport can be interacted
 * with using the keyboard or the mouse.
 *
 * @memberof OpenSeadragon
 * @extends OpenSeadragon.Viewer
 * @extends OpenSeadragon.EventSource
 * @param {Object} options
 */ $11.Navigator = function(options11) {
        var viewer11 = options11.viewer, _this11 = this, viewerSize11, navigatorSize11;
        //We may need to create a new element and id if they did not
        //provide the id for the existing element
        if (!options11.id) {
            options11.id = "navigator-" + $11.now();
            this.element = $11.makeNeutralElement("div");
            options11.controlOptions = {
                anchor: $11.ControlAnchor.TOP_RIGHT,
                attachToViewer: true,
                autoFade: options11.autoFade
            };
            if (options11.position) {
                if ("BOTTOM_RIGHT" == options11.position) options11.controlOptions.anchor = $11.ControlAnchor.BOTTOM_RIGHT;
                else if ("BOTTOM_LEFT" == options11.position) options11.controlOptions.anchor = $11.ControlAnchor.BOTTOM_LEFT;
                else if ("TOP_RIGHT" == options11.position) options11.controlOptions.anchor = $11.ControlAnchor.TOP_RIGHT;
                else if ("TOP_LEFT" == options11.position) options11.controlOptions.anchor = $11.ControlAnchor.TOP_LEFT;
                else if ("ABSOLUTE" == options11.position) {
                    options11.controlOptions.anchor = $11.ControlAnchor.ABSOLUTE;
                    options11.controlOptions.top = options11.top;
                    options11.controlOptions.left = options11.left;
                    options11.controlOptions.height = options11.height;
                    options11.controlOptions.width = options11.width;
                }
            }
        } else {
            this.element = document.getElementById(options11.id);
            options11.controlOptions = {
                anchor: $11.ControlAnchor.NONE,
                attachToViewer: false,
                autoFade: false
            };
        }
        this.element.id = options11.id;
        this.element.className += " navigator";
        options11 = $11.extend(true, {
            sizeRatio: $11.DEFAULT_SETTINGS.navigatorSizeRatio
        }, options11, {
            element: this.element,
            tabIndex: -1,
            //These need to be overridden to prevent recursion since
            //the navigator is a viewer and a viewer has a navigator
            showNavigator: false,
            mouseNavEnabled: false,
            showNavigationControl: false,
            showSequenceControl: false,
            immediateRender: true,
            blendTime: 0,
            animationTime: 0,
            autoResize: options11.autoResize,
            // prevent resizing the navigator from adding unwanted space around the image
            minZoomImageRatio: 1.0,
            background: options11.background,
            opacity: options11.opacity,
            borderColor: options11.borderColor,
            displayRegionColor: options11.displayRegionColor
        });
        options11.minPixelRatio = this.minPixelRatio = viewer11.minPixelRatio;
        $11.setElementTouchActionNone(this.element);
        this.borderWidth = 2;
        //At some browser magnification levels the display regions lines up correctly, but at some there appears to
        //be a one pixel gap.
        this.fudge = new $11.Point(1, 1);
        this.totalBorderWidths = new $11.Point(this.borderWidth * 2, this.borderWidth * 2).minus(this.fudge);
        if (options11.controlOptions.anchor != $11.ControlAnchor.NONE) (function(style11, borderWidth11) {
            style11.margin = "0px";
            style11.border = borderWidth11 + "px solid " + options11.borderColor;
            style11.padding = "0px";
            style11.background = options11.background;
            style11.opacity = options11.opacity;
            style11.overflow = "hidden";
        })(this.element.style, this.borderWidth);
        this.displayRegion = $11.makeNeutralElement("div");
        this.displayRegion.id = this.element.id + "-displayregion";
        this.displayRegion.className = "displayregion";
        (function(style11, borderWidth11) {
            style11.position = "relative";
            style11.top = "0px";
            style11.left = "0px";
            style11.fontSize = "0px";
            style11.overflow = "hidden";
            style11.border = borderWidth11 + "px solid " + options11.displayRegionColor;
            style11.margin = "0px";
            style11.padding = "0px";
            //TODO: IE doesnt like this property being set
            //try{ style.outline  = '2px auto #909'; }catch(e){/*ignore*/}
            style11.background = "transparent";
            // We use square bracket notation on the statement below, because float is a keyword.
            // This is important for the Google Closure compiler, if nothing else.
            /*jshint sub:true */ style11["float"] = "left"; //Webkit
            style11.cssFloat = "left"; //Firefox
            style11.styleFloat = "left"; //IE
            style11.zIndex = 999999999;
            style11.cursor = "default";
        })(this.displayRegion.style, this.borderWidth);
        this.displayRegionContainer = $11.makeNeutralElement("div");
        this.displayRegionContainer.id = this.element.id + "-displayregioncontainer";
        this.displayRegionContainer.className = "displayregioncontainer";
        this.displayRegionContainer.style.width = "100%";
        this.displayRegionContainer.style.height = "100%";
        viewer11.addControl(this.element, options11.controlOptions);
        this._resizeWithViewer = options11.controlOptions.anchor != $11.ControlAnchor.ABSOLUTE && options11.controlOptions.anchor != $11.ControlAnchor.NONE;
        if (this._resizeWithViewer) {
            if (options11.width && options11.height) {
                this.element.style.height = typeof options11.height == "number" ? options11.height + "px" : options11.height;
                this.element.style.width = typeof options11.width == "number" ? options11.width + "px" : options11.width;
            } else {
                viewerSize11 = $11.getElementSize(viewer11.element);
                this.element.style.height = Math.round(viewerSize11.y * options11.sizeRatio) + "px";
                this.element.style.width = Math.round(viewerSize11.x * options11.sizeRatio) + "px";
                this.oldViewerSize = viewerSize11;
            }
            navigatorSize11 = $11.getElementSize(this.element);
            this.elementArea = navigatorSize11.x * navigatorSize11.y;
        }
        this.oldContainerSize = new $11.Point(0, 0);
        $11.Viewer.apply(this, [
            options11
        ]);
        this.displayRegionContainer.appendChild(this.displayRegion);
        this.element.getElementsByTagName("div")[0].appendChild(this.displayRegionContainer);
        function rotate11(degrees11) {
            _setTransformRotate11(_this11.displayRegionContainer, degrees11);
            _setTransformRotate11(_this11.displayRegion, -degrees11);
            _this11.viewport.setRotation(degrees11);
        }
        if (options11.navigatorRotate) {
            var degrees11 = options11.viewer.viewport ? options11.viewer.viewport.getRotation() : options11.viewer.degrees || 0;
            rotate11(degrees11);
            options11.viewer.addHandler("rotate", function(args11) {
                rotate11(args11.degrees);
            });
        }
        // Remove the base class' (Viewer's) innerTracker and replace it with our own
        this.innerTracker.destroy();
        this.innerTracker = new $11.MouseTracker({
            element: this.element,
            dragHandler: $11.delegate(this, onCanvasDrag11),
            clickHandler: $11.delegate(this, onCanvasClick11),
            releaseHandler: $11.delegate(this, onCanvasRelease11),
            scrollHandler: $11.delegate(this, onCanvasScroll11)
        });
        this.addHandler("reset-size", function() {
            if (_this11.viewport) _this11.viewport.goHome(true);
        });
        viewer11.world.addHandler("item-index-change", function(event11) {
            window.setTimeout(function() {
                var item11 = _this11.world.getItemAt(event11.previousIndex);
                _this11.world.setItemIndex(item11, event11.newIndex);
            }, 1);
        });
        viewer11.world.addHandler("remove-item", function(event11) {
            var theirItem11 = event11.item;
            var myItem11 = _this11._getMatchingItem(theirItem11);
            if (myItem11) _this11.world.removeItem(myItem11);
        });
        this.update(viewer11.viewport);
    };
    $11.extend($11.Navigator.prototype, $11.EventSource.prototype, $11.Viewer.prototype, /** @lends OpenSeadragon.Navigator.prototype */ {
        /**
     * Used to notify the navigator when its size has changed.
     * Especially useful when {@link OpenSeadragon.Options}.navigatorAutoResize is set to false and the navigator is resizable.
     * @function
     */ updateSize: function() {
            if (this.viewport) {
                var containerSize11 = new $11.Point(this.container.clientWidth === 0 ? 1 : this.container.clientWidth, this.container.clientHeight === 0 ? 1 : this.container.clientHeight);
                if (!containerSize11.equals(this.oldContainerSize)) {
                    this.viewport.resize(containerSize11, true);
                    this.viewport.goHome(true);
                    this.oldContainerSize = containerSize11;
                    this.drawer.clear();
                    this.world.draw();
                }
            }
        },
        /**
      /* Flip navigator element
      * @param {Boolean} state - Flip state to set.
      */ setFlip: function(state11) {
            this.viewport.setFlip(state11);
            this.setDisplayTransform(this.viewer.viewport.getFlip() ? "scale(-1,1)" : "scale(1,1)");
            return this;
        },
        setDisplayTransform: function(rule11) {
            setElementTransform11(this.displayRegion, rule11);
            setElementTransform11(this.canvas, rule11);
            setElementTransform11(this.element, rule11);
        },
        /**
     * Used to update the navigator minimap's viewport rectangle when a change in the viewer's viewport occurs.
     * @function
     * @param {OpenSeadragon.Viewport} The viewport this navigator is tracking.
     */ update: function(viewport11) {
            var viewerSize11, newWidth11, newHeight11, bounds11, topleft11, bottomright11;
            viewerSize11 = $11.getElementSize(this.viewer.element);
            if (this._resizeWithViewer && viewerSize11.x && viewerSize11.y && !viewerSize11.equals(this.oldViewerSize)) {
                this.oldViewerSize = viewerSize11;
                if (this.maintainSizeRatio || !this.elementArea) {
                    newWidth11 = viewerSize11.x * this.sizeRatio;
                    newHeight11 = viewerSize11.y * this.sizeRatio;
                } else {
                    newWidth11 = Math.sqrt(this.elementArea * (viewerSize11.x / viewerSize11.y));
                    newHeight11 = this.elementArea / newWidth11;
                }
                this.element.style.width = Math.round(newWidth11) + "px";
                this.element.style.height = Math.round(newHeight11) + "px";
                if (!this.elementArea) this.elementArea = newWidth11 * newHeight11;
                this.updateSize();
            }
            if (viewport11 && this.viewport) {
                bounds11 = viewport11.getBoundsNoRotate(true);
                topleft11 = this.viewport.pixelFromPointNoRotate(bounds11.getTopLeft(), false);
                bottomright11 = this.viewport.pixelFromPointNoRotate(bounds11.getBottomRight(), false).minus(this.totalBorderWidths);
                //update style for navigator-box
                var style11 = this.displayRegion.style;
                style11.display = this.world.getItemCount() ? "block" : "none";
                style11.top = Math.round(topleft11.y) + "px";
                style11.left = Math.round(topleft11.x) + "px";
                var width11 = Math.abs(topleft11.x - bottomright11.x);
                var height11 = Math.abs(topleft11.y - bottomright11.y);
                // make sure width and height are non-negative so IE doesn't throw
                style11.width = Math.round(Math.max(width11, 0)) + "px";
                style11.height = Math.round(Math.max(height11, 0)) + "px";
            }
        },
        // overrides Viewer.addTiledImage
        addTiledImage: function(options11) {
            var _this11 = this;
            var original11 = options11.originalTiledImage;
            delete options11.original;
            var optionsClone11 = $11.extend({}, options11, {
                success: function(event11) {
                    var myItem11 = event11.item;
                    myItem11._originalForNavigator = original11;
                    _this11._matchBounds(myItem11, original11, true);
                    function matchBounds11() {
                        _this11._matchBounds(myItem11, original11);
                    }
                    function matchOpacity11() {
                        _this11._matchOpacity(myItem11, original11);
                    }
                    function matchCompositeOperation11() {
                        _this11._matchCompositeOperation(myItem11, original11);
                    }
                    original11.addHandler("bounds-change", matchBounds11);
                    original11.addHandler("clip-change", matchBounds11);
                    original11.addHandler("opacity-change", matchOpacity11);
                    original11.addHandler("composite-operation-change", matchCompositeOperation11);
                }
            });
            return $11.Viewer.prototype.addTiledImage.apply(this, [
                optionsClone11
            ]);
        },
        // private
        _getMatchingItem: function(theirItem11) {
            var count11 = this.world.getItemCount();
            var item11;
            for(var i11 = 0; i11 < count11; i11++){
                item11 = this.world.getItemAt(i11);
                if (item11._originalForNavigator === theirItem11) return item11;
            }
            return null;
        },
        // private
        _matchBounds: function(myItem11, theirItem11, immediately11) {
            var bounds11 = theirItem11.getBoundsNoRotate();
            myItem11.setPosition(bounds11.getTopLeft(), immediately11);
            myItem11.setWidth(bounds11.width, immediately11);
            myItem11.setRotation(theirItem11.getRotation(), immediately11);
            myItem11.setClip(theirItem11.getClip());
        },
        // private
        _matchOpacity: function(myItem11, theirItem11) {
            myItem11.setOpacity(theirItem11.opacity);
        },
        // private
        _matchCompositeOperation: function(myItem11, theirItem11) {
            myItem11.setCompositeOperation(theirItem11.compositeOperation);
        }
    });
    /**
 * @private
 * @inner
 * @function
 */ function onCanvasClick11(event11) {
        var canvasClickEventArgs11 = {
            tracker: event11.eventSource,
            position: event11.position,
            quick: event11.quick,
            shift: event11.shift,
            originalEvent: event11.originalEvent,
            preventDefaultAction: event11.preventDefaultAction
        };
        /**
   * Raised when a click event occurs on the {@link OpenSeadragon.Viewer#navigator} element.
   *
   * @event navigator-click
   * @memberof OpenSeadragon.Viewer
   * @type {object}
   * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
   * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
   * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
   * @property {Boolean} quick - True only if the clickDistThreshold and clickTimeThreshold are both passed. Useful for differentiating between clicks and drags.
   * @property {Boolean} shift - True if the shift key was pressed during this event.
   * @property {Object} originalEvent - The original DOM event.
   * @property {?Object} userData - Arbitrary subscriber-defined object.
   * @property {Boolean} preventDefaultAction - Set to true to prevent default click to zoom behaviour. Default: false.
   */ this.viewer.raiseEvent("navigator-click", canvasClickEventArgs11);
        if (!canvasClickEventArgs11.preventDefaultAction && event11.quick && this.viewer.viewport && (this.panVertical || this.panHorizontal)) {
            if (this.viewer.viewport.flipped) event11.position.x = this.viewport.getContainerSize().x - event11.position.x;
            var target11 = this.viewport.pointFromPixel(event11.position);
            if (!this.panVertical) // perform only horizonal pan
            target11.y = this.viewer.viewport.getCenter(true).y;
            else if (!this.panHorizontal) // perform only vertical pan
            target11.x = this.viewer.viewport.getCenter(true).x;
            this.viewer.viewport.panTo(target11);
            this.viewer.viewport.applyConstraints();
        }
    }
    /**
 * @private
 * @inner
 * @function
 */ function onCanvasDrag11(event11) {
        var canvasDragEventArgs11 = {
            tracker: event11.eventSource,
            position: event11.position,
            delta: event11.delta,
            speed: event11.speed,
            direction: event11.direction,
            shift: event11.shift,
            originalEvent: event11.originalEvent,
            preventDefaultAction: event11.preventDefaultAction
        };
        /**
     * Raised when a drag event occurs on the {@link OpenSeadragon.Viewer#navigator} element.
     *
     * @event navigator-drag
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {OpenSeadragon.Point} delta - The x,y components of the difference between start drag and end drag.
     * @property {Number} speed - Current computed speed, in pixels per second.
     * @property {Number} direction - Current computed direction, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
     * @property {Boolean} shift - True if the shift key was pressed during this event.
     * @property {Object} originalEvent - The original DOM event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     * @property {Boolean} preventDefaultAction - Set to true to prevent default click to zoom behaviour. Default: false.
     */ this.viewer.raiseEvent("navigator-drag", canvasDragEventArgs11);
        if (!canvasDragEventArgs11.preventDefaultAction && this.viewer.viewport) {
            if (!this.panHorizontal) event11.delta.x = 0;
            if (!this.panVertical) event11.delta.y = 0;
            if (this.viewer.viewport.flipped) event11.delta.x = -event11.delta.x;
            this.viewer.viewport.panBy(this.viewport.deltaPointsFromPixels(event11.delta));
            if (this.viewer.constrainDuringPan) this.viewer.viewport.applyConstraints();
        }
    }
    /**
 * @private
 * @inner
 * @function
 */ function onCanvasRelease11(event11) {
        if (event11.insideElementPressed && this.viewer.viewport) this.viewer.viewport.applyConstraints();
    }
    /**
 * @private
 * @inner
 * @function
 */ function onCanvasScroll11(event11) {
        /**
     * Raised when a scroll event occurs on the {@link OpenSeadragon.Viewer#navigator} element (mouse wheel, touch pinch, etc.).
     *
     * @event navigator-scroll
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {Number} scroll - The scroll delta for the event.
     * @property {Boolean} shift - True if the shift key was pressed during this event.
     * @property {Object} originalEvent - The original DOM event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */ this.viewer.raiseEvent("navigator-scroll", {
            tracker: event11.eventSource,
            position: event11.position,
            scroll: event11.scroll,
            shift: event11.shift,
            originalEvent: event11.originalEvent
        });
        //dont scroll the page up and down if the user is scrolling
        //in the navigator
        return false;
    }
    /**
    * @function
    * @private
    * @param {Object} element
    * @param {Number} degrees
    */ function _setTransformRotate11(element11, degrees11) {
        setElementTransform11(element11, "rotate(" + degrees11 + "deg)");
    }
    function setElementTransform11(element11, rule11) {
        element11.style.webkitTransform = rule11;
        element11.style.mozTransform = rule11;
        element11.style.msTransform = rule11;
        element11.style.oTransform = rule11;
        element11.style.transform = rule11;
    }
})(OpenSeadragon);
/*
 * OpenSeadragon - getString/setString
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    //TODO: I guess this is where the i18n needs to be reimplemented.  I'll look
    //      into existing patterns for i18n in javascript but i think that mimicking
    //      pythons gettext might be a reasonable approach.
    var I18N11 = {
        Errors: {
            Dzc: "Sorry, we don't support Deep Zoom Collections!",
            Dzi: "Hmm, this doesn't appear to be a valid Deep Zoom Image.",
            Xml: "Hmm, this doesn't appear to be a valid Deep Zoom Image.",
            ImageFormat: "Sorry, we don't support {0}-based Deep Zoom Images.",
            Security: "It looks like a security restriction stopped us from loading this Deep Zoom Image.",
            Status: "This space unintentionally left blank ({0} {1}).",
            OpenFailed: "Unable to open {0}: {1}"
        },
        Tooltips: {
            FullPage: "Toggle full page",
            Home: "Go home",
            ZoomIn: "Zoom in",
            ZoomOut: "Zoom out",
            NextPage: "Next page",
            PreviousPage: "Previous page",
            RotateLeft: "Rotate left",
            RotateRight: "Rotate right",
            Flip: "Flip Horizontally"
        }
    };
    $11.extend($11, /** @lends OpenSeadragon */ {
        /**
     * @function
     * @param {String} property
     */ getString: function(prop11) {
            var props11 = prop11.split("."), string11 = null, args11 = arguments, container11 = I18N11, i11;
            for(i11 = 0; i11 < props11.length - 1; i11++)// in case not a subproperty
            container11 = container11[props11[i11]] || {};
            string11 = container11[props11[i11]];
            if (typeof string11 != "string") {
                $11.console.log("Untranslated source string:", prop11);
                string11 = ""; // FIXME: this breaks gettext()-style convention, which would return source
            }
            return string11.replace(/\{\d+\}/g, function(capture11) {
                var i11 = parseInt(capture11.match(/\d+/), 10) + 1;
                return i11 < args11.length ? args11[i11] : "";
            });
        },
        /**
     * @function
     * @param {String} property
     * @param {*} value
     */ setString: function(prop11, value11) {
            var props11 = prop11.split("."), container11 = I18N11, i11;
            for(i11 = 0; i11 < props11.length - 1; i11++){
                if (!container11[props11[i11]]) container11[props11[i11]] = {};
                container11 = container11[props11[i11]];
            }
            container11[props11[i11]] = value11;
        }
    });
})(OpenSeadragon);
/*
 * OpenSeadragon - Point
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    /**
 * @class Point
 * @classdesc A Point is really used as a 2-dimensional vector, equally useful for
 * representing a point on a plane, or the height and width of a plane
 * not requiring any other frame of reference.
 *
 * @memberof OpenSeadragon
 * @param {Number} [x] The vector component 'x'. Defaults to the origin at 0.
 * @param {Number} [y] The vector component 'y'. Defaults to the origin at 0.
 */ $11.Point = function(x11, y11) {
        /**
     * The vector component 'x'.
     * @member {Number} x
     * @memberof OpenSeadragon.Point#
     */ this.x = typeof x11 == "number" ? x11 : 0;
        /**
     * The vector component 'y'.
     * @member {Number} y
     * @memberof OpenSeadragon.Point#
     */ this.y = typeof y11 == "number" ? y11 : 0;
    };
    /** @lends OpenSeadragon.Point.prototype */ $11.Point.prototype = {
        /**
     * @function
     * @returns {OpenSeadragon.Point} a duplicate of this Point
     */ clone: function() {
            return new $11.Point(this.x, this.y);
        },
        /**
     * Add another Point to this point and return a new Point.
     * @function
     * @param {OpenSeadragon.Point} point The point to add vector components.
     * @returns {OpenSeadragon.Point} A new point representing the sum of the
     *  vector components
     */ plus: function(point31) {
            return new $11.Point(this.x + point31.x, this.y + point31.y);
        },
        /**
     * Substract another Point to this point and return a new Point.
     * @function
     * @param {OpenSeadragon.Point} point The point to substract vector components.
     * @returns {OpenSeadragon.Point} A new point representing the substraction of the
     *  vector components
     */ minus: function(point31) {
            return new $11.Point(this.x - point31.x, this.y - point31.y);
        },
        /**
     * Multiply this point by a factor and return a new Point.
     * @function
     * @param {Number} factor The factor to multiply vector components.
     * @returns {OpenSeadragon.Point} A new point representing the multiplication
     *  of the vector components by the factor
     */ times: function(factor11) {
            return new $11.Point(this.x * factor11, this.y * factor11);
        },
        /**
     * Divide this point by a factor and return a new Point.
     * @function
     * @param {Number} factor The factor to divide vector components.
     * @returns {OpenSeadragon.Point} A new point representing the division of the
     *  vector components by the factor
     */ divide: function(factor11) {
            return new $11.Point(this.x / factor11, this.y / factor11);
        },
        /**
     * Compute the opposite of this point and return a new Point.
     * @function
     * @returns {OpenSeadragon.Point} A new point representing the opposite of the
     *  vector components
     */ negate: function() {
            return new $11.Point(-this.x, -this.y);
        },
        /**
     * Compute the distance between this point and another point.
     * @function
     * @param {OpenSeadragon.Point} point The point to compute the distance with.
     * @returns {Number} The distance between the 2 points
     */ distanceTo: function(point31) {
            return Math.sqrt(Math.pow(this.x - point31.x, 2) + Math.pow(this.y - point31.y, 2));
        },
        /**
     * Compute the squared distance between this point and another point.
     * Useful for optimizing things like comparing distances.
     * @function
     * @param {OpenSeadragon.Point} point The point to compute the squared distance with.
     * @returns {Number} The squared distance between the 2 points
     */ squaredDistanceTo: function(point31) {
            return Math.pow(this.x - point31.x, 2) + Math.pow(this.y - point31.y, 2);
        },
        /**
     * Apply a function to each coordinate of this point and return a new point.
     * @function
     * @param {function} func The function to apply to each coordinate.
     * @returns {OpenSeadragon.Point} A new point with the coordinates computed
     * by the specified function
     */ apply: function(func11) {
            return new $11.Point(func11(this.x), func11(this.y));
        },
        /**
     * Check if this point is equal to another one.
     * @function
     * @param {OpenSeadragon.Point} point The point to compare this point with.
     * @returns {Boolean} true if they are equal, false otherwise.
     */ equals: function(point31) {
            return point31 instanceof $11.Point && this.x === point31.x && this.y === point31.y;
        },
        /**
     * Rotates the point around the specified pivot
     * From http://stackoverflow.com/questions/4465931/rotate-rectangle-around-a-point
     * @function
     * @param {Number} degress to rotate around the pivot.
     * @param {OpenSeadragon.Point} [pivot=(0,0)] Point around which to rotate.
     * Defaults to the origin.
     * @returns {OpenSeadragon.Point}. A new point representing the point rotated around the specified pivot
     */ rotate: function(degrees11, pivot11) {
            pivot11 = pivot11 || new $11.Point(0, 0);
            var cos11;
            var sin11;
            // Avoid float computations when possible
            if (degrees11 % 90 === 0) {
                var d11 = $11.positiveModulo(degrees11, 360);
                switch(d11){
                    case 0:
                        cos11 = 1;
                        sin11 = 0;
                        break;
                    case 90:
                        cos11 = 0;
                        sin11 = 1;
                        break;
                    case 180:
                        cos11 = -1;
                        sin11 = 0;
                        break;
                    case 270:
                        cos11 = 0;
                        sin11 = -1;
                        break;
                }
            } else {
                var angle31 = degrees11 * Math.PI / 180.0;
                cos11 = Math.cos(angle31);
                sin11 = Math.sin(angle31);
            }
            var x11 = cos11 * (this.x - pivot11.x) - sin11 * (this.y - pivot11.y) + pivot11.x;
            var y11 = sin11 * (this.x - pivot11.x) + cos11 * (this.y - pivot11.y) + pivot11.y;
            return new $11.Point(x11, y11);
        },
        /**
     * Convert this point to a string in the format (x,y) where x and y are
     * rounded to the nearest integer.
     * @function
     * @returns {String} A string representation of this point.
     */ toString: function() {
            return "(" + Math.round(this.x * 100) / 100 + "," + Math.round(this.y * 100) / 100 + ")";
        }
    };
})(OpenSeadragon);
/*
 * OpenSeadragon - TileSource
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    /**
 * @class TileSource
 * @classdesc The TileSource contains the most basic implementation required to create a
 * smooth transition between layers in an image pyramid. It has only a single key
 * interface that must be implemented to complete its key functionality:
 * 'getTileUrl'.  It also has several optional interfaces that can be
 * implemented if a new TileSource wishes to support configuration via a simple
 * object or array ('configure') and if the tile source supports or requires
 * configuration via retrieval of a document on the network ala AJAX or JSONP,
 * ('getImageInfo').
 * <br/>
 * By default the image pyramid is split into N layers where the image's longest
 * side in M (in pixels), where N is the smallest integer which satisfies
 *      <strong>2^(N+1) >= M</strong>.
 *
 * @memberof OpenSeadragon
 * @extends OpenSeadragon.EventSource
 * @param {Object} options
 *      You can either specify a URL, or literally define the TileSource (by specifying
 *      width, height, tileSize, tileOverlap, minLevel, and maxLevel). For the former,
 *      the extending class is expected to implement 'getImageInfo' and 'configure'.
 *      For the latter, the construction is assumed to occur through
 *      the extending classes implementation of 'configure'.
 * @param {String} [options.url]
 *      The URL for the data necessary for this TileSource.
 * @param {String} [options.referenceStripThumbnailUrl]
 *      The URL for a thumbnail image to be used by the reference strip
 * @param {Function} [options.success]
 *      A function to be called upon successful creation.
 * @param {Boolean} [options.ajaxWithCredentials]
 *      If this TileSource needs to make an AJAX call, this specifies whether to set
 *      the XHR's withCredentials (for accessing secure data).
 * @param {Object} [options.ajaxHeaders]
 *      A set of headers to include in AJAX requests.
 * @param {Number} [options.width]
 *      Width of the source image at max resolution in pixels.
 * @param {Number} [options.height]
 *      Height of the source image at max resolution in pixels.
 * @param {Number} [options.tileSize]
 *      The size of the tiles to assumed to make up each pyramid layer in pixels.
 *      Tile size determines the point at which the image pyramid must be
 *      divided into a matrix of smaller images.
 *      Use options.tileWidth and options.tileHeight to support non-square tiles.
 * @param {Number} [options.tileWidth]
 *      The width of the tiles to assumed to make up each pyramid layer in pixels.
 * @param {Number} [options.tileHeight]
 *      The height of the tiles to assumed to make up each pyramid layer in pixels.
 * @param {Number} [options.tileOverlap]
 *      The number of pixels each tile is expected to overlap touching tiles.
 * @param {Number} [options.minLevel]
 *      The minimum level to attempt to load.
 * @param {Number} [options.maxLevel]
 *      The maximum level to attempt to load.
 */ $11.TileSource = function(width11, height11, tileSize11, tileOverlap11, minLevel11, maxLevel11) {
        var _this11 = this;
        var args11 = arguments, options11, i11;
        if ($11.isPlainObject(width11)) options11 = width11;
        else options11 = {
            width: args11[0],
            height: args11[1],
            tileSize: args11[2],
            tileOverlap: args11[3],
            minLevel: args11[4],
            maxLevel: args11[5]
        };
        //Tile sources supply some events, namely 'ready' when they must be configured
        //by asynchronously fetching their configuration data.
        $11.EventSource.call(this);
        //we allow options to override anything we dont treat as
        //required via idiomatic options or which is functionally
        //set depending on the state of the readiness of this tile
        //source
        $11.extend(true, this, options11);
        if (!this.success) {
            //Any functions that are passed as arguments are bound to the ready callback
            for(i11 = 0; i11 < arguments.length; i11++)if ($11.isFunction(arguments[i11])) {
                this.success = arguments[i11];
                break;
            }
        }
        if (this.success) this.addHandler("ready", function(event11) {
            _this11.success(event11);
        });
        /**
     * Ratio of width to height
     * @member {Number} aspectRatio
     * @memberof OpenSeadragon.TileSource#
     */ /**
     * Vector storing x and y dimensions ( width and height respectively ).
     * @member {OpenSeadragon.Point} dimensions
     * @memberof OpenSeadragon.TileSource#
     */ /**
     * The overlap in pixels each tile shares with its adjacent neighbors.
     * @member {Number} tileOverlap
     * @memberof OpenSeadragon.TileSource#
     */ /**
     * The minimum pyramid level this tile source supports or should attempt to load.
     * @member {Number} minLevel
     * @memberof OpenSeadragon.TileSource#
     */ /**
     * The maximum pyramid level this tile source supports or should attempt to load.
     * @member {Number} maxLevel
     * @memberof OpenSeadragon.TileSource#
     */ /**
     *
     * @member {Boolean} ready
     * @memberof OpenSeadragon.TileSource#
     */ if ("string" == $11.type(arguments[0])) this.url = arguments[0];
        if (this.url) {
            //in case the getImageInfo method is overriden and/or implies an
            //async mechanism set some safe defaults first
            this.aspectRatio = 1;
            this.dimensions = new $11.Point(10, 10);
            this._tileWidth = 0;
            this._tileHeight = 0;
            this.tileOverlap = 0;
            this.minLevel = 0;
            this.maxLevel = 0;
            this.ready = false;
            //configuration via url implies the extending class
            //implements and 'configure'
            this.getImageInfo(this.url);
        } else {
            //explicit configuration via positional args in constructor
            //or the more idiomatic 'options' object
            this.ready = true;
            this.aspectRatio = options11.width && options11.height ? options11.width / options11.height : 1;
            this.dimensions = new $11.Point(options11.width, options11.height);
            if (this.tileSize) {
                this._tileWidth = this._tileHeight = this.tileSize;
                delete this.tileSize;
            } else {
                if (this.tileWidth) {
                    // We were passed tileWidth in options, but we want to rename it
                    // with a leading underscore to make clear that it is not safe to directly modify it
                    this._tileWidth = this.tileWidth;
                    delete this.tileWidth;
                } else this._tileWidth = 0;
                if (this.tileHeight) {
                    // See note above about renaming this.tileWidth
                    this._tileHeight = this.tileHeight;
                    delete this.tileHeight;
                } else this._tileHeight = 0;
            }
            this.tileOverlap = options11.tileOverlap ? options11.tileOverlap : 0;
            this.minLevel = options11.minLevel ? options11.minLevel : 0;
            this.maxLevel = undefined !== options11.maxLevel && null !== options11.maxLevel ? options11.maxLevel : options11.width && options11.height ? Math.ceil(Math.log(Math.max(options11.width, options11.height)) / Math.log(2)) : 0;
            if (this.success && $11.isFunction(this.success)) this.success(this);
        }
    };
    /** @lends OpenSeadragon.TileSource.prototype */ $11.TileSource.prototype = {
        getTileSize: function(level11) {
            $11.console.error("[TileSource.getTileSize] is deprecated.Use TileSource.getTileWidth() and TileSource.getTileHeight() instead");
            return this._tileWidth;
        },
        /**
     * Return the tileWidth for a given level.
     * Subclasses should override this if tileWidth can be different at different levels
     *   such as in IIIFTileSource.  Code should use this function rather than reading
     *   from ._tileWidth directly.
     * @function
     * @param {Number} level
     */ getTileWidth: function(level11) {
            if (!this._tileWidth) return this.getTileSize(level11);
            return this._tileWidth;
        },
        /**
     * Return the tileHeight for a given level.
     * Subclasses should override this if tileHeight can be different at different levels
     *   such as in IIIFTileSource.  Code should use this function rather than reading
     *   from ._tileHeight directly.
     * @function
     * @param {Number} level
     */ getTileHeight: function(level11) {
            if (!this._tileHeight) return this.getTileSize(level11);
            return this._tileHeight;
        },
        /**
     * @function
     * @param {Number} level
     */ getLevelScale: function(level11) {
            // see https://github.com/openseadragon/openseadragon/issues/22
            // we use the tilesources implementation of getLevelScale to generate
            // a memoized re-implementation
            var levelScaleCache11 = {}, i11;
            for(i11 = 0; i11 <= this.maxLevel; i11++)levelScaleCache11[i11] = 1 / Math.pow(2, this.maxLevel - i11);
            this.getLevelScale = function(_level11) {
                return levelScaleCache11[_level11];
            };
            return this.getLevelScale(level11);
        },
        /**
     * @function
     * @param {Number} level
     */ getNumTiles: function(level11) {
            var scale11 = this.getLevelScale(level11), x11 = Math.ceil(scale11 * this.dimensions.x / this.getTileWidth(level11)), y11 = Math.ceil(scale11 * this.dimensions.y / this.getTileHeight(level11));
            return new $11.Point(x11, y11);
        },
        /**
     * @function
     * @param {Number} level
     */ getPixelRatio: function(level11) {
            var imageSizeScaled11 = this.dimensions.times(this.getLevelScale(level11)), rx11 = 1.0 / imageSizeScaled11.x, ry11 = 1.0 / imageSizeScaled11.y;
            return new $11.Point(rx11, ry11);
        },
        /**
     * @function
     * @returns {Number} The highest level in this tile source that can be contained in a single tile.
     */ getClosestLevel: function() {
            var i11, tiles11;
            for(i11 = this.minLevel + 1; i11 <= this.maxLevel; i11++){
                tiles11 = this.getNumTiles(i11);
                if (tiles11.x > 1 || tiles11.y > 1) break;
            }
            return i11 - 1;
        },
        /**
     * @function
     * @param {Number} level
     * @param {OpenSeadragon.Point} point
     */ getTileAtPoint: function(level11, point31) {
            var validPoint11 = point31.x >= 0 && point31.x <= 1 && point31.y >= 0 && point31.y <= 1 / this.aspectRatio;
            $11.console.assert(validPoint11, "[TileSource.getTileAtPoint] must be called with a valid point.");
            var widthScaled11 = this.dimensions.x * this.getLevelScale(level11);
            var pixelX11 = point31.x * widthScaled11;
            var pixelY11 = point31.y * widthScaled11;
            var x11 = Math.floor(pixelX11 / this.getTileWidth(level11));
            var y11 = Math.floor(pixelY11 / this.getTileHeight(level11));
            // When point.x == 1 or point.y == 1 / this.aspectRatio we want to
            // return the last tile of the row/column
            if (point31.x >= 1) x11 = this.getNumTiles(level11).x - 1;
            var EPSILON11 = 1e-15;
            if (point31.y >= 1 / this.aspectRatio - EPSILON11) y11 = this.getNumTiles(level11).y - 1;
            return new $11.Point(x11, y11);
        },
        /**
     * @function
     * @param {Number} level
     * @param {Number} x
     * @param {Number} y
     * @param {Boolean} [isSource=false] Whether to return the source bounds of the tile.
     * @returns {OpenSeadragon.Rect} Either where this tile fits (in normalized coordinates) or the
     * portion of the tile to use as the source of the drawing operation (in pixels), depending on
     * the isSource parameter.
     */ getTileBounds: function(level11, x11, y11, isSource11) {
            var dimensionsScaled11 = this.dimensions.times(this.getLevelScale(level11)), tileWidth11 = this.getTileWidth(level11), tileHeight11 = this.getTileHeight(level11), px11 = x11 === 0 ? 0 : tileWidth11 * x11 - this.tileOverlap, py11 = y11 === 0 ? 0 : tileHeight11 * y11 - this.tileOverlap, sx11 = tileWidth11 + (x11 === 0 ? 1 : 2) * this.tileOverlap, sy11 = tileHeight11 + (y11 === 0 ? 1 : 2) * this.tileOverlap, scale11 = 1.0 / dimensionsScaled11.x;
            sx11 = Math.min(sx11, dimensionsScaled11.x - px11);
            sy11 = Math.min(sy11, dimensionsScaled11.y - py11);
            if (isSource11) return new $11.Rect(0, 0, sx11, sy11);
            return new $11.Rect(px11 * scale11, py11 * scale11, sx11 * scale11, sy11 * scale11);
        },
        /**
     * Responsible for retrieving, and caching the
     * image metadata pertinent to this TileSources implementation.
     * @function
     * @param {String} url
     * @throws {Error}
     */ getImageInfo: function(url11) {
            var _this11 = this, callbackName11, callback11, readySource11, options11, urlParts11, filename11, lastDot11;
            if (url11) {
                urlParts11 = url11.split("/");
                filename11 = urlParts11[urlParts11.length - 1];
                lastDot11 = filename11.lastIndexOf(".");
                if (lastDot11 > -1) urlParts11[urlParts11.length - 1] = filename11.slice(0, lastDot11);
            }
            callback11 = function(data11) {
                if (typeof data11 === "string") data11 = $11.parseXml(data11);
                var $TileSource11 = $11.TileSource.determineType(_this11, data11, url11);
                if (!$TileSource11) {
                    /**
                 * Raised when an error occurs loading a TileSource.
                 *
                 * @event open-failed
                 * @memberof OpenSeadragon.TileSource
                 * @type {object}
                 * @property {OpenSeadragon.TileSource} eventSource - A reference to the TileSource which raised the event.
                 * @property {String} message
                 * @property {String} source
                 * @property {?Object} userData - Arbitrary subscriber-defined object.
                 */ _this11.raiseEvent("open-failed", {
                        message: "Unable to load TileSource",
                        source: url11
                    });
                    return;
                }
                options11 = $TileSource11.prototype.configure.apply(_this11, [
                    data11,
                    url11
                ]);
                if (options11.ajaxWithCredentials === undefined) options11.ajaxWithCredentials = _this11.ajaxWithCredentials;
                readySource11 = new $TileSource11(options11);
                _this11.ready = true;
                /**
             * Raised when a TileSource is opened and initialized.
             *
             * @event ready
             * @memberof OpenSeadragon.TileSource
             * @type {object}
             * @property {OpenSeadragon.TileSource} eventSource - A reference to the TileSource which raised the event.
             * @property {Object} tileSource
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */ _this11.raiseEvent("ready", {
                    tileSource: readySource11
                });
            };
            if (url11.match(/\.js$/)) {
                //TODO: Its not very flexible to require tile sources to end jsonp
                //      request for info  with a url that ends with '.js' but for
                //      now it's the only way I see to distinguish uniformly.
                callbackName11 = url11.split("/").pop().replace(".js", "");
                $11.jsonp({
                    url: url11,
                    async: false,
                    callbackName: callbackName11,
                    callback: callback11
                });
            } else // request info via xhr asynchronously.
            $11.makeAjaxRequest({
                url: url11,
                withCredentials: this.ajaxWithCredentials,
                headers: this.ajaxHeaders,
                success: function(xhr11) {
                    var data11 = processResponse11(xhr11);
                    callback11(data11);
                },
                error: function(xhr11, exc11) {
                    var msg11;
                    /*
                        IE < 10 will block XHR requests to different origins. Any property access on the request
                        object will raise an exception which we'll attempt to handle by formatting the original
                        exception rather than the second one raised when we try to access xhr.status
                     */ try {
                        msg11 = "HTTP " + xhr11.status + " attempting to load TileSource";
                    } catch (e11) {
                        var formattedExc11;
                        if (typeof exc11 == "undefined" || !exc11.toString) formattedExc11 = "Unknown error";
                        else formattedExc11 = exc11.toString();
                        msg11 = formattedExc11 + " attempting to load TileSource";
                    }
                    /***
                     * Raised when an error occurs loading a TileSource.
                     *
                     * @event open-failed
                     * @memberof OpenSeadragon.TileSource
                     * @type {object}
                     * @property {OpenSeadragon.TileSource} eventSource - A reference to the TileSource which raised the event.
                     * @property {String} message
                     * @property {String} source
                     * @property {?Object} userData - Arbitrary subscriber-defined object.
                     */ _this11.raiseEvent("open-failed", {
                        message: msg11,
                        source: url11
                    });
                }
            });
        },
        /**
     * Responsible determining if a the particular TileSource supports the
     * data format ( and allowed to apply logic against the url the data was
     * loaded from, if any ). Overriding implementations are expected to do
     * something smart with data and / or url to determine support.  Also
     * understand that iteration order of TileSources is not guarunteed so
     * please make sure your data or url is expressive enough to ensure a simple
     * and sufficient mechanisim for clear determination.
     * @function
     * @param {String|Object|Array|Document} data
     * @param {String} url - the url the data was loaded
     *      from if any.
     * @return {Boolean}
     */ supports: function(data11, url11) {
            return false;
        },
        /**
     * Responsible for parsing and configuring the
     * image metadata pertinent to this TileSources implementation.
     * This method is not implemented by this class other than to throw an Error
     * announcing you have to implement it.  Because of the variety of tile
     * server technologies, and various specifications for building image
     * pyramids, this method is here to allow easy integration.
     * @function
     * @param {String|Object|Array|Document} data
     * @param {String} url - the url the data was loaded
     *      from if any.
     * @return {Object} options - A dictionary of keyword arguments sufficient
     *      to configure this tile sources constructor.
     * @throws {Error}
     */ configure: function(data11, url11) {
            throw new Error("Method not implemented.");
        },
        /**
     * Responsible for retrieving the url which will return an image for the
     * region specified by the given x, y, and level components.
     * This method is not implemented by this class other than to throw an Error
     * announcing you have to implement it.  Because of the variety of tile
     * server technologies, and various specifications for building image
     * pyramids, this method is here to allow easy integration.
     * @function
     * @param {Number} level
     * @param {Number} x
     * @param {Number} y
     * @throws {Error}
     */ getTileUrl: function(level11, x11, y11) {
            throw new Error("Method not implemented.");
        },
        /**
     * Responsible for retrieving the headers which will be attached to the image request for the
     * region specified by the given x, y, and level components.
     * This option is only relevant if {@link OpenSeadragon.Options}.loadTilesWithAjax is set to true.
     * The headers returned here will override headers specified at the Viewer or TiledImage level.
     * Specifying a falsy value for a header will clear its existing value set at the Viewer or
     * TiledImage level (if any).
     * @function
     * @param {Number} level
     * @param {Number} x
     * @param {Number} y
     * @returns {Object}
     */ getTileAjaxHeaders: function(level11, x11, y11) {
            return {};
        },
        /**
     * @function
     * @param {Number} level
     * @param {Number} x
     * @param {Number} y
     */ tileExists: function(level11, x11, y11) {
            var numTiles11 = this.getNumTiles(level11);
            return level11 >= this.minLevel && level11 <= this.maxLevel && x11 >= 0 && y11 >= 0 && x11 < numTiles11.x && y11 < numTiles11.y;
        }
    };
    $11.extend(true, $11.TileSource.prototype, $11.EventSource.prototype);
    /**
 * Decides whether to try to process the response as xml, json, or hand back
 * the text
 * @private
 * @inner
 * @function
 * @param {XMLHttpRequest} xhr - the completed network request
 */ function processResponse11(xhr11) {
        var responseText11 = xhr11.responseText, status11 = xhr11.status, statusText11, data11;
        if (!xhr11) throw new Error($11.getString("Errors.Security"));
        else if (xhr11.status !== 200 && xhr11.status !== 0) {
            status11 = xhr11.status;
            statusText11 = status11 == 404 ? "Not Found" : xhr11.statusText;
            throw new Error($11.getString("Errors.Status", status11, statusText11));
        }
        if (responseText11.match(/\s*<.*/)) try {
            data11 = xhr11.responseXML && xhr11.responseXML.documentElement ? xhr11.responseXML : $11.parseXml(responseText11);
        } catch (e11) {
            data11 = xhr11.responseText;
        }
        else if (responseText11.match(/\s*[\{\[].*/)) try {
            data11 = $11.parseJSON(responseText11);
        } catch (e11) {
            data11 = responseText11;
        }
        else data11 = responseText11;
        return data11;
    }
    /**
 * Determines the TileSource Implementation by introspection of OpenSeadragon
 * namespace, calling each TileSource implementation of 'isType'
 * @private
 * @inner
 * @function
 * @param {Object|Array|Document} data - the tile source configuration object
 * @param {String} url - the url where the tile source configuration object was
 *      loaded from, if any.
 */ $11.TileSource.determineType = function(tileSource11, data11, url11) {
        var property11;
        for(property11 in OpenSeadragon){
            if (property11.match(/.+TileSource$/) && $11.isFunction(OpenSeadragon[property11]) && $11.isFunction(OpenSeadragon[property11].prototype.supports) && OpenSeadragon[property11].prototype.supports.call(tileSource11, data11, url11)) return OpenSeadragon[property11];
        }
        $11.console.error("No TileSource was able to open %s %s", url11, data11);
    };
})(OpenSeadragon);
/*
 * OpenSeadragon - DziTileSource
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    /**
 * @class DziTileSource
 * @memberof OpenSeadragon
 * @extends OpenSeadragon.TileSource
 * @param {Number|Object} width - the pixel width of the image or the idiomatic
 *      options object which is used instead of positional arguments.
 * @param {Number} height
 * @param {Number} tileSize
 * @param {Number} tileOverlap
 * @param {String} tilesUrl
 * @param {String} fileFormat
 * @param {OpenSeadragon.DisplayRect[]} displayRects
 * @property {String} tilesUrl
 * @property {String} fileFormat
 * @property {OpenSeadragon.DisplayRect[]} displayRects
 */ $11.DziTileSource = function(width11, height11, tileSize11, tileOverlap11, tilesUrl11, fileFormat11, displayRects11, minLevel11, maxLevel11) {
        var i11, rect11, level11, options11;
        if ($11.isPlainObject(width11)) options11 = width11;
        else options11 = {
            width: arguments[0],
            height: arguments[1],
            tileSize: arguments[2],
            tileOverlap: arguments[3],
            tilesUrl: arguments[4],
            fileFormat: arguments[5],
            displayRects: arguments[6],
            minLevel: arguments[7],
            maxLevel: arguments[8]
        };
        this._levelRects = {};
        this.tilesUrl = options11.tilesUrl;
        this.fileFormat = options11.fileFormat;
        this.displayRects = options11.displayRects;
        if (this.displayRects) for(i11 = this.displayRects.length - 1; i11 >= 0; i11--){
            rect11 = this.displayRects[i11];
            for(level11 = rect11.minLevel; level11 <= rect11.maxLevel; level11++){
                if (!this._levelRects[level11]) this._levelRects[level11] = [];
                this._levelRects[level11].push(rect11);
            }
        }
        $11.TileSource.apply(this, [
            options11
        ]);
    };
    $11.extend($11.DziTileSource.prototype, $11.TileSource.prototype, /** @lends OpenSeadragon.DziTileSource.prototype */ {
        /**
     * Determine if the data and/or url imply the image service is supported by
     * this tile source.
     * @function
     * @param {Object|Array} data
     * @param {String} optional - url
     */ supports: function(data11, url11) {
            var ns11;
            if (data11.Image) ns11 = data11.Image.xmlns;
            else if (data11.documentElement) {
                if ("Image" == data11.documentElement.localName || "Image" == data11.documentElement.tagName) ns11 = data11.documentElement.namespaceURI;
            }
            ns11 = (ns11 || "").toLowerCase();
            return ns11.indexOf("schemas.microsoft.com/deepzoom/2008") !== -1 || ns11.indexOf("schemas.microsoft.com/deepzoom/2009") !== -1;
        },
        /**
     *
     * @function
     * @param {Object|XMLDocument} data - the raw configuration
     * @param {String} url - the url the data was retreived from if any.
     * @return {Object} options - A dictionary of keyword arguments sufficient
     *      to configure this tile sources constructor.
     */ configure: function(data11, url11) {
            var options11;
            if (!$11.isPlainObject(data11)) options11 = configureFromXML11(this, data11);
            else options11 = configureFromObject11(this, data11);
            if (url11 && !options11.tilesUrl) {
                options11.tilesUrl = url11.replace(/([^\/]+?)(\.(dzi|xml|js)?(\?[^\/]*)?)?\/?$/, "$1_files/");
                if (url11.search(/\.(dzi|xml|js)\?/) != -1) options11.queryParams = url11.match(/\?.*/);
                else options11.queryParams = "";
            }
            return options11;
        },
        /**
     * @function
     * @param {Number} level
     * @param {Number} x
     * @param {Number} y
     */ getTileUrl: function(level11, x11, y11) {
            return [
                this.tilesUrl,
                level11,
                "/",
                x11,
                "_",
                y11,
                ".",
                this.fileFormat,
                this.queryParams
            ].join("");
        },
        /**
     * @function
     * @param {Number} level
     * @param {Number} x
     * @param {Number} y
     */ tileExists: function(level11, x11, y11) {
            var rects11 = this._levelRects[level11], rect11, scale11, xMin11, yMin11, xMax11, yMax11, i11;
            if (this.minLevel && level11 < this.minLevel || this.maxLevel && level11 > this.maxLevel) return false;
            if (!rects11 || !rects11.length) return true;
            for(i11 = rects11.length - 1; i11 >= 0; i11--){
                rect11 = rects11[i11];
                if (level11 < rect11.minLevel || level11 > rect11.maxLevel) continue;
                scale11 = this.getLevelScale(level11);
                xMin11 = rect11.x * scale11;
                yMin11 = rect11.y * scale11;
                xMax11 = xMin11 + rect11.width * scale11;
                yMax11 = yMin11 + rect11.height * scale11;
                xMin11 = Math.floor(xMin11 / this._tileWidth);
                yMin11 = Math.floor(yMin11 / this._tileWidth); // DZI tiles are square, so we just use _tileWidth
                xMax11 = Math.ceil(xMax11 / this._tileWidth);
                yMax11 = Math.ceil(yMax11 / this._tileWidth);
                if (xMin11 <= x11 && x11 < xMax11 && yMin11 <= y11 && y11 < yMax11) return true;
            }
            return false;
        }
    });
    /**
 * @private
 * @inner
 * @function
 */ function configureFromXML11(tileSource11, xmlDoc11) {
        if (!xmlDoc11 || !xmlDoc11.documentElement) throw new Error($11.getString("Errors.Xml"));
        var root11 = xmlDoc11.documentElement, rootName11 = root11.localName || root11.tagName, ns11 = xmlDoc11.documentElement.namespaceURI, configuration11 = null, displayRects11 = [], dispRectNodes11, dispRectNode11, rectNode11, sizeNode11, i11;
        if (rootName11 == "Image") try {
            sizeNode11 = root11.getElementsByTagName("Size")[0];
            if (sizeNode11 === undefined) sizeNode11 = root11.getElementsByTagNameNS(ns11, "Size")[0];
            configuration11 = {
                Image: {
                    xmlns: "http://schemas.microsoft.com/deepzoom/2008",
                    Url: root11.getAttribute("Url"),
                    Format: root11.getAttribute("Format"),
                    DisplayRect: null,
                    Overlap: parseInt(root11.getAttribute("Overlap"), 10),
                    TileSize: parseInt(root11.getAttribute("TileSize"), 10),
                    Size: {
                        Height: parseInt(sizeNode11.getAttribute("Height"), 10),
                        Width: parseInt(sizeNode11.getAttribute("Width"), 10)
                    }
                }
            };
            if (!$11.imageFormatSupported(configuration11.Image.Format)) throw new Error($11.getString("Errors.ImageFormat", configuration11.Image.Format.toUpperCase()));
            dispRectNodes11 = root11.getElementsByTagName("DisplayRect");
            if (dispRectNodes11 === undefined) dispRectNodes11 = root11.getElementsByTagNameNS(ns11, "DisplayRect")[0];
            for(i11 = 0; i11 < dispRectNodes11.length; i11++){
                dispRectNode11 = dispRectNodes11[i11];
                rectNode11 = dispRectNode11.getElementsByTagName("Rect")[0];
                if (rectNode11 === undefined) rectNode11 = dispRectNode11.getElementsByTagNameNS(ns11, "Rect")[0];
                displayRects11.push({
                    Rect: {
                        X: parseInt(rectNode11.getAttribute("X"), 10),
                        Y: parseInt(rectNode11.getAttribute("Y"), 10),
                        Width: parseInt(rectNode11.getAttribute("Width"), 10),
                        Height: parseInt(rectNode11.getAttribute("Height"), 10),
                        MinLevel: parseInt(dispRectNode11.getAttribute("MinLevel"), 10),
                        MaxLevel: parseInt(dispRectNode11.getAttribute("MaxLevel"), 10)
                    }
                });
            }
            if (displayRects11.length) configuration11.Image.DisplayRect = displayRects11;
            return configureFromObject11(tileSource11, configuration11);
        } catch (e11) {
            throw e11 instanceof Error ? e11 : new Error($11.getString("Errors.Dzi"));
        }
        else if (rootName11 == "Collection") throw new Error($11.getString("Errors.Dzc"));
        else if (rootName11 == "Error") {
            var messageNode11 = root11.getElementsByTagName("Message")[0];
            var message11 = messageNode11.firstChild.nodeValue;
            throw new Error(message11);
        }
        throw new Error($11.getString("Errors.Dzi"));
    }
    /**
 * @private
 * @inner
 * @function
 */ function configureFromObject11(tileSource11, configuration11) {
        var imageData11 = configuration11.Image, tilesUrl11 = imageData11.Url, fileFormat11 = imageData11.Format, sizeData11 = imageData11.Size, dispRectData11 = imageData11.DisplayRect || [], width11 = parseInt(sizeData11.Width, 10), height11 = parseInt(sizeData11.Height, 10), tileSize11 = parseInt(imageData11.TileSize, 10), tileOverlap11 = parseInt(imageData11.Overlap, 10), displayRects11 = [], rectData11, i11;
        //TODO: need to figure out out to better handle image format compatibility
        //      which actually includes additional file formats like xml and pdf
        //      and plain text for various tilesource implementations to avoid low
        //      level errors.
        //
        //      For now, just don't perform the check.
        //
        /*if ( !imageFormatSupported( fileFormat ) ) {
        throw new Error(
            $.getString( "Errors.ImageFormat", fileFormat.toUpperCase() )
        );
    }*/ for(i11 = 0; i11 < dispRectData11.length; i11++){
            rectData11 = dispRectData11[i11].Rect;
            displayRects11.push(new $11.DisplayRect(parseInt(rectData11.X, 10), parseInt(rectData11.Y, 10), parseInt(rectData11.Width, 10), parseInt(rectData11.Height, 10), parseInt(rectData11.MinLevel, 10), parseInt(rectData11.MaxLevel, 10)));
        }
        return $11.extend(true, {
            width: width11,
            /* width *required */ height: height11,
            /* height *required */ tileSize: tileSize11,
            /* tileSize *required */ tileOverlap: tileOverlap11,
            /* tileOverlap *required */ minLevel: null,
            /* minLevel */ maxLevel: null,
            /* maxLevel */ tilesUrl: tilesUrl11,
            /* tilesUrl */ fileFormat: fileFormat11,
            /* fileFormat */ displayRects: displayRects11 /* displayRects */ 
        }, configuration11);
    }
})(OpenSeadragon);
/*
 * OpenSeadragon - IIIFTileSource
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    /**
 * @class IIIFTileSource
 * @classdesc A client implementation of the International Image Interoperability Framework
 * Format: Image API 1.0 - 2.1
 *
 * @memberof OpenSeadragon
 * @extends OpenSeadragon.TileSource
 * @see http://iiif.io/api/image/
 */ $11.IIIFTileSource = function(options11) {
        /* eslint-disable camelcase */ $11.extend(true, this, options11);
        if (!(this.height && this.width && this["@id"])) throw new Error("IIIF required parameters not provided.");
        options11.tileSizePerScaleFactor = {};
        // N.B. 2.0 renamed scale_factors to scaleFactors
        if (this.tile_width && this.tile_height) {
            options11.tileWidth = this.tile_width;
            options11.tileHeight = this.tile_height;
        } else if (this.tile_width) options11.tileSize = this.tile_width;
        else if (this.tile_height) options11.tileSize = this.tile_height;
        else if (this.tiles) {
            // Version 2.0 forwards
            if (this.tiles.length == 1) {
                options11.tileWidth = this.tiles[0].width;
                // Use height if provided, otherwise assume square tiles and use width.
                options11.tileHeight = this.tiles[0].height || this.tiles[0].width;
                this.scale_factors = this.tiles[0].scaleFactors;
            } else {
                // Multiple tile sizes at different levels
                this.scale_factors = [];
                for(var t11 = 0; t11 < this.tiles.length; t11++)for(var sf11 = 0; sf11 < this.tiles[t11].scaleFactors.length; sf11++){
                    var scaleFactor11 = this.tiles[t11].scaleFactors[sf11];
                    this.scale_factors.push(scaleFactor11);
                    options11.tileSizePerScaleFactor[scaleFactor11] = {
                        width: this.tiles[t11].width,
                        height: this.tiles[t11].height || this.tiles[t11].width
                    };
                }
            }
        } else if (canBeTiled11(options11.profile)) {
            // use the largest of tileOptions that is smaller than the short dimension
            var shortDim11 = Math.min(this.height, this.width), tileOptions11 = [
                256,
                512,
                1024
            ], smallerTiles11 = [];
            for(var c11 = 0; c11 < tileOptions11.length; c11++)if (tileOptions11[c11] <= shortDim11) smallerTiles11.push(tileOptions11[c11]);
            if (smallerTiles11.length > 0) options11.tileSize = Math.max.apply(null, smallerTiles11);
            else // If we're smaller than 256, just use the short side.
            options11.tileSize = shortDim11;
        } else if (this.sizes && this.sizes.length > 0) {
            // This info.json can't be tiled, but we can still construct a legacy pyramid from the sizes array.
            // In this mode, IIIFTileSource will call functions from the abstract baseTileSource or the
            // LegacyTileSource instead of performing IIIF tiling.
            this.emulateLegacyImagePyramid = true;
            options11.levels = constructLevels11(this);
            // use the largest available size to define tiles
            $11.extend(true, options11, {
                width: options11.levels[options11.levels.length - 1].width,
                height: options11.levels[options11.levels.length - 1].height,
                tileSize: Math.max(options11.height, options11.width),
                tileOverlap: 0,
                minLevel: 0,
                maxLevel: options11.levels.length - 1
            });
            this.levels = options11.levels;
        } else $11.console.error("Nothing in the info.json to construct image pyramids from");
        if (!options11.maxLevel && !this.emulateLegacyImagePyramid) {
            if (!this.scale_factors) options11.maxLevel = Number(Math.ceil(Math.log(Math.max(this.width, this.height), 2)));
            else {
                var maxScaleFactor11 = Math.max.apply(null, this.scale_factors);
                options11.maxLevel = Math.round(Math.log(maxScaleFactor11) * Math.LOG2E);
            }
        }
        $11.TileSource.apply(this, [
            options11
        ]);
    };
    $11.extend($11.IIIFTileSource.prototype, $11.TileSource.prototype, /** @lends OpenSeadragon.IIIFTileSource.prototype */ {
        /**
     * Determine if the data and/or url imply the image service is supported by
     * this tile source.
     * @function
     * @param {Object|Array} data
     * @param {String} optional - url
     */ supports: function(data11, url11) {
            // Version 2.0 and forwards
            if (data11.protocol && data11.protocol == "http://iiif.io/api/image") return true;
            else if (data11["@context"] && (data11["@context"] == "http://library.stanford.edu/iiif/image-api/1.1/context.json" || data11["@context"] == "http://iiif.io/api/image/1/context.json")) // N.B. the iiif.io context is wrong, but where the representation lives so likely to be used
            return true;
            else if (data11.profile && data11.profile.indexOf("http://library.stanford.edu/iiif/image-api/compliance.html") === 0) return true;
            else if (data11.identifier && data11.width && data11.height) return true;
            else if (data11.documentElement && "info" == data11.documentElement.tagName && "http://library.stanford.edu/iiif/image-api/ns/" == data11.documentElement.namespaceURI) return true;
            else return false;
        },
        /**
     *
     * @function
     * @param {Object} data - the raw configuration
     * @example <caption>IIIF 1.1 Info Looks like this</caption>
     * {
     *   "@context" : "http://library.stanford.edu/iiif/image-api/1.1/context.json",
     *   "@id" : "http://iiif.example.com/prefix/1E34750D-38DB-4825-A38A-B60A345E591C",
     *   "width" : 6000,
     *   "height" : 4000,
     *   "scale_factors" : [ 1, 2, 4 ],
     *   "tile_width" : 1024,
     *   "tile_height" : 1024,
     *   "formats" : [ "jpg", "png" ],
     *   "qualities" : [ "native", "grey" ],
     *   "profile" : "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level0"
     * }
     */ configure: function(data11, url11) {
            // Try to deduce our version and fake it upwards if needed
            if (!$11.isPlainObject(data11)) {
                var options11 = configureFromXml1011(data11);
                options11["@context"] = "http://iiif.io/api/image/1.0/context.json";
                options11["@id"] = url11.replace("/info.xml", "");
                return options11;
            } else if (!data11["@context"]) {
                data11["@context"] = "http://iiif.io/api/image/1.0/context.json";
                data11["@id"] = url11.replace("/info.json", "");
                return data11;
            } else return data11;
        },
        /**
     * Return the tileWidth for the given level.
     * @function
     * @param {Number} level
     */ getTileWidth: function(level11) {
            if (this.emulateLegacyImagePyramid) return $11.TileSource.prototype.getTileWidth.call(this, level11);
            var scaleFactor11 = Math.pow(2, this.maxLevel - level11);
            if (this.tileSizePerScaleFactor && this.tileSizePerScaleFactor[scaleFactor11]) return this.tileSizePerScaleFactor[scaleFactor11].width;
            return this._tileWidth;
        },
        /**
     * Return the tileHeight for the given level.
     * @function
     * @param {Number} level
     */ getTileHeight: function(level11) {
            if (this.emulateLegacyImagePyramid) return $11.TileSource.prototype.getTileHeight.call(this, level11);
            var scaleFactor11 = Math.pow(2, this.maxLevel - level11);
            if (this.tileSizePerScaleFactor && this.tileSizePerScaleFactor[scaleFactor11]) return this.tileSizePerScaleFactor[scaleFactor11].height;
            return this._tileHeight;
        },
        /**
     * @function
     * @param {Number} level
     */ getLevelScale: function(level11) {
            if (this.emulateLegacyImagePyramid) {
                var levelScale11 = NaN;
                if (this.levels.length > 0 && level11 >= this.minLevel && level11 <= this.maxLevel) levelScale11 = this.levels[level11].width / this.levels[this.maxLevel].width;
                return levelScale11;
            }
            return $11.TileSource.prototype.getLevelScale.call(this, level11);
        },
        /**
     * @function
     * @param {Number} level
     */ getNumTiles: function(level11) {
            if (this.emulateLegacyImagePyramid) {
                var scale11 = this.getLevelScale(level11);
                if (scale11) return new $11.Point(1, 1);
                else return new $11.Point(0, 0);
            }
            return $11.TileSource.prototype.getNumTiles.call(this, level11);
        },
        /**
     * @function
     * @param {Number} level
     * @param {OpenSeadragon.Point} point
     */ getTileAtPoint: function(level11, point31) {
            if (this.emulateLegacyImagePyramid) return new $11.Point(0, 0);
            return $11.TileSource.prototype.getTileAtPoint.call(this, level11, point31);
        },
        /**
     * Responsible for retrieving the url which will return an image for the
     * region specified by the given x, y, and level components.
     * @function
     * @param {Number} level - z index
     * @param {Number} x
     * @param {Number} y
     * @throws {Error}
     */ getTileUrl: function(level11, x11, y11) {
            if (this.emulateLegacyImagePyramid) {
                var url11 = null;
                if (this.levels.length > 0 && level11 >= this.minLevel && level11 <= this.maxLevel) url11 = this.levels[level11].url;
                return url11;
            }
            //# constants
            var IIIF_ROTATION11 = "0", //## get the scale (level as a decimal)
            scale11 = Math.pow(0.5, this.maxLevel - level11), //# image dimensions at this level
            levelWidth11 = Math.ceil(this.width * scale11), levelHeight11 = Math.ceil(this.height * scale11), //## iiif region
            tileWidth11, tileHeight11, iiifTileSizeWidth11, iiifTileSizeHeight11, iiifRegion11, iiifTileX11, iiifTileY11, iiifTileW11, iiifTileH11, iiifSize11, iiifQuality11, uri11;
            tileWidth11 = this.getTileWidth(level11);
            tileHeight11 = this.getTileHeight(level11);
            iiifTileSizeWidth11 = Math.ceil(tileWidth11 / scale11);
            iiifTileSizeHeight11 = Math.ceil(tileHeight11 / scale11);
            if (this["@context"].indexOf("/1.0/context.json") > -1 || this["@context"].indexOf("/1.1/context.json") > -1 || this["@context"].indexOf("/1/context.json") > -1) iiifQuality11 = "native.jpg";
            else iiifQuality11 = "default.jpg";
            if (levelWidth11 < tileWidth11 && levelHeight11 < tileHeight11) {
                iiifSize11 = levelWidth11 + ",";
                iiifRegion11 = "full";
            } else {
                iiifTileX11 = x11 * iiifTileSizeWidth11;
                iiifTileY11 = y11 * iiifTileSizeHeight11;
                iiifTileW11 = Math.min(iiifTileSizeWidth11, this.width - iiifTileX11);
                iiifTileH11 = Math.min(iiifTileSizeHeight11, this.height - iiifTileY11);
                iiifSize11 = Math.ceil(iiifTileW11 * scale11) + ",";
                iiifRegion11 = [
                    iiifTileX11,
                    iiifTileY11,
                    iiifTileW11,
                    iiifTileH11
                ].join(",");
            }
            uri11 = [
                this["@id"],
                iiifRegion11,
                iiifSize11,
                IIIF_ROTATION11,
                iiifQuality11
            ].join("/");
            return uri11;
        }
    });
    /**
     * Determine whether arbitrary tile requests can be made against a service with the given profile
     * @function
     * @param {object} profile - IIIF profile object
     * @throws {Error}
     */ function canBeTiled11(profile11) {
        var level0Profiles11 = [
            "http://library.stanford.edu/iiif/image-api/compliance.html#level0",
            "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level0",
            "http://iiif.io/api/image/2/level0.json"
        ];
        var isLevel011 = level0Profiles11.indexOf(profile11[0]) != -1;
        return !isLevel011 || profile11.indexOf("sizeByW") != -1;
    }
    /**
     * Build the legacy pyramid URLs (one tile per level)
     * @function
     * @param {object} options - infoJson
     * @throws {Error}
     */ function constructLevels11(options11) {
        var levels11 = [];
        for(var i11 = 0; i11 < options11.sizes.length; i11++)levels11.push({
            url: options11["@id"] + "/full/" + options11.sizes[i11].width + ",/0/default.jpg",
            width: options11.sizes[i11].width,
            height: options11.sizes[i11].height
        });
        return levels11.sort(function(a11, b11) {
            return a11.width - b11.width;
        });
    }
    function configureFromXml1011(xmlDoc11) {
        //parse the xml
        if (!xmlDoc11 || !xmlDoc11.documentElement) throw new Error($11.getString("Errors.Xml"));
        var root11 = xmlDoc11.documentElement, rootName11 = root11.tagName, configuration11 = null;
        if (rootName11 == "info") try {
            configuration11 = {};
            parseXML1011(root11, configuration11);
            return configuration11;
        } catch (e11) {
            throw e11 instanceof Error ? e11 : new Error($11.getString("Errors.IIIF"));
        }
        throw new Error($11.getString("Errors.IIIF"));
    }
    function parseXML1011(node11, configuration11, property11) {
        var i11, value11;
        if (node11.nodeType == 3 && property11) {
            value11 = node11.nodeValue.trim();
            if (value11.match(/^\d*$/)) value11 = Number(value11);
            if (!configuration11[property11]) configuration11[property11] = value11;
            else {
                if (!$11.isArray(configuration11[property11])) configuration11[property11] = [
                    configuration11[property11]
                ];
                configuration11[property11].push(value11);
            }
        } else if (node11.nodeType == 1) for(i11 = 0; i11 < node11.childNodes.length; i11++)parseXML1011(node11.childNodes[i11], configuration11, node11.nodeName);
    }
})(OpenSeadragon);
/*
 * OpenSeadragon - OsmTileSource
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /*
 * Derived from the OSM tile source in Rainer Simon's seajax-utils project
 * <http://github.com/rsimon/seajax-utils>.  Rainer Simon has contributed
 * the included code to the OpenSeadragon project under the New BSD license;
 * see <https://github.com/openseadragon/openseadragon/issues/58>.
 */ (function($11) {
    /**
 * @class OsmTileSource
 * @classdesc A tilesource implementation for OpenStreetMap.<br><br>
 *
 * Note 1. Zoomlevels. Deep Zoom and OSM define zoom levels differently. In  Deep
 * Zoom, level 0 equals an image of 1x1 pixels. In OSM, level 0 equals an image of
 * 256x256 levels (see http://gasi.ch/blog/inside-deep-zoom-2). I.e. there is a
 * difference of log2(256)=8 levels.<br><br>
 *
 * Note 2. Image dimension. According to the OSM Wiki
 * (http://wiki.openstreetmap.org/wiki/Slippy_map_tilenames#Zoom_levels)
 * the highest Mapnik zoom level has 256.144x256.144 tiles, with a 256x256
 * pixel size. I.e. the Deep Zoom image dimension is 65.572.864x65.572.864
 * pixels.
 *
 * @memberof OpenSeadragon
 * @extends OpenSeadragon.TileSource
 * @param {Number|Object} width - the pixel width of the image or the idiomatic
 *      options object which is used instead of positional arguments.
 * @param {Number} height
 * @param {Number} tileSize
 * @param {Number} tileOverlap
 * @param {String} tilesUrl
 */ $11.OsmTileSource = function(width11, height11, tileSize11, tileOverlap11, tilesUrl11) {
        var options11;
        if ($11.isPlainObject(width11)) options11 = width11;
        else options11 = {
            width: arguments[0],
            height: arguments[1],
            tileSize: arguments[2],
            tileOverlap: arguments[3],
            tilesUrl: arguments[4]
        };
        //apply default setting for standard public OpenStreatMaps service
        //but allow them to be specified so fliks can host there own instance
        //or apply against other services supportting the same standard
        if (!options11.width || !options11.height) {
            options11.width = 65572864;
            options11.height = 65572864;
        }
        if (!options11.tileSize) {
            options11.tileSize = 256;
            options11.tileOverlap = 0;
        }
        if (!options11.tilesUrl) options11.tilesUrl = "http://tile.openstreetmap.org/";
        options11.minLevel = 8;
        $11.TileSource.apply(this, [
            options11
        ]);
    };
    $11.extend($11.OsmTileSource.prototype, $11.TileSource.prototype, /** @lends OpenSeadragon.OsmTileSource.prototype */ {
        /**
     * Determine if the data and/or url imply the image service is supported by
     * this tile source.
     * @function
     * @param {Object|Array} data
     * @param {String} optional - url
     */ supports: function(data11, url11) {
            return data11.type && "openstreetmaps" == data11.type;
        },
        /**
     *
     * @function
     * @param {Object} data - the raw configuration
     * @param {String} url - the url the data was retreived from if any.
     * @return {Object} options - A dictionary of keyword arguments sufficient
     *      to configure this tile sources constructor.
     */ configure: function(data11, url11) {
            return data11;
        },
        /**
     * @function
     * @param {Number} level
     * @param {Number} x
     * @param {Number} y
     */ getTileUrl: function(level11, x11, y11) {
            return this.tilesUrl + (level11 - 8) + "/" + x11 + "/" + y11 + ".png";
        }
    });
})(OpenSeadragon);
/*
 * OpenSeadragon - TmsTileSource
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /*
 * Derived from the TMS tile source in Rainer Simon's seajax-utils project
 * <http://github.com/rsimon/seajax-utils>.  Rainer Simon has contributed
 * the included code to the OpenSeadragon project under the New BSD license;
 * see <https://github.com/openseadragon/openseadragon/issues/58>.
 */ (function($11) {
    /**
 * @class TmsTileSource
 * @classdesc A tilesource implementation for Tiled Map Services (TMS).
 * TMS tile scheme ( [ as supported by OpenLayers ] is described here
 * ( http://openlayers.org/dev/examples/tms.html ).
 *
 * @memberof OpenSeadragon
 * @extends OpenSeadragon.TileSource
 * @param {Number|Object} width - the pixel width of the image or the idiomatic
 *      options object which is used instead of positional arguments.
 * @param {Number} height
 * @param {Number} tileSize
 * @param {Number} tileOverlap
 * @param {String} tilesUrl
 */ $11.TmsTileSource = function(width11, height11, tileSize11, tileOverlap11, tilesUrl11) {
        var options11;
        if ($11.isPlainObject(width11)) options11 = width11;
        else options11 = {
            width: arguments[0],
            height: arguments[1],
            tileSize: arguments[2],
            tileOverlap: arguments[3],
            tilesUrl: arguments[4]
        };
        // TMS has integer multiples of 256 for width/height and adds buffer
        // if necessary -> account for this!
        var bufferedWidth11 = Math.ceil(options11.width / 256) * 256, bufferedHeight11 = Math.ceil(options11.height / 256) * 256, max11;
        // Compute number of zoomlevels in this tileset
        if (bufferedWidth11 > bufferedHeight11) max11 = bufferedWidth11 / 256;
        else max11 = bufferedHeight11 / 256;
        options11.maxLevel = Math.ceil(Math.log(max11) / Math.log(2)) - 1;
        options11.tileSize = 256;
        options11.width = bufferedWidth11;
        options11.height = bufferedHeight11;
        $11.TileSource.apply(this, [
            options11
        ]);
    };
    $11.extend($11.TmsTileSource.prototype, $11.TileSource.prototype, /** @lends OpenSeadragon.TmsTileSource.prototype */ {
        /**
     * Determine if the data and/or url imply the image service is supported by
     * this tile source.
     * @function
     * @param {Object|Array} data
     * @param {String} optional - url
     */ supports: function(data11, url11) {
            return data11.type && "tiledmapservice" == data11.type;
        },
        /**
     *
     * @function
     * @param {Object} data - the raw configuration
     * @param {String} url - the url the data was retreived from if any.
     * @return {Object} options - A dictionary of keyword arguments sufficient
     *      to configure this tile sources constructor.
     */ configure: function(data11, url11) {
            return data11;
        },
        /**
     * @function
     * @param {Number} level
     * @param {Number} x
     * @param {Number} y
     */ getTileUrl: function(level11, x11, y11) {
            // Convert from Deep Zoom definition to TMS zoom definition
            var yTiles11 = this.getNumTiles(level11).y - 1;
            return this.tilesUrl + level11 + "/" + x11 + "/" + (yTiles11 - y11) + ".png";
        }
    });
})(OpenSeadragon);
(function($11) {
    /**
     * @class ZoomifyTileSource
     * @classdesc A tilesource implementation for the zoomify format.
     *
     * A description of the format can be found here:
     * https://ecommons.cornell.edu/bitstream/handle/1813/5410/Introducing_Zoomify_Image.pdf
     *
     * There are two ways of creating a zoomify tilesource for openseadragon
     *
     * 1) Supplying all necessary information in the tilesource object. A minimal example object for this method looks like this:
     *
     * {
     *      type: "zoomifytileservice",
     *      width: 1000,
     *      height: 1000,
     *      tilesUrl: "/test/data/zoomify/"
     * }
     *
     * The tileSize is currently hardcoded to 256 (the usual Zoomify default). The tileUrl must the path to the image _directory_.
     *
     * 2) Loading image metadata from xml file: (CURRENTLY NOT SUPPORTED)
     *
     * When creating zoomify formatted images one "xml" like file with name ImageProperties.xml
     * will be created as well. Here is an example of such a file:
     *
     * <IMAGE_PROPERTIES WIDTH="1000" HEIGHT="1000" NUMTILES="21" NUMIMAGES="1" VERSION="1.8" TILESIZE="256" />
     *
     * To use this xml file as metadata source you must supply the path to the ImageProperties.xml file and leave out all other parameters:
     * As stated above, this method of loading a zoomify tilesource is currently not supported
     *
     * {
     *      type: "zoomifytileservice",
     *      tilesUrl: "/test/data/zoomify/ImageProperties.xml"
     * }

    *
    * @memberof OpenSeadragon
     * @extends OpenSeadragon.TileSource
     * @param {Number} width - the pixel width of the image.
     * @param {Number} height
     * @param {Number} tileSize
     * @param {String} tilesUrl
     */ $11.ZoomifyTileSource = function(options11) {
        options11.tileSize = 256;
        var currentImageSize11 = {
            x: options11.width,
            y: options11.height
        };
        options11.imageSizes = [
            {
                x: options11.width,
                y: options11.height
            }
        ];
        options11.gridSize = [
            this._getGridSize(options11.width, options11.height, options11.tileSize)
        ];
        while(parseInt(currentImageSize11.x, 10) > options11.tileSize || parseInt(currentImageSize11.y, 10) > options11.tileSize){
            currentImageSize11.x = Math.floor(currentImageSize11.x / 2);
            currentImageSize11.y = Math.floor(currentImageSize11.y / 2);
            options11.imageSizes.push({
                x: currentImageSize11.x,
                y: currentImageSize11.y
            });
            options11.gridSize.push(this._getGridSize(currentImageSize11.x, currentImageSize11.y, options11.tileSize));
        }
        options11.imageSizes.reverse();
        options11.gridSize.reverse();
        options11.minLevel = 0;
        options11.maxLevel = options11.gridSize.length - 1;
        OpenSeadragon.TileSource.apply(this, [
            options11
        ]);
    };
    $11.extend($11.ZoomifyTileSource.prototype, $11.TileSource.prototype, /** @lends OpenSeadragon.ZoomifyTileSource.prototype */ {
        //private
        _getGridSize: function(width11, height11, tileSize11) {
            return {
                x: Math.ceil(width11 / tileSize11),
                y: Math.ceil(height11 / tileSize11)
            };
        },
        //private
        _calculateAbsoluteTileNumber: function(level11, x11, y11) {
            var num11 = 0;
            var size11 = {};
            //Sum up all tiles below the level we want the number of tiles
            for(var z11 = 0; z11 < level11; z11++){
                size11 = this.gridSize[z11];
                num11 += size11.x * size11.y;
            }
            //Add the tiles of the level
            size11 = this.gridSize[level11];
            num11 += size11.x * y11 + x11;
            return num11;
        },
        /**
         * Determine if the data and/or url imply the image service is supported by
         * this tile source.
         * @function
         * @param {Object|Array} data
         * @param {String} optional - url
         */ supports: function(data11, url11) {
            return data11.type && "zoomifytileservice" == data11.type;
        },
        /**
         *
         * @function
         * @param {Object} data - the raw configuration
         * @param {String} url - the url the data was retreived from if any.
         * @return {Object} options - A dictionary of keyword arguments sufficient
         *      to configure this tile sources constructor.
         */ configure: function(data11, url11) {
            return data11;
        },
        /**
         * @function
         * @param {Number} level
         * @param {Number} x
         * @param {Number} y
         */ getTileUrl: function(level11, x11, y11) {
            //console.log(level);
            var result11 = 0;
            var num11 = this._calculateAbsoluteTileNumber(level11, x11, y11);
            result11 = Math.floor(num11 / 256);
            return this.tilesUrl + "TileGroup" + result11 + "/" + level11 + "-" + x11 + "-" + y11 + ".jpg";
        }
    });
})(OpenSeadragon);
/*
 * OpenSeadragon - LegacyTileSource
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    /**
 * @class LegacyTileSource
 * @classdesc The LegacyTileSource allows simple, traditional image pyramids to be loaded
 * into an OpenSeadragon Viewer.  Basically, this translates to the historically
 * common practice of starting with a 'master' image, maybe a tiff for example,
 * and generating a set of 'service' images like one or more thumbnails, a medium
 * resolution image and a high resolution image in standard web formats like
 * png or jpg.
 *
 * @memberof OpenSeadragon
 * @extends OpenSeadragon.TileSource
 * @param {Array} levels An array of file descriptions, each is an object with
 *      a 'url', a 'width', and a 'height'.  Overriding classes can expect more
 *      properties but these properties are sufficient for this implementation.
 *      Additionally, the levels are required to be listed in order from
 *      smallest to largest.
 * @property {Number} aspectRatio
 * @property {Number} dimensions
 * @property {Number} tileSize
 * @property {Number} tileOverlap
 * @property {Number} minLevel
 * @property {Number} maxLevel
 * @property {Array}  levels
 */ $11.LegacyTileSource = function(levels11) {
        var options11, width11, height11;
        if ($11.isArray(levels11)) options11 = {
            type: "legacy-image-pyramid",
            levels: levels11
        };
        //clean up the levels to make sure we support all formats
        options11.levels = filterFiles11(options11.levels);
        if (options11.levels.length > 0) {
            width11 = options11.levels[options11.levels.length - 1].width;
            height11 = options11.levels[options11.levels.length - 1].height;
        } else {
            width11 = 0;
            height11 = 0;
            $11.console.error("No supported image formats found");
        }
        $11.extend(true, options11, {
            width: width11,
            height: height11,
            tileSize: Math.max(height11, width11),
            tileOverlap: 0,
            minLevel: 0,
            maxLevel: options11.levels.length > 0 ? options11.levels.length - 1 : 0
        });
        $11.TileSource.apply(this, [
            options11
        ]);
        this.levels = options11.levels;
    };
    $11.extend($11.LegacyTileSource.prototype, $11.TileSource.prototype, /** @lends OpenSeadragon.LegacyTileSource.prototype */ {
        /**
     * Determine if the data and/or url imply the image service is supported by
     * this tile source.
     * @function
     * @param {Object|Array} data
     * @param {String} optional - url
     */ supports: function(data11, url11) {
            return data11.type && "legacy-image-pyramid" == data11.type || data11.documentElement && "legacy-image-pyramid" == data11.documentElement.getAttribute("type");
        },
        /**
     *
     * @function
     * @param {Object|XMLDocument} configuration - the raw configuration
     * @param {String} dataUrl - the url the data was retreived from if any.
     * @return {Object} options - A dictionary of keyword arguments sufficient
     *      to configure this tile sources constructor.
     */ configure: function(configuration11, dataUrl11) {
            var options11;
            if (!$11.isPlainObject(configuration11)) options11 = configureFromXML11(this, configuration11);
            else options11 = configureFromObject11(this, configuration11);
            return options11;
        },
        /**
     * @function
     * @param {Number} level
     */ getLevelScale: function(level11) {
            var levelScale11 = NaN;
            if (this.levels.length > 0 && level11 >= this.minLevel && level11 <= this.maxLevel) levelScale11 = this.levels[level11].width / this.levels[this.maxLevel].width;
            return levelScale11;
        },
        /**
     * @function
     * @param {Number} level
     */ getNumTiles: function(level11) {
            var scale11 = this.getLevelScale(level11);
            if (scale11) return new $11.Point(1, 1);
            else return new $11.Point(0, 0);
        },
        /**
     * This method is not implemented by this class other than to throw an Error
     * announcing you have to implement it.  Because of the variety of tile
     * server technologies, and various specifications for building image
     * pyramids, this method is here to allow easy integration.
     * @function
     * @param {Number} level
     * @param {Number} x
     * @param {Number} y
     * @throws {Error}
     */ getTileUrl: function(level11, x11, y11) {
            var url11 = null;
            if (this.levels.length > 0 && level11 >= this.minLevel && level11 <= this.maxLevel) url11 = this.levels[level11].url;
            return url11;
        }
    });
    /**
 * This method removes any files from the Array which dont conform to our
 * basic requirements for a 'level' in the LegacyTileSource.
 * @private
 * @inner
 * @function
 */ function filterFiles11(files11) {
        var filtered11 = [], file11, i11;
        for(i11 = 0; i11 < files11.length; i11++){
            file11 = files11[i11];
            if (file11.height && file11.width && file11.url) //This is sufficient to serve as a level
            filtered11.push({
                url: file11.url,
                width: Number(file11.width),
                height: Number(file11.height)
            });
            else $11.console.error("Unsupported image format: %s", file11.url ? file11.url : "<no URL>");
        }
        return filtered11.sort(function(a11, b11) {
            return a11.height - b11.height;
        });
    }
    /**
 * @private
 * @inner
 * @function
 */ function configureFromXML11(tileSource11, xmlDoc11) {
        if (!xmlDoc11 || !xmlDoc11.documentElement) throw new Error($11.getString("Errors.Xml"));
        var root11 = xmlDoc11.documentElement, rootName11 = root11.tagName, conf11 = null, levels11 = [], level11, i11;
        if (rootName11 == "image") try {
            conf11 = {
                type: root11.getAttribute("type"),
                levels: []
            };
            levels11 = root11.getElementsByTagName("level");
            for(i11 = 0; i11 < levels11.length; i11++){
                level11 = levels11[i11];
                conf11.levels.push({
                    url: level11.getAttribute("url"),
                    width: parseInt(level11.getAttribute("width"), 10),
                    height: parseInt(level11.getAttribute("height"), 10)
                });
            }
            return configureFromObject11(tileSource11, conf11);
        } catch (e11) {
            throw e11 instanceof Error ? e11 : new Error("Unknown error parsing Legacy Image Pyramid XML.");
        }
        else if (rootName11 == "collection") throw new Error("Legacy Image Pyramid Collections not yet supported.");
        else if (rootName11 == "error") throw new Error("Error: " + xmlDoc11);
        throw new Error("Unknown element " + rootName11);
    }
    /**
 * @private
 * @inner
 * @function
 */ function configureFromObject11(tileSource11, configuration11) {
        return configuration11.levels;
    }
})(OpenSeadragon);
/*
 * OpenSeadragon - ImageTileSource
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    /**
     * @class ImageTileSource
     * @classdesc The ImageTileSource allows a simple image to be loaded
     * into an OpenSeadragon Viewer.
     * There are 2 ways to open an ImageTileSource:
     * 1. viewer.open({type: 'image', url: fooUrl});
     * 2. viewer.open(new OpenSeadragon.ImageTileSource({url: fooUrl}));
     *
     * With the first syntax, the crossOriginPolicy, ajaxWithCredentials and
     * useCanvas options are inherited from the viewer if they are not
     * specified directly in the options object.
     *
     * @memberof OpenSeadragon
     * @extends OpenSeadragon.TileSource
     * @param {Object} options Options object.
     * @param {String} options.url URL of the image
     * @param {Boolean} [options.buildPyramid=true] If set to true (default), a
     * pyramid will be built internally to provide a better downsampling.
     * @param {String|Boolean} [options.crossOriginPolicy=false] Valid values are
     * 'Anonymous', 'use-credentials', and false. If false, image requests will
     * not use CORS preventing internal pyramid building for images from other
     * domains.
     * @param {String|Boolean} [options.ajaxWithCredentials=false] Whether to set
     * the withCredentials XHR flag for AJAX requests (when loading tile sources).
     * @param {Boolean} [options.useCanvas=true] Set to false to prevent any use
     * of the canvas API.
     */ $11.ImageTileSource = function(options11) {
        options11 = $11.extend({
            buildPyramid: true,
            crossOriginPolicy: false,
            ajaxWithCredentials: false,
            useCanvas: true
        }, options11);
        $11.TileSource.apply(this, [
            options11
        ]);
    };
    $11.extend($11.ImageTileSource.prototype, $11.TileSource.prototype, /** @lends OpenSeadragon.ImageTileSource.prototype */ {
        /**
         * Determine if the data and/or url imply the image service is supported by
         * this tile source.
         * @function
         * @param {Object|Array} data
         * @param {String} optional - url
         */ supports: function(data11, url11) {
            return data11.type && data11.type === "image";
        },
        /**
         *
         * @function
         * @param {Object} options - the options
         * @param {String} dataUrl - the url the image was retreived from, if any.
         * @return {Object} options - A dictionary of keyword arguments sufficient
         *      to configure this tile sources constructor.
         */ configure: function(options11, dataUrl11) {
            return options11;
        },
        /**
         * Responsible for retrieving, and caching the
         * image metadata pertinent to this TileSources implementation.
         * @function
         * @param {String} url
         * @throws {Error}
         */ getImageInfo: function(url11) {
            var image11 = this._image = new Image();
            var _this11 = this;
            if (this.crossOriginPolicy) image11.crossOrigin = this.crossOriginPolicy;
            if (this.ajaxWithCredentials) image11.useCredentials = this.ajaxWithCredentials;
            $11.addEvent(image11, "load", function() {
                /* IE8 fix since it has no naturalWidth and naturalHeight */ _this11.width = Object.prototype.hasOwnProperty.call(image11, "naturalWidth") ? image11.naturalWidth : image11.width;
                _this11.height = Object.prototype.hasOwnProperty.call(image11, "naturalHeight") ? image11.naturalHeight : image11.height;
                _this11.aspectRatio = _this11.width / _this11.height;
                _this11.dimensions = new $11.Point(_this11.width, _this11.height);
                _this11._tileWidth = _this11.width;
                _this11._tileHeight = _this11.height;
                _this11.tileOverlap = 0;
                _this11.minLevel = 0;
                _this11.levels = _this11._buildLevels();
                _this11.maxLevel = _this11.levels.length - 1;
                _this11.ready = true;
                // Note: this event is documented elsewhere, in TileSource
                _this11.raiseEvent("ready", {
                    tileSource: _this11
                });
            });
            $11.addEvent(image11, "error", function() {
                // Note: this event is documented elsewhere, in TileSource
                _this11.raiseEvent("open-failed", {
                    message: "Error loading image at " + url11,
                    source: url11
                });
            });
            image11.src = url11;
        },
        /**
         * @function
         * @param {Number} level
         */ getLevelScale: function(level11) {
            var levelScale11 = NaN;
            if (level11 >= this.minLevel && level11 <= this.maxLevel) levelScale11 = this.levels[level11].width / this.levels[this.maxLevel].width;
            return levelScale11;
        },
        /**
         * @function
         * @param {Number} level
         */ getNumTiles: function(level11) {
            var scale11 = this.getLevelScale(level11);
            if (scale11) return new $11.Point(1, 1);
            else return new $11.Point(0, 0);
        },
        /**
         * Retrieves a tile url
         * @function
         * @param {Number} level Level of the tile
         * @param {Number} x x coordinate of the tile
         * @param {Number} y y coordinate of the tile
         */ getTileUrl: function(level11, x11, y11) {
            var url11 = null;
            if (level11 >= this.minLevel && level11 <= this.maxLevel) url11 = this.levels[level11].url;
            return url11;
        },
        /**
         * Retrieves a tile context 2D
         * @function
         * @param {Number} level Level of the tile
         * @param {Number} x x coordinate of the tile
         * @param {Number} y y coordinate of the tile
         */ getContext2D: function(level11, x11, y11) {
            var context11 = null;
            if (level11 >= this.minLevel && level11 <= this.maxLevel) context11 = this.levels[level11].context2D;
            return context11;
        },
        // private
        //
        // Builds the differents levels of the pyramid if possible
        // (i.e. if canvas API enabled and no canvas tainting issue).
        _buildLevels: function() {
            var levels11 = [
                {
                    url: this._image.src,
                    /* IE8 fix since it has no naturalWidth and naturalHeight */ width: Object.prototype.hasOwnProperty.call(this._image, "naturalWidth") ? this._image.naturalWidth : this._image.width,
                    height: Object.prototype.hasOwnProperty.call(this._image, "naturalHeight") ? this._image.naturalHeight : this._image.height
                }
            ];
            if (!this.buildPyramid || !$11.supportsCanvas || !this.useCanvas) {
                // We don't need the image anymore. Allows it to be GC.
                delete this._image;
                return levels11;
            }
            /* IE8 fix since it has no naturalWidth and naturalHeight */ var currentWidth11 = Object.prototype.hasOwnProperty.call(this._image, "naturalWidth") ? this._image.naturalWidth : this._image.width;
            var currentHeight11 = Object.prototype.hasOwnProperty.call(this._image, "naturalHeight") ? this._image.naturalHeight : this._image.height;
            var bigCanvas11 = document.createElement("canvas");
            var bigContext11 = bigCanvas11.getContext("2d");
            bigCanvas11.width = currentWidth11;
            bigCanvas11.height = currentHeight11;
            bigContext11.drawImage(this._image, 0, 0, currentWidth11, currentHeight11);
            // We cache the context of the highest level because the browser
            // is a lot faster at downsampling something it already has
            // downsampled before.
            levels11[0].context2D = bigContext11;
            // We don't need the image anymore. Allows it to be GC.
            delete this._image;
            if ($11.isCanvasTainted(bigCanvas11)) // If the canvas is tainted, we can't compute the pyramid.
            return levels11;
            // We build smaller levels until either width or height becomes
            // 1 pixel wide.
            while(currentWidth11 >= 2 && currentHeight11 >= 2){
                currentWidth11 = Math.floor(currentWidth11 / 2);
                currentHeight11 = Math.floor(currentHeight11 / 2);
                var smallCanvas11 = document.createElement("canvas");
                var smallContext11 = smallCanvas11.getContext("2d");
                smallCanvas11.width = currentWidth11;
                smallCanvas11.height = currentHeight11;
                smallContext11.drawImage(bigCanvas11, 0, 0, currentWidth11, currentHeight11);
                levels11.splice(0, 0, {
                    context2D: smallContext11,
                    width: currentWidth11,
                    height: currentHeight11
                });
                bigCanvas11 = smallCanvas11;
                bigContext11 = smallContext11;
            }
            return levels11;
        }
    });
})(OpenSeadragon);
/*
 * OpenSeadragon - TileSourceCollection
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    // deprecated
    $11.TileSourceCollection = function(tileSize11, tileSources11, rows11, layout11) {
        $11.console.error("TileSourceCollection is deprecated; use World instead");
    };
})(OpenSeadragon);
/*
 * OpenSeadragon - Button
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    /**
 * An enumeration of button states
 * @member ButtonState
 * @memberof OpenSeadragon
 * @static
 * @type {Object}
 * @property {Number} REST
 * @property {Number} GROUP
 * @property {Number} HOVER
 * @property {Number} DOWN
 */ $11.ButtonState = {
        REST: 0,
        GROUP: 1,
        HOVER: 2,
        DOWN: 3
    };
    /**
 * @class Button
 * @classdesc Manages events, hover states for individual buttons, tool-tips, as well
 * as fading the buttons out when the user has not interacted with them
 * for a specified period.
 *
 * @memberof OpenSeadragon
 * @extends OpenSeadragon.EventSource
 * @param {Object} options
 * @param {Element} [options.element=null] Element to use as the button. If not specified, an HTML &lt;div&gt; element is created.
 * @param {String} [options.tooltip=null] Provides context help for the button when the
 *  user hovers over it.
 * @param {String} [options.srcRest=null] URL of image to use in 'rest' state.
 * @param {String} [options.srcGroup=null] URL of image to use in 'up' state.
 * @param {String} [options.srcHover=null] URL of image to use in 'hover' state.
 * @param {String} [options.srcDown=null] URL of image to use in 'down' state.
 * @param {Number} [options.fadeDelay=0] How long to wait before fading.
 * @param {Number} [options.fadeLength=2000] How long should it take to fade the button.
 * @param {OpenSeadragon.EventHandler} [options.onPress=null] Event handler callback for {@link OpenSeadragon.Button.event:press}.
 * @param {OpenSeadragon.EventHandler} [options.onRelease=null] Event handler callback for {@link OpenSeadragon.Button.event:release}.
 * @param {OpenSeadragon.EventHandler} [options.onClick=null] Event handler callback for {@link OpenSeadragon.Button.event:click}.
 * @param {OpenSeadragon.EventHandler} [options.onEnter=null] Event handler callback for {@link OpenSeadragon.Button.event:enter}.
 * @param {OpenSeadragon.EventHandler} [options.onExit=null] Event handler callback for {@link OpenSeadragon.Button.event:exit}.
 * @param {OpenSeadragon.EventHandler} [options.onFocus=null] Event handler callback for {@link OpenSeadragon.Button.event:focus}.
 * @param {OpenSeadragon.EventHandler} [options.onBlur=null] Event handler callback for {@link OpenSeadragon.Button.event:blur}.
 */ $11.Button = function(options11) {
        var _this11 = this;
        $11.EventSource.call(this);
        $11.extend(true, this, {
            tooltip: null,
            srcRest: null,
            srcGroup: null,
            srcHover: null,
            srcDown: null,
            clickTimeThreshold: $11.DEFAULT_SETTINGS.clickTimeThreshold,
            clickDistThreshold: $11.DEFAULT_SETTINGS.clickDistThreshold,
            /**
         * How long to wait before fading.
         * @member {Number} fadeDelay
         * @memberof OpenSeadragon.Button#
         */ fadeDelay: 0,
            /**
         * How long should it take to fade the button.
         * @member {Number} fadeLength
         * @memberof OpenSeadragon.Button#
         */ fadeLength: 2000,
            onPress: null,
            onRelease: null,
            onClick: null,
            onEnter: null,
            onExit: null,
            onFocus: null,
            onBlur: null
        }, options11);
        /**
     * The button element.
     * @member {Element} element
     * @memberof OpenSeadragon.Button#
     */ this.element = options11.element || $11.makeNeutralElement("div");
        //if the user has specified the element to bind the control to explicitly
        //then do not add the default control images
        if (!options11.element) {
            this.imgRest = $11.makeTransparentImage(this.srcRest);
            this.imgGroup = $11.makeTransparentImage(this.srcGroup);
            this.imgHover = $11.makeTransparentImage(this.srcHover);
            this.imgDown = $11.makeTransparentImage(this.srcDown);
            this.imgRest.alt = this.imgGroup.alt = this.imgHover.alt = this.imgDown.alt = this.tooltip;
            this.element.style.position = "relative";
            $11.setElementTouchActionNone(this.element);
            this.imgGroup.style.position = this.imgHover.style.position = this.imgDown.style.position = "absolute";
            this.imgGroup.style.top = this.imgHover.style.top = this.imgDown.style.top = "0px";
            this.imgGroup.style.left = this.imgHover.style.left = this.imgDown.style.left = "0px";
            this.imgHover.style.visibility = this.imgDown.style.visibility = "hidden";
            if ($11.Browser.vendor == $11.BROWSERS.FIREFOX && $11.Browser.version < 3) this.imgGroup.style.top = this.imgHover.style.top = this.imgDown.style.top = "";
            this.element.appendChild(this.imgRest);
            this.element.appendChild(this.imgGroup);
            this.element.appendChild(this.imgHover);
            this.element.appendChild(this.imgDown);
        }
        this.addHandler("press", this.onPress);
        this.addHandler("release", this.onRelease);
        this.addHandler("click", this.onClick);
        this.addHandler("enter", this.onEnter);
        this.addHandler("exit", this.onExit);
        this.addHandler("focus", this.onFocus);
        this.addHandler("blur", this.onBlur);
        /**
     * The button's current state.
     * @member {OpenSeadragon.ButtonState} currentState
     * @memberof OpenSeadragon.Button#
     */ this.currentState = $11.ButtonState.GROUP;
        // When the button last began to fade.
        this.fadeBeginTime = null;
        // Whether this button should fade after user stops interacting with the viewport.
        this.shouldFade = false;
        this.element.style.display = "inline-block";
        this.element.style.position = "relative";
        this.element.title = this.tooltip;
        /**
     * Tracks mouse/touch/key events on the button.
     * @member {OpenSeadragon.MouseTracker} tracker
     * @memberof OpenSeadragon.Button#
     */ this.tracker = new $11.MouseTracker({
            element: this.element,
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold,
            enterHandler: function(event11) {
                if (event11.insideElementPressed) {
                    inTo11(_this11, $11.ButtonState.DOWN);
                    /**
                 * Raised when the cursor enters the Button element.
                 *
                 * @event enter
                 * @memberof OpenSeadragon.Button
                 * @type {object}
                 * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
                 * @property {Object} originalEvent - The original DOM event.
                 * @property {?Object} userData - Arbitrary subscriber-defined object.
                 */ _this11.raiseEvent("enter", {
                        originalEvent: event11.originalEvent
                    });
                } else if (!event11.buttonDownAny) inTo11(_this11, $11.ButtonState.HOVER);
            },
            focusHandler: function(event11) {
                this.enterHandler(event11);
                /**
             * Raised when the Button element receives focus.
             *
             * @event focus
             * @memberof OpenSeadragon.Button
             * @type {object}
             * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
             * @property {Object} originalEvent - The original DOM event.
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */ _this11.raiseEvent("focus", {
                    originalEvent: event11.originalEvent
                });
            },
            exitHandler: function(event11) {
                outTo11(_this11, $11.ButtonState.GROUP);
                if (event11.insideElementPressed) /**
                 * Raised when the cursor leaves the Button element.
                 *
                 * @event exit
                 * @memberof OpenSeadragon.Button
                 * @type {object}
                 * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
                 * @property {Object} originalEvent - The original DOM event.
                 * @property {?Object} userData - Arbitrary subscriber-defined object.
                 */ _this11.raiseEvent("exit", {
                    originalEvent: event11.originalEvent
                });
            },
            blurHandler: function(event11) {
                this.exitHandler(event11);
                /**
             * Raised when the Button element loses focus.
             *
             * @event blur
             * @memberof OpenSeadragon.Button
             * @type {object}
             * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
             * @property {Object} originalEvent - The original DOM event.
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */ _this11.raiseEvent("blur", {
                    originalEvent: event11.originalEvent
                });
            },
            pressHandler: function(event11) {
                inTo11(_this11, $11.ButtonState.DOWN);
                /**
             * Raised when a mouse button is pressed or touch occurs in the Button element.
             *
             * @event press
             * @memberof OpenSeadragon.Button
             * @type {object}
             * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
             * @property {Object} originalEvent - The original DOM event.
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */ _this11.raiseEvent("press", {
                    originalEvent: event11.originalEvent
                });
            },
            releaseHandler: function(event11) {
                if (event11.insideElementPressed && event11.insideElementReleased) {
                    outTo11(_this11, $11.ButtonState.HOVER);
                    /**
                 * Raised when the mouse button is released or touch ends in the Button element.
                 *
                 * @event release
                 * @memberof OpenSeadragon.Button
                 * @type {object}
                 * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
                 * @property {Object} originalEvent - The original DOM event.
                 * @property {?Object} userData - Arbitrary subscriber-defined object.
                 */ _this11.raiseEvent("release", {
                        originalEvent: event11.originalEvent
                    });
                } else if (event11.insideElementPressed) outTo11(_this11, $11.ButtonState.GROUP);
                else inTo11(_this11, $11.ButtonState.HOVER);
            },
            clickHandler: function(event11) {
                if (event11.quick) /**
                 * Raised when a mouse button is pressed and released or touch is initiated and ended in the Button element within the time and distance threshold.
                 *
                 * @event click
                 * @memberof OpenSeadragon.Button
                 * @type {object}
                 * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
                 * @property {Object} originalEvent - The original DOM event.
                 * @property {?Object} userData - Arbitrary subscriber-defined object.
                 */ _this11.raiseEvent("click", {
                    originalEvent: event11.originalEvent
                });
            },
            keyHandler: function(event11) {
                //console.log( "%s : handling key %s!", _this.tooltip, event.keyCode);
                if (13 === event11.keyCode) {
                    /***
                 * Raised when a mouse button is pressed and released or touch is initiated and ended in the Button element within the time and distance threshold.
                 *
                 * @event click
                 * @memberof OpenSeadragon.Button
                 * @type {object}
                 * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
                 * @property {Object} originalEvent - The original DOM event.
                 * @property {?Object} userData - Arbitrary subscriber-defined object.
                 */ _this11.raiseEvent("click", {
                        originalEvent: event11.originalEvent
                    });
                    /***
                 * Raised when the mouse button is released or touch ends in the Button element.
                 *
                 * @event release
                 * @memberof OpenSeadragon.Button
                 * @type {object}
                 * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
                 * @property {Object} originalEvent - The original DOM event.
                 * @property {?Object} userData - Arbitrary subscriber-defined object.
                 */ _this11.raiseEvent("release", {
                        originalEvent: event11.originalEvent
                    });
                    return false;
                }
                return true;
            }
        });
        outTo11(this, $11.ButtonState.REST);
    };
    $11.extend($11.Button.prototype, $11.EventSource.prototype, /** @lends OpenSeadragon.Button.prototype */ {
        /**
     * TODO: Determine what this function is intended to do and if it's actually
     * useful as an API point.
     * @function
     */ notifyGroupEnter: function() {
            inTo11(this, $11.ButtonState.GROUP);
        },
        /**
     * TODO: Determine what this function is intended to do and if it's actually
     * useful as an API point.
     * @function
     */ notifyGroupExit: function() {
            outTo11(this, $11.ButtonState.REST);
        },
        /**
     * @function
     */ disable: function() {
            this.notifyGroupExit();
            this.element.disabled = true;
            $11.setElementOpacity(this.element, 0.2, true);
        },
        /**
     * @function
     */ enable: function() {
            this.element.disabled = false;
            $11.setElementOpacity(this.element, 1.0, true);
            this.notifyGroupEnter();
        }
    });
    function scheduleFade11(button11) {
        $11.requestAnimationFrame(function() {
            updateFade11(button11);
        });
    }
    function updateFade11(button11) {
        var currentTime11, deltaTime11, opacity11;
        if (button11.shouldFade) {
            currentTime11 = $11.now();
            deltaTime11 = currentTime11 - button11.fadeBeginTime;
            opacity11 = 1.0 - deltaTime11 / button11.fadeLength;
            opacity11 = Math.min(1.0, opacity11);
            opacity11 = Math.max(0.0, opacity11);
            if (button11.imgGroup) $11.setElementOpacity(button11.imgGroup, opacity11, true);
            if (opacity11 > 0) // fade again
            scheduleFade11(button11);
        }
    }
    function beginFading11(button11) {
        button11.shouldFade = true;
        button11.fadeBeginTime = $11.now() + button11.fadeDelay;
        window.setTimeout(function() {
            scheduleFade11(button11);
        }, button11.fadeDelay);
    }
    function stopFading11(button11) {
        button11.shouldFade = false;
        if (button11.imgGroup) $11.setElementOpacity(button11.imgGroup, 1.0, true);
    }
    function inTo11(button11, newState11) {
        if (button11.element.disabled) return;
        if (newState11 >= $11.ButtonState.GROUP && button11.currentState == $11.ButtonState.REST) {
            stopFading11(button11);
            button11.currentState = $11.ButtonState.GROUP;
        }
        if (newState11 >= $11.ButtonState.HOVER && button11.currentState == $11.ButtonState.GROUP) {
            if (button11.imgHover) button11.imgHover.style.visibility = "";
            button11.currentState = $11.ButtonState.HOVER;
        }
        if (newState11 >= $11.ButtonState.DOWN && button11.currentState == $11.ButtonState.HOVER) {
            if (button11.imgDown) button11.imgDown.style.visibility = "";
            button11.currentState = $11.ButtonState.DOWN;
        }
    }
    function outTo11(button11, newState11) {
        if (button11.element.disabled) return;
        if (newState11 <= $11.ButtonState.HOVER && button11.currentState == $11.ButtonState.DOWN) {
            if (button11.imgDown) button11.imgDown.style.visibility = "hidden";
            button11.currentState = $11.ButtonState.HOVER;
        }
        if (newState11 <= $11.ButtonState.GROUP && button11.currentState == $11.ButtonState.HOVER) {
            if (button11.imgHover) button11.imgHover.style.visibility = "hidden";
            button11.currentState = $11.ButtonState.GROUP;
        }
        if (newState11 <= $11.ButtonState.REST && button11.currentState == $11.ButtonState.GROUP) {
            beginFading11(button11);
            button11.currentState = $11.ButtonState.REST;
        }
    }
})(OpenSeadragon);
/*
 * OpenSeadragon - ButtonGroup
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    /**
 * @class ButtonGroup
 * @classdesc Manages events on groups of buttons.
 *
 * @memberof OpenSeadragon
 * @param {Object} options - A dictionary of settings applied against the entire group of buttons.
 * @param {Array} options.buttons Array of buttons
 * @param {Element} [options.element] Element to use as the container
 **/ $11.ButtonGroup = function(options11) {
        $11.extend(true, this, {
            /**
         * An array containing the buttons themselves.
         * @member {Array} buttons
         * @memberof OpenSeadragon.ButtonGroup#
         */ buttons: [],
            clickTimeThreshold: $11.DEFAULT_SETTINGS.clickTimeThreshold,
            clickDistThreshold: $11.DEFAULT_SETTINGS.clickDistThreshold,
            labelText: ""
        }, options11);
        // copy the button elements  TODO: Why?
        var buttons11 = this.buttons.concat([]), _this11 = this, i11;
        /**
     * The shared container for the buttons.
     * @member {Element} element
     * @memberof OpenSeadragon.ButtonGroup#
     */ this.element = options11.element || $11.makeNeutralElement("div");
        // TODO What if there IS an options.group specified?
        if (!options11.group) {
            this.label = $11.makeNeutralElement("label");
            //TODO: support labels for ButtonGroups
            //this.label.innerHTML = this.labelText;
            this.element.style.display = "inline-block";
            this.element.appendChild(this.label);
            for(i11 = 0; i11 < buttons11.length; i11++)this.element.appendChild(buttons11[i11].element);
        }
        $11.setElementTouchActionNone(this.element);
        /**
     * Tracks mouse/touch/key events accross the group of buttons.
     * @member {OpenSeadragon.MouseTracker} tracker
     * @memberof OpenSeadragon.ButtonGroup#
     */ this.tracker = new $11.MouseTracker({
            element: this.element,
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold,
            enterHandler: function(event11) {
                var i11;
                for(i11 = 0; i11 < _this11.buttons.length; i11++)_this11.buttons[i11].notifyGroupEnter();
            },
            exitHandler: function(event11) {
                var i11;
                if (!event11.insideElementPressed) for(i11 = 0; i11 < _this11.buttons.length; i11++)_this11.buttons[i11].notifyGroupExit();
            }
        });
    };
    /** @lends OpenSeadragon.ButtonGroup.prototype */ $11.ButtonGroup.prototype = {
        /**
     * TODO: Figure out why this is used on the public API and if a more useful
     * api can be created.
     * @function
     * @private
     */ emulateEnter: function() {
            this.tracker.enterHandler({
                eventSource: this.tracker
            });
        },
        /**
     * TODO: Figure out why this is used on the public API and if a more useful
     * api can be created.
     * @function
     * @private
     */ emulateExit: function() {
            this.tracker.exitHandler({
                eventSource: this.tracker
            });
        }
    };
})(OpenSeadragon);
/*
 * OpenSeadragon - Rect
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    /**
 * @class Rect
 * @classdesc A Rectangle is described by it top left coordinates (x, y), width,
 * height and degrees of rotation around (x, y).
 * Note that the coordinate system used is the one commonly used with images:
 * x increases when going to the right
 * y increases when going to the bottom
 * degrees increases clockwise with 0 being the horizontal
 *
 * The constructor normalizes the rectangle to always have 0 <= degrees < 90
 *
 * @memberof OpenSeadragon
 * @param {Number} [x=0] The vector component 'x'.
 * @param {Number} [y=0] The vector component 'y'.
 * @param {Number} [width=0] The vector component 'width'.
 * @param {Number} [height=0] The vector component 'height'.
 * @param {Number} [degrees=0] Rotation of the rectangle around (x,y) in degrees.
 */ $11.Rect = function(x11, y11, width11, height11, degrees11) {
        /**
     * The vector component 'x'.
     * @member {Number} x
     * @memberof OpenSeadragon.Rect#
     */ this.x = typeof x11 === "number" ? x11 : 0;
        /**
     * The vector component 'y'.
     * @member {Number} y
     * @memberof OpenSeadragon.Rect#
     */ this.y = typeof y11 === "number" ? y11 : 0;
        /**
     * The vector component 'width'.
     * @member {Number} width
     * @memberof OpenSeadragon.Rect#
     */ this.width = typeof width11 === "number" ? width11 : 0;
        /**
     * The vector component 'height'.
     * @member {Number} height
     * @memberof OpenSeadragon.Rect#
     */ this.height = typeof height11 === "number" ? height11 : 0;
        this.degrees = typeof degrees11 === "number" ? degrees11 : 0;
        // Normalizes the rectangle.
        this.degrees = $11.positiveModulo(this.degrees, 360);
        var newTopLeft11, newWidth11;
        if (this.degrees >= 270) {
            newTopLeft11 = this.getTopRight();
            this.x = newTopLeft11.x;
            this.y = newTopLeft11.y;
            newWidth11 = this.height;
            this.height = this.width;
            this.width = newWidth11;
            this.degrees -= 270;
        } else if (this.degrees >= 180) {
            newTopLeft11 = this.getBottomRight();
            this.x = newTopLeft11.x;
            this.y = newTopLeft11.y;
            this.degrees -= 180;
        } else if (this.degrees >= 90) {
            newTopLeft11 = this.getBottomLeft();
            this.x = newTopLeft11.x;
            this.y = newTopLeft11.y;
            newWidth11 = this.height;
            this.height = this.width;
            this.width = newWidth11;
            this.degrees -= 90;
        }
    };
    /**
 * Builds a rectangle having the 3 specified points as summits.
 * @static
 * @memberof OpenSeadragon.Rect
 * @param {OpenSeadragon.Point} topLeft
 * @param {OpenSeadragon.Point} topRight
 * @param {OpenSeadragon.Point} bottomLeft
 * @returns {OpenSeadragon.Rect}
 */ $11.Rect.fromSummits = function(topLeft11, topRight11, bottomLeft11) {
        var width11 = topLeft11.distanceTo(topRight11);
        var height11 = topLeft11.distanceTo(bottomLeft11);
        var diff11 = topRight11.minus(topLeft11);
        var radians11 = Math.atan(diff11.y / diff11.x);
        if (diff11.x < 0) radians11 += Math.PI;
        else if (diff11.y < 0) radians11 += 2 * Math.PI;
        return new $11.Rect(topLeft11.x, topLeft11.y, width11, height11, radians11 / Math.PI * 180);
    };
    /** @lends OpenSeadragon.Rect.prototype */ $11.Rect.prototype = {
        /**
     * @function
     * @returns {OpenSeadragon.Rect} a duplicate of this Rect
     */ clone: function() {
            return new $11.Rect(this.x, this.y, this.width, this.height, this.degrees);
        },
        /**
     * The aspect ratio is simply the ratio of width to height.
     * @function
     * @returns {Number} The ratio of width to height.
     */ getAspectRatio: function() {
            return this.width / this.height;
        },
        /**
     * Provides the coordinates of the upper-left corner of the rectangle as a
     * point.
     * @function
     * @returns {OpenSeadragon.Point} The coordinate of the upper-left corner of
     *  the rectangle.
     */ getTopLeft: function() {
            return new $11.Point(this.x, this.y);
        },
        /**
     * Provides the coordinates of the bottom-right corner of the rectangle as a
     * point.
     * @function
     * @returns {OpenSeadragon.Point} The coordinate of the bottom-right corner of
     *  the rectangle.
     */ getBottomRight: function() {
            return new $11.Point(this.x + this.width, this.y + this.height).rotate(this.degrees, this.getTopLeft());
        },
        /**
     * Provides the coordinates of the top-right corner of the rectangle as a
     * point.
     * @function
     * @returns {OpenSeadragon.Point} The coordinate of the top-right corner of
     *  the rectangle.
     */ getTopRight: function() {
            return new $11.Point(this.x + this.width, this.y).rotate(this.degrees, this.getTopLeft());
        },
        /**
     * Provides the coordinates of the bottom-left corner of the rectangle as a
     * point.
     * @function
     * @returns {OpenSeadragon.Point} The coordinate of the bottom-left corner of
     *  the rectangle.
     */ getBottomLeft: function() {
            return new $11.Point(this.x, this.y + this.height).rotate(this.degrees, this.getTopLeft());
        },
        /**
     * Computes the center of the rectangle.
     * @function
     * @returns {OpenSeadragon.Point} The center of the rectangle as represented
     *  as represented by a 2-dimensional vector (x,y)
     */ getCenter: function() {
            return new $11.Point(this.x + this.width / 2.0, this.y + this.height / 2.0).rotate(this.degrees, this.getTopLeft());
        },
        /**
     * Returns the width and height component as a vector OpenSeadragon.Point
     * @function
     * @returns {OpenSeadragon.Point} The 2 dimensional vector representing the
     *  the width and height of the rectangle.
     */ getSize: function() {
            return new $11.Point(this.width, this.height);
        },
        /**
     * Determines if two Rectangles have equivalent components.
     * @function
     * @param {OpenSeadragon.Rect} rectangle The Rectangle to compare to.
     * @return {Boolean} 'true' if all components are equal, otherwise 'false'.
     */ equals: function(other11) {
            return other11 instanceof $11.Rect && this.x === other11.x && this.y === other11.y && this.width === other11.width && this.height === other11.height && this.degrees === other11.degrees;
        },
        /**
    * Multiply all dimensions (except degrees) in this Rect by a factor and
    * return a new Rect.
    * @function
    * @param {Number} factor The factor to multiply vector components.
    * @returns {OpenSeadragon.Rect} A new rect representing the multiplication
    *  of the vector components by the factor
    */ times: function(factor11) {
            return new $11.Rect(this.x * factor11, this.y * factor11, this.width * factor11, this.height * factor11, this.degrees);
        },
        /**
    * Translate/move this Rect by a vector and return new Rect.
    * @function
    * @param {OpenSeadragon.Point} delta The translation vector.
    * @returns {OpenSeadragon.Rect} A new rect with altered position
    */ translate: function(delta11) {
            return new $11.Rect(this.x + delta11.x, this.y + delta11.y, this.width, this.height, this.degrees);
        },
        /**
     * Returns the smallest rectangle that will contain this and the given
     * rectangle bounding boxes.
     * @param {OpenSeadragon.Rect} rect
     * @return {OpenSeadragon.Rect} The new rectangle.
     */ union: function(rect11) {
            var thisBoundingBox11 = this.getBoundingBox();
            var otherBoundingBox11 = rect11.getBoundingBox();
            var left11 = Math.min(thisBoundingBox11.x, otherBoundingBox11.x);
            var top11 = Math.min(thisBoundingBox11.y, otherBoundingBox11.y);
            var right11 = Math.max(thisBoundingBox11.x + thisBoundingBox11.width, otherBoundingBox11.x + otherBoundingBox11.width);
            var bottom11 = Math.max(thisBoundingBox11.y + thisBoundingBox11.height, otherBoundingBox11.y + otherBoundingBox11.height);
            return new $11.Rect(left11, top11, right11 - left11, bottom11 - top11);
        },
        /**
     * Returns the bounding box of the intersection of this rectangle with the
     * given rectangle.
     * @param {OpenSeadragon.Rect} rect
     * @return {OpenSeadragon.Rect} the bounding box of the intersection
     * or null if the rectangles don't intersect.
     */ intersection: function(rect11) {
            // Simplified version of Weiler Atherton clipping algorithm
            // https://en.wikipedia.org/wiki/Weiler%E2%80%93Atherton_clipping_algorithm
            // Because we just want the bounding box of the intersection,
            // we can just compute the bounding box of:
            // 1. all the summits of this which are inside rect
            // 2. all the summits of rect which are inside this
            // 3. all the intersections of rect and this
            var EPSILON11 = 0.0000000001;
            var intersectionPoints11 = [];
            var thisTopLeft11 = this.getTopLeft();
            if (rect11.containsPoint(thisTopLeft11, EPSILON11)) intersectionPoints11.push(thisTopLeft11);
            var thisTopRight11 = this.getTopRight();
            if (rect11.containsPoint(thisTopRight11, EPSILON11)) intersectionPoints11.push(thisTopRight11);
            var thisBottomLeft11 = this.getBottomLeft();
            if (rect11.containsPoint(thisBottomLeft11, EPSILON11)) intersectionPoints11.push(thisBottomLeft11);
            var thisBottomRight11 = this.getBottomRight();
            if (rect11.containsPoint(thisBottomRight11, EPSILON11)) intersectionPoints11.push(thisBottomRight11);
            var rectTopLeft11 = rect11.getTopLeft();
            if (this.containsPoint(rectTopLeft11, EPSILON11)) intersectionPoints11.push(rectTopLeft11);
            var rectTopRight11 = rect11.getTopRight();
            if (this.containsPoint(rectTopRight11, EPSILON11)) intersectionPoints11.push(rectTopRight11);
            var rectBottomLeft11 = rect11.getBottomLeft();
            if (this.containsPoint(rectBottomLeft11, EPSILON11)) intersectionPoints11.push(rectBottomLeft11);
            var rectBottomRight11 = rect11.getBottomRight();
            if (this.containsPoint(rectBottomRight11, EPSILON11)) intersectionPoints11.push(rectBottomRight11);
            var thisSegments11 = this._getSegments();
            var rectSegments11 = rect11._getSegments();
            for(var i11 = 0; i11 < thisSegments11.length; i11++){
                var thisSegment11 = thisSegments11[i11];
                for(var j11 = 0; j11 < rectSegments11.length; j11++){
                    var rectSegment11 = rectSegments11[j11];
                    var intersect11 = getIntersection11(thisSegment11[0], thisSegment11[1], rectSegment11[0], rectSegment11[1]);
                    if (intersect11) intersectionPoints11.push(intersect11);
                }
            }
            // Get intersection point of segments [a,b] and [c,d]
            function getIntersection11(a11, b11, c11, d11) {
                // http://stackoverflow.com/a/1968345/1440403
                var abVector11 = b11.minus(a11);
                var cdVector11 = d11.minus(c11);
                var denom11 = -cdVector11.x * abVector11.y + abVector11.x * cdVector11.y;
                if (denom11 === 0) return null;
                var s11 = (abVector11.x * (a11.y - c11.y) - abVector11.y * (a11.x - c11.x)) / denom11;
                var t11 = (cdVector11.x * (a11.y - c11.y) - cdVector11.y * (a11.x - c11.x)) / denom11;
                if (-EPSILON11 <= s11 && s11 <= 1 - EPSILON11 && -EPSILON11 <= t11 && t11 <= 1 - EPSILON11) return new $11.Point(a11.x + t11 * abVector11.x, a11.y + t11 * abVector11.y);
                return null;
            }
            if (intersectionPoints11.length === 0) return null;
            var minX11 = intersectionPoints11[0].x;
            var maxX11 = intersectionPoints11[0].x;
            var minY11 = intersectionPoints11[0].y;
            var maxY11 = intersectionPoints11[0].y;
            for(var k11 = 1; k11 < intersectionPoints11.length; k11++){
                var point31 = intersectionPoints11[k11];
                if (point31.x < minX11) minX11 = point31.x;
                if (point31.x > maxX11) maxX11 = point31.x;
                if (point31.y < minY11) minY11 = point31.y;
                if (point31.y > maxY11) maxY11 = point31.y;
            }
            return new $11.Rect(minX11, minY11, maxX11 - minX11, maxY11 - minY11);
        },
        // private
        _getSegments: function() {
            var topLeft11 = this.getTopLeft();
            var topRight11 = this.getTopRight();
            var bottomLeft11 = this.getBottomLeft();
            var bottomRight11 = this.getBottomRight();
            return [
                [
                    topLeft11,
                    topRight11
                ],
                [
                    topRight11,
                    bottomRight11
                ],
                [
                    bottomRight11,
                    bottomLeft11
                ],
                [
                    bottomLeft11,
                    topLeft11
                ]
            ];
        },
        /**
     * Rotates a rectangle around a point.
     * @function
     * @param {Number} degrees The angle in degrees to rotate.
     * @param {OpenSeadragon.Point} [pivot] The point about which to rotate.
     * Defaults to the center of the rectangle.
     * @return {OpenSeadragon.Rect}
     */ rotate: function(degrees11, pivot11) {
            degrees11 = $11.positiveModulo(degrees11, 360);
            if (degrees11 === 0) return this.clone();
            pivot11 = pivot11 || this.getCenter();
            var newTopLeft11 = this.getTopLeft().rotate(degrees11, pivot11);
            var newTopRight11 = this.getTopRight().rotate(degrees11, pivot11);
            var diff11 = newTopRight11.minus(newTopLeft11);
            // Handle floating point error
            diff11 = diff11.apply(function(x11) {
                var EPSILON11 = 1e-15;
                return Math.abs(x11) < EPSILON11 ? 0 : x11;
            });
            var radians11 = Math.atan(diff11.y / diff11.x);
            if (diff11.x < 0) radians11 += Math.PI;
            else if (diff11.y < 0) radians11 += 2 * Math.PI;
            return new $11.Rect(newTopLeft11.x, newTopLeft11.y, this.width, this.height, radians11 / Math.PI * 180);
        },
        /**
     * Retrieves the smallest horizontal (degrees=0) rectangle which contains
     * this rectangle.
     * @returns {OpenSeadragon.Rect}
     */ getBoundingBox: function() {
            if (this.degrees === 0) return this.clone();
            var topLeft11 = this.getTopLeft();
            var topRight11 = this.getTopRight();
            var bottomLeft11 = this.getBottomLeft();
            var bottomRight11 = this.getBottomRight();
            var minX11 = Math.min(topLeft11.x, topRight11.x, bottomLeft11.x, bottomRight11.x);
            var maxX11 = Math.max(topLeft11.x, topRight11.x, bottomLeft11.x, bottomRight11.x);
            var minY11 = Math.min(topLeft11.y, topRight11.y, bottomLeft11.y, bottomRight11.y);
            var maxY11 = Math.max(topLeft11.y, topRight11.y, bottomLeft11.y, bottomRight11.y);
            return new $11.Rect(minX11, minY11, maxX11 - minX11, maxY11 - minY11);
        },
        /**
     * Retrieves the smallest horizontal (degrees=0) rectangle which contains
     * this rectangle and has integers x, y, width and height
     * @returns {OpenSeadragon.Rect}
     */ getIntegerBoundingBox: function() {
            var boundingBox11 = this.getBoundingBox();
            var x11 = Math.floor(boundingBox11.x);
            var y11 = Math.floor(boundingBox11.y);
            var width11 = Math.ceil(boundingBox11.width + boundingBox11.x - x11);
            var height11 = Math.ceil(boundingBox11.height + boundingBox11.y - y11);
            return new $11.Rect(x11, y11, width11, height11);
        },
        /**
     * Determines whether a point is inside this rectangle (edge included).
     * @function
     * @param {OpenSeadragon.Point} point
     * @param {Number} [epsilon=0] the margin of error allowed
     * @returns {Boolean} true if the point is inside this rectangle, false
     * otherwise.
     */ containsPoint: function(point31, epsilon11) {
            epsilon11 = epsilon11 || 0;
            // See http://stackoverflow.com/a/2752754/1440403 for explanation
            var topLeft11 = this.getTopLeft();
            var topRight11 = this.getTopRight();
            var bottomLeft11 = this.getBottomLeft();
            var topDiff11 = topRight11.minus(topLeft11);
            var leftDiff11 = bottomLeft11.minus(topLeft11);
            return (point31.x - topLeft11.x) * topDiff11.x + (point31.y - topLeft11.y) * topDiff11.y >= -epsilon11 && (point31.x - topRight11.x) * topDiff11.x + (point31.y - topRight11.y) * topDiff11.y <= epsilon11 && (point31.x - topLeft11.x) * leftDiff11.x + (point31.y - topLeft11.y) * leftDiff11.y >= -epsilon11 && (point31.x - bottomLeft11.x) * leftDiff11.x + (point31.y - bottomLeft11.y) * leftDiff11.y <= epsilon11;
        },
        /**
     * Provides a string representation of the rectangle which is useful for
     * debugging.
     * @function
     * @returns {String} A string representation of the rectangle.
     */ toString: function() {
            return "[" + Math.round(this.x * 100) / 100 + ", " + Math.round(this.y * 100) / 100 + ", " + Math.round(this.width * 100) / 100 + "x" + Math.round(this.height * 100) / 100 + ", " + Math.round(this.degrees * 100) / 100 + "deg" + "]";
        }
    };
})(OpenSeadragon);
/*
 * OpenSeadragon - ReferenceStrip
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    // dictionary from id to private properties
    var THIS11 = {};
    /**
 *  The CollectionDrawer is a reimplementation if the Drawer API that
 *  focuses on allowing a viewport to be redefined as a collection
 *  of smaller viewports, defined by a clear number of rows and / or
 *  columns of which each item in the matrix of viewports has its own
 *  source.
 *
 *  This idea is a reexpression of the idea of dzi collections
 *  which allows a clearer algorithm to reuse the tile sources already
 *  supported by OpenSeadragon, in heterogenious or homogenious
 *  sequences just like mixed groups already supported by the viewer
 *  for the purpose of image sequnces.
 *
 *  TODO:   The difficult part of this feature is figuring out how to express
 *          this functionality as a combination of the functionality already
 *          provided by Drawer, Viewport, TileSource, and Navigator.  It may
 *          require better abstraction at those points in order to effeciently
 *          reuse those paradigms.
 */ /**
 * @class ReferenceStrip
 * @memberof OpenSeadragon
 * @param {Object} options
 */ $11.ReferenceStrip = function(options11) {
        var _this11 = this, viewer11 = options11.viewer, viewerSize11 = $11.getElementSize(viewer11.element), element11, style11, i11;
        //We may need to create a new element and id if they did not
        //provide the id for the existing element
        if (!options11.id) {
            options11.id = "referencestrip-" + $11.now();
            this.element = $11.makeNeutralElement("div");
            this.element.id = options11.id;
            this.element.className = "referencestrip";
        }
        options11 = $11.extend(true, {
            sizeRatio: $11.DEFAULT_SETTINGS.referenceStripSizeRatio,
            position: $11.DEFAULT_SETTINGS.referenceStripPosition,
            scroll: $11.DEFAULT_SETTINGS.referenceStripScroll,
            clickTimeThreshold: $11.DEFAULT_SETTINGS.clickTimeThreshold
        }, options11, {
            //required overrides
            element: this.element,
            //These need to be overridden to prevent recursion since
            //the navigator is a viewer and a viewer has a navigator
            showNavigator: false,
            mouseNavEnabled: false,
            showNavigationControl: false,
            showSequenceControl: false
        });
        $11.extend(this, options11);
        //Private state properties
        THIS11[this.id] = {
            "animating": false
        };
        this.minPixelRatio = this.viewer.minPixelRatio;
        style11 = this.element.style;
        style11.marginTop = "0px";
        style11.marginRight = "0px";
        style11.marginBottom = "0px";
        style11.marginLeft = "0px";
        style11.left = "0px";
        style11.bottom = "0px";
        style11.border = "0px";
        style11.background = "#000";
        style11.position = "relative";
        $11.setElementTouchActionNone(this.element);
        $11.setElementOpacity(this.element, 0.8);
        this.viewer = viewer11;
        this.innerTracker = new $11.MouseTracker({
            element: this.element,
            dragHandler: $11.delegate(this, onStripDrag11),
            scrollHandler: $11.delegate(this, onStripScroll11),
            enterHandler: $11.delegate(this, onStripEnter11),
            exitHandler: $11.delegate(this, onStripExit11),
            keyDownHandler: $11.delegate(this, onKeyDown11),
            keyHandler: $11.delegate(this, onKeyPress11)
        });
        //Controls the position and orientation of the reference strip and sets the
        //appropriate width and height
        if (options11.width && options11.height) {
            this.element.style.width = options11.width + "px";
            this.element.style.height = options11.height + "px";
            viewer11.addControl(this.element, {
                anchor: $11.ControlAnchor.BOTTOM_LEFT
            });
        } else if ("horizontal" == options11.scroll) {
            this.element.style.width = viewerSize11.x * options11.sizeRatio * viewer11.tileSources.length + 12 * viewer11.tileSources.length + "px";
            this.element.style.height = viewerSize11.y * options11.sizeRatio + "px";
            viewer11.addControl(this.element, {
                anchor: $11.ControlAnchor.BOTTOM_LEFT
            });
        } else {
            this.element.style.height = viewerSize11.y * options11.sizeRatio * viewer11.tileSources.length + 12 * viewer11.tileSources.length + "px";
            this.element.style.width = viewerSize11.x * options11.sizeRatio + "px";
            viewer11.addControl(this.element, {
                anchor: $11.ControlAnchor.TOP_LEFT
            });
        }
        this.panelWidth = viewerSize11.x * this.sizeRatio + 8;
        this.panelHeight = viewerSize11.y * this.sizeRatio + 8;
        this.panels = [];
        this.miniViewers = {};
        /*jshint loopfunc:true*/ for(i11 = 0; i11 < viewer11.tileSources.length; i11++){
            element11 = $11.makeNeutralElement("div");
            element11.id = this.element.id + "-" + i11;
            element11.style.width = _this11.panelWidth + "px";
            element11.style.height = _this11.panelHeight + "px";
            element11.style.display = "inline";
            element11.style.float = "left"; //Webkit
            element11.style.cssFloat = "left"; //Firefox
            element11.style.styleFloat = "left"; //IE
            element11.style.padding = "2px";
            $11.setElementTouchActionNone(element11);
            element11.innerTracker = new $11.MouseTracker({
                element: element11,
                clickTimeThreshold: this.clickTimeThreshold,
                clickDistThreshold: this.clickDistThreshold,
                pressHandler: function(event11) {
                    event11.eventSource.dragging = $11.now();
                },
                releaseHandler: function(event11) {
                    var tracker11 = event11.eventSource, id11 = tracker11.element.id, page11 = Number(id11.split("-")[2]), now11 = $11.now();
                    if (event11.insideElementPressed && event11.insideElementReleased && tracker11.dragging && now11 - tracker11.dragging < tracker11.clickTimeThreshold) {
                        tracker11.dragging = null;
                        viewer11.goToPage(page11);
                    }
                }
            });
            this.element.appendChild(element11);
            element11.activePanel = false;
            this.panels.push(element11);
        }
        loadPanels11(this, this.scroll == "vertical" ? viewerSize11.y : viewerSize11.x, 0);
        this.setFocus(0);
    };
    $11.extend($11.ReferenceStrip.prototype, $11.EventSource.prototype, $11.Viewer.prototype, /** @lends OpenSeadragon.ReferenceStrip.prototype */ {
        /**
     * @function
     */ setFocus: function(page11) {
            var element11 = $11.getElement(this.element.id + "-" + page11), viewerSize11 = $11.getElementSize(this.viewer.canvas), scrollWidth11 = Number(this.element.style.width.replace("px", "")), scrollHeight11 = Number(this.element.style.height.replace("px", "")), offsetLeft11 = -Number(this.element.style.marginLeft.replace("px", "")), offsetTop11 = -Number(this.element.style.marginTop.replace("px", "")), offset11;
            if (this.currentSelected !== element11) {
                if (this.currentSelected) this.currentSelected.style.background = "#000";
                this.currentSelected = element11;
                this.currentSelected.style.background = "#999";
                if ("horizontal" == this.scroll) {
                    //right left
                    offset11 = Number(page11) * (this.panelWidth + 3);
                    if (offset11 > offsetLeft11 + viewerSize11.x - this.panelWidth) {
                        offset11 = Math.min(offset11, scrollWidth11 - viewerSize11.x);
                        this.element.style.marginLeft = -offset11 + "px";
                        loadPanels11(this, viewerSize11.x, -offset11);
                    } else if (offset11 < offsetLeft11) {
                        offset11 = Math.max(0, offset11 - viewerSize11.x / 2);
                        this.element.style.marginLeft = -offset11 + "px";
                        loadPanels11(this, viewerSize11.x, -offset11);
                    }
                } else {
                    offset11 = Number(page11) * (this.panelHeight + 3);
                    if (offset11 > offsetTop11 + viewerSize11.y - this.panelHeight) {
                        offset11 = Math.min(offset11, scrollHeight11 - viewerSize11.y);
                        this.element.style.marginTop = -offset11 + "px";
                        loadPanels11(this, viewerSize11.y, -offset11);
                    } else if (offset11 < offsetTop11) {
                        offset11 = Math.max(0, offset11 - viewerSize11.y / 2);
                        this.element.style.marginTop = -offset11 + "px";
                        loadPanels11(this, viewerSize11.y, -offset11);
                    }
                }
                this.currentPage = page11;
                onStripEnter11.call(this, {
                    eventSource: this.innerTracker
                });
            }
        },
        /**
     * @function
     */ update: function() {
            if (THIS11[this.id].animating) {
                $11.console.log("image reference strip update");
                return true;
            }
            return false;
        },
        // Overrides Viewer.destroy
        destroy: function() {
            if (this.miniViewers) for(var key11 in this.miniViewers)this.miniViewers[key11].destroy();
            if (this.element) this.element.parentNode.removeChild(this.element);
        }
    });
    /**
 * @private
 * @inner
 * @function
 */ function onStripDrag11(event11) {
        var offsetLeft11 = Number(this.element.style.marginLeft.replace("px", "")), offsetTop11 = Number(this.element.style.marginTop.replace("px", "")), scrollWidth11 = Number(this.element.style.width.replace("px", "")), scrollHeight11 = Number(this.element.style.height.replace("px", "")), viewerSize11 = $11.getElementSize(this.viewer.canvas);
        this.dragging = true;
        if (this.element) {
            if ("horizontal" == this.scroll) {
                if (-event11.delta.x > 0) //forward
                {
                    if (offsetLeft11 > -(scrollWidth11 - viewerSize11.x)) {
                        this.element.style.marginLeft = offsetLeft11 + event11.delta.x * 2 + "px";
                        loadPanels11(this, viewerSize11.x, offsetLeft11 + event11.delta.x * 2);
                    }
                } else if (-event11.delta.x < 0) //reverse
                {
                    if (offsetLeft11 < 0) {
                        this.element.style.marginLeft = offsetLeft11 + event11.delta.x * 2 + "px";
                        loadPanels11(this, viewerSize11.x, offsetLeft11 + event11.delta.x * 2);
                    }
                }
            } else {
                if (-event11.delta.y > 0) //forward
                {
                    if (offsetTop11 > -(scrollHeight11 - viewerSize11.y)) {
                        this.element.style.marginTop = offsetTop11 + event11.delta.y * 2 + "px";
                        loadPanels11(this, viewerSize11.y, offsetTop11 + event11.delta.y * 2);
                    }
                } else if (-event11.delta.y < 0) //reverse
                {
                    if (offsetTop11 < 0) {
                        this.element.style.marginTop = offsetTop11 + event11.delta.y * 2 + "px";
                        loadPanels11(this, viewerSize11.y, offsetTop11 + event11.delta.y * 2);
                    }
                }
            }
        }
        return false;
    }
    /**
 * @private
 * @inner
 * @function
 */ function onStripScroll11(event11) {
        var offsetLeft11 = Number(this.element.style.marginLeft.replace("px", "")), offsetTop11 = Number(this.element.style.marginTop.replace("px", "")), scrollWidth11 = Number(this.element.style.width.replace("px", "")), scrollHeight11 = Number(this.element.style.height.replace("px", "")), viewerSize11 = $11.getElementSize(this.viewer.canvas);
        if (this.element) {
            if ("horizontal" == this.scroll) {
                if (event11.scroll > 0) //forward
                {
                    if (offsetLeft11 > -(scrollWidth11 - viewerSize11.x)) {
                        this.element.style.marginLeft = offsetLeft11 - event11.scroll * 60 + "px";
                        loadPanels11(this, viewerSize11.x, offsetLeft11 - event11.scroll * 60);
                    }
                } else if (event11.scroll < 0) //reverse
                {
                    if (offsetLeft11 < 0) {
                        this.element.style.marginLeft = offsetLeft11 - event11.scroll * 60 + "px";
                        loadPanels11(this, viewerSize11.x, offsetLeft11 - event11.scroll * 60);
                    }
                }
            } else {
                if (event11.scroll < 0) //scroll up
                {
                    if (offsetTop11 > viewerSize11.y - scrollHeight11) {
                        this.element.style.marginTop = offsetTop11 + event11.scroll * 60 + "px";
                        loadPanels11(this, viewerSize11.y, offsetTop11 + event11.scroll * 60);
                    }
                } else if (event11.scroll > 0) //scroll dowm
                {
                    if (offsetTop11 < 0) {
                        this.element.style.marginTop = offsetTop11 + event11.scroll * 60 + "px";
                        loadPanels11(this, viewerSize11.y, offsetTop11 + event11.scroll * 60);
                    }
                }
            }
        }
        //cancels event
        return false;
    }
    function loadPanels11(strip11, viewerSize11, scroll11) {
        var panelSize11, activePanelsStart11, activePanelsEnd11, miniViewer11, style11, i11, element11;
        if ("horizontal" == strip11.scroll) panelSize11 = strip11.panelWidth;
        else panelSize11 = strip11.panelHeight;
        activePanelsStart11 = Math.ceil(viewerSize11 / panelSize11) + 5;
        activePanelsEnd11 = Math.ceil((Math.abs(scroll11) + viewerSize11) / panelSize11) + 1;
        activePanelsStart11 = activePanelsEnd11 - activePanelsStart11;
        activePanelsStart11 = activePanelsStart11 < 0 ? 0 : activePanelsStart11;
        for(i11 = activePanelsStart11; i11 < activePanelsEnd11 && i11 < strip11.panels.length; i11++){
            element11 = strip11.panels[i11];
            if (!element11.activePanel) {
                var miniTileSource11;
                var originalTileSource11 = strip11.viewer.tileSources[i11];
                if (originalTileSource11.referenceStripThumbnailUrl) miniTileSource11 = {
                    type: "image",
                    url: originalTileSource11.referenceStripThumbnailUrl
                };
                else miniTileSource11 = originalTileSource11;
                miniViewer11 = new $11.Viewer({
                    id: element11.id,
                    tileSources: [
                        miniTileSource11
                    ],
                    element: element11,
                    navigatorSizeRatio: strip11.sizeRatio,
                    showNavigator: false,
                    mouseNavEnabled: false,
                    showNavigationControl: false,
                    showSequenceControl: false,
                    immediateRender: true,
                    blendTime: 0,
                    animationTime: 0
                });
                miniViewer11.displayRegion = $11.makeNeutralElement("div");
                miniViewer11.displayRegion.id = element11.id + "-displayregion";
                miniViewer11.displayRegion.className = "displayregion";
                style11 = miniViewer11.displayRegion.style;
                style11.position = "relative";
                style11.top = "0px";
                style11.left = "0px";
                style11.fontSize = "0px";
                style11.overflow = "hidden";
                style11.float = "left"; //Webkit
                style11.cssFloat = "left"; //Firefox
                style11.styleFloat = "left"; //IE
                style11.zIndex = 999999999;
                style11.cursor = "default";
                style11.width = strip11.panelWidth - 4 + "px";
                style11.height = strip11.panelHeight - 4 + "px";
                // TODO: What is this for? Future keyboard navigation support?
                miniViewer11.displayRegion.innerTracker = new $11.MouseTracker({
                    element: miniViewer11.displayRegion,
                    startDisabled: true
                });
                element11.getElementsByTagName("div")[0].appendChild(miniViewer11.displayRegion);
                strip11.miniViewers[element11.id] = miniViewer11;
                element11.activePanel = true;
            }
        }
    }
    /**
 * @private
 * @inner
 * @function
 */ function onStripEnter11(event11) {
        var element11 = event11.eventSource.element;
        //$.setElementOpacity(element, 0.8);
        //element.style.border = '1px solid #555';
        //element.style.background = '#000';
        if ("horizontal" == this.scroll) //element.style.paddingTop = "0px";
        element11.style.marginBottom = "0px";
        else //element.style.paddingRight = "0px";
        element11.style.marginLeft = "0px";
        return false;
    }
    /**
 * @private
 * @inner
 * @function
 */ function onStripExit11(event11) {
        var element11 = event11.eventSource.element;
        if ("horizontal" == this.scroll) //element.style.paddingTop = "10px";
        element11.style.marginBottom = "-" + $11.getElementSize(element11).y / 2 + "px";
        else //element.style.paddingRight = "10px";
        element11.style.marginLeft = "-" + $11.getElementSize(element11).x / 2 + "px";
        return false;
    }
    /**
 * @private
 * @inner
 * @function
 */ function onKeyDown11(event11) {
        //console.log( event.keyCode );
        if (!event11.preventDefaultAction && !event11.ctrl && !event11.alt && !event11.meta) switch(event11.keyCode){
            case 38:
                onStripScroll11.call(this, {
                    eventSource: this.tracker,
                    position: null,
                    scroll: 1,
                    shift: null
                });
                return false;
            case 40:
                onStripScroll11.call(this, {
                    eventSource: this.tracker,
                    position: null,
                    scroll: -1,
                    shift: null
                });
                return false;
            case 37:
                onStripScroll11.call(this, {
                    eventSource: this.tracker,
                    position: null,
                    scroll: -1,
                    shift: null
                });
                return false;
            case 39:
                onStripScroll11.call(this, {
                    eventSource: this.tracker,
                    position: null,
                    scroll: 1,
                    shift: null
                });
                return false;
            default:
                //console.log( 'navigator keycode %s', event.keyCode );
                return true;
        }
        else return true;
    }
    /**
 * @private
 * @inner
 * @function
 */ function onKeyPress11(event11) {
        //console.log( event.keyCode );
        if (!event11.preventDefaultAction && !event11.ctrl && !event11.alt && !event11.meta) switch(event11.keyCode){
            case 61:
                onStripScroll11.call(this, {
                    eventSource: this.tracker,
                    position: null,
                    scroll: 1,
                    shift: null
                });
                return false;
            case 45:
                onStripScroll11.call(this, {
                    eventSource: this.tracker,
                    position: null,
                    scroll: -1,
                    shift: null
                });
                return false;
            case 48:
            case 119:
            case 87:
                onStripScroll11.call(this, {
                    eventSource: this.tracker,
                    position: null,
                    scroll: 1,
                    shift: null
                });
                return false;
            case 115:
            case 83:
                onStripScroll11.call(this, {
                    eventSource: this.tracker,
                    position: null,
                    scroll: -1,
                    shift: null
                });
                return false;
            case 97:
                onStripScroll11.call(this, {
                    eventSource: this.tracker,
                    position: null,
                    scroll: -1,
                    shift: null
                });
                return false;
            case 100:
                onStripScroll11.call(this, {
                    eventSource: this.tracker,
                    position: null,
                    scroll: 1,
                    shift: null
                });
                return false;
            default:
                //console.log( 'navigator keycode %s', event.keyCode );
                return true;
        }
        else return true;
    }
})(OpenSeadragon);
/*
 * OpenSeadragon - DisplayRect
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    /**
 * @class DisplayRect
 * @classdesc A display rectangle is very similar to {@link OpenSeadragon.Rect} but adds two
 * fields, 'minLevel' and 'maxLevel' which denote the supported zoom levels
 * for this rectangle.
 *
 * @memberof OpenSeadragon
 * @extends OpenSeadragon.Rect
 * @param {Number} x The vector component 'x'.
 * @param {Number} y The vector component 'y'.
 * @param {Number} width The vector component 'height'.
 * @param {Number} height The vector component 'width'.
 * @param {Number} minLevel The lowest zoom level supported.
 * @param {Number} maxLevel The highest zoom level supported.
 */ $11.DisplayRect = function(x11, y11, width11, height11, minLevel11, maxLevel11) {
        $11.Rect.apply(this, [
            x11,
            y11,
            width11,
            height11
        ]);
        /**
     * The lowest zoom level supported.
     * @member {Number} minLevel
     * @memberof OpenSeadragon.DisplayRect#
     */ this.minLevel = minLevel11;
        /**
     * The highest zoom level supported.
     * @member {Number} maxLevel
     * @memberof OpenSeadragon.DisplayRect#
     */ this.maxLevel = maxLevel11;
    };
    $11.extend($11.DisplayRect.prototype, $11.Rect.prototype);
})(OpenSeadragon);
/*
 * OpenSeadragon - Spring
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    /**
 * @class Spring
 * @memberof OpenSeadragon
 * @param {Object} options - Spring configuration settings.
 * @param {Number} options.springStiffness - Spring stiffness. Must be greater than zero.
 * The closer to zero, the closer to linear animation.
 * @param {Number} options.animationTime - Animation duration per spring, in seconds.
 * Must be zero or greater.
 * @param {Number} [options.initial=0] - Initial value of spring.
 * @param {Boolean} [options.exponential=false] - Whether this spring represents
 * an exponential scale (such as zoom) and should be animated accordingly. Note that
 * exponential springs must have non-zero values.
 */ $11.Spring = function(options11) {
        var args11 = arguments;
        if (typeof options11 != "object") //allows backward compatible use of ( initialValue, config ) as
        //constructor parameters
        options11 = {
            initial: args11.length && typeof args11[0] == "number" ? args11[0] : undefined,
            /**
             * Spring stiffness.
             * @member {Number} springStiffness
             * @memberof OpenSeadragon.Spring#
             */ springStiffness: args11.length > 1 ? args11[1].springStiffness : 5.0,
            /**
             * Animation duration per spring.
             * @member {Number} animationTime
             * @memberof OpenSeadragon.Spring#
             */ animationTime: args11.length > 1 ? args11[1].animationTime : 1.5
        };
        $11.console.assert(typeof options11.springStiffness === "number" && options11.springStiffness !== 0, "[OpenSeadragon.Spring] options.springStiffness must be a non-zero number");
        $11.console.assert(typeof options11.animationTime === "number" && options11.animationTime >= 0, "[OpenSeadragon.Spring] options.animationTime must be a number greater than or equal to 0");
        if (options11.exponential) {
            this._exponential = true;
            delete options11.exponential;
        }
        $11.extend(true, this, options11);
        /**
     * @member {Object} current
     * @memberof OpenSeadragon.Spring#
     * @property {Number} value
     * @property {Number} time
     */ this.current = {
            value: typeof this.initial == "number" ? this.initial : this._exponential ? 0 : 1,
            time: $11.now() // always work in milliseconds
        };
        $11.console.assert(!this._exponential || this.current.value !== 0, "[OpenSeadragon.Spring] value must be non-zero for exponential springs");
        /**
     * @member {Object} start
     * @memberof OpenSeadragon.Spring#
     * @property {Number} value
     * @property {Number} time
     */ this.start = {
            value: this.current.value,
            time: this.current.time
        };
        /**
     * @member {Object} target
     * @memberof OpenSeadragon.Spring#
     * @property {Number} value
     * @property {Number} time
     */ this.target = {
            value: this.current.value,
            time: this.current.time
        };
        if (this._exponential) {
            this.start._logValue = Math.log(this.start.value);
            this.target._logValue = Math.log(this.target.value);
            this.current._logValue = Math.log(this.current.value);
        }
    };
    /** @lends OpenSeadragon.Spring.prototype */ $11.Spring.prototype = {
        /**
     * @function
     * @param {Number} target
     */ resetTo: function(target11) {
            $11.console.assert(!this._exponential || target11 !== 0, "[OpenSeadragon.Spring.resetTo] target must be non-zero for exponential springs");
            this.start.value = this.target.value = this.current.value = target11;
            this.start.time = this.target.time = this.current.time = $11.now();
            if (this._exponential) {
                this.start._logValue = Math.log(this.start.value);
                this.target._logValue = Math.log(this.target.value);
                this.current._logValue = Math.log(this.current.value);
            }
        },
        /**
     * @function
     * @param {Number} target
     */ springTo: function(target11) {
            $11.console.assert(!this._exponential || target11 !== 0, "[OpenSeadragon.Spring.springTo] target must be non-zero for exponential springs");
            this.start.value = this.current.value;
            this.start.time = this.current.time;
            this.target.value = target11;
            this.target.time = this.start.time + 1000 * this.animationTime;
            if (this._exponential) {
                this.start._logValue = Math.log(this.start.value);
                this.target._logValue = Math.log(this.target.value);
            }
        },
        /**
     * @function
     * @param {Number} delta
     */ shiftBy: function(delta11) {
            this.start.value += delta11;
            this.target.value += delta11;
            if (this._exponential) {
                $11.console.assert(this.target.value !== 0 && this.start.value !== 0, "[OpenSeadragon.Spring.shiftBy] spring value must be non-zero for exponential springs");
                this.start._logValue = Math.log(this.start.value);
                this.target._logValue = Math.log(this.target.value);
            }
        },
        setExponential: function(value11) {
            this._exponential = value11;
            if (this._exponential) {
                $11.console.assert(this.current.value !== 0 && this.target.value !== 0 && this.start.value !== 0, "[OpenSeadragon.Spring.setExponential] spring value must be non-zero for exponential springs");
                this.start._logValue = Math.log(this.start.value);
                this.target._logValue = Math.log(this.target.value);
                this.current._logValue = Math.log(this.current.value);
            }
        },
        /**
     * @function
     * @returns true if the value got updated, false otherwise
     */ update: function() {
            this.current.time = $11.now();
            var startValue11, targetValue11;
            if (this._exponential) {
                startValue11 = this.start._logValue;
                targetValue11 = this.target._logValue;
            } else {
                startValue11 = this.start.value;
                targetValue11 = this.target.value;
            }
            var currentValue11 = this.current.time >= this.target.time ? targetValue11 : startValue11 + (targetValue11 - startValue11) * transform11(this.springStiffness, (this.current.time - this.start.time) / (this.target.time - this.start.time));
            var oldValue11 = this.current.value;
            if (this._exponential) this.current.value = Math.exp(currentValue11);
            else this.current.value = currentValue11;
            return oldValue11 != this.current.value;
        },
        /**
     * Returns whether the spring is at the target value
     * @function
     * @returns {Boolean} True if at target value, false otherwise
     */ isAtTargetValue: function() {
            return this.current.value === this.target.value;
        }
    };
    /**
 * @private
 */ function transform11(stiffness11, x11) {
        return (1.0 - Math.exp(stiffness11 * -x11)) / (1.0 - Math.exp(-stiffness11));
    }
})(OpenSeadragon);
/*
 * OpenSeadragon - ImageLoader
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors

 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    /**
 * @private
 * @class ImageJob
 * @classdesc Handles downloading of a single image.
 * @param {Object} options - Options for this ImageJob.
 * @param {String} [options.src] - URL of image to download.
 * @param {String} [options.loadWithAjax] - Whether to load this image with AJAX.
 * @param {String} [options.ajaxHeaders] - Headers to add to the image request if using AJAX.
 * @param {String} [options.crossOriginPolicy] - CORS policy to use for downloads
 * @param {Function} [options.callback] - Called once image has been downloaded.
 * @param {Function} [options.abort] - Called when this image job is aborted.
 * @param {Number} [options.timeout] - The max number of milliseconds that this image job may take to complete.
 */ function ImageJob11(options11) {
        $11.extend(true, this, {
            timeout: $11.DEFAULT_SETTINGS.timeout,
            jobId: null
        }, options11);
        /**
     * Image object which will contain downloaded image.
     * @member {Image} image
     * @memberof OpenSeadragon.ImageJob#
     */ this.image = null;
    }
    ImageJob11.prototype = {
        errorMsg: null,
        /**
     * Starts the image job.
     * @method
     */ start: function() {
            var self11 = this;
            var selfAbort11 = this.abort;
            this.image = new Image();
            this.image.onload = function() {
                self11.finish(true);
            };
            this.image.onabort = this.image.onerror = function() {
                self11.errorMsg = "Image load aborted";
                self11.finish(false);
            };
            this.jobId = window.setTimeout(function() {
                self11.errorMsg = "Image load exceeded timeout";
                self11.finish(false);
            }, this.timeout);
            // Load the tile with an AJAX request if the loadWithAjax option is
            // set. Otherwise load the image by setting the source proprety of the image object.
            if (this.loadWithAjax) {
                this.request = $11.makeAjaxRequest({
                    url: this.src,
                    withCredentials: this.ajaxWithCredentials,
                    headers: this.ajaxHeaders,
                    responseType: "arraybuffer",
                    success: function(request11) {
                        var blb11;
                        // Make the raw data into a blob.
                        // BlobBuilder fallback adapted from
                        // http://stackoverflow.com/questions/15293694/blob-constructor-browser-compatibility
                        try {
                            blb11 = new window.Blob([
                                request11.response
                            ]);
                        } catch (e11) {
                            var BlobBuilder11 = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
                            if (e11.name === "TypeError" && BlobBuilder11) {
                                var bb11 = new BlobBuilder11();
                                bb11.append(request11.response);
                                blb11 = bb11.getBlob();
                            }
                        }
                        // If the blob is empty for some reason consider the image load a failure.
                        if (blb11.size === 0) {
                            self11.errorMsg = "Empty image response.";
                            self11.finish(false);
                        }
                        // Create a URL for the blob data and make it the source of the image object.
                        // This will still trigger Image.onload to indicate a successful tile load.
                        var url11 = (window.URL || window.webkitURL).createObjectURL(blb11);
                        self11.image.src = url11;
                    },
                    error: function(request11) {
                        self11.errorMsg = "Image load aborted - XHR error";
                        self11.finish(false);
                    }
                });
                // Provide a function to properly abort the request.
                this.abort = function() {
                    self11.request.abort();
                    // Call the existing abort function if available
                    if (typeof selfAbort11 === "function") selfAbort11();
                };
            } else {
                if (this.crossOriginPolicy !== false) this.image.crossOrigin = this.crossOriginPolicy;
                this.image.src = this.src;
            }
        },
        finish: function(successful11) {
            this.image.onload = this.image.onerror = this.image.onabort = null;
            if (!successful11) this.image = null;
            if (this.jobId) window.clearTimeout(this.jobId);
            this.callback(this);
        }
    };
    /**
 * @class ImageLoader
 * @memberof OpenSeadragon
 * @classdesc Handles downloading of a set of images using asynchronous queue pattern.
 * You generally won't have to interact with the ImageLoader directly.
 * @param {Object} options - Options for this ImageLoader.
 * @param {Number} [options.jobLimit] - The number of concurrent image requests. See imageLoaderLimit in {@link OpenSeadragon.Options} for details.
 * @param {Number} [options.timeout] - The max number of milliseconds that an image job may take to complete.
 */ $11.ImageLoader = function(options11) {
        $11.extend(true, this, {
            jobLimit: $11.DEFAULT_SETTINGS.imageLoaderLimit,
            timeout: $11.DEFAULT_SETTINGS.timeout,
            jobQueue: [],
            jobsInProgress: 0
        }, options11);
    };
    /** @lends OpenSeadragon.ImageLoader.prototype */ $11.ImageLoader.prototype = {
        /**
     * Add an unloaded image to the loader queue.
     * @method
     * @param {Object} options - Options for this job.
     * @param {String} [options.src] - URL of image to download.
     * @param {String} [options.loadWithAjax] - Whether to load this image with AJAX.
     * @param {String} [options.ajaxHeaders] - Headers to add to the image request if using AJAX.
     * @param {String|Boolean} [options.crossOriginPolicy] - CORS policy to use for downloads
     * @param {Boolean} [options.ajaxWithCredentials] - Whether to set withCredentials on AJAX
     * requests.
     * @param {Function} [options.callback] - Called once image has been downloaded.
     * @param {Function} [options.abort] - Called when this image job is aborted.
     */ addJob: function(options11) {
            var _this11 = this, complete11 = function(job11) {
                completeJob11(_this11, job11, options11.callback);
            }, jobOptions11 = {
                src: options11.src,
                loadWithAjax: options11.loadWithAjax,
                ajaxHeaders: options11.loadWithAjax ? options11.ajaxHeaders : null,
                crossOriginPolicy: options11.crossOriginPolicy,
                ajaxWithCredentials: options11.ajaxWithCredentials,
                callback: complete11,
                abort: options11.abort,
                timeout: this.timeout
            }, newJob11 = new ImageJob11(jobOptions11);
            if (!this.jobLimit || this.jobsInProgress < this.jobLimit) {
                newJob11.start();
                this.jobsInProgress++;
            } else this.jobQueue.push(newJob11);
        },
        /**
     * Clear any unstarted image loading jobs from the queue.
     * @method
     */ clear: function() {
            for(var i11 = 0; i11 < this.jobQueue.length; i11++){
                var job11 = this.jobQueue[i11];
                if (typeof job11.abort === "function") job11.abort();
            }
            this.jobQueue = [];
        }
    };
    /**
 * Cleans up ImageJob once completed.
 * @method
 * @private
 * @param loader - ImageLoader used to start job.
 * @param job - The ImageJob that has completed.
 * @param callback - Called once cleanup is finished.
 */ function completeJob11(loader11, job11, callback11) {
        var nextJob11;
        loader11.jobsInProgress--;
        if ((!loader11.jobLimit || loader11.jobsInProgress < loader11.jobLimit) && loader11.jobQueue.length > 0) {
            nextJob11 = loader11.jobQueue.shift();
            nextJob11.start();
            loader11.jobsInProgress++;
        }
        callback11(job11.image, job11.errorMsg, job11.request);
    }
})(OpenSeadragon);
/*
 * OpenSeadragon - Tile
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    /**
 * @class Tile
 * @memberof OpenSeadragon
 * @param {Number} level The zoom level this tile belongs to.
 * @param {Number} x The vector component 'x'.
 * @param {Number} y The vector component 'y'.
 * @param {OpenSeadragon.Rect} bounds Where this tile fits, in normalized
 *      coordinates.
 * @param {Boolean} exists Is this tile a part of a sparse image? ( Also has
 *      this tile failed to load? )
 * @param {String} url The URL of this tile's image.
 * @param {CanvasRenderingContext2D} context2D The context2D of this tile if it
 * is provided directly by the tile source.
 * @param {Boolean} loadWithAjax Whether this tile image should be loaded with an AJAX request .
 * @param {Object} ajaxHeaders The headers to send with this tile's AJAX request (if applicable).
 * @param {OpenSeadragon.Rect} sourceBounds The portion of the tile to use as the source of the
 * drawing operation, in pixels. Note that this only works when drawing with canvas; when drawing
 * with HTML the entire tile is always used.
 */ $11.Tile = function(level11, x11, y11, bounds11, exists11, url11, context2D11, loadWithAjax11, ajaxHeaders11, sourceBounds11) {
        /**
     * The zoom level this tile belongs to.
     * @member {Number} level
     * @memberof OpenSeadragon.Tile#
     */ this.level = level11;
        /**
     * The vector component 'x'.
     * @member {Number} x
     * @memberof OpenSeadragon.Tile#
     */ this.x = x11;
        /**
     * The vector component 'y'.
     * @member {Number} y
     * @memberof OpenSeadragon.Tile#
     */ this.y = y11;
        /**
     * Where this tile fits, in normalized coordinates
     * @member {OpenSeadragon.Rect} bounds
     * @memberof OpenSeadragon.Tile#
     */ this.bounds = bounds11;
        /**
    * The portion of the tile to use as the source of the drawing operation, in pixels. Note that
    * this only works when drawing with canvas; when drawing with HTML the entire tile is always used.
    * @member {OpenSeadragon.Rect} sourceBounds
    * @memberof OpenSeadragon.Tile#
    */ this.sourceBounds = sourceBounds11;
        /**
     * Is this tile a part of a sparse image? Also has this tile failed to load?
     * @member {Boolean} exists
     * @memberof OpenSeadragon.Tile#
     */ this.exists = exists11;
        /**
     * The URL of this tile's image.
     * @member {String} url
     * @memberof OpenSeadragon.Tile#
     */ this.url = url11;
        /**
     * The context2D of this tile if it is provided directly by the tile source.
     * @member {CanvasRenderingContext2D} context2D
     * @memberOf OpenSeadragon.Tile#
     */ this.context2D = context2D11;
        /**
     * Whether to load this tile's image with an AJAX request.
     * @member {Boolean} loadWithAjax
     * @memberof OpenSeadragon.Tile#
     */ this.loadWithAjax = loadWithAjax11;
        /**
     * The headers to be used in requesting this tile's image.
     * Only used if loadWithAjax is set to true.
     * @member {Object} ajaxHeaders
     * @memberof OpenSeadragon.Tile#
     */ this.ajaxHeaders = ajaxHeaders11;
        /**
     * The unique cache key for this tile.
     * @member {String} cacheKey
     * @memberof OpenSeadragon.Tile#
     */ if (this.ajaxHeaders) this.cacheKey = this.url + "+" + JSON.stringify(this.ajaxHeaders);
        else this.cacheKey = this.url;
        /**
     * Is this tile loaded?
     * @member {Boolean} loaded
     * @memberof OpenSeadragon.Tile#
     */ this.loaded = false;
        /**
     * Is this tile loading?
     * @member {Boolean} loading
     * @memberof OpenSeadragon.Tile#
     */ this.loading = false;
        /**
     * The HTML div element for this tile
     * @member {Element} element
     * @memberof OpenSeadragon.Tile#
     */ this.element = null;
        /**
     * The HTML img element for this tile.
     * @member {Element} imgElement
     * @memberof OpenSeadragon.Tile#
     */ this.imgElement = null;
        /**
     * The Image object for this tile.
     * @member {Object} image
     * @memberof OpenSeadragon.Tile#
     */ this.image = null;
        /**
     * The alias of this.element.style.
     * @member {String} style
     * @memberof OpenSeadragon.Tile#
     */ this.style = null;
        /**
     * This tile's position on screen, in pixels.
     * @member {OpenSeadragon.Point} position
     * @memberof OpenSeadragon.Tile#
     */ this.position = null;
        /**
     * This tile's size on screen, in pixels.
     * @member {OpenSeadragon.Point} size
     * @memberof OpenSeadragon.Tile#
     */ this.size = null;
        /**
     * The start time of this tile's blending.
     * @member {Number} blendStart
     * @memberof OpenSeadragon.Tile#
     */ this.blendStart = null;
        /**
     * The current opacity this tile should be.
     * @member {Number} opacity
     * @memberof OpenSeadragon.Tile#
     */ this.opacity = null;
        /**
     * The squared distance of this tile to the viewport center.
     * Use for comparing tiles.
     * @private
     * @member {Number} squaredDistance
     * @memberof OpenSeadragon.Tile#
     */ this.squaredDistance = null;
        /**
     * The visibility score of this tile.
     * @member {Number} visibility
     * @memberof OpenSeadragon.Tile#
     */ this.visibility = null;
        /**
     * Whether this tile is currently being drawn.
     * @member {Boolean} beingDrawn
     * @memberof OpenSeadragon.Tile#
     */ this.beingDrawn = false;
        /**
     * Timestamp the tile was last touched.
     * @member {Number} lastTouchTime
     * @memberof OpenSeadragon.Tile#
     */ this.lastTouchTime = 0;
        /**
     * Whether this tile is in the right-most column for its level.
     * @member {Boolean} isRightMost
     * @memberof OpenSeadragon.Tile#
     */ this.isRightMost = false;
        /**
     * Whether this tile is in the bottom-most row for its level.
     * @member {Boolean} isBottomMost
     * @memberof OpenSeadragon.Tile#
     */ this.isBottomMost = false;
    };
    /** @lends OpenSeadragon.Tile.prototype */ $11.Tile.prototype = {
        /**
     * Provides a string representation of this tiles level and (x,y)
     * components.
     * @function
     * @returns {String}
     */ toString: function() {
            return this.level + "/" + this.x + "_" + this.y;
        },
        // private
        _hasTransparencyChannel: function() {
            return !!this.context2D || this.url.match(".png");
        },
        /**
     * Renders the tile in an html container.
     * @function
     * @param {Element} container
     */ drawHTML: function(container11) {
            if (!this.cacheImageRecord) {
                $11.console.warn("[Tile.drawHTML] attempting to draw tile %s when it's not cached", this.toString());
                return;
            }
            if (!this.loaded) {
                $11.console.warn("Attempting to draw tile %s when it's not yet loaded.", this.toString());
                return;
            }
            //EXPERIMENTAL - trying to figure out how to scale the container
            //               content during animation of the container size.
            if (!this.element) {
                this.element = $11.makeNeutralElement("div");
                this.imgElement = this.cacheImageRecord.getImage().cloneNode();
                this.imgElement.style.msInterpolationMode = "nearest-neighbor";
                this.imgElement.style.width = "100%";
                this.imgElement.style.height = "100%";
                this.style = this.element.style;
                this.style.position = "absolute";
            }
            if (this.element.parentNode != container11) container11.appendChild(this.element);
            if (this.imgElement.parentNode != this.element) this.element.appendChild(this.imgElement);
            this.style.top = this.position.y + "px";
            this.style.left = this.position.x + "px";
            this.style.height = this.size.y + "px";
            this.style.width = this.size.x + "px";
            $11.setElementOpacity(this.element, this.opacity);
        },
        /**
     * Renders the tile in a canvas-based context.
     * @function
     * @param {Canvas} context
     * @param {Function} drawingHandler - Method for firing the drawing event.
     * drawingHandler({context, tile, rendered})
     * where <code>rendered</code> is the context with the pre-drawn image.
     * @param {Number} [scale=1] - Apply a scale to position and size
     * @param {OpenSeadragon.Point} [translate] - A translation vector
     */ drawCanvas: function(context11, drawingHandler11, scale11, translate11) {
            var position11 = this.position.times($11.pixelDensityRatio), size11 = this.size.times($11.pixelDensityRatio), rendered11;
            if (!this.context2D && !this.cacheImageRecord) {
                $11.console.warn("[Tile.drawCanvas] attempting to draw tile %s when it's not cached", this.toString());
                return;
            }
            rendered11 = this.context2D || this.cacheImageRecord.getRenderedContext();
            if (!this.loaded || !rendered11) {
                $11.console.warn("Attempting to draw tile %s when it's not yet loaded.", this.toString());
                return;
            }
            context11.save();
            context11.globalAlpha = this.opacity;
            if (typeof scale11 === "number" && scale11 !== 1) {
                // draw tile at a different scale
                position11 = position11.times(scale11);
                size11 = size11.times(scale11);
            }
            if (translate11 instanceof $11.Point) // shift tile position slightly
            position11 = position11.plus(translate11);
            //if we are supposed to be rendering fully opaque rectangle,
            //ie its done fading or fading is turned off, and if we are drawing
            //an image with an alpha channel, then the only way
            //to avoid seeing the tile underneath is to clear the rectangle
            if (context11.globalAlpha === 1 && this._hasTransparencyChannel()) //clearing only the inside of the rectangle occupied
            //by the png prevents edge flikering
            context11.clearRect(position11.x, position11.y, size11.x, size11.y);
            // This gives the application a chance to make image manipulation
            // changes as we are rendering the image
            drawingHandler11({
                context: context11,
                tile: this,
                rendered: rendered11
            });
            var sourceWidth11, sourceHeight11;
            if (this.sourceBounds) {
                sourceWidth11 = Math.min(this.sourceBounds.width, rendered11.canvas.width);
                sourceHeight11 = Math.min(this.sourceBounds.height, rendered11.canvas.height);
            } else {
                sourceWidth11 = rendered11.canvas.width;
                sourceHeight11 = rendered11.canvas.height;
            }
            context11.drawImage(rendered11.canvas, 0, 0, sourceWidth11, sourceHeight11, position11.x, position11.y, size11.x, size11.y);
            context11.restore();
        },
        /**
     * Get the ratio between current and original size.
     * @function
     * @return {Float}
     */ getScaleForEdgeSmoothing: function() {
            var context11;
            if (this.cacheImageRecord) context11 = this.cacheImageRecord.getRenderedContext();
            else if (this.context2D) context11 = this.context2D;
            else {
                $11.console.warn("[Tile.drawCanvas] attempting to get tile scale %s when tile's not cached", this.toString());
                return 1;
            }
            return context11.canvas.width / (this.size.x * $11.pixelDensityRatio);
        },
        /**
     * Get a translation vector that when applied to the tile position produces integer coordinates.
     * Needed to avoid swimming and twitching.
     * @function
     * @param {Number} [scale=1] - Scale to be applied to position.
     * @return {OpenSeadragon.Point}
     */ getTranslationForEdgeSmoothing: function(scale11, canvasSize11, sketchCanvasSize11) {
            // The translation vector must have positive values, otherwise the image goes a bit off
            // the sketch canvas to the top and left and we must use negative coordinates to repaint it
            // to the main canvas. In that case, some browsers throw:
            // INDEX_SIZE_ERR: DOM Exception 1: Index or size was negative, or greater than the allowed value.
            var x11 = Math.max(1, Math.ceil((sketchCanvasSize11.x - canvasSize11.x) / 2));
            var y11 = Math.max(1, Math.ceil((sketchCanvasSize11.y - canvasSize11.y) / 2));
            return new $11.Point(x11, y11).minus(this.position.times($11.pixelDensityRatio).times(scale11 || 1).apply(function(x11) {
                return x11 % 1;
            }));
        },
        /**
     * Removes tile from its container.
     * @function
     */ unload: function() {
            if (this.imgElement && this.imgElement.parentNode) this.imgElement.parentNode.removeChild(this.imgElement);
            if (this.element && this.element.parentNode) this.element.parentNode.removeChild(this.element);
            this.element = null;
            this.imgElement = null;
            this.loaded = false;
            this.loading = false;
        }
    };
})(OpenSeadragon);
/*
 * OpenSeadragon - Overlay
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    /**
     * An enumeration of positions that an overlay may be assigned relative to
     * the viewport.
     * It is identical to OpenSeadragon.Placement but is kept for backward
     * compatibility.
     * @member OverlayPlacement
     * @memberof OpenSeadragon
     * @see OpenSeadragon.Placement
     * @static
     * @readonly
     * @type {Object}
     * @property {Number} CENTER
     * @property {Number} TOP_LEFT
     * @property {Number} TOP
     * @property {Number} TOP_RIGHT
     * @property {Number} RIGHT
     * @property {Number} BOTTOM_RIGHT
     * @property {Number} BOTTOM
     * @property {Number} BOTTOM_LEFT
     * @property {Number} LEFT
     */ $11.OverlayPlacement = $11.Placement;
    /**
     * An enumeration of possible ways to handle overlays rotation
     * @member OverlayRotationMode
     * @memberOf OpenSeadragon
     * @static
     * @readonly
     * @property {Number} NO_ROTATION The overlay ignore the viewport rotation.
     * @property {Number} EXACT The overlay use CSS 3 transforms to rotate with
     * the viewport. If the overlay contains text, it will get rotated as well.
     * @property {Number} BOUNDING_BOX The overlay adjusts for rotation by
     * taking the size of the bounding box of the rotated bounds.
     * Only valid for overlays with Rect location and scalable in both directions.
     */ $11.OverlayRotationMode = $11.freezeObject({
        NO_ROTATION: 1,
        EXACT: 2,
        BOUNDING_BOX: 3
    });
    /**
     * @class Overlay
     * @classdesc Provides a way to float an HTML element on top of the viewer element.
     *
     * @memberof OpenSeadragon
     * @param {Object} options
     * @param {Element} options.element
     * @param {OpenSeadragon.Point|OpenSeadragon.Rect} options.location - The
     * location of the overlay on the image. If a {@link OpenSeadragon.Point}
     * is specified, the overlay will be located at this location with respect
     * to the placement option. If a {@link OpenSeadragon.Rect} is specified,
     * the overlay will be placed at this location with the corresponding width
     * and height and placement TOP_LEFT.
     * @param {OpenSeadragon.Placement} [options.placement=OpenSeadragon.Placement.TOP_LEFT]
     * Defines what part of the overlay should be at the specified options.location
     * @param {OpenSeadragon.Overlay.OnDrawCallback} [options.onDraw]
     * @param {Boolean} [options.checkResize=true] Set to false to avoid to
     * check the size of the overlay everytime it is drawn in the directions
     * which are not scaled. It will improve performances but will cause a
     * misalignment if the overlay size changes.
     * @param {Number} [options.width] The width of the overlay in viewport
     * coordinates. If specified, the width of the overlay will be adjusted when
     * the zoom changes.
     * @param {Number} [options.height] The height of the overlay in viewport
     * coordinates. If specified, the height of the overlay will be adjusted when
     * the zoom changes.
     * @param {Boolean} [options.rotationMode=OpenSeadragon.OverlayRotationMode.EXACT]
     * How to handle the rotation of the viewport.
     */ $11.Overlay = function(element11, location11, placement11) {
        /**
         * onDraw callback signature used by {@link OpenSeadragon.Overlay}.
         *
         * @callback OnDrawCallback
         * @memberof OpenSeadragon.Overlay
         * @param {OpenSeadragon.Point} position
         * @param {OpenSeadragon.Point} size
         * @param {Element} element
         */ var options11;
        if ($11.isPlainObject(element11)) options11 = element11;
        else options11 = {
            element: element11,
            location: location11,
            placement: placement11
        };
        this.element = options11.element;
        this.style = options11.element.style;
        this._init(options11);
    };
    /** @lends OpenSeadragon.Overlay.prototype */ $11.Overlay.prototype = {
        // private
        _init: function(options11) {
            this.location = options11.location;
            this.placement = options11.placement === undefined ? $11.Placement.TOP_LEFT : options11.placement;
            this.onDraw = options11.onDraw;
            this.checkResize = options11.checkResize === undefined ? true : options11.checkResize;
            // When this.width is not null, the overlay get scaled horizontally
            this.width = options11.width === undefined ? null : options11.width;
            // When this.height is not null, the overlay get scaled vertically
            this.height = options11.height === undefined ? null : options11.height;
            this.rotationMode = options11.rotationMode || $11.OverlayRotationMode.EXACT;
            // Having a rect as location is a syntactic sugar
            if (this.location instanceof $11.Rect) {
                this.width = this.location.width;
                this.height = this.location.height;
                this.location = this.location.getTopLeft();
                this.placement = $11.Placement.TOP_LEFT;
            }
            // Deprecated properties kept for backward compatibility.
            this.scales = this.width !== null && this.height !== null;
            this.bounds = new $11.Rect(this.location.x, this.location.y, this.width, this.height);
            this.position = this.location;
        },
        /**
         * Internal function to adjust the position of an overlay
         * depending on it size and placement.
         * @function
         * @param {OpenSeadragon.Point} position
         * @param {OpenSeadragon.Point} size
         */ adjust: function(position11, size11) {
            var properties11 = $11.Placement.properties[this.placement];
            if (!properties11) return;
            if (properties11.isHorizontallyCentered) position11.x -= size11.x / 2;
            else if (properties11.isRight) position11.x -= size11.x;
            if (properties11.isVerticallyCentered) position11.y -= size11.y / 2;
            else if (properties11.isBottom) position11.y -= size11.y;
        },
        /**
         * @function
         */ destroy: function() {
            var element11 = this.element;
            var style11 = this.style;
            if (element11.parentNode) {
                element11.parentNode.removeChild(element11);
                //this should allow us to preserve overlays when required between
                //pages
                if (element11.prevElementParent) {
                    style11.display = "none";
                    //element.prevElementParent.insertBefore(
                    //    element,
                    //    element.prevNextSibling
                    //);
                    document.body.appendChild(element11);
                }
            }
            // clear the onDraw callback
            this.onDraw = null;
            style11.top = "";
            style11.left = "";
            style11.position = "";
            if (this.width !== null) style11.width = "";
            if (this.height !== null) style11.height = "";
            var transformOriginProp11 = $11.getCssPropertyWithVendorPrefix("transformOrigin");
            var transformProp11 = $11.getCssPropertyWithVendorPrefix("transform");
            if (transformOriginProp11 && transformProp11) {
                style11[transformOriginProp11] = "";
                style11[transformProp11] = "";
            }
        },
        /**
         * @function
         * @param {Element} container
         */ drawHTML: function(container11, viewport11) {
            var element11 = this.element;
            if (element11.parentNode !== container11) {
                //save the source parent for later if we need it
                element11.prevElementParent = element11.parentNode;
                element11.prevNextSibling = element11.nextSibling;
                container11.appendChild(element11);
                // have to set position before calculating size, fix #1116
                this.style.position = "absolute";
                // this.size is used by overlays which don't get scaled in at
                // least one direction when this.checkResize is set to false.
                this.size = $11.getElementSize(element11);
            }
            var positionAndSize11 = this._getOverlayPositionAndSize(viewport11);
            var position11 = positionAndSize11.position;
            var size11 = this.size = positionAndSize11.size;
            var rotate11 = positionAndSize11.rotate;
            // call the onDraw callback if it exists to allow one to overwrite
            // the drawing/positioning/sizing of the overlay
            if (this.onDraw) this.onDraw(position11, size11, this.element);
            else {
                var style11 = this.style;
                style11.left = position11.x + "px";
                style11.top = position11.y + "px";
                if (this.width !== null) style11.width = size11.x + "px";
                if (this.height !== null) style11.height = size11.y + "px";
                var transformOriginProp11 = $11.getCssPropertyWithVendorPrefix("transformOrigin");
                var transformProp11 = $11.getCssPropertyWithVendorPrefix("transform");
                if (transformOriginProp11 && transformProp11) {
                    if (rotate11) {
                        style11[transformOriginProp11] = this._getTransformOrigin();
                        style11[transformProp11] = "rotate(" + rotate11 + "deg)";
                    } else {
                        style11[transformOriginProp11] = "";
                        style11[transformProp11] = "";
                    }
                }
                if (style11.display !== "none") style11.display = "block";
            }
        },
        // private
        _getOverlayPositionAndSize: function(viewport11) {
            var position11 = viewport11.pixelFromPoint(this.location, true);
            var size11 = this._getSizeInPixels(viewport11);
            this.adjust(position11, size11);
            var rotate11 = 0;
            if (viewport11.degrees && this.rotationMode !== $11.OverlayRotationMode.NO_ROTATION) {
                // BOUNDING_BOX is only valid if both directions get scaled.
                // Get replaced by EXACT otherwise.
                if (this.rotationMode === $11.OverlayRotationMode.BOUNDING_BOX && this.width !== null && this.height !== null) {
                    var rect11 = new $11.Rect(position11.x, position11.y, size11.x, size11.y);
                    var boundingBox11 = this._getBoundingBox(rect11, viewport11.degrees);
                    position11 = boundingBox11.getTopLeft();
                    size11 = boundingBox11.getSize();
                } else rotate11 = viewport11.degrees;
            }
            return {
                position: position11,
                size: size11,
                rotate: rotate11
            };
        },
        // private
        _getSizeInPixels: function(viewport11) {
            var width11 = this.size.x;
            var height11 = this.size.y;
            if (this.width !== null || this.height !== null) {
                var scaledSize11 = viewport11.deltaPixelsFromPointsNoRotate(new $11.Point(this.width || 0, this.height || 0), true);
                if (this.width !== null) width11 = scaledSize11.x;
                if (this.height !== null) height11 = scaledSize11.y;
            }
            if (this.checkResize && (this.width === null || this.height === null)) {
                var eltSize11 = this.size = $11.getElementSize(this.element);
                if (this.width === null) width11 = eltSize11.x;
                if (this.height === null) height11 = eltSize11.y;
            }
            return new $11.Point(width11, height11);
        },
        // private
        _getBoundingBox: function(rect11, degrees11) {
            var refPoint11 = this._getPlacementPoint(rect11);
            return rect11.rotate(degrees11, refPoint11).getBoundingBox();
        },
        // private
        _getPlacementPoint: function(rect11) {
            var result11 = new $11.Point(rect11.x, rect11.y);
            var properties11 = $11.Placement.properties[this.placement];
            if (properties11) {
                if (properties11.isHorizontallyCentered) result11.x += rect11.width / 2;
                else if (properties11.isRight) result11.x += rect11.width;
                if (properties11.isVerticallyCentered) result11.y += rect11.height / 2;
                else if (properties11.isBottom) result11.y += rect11.height;
            }
            return result11;
        },
        // private
        _getTransformOrigin: function() {
            var result11 = "";
            var properties11 = $11.Placement.properties[this.placement];
            if (!properties11) return result11;
            if (properties11.isLeft) result11 = "left";
            else if (properties11.isRight) result11 = "right";
            if (properties11.isTop) result11 += " top";
            else if (properties11.isBottom) result11 += " bottom";
            return result11;
        },
        /**
         * Changes the overlay settings.
         * @function
         * @param {OpenSeadragon.Point|OpenSeadragon.Rect|Object} location
         * If an object is specified, the options are the same than the constructor
         * except for the element which can not be changed.
         * @param {OpenSeadragon.Placement} placement
         */ update: function(location11, placement11) {
            var options11 = $11.isPlainObject(location11) ? location11 : {
                location: location11,
                placement: placement11
            };
            this._init({
                location: options11.location || this.location,
                placement: options11.placement !== undefined ? options11.placement : this.placement,
                onDraw: options11.onDraw || this.onDraw,
                checkResize: options11.checkResize || this.checkResize,
                width: options11.width !== undefined ? options11.width : this.width,
                height: options11.height !== undefined ? options11.height : this.height,
                rotationMode: options11.rotationMode || this.rotationMode
            });
        },
        /**
         * Returns the current bounds of the overlay in viewport coordinates
         * @function
         * @param {OpenSeadragon.Viewport} viewport the viewport
         * @returns {OpenSeadragon.Rect} overlay bounds
         */ getBounds: function(viewport11) {
            $11.console.assert(viewport11, "A viewport must now be passed to Overlay.getBounds.");
            var width11 = this.width;
            var height11 = this.height;
            if (width11 === null || height11 === null) {
                var size11 = viewport11.deltaPointsFromPixelsNoRotate(this.size, true);
                if (width11 === null) width11 = size11.x;
                if (height11 === null) height11 = size11.y;
            }
            var location11 = this.location.clone();
            this.adjust(location11, new $11.Point(width11, height11));
            return this._adjustBoundsForRotation(viewport11, new $11.Rect(location11.x, location11.y, width11, height11));
        },
        // private
        _adjustBoundsForRotation: function(viewport11, bounds11) {
            if (!viewport11 || viewport11.degrees === 0 || this.rotationMode === $11.OverlayRotationMode.EXACT) return bounds11;
            if (this.rotationMode === $11.OverlayRotationMode.BOUNDING_BOX) {
                // If overlay not fully scalable, BOUNDING_BOX falls back to EXACT
                if (this.width === null || this.height === null) return bounds11;
                // It is easier to just compute the position and size and
                // convert to viewport coordinates.
                var positionAndSize11 = this._getOverlayPositionAndSize(viewport11);
                return viewport11.viewerElementToViewportRectangle(new $11.Rect(positionAndSize11.position.x, positionAndSize11.position.y, positionAndSize11.size.x, positionAndSize11.size.y));
            }
            // NO_ROTATION case
            return bounds11.rotate(-viewport11.degrees, this._getPlacementPoint(bounds11));
        }
    };
})(OpenSeadragon);
/*
 * OpenSeadragon - Drawer
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    /**
 * @class Drawer
 * @memberof OpenSeadragon
 * @classdesc Handles rendering of tiles for an {@link OpenSeadragon.Viewer}.
 * @param {Object} options - Options for this Drawer.
 * @param {OpenSeadragon.Viewer} options.viewer - The Viewer that owns this Drawer.
 * @param {OpenSeadragon.Viewport} options.viewport - Reference to Viewer viewport.
 * @param {Element} options.element - Parent element.
 * @param {Number} [options.debugGridColor] - See debugGridColor in {@link OpenSeadragon.Options} for details.
 */ $11.Drawer = function(options11) {
        $11.console.assert(options11.viewer, "[Drawer] options.viewer is required");
        //backward compatibility for positional args while prefering more
        //idiomatic javascript options object as the only argument
        var args11 = arguments;
        if (!$11.isPlainObject(options11)) options11 = {
            source: args11[0],
            viewport: args11[1],
            element: args11[2] // Parent element.
        };
        $11.console.assert(options11.viewport, "[Drawer] options.viewport is required");
        $11.console.assert(options11.element, "[Drawer] options.element is required");
        if (options11.source) $11.console.error("[Drawer] options.source is no longer accepted; use TiledImage instead");
        this.viewer = options11.viewer;
        this.viewport = options11.viewport;
        this.debugGridColor = typeof options11.debugGridColor === "string" ? [
            options11.debugGridColor
        ] : options11.debugGridColor || $11.DEFAULT_SETTINGS.debugGridColor;
        if (options11.opacity) $11.console.error("[Drawer] options.opacity is no longer accepted; set the opacity on the TiledImage instead");
        this.useCanvas = $11.supportsCanvas && (this.viewer ? this.viewer.useCanvas : true);
        /**
     * The parent element of this Drawer instance, passed in when the Drawer was created.
     * The parent of {@link OpenSeadragon.Drawer#canvas}.
     * @member {Element} container
     * @memberof OpenSeadragon.Drawer#
     */ this.container = $11.getElement(options11.element);
        /**
     * A &lt;canvas&gt; element if the browser supports them, otherwise a &lt;div&gt; element.
     * Child element of {@link OpenSeadragon.Drawer#container}.
     * @member {Element} canvas
     * @memberof OpenSeadragon.Drawer#
     */ this.canvas = $11.makeNeutralElement(this.useCanvas ? "canvas" : "div");
        /**
     * 2d drawing context for {@link OpenSeadragon.Drawer#canvas} if it's a &lt;canvas&gt; element, otherwise null.
     * @member {Object} context
     * @memberof OpenSeadragon.Drawer#
     */ this.context = this.useCanvas ? this.canvas.getContext("2d") : null;
        /**
     * Sketch canvas used to temporarily draw tiles which cannot be drawn directly
     * to the main canvas due to opacity. Lazily initialized.
     */ this.sketchCanvas = null;
        this.sketchContext = null;
        /**
     * @member {Element} element
     * @memberof OpenSeadragon.Drawer#
     * @deprecated Alias for {@link OpenSeadragon.Drawer#container}.
     */ this.element = this.container;
        // We force our container to ltr because our drawing math doesn't work in rtl.
        // This issue only affects our canvas renderer, but we do it always for consistency.
        // Note that this means overlays you want to be rtl need to be explicitly set to rtl.
        this.container.dir = "ltr";
        // check canvas available width and height, set canvas width and height such that the canvas backing store is set to the proper pixel density
        if (this.useCanvas) {
            var viewportSize11 = this._calculateCanvasSize();
            this.canvas.width = viewportSize11.x;
            this.canvas.height = viewportSize11.y;
        }
        this.canvas.style.width = "100%";
        this.canvas.style.height = "100%";
        this.canvas.style.position = "absolute";
        $11.setElementOpacity(this.canvas, this.opacity, true);
        // explicit left-align
        this.container.style.textAlign = "left";
        this.container.appendChild(this.canvas);
    };
    /** @lends OpenSeadragon.Drawer.prototype */ $11.Drawer.prototype = {
        // deprecated
        addOverlay: function(element11, location11, placement11, onDraw11) {
            $11.console.error("drawer.addOverlay is deprecated. Use viewer.addOverlay instead.");
            this.viewer.addOverlay(element11, location11, placement11, onDraw11);
            return this;
        },
        // deprecated
        updateOverlay: function(element11, location11, placement11) {
            $11.console.error("drawer.updateOverlay is deprecated. Use viewer.updateOverlay instead.");
            this.viewer.updateOverlay(element11, location11, placement11);
            return this;
        },
        // deprecated
        removeOverlay: function(element11) {
            $11.console.error("drawer.removeOverlay is deprecated. Use viewer.removeOverlay instead.");
            this.viewer.removeOverlay(element11);
            return this;
        },
        // deprecated
        clearOverlays: function() {
            $11.console.error("drawer.clearOverlays is deprecated. Use viewer.clearOverlays instead.");
            this.viewer.clearOverlays();
            return this;
        },
        /**
     * Set the opacity of the drawer.
     * @param {Number} opacity
     * @return {OpenSeadragon.Drawer} Chainable.
     */ setOpacity: function(opacity11) {
            $11.console.error("drawer.setOpacity is deprecated. Use tiledImage.setOpacity instead.");
            var world11 = this.viewer.world;
            for(var i11 = 0; i11 < world11.getItemCount(); i11++)world11.getItemAt(i11).setOpacity(opacity11);
            return this;
        },
        /**
     * Get the opacity of the drawer.
     * @returns {Number}
     */ getOpacity: function() {
            $11.console.error("drawer.getOpacity is deprecated. Use tiledImage.getOpacity instead.");
            var world11 = this.viewer.world;
            var maxOpacity11 = 0;
            for(var i11 = 0; i11 < world11.getItemCount(); i11++){
                var opacity11 = world11.getItemAt(i11).getOpacity();
                if (opacity11 > maxOpacity11) maxOpacity11 = opacity11;
            }
            return maxOpacity11;
        },
        // deprecated
        needsUpdate: function() {
            $11.console.error("[Drawer.needsUpdate] this function is deprecated. Use World.needsDraw instead.");
            return this.viewer.world.needsDraw();
        },
        // deprecated
        numTilesLoaded: function() {
            $11.console.error("[Drawer.numTilesLoaded] this function is deprecated. Use TileCache.numTilesLoaded instead.");
            return this.viewer.tileCache.numTilesLoaded();
        },
        // deprecated
        reset: function() {
            $11.console.error("[Drawer.reset] this function is deprecated. Use World.resetItems instead.");
            this.viewer.world.resetItems();
            return this;
        },
        // deprecated
        update: function() {
            $11.console.error("[Drawer.update] this function is deprecated. Use Drawer.clear and World.draw instead.");
            this.clear();
            this.viewer.world.draw();
            return this;
        },
        /**
     * @return {Boolean} True if rotation is supported.
     */ canRotate: function() {
            return this.useCanvas;
        },
        /**
     * Destroy the drawer (unload current loaded tiles)
     */ destroy: function() {
            //force unloading of current canvas (1x1 will be gc later, trick not necessarily needed)
            this.canvas.width = 1;
            this.canvas.height = 1;
            this.sketchCanvas = null;
            this.sketchContext = null;
        },
        /**
     * Clears the Drawer so it's ready to draw another frame.
     */ clear: function() {
            this.canvas.innerHTML = "";
            if (this.useCanvas) {
                var viewportSize11 = this._calculateCanvasSize();
                if (this.canvas.width != viewportSize11.x || this.canvas.height != viewportSize11.y) {
                    this.canvas.width = viewportSize11.x;
                    this.canvas.height = viewportSize11.y;
                    if (this.sketchCanvas !== null) {
                        var sketchCanvasSize11 = this._calculateSketchCanvasSize();
                        this.sketchCanvas.width = sketchCanvasSize11.x;
                        this.sketchCanvas.height = sketchCanvasSize11.y;
                    }
                }
                this._clear();
            }
        },
        _clear: function(useSketch11, bounds11) {
            if (!this.useCanvas) return;
            var context11 = this._getContext(useSketch11);
            if (bounds11) context11.clearRect(bounds11.x, bounds11.y, bounds11.width, bounds11.height);
            else {
                var canvas11 = context11.canvas;
                context11.clearRect(0, 0, canvas11.width, canvas11.height);
            }
        },
        /**
     * Scale from OpenSeadragon viewer rectangle to drawer rectangle
     * (ignoring rotation)
     * @param {OpenSeadragon.Rect} rectangle - The rectangle in viewport coordinate system.
     * @return {OpenSeadragon.Rect} Rectangle in drawer coordinate system.
     */ viewportToDrawerRectangle: function(rectangle11) {
            var topLeft11 = this.viewport.pixelFromPointNoRotate(rectangle11.getTopLeft(), true);
            var size11 = this.viewport.deltaPixelsFromPointsNoRotate(rectangle11.getSize(), true);
            return new $11.Rect(topLeft11.x * $11.pixelDensityRatio, topLeft11.y * $11.pixelDensityRatio, size11.x * $11.pixelDensityRatio, size11.y * $11.pixelDensityRatio);
        },
        /**
     * Draws the given tile.
     * @param {OpenSeadragon.Tile} tile - The tile to draw.
     * @param {Function} drawingHandler - Method for firing the drawing event if using canvas.
     * drawingHandler({context, tile, rendered})
     * @param {Boolean} useSketch - Whether to use the sketch canvas or not.
     * where <code>rendered</code> is the context with the pre-drawn image.
     * @param {Float} [scale=1] - Apply a scale to tile position and size. Defaults to 1.
     * @param {OpenSeadragon.Point} [translate] A translation vector to offset tile position
     */ drawTile: function(tile11, drawingHandler11, useSketch11, scale11, translate11) {
            $11.console.assert(tile11, "[Drawer.drawTile] tile is required");
            $11.console.assert(drawingHandler11, "[Drawer.drawTile] drawingHandler is required");
            if (this.useCanvas) {
                var context11 = this._getContext(useSketch11);
                scale11 = scale11 || 1;
                tile11.drawCanvas(context11, drawingHandler11, scale11, translate11);
            } else tile11.drawHTML(this.canvas);
        },
        _getContext: function(useSketch11) {
            var context11 = this.context;
            if (useSketch11) {
                if (this.sketchCanvas === null) {
                    this.sketchCanvas = document.createElement("canvas");
                    var sketchCanvasSize11 = this._calculateSketchCanvasSize();
                    this.sketchCanvas.width = sketchCanvasSize11.x;
                    this.sketchCanvas.height = sketchCanvasSize11.y;
                    this.sketchContext = this.sketchCanvas.getContext("2d");
                    // If the viewport is not currently rotated, the sketchCanvas
                    // will have the same size as the main canvas. However, if
                    // the viewport get rotated later on, we will need to resize it.
                    if (this.viewport.getRotation() === 0) {
                        var self11 = this;
                        this.viewer.addHandler("rotate", function resizeSketchCanvas11() {
                            if (self11.viewport.getRotation() === 0) return;
                            self11.viewer.removeHandler("rotate", resizeSketchCanvas11);
                            var sketchCanvasSize11 = self11._calculateSketchCanvasSize();
                            self11.sketchCanvas.width = sketchCanvasSize11.x;
                            self11.sketchCanvas.height = sketchCanvasSize11.y;
                        });
                    }
                }
                context11 = this.sketchContext;
            }
            return context11;
        },
        // private
        saveContext: function(useSketch11) {
            if (!this.useCanvas) return;
            this._getContext(useSketch11).save();
        },
        // private
        restoreContext: function(useSketch11) {
            if (!this.useCanvas) return;
            this._getContext(useSketch11).restore();
        },
        // private
        setClip: function(rect11, useSketch11) {
            if (!this.useCanvas) return;
            var context11 = this._getContext(useSketch11);
            context11.beginPath();
            context11.rect(rect11.x, rect11.y, rect11.width, rect11.height);
            context11.clip();
        },
        // private
        drawRectangle: function(rect11, fillStyle11, useSketch11) {
            if (!this.useCanvas) return;
            var context11 = this._getContext(useSketch11);
            context11.save();
            context11.fillStyle = fillStyle11;
            context11.fillRect(rect11.x, rect11.y, rect11.width, rect11.height);
            context11.restore();
        },
        /**
     * Blends the sketch canvas in the main canvas.
     * @param {Object} options The options
     * @param {Float} options.opacity The opacity of the blending.
     * @param {Float} [options.scale=1] The scale at which tiles were drawn on
     * the sketch. Default is 1.
     * Use scale to draw at a lower scale and then enlarge onto the main canvas.
     * @param {OpenSeadragon.Point} [options.translate] A translation vector
     * that was used to draw the tiles
     * @param {String} [options.compositeOperation] - How the image is
     * composited onto other images; see compositeOperation in
     * {@link OpenSeadragon.Options} for possible values.
     * @param {OpenSeadragon.Rect} [options.bounds] The part of the sketch
     * canvas to blend in the main canvas. If specified, options.scale and
     * options.translate get ignored.
     */ blendSketch: function(opacity11, scale11, translate11, compositeOperation11) {
            var options11 = opacity11;
            if (!$11.isPlainObject(options11)) options11 = {
                opacity: opacity11,
                scale: scale11,
                translate: translate11,
                compositeOperation: compositeOperation11
            };
            if (!this.useCanvas || !this.sketchCanvas) return;
            opacity11 = options11.opacity;
            compositeOperation11 = options11.compositeOperation;
            var bounds11 = options11.bounds;
            this.context.save();
            this.context.globalAlpha = opacity11;
            if (compositeOperation11) this.context.globalCompositeOperation = compositeOperation11;
            if (bounds11) {
                // Internet Explorer, Microsoft Edge, and Safari have problems
                // when you call context.drawImage with negative x or y
                // or x + width or y + height greater than the canvas width or height respectively.
                if (bounds11.x < 0) {
                    bounds11.width += bounds11.x;
                    bounds11.x = 0;
                }
                if (bounds11.x + bounds11.width > this.canvas.width) bounds11.width = this.canvas.width - bounds11.x;
                if (bounds11.y < 0) {
                    bounds11.height += bounds11.y;
                    bounds11.y = 0;
                }
                if (bounds11.y + bounds11.height > this.canvas.height) bounds11.height = this.canvas.height - bounds11.y;
                this.context.drawImage(this.sketchCanvas, bounds11.x, bounds11.y, bounds11.width, bounds11.height, bounds11.x, bounds11.y, bounds11.width, bounds11.height);
            } else {
                scale11 = options11.scale || 1;
                translate11 = options11.translate;
                var position11 = translate11 instanceof $11.Point ? translate11 : new $11.Point(0, 0);
                var widthExt11 = 0;
                var heightExt11 = 0;
                if (translate11) {
                    var widthDiff11 = this.sketchCanvas.width - this.canvas.width;
                    var heightDiff11 = this.sketchCanvas.height - this.canvas.height;
                    widthExt11 = Math.round(widthDiff11 / 2);
                    heightExt11 = Math.round(heightDiff11 / 2);
                }
                this.context.drawImage(this.sketchCanvas, position11.x - widthExt11 * scale11, position11.y - heightExt11 * scale11, (this.canvas.width + 2 * widthExt11) * scale11, (this.canvas.height + 2 * heightExt11) * scale11, -widthExt11, -heightExt11, this.canvas.width + 2 * widthExt11, this.canvas.height + 2 * heightExt11);
            }
            this.context.restore();
        },
        // private
        drawDebugInfo: function(tile11, count11, i11, tiledImage11) {
            if (!this.useCanvas) return;
            var colorIndex11 = this.viewer.world.getIndexOfItem(tiledImage11) % this.debugGridColor.length;
            var context11 = this.context;
            context11.save();
            context11.lineWidth = 2 * $11.pixelDensityRatio;
            context11.font = "small-caps bold " + 13 * $11.pixelDensityRatio + "px arial";
            context11.strokeStyle = this.debugGridColor[colorIndex11];
            context11.fillStyle = this.debugGridColor[colorIndex11];
            if (this.viewport.degrees !== 0) this._offsetForRotation({
                degrees: this.viewport.degrees
            });
            else if (this.viewer.viewport.flipped) this._flip();
            if (tiledImage11.getRotation(true) % 360 !== 0) this._offsetForRotation({
                degrees: tiledImage11.getRotation(true),
                point: tiledImage11.viewport.pixelFromPointNoRotate(tiledImage11._getRotationPoint(true), true)
            });
            context11.strokeRect(tile11.position.x * $11.pixelDensityRatio, tile11.position.y * $11.pixelDensityRatio, tile11.size.x * $11.pixelDensityRatio, tile11.size.y * $11.pixelDensityRatio);
            var tileCenterX11 = (tile11.position.x + tile11.size.x / 2) * $11.pixelDensityRatio;
            var tileCenterY11 = (tile11.position.y + tile11.size.y / 2) * $11.pixelDensityRatio;
            // Rotate the text the right way around.
            context11.translate(tileCenterX11, tileCenterY11);
            context11.rotate(Math.PI / 180 * -this.viewport.degrees);
            context11.translate(-tileCenterX11, -tileCenterY11);
            if (tile11.x === 0 && tile11.y === 0) {
                context11.fillText("Zoom: " + this.viewport.getZoom(), tile11.position.x * $11.pixelDensityRatio, (tile11.position.y - 30) * $11.pixelDensityRatio);
                context11.fillText("Pan: " + this.viewport.getBounds().toString(), tile11.position.x * $11.pixelDensityRatio, (tile11.position.y - 20) * $11.pixelDensityRatio);
            }
            context11.fillText("Level: " + tile11.level, (tile11.position.x + 10) * $11.pixelDensityRatio, (tile11.position.y + 20) * $11.pixelDensityRatio);
            context11.fillText("Column: " + tile11.x, (tile11.position.x + 10) * $11.pixelDensityRatio, (tile11.position.y + 30) * $11.pixelDensityRatio);
            context11.fillText("Row: " + tile11.y, (tile11.position.x + 10) * $11.pixelDensityRatio, (tile11.position.y + 40) * $11.pixelDensityRatio);
            context11.fillText("Order: " + i11 + " of " + count11, (tile11.position.x + 10) * $11.pixelDensityRatio, (tile11.position.y + 50) * $11.pixelDensityRatio);
            context11.fillText("Size: " + tile11.size.toString(), (tile11.position.x + 10) * $11.pixelDensityRatio, (tile11.position.y + 60) * $11.pixelDensityRatio);
            context11.fillText("Position: " + tile11.position.toString(), (tile11.position.x + 10) * $11.pixelDensityRatio, (tile11.position.y + 70) * $11.pixelDensityRatio);
            if (this.viewport.degrees !== 0) this._restoreRotationChanges();
            if (tiledImage11.getRotation(true) % 360 !== 0) this._restoreRotationChanges();
            context11.restore();
        },
        // private
        debugRect: function(rect11) {
            if (this.useCanvas) {
                var context11 = this.context;
                context11.save();
                context11.lineWidth = 2 * $11.pixelDensityRatio;
                context11.strokeStyle = this.debugGridColor[0];
                context11.fillStyle = this.debugGridColor[0];
                context11.strokeRect(rect11.x * $11.pixelDensityRatio, rect11.y * $11.pixelDensityRatio, rect11.width * $11.pixelDensityRatio, rect11.height * $11.pixelDensityRatio);
                context11.restore();
            }
        },
        /**
     * Get the canvas size
     * @param {Boolean} sketch If set to true return the size of the sketch canvas
     * @returns {OpenSeadragon.Point} The size of the canvas
     */ getCanvasSize: function(sketch11) {
            var canvas11 = this._getContext(sketch11).canvas;
            return new $11.Point(canvas11.width, canvas11.height);
        },
        getCanvasCenter: function() {
            return new $11.Point(this.canvas.width / 2, this.canvas.height / 2);
        },
        // private
        _offsetForRotation: function(options11) {
            var point31 = options11.point ? options11.point.times($11.pixelDensityRatio) : this.getCanvasCenter();
            var context11 = this._getContext(options11.useSketch);
            context11.save();
            context11.translate(point31.x, point31.y);
            if (this.viewer.viewport.flipped) {
                context11.rotate(Math.PI / 180 * -options11.degrees);
                context11.scale(-1, 1);
            } else context11.rotate(Math.PI / 180 * options11.degrees);
            context11.translate(-point31.x, -point31.y);
        },
        // private
        _flip: function(options11) {
            options11 = options11 || {};
            var point31 = options11.point ? options11.point.times($11.pixelDensityRatio) : this.getCanvasCenter();
            var context11 = this._getContext(options11.useSketch);
            context11.translate(point31.x, 0);
            context11.scale(-1, 1);
            context11.translate(-point31.x, 0);
        },
        // private
        _restoreRotationChanges: function(useSketch11) {
            var context11 = this._getContext(useSketch11);
            context11.restore();
        },
        // private
        _calculateCanvasSize: function() {
            var pixelDensityRatio11 = $11.pixelDensityRatio;
            var viewportSize11 = this.viewport.getContainerSize();
            return {
                x: viewportSize11.x * pixelDensityRatio11,
                y: viewportSize11.y * pixelDensityRatio11
            };
        },
        // private
        _calculateSketchCanvasSize: function() {
            var canvasSize11 = this._calculateCanvasSize();
            if (this.viewport.getRotation() === 0) return canvasSize11;
            // If the viewport is rotated, we need a larger sketch canvas in order
            // to support edge smoothing.
            var sketchCanvasSize11 = Math.ceil(Math.sqrt(canvasSize11.x * canvasSize11.x + canvasSize11.y * canvasSize11.y));
            return {
                x: sketchCanvasSize11,
                y: sketchCanvasSize11
            };
        }
    };
})(OpenSeadragon);
/*
 * OpenSeadragon - Viewport
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    /**
 * @class Viewport
 * @memberof OpenSeadragon
 * @classdesc Handles coordinate-related functionality (zoom, pan, rotation, etc.)
 * for an {@link OpenSeadragon.Viewer}.
 * @param {Object} options - Options for this Viewport.
 * @param {Object} [options.margins] - See viewportMargins in {@link OpenSeadragon.Options}.
 * @param {Number} [options.springStiffness] - See springStiffness in {@link OpenSeadragon.Options}.
 * @param {Number} [options.animationTime] - See animationTime in {@link OpenSeadragon.Options}.
 * @param {Number} [options.minZoomImageRatio] - See minZoomImageRatio in {@link OpenSeadragon.Options}.
 * @param {Number} [options.maxZoomPixelRatio] - See maxZoomPixelRatio in {@link OpenSeadragon.Options}.
 * @param {Number} [options.visibilityRatio] - See visibilityRatio in {@link OpenSeadragon.Options}.
 * @param {Boolean} [options.wrapHorizontal] - See wrapHorizontal in {@link OpenSeadragon.Options}.
 * @param {Boolean} [options.wrapVertical] - See wrapVertical in {@link OpenSeadragon.Options}.
 * @param {Number} [options.defaultZoomLevel] - See defaultZoomLevel in {@link OpenSeadragon.Options}.
 * @param {Number} [options.minZoomLevel] - See minZoomLevel in {@link OpenSeadragon.Options}.
 * @param {Number} [options.maxZoomLevel] - See maxZoomLevel in {@link OpenSeadragon.Options}.
 * @param {Number} [options.degrees] - See degrees in {@link OpenSeadragon.Options}.
 * @param {Boolean} [options.homeFillsViewer] - See homeFillsViewer in {@link OpenSeadragon.Options}.
 */ $11.Viewport = function(options11) {
        //backward compatibility for positional args while prefering more
        //idiomatic javascript options object as the only argument
        var args11 = arguments;
        if (args11.length && args11[0] instanceof $11.Point) options11 = {
            containerSize: args11[0],
            contentSize: args11[1],
            config: args11[2]
        };
        //options.config and the general config argument are deprecated
        //in favor of the more direct specification of optional settings
        //being passed directly on the options object
        if (options11.config) {
            $11.extend(true, options11, options11.config);
            delete options11.config;
        }
        this._margins = $11.extend({
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        }, options11.margins || {});
        delete options11.margins;
        $11.extend(true, this, {
            //required settings
            containerSize: null,
            contentSize: null,
            //internal state properties
            zoomPoint: null,
            viewer: null,
            //configurable options
            springStiffness: $11.DEFAULT_SETTINGS.springStiffness,
            animationTime: $11.DEFAULT_SETTINGS.animationTime,
            minZoomImageRatio: $11.DEFAULT_SETTINGS.minZoomImageRatio,
            maxZoomPixelRatio: $11.DEFAULT_SETTINGS.maxZoomPixelRatio,
            visibilityRatio: $11.DEFAULT_SETTINGS.visibilityRatio,
            wrapHorizontal: $11.DEFAULT_SETTINGS.wrapHorizontal,
            wrapVertical: $11.DEFAULT_SETTINGS.wrapVertical,
            defaultZoomLevel: $11.DEFAULT_SETTINGS.defaultZoomLevel,
            minZoomLevel: $11.DEFAULT_SETTINGS.minZoomLevel,
            maxZoomLevel: $11.DEFAULT_SETTINGS.maxZoomLevel,
            degrees: $11.DEFAULT_SETTINGS.degrees,
            flipped: $11.DEFAULT_SETTINGS.flipped,
            homeFillsViewer: $11.DEFAULT_SETTINGS.homeFillsViewer
        }, options11);
        this._updateContainerInnerSize();
        this.centerSpringX = new $11.Spring({
            initial: 0,
            springStiffness: this.springStiffness,
            animationTime: this.animationTime
        });
        this.centerSpringY = new $11.Spring({
            initial: 0,
            springStiffness: this.springStiffness,
            animationTime: this.animationTime
        });
        this.zoomSpring = new $11.Spring({
            exponential: true,
            initial: 1,
            springStiffness: this.springStiffness,
            animationTime: this.animationTime
        });
        this._oldCenterX = this.centerSpringX.current.value;
        this._oldCenterY = this.centerSpringY.current.value;
        this._oldZoom = this.zoomSpring.current.value;
        this._setContentBounds(new $11.Rect(0, 0, 1, 1), 1);
        this.goHome(true);
        this.update();
    };
    /** @lends OpenSeadragon.Viewport.prototype */ $11.Viewport.prototype = {
        /**
     * Updates the viewport's home bounds and constraints for the given content size.
     * @function
     * @param {OpenSeadragon.Point} contentSize - size of the content in content units
     * @return {OpenSeadragon.Viewport} Chainable.
     * @fires OpenSeadragon.Viewer.event:reset-size
     */ resetContentSize: function(contentSize11) {
            $11.console.assert(contentSize11, "[Viewport.resetContentSize] contentSize is required");
            $11.console.assert(contentSize11 instanceof $11.Point, "[Viewport.resetContentSize] contentSize must be an OpenSeadragon.Point");
            $11.console.assert(contentSize11.x > 0, "[Viewport.resetContentSize] contentSize.x must be greater than 0");
            $11.console.assert(contentSize11.y > 0, "[Viewport.resetContentSize] contentSize.y must be greater than 0");
            this._setContentBounds(new $11.Rect(0, 0, 1, contentSize11.y / contentSize11.x), contentSize11.x);
            return this;
        },
        // deprecated
        setHomeBounds: function(bounds11, contentFactor11) {
            $11.console.error("[Viewport.setHomeBounds] this function is deprecated; The content bounds should not be set manually.");
            this._setContentBounds(bounds11, contentFactor11);
        },
        // Set the viewport's content bounds
        // @param {OpenSeadragon.Rect} bounds - the new bounds in viewport coordinates
        // without rotation
        // @param {Number} contentFactor - how many content units per viewport unit
        // @fires OpenSeadragon.Viewer.event:reset-size
        // @private
        _setContentBounds: function(bounds11, contentFactor11) {
            $11.console.assert(bounds11, "[Viewport._setContentBounds] bounds is required");
            $11.console.assert(bounds11 instanceof $11.Rect, "[Viewport._setContentBounds] bounds must be an OpenSeadragon.Rect");
            $11.console.assert(bounds11.width > 0, "[Viewport._setContentBounds] bounds.width must be greater than 0");
            $11.console.assert(bounds11.height > 0, "[Viewport._setContentBounds] bounds.height must be greater than 0");
            this._contentBoundsNoRotate = bounds11.clone();
            this._contentSizeNoRotate = this._contentBoundsNoRotate.getSize().times(contentFactor11);
            this._contentBounds = bounds11.rotate(this.degrees).getBoundingBox();
            this._contentSize = this._contentBounds.getSize().times(contentFactor11);
            this._contentAspectRatio = this._contentSize.x / this._contentSize.y;
            if (this.viewer) /**
             * Raised when the viewer's content size or home bounds are reset
             * (see {@link OpenSeadragon.Viewport#resetContentSize}).
             *
             * @event reset-size
             * @memberof OpenSeadragon.Viewer
             * @type {object}
             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
             * @property {OpenSeadragon.Point} contentSize
             * @property {OpenSeadragon.Rect} contentBounds - Content bounds.
             * @property {OpenSeadragon.Rect} homeBounds - Content bounds.
             * Deprecated use contentBounds instead.
             * @property {Number} contentFactor
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */ this.viewer.raiseEvent("reset-size", {
                contentSize: this._contentSizeNoRotate.clone(),
                contentFactor: contentFactor11,
                homeBounds: this._contentBoundsNoRotate.clone(),
                contentBounds: this._contentBounds.clone()
            });
        },
        /**
     * Returns the home zoom in "viewport zoom" value.
     * @function
     * @returns {Number} The home zoom in "viewport zoom".
     */ getHomeZoom: function() {
            if (this.defaultZoomLevel) return this.defaultZoomLevel;
            var aspectFactor11 = this._contentAspectRatio / this.getAspectRatio();
            var output11;
            if (this.homeFillsViewer) output11 = aspectFactor11 >= 1 ? aspectFactor11 : 1;
            else output11 = aspectFactor11 >= 1 ? 1 : aspectFactor11;
            return output11 / this._contentBounds.width;
        },
        /**
     * Returns the home bounds in viewport coordinates.
     * @function
     * @returns {OpenSeadragon.Rect} The home bounds in vewport coordinates.
     */ getHomeBounds: function() {
            return this.getHomeBoundsNoRotate().rotate(-this.getRotation());
        },
        /**
     * Returns the home bounds in viewport coordinates.
     * This method ignores the viewport rotation. Use
     * {@link OpenSeadragon.Viewport#getHomeBounds} to take it into account.
     * @function
     * @returns {OpenSeadragon.Rect} The home bounds in vewport coordinates.
     */ getHomeBoundsNoRotate: function() {
            var center11 = this._contentBounds.getCenter();
            var width11 = 1.0 / this.getHomeZoom();
            var height11 = width11 / this.getAspectRatio();
            return new $11.Rect(center11.x - width11 / 2.0, center11.y - height11 / 2.0, width11, height11);
        },
        /**
     * @function
     * @param {Boolean} immediately
     * @fires OpenSeadragon.Viewer.event:home
     */ goHome: function(immediately11) {
            if (this.viewer) /**
             * Raised when the "home" operation occurs (see {@link OpenSeadragon.Viewport#goHome}).
             *
             * @event home
             * @memberof OpenSeadragon.Viewer
             * @type {object}
             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
             * @property {Boolean} immediately
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */ this.viewer.raiseEvent("home", {
                immediately: immediately11
            });
            return this.fitBounds(this.getHomeBounds(), immediately11);
        },
        /**
     * @function
     */ getMinZoom: function() {
            var homeZoom11 = this.getHomeZoom(), zoom11 = this.minZoomLevel ? this.minZoomLevel : this.minZoomImageRatio * homeZoom11;
            return zoom11;
        },
        /**
     * @function
     */ getMaxZoom: function() {
            var zoom11 = this.maxZoomLevel;
            if (!zoom11) {
                zoom11 = this._contentSize.x * this.maxZoomPixelRatio / this._containerInnerSize.x;
                zoom11 /= this._contentBounds.width;
            }
            return Math.max(zoom11, this.getHomeZoom());
        },
        /**
     * @function
     */ getAspectRatio: function() {
            return this._containerInnerSize.x / this._containerInnerSize.y;
        },
        /**
     * @function
     * @returns {OpenSeadragon.Point} The size of the container, in screen coordinates.
     */ getContainerSize: function() {
            return new $11.Point(this.containerSize.x, this.containerSize.y);
        },
        /**
     * The margins push the "home" region in from the sides by the specified amounts.
     * @function
     * @returns {Object} Properties (Numbers, in screen coordinates): left, top, right, bottom.
     */ getMargins: function() {
            return $11.extend({}, this._margins); // Make a copy so we are not returning our original
        },
        /**
     * The margins push the "home" region in from the sides by the specified amounts.
     * @function
     * @param {Object} margins - Properties (Numbers, in screen coordinates): left, top, right, bottom.
     */ setMargins: function(margins11) {
            $11.console.assert($11.type(margins11) === "object", "[Viewport.setMargins] margins must be an object");
            this._margins = $11.extend({
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            }, margins11);
            this._updateContainerInnerSize();
            if (this.viewer) this.viewer.forceRedraw();
        },
        /**
     * Returns the bounds of the visible area in viewport coordinates.
     * @function
     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
     * @returns {OpenSeadragon.Rect} The location you are zoomed/panned to, in viewport coordinates.
     */ getBounds: function(current11) {
            return this.getBoundsNoRotate(current11).rotate(-this.getRotation());
        },
        /**
     * Returns the bounds of the visible area in viewport coordinates.
     * This method ignores the viewport rotation. Use
     * {@link OpenSeadragon.Viewport#getBounds} to take it into account.
     * @function
     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
     * @returns {OpenSeadragon.Rect} The location you are zoomed/panned to, in viewport coordinates.
     */ getBoundsNoRotate: function(current11) {
            var center11 = this.getCenter(current11);
            var width11 = 1.0 / this.getZoom(current11);
            var height11 = width11 / this.getAspectRatio();
            return new $11.Rect(center11.x - width11 / 2.0, center11.y - height11 / 2.0, width11, height11);
        },
        /**
     * @function
     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
     * @returns {OpenSeadragon.Rect} The location you are zoomed/panned to,
     * including the space taken by margins, in viewport coordinates.
     */ getBoundsWithMargins: function(current11) {
            return this.getBoundsNoRotateWithMargins(current11).rotate(-this.getRotation(), this.getCenter(current11));
        },
        /**
     * @function
     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
     * @returns {OpenSeadragon.Rect} The location you are zoomed/panned to,
     * including the space taken by margins, in viewport coordinates.
     */ getBoundsNoRotateWithMargins: function(current11) {
            var bounds11 = this.getBoundsNoRotate(current11);
            var factor11 = this._containerInnerSize.x * this.getZoom(current11);
            bounds11.x -= this._margins.left / factor11;
            bounds11.y -= this._margins.top / factor11;
            bounds11.width += (this._margins.left + this._margins.right) / factor11;
            bounds11.height += (this._margins.top + this._margins.bottom) / factor11;
            return bounds11;
        },
        /**
     * @function
     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
     */ getCenter: function(current11) {
            var centerCurrent11 = new $11.Point(this.centerSpringX.current.value, this.centerSpringY.current.value), centerTarget11 = new $11.Point(this.centerSpringX.target.value, this.centerSpringY.target.value), oldZoomPixel11, zoom11, width11, height11, bounds11, newZoomPixel11, deltaZoomPixels11, deltaZoomPoints11;
            if (current11) return centerCurrent11;
            else if (!this.zoomPoint) return centerTarget11;
            oldZoomPixel11 = this.pixelFromPoint(this.zoomPoint, true);
            zoom11 = this.getZoom();
            width11 = 1.0 / zoom11;
            height11 = width11 / this.getAspectRatio();
            bounds11 = new $11.Rect(centerCurrent11.x - width11 / 2.0, centerCurrent11.y - height11 / 2.0, width11, height11);
            newZoomPixel11 = this._pixelFromPoint(this.zoomPoint, bounds11);
            deltaZoomPixels11 = newZoomPixel11.minus(oldZoomPixel11);
            deltaZoomPoints11 = deltaZoomPixels11.divide(this._containerInnerSize.x * zoom11);
            return centerTarget11.plus(deltaZoomPoints11);
        },
        /**
     * @function
     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
     */ getZoom: function(current11) {
            if (current11) return this.zoomSpring.current.value;
            else return this.zoomSpring.target.value;
        },
        // private
        _applyZoomConstraints: function(zoom11) {
            return Math.max(Math.min(zoom11, this.getMaxZoom()), this.getMinZoom());
        },
        /**
     * @function
     * @private
     * @param {OpenSeadragon.Rect} bounds
     * @return {OpenSeadragon.Rect} constrained bounds.
     */ _applyBoundaryConstraints: function(bounds11) {
            var newBounds11 = new $11.Rect(bounds11.x, bounds11.y, bounds11.width, bounds11.height);
            if (this.wrapHorizontal) ;
            else {
                var horizontalThreshold11 = this.visibilityRatio * newBounds11.width;
                var boundsRight11 = newBounds11.x + newBounds11.width;
                var contentRight11 = this._contentBoundsNoRotate.x + this._contentBoundsNoRotate.width;
                var leftDx11 = this._contentBoundsNoRotate.x - boundsRight11 + horizontalThreshold11;
                var rightDx11 = contentRight11 - newBounds11.x - horizontalThreshold11;
                if (horizontalThreshold11 > this._contentBoundsNoRotate.width) newBounds11.x += (leftDx11 + rightDx11) / 2;
                else if (rightDx11 < 0) newBounds11.x += rightDx11;
                else if (leftDx11 > 0) newBounds11.x += leftDx11;
            }
            if (this.wrapVertical) ;
            else {
                var verticalThreshold11 = this.visibilityRatio * newBounds11.height;
                var boundsBottom11 = newBounds11.y + newBounds11.height;
                var contentBottom11 = this._contentBoundsNoRotate.y + this._contentBoundsNoRotate.height;
                var topDy11 = this._contentBoundsNoRotate.y - boundsBottom11 + verticalThreshold11;
                var bottomDy11 = contentBottom11 - newBounds11.y - verticalThreshold11;
                if (verticalThreshold11 > this._contentBoundsNoRotate.height) newBounds11.y += (topDy11 + bottomDy11) / 2;
                else if (bottomDy11 < 0) newBounds11.y += bottomDy11;
                else if (topDy11 > 0) newBounds11.y += topDy11;
            }
            return newBounds11;
        },
        /**
     * @function
     * @private
     * @param {Boolean} [immediately=false] - whether the function that triggered this event was
     * called with the "immediately" flag
     */ _raiseConstraintsEvent: function(immediately11) {
            if (this.viewer) /**
             * Raised when the viewport constraints are applied (see {@link OpenSeadragon.Viewport#applyConstraints}).
             *
             * @event constrain
             * @memberof OpenSeadragon.Viewer
             * @type {object}
             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
             * @property {Boolean} immediately - whether the function that triggered this event was
             * called with the "immediately" flag
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */ this.viewer.raiseEvent("constrain", {
                immediately: immediately11
            });
        },
        /**
     * Enforces the minZoom, maxZoom and visibilityRatio constraints by
     * zooming and panning to the closest acceptable zoom and location.
     * @function
     * @param {Boolean} [immediately=false]
     * @return {OpenSeadragon.Viewport} Chainable.
     * @fires OpenSeadragon.Viewer.event:constrain
     */ applyConstraints: function(immediately11) {
            var actualZoom11 = this.getZoom();
            var constrainedZoom11 = this._applyZoomConstraints(actualZoom11);
            if (actualZoom11 !== constrainedZoom11) this.zoomTo(constrainedZoom11, this.zoomPoint, immediately11);
            var bounds11 = this.getBoundsNoRotate();
            var constrainedBounds11 = this._applyBoundaryConstraints(bounds11);
            this._raiseConstraintsEvent(immediately11);
            if (bounds11.x !== constrainedBounds11.x || bounds11.y !== constrainedBounds11.y || immediately11) this.fitBounds(constrainedBounds11.rotate(-this.getRotation()), immediately11);
            return this;
        },
        /**
     * Equivalent to {@link OpenSeadragon.Viewport#applyConstraints}
     * @function
     * @param {Boolean} [immediately=false]
     * @return {OpenSeadragon.Viewport} Chainable.
     * @fires OpenSeadragon.Viewer.event:constrain
     */ ensureVisible: function(immediately11) {
            return this.applyConstraints(immediately11);
        },
        /**
     * @function
     * @private
     * @param {OpenSeadragon.Rect} bounds
     * @param {Object} options (immediately=false, constraints=false)
     * @return {OpenSeadragon.Viewport} Chainable.
     */ _fitBounds: function(bounds11, options11) {
            options11 = options11 || {};
            var immediately11 = options11.immediately || false;
            var constraints11 = options11.constraints || false;
            var aspect11 = this.getAspectRatio();
            var center11 = bounds11.getCenter();
            // Compute width and height of bounding box.
            var newBounds11 = new $11.Rect(bounds11.x, bounds11.y, bounds11.width, bounds11.height, bounds11.degrees + this.getRotation()).getBoundingBox();
            if (newBounds11.getAspectRatio() >= aspect11) newBounds11.height = newBounds11.width / aspect11;
            else newBounds11.width = newBounds11.height * aspect11;
            // Compute x and y from width, height and center position
            newBounds11.x = center11.x - newBounds11.width / 2;
            newBounds11.y = center11.y - newBounds11.height / 2;
            var newZoom11 = 1.0 / newBounds11.width;
            if (constraints11) {
                var newBoundsAspectRatio11 = newBounds11.getAspectRatio();
                var newConstrainedZoom11 = this._applyZoomConstraints(newZoom11);
                if (newZoom11 !== newConstrainedZoom11) {
                    newZoom11 = newConstrainedZoom11;
                    newBounds11.width = 1.0 / newZoom11;
                    newBounds11.x = center11.x - newBounds11.width / 2;
                    newBounds11.height = newBounds11.width / newBoundsAspectRatio11;
                    newBounds11.y = center11.y - newBounds11.height / 2;
                }
                newBounds11 = this._applyBoundaryConstraints(newBounds11);
                center11 = newBounds11.getCenter();
                this._raiseConstraintsEvent(immediately11);
            }
            if (immediately11) {
                this.panTo(center11, true);
                return this.zoomTo(newZoom11, null, true);
            }
            this.panTo(this.getCenter(true), true);
            this.zoomTo(this.getZoom(true), null, true);
            var oldBounds11 = this.getBounds();
            var oldZoom11 = this.getZoom();
            if (oldZoom11 === 0 || Math.abs(newZoom11 / oldZoom11 - 1) < 0.00000001) {
                this.zoomTo(newZoom11, true);
                return this.panTo(center11, immediately11);
            }
            newBounds11 = newBounds11.rotate(-this.getRotation());
            var referencePoint11 = newBounds11.getTopLeft().times(newZoom11).minus(oldBounds11.getTopLeft().times(oldZoom11)).divide(newZoom11 - oldZoom11);
            return this.zoomTo(newZoom11, referencePoint11, immediately11);
        },
        /**
     * Makes the viewport zoom and pan so that the specified bounds take
     * as much space as possible in the viewport.
     * Note: this method ignores the constraints (minZoom, maxZoom and
     * visibilityRatio).
     * Use {@link OpenSeadragon.Viewport#fitBoundsWithConstraints} to enforce
     * them.
     * @function
     * @param {OpenSeadragon.Rect} bounds
     * @param {Boolean} [immediately=false]
     * @return {OpenSeadragon.Viewport} Chainable.
     */ fitBounds: function(bounds11, immediately11) {
            return this._fitBounds(bounds11, {
                immediately: immediately11,
                constraints: false
            });
        },
        /**
     * Makes the viewport zoom and pan so that the specified bounds take
     * as much space as possible in the viewport while enforcing the constraints
     * (minZoom, maxZoom and visibilityRatio).
     * Note: because this method enforces the constraints, part of the
     * provided bounds may end up outside of the viewport.
     * Use {@link OpenSeadragon.Viewport#fitBounds} to ignore them.
     * @function
     * @param {OpenSeadragon.Rect} bounds
     * @param {Boolean} [immediately=false]
     * @return {OpenSeadragon.Viewport} Chainable.
     */ fitBoundsWithConstraints: function(bounds11, immediately11) {
            return this._fitBounds(bounds11, {
                immediately: immediately11,
                constraints: true
            });
        },
        /**
     * Zooms so the image just fills the viewer vertically.
     * @param {Boolean} immediately
     * @return {OpenSeadragon.Viewport} Chainable.
     */ fitVertically: function(immediately11) {
            var box11 = new $11.Rect(this._contentBounds.x + this._contentBounds.width / 2, this._contentBounds.y, 0, this._contentBounds.height);
            return this.fitBounds(box11, immediately11);
        },
        /**
     * Zooms so the image just fills the viewer horizontally.
     * @param {Boolean} immediately
     * @return {OpenSeadragon.Viewport} Chainable.
     */ fitHorizontally: function(immediately11) {
            var box11 = new $11.Rect(this._contentBounds.x, this._contentBounds.y + this._contentBounds.height / 2, this._contentBounds.width, 0);
            return this.fitBounds(box11, immediately11);
        },
        /**
     * Returns bounds taking constraints into account
     * Added to improve constrained panning
     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
     * @return {OpenSeadragon.Viewport} Chainable.
     */ getConstrainedBounds: function(current11) {
            var bounds11, constrainedBounds11;
            bounds11 = this.getBounds(current11);
            constrainedBounds11 = this._applyBoundaryConstraints(bounds11);
            return constrainedBounds11;
        },
        /**
     * @function
     * @param {OpenSeadragon.Point} delta
     * @param {Boolean} immediately
     * @return {OpenSeadragon.Viewport} Chainable.
     * @fires OpenSeadragon.Viewer.event:pan
     */ panBy: function(delta11, immediately11) {
            var center11 = new $11.Point(this.centerSpringX.target.value, this.centerSpringY.target.value);
            return this.panTo(center11.plus(delta11), immediately11);
        },
        /**
     * @function
     * @param {OpenSeadragon.Point} center
     * @param {Boolean} immediately
     * @return {OpenSeadragon.Viewport} Chainable.
     * @fires OpenSeadragon.Viewer.event:pan
     */ panTo: function(center11, immediately11) {
            if (immediately11) {
                this.centerSpringX.resetTo(center11.x);
                this.centerSpringY.resetTo(center11.y);
            } else {
                this.centerSpringX.springTo(center11.x);
                this.centerSpringY.springTo(center11.y);
            }
            if (this.viewer) /**
             * Raised when the viewport is panned (see {@link OpenSeadragon.Viewport#panBy} and {@link OpenSeadragon.Viewport#panTo}).
             *
             * @event pan
             * @memberof OpenSeadragon.Viewer
             * @type {object}
             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
             * @property {OpenSeadragon.Point} center
             * @property {Boolean} immediately
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */ this.viewer.raiseEvent("pan", {
                center: center11,
                immediately: immediately11
            });
            return this;
        },
        /**
     * @function
     * @return {OpenSeadragon.Viewport} Chainable.
     * @fires OpenSeadragon.Viewer.event:zoom
     */ zoomBy: function(factor11, refPoint11, immediately11) {
            return this.zoomTo(this.zoomSpring.target.value * factor11, refPoint11, immediately11);
        },
        /**
     * Zooms to the specified zoom level
     * @function
     * @param {Number} zoom The zoom level to zoom to.
     * @param {OpenSeadragon.Point} [refPoint] The point which will stay at
     * the same screen location. Defaults to the viewport center.
     * @param {Boolean} [immediately=false]
     * @return {OpenSeadragon.Viewport} Chainable.
     * @fires OpenSeadragon.Viewer.event:zoom
     */ zoomTo: function(zoom11, refPoint11, immediately11) {
            var _this11 = this;
            this.zoomPoint = refPoint11 instanceof $11.Point && !isNaN(refPoint11.x) && !isNaN(refPoint11.y) ? refPoint11 : null;
            if (immediately11) this._adjustCenterSpringsForZoomPoint(function() {
                _this11.zoomSpring.resetTo(zoom11);
            });
            else this.zoomSpring.springTo(zoom11);
            if (this.viewer) /**
             * Raised when the viewport zoom level changes (see {@link OpenSeadragon.Viewport#zoomBy} and {@link OpenSeadragon.Viewport#zoomTo}).
             *
             * @event zoom
             * @memberof OpenSeadragon.Viewer
             * @type {object}
             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
             * @property {Number} zoom
             * @property {OpenSeadragon.Point} refPoint
             * @property {Boolean} immediately
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */ this.viewer.raiseEvent("zoom", {
                zoom: zoom11,
                refPoint: refPoint11,
                immediately: immediately11
            });
            return this;
        },
        /**
     * Rotates this viewport to the angle specified.
     * @function
     * @return {OpenSeadragon.Viewport} Chainable.
     */ setRotation: function(degrees11) {
            if (!this.viewer || !this.viewer.drawer.canRotate()) return this;
            this.degrees = $11.positiveModulo(degrees11, 360);
            this._setContentBounds(this.viewer.world.getHomeBounds(), this.viewer.world.getContentFactor());
            this.viewer.forceRedraw();
            /**
         * Raised when rotation has been changed.
         *
         * @event rotate
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
         * @property {Number} degrees - The number of degrees the rotation was set to.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */ this.viewer.raiseEvent("rotate", {
                "degrees": degrees11
            });
            return this;
        },
        /**
     * Gets the current rotation in degrees.
     * @function
     * @return {Number} The current rotation in degrees.
     */ getRotation: function() {
            return this.degrees;
        },
        /**
     * @function
     * @return {OpenSeadragon.Viewport} Chainable.
     * @fires OpenSeadragon.Viewer.event:resize
     */ resize: function(newContainerSize11, maintain11) {
            var oldBounds11 = this.getBoundsNoRotate(), newBounds11 = oldBounds11, widthDeltaFactor11;
            this.containerSize.x = newContainerSize11.x;
            this.containerSize.y = newContainerSize11.y;
            this._updateContainerInnerSize();
            if (maintain11) {
                // TODO: widthDeltaFactor will always be 1; probably not what's intended
                widthDeltaFactor11 = newContainerSize11.x / this.containerSize.x;
                newBounds11.width = oldBounds11.width * widthDeltaFactor11;
                newBounds11.height = newBounds11.width / this.getAspectRatio();
            }
            if (this.viewer) /**
             * Raised when the viewer is resized (see {@link OpenSeadragon.Viewport#resize}).
             *
             * @event resize
             * @memberof OpenSeadragon.Viewer
             * @type {object}
             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
             * @property {OpenSeadragon.Point} newContainerSize
             * @property {Boolean} maintain
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */ this.viewer.raiseEvent("resize", {
                newContainerSize: newContainerSize11,
                maintain: maintain11
            });
            return this.fitBounds(newBounds11, true);
        },
        // private
        _updateContainerInnerSize: function() {
            this._containerInnerSize = new $11.Point(Math.max(1, this.containerSize.x - (this._margins.left + this._margins.right)), Math.max(1, this.containerSize.y - (this._margins.top + this._margins.bottom)));
        },
        /**
     * Update the zoom and center (X and Y) springs.
     * @function
     * @returns {Boolean} True if any change has been made, false otherwise.
     */ update: function() {
            var _this11 = this;
            this._adjustCenterSpringsForZoomPoint(function() {
                _this11.zoomSpring.update();
            });
            this.centerSpringX.update();
            this.centerSpringY.update();
            var changed11 = this.centerSpringX.current.value !== this._oldCenterX || this.centerSpringY.current.value !== this._oldCenterY || this.zoomSpring.current.value !== this._oldZoom;
            this._oldCenterX = this.centerSpringX.current.value;
            this._oldCenterY = this.centerSpringY.current.value;
            this._oldZoom = this.zoomSpring.current.value;
            return changed11;
        },
        _adjustCenterSpringsForZoomPoint: function(zoomSpringHandler11) {
            if (this.zoomPoint) {
                var oldZoomPixel11 = this.pixelFromPoint(this.zoomPoint, true);
                zoomSpringHandler11();
                var newZoomPixel11 = this.pixelFromPoint(this.zoomPoint, true);
                var deltaZoomPixels11 = newZoomPixel11.minus(oldZoomPixel11);
                var deltaZoomPoints11 = this.deltaPointsFromPixels(deltaZoomPixels11, true);
                this.centerSpringX.shiftBy(deltaZoomPoints11.x);
                this.centerSpringY.shiftBy(deltaZoomPoints11.y);
                if (this.zoomSpring.isAtTargetValue()) this.zoomPoint = null;
            } else zoomSpringHandler11();
        },
        /**
     * Convert a delta (translation vector) from viewport coordinates to pixels
     * coordinates. This method does not take rotation into account.
     * Consider using deltaPixelsFromPoints if you need to account for rotation.
     * @param {OpenSeadragon.Point} deltaPoints - The translation vector to convert.
     * @param {Boolean} [current=false] - Pass true for the current location;
     * defaults to false (target location).
     * @returns {OpenSeadragon.Point}
     */ deltaPixelsFromPointsNoRotate: function(deltaPoints11, current11) {
            return deltaPoints11.times(this._containerInnerSize.x * this.getZoom(current11));
        },
        /**
     * Convert a delta (translation vector) from viewport coordinates to pixels
     * coordinates.
     * @param {OpenSeadragon.Point} deltaPoints - The translation vector to convert.
     * @param {Boolean} [current=false] - Pass true for the current location;
     * defaults to false (target location).
     * @returns {OpenSeadragon.Point}
     */ deltaPixelsFromPoints: function(deltaPoints11, current11) {
            return this.deltaPixelsFromPointsNoRotate(deltaPoints11.rotate(this.getRotation()), current11);
        },
        /**
     * Convert a delta (translation vector) from pixels coordinates to viewport
     * coordinates. This method does not take rotation into account.
     * Consider using deltaPointsFromPixels if you need to account for rotation.
     * @param {OpenSeadragon.Point} deltaPixels - The translation vector to convert.
     * @param {Boolean} [current=false] - Pass true for the current location;
     * defaults to false (target location).
     * @returns {OpenSeadragon.Point}
     */ deltaPointsFromPixelsNoRotate: function(deltaPixels11, current11) {
            return deltaPixels11.divide(this._containerInnerSize.x * this.getZoom(current11));
        },
        /**
     * Convert a delta (translation vector) from pixels coordinates to viewport
     * coordinates.
     * @param {OpenSeadragon.Point} deltaPixels - The translation vector to convert.
     * @param {Boolean} [current=false] - Pass true for the current location;
     * defaults to false (target location).
     * @returns {OpenSeadragon.Point}
     */ deltaPointsFromPixels: function(deltaPixels11, current11) {
            return this.deltaPointsFromPixelsNoRotate(deltaPixels11, current11).rotate(-this.getRotation());
        },
        /**
     * Convert viewport coordinates to pixels coordinates.
     * This method does not take rotation into account.
     * Consider using pixelFromPoint if you need to account for rotation.
     * @param {OpenSeadragon.Point} point the viewport coordinates
     * @param {Boolean} [current=false] - Pass true for the current location;
     * defaults to false (target location).
     * @returns {OpenSeadragon.Point}
     */ pixelFromPointNoRotate: function(point31, current11) {
            return this._pixelFromPointNoRotate(point31, this.getBoundsNoRotate(current11));
        },
        /**
     * Convert viewport coordinates to pixel coordinates.
     * @param {OpenSeadragon.Point} point the viewport coordinates
     * @param {Boolean} [current=false] - Pass true for the current location;
     * defaults to false (target location).
     * @returns {OpenSeadragon.Point}
     */ pixelFromPoint: function(point31, current11) {
            return this._pixelFromPoint(point31, this.getBoundsNoRotate(current11));
        },
        // private
        _pixelFromPointNoRotate: function(point31, bounds11) {
            return point31.minus(bounds11.getTopLeft()).times(this._containerInnerSize.x / bounds11.width).plus(new $11.Point(this._margins.left, this._margins.top));
        },
        // private
        _pixelFromPoint: function(point31, bounds11) {
            return this._pixelFromPointNoRotate(point31.rotate(this.getRotation(), this.getCenter(true)), bounds11);
        },
        /**
     * Convert pixel coordinates to viewport coordinates.
     * This method does not take rotation into account.
     * Consider using pointFromPixel if you need to account for rotation.
     * @param {OpenSeadragon.Point} pixel Pixel coordinates
     * @param {Boolean} [current=false] - Pass true for the current location;
     * defaults to false (target location).
     * @returns {OpenSeadragon.Point}
     */ pointFromPixelNoRotate: function(pixel11, current11) {
            var bounds11 = this.getBoundsNoRotate(current11);
            return pixel11.minus(new $11.Point(this._margins.left, this._margins.top)).divide(this._containerInnerSize.x / bounds11.width).plus(bounds11.getTopLeft());
        },
        /**
     * Convert pixel coordinates to viewport coordinates.
     * @param {OpenSeadragon.Point} pixel Pixel coordinates
     * @param {Boolean} [current=false] - Pass true for the current location;
     * defaults to false (target location).
     * @returns {OpenSeadragon.Point}
     */ pointFromPixel: function(pixel11, current11) {
            return this.pointFromPixelNoRotate(pixel11, current11).rotate(-this.getRotation(), this.getCenter(true));
        },
        // private
        _viewportToImageDelta: function(viewerX11, viewerY11) {
            var scale11 = this._contentBoundsNoRotate.width;
            return new $11.Point(viewerX11 * this._contentSizeNoRotate.x / scale11, viewerY11 * this._contentSizeNoRotate.x / scale11);
        },
        /**
     * Translates from OpenSeadragon viewer coordinate system to image coordinate system.
     * This method can be called either by passing X,Y coordinates or an
     * OpenSeadragon.Point
     * Note: not accurate with multi-image; use TiledImage.viewportToImageCoordinates instead.
     * @function
     * @param {(OpenSeadragon.Point|Number)} viewerX either a point or the X
     * coordinate in viewport coordinate system.
     * @param {Number} [viewerY] Y coordinate in viewport coordinate system.
     * @return {OpenSeadragon.Point} a point representing the coordinates in the image.
     */ viewportToImageCoordinates: function(viewerX11, viewerY11) {
            if (viewerX11 instanceof $11.Point) //they passed a point instead of individual components
            return this.viewportToImageCoordinates(viewerX11.x, viewerX11.y);
            if (this.viewer) {
                var count11 = this.viewer.world.getItemCount();
                if (count11 > 1) $11.console.error("[Viewport.viewportToImageCoordinates] is not accurate with multi-image; use TiledImage.viewportToImageCoordinates instead.");
                else if (count11 === 1) {
                    // It is better to use TiledImage.viewportToImageCoordinates
                    // because this._contentBoundsNoRotate can not be relied on
                    // with clipping.
                    var item11 = this.viewer.world.getItemAt(0);
                    return item11.viewportToImageCoordinates(viewerX11, viewerY11, true);
                }
            }
            return this._viewportToImageDelta(viewerX11 - this._contentBoundsNoRotate.x, viewerY11 - this._contentBoundsNoRotate.y);
        },
        // private
        _imageToViewportDelta: function(imageX11, imageY11) {
            var scale11 = this._contentBoundsNoRotate.width;
            return new $11.Point(imageX11 / this._contentSizeNoRotate.x * scale11, imageY11 / this._contentSizeNoRotate.x * scale11);
        },
        /**
     * Translates from image coordinate system to OpenSeadragon viewer coordinate system
     * This method can be called either by passing X,Y coordinates or an
     * OpenSeadragon.Point
     * Note: not accurate with multi-image; use TiledImage.imageToViewportCoordinates instead.
     * @function
     * @param {(OpenSeadragon.Point | Number)} imageX the point or the
     * X coordinate in image coordinate system.
     * @param {Number} [imageY] Y coordinate in image coordinate system.
     * @return {OpenSeadragon.Point} a point representing the coordinates in the viewport.
     */ imageToViewportCoordinates: function(imageX11, imageY11) {
            if (imageX11 instanceof $11.Point) //they passed a point instead of individual components
            return this.imageToViewportCoordinates(imageX11.x, imageX11.y);
            if (this.viewer) {
                var count11 = this.viewer.world.getItemCount();
                if (count11 > 1) $11.console.error("[Viewport.imageToViewportCoordinates] is not accurate with multi-image; use TiledImage.imageToViewportCoordinates instead.");
                else if (count11 === 1) {
                    // It is better to use TiledImage.viewportToImageCoordinates
                    // because this._contentBoundsNoRotate can not be relied on
                    // with clipping.
                    var item11 = this.viewer.world.getItemAt(0);
                    return item11.imageToViewportCoordinates(imageX11, imageY11, true);
                }
            }
            var point31 = this._imageToViewportDelta(imageX11, imageY11);
            point31.x += this._contentBoundsNoRotate.x;
            point31.y += this._contentBoundsNoRotate.y;
            return point31;
        },
        /**
     * Translates from a rectangle which describes a portion of the image in
     * pixel coordinates to OpenSeadragon viewport rectangle coordinates.
     * This method can be called either by passing X,Y,width,height or an
     * OpenSeadragon.Rect
     * Note: not accurate with multi-image; use TiledImage.imageToViewportRectangle instead.
     * @function
     * @param {(OpenSeadragon.Rect | Number)} imageX the rectangle or the X
     * coordinate of the top left corner of the rectangle in image coordinate system.
     * @param {Number} [imageY] the Y coordinate of the top left corner of the rectangle
     * in image coordinate system.
     * @param {Number} [pixelWidth] the width in pixel of the rectangle.
     * @param {Number} [pixelHeight] the height in pixel of the rectangle.
     * @returns {OpenSeadragon.Rect} This image's bounds in viewport coordinates
     */ imageToViewportRectangle: function(imageX11, imageY11, pixelWidth11, pixelHeight11) {
            var rect11 = imageX11;
            if (!(rect11 instanceof $11.Rect)) //they passed individual components instead of a rectangle
            rect11 = new $11.Rect(imageX11, imageY11, pixelWidth11, pixelHeight11);
            if (this.viewer) {
                var count11 = this.viewer.world.getItemCount();
                if (count11 > 1) $11.console.error("[Viewport.imageToViewportRectangle] is not accurate with multi-image; use TiledImage.imageToViewportRectangle instead.");
                else if (count11 === 1) {
                    // It is better to use TiledImage.imageToViewportRectangle
                    // because this._contentBoundsNoRotate can not be relied on
                    // with clipping.
                    var item11 = this.viewer.world.getItemAt(0);
                    return item11.imageToViewportRectangle(imageX11, imageY11, pixelWidth11, pixelHeight11, true);
                }
            }
            var coordA11 = this.imageToViewportCoordinates(rect11.x, rect11.y);
            var coordB11 = this._imageToViewportDelta(rect11.width, rect11.height);
            return new $11.Rect(coordA11.x, coordA11.y, coordB11.x, coordB11.y, rect11.degrees);
        },
        /**
     * Translates from a rectangle which describes a portion of
     * the viewport in point coordinates to image rectangle coordinates.
     * This method can be called either by passing X,Y,width,height or an
     * OpenSeadragon.Rect
     * Note: not accurate with multi-image; use TiledImage.viewportToImageRectangle instead.
     * @function
     * @param {(OpenSeadragon.Rect | Number)} viewerX either a rectangle or
     * the X coordinate of the top left corner of the rectangle in viewport
     * coordinate system.
     * @param {Number} [viewerY] the Y coordinate of the top left corner of the rectangle
     * in viewport coordinate system.
     * @param {Number} [pointWidth] the width of the rectangle in viewport coordinate system.
     * @param {Number} [pointHeight] the height of the rectangle in viewport coordinate system.
     */ viewportToImageRectangle: function(viewerX11, viewerY11, pointWidth11, pointHeight11) {
            var rect11 = viewerX11;
            if (!(rect11 instanceof $11.Rect)) //they passed individual components instead of a rectangle
            rect11 = new $11.Rect(viewerX11, viewerY11, pointWidth11, pointHeight11);
            if (this.viewer) {
                var count11 = this.viewer.world.getItemCount();
                if (count11 > 1) $11.console.error("[Viewport.viewportToImageRectangle] is not accurate with multi-image; use TiledImage.viewportToImageRectangle instead.");
                else if (count11 === 1) {
                    // It is better to use TiledImage.viewportToImageCoordinates
                    // because this._contentBoundsNoRotate can not be relied on
                    // with clipping.
                    var item11 = this.viewer.world.getItemAt(0);
                    return item11.viewportToImageRectangle(viewerX11, viewerY11, pointWidth11, pointHeight11, true);
                }
            }
            var coordA11 = this.viewportToImageCoordinates(rect11.x, rect11.y);
            var coordB11 = this._viewportToImageDelta(rect11.width, rect11.height);
            return new $11.Rect(coordA11.x, coordA11.y, coordB11.x, coordB11.y, rect11.degrees);
        },
        /**
     * Convert pixel coordinates relative to the viewer element to image
     * coordinates.
     * Note: not accurate with multi-image.
     * @param {OpenSeadragon.Point} pixel
     * @returns {OpenSeadragon.Point}
     */ viewerElementToImageCoordinates: function(pixel11) {
            var point31 = this.pointFromPixel(pixel11, true);
            return this.viewportToImageCoordinates(point31);
        },
        /**
     * Convert pixel coordinates relative to the image to
     * viewer element coordinates.
     * Note: not accurate with multi-image.
     * @param {OpenSeadragon.Point} pixel
     * @returns {OpenSeadragon.Point}
     */ imageToViewerElementCoordinates: function(pixel11) {
            var point31 = this.imageToViewportCoordinates(pixel11);
            return this.pixelFromPoint(point31, true);
        },
        /**
     * Convert pixel coordinates relative to the window to image coordinates.
     * Note: not accurate with multi-image.
     * @param {OpenSeadragon.Point} pixel
     * @returns {OpenSeadragon.Point}
     */ windowToImageCoordinates: function(pixel11) {
            $11.console.assert(this.viewer, "[Viewport.windowToImageCoordinates] the viewport must have a viewer.");
            var viewerCoordinates11 = pixel11.minus($11.getElementPosition(this.viewer.element));
            return this.viewerElementToImageCoordinates(viewerCoordinates11);
        },
        /**
     * Convert image coordinates to pixel coordinates relative to the window.
     * Note: not accurate with multi-image.
     * @param {OpenSeadragon.Point} pixel
     * @returns {OpenSeadragon.Point}
     */ imageToWindowCoordinates: function(pixel11) {
            $11.console.assert(this.viewer, "[Viewport.imageToWindowCoordinates] the viewport must have a viewer.");
            var viewerCoordinates11 = this.imageToViewerElementCoordinates(pixel11);
            return viewerCoordinates11.plus($11.getElementPosition(this.viewer.element));
        },
        /**
     * Convert pixel coordinates relative to the viewer element to viewport
     * coordinates.
     * @param {OpenSeadragon.Point} pixel
     * @returns {OpenSeadragon.Point}
     */ viewerElementToViewportCoordinates: function(pixel11) {
            return this.pointFromPixel(pixel11, true);
        },
        /**
     * Convert viewport coordinates to pixel coordinates relative to the
     * viewer element.
     * @param {OpenSeadragon.Point} point
     * @returns {OpenSeadragon.Point}
     */ viewportToViewerElementCoordinates: function(point31) {
            return this.pixelFromPoint(point31, true);
        },
        /**
     * Convert a rectangle in pixel coordinates relative to the viewer element
     * to viewport coordinates.
     * @param {OpenSeadragon.Rect} rectangle the rectangle to convert
     * @returns {OpenSeadragon.Rect} the converted rectangle
     */ viewerElementToViewportRectangle: function(rectangle11) {
            return $11.Rect.fromSummits(this.pointFromPixel(rectangle11.getTopLeft(), true), this.pointFromPixel(rectangle11.getTopRight(), true), this.pointFromPixel(rectangle11.getBottomLeft(), true));
        },
        /**
     * Convert a rectangle in viewport coordinates to pixel coordinates relative
     * to the viewer element.
     * @param {OpenSeadragon.Rect} rectangle the rectangle to convert
     * @returns {OpenSeadragon.Rect} the converted rectangle
     */ viewportToViewerElementRectangle: function(rectangle11) {
            return $11.Rect.fromSummits(this.pixelFromPoint(rectangle11.getTopLeft(), true), this.pixelFromPoint(rectangle11.getTopRight(), true), this.pixelFromPoint(rectangle11.getBottomLeft(), true));
        },
        /**
     * Convert pixel coordinates relative to the window to viewport coordinates.
     * @param {OpenSeadragon.Point} pixel
     * @returns {OpenSeadragon.Point}
     */ windowToViewportCoordinates: function(pixel11) {
            $11.console.assert(this.viewer, "[Viewport.windowToViewportCoordinates] the viewport must have a viewer.");
            var viewerCoordinates11 = pixel11.minus($11.getElementPosition(this.viewer.element));
            return this.viewerElementToViewportCoordinates(viewerCoordinates11);
        },
        /**
     * Convert viewport coordinates to pixel coordinates relative to the window.
     * @param {OpenSeadragon.Point} point
     * @returns {OpenSeadragon.Point}
     */ viewportToWindowCoordinates: function(point31) {
            $11.console.assert(this.viewer, "[Viewport.viewportToWindowCoordinates] the viewport must have a viewer.");
            var viewerCoordinates11 = this.viewportToViewerElementCoordinates(point31);
            return viewerCoordinates11.plus($11.getElementPosition(this.viewer.element));
        },
        /**
     * Convert a viewport zoom to an image zoom.
     * Image zoom: ratio of the original image size to displayed image size.
     * 1 means original image size, 0.5 half size...
     * Viewport zoom: ratio of the displayed image's width to viewport's width.
     * 1 means identical width, 2 means image's width is twice the viewport's width...
     * Note: not accurate with multi-image.
     * @function
     * @param {Number} viewportZoom The viewport zoom
     * target zoom.
     * @returns {Number} imageZoom The image zoom
     */ viewportToImageZoom: function(viewportZoom11) {
            if (this.viewer) {
                var count11 = this.viewer.world.getItemCount();
                if (count11 > 1) $11.console.error("[Viewport.viewportToImageZoom] is not accurate with multi-image.");
                else if (count11 === 1) {
                    // It is better to use TiledImage.viewportToImageZoom
                    // because this._contentBoundsNoRotate can not be relied on
                    // with clipping.
                    var item11 = this.viewer.world.getItemAt(0);
                    return item11.viewportToImageZoom(viewportZoom11);
                }
            }
            var imageWidth11 = this._contentSizeNoRotate.x;
            var containerWidth11 = this._containerInnerSize.x;
            var scale11 = this._contentBoundsNoRotate.width;
            var viewportToImageZoomRatio11 = containerWidth11 / imageWidth11 * scale11;
            return viewportZoom11 * viewportToImageZoomRatio11;
        },
        /**
     * Convert an image zoom to a viewport zoom.
     * Image zoom: ratio of the original image size to displayed image size.
     * 1 means original image size, 0.5 half size...
     * Viewport zoom: ratio of the displayed image's width to viewport's width.
     * 1 means identical width, 2 means image's width is twice the viewport's width...
     * Note: not accurate with multi-image.
     * @function
     * @param {Number} imageZoom The image zoom
     * target zoom.
     * @returns {Number} viewportZoom The viewport zoom
     */ imageToViewportZoom: function(imageZoom11) {
            if (this.viewer) {
                var count11 = this.viewer.world.getItemCount();
                if (count11 > 1) $11.console.error("[Viewport.imageToViewportZoom] is not accurate with multi-image.");
                else if (count11 === 1) {
                    // It is better to use TiledImage.imageToViewportZoom
                    // because this._contentBoundsNoRotate can not be relied on
                    // with clipping.
                    var item11 = this.viewer.world.getItemAt(0);
                    return item11.imageToViewportZoom(imageZoom11);
                }
            }
            var imageWidth11 = this._contentSizeNoRotate.x;
            var containerWidth11 = this._containerInnerSize.x;
            var scale11 = this._contentBoundsNoRotate.width;
            var viewportToImageZoomRatio11 = imageWidth11 / containerWidth11 / scale11;
            return imageZoom11 * viewportToImageZoomRatio11;
        },
        /**
     * Toggles flip state and demands a new drawing on navigator and viewer objects.
     * @function
     * @return {OpenSeadragon.Viewport} Chainable.
     */ toggleFlip: function() {
            this.setFlip(!this.getFlip());
            return this;
        },
        /**
     * Gets flip state stored on viewport.
     * @function
     * @return {Boolean} Flip state.
     */ getFlip: function() {
            return this.flipped;
        },
        /**
     * Sets flip state according to the state input argument.
     * @function
     * @param {Boolean} state - Flip state to set.
     * @return {OpenSeadragon.Viewport} Chainable.
     */ setFlip: function(state11) {
            if (this.flipped === state11) return this;
            this.flipped = state11;
            if (this.viewer.navigator) this.viewer.navigator.setFlip(this.getFlip());
            this.viewer.forceRedraw();
            /**
       * Raised when flip state has been changed.
       *
       * @event flip
       * @memberof OpenSeadragon.Viewer
       * @type {object}
       * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
       * @property {Number} flipped - The flip state after this change.
       * @property {?Object} userData - Arbitrary subscriber-defined object.
       */ this.viewer.raiseEvent("flip", {
                "flipped": state11
            });
            return this;
        }
    };
})(OpenSeadragon);
/*
 * OpenSeadragon - TiledImage
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    /**
 * You shouldn't have to create a TiledImage instance directly; get it asynchronously by
 * using {@link OpenSeadragon.Viewer#open} or {@link OpenSeadragon.Viewer#addTiledImage} instead.
 * @class TiledImage
 * @memberof OpenSeadragon
 * @extends OpenSeadragon.EventSource
 * @classdesc Handles rendering of tiles for an {@link OpenSeadragon.Viewer}.
 * A new instance is created for each TileSource opened.
 * @param {Object} options - Configuration for this TiledImage.
 * @param {OpenSeadragon.TileSource} options.source - The TileSource that defines this TiledImage.
 * @param {OpenSeadragon.Viewer} options.viewer - The Viewer that owns this TiledImage.
 * @param {OpenSeadragon.TileCache} options.tileCache - The TileCache for this TiledImage to use.
 * @param {OpenSeadragon.Drawer} options.drawer - The Drawer for this TiledImage to draw onto.
 * @param {OpenSeadragon.ImageLoader} options.imageLoader - The ImageLoader for this TiledImage to use.
 * @param {Number} [options.x=0] - Left position, in viewport coordinates.
 * @param {Number} [options.y=0] - Top position, in viewport coordinates.
 * @param {Number} [options.width=1] - Width, in viewport coordinates.
 * @param {Number} [options.height] - Height, in viewport coordinates.
 * @param {OpenSeadragon.Rect} [options.fitBounds] The bounds in viewport coordinates
 * to fit the image into. If specified, x, y, width and height get ignored.
 * @param {OpenSeadragon.Placement} [options.fitBoundsPlacement=OpenSeadragon.Placement.CENTER]
 * How to anchor the image in the bounds if options.fitBounds is set.
 * @param {OpenSeadragon.Rect} [options.clip] - An area, in image pixels, to clip to
 * (portions of the image outside of this area will not be visible). Only works on
 * browsers that support the HTML5 canvas.
 * @param {Number} [options.springStiffness] - See {@link OpenSeadragon.Options}.
 * @param {Boolean} [options.animationTime] - See {@link OpenSeadragon.Options}.
 * @param {Number} [options.minZoomImageRatio] - See {@link OpenSeadragon.Options}.
 * @param {Boolean} [options.wrapHorizontal] - See {@link OpenSeadragon.Options}.
 * @param {Boolean} [options.wrapVertical] - See {@link OpenSeadragon.Options}.
 * @param {Boolean} [options.immediateRender] - See {@link OpenSeadragon.Options}.
 * @param {Number} [options.blendTime] - See {@link OpenSeadragon.Options}.
 * @param {Boolean} [options.alwaysBlend] - See {@link OpenSeadragon.Options}.
 * @param {Number} [options.minPixelRatio] - See {@link OpenSeadragon.Options}.
 * @param {Number} [options.smoothTileEdgesMinZoom] - See {@link OpenSeadragon.Options}.
 * @param {Boolean} [options.iOSDevice] - See {@link OpenSeadragon.Options}.
 * @param {Number} [options.opacity=1] - Set to draw at proportional opacity. If zero, images will not draw.
 * @param {Boolean} [options.preload=false] - Set true to load even when the image is hidden by zero opacity.
 * @param {String} [options.compositeOperation] - How the image is composited onto other images; see compositeOperation in {@link OpenSeadragon.Options} for possible values.
 * @param {Boolean} [options.debugMode] - See {@link OpenSeadragon.Options}.
 * @param {String|CanvasGradient|CanvasPattern|Function} [options.placeholderFillStyle] - See {@link OpenSeadragon.Options}.
 * @param {String|Boolean} [options.crossOriginPolicy] - See {@link OpenSeadragon.Options}.
 * @param {Boolean} [options.ajaxWithCredentials] - See {@link OpenSeadragon.Options}.
 * @param {Boolean} [options.loadTilesWithAjax]
 *      Whether to load tile data using AJAX requests.
 *      Defaults to the setting in {@link OpenSeadragon.Options}.
 * @param {Object} [options.ajaxHeaders={}]
 *      A set of headers to include when making tile AJAX requests.
 */ $11.TiledImage = function(options11) {
        var _this11 = this;
        /**
     * The {@link OpenSeadragon.TileSource} that defines this TiledImage.
     * @member {OpenSeadragon.TileSource} source
     * @memberof OpenSeadragon.TiledImage#
     */ $11.console.assert(options11.tileCache, "[TiledImage] options.tileCache is required");
        $11.console.assert(options11.drawer, "[TiledImage] options.drawer is required");
        $11.console.assert(options11.viewer, "[TiledImage] options.viewer is required");
        $11.console.assert(options11.imageLoader, "[TiledImage] options.imageLoader is required");
        $11.console.assert(options11.source, "[TiledImage] options.source is required");
        $11.console.assert(!options11.clip || options11.clip instanceof $11.Rect, "[TiledImage] options.clip must be an OpenSeadragon.Rect if present");
        $11.EventSource.call(this);
        this._tileCache = options11.tileCache;
        delete options11.tileCache;
        this._drawer = options11.drawer;
        delete options11.drawer;
        this._imageLoader = options11.imageLoader;
        delete options11.imageLoader;
        if (options11.clip instanceof $11.Rect) this._clip = options11.clip.clone();
        delete options11.clip;
        var x11 = options11.x || 0;
        delete options11.x;
        var y11 = options11.y || 0;
        delete options11.y;
        // Ratio of zoomable image height to width.
        this.normHeight = options11.source.dimensions.y / options11.source.dimensions.x;
        this.contentAspectX = options11.source.dimensions.x / options11.source.dimensions.y;
        var scale11 = 1;
        if (options11.width) {
            scale11 = options11.width;
            delete options11.width;
            if (options11.height) {
                $11.console.error("specifying both width and height to a tiledImage is not supported");
                delete options11.height;
            }
        } else if (options11.height) {
            scale11 = options11.height / this.normHeight;
            delete options11.height;
        }
        var fitBounds11 = options11.fitBounds;
        delete options11.fitBounds;
        var fitBoundsPlacement11 = options11.fitBoundsPlacement || OpenSeadragon.Placement.CENTER;
        delete options11.fitBoundsPlacement;
        var degrees11 = options11.degrees || 0;
        delete options11.degrees;
        $11.extend(true, this, {
            //internal state properties
            viewer: null,
            tilesMatrix: {},
            coverage: {},
            loadingCoverage: {},
            lastDrawn: [],
            lastResetTime: 0,
            _midDraw: false,
            _needsDraw: true,
            _hasOpaqueTile: false,
            _tilesLoading: 0,
            //configurable settings
            springStiffness: $11.DEFAULT_SETTINGS.springStiffness,
            animationTime: $11.DEFAULT_SETTINGS.animationTime,
            minZoomImageRatio: $11.DEFAULT_SETTINGS.minZoomImageRatio,
            wrapHorizontal: $11.DEFAULT_SETTINGS.wrapHorizontal,
            wrapVertical: $11.DEFAULT_SETTINGS.wrapVertical,
            immediateRender: $11.DEFAULT_SETTINGS.immediateRender,
            blendTime: $11.DEFAULT_SETTINGS.blendTime,
            alwaysBlend: $11.DEFAULT_SETTINGS.alwaysBlend,
            minPixelRatio: $11.DEFAULT_SETTINGS.minPixelRatio,
            smoothTileEdgesMinZoom: $11.DEFAULT_SETTINGS.smoothTileEdgesMinZoom,
            iOSDevice: $11.DEFAULT_SETTINGS.iOSDevice,
            debugMode: $11.DEFAULT_SETTINGS.debugMode,
            crossOriginPolicy: $11.DEFAULT_SETTINGS.crossOriginPolicy,
            ajaxWithCredentials: $11.DEFAULT_SETTINGS.ajaxWithCredentials,
            placeholderFillStyle: $11.DEFAULT_SETTINGS.placeholderFillStyle,
            opacity: $11.DEFAULT_SETTINGS.opacity,
            preload: $11.DEFAULT_SETTINGS.preload,
            compositeOperation: $11.DEFAULT_SETTINGS.compositeOperation
        }, options11);
        this._preload = this.preload;
        delete this.preload;
        this._fullyLoaded = false;
        this._xSpring = new $11.Spring({
            initial: x11,
            springStiffness: this.springStiffness,
            animationTime: this.animationTime
        });
        this._ySpring = new $11.Spring({
            initial: y11,
            springStiffness: this.springStiffness,
            animationTime: this.animationTime
        });
        this._scaleSpring = new $11.Spring({
            initial: scale11,
            springStiffness: this.springStiffness,
            animationTime: this.animationTime
        });
        this._degreesSpring = new $11.Spring({
            initial: degrees11,
            springStiffness: this.springStiffness,
            animationTime: this.animationTime
        });
        this._updateForScale();
        if (fitBounds11) this.fitBounds(fitBounds11, fitBoundsPlacement11, true);
        // We need a callback to give image manipulation a chance to happen
        this._drawingHandler = function(args11) {
            /**
       * This event is fired just before the tile is drawn giving the application a chance to alter the image.
       *
       * NOTE: This event is only fired when the drawer is using a &lt;canvas&gt;.
       *
       * @event tile-drawing
       * @memberof OpenSeadragon.Viewer
       * @type {object}
       * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
       * @property {OpenSeadragon.Tile} tile - The Tile being drawn.
       * @property {OpenSeadragon.TiledImage} tiledImage - Which TiledImage is being drawn.
       * @property {OpenSeadragon.Tile} context - The HTML canvas context being drawn into.
       * @property {OpenSeadragon.Tile} rendered - The HTML canvas context containing the tile imagery.
       * @property {?Object} userData - Arbitrary subscriber-defined object.
       */ _this11.viewer.raiseEvent("tile-drawing", $11.extend({
                tiledImage: _this11
            }, args11));
        };
    };
    $11.extend($11.TiledImage.prototype, $11.EventSource.prototype, /** @lends OpenSeadragon.TiledImage.prototype */ {
        /**
     * @returns {Boolean} Whether the TiledImage needs to be drawn.
     */ needsDraw: function() {
            return this._needsDraw;
        },
        /**
     * @returns {Boolean} Whether all tiles necessary for this TiledImage to draw at the current view have been loaded.
     */ getFullyLoaded: function() {
            return this._fullyLoaded;
        },
        // private
        _setFullyLoaded: function(flag11) {
            if (flag11 === this._fullyLoaded) return;
            this._fullyLoaded = flag11;
            /**
         * Fired when the TiledImage's "fully loaded" flag (whether all tiles necessary for this TiledImage
         * to draw at the current view have been loaded) changes.
         *
         * @event fully-loaded-change
         * @memberof OpenSeadragon.TiledImage
         * @type {object}
         * @property {Boolean} fullyLoaded - The new "fully loaded" value.
         * @property {OpenSeadragon.TiledImage} eventSource - A reference to the TiledImage which raised the event.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */ this.raiseEvent("fully-loaded-change", {
                fullyLoaded: this._fullyLoaded
            });
        },
        /**
     * Clears all tiles and triggers an update on the next call to
     * {@link OpenSeadragon.TiledImage#update}.
     */ reset: function() {
            this._tileCache.clearTilesFor(this);
            this.lastResetTime = $11.now();
            this._needsDraw = true;
        },
        /**
     * Updates the TiledImage's bounds, animating if needed.
     * @returns {Boolean} Whether the TiledImage animated.
     */ update: function() {
            var xUpdated11 = this._xSpring.update();
            var yUpdated11 = this._ySpring.update();
            var scaleUpdated11 = this._scaleSpring.update();
            var degreesUpdated11 = this._degreesSpring.update();
            if (xUpdated11 || yUpdated11 || scaleUpdated11 || degreesUpdated11) {
                this._updateForScale();
                this._needsDraw = true;
                return true;
            }
            return false;
        },
        /**
     * Draws the TiledImage to its Drawer.
     */ draw: function() {
            if (this.opacity !== 0 || this._preload) {
                this._midDraw = true;
                this._updateViewport();
                this._midDraw = false;
            } else this._needsDraw = false;
        },
        /**
     * Destroy the TiledImage (unload current loaded tiles).
     */ destroy: function() {
            this.reset();
        },
        /**
     * Get this TiledImage's bounds in viewport coordinates.
     * @param {Boolean} [current=false] - Pass true for the current location;
     * false for target location.
     * @returns {OpenSeadragon.Rect} This TiledImage's bounds in viewport coordinates.
     */ getBounds: function(current11) {
            return this.getBoundsNoRotate(current11).rotate(this.getRotation(current11), this._getRotationPoint(current11));
        },
        /**
     * Get this TiledImage's bounds in viewport coordinates without taking
     * rotation into account.
     * @param {Boolean} [current=false] - Pass true for the current location;
     * false for target location.
     * @returns {OpenSeadragon.Rect} This TiledImage's bounds in viewport coordinates.
     */ getBoundsNoRotate: function(current11) {
            return current11 ? new $11.Rect(this._xSpring.current.value, this._ySpring.current.value, this._worldWidthCurrent, this._worldHeightCurrent) : new $11.Rect(this._xSpring.target.value, this._ySpring.target.value, this._worldWidthTarget, this._worldHeightTarget);
        },
        // deprecated
        getWorldBounds: function() {
            $11.console.error("[TiledImage.getWorldBounds] is deprecated; use TiledImage.getBounds instead");
            return this.getBounds();
        },
        /**
     * Get the bounds of the displayed part of the tiled image.
     * @param {Boolean} [current=false] Pass true for the current location,
     * false for the target location.
     * @returns {$.Rect} The clipped bounds in viewport coordinates.
     */ getClippedBounds: function(current11) {
            var bounds11 = this.getBoundsNoRotate(current11);
            if (this._clip) {
                var worldWidth11 = current11 ? this._worldWidthCurrent : this._worldWidthTarget;
                var ratio11 = worldWidth11 / this.source.dimensions.x;
                var clip11 = this._clip.times(ratio11);
                bounds11 = new $11.Rect(bounds11.x + clip11.x, bounds11.y + clip11.y, clip11.width, clip11.height);
            }
            return bounds11.rotate(this.getRotation(current11), this._getRotationPoint(current11));
        },
        /**
     * @returns {OpenSeadragon.Point} This TiledImage's content size, in original pixels.
     */ getContentSize: function() {
            return new $11.Point(this.source.dimensions.x, this.source.dimensions.y);
        },
        // private
        _viewportToImageDelta: function(viewerX11, viewerY11, current11) {
            var scale11 = current11 ? this._scaleSpring.current.value : this._scaleSpring.target.value;
            return new $11.Point(viewerX11 * (this.source.dimensions.x / scale11), viewerY11 * (this.source.dimensions.y * this.contentAspectX / scale11));
        },
        /**
     * Translates from OpenSeadragon viewer coordinate system to image coordinate system.
     * This method can be called either by passing X,Y coordinates or an {@link OpenSeadragon.Point}.
     * @param {Number|OpenSeadragon.Point} viewerX - The X coordinate or point in viewport coordinate system.
     * @param {Number} [viewerY] - The Y coordinate in viewport coordinate system.
     * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
     * @return {OpenSeadragon.Point} A point representing the coordinates in the image.
     */ viewportToImageCoordinates: function(viewerX11, viewerY11, current11) {
            var point31;
            if (viewerX11 instanceof $11.Point) {
                //they passed a point instead of individual components
                current11 = viewerY11;
                point31 = viewerX11;
            } else point31 = new $11.Point(viewerX11, viewerY11);
            point31 = point31.rotate(-this.getRotation(current11), this._getRotationPoint(current11));
            return current11 ? this._viewportToImageDelta(point31.x - this._xSpring.current.value, point31.y - this._ySpring.current.value) : this._viewportToImageDelta(point31.x - this._xSpring.target.value, point31.y - this._ySpring.target.value);
        },
        // private
        _imageToViewportDelta: function(imageX11, imageY11, current11) {
            var scale11 = current11 ? this._scaleSpring.current.value : this._scaleSpring.target.value;
            return new $11.Point(imageX11 / this.source.dimensions.x * scale11, imageY11 / this.source.dimensions.y / this.contentAspectX * scale11);
        },
        /**
     * Translates from image coordinate system to OpenSeadragon viewer coordinate system
     * This method can be called either by passing X,Y coordinates or an {@link OpenSeadragon.Point}.
     * @param {Number|OpenSeadragon.Point} imageX - The X coordinate or point in image coordinate system.
     * @param {Number} [imageY] - The Y coordinate in image coordinate system.
     * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
     * @return {OpenSeadragon.Point} A point representing the coordinates in the viewport.
     */ imageToViewportCoordinates: function(imageX11, imageY11, current11) {
            if (imageX11 instanceof $11.Point) {
                //they passed a point instead of individual components
                current11 = imageY11;
                imageY11 = imageX11.y;
                imageX11 = imageX11.x;
            }
            var point31 = this._imageToViewportDelta(imageX11, imageY11);
            if (current11) {
                point31.x += this._xSpring.current.value;
                point31.y += this._ySpring.current.value;
            } else {
                point31.x += this._xSpring.target.value;
                point31.y += this._ySpring.target.value;
            }
            return point31.rotate(this.getRotation(current11), this._getRotationPoint(current11));
        },
        /**
     * Translates from a rectangle which describes a portion of the image in
     * pixel coordinates to OpenSeadragon viewport rectangle coordinates.
     * This method can be called either by passing X,Y,width,height or an {@link OpenSeadragon.Rect}.
     * @param {Number|OpenSeadragon.Rect} imageX - The left coordinate or rectangle in image coordinate system.
     * @param {Number} [imageY] - The top coordinate in image coordinate system.
     * @param {Number} [pixelWidth] - The width in pixel of the rectangle.
     * @param {Number} [pixelHeight] - The height in pixel of the rectangle.
     * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
     * @return {OpenSeadragon.Rect} A rect representing the coordinates in the viewport.
     */ imageToViewportRectangle: function(imageX11, imageY11, pixelWidth11, pixelHeight11, current11) {
            var rect11 = imageX11;
            if (rect11 instanceof $11.Rect) //they passed a rect instead of individual components
            current11 = imageY11;
            else rect11 = new $11.Rect(imageX11, imageY11, pixelWidth11, pixelHeight11);
            var coordA11 = this.imageToViewportCoordinates(rect11.getTopLeft(), current11);
            var coordB11 = this._imageToViewportDelta(rect11.width, rect11.height, current11);
            return new $11.Rect(coordA11.x, coordA11.y, coordB11.x, coordB11.y, rect11.degrees + this.getRotation(current11));
        },
        /**
     * Translates from a rectangle which describes a portion of
     * the viewport in point coordinates to image rectangle coordinates.
     * This method can be called either by passing X,Y,width,height or an {@link OpenSeadragon.Rect}.
     * @param {Number|OpenSeadragon.Rect} viewerX - The left coordinate or rectangle in viewport coordinate system.
     * @param {Number} [viewerY] - The top coordinate in viewport coordinate system.
     * @param {Number} [pointWidth] - The width in viewport coordinate system.
     * @param {Number} [pointHeight] - The height in viewport coordinate system.
     * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
     * @return {OpenSeadragon.Rect} A rect representing the coordinates in the image.
     */ viewportToImageRectangle: function(viewerX11, viewerY11, pointWidth11, pointHeight11, current11) {
            var rect11 = viewerX11;
            if (viewerX11 instanceof $11.Rect) //they passed a rect instead of individual components
            current11 = viewerY11;
            else rect11 = new $11.Rect(viewerX11, viewerY11, pointWidth11, pointHeight11);
            var coordA11 = this.viewportToImageCoordinates(rect11.getTopLeft(), current11);
            var coordB11 = this._viewportToImageDelta(rect11.width, rect11.height, current11);
            return new $11.Rect(coordA11.x, coordA11.y, coordB11.x, coordB11.y, rect11.degrees - this.getRotation(current11));
        },
        /**
     * Convert pixel coordinates relative to the viewer element to image
     * coordinates.
     * @param {OpenSeadragon.Point} pixel
     * @returns {OpenSeadragon.Point}
     */ viewerElementToImageCoordinates: function(pixel11) {
            var point31 = this.viewport.pointFromPixel(pixel11, true);
            return this.viewportToImageCoordinates(point31);
        },
        /**
     * Convert pixel coordinates relative to the image to
     * viewer element coordinates.
     * @param {OpenSeadragon.Point} pixel
     * @returns {OpenSeadragon.Point}
     */ imageToViewerElementCoordinates: function(pixel11) {
            var point31 = this.imageToViewportCoordinates(pixel11);
            return this.viewport.pixelFromPoint(point31, true);
        },
        /**
     * Convert pixel coordinates relative to the window to image coordinates.
     * @param {OpenSeadragon.Point} pixel
     * @returns {OpenSeadragon.Point}
     */ windowToImageCoordinates: function(pixel11) {
            var viewerCoordinates11 = pixel11.minus(OpenSeadragon.getElementPosition(this.viewer.element));
            return this.viewerElementToImageCoordinates(viewerCoordinates11);
        },
        /**
     * Convert image coordinates to pixel coordinates relative to the window.
     * @param {OpenSeadragon.Point} pixel
     * @returns {OpenSeadragon.Point}
     */ imageToWindowCoordinates: function(pixel11) {
            var viewerCoordinates11 = this.imageToViewerElementCoordinates(pixel11);
            return viewerCoordinates11.plus(OpenSeadragon.getElementPosition(this.viewer.element));
        },
        // private
        // Convert rectangle in viewport coordinates to this tiled image point
        // coordinates (x in [0, 1] and y in [0, aspectRatio])
        _viewportToTiledImageRectangle: function(rect11) {
            var scale11 = this._scaleSpring.current.value;
            rect11 = rect11.rotate(-this.getRotation(true), this._getRotationPoint(true));
            return new $11.Rect((rect11.x - this._xSpring.current.value) / scale11, (rect11.y - this._ySpring.current.value) / scale11, rect11.width / scale11, rect11.height / scale11, rect11.degrees);
        },
        /**
     * Convert a viewport zoom to an image zoom.
     * Image zoom: ratio of the original image size to displayed image size.
     * 1 means original image size, 0.5 half size...
     * Viewport zoom: ratio of the displayed image's width to viewport's width.
     * 1 means identical width, 2 means image's width is twice the viewport's width...
     * @function
     * @param {Number} viewportZoom The viewport zoom
     * @returns {Number} imageZoom The image zoom
     */ viewportToImageZoom: function(viewportZoom11) {
            var ratio11 = this._scaleSpring.current.value * this.viewport._containerInnerSize.x / this.source.dimensions.x;
            return ratio11 * viewportZoom11;
        },
        /**
     * Convert an image zoom to a viewport zoom.
     * Image zoom: ratio of the original image size to displayed image size.
     * 1 means original image size, 0.5 half size...
     * Viewport zoom: ratio of the displayed image's width to viewport's width.
     * 1 means identical width, 2 means image's width is twice the viewport's width...
     * Note: not accurate with multi-image.
     * @function
     * @param {Number} imageZoom The image zoom
     * @returns {Number} viewportZoom The viewport zoom
     */ imageToViewportZoom: function(imageZoom11) {
            var ratio11 = this._scaleSpring.current.value * this.viewport._containerInnerSize.x / this.source.dimensions.x;
            return imageZoom11 / ratio11;
        },
        /**
     * Sets the TiledImage's position in the world.
     * @param {OpenSeadragon.Point} position - The new position, in viewport coordinates.
     * @param {Boolean} [immediately=false] - Whether to animate to the new position or snap immediately.
     * @fires OpenSeadragon.TiledImage.event:bounds-change
     */ setPosition: function(position11, immediately11) {
            var sameTarget11 = this._xSpring.target.value === position11.x && this._ySpring.target.value === position11.y;
            if (immediately11) {
                if (sameTarget11 && this._xSpring.current.value === position11.x && this._ySpring.current.value === position11.y) return;
                this._xSpring.resetTo(position11.x);
                this._ySpring.resetTo(position11.y);
                this._needsDraw = true;
            } else {
                if (sameTarget11) return;
                this._xSpring.springTo(position11.x);
                this._ySpring.springTo(position11.y);
                this._needsDraw = true;
            }
            if (!sameTarget11) this._raiseBoundsChange();
        },
        /**
     * Sets the TiledImage's width in the world, adjusting the height to match based on aspect ratio.
     * @param {Number} width - The new width, in viewport coordinates.
     * @param {Boolean} [immediately=false] - Whether to animate to the new size or snap immediately.
     * @fires OpenSeadragon.TiledImage.event:bounds-change
     */ setWidth: function(width11, immediately11) {
            this._setScale(width11, immediately11);
        },
        /**
     * Sets the TiledImage's height in the world, adjusting the width to match based on aspect ratio.
     * @param {Number} height - The new height, in viewport coordinates.
     * @param {Boolean} [immediately=false] - Whether to animate to the new size or snap immediately.
     * @fires OpenSeadragon.TiledImage.event:bounds-change
     */ setHeight: function(height11, immediately11) {
            this._setScale(height11 / this.normHeight, immediately11);
        },
        /**
     * Positions and scales the TiledImage to fit in the specified bounds.
     * Note: this method fires OpenSeadragon.TiledImage.event:bounds-change
     * twice
     * @param {OpenSeadragon.Rect} bounds The bounds to fit the image into.
     * @param {OpenSeadragon.Placement} [anchor=OpenSeadragon.Placement.CENTER]
     * How to anchor the image in the bounds.
     * @param {Boolean} [immediately=false] Whether to animate to the new size
     * or snap immediately.
     * @fires OpenSeadragon.TiledImage.event:bounds-change
     */ fitBounds: function(bounds11, anchor11, immediately11) {
            anchor11 = anchor11 || $11.Placement.CENTER;
            var anchorProperties11 = $11.Placement.properties[anchor11];
            var aspectRatio11 = this.contentAspectX;
            var xOffset11 = 0;
            var yOffset11 = 0;
            var displayedWidthRatio11 = 1;
            var displayedHeightRatio11 = 1;
            if (this._clip) {
                aspectRatio11 = this._clip.getAspectRatio();
                displayedWidthRatio11 = this._clip.width / this.source.dimensions.x;
                displayedHeightRatio11 = this._clip.height / this.source.dimensions.y;
                if (bounds11.getAspectRatio() > aspectRatio11) {
                    xOffset11 = this._clip.x / this._clip.height * bounds11.height;
                    yOffset11 = this._clip.y / this._clip.height * bounds11.height;
                } else {
                    xOffset11 = this._clip.x / this._clip.width * bounds11.width;
                    yOffset11 = this._clip.y / this._clip.width * bounds11.width;
                }
            }
            if (bounds11.getAspectRatio() > aspectRatio11) {
                // We will have margins on the X axis
                var height11 = bounds11.height / displayedHeightRatio11;
                var marginLeft11 = 0;
                if (anchorProperties11.isHorizontallyCentered) marginLeft11 = (bounds11.width - bounds11.height * aspectRatio11) / 2;
                else if (anchorProperties11.isRight) marginLeft11 = bounds11.width - bounds11.height * aspectRatio11;
                this.setPosition(new $11.Point(bounds11.x - xOffset11 + marginLeft11, bounds11.y - yOffset11), immediately11);
                this.setHeight(height11, immediately11);
            } else {
                // We will have margins on the Y axis
                var width11 = bounds11.width / displayedWidthRatio11;
                var marginTop11 = 0;
                if (anchorProperties11.isVerticallyCentered) marginTop11 = (bounds11.height - bounds11.width / aspectRatio11) / 2;
                else if (anchorProperties11.isBottom) marginTop11 = bounds11.height - bounds11.width / aspectRatio11;
                this.setPosition(new $11.Point(bounds11.x - xOffset11, bounds11.y - yOffset11 + marginTop11), immediately11);
                this.setWidth(width11, immediately11);
            }
        },
        /**
     * @returns {OpenSeadragon.Rect|null} The TiledImage's current clip rectangle,
     * in image pixels, or null if none.
     */ getClip: function() {
            if (this._clip) return this._clip.clone();
            return null;
        },
        /**
     * @param {OpenSeadragon.Rect|null} newClip - An area, in image pixels, to clip to
     * (portions of the image outside of this area will not be visible). Only works on
     * browsers that support the HTML5 canvas.
     * @fires OpenSeadragon.TiledImage.event:clip-change
     */ setClip: function(newClip11) {
            $11.console.assert(!newClip11 || newClip11 instanceof $11.Rect, "[TiledImage.setClip] newClip must be an OpenSeadragon.Rect or null");
            if (newClip11 instanceof $11.Rect) this._clip = newClip11.clone();
            else this._clip = null;
            this._needsDraw = true;
            /**
         * Raised when the TiledImage's clip is changed.
         * @event clip-change
         * @memberOf OpenSeadragon.TiledImage
         * @type {object}
         * @property {OpenSeadragon.TiledImage} eventSource - A reference to the
         * TiledImage which raised the event.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */ this.raiseEvent("clip-change");
        },
        /**
     * @returns {Number} The TiledImage's current opacity.
     */ getOpacity: function() {
            return this.opacity;
        },
        /**
     * @param {Number} opacity Opacity the tiled image should be drawn at.
     * @fires OpenSeadragon.TiledImage.event:opacity-change
     */ setOpacity: function(opacity11) {
            if (opacity11 === this.opacity) return;
            this.opacity = opacity11;
            this._needsDraw = true;
            /**
         * Raised when the TiledImage's opacity is changed.
         * @event opacity-change
         * @memberOf OpenSeadragon.TiledImage
         * @type {object}
         * @property {Number} opacity - The new opacity value.
         * @property {OpenSeadragon.TiledImage} eventSource - A reference to the
         * TiledImage which raised the event.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */ this.raiseEvent("opacity-change", {
                opacity: this.opacity
            });
        },
        /**
     * @returns {Boolean} whether the tiledImage can load its tiles even when it has zero opacity.
     */ getPreload: function() {
            return this._preload;
        },
        /**
     * Set true to load even when hidden. Set false to block loading when hidden.
     */ setPreload: function(preload11) {
            this._preload = !!preload11;
            this._needsDraw = true;
        },
        /**
     * Get the rotation of this tiled image in degrees.
     * @param {Boolean} [current=false] True for current rotation, false for target.
     * @returns {Number} the rotation of this tiled image in degrees.
     */ getRotation: function(current11) {
            return current11 ? this._degreesSpring.current.value : this._degreesSpring.target.value;
        },
        /**
     * Set the current rotation of this tiled image in degrees.
     * @param {Number} degrees the rotation in degrees.
     * @param {Boolean} [immediately=false] Whether to animate to the new angle
     * or rotate immediately.
     * @fires OpenSeadragon.TiledImage.event:bounds-change
     */ setRotation: function(degrees11, immediately11) {
            if (this._degreesSpring.target.value === degrees11 && this._degreesSpring.isAtTargetValue()) return;
            if (immediately11) this._degreesSpring.resetTo(degrees11);
            else this._degreesSpring.springTo(degrees11);
            this._needsDraw = true;
            this._raiseBoundsChange();
        },
        /**
     * Get the point around which this tiled image is rotated
     * @private
     * @param {Boolean} current True for current rotation point, false for target.
     * @returns {OpenSeadragon.Point}
     */ _getRotationPoint: function(current11) {
            return this.getBoundsNoRotate(current11).getCenter();
        },
        /**
     * @returns {String} The TiledImage's current compositeOperation.
     */ getCompositeOperation: function() {
            return this.compositeOperation;
        },
        /**
     * @param {String} compositeOperation the tiled image should be drawn with this globalCompositeOperation.
     * @fires OpenSeadragon.TiledImage.event:composite-operation-change
     */ setCompositeOperation: function(compositeOperation11) {
            if (compositeOperation11 === this.compositeOperation) return;
            this.compositeOperation = compositeOperation11;
            this._needsDraw = true;
            /**
         * Raised when the TiledImage's opacity is changed.
         * @event composite-operation-change
         * @memberOf OpenSeadragon.TiledImage
         * @type {object}
         * @property {String} compositeOperation - The new compositeOperation value.
         * @property {OpenSeadragon.TiledImage} eventSource - A reference to the
         * TiledImage which raised the event.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */ this.raiseEvent("composite-operation-change", {
                compositeOperation: this.compositeOperation
            });
        },
        // private
        _setScale: function(scale11, immediately11) {
            var sameTarget11 = this._scaleSpring.target.value === scale11;
            if (immediately11) {
                if (sameTarget11 && this._scaleSpring.current.value === scale11) return;
                this._scaleSpring.resetTo(scale11);
                this._updateForScale();
                this._needsDraw = true;
            } else {
                if (sameTarget11) return;
                this._scaleSpring.springTo(scale11);
                this._updateForScale();
                this._needsDraw = true;
            }
            if (!sameTarget11) this._raiseBoundsChange();
        },
        // private
        _updateForScale: function() {
            this._worldWidthTarget = this._scaleSpring.target.value;
            this._worldHeightTarget = this.normHeight * this._scaleSpring.target.value;
            this._worldWidthCurrent = this._scaleSpring.current.value;
            this._worldHeightCurrent = this.normHeight * this._scaleSpring.current.value;
        },
        // private
        _raiseBoundsChange: function() {
            /**
         * Raised when the TiledImage's bounds are changed.
         * Note that this event is triggered only when the animation target is changed;
         * not for every frame of animation.
         * @event bounds-change
         * @memberOf OpenSeadragon.TiledImage
         * @type {object}
         * @property {OpenSeadragon.TiledImage} eventSource - A reference to the
         * TiledImage which raised the event.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */ this.raiseEvent("bounds-change");
        },
        // private
        _isBottomItem: function() {
            return this.viewer.world.getItemAt(0) === this;
        },
        // private
        _getLevelsInterval: function() {
            var lowestLevel11 = Math.max(this.source.minLevel, Math.floor(Math.log(this.minZoomImageRatio) / Math.log(2)));
            var currentZeroRatio11 = this.viewport.deltaPixelsFromPointsNoRotate(this.source.getPixelRatio(0), true).x * this._scaleSpring.current.value;
            var highestLevel11 = Math.min(Math.abs(this.source.maxLevel), Math.abs(Math.floor(Math.log(currentZeroRatio11 / this.minPixelRatio) / Math.log(2))));
            // Calculations for the interval of levels to draw
            // can return invalid intervals; fix that here if necessary
            highestLevel11 = Math.max(highestLevel11, this.source.minLevel || 0);
            lowestLevel11 = Math.min(lowestLevel11, highestLevel11);
            return {
                lowestLevel: lowestLevel11,
                highestLevel: highestLevel11
            };
        },
        /**
     * @private
     * @inner
     * Pretty much every other line in this needs to be documented so it's clear
     * how each piece of this routine contributes to the drawing process.  That's
     * why there are so many TODO's inside this function.
     */ _updateViewport: function() {
            this._needsDraw = false;
            this._tilesLoading = 0;
            this.loadingCoverage = {};
            // Reset tile's internal drawn state
            while(this.lastDrawn.length > 0){
                var tile11 = this.lastDrawn.pop();
                tile11.beingDrawn = false;
            }
            var viewport11 = this.viewport;
            var drawArea11 = this._viewportToTiledImageRectangle(viewport11.getBoundsWithMargins(true));
            if (!this.wrapHorizontal && !this.wrapVertical) {
                var tiledImageBounds11 = this._viewportToTiledImageRectangle(this.getClippedBounds(true));
                drawArea11 = drawArea11.intersection(tiledImageBounds11);
                if (drawArea11 === null) return;
            }
            var levelsInterval11 = this._getLevelsInterval();
            var lowestLevel11 = levelsInterval11.lowestLevel;
            var highestLevel11 = levelsInterval11.highestLevel;
            var bestTile11 = null;
            var haveDrawn11 = false;
            var currentTime11 = $11.now();
            // Update any level that will be drawn
            for(var level11 = highestLevel11; level11 >= lowestLevel11; level11--){
                var drawLevel11 = false;
                //Avoid calculations for draw if we have already drawn this
                var currentRenderPixelRatio11 = viewport11.deltaPixelsFromPointsNoRotate(this.source.getPixelRatio(level11), true).x * this._scaleSpring.current.value;
                if (level11 === lowestLevel11 || !haveDrawn11 && currentRenderPixelRatio11 >= this.minPixelRatio) {
                    drawLevel11 = true;
                    haveDrawn11 = true;
                } else if (!haveDrawn11) continue;
                //Perform calculations for draw if we haven't drawn this
                var targetRenderPixelRatio11 = viewport11.deltaPixelsFromPointsNoRotate(this.source.getPixelRatio(level11), false).x * this._scaleSpring.current.value;
                var targetZeroRatio11 = viewport11.deltaPixelsFromPointsNoRotate(this.source.getPixelRatio(Math.max(this.source.getClosestLevel(), 0)), false).x * this._scaleSpring.current.value;
                var optimalRatio11 = this.immediateRender ? 1 : targetZeroRatio11;
                var levelOpacity11 = Math.min(1, (currentRenderPixelRatio11 - 0.5) / 0.5);
                var levelVisibility11 = optimalRatio11 / Math.abs(optimalRatio11 - targetRenderPixelRatio11);
                // Update the level and keep track of 'best' tile to load
                bestTile11 = updateLevel11(this, haveDrawn11, drawLevel11, level11, levelOpacity11, levelVisibility11, drawArea11, currentTime11, bestTile11);
                // Stop the loop if lower-res tiles would all be covered by
                // already drawn tiles
                if (providesCoverage11(this.coverage, level11)) break;
            }
            // Perform the actual drawing
            drawTiles11(this, this.lastDrawn);
            // Load the new 'best' tile
            if (bestTile11 && !bestTile11.context2D) {
                loadTile11(this, bestTile11, currentTime11);
                this._needsDraw = true;
                this._setFullyLoaded(false);
            } else this._setFullyLoaded(this._tilesLoading === 0);
        },
        // private
        _getCornerTiles: function(level11, topLeftBound11, bottomRightBound11) {
            var leftX11;
            var rightX11;
            if (this.wrapHorizontal) {
                leftX11 = $11.positiveModulo(topLeftBound11.x, 1);
                rightX11 = $11.positiveModulo(bottomRightBound11.x, 1);
            } else {
                leftX11 = Math.max(0, topLeftBound11.x);
                rightX11 = Math.min(1, bottomRightBound11.x);
            }
            var topY11;
            var bottomY11;
            var aspectRatio11 = 1 / this.source.aspectRatio;
            if (this.wrapVertical) {
                topY11 = $11.positiveModulo(topLeftBound11.y, aspectRatio11);
                bottomY11 = $11.positiveModulo(bottomRightBound11.y, aspectRatio11);
            } else {
                topY11 = Math.max(0, topLeftBound11.y);
                bottomY11 = Math.min(aspectRatio11, bottomRightBound11.y);
            }
            var topLeftTile11 = this.source.getTileAtPoint(level11, new $11.Point(leftX11, topY11));
            var bottomRightTile11 = this.source.getTileAtPoint(level11, new $11.Point(rightX11, bottomY11));
            var numTiles11 = this.source.getNumTiles(level11);
            if (this.wrapHorizontal) {
                topLeftTile11.x += numTiles11.x * Math.floor(topLeftBound11.x);
                bottomRightTile11.x += numTiles11.x * Math.floor(bottomRightBound11.x);
            }
            if (this.wrapVertical) {
                topLeftTile11.y += numTiles11.y * Math.floor(topLeftBound11.y / aspectRatio11);
                bottomRightTile11.y += numTiles11.y * Math.floor(bottomRightBound11.y / aspectRatio11);
            }
            return {
                topLeft: topLeftTile11,
                bottomRight: bottomRightTile11
            };
        }
    });
    /**
 * @private
 * @inner
 * Updates all tiles at a given resolution level.
 * @param {OpenSeadragon.TiledImage} tiledImage - Which TiledImage is being drawn.
 * @param {Boolean} haveDrawn
 * @param {Boolean} drawLevel
 * @param {Number} level
 * @param {Number} levelOpacity
 * @param {Number} levelVisibility
 * @param {OpenSeadragon.Point} viewportTL - The index of the most top-left visible tile.
 * @param {OpenSeadragon.Point} viewportBR - The index of the most bottom-right visible tile.
 * @param {Number} currentTime
 * @param {OpenSeadragon.Tile} best - The current "best" tile to draw.
 */ function updateLevel11(tiledImage11, haveDrawn11, drawLevel11, level11, levelOpacity11, levelVisibility11, drawArea11, currentTime11, best11) {
        var topLeftBound11 = drawArea11.getBoundingBox().getTopLeft();
        var bottomRightBound11 = drawArea11.getBoundingBox().getBottomRight();
        if (tiledImage11.viewer) /**
         * <em>- Needs documentation -</em>
         *
         * @event update-level
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
         * @property {OpenSeadragon.TiledImage} tiledImage - Which TiledImage is being drawn.
         * @property {Object} havedrawn
         * @property {Object} level
         * @property {Object} opacity
         * @property {Object} visibility
         * @property {OpenSeadragon.Rect} drawArea
         * @property {Object} topleft deprecated, use drawArea instead
         * @property {Object} bottomright deprecated, use drawArea instead
         * @property {Object} currenttime
         * @property {Object} best
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */ tiledImage11.viewer.raiseEvent("update-level", {
            tiledImage: tiledImage11,
            havedrawn: haveDrawn11,
            level: level11,
            opacity: levelOpacity11,
            visibility: levelVisibility11,
            drawArea: drawArea11,
            topleft: topLeftBound11,
            bottomright: bottomRightBound11,
            currenttime: currentTime11,
            best: best11
        });
        resetCoverage11(tiledImage11.coverage, level11);
        resetCoverage11(tiledImage11.loadingCoverage, level11);
        //OK, a new drawing so do your calculations
        var cornerTiles11 = tiledImage11._getCornerTiles(level11, topLeftBound11, bottomRightBound11);
        var topLeftTile11 = cornerTiles11.topLeft;
        var bottomRightTile11 = cornerTiles11.bottomRight;
        var numberOfTiles11 = tiledImage11.source.getNumTiles(level11);
        var viewportCenter11 = tiledImage11.viewport.pixelFromPoint(tiledImage11.viewport.getCenter());
        for(var x11 = topLeftTile11.x; x11 <= bottomRightTile11.x; x11++)for(var y11 = topLeftTile11.y; y11 <= bottomRightTile11.y; y11++){
            // Optimisation disabled with wrapping because getTileBounds does not
            // work correctly with x and y outside of the number of tiles
            if (!tiledImage11.wrapHorizontal && !tiledImage11.wrapVertical) {
                var tileBounds11 = tiledImage11.source.getTileBounds(level11, x11, y11);
                if (drawArea11.intersection(tileBounds11) === null) continue;
            }
            best11 = updateTile11(tiledImage11, drawLevel11, haveDrawn11, x11, y11, level11, levelOpacity11, levelVisibility11, viewportCenter11, numberOfTiles11, currentTime11, best11);
        }
        return best11;
    }
    /**
 * @private
 * @inner
 * Update a single tile at a particular resolution level.
 * @param {OpenSeadragon.TiledImage} tiledImage - Which TiledImage is being drawn.
 * @param {Boolean} haveDrawn
 * @param {Boolean} drawLevel
 * @param {Number} x
 * @param {Number} y
 * @param {Number} level
 * @param {Number} levelOpacity
 * @param {Number} levelVisibility
 * @param {OpenSeadragon.Point} viewportCenter
 * @param {Number} numberOfTiles
 * @param {Number} currentTime
 * @param {OpenSeadragon.Tile} best - The current "best" tile to draw.
 */ function updateTile11(tiledImage11, haveDrawn11, drawLevel11, x11, y11, level11, levelOpacity11, levelVisibility11, viewportCenter11, numberOfTiles11, currentTime11, best11) {
        var tile11 = getTile11(x11, y11, level11, tiledImage11, tiledImage11.source, tiledImage11.tilesMatrix, currentTime11, numberOfTiles11, tiledImage11._worldWidthCurrent, tiledImage11._worldHeightCurrent), drawTile11 = drawLevel11;
        if (tiledImage11.viewer) /**
         * <em>- Needs documentation -</em>
         *
         * @event update-tile
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
         * @property {OpenSeadragon.TiledImage} tiledImage - Which TiledImage is being drawn.
         * @property {OpenSeadragon.Tile} tile
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */ tiledImage11.viewer.raiseEvent("update-tile", {
            tiledImage: tiledImage11,
            tile: tile11
        });
        setCoverage11(tiledImage11.coverage, level11, x11, y11, false);
        var loadingCoverage11 = tile11.loaded || tile11.loading || isCovered11(tiledImage11.loadingCoverage, level11, x11, y11);
        setCoverage11(tiledImage11.loadingCoverage, level11, x11, y11, loadingCoverage11);
        if (!tile11.exists) return best11;
        if (haveDrawn11 && !drawTile11) {
            if (isCovered11(tiledImage11.coverage, level11, x11, y11)) setCoverage11(tiledImage11.coverage, level11, x11, y11, true);
            else drawTile11 = true;
        }
        if (!drawTile11) return best11;
        positionTile11(tile11, tiledImage11.source.tileOverlap, tiledImage11.viewport, viewportCenter11, levelVisibility11, tiledImage11);
        if (!tile11.loaded) {
            if (tile11.context2D) setTileLoaded11(tiledImage11, tile11);
            else {
                var imageRecord11 = tiledImage11._tileCache.getImageRecord(tile11.cacheKey);
                if (imageRecord11) {
                    var image11 = imageRecord11.getImage();
                    setTileLoaded11(tiledImage11, tile11, image11);
                }
            }
        }
        if (tile11.loaded) {
            var needsDraw11 = blendTile11(tiledImage11, tile11, x11, y11, level11, levelOpacity11, currentTime11);
            if (needsDraw11) tiledImage11._needsDraw = true;
        } else if (tile11.loading) // the tile is already in the download queue
        tiledImage11._tilesLoading++;
        else if (!loadingCoverage11) best11 = compareTiles11(best11, tile11);
        return best11;
    }
    /**
 * @private
 * @inner
 * Obtains a tile at the given location.
 * @param {Number} x
 * @param {Number} y
 * @param {Number} level
 * @param {OpenSeadragon.TiledImage} tiledImage
 * @param {OpenSeadragon.TileSource} tileSource
 * @param {Object} tilesMatrix - A '3d' dictionary [level][x][y] --> Tile.
 * @param {Number} time
 * @param {Number} numTiles
 * @param {Number} worldWidth
 * @param {Number} worldHeight
 * @returns {OpenSeadragon.Tile}
 */ function getTile11(x11, y11, level11, tiledImage11, tileSource11, tilesMatrix11, time11, numTiles11, worldWidth11, worldHeight11) {
        var xMod11, yMod11, bounds11, sourceBounds11, exists11, url11, ajaxHeaders11, context2D11, tile11;
        if (!tilesMatrix11[level11]) tilesMatrix11[level11] = {};
        if (!tilesMatrix11[level11][x11]) tilesMatrix11[level11][x11] = {};
        if (!tilesMatrix11[level11][x11][y11]) {
            xMod11 = (numTiles11.x + x11 % numTiles11.x) % numTiles11.x;
            yMod11 = (numTiles11.y + y11 % numTiles11.y) % numTiles11.y;
            bounds11 = tileSource11.getTileBounds(level11, xMod11, yMod11);
            sourceBounds11 = tileSource11.getTileBounds(level11, xMod11, yMod11, true);
            exists11 = tileSource11.tileExists(level11, xMod11, yMod11);
            url11 = tileSource11.getTileUrl(level11, xMod11, yMod11);
            // Headers are only applicable if loadTilesWithAjax is set
            if (tiledImage11.loadTilesWithAjax) {
                ajaxHeaders11 = tileSource11.getTileAjaxHeaders(level11, xMod11, yMod11);
                // Combine tile AJAX headers with tiled image AJAX headers (if applicable)
                if ($11.isPlainObject(tiledImage11.ajaxHeaders)) ajaxHeaders11 = $11.extend({}, tiledImage11.ajaxHeaders, ajaxHeaders11);
            } else ajaxHeaders11 = null;
            context2D11 = tileSource11.getContext2D ? tileSource11.getContext2D(level11, xMod11, yMod11) : undefined;
            bounds11.x += (x11 - xMod11) / numTiles11.x;
            bounds11.y += worldHeight11 / worldWidth11 * ((y11 - yMod11) / numTiles11.y);
            tile11 = new $11.Tile(level11, x11, y11, bounds11, exists11, url11, context2D11, tiledImage11.loadTilesWithAjax, ajaxHeaders11, sourceBounds11);
            if (xMod11 === numTiles11.x - 1) tile11.isRightMost = true;
            if (yMod11 === numTiles11.y - 1) tile11.isBottomMost = true;
            tilesMatrix11[level11][x11][y11] = tile11;
        }
        tile11 = tilesMatrix11[level11][x11][y11];
        tile11.lastTouchTime = time11;
        return tile11;
    }
    /**
 * @private
 * @inner
 * Dispatch a job to the ImageLoader to load the Image for a Tile.
 * @param {OpenSeadragon.TiledImage} tiledImage
 * @param {OpenSeadragon.Tile} tile
 * @param {Number} time
 */ function loadTile11(tiledImage11, tile11, time11) {
        tile11.loading = true;
        tiledImage11._imageLoader.addJob({
            src: tile11.url,
            loadWithAjax: tile11.loadWithAjax,
            ajaxHeaders: tile11.ajaxHeaders,
            crossOriginPolicy: tiledImage11.crossOriginPolicy,
            ajaxWithCredentials: tiledImage11.ajaxWithCredentials,
            callback: function(image11, errorMsg11, tileRequest11) {
                onTileLoad11(tiledImage11, tile11, time11, image11, errorMsg11, tileRequest11);
            },
            abort: function() {
                tile11.loading = false;
            }
        });
    }
    /**
 * @private
 * @inner
 * Callback fired when a Tile's Image finished downloading.
 * @param {OpenSeadragon.TiledImage} tiledImage
 * @param {OpenSeadragon.Tile} tile
 * @param {Number} time
 * @param {Image} image
 * @param {String} errorMsg
 * @param {XMLHttpRequest} tileRequest
 */ function onTileLoad11(tiledImage11, tile11, time11, image11, errorMsg11, tileRequest11) {
        if (!image11) {
            $11.console.log("Tile %s failed to load: %s - error: %s", tile11, tile11.url, errorMsg11);
            /**
         * Triggered when a tile fails to load.
         *
         * @event tile-load-failed
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Tile} tile - The tile that failed to load.
         * @property {OpenSeadragon.TiledImage} tiledImage - The tiled image the tile belongs to.
         * @property {number} time - The time in milliseconds when the tile load began.
         * @property {string} message - The error message.
         * @property {XMLHttpRequest} tileRequest - The XMLHttpRequest used to load the tile if available.
         */ tiledImage11.viewer.raiseEvent("tile-load-failed", {
                tile: tile11,
                tiledImage: tiledImage11,
                time: time11,
                message: errorMsg11,
                tileRequest: tileRequest11
            });
            tile11.loading = false;
            tile11.exists = false;
            return;
        }
        if (time11 < tiledImage11.lastResetTime) {
            $11.console.log("Ignoring tile %s loaded before reset: %s", tile11, tile11.url);
            tile11.loading = false;
            return;
        }
        var finish11 = function() {
            var cutoff11 = tiledImage11.source.getClosestLevel();
            setTileLoaded11(tiledImage11, tile11, image11, cutoff11, tileRequest11);
        };
        // Check if we're mid-update; this can happen on IE8 because image load events for
        // cached images happen immediately there
        if (!tiledImage11._midDraw) finish11();
        else // Wait until after the update, in case caching unloads any tiles
        window.setTimeout(finish11, 1);
    }
    /**
 * @private
 * @inner
 * @param {OpenSeadragon.TiledImage} tiledImage
 * @param {OpenSeadragon.Tile} tile
 * @param {Image} image
 * @param {Number} cutoff
 */ function setTileLoaded11(tiledImage11, tile11, image11, cutoff11, tileRequest11) {
        var increment11 = 0;
        function getCompletionCallback11() {
            increment11++;
            return completionCallback11;
        }
        function completionCallback11() {
            increment11--;
            if (increment11 === 0) {
                tile11.loading = false;
                tile11.loaded = true;
                if (!tile11.context2D) tiledImage11._tileCache.cacheTile({
                    image: image11,
                    tile: tile11,
                    cutoff: cutoff11,
                    tiledImage: tiledImage11
                });
                tiledImage11._needsDraw = true;
            }
        }
        /**
     * Triggered when a tile has just been loaded in memory. That means that the
     * image has been downloaded and can be modified before being drawn to the canvas.
     *
     * @event tile-loaded
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {Image} image - The image of the tile.
     * @property {OpenSeadragon.TiledImage} tiledImage - The tiled image of the loaded tile.
     * @property {OpenSeadragon.Tile} tile - The tile which has been loaded.
     * @property {XMLHttpRequest} tiledImage - The AJAX request that loaded this tile (if applicable).
     * @property {function} getCompletionCallback - A function giving a callback to call
     * when the asynchronous processing of the image is done. The image will be
     * marked as entirely loaded when the callback has been called once for each
     * call to getCompletionCallback.
     */ tiledImage11.viewer.raiseEvent("tile-loaded", {
            tile: tile11,
            tiledImage: tiledImage11,
            tileRequest: tileRequest11,
            image: image11,
            getCompletionCallback: getCompletionCallback11
        });
        // In case the completion callback is never called, we at least force it once.
        getCompletionCallback11()();
    }
    /**
 * @private
 * @inner
 * @param {OpenSeadragon.Tile} tile
 * @param {Boolean} overlap
 * @param {OpenSeadragon.Viewport} viewport
 * @param {OpenSeadragon.Point} viewportCenter
 * @param {Number} levelVisibility
 * @param {OpenSeadragon.TiledImage} tiledImage
 */ function positionTile11(tile11, overlap11, viewport11, viewportCenter11, levelVisibility11, tiledImage11) {
        var boundsTL11 = tile11.bounds.getTopLeft();
        boundsTL11.x *= tiledImage11._scaleSpring.current.value;
        boundsTL11.y *= tiledImage11._scaleSpring.current.value;
        boundsTL11.x += tiledImage11._xSpring.current.value;
        boundsTL11.y += tiledImage11._ySpring.current.value;
        var boundsSize11 = tile11.bounds.getSize();
        boundsSize11.x *= tiledImage11._scaleSpring.current.value;
        boundsSize11.y *= tiledImage11._scaleSpring.current.value;
        var positionC11 = viewport11.pixelFromPointNoRotate(boundsTL11, true), positionT11 = viewport11.pixelFromPointNoRotate(boundsTL11, false), sizeC11 = viewport11.deltaPixelsFromPointsNoRotate(boundsSize11, true), sizeT11 = viewport11.deltaPixelsFromPointsNoRotate(boundsSize11, false), tileCenter11 = positionT11.plus(sizeT11.divide(2)), tileSquaredDistance11 = viewportCenter11.squaredDistanceTo(tileCenter11);
        if (!overlap11) sizeC11 = sizeC11.plus(new $11.Point(1, 1));
        if (tile11.isRightMost && tiledImage11.wrapHorizontal) sizeC11.x += 0.75; // Otherwise Firefox and Safari show seams
        if (tile11.isBottomMost && tiledImage11.wrapVertical) sizeC11.y += 0.75; // Otherwise Firefox and Safari show seams
        tile11.position = positionC11;
        tile11.size = sizeC11;
        tile11.squaredDistance = tileSquaredDistance11;
        tile11.visibility = levelVisibility11;
    }
    /**
 * @private
 * @inner
 * Updates the opacity of a tile according to the time it has been on screen
 * to perform a fade-in.
 * Updates coverage once a tile is fully opaque.
 * Returns whether the fade-in has completed.
 *
 * @param {OpenSeadragon.TiledImage} tiledImage
 * @param {OpenSeadragon.Tile} tile
 * @param {Number} x
 * @param {Number} y
 * @param {Number} level
 * @param {Number} levelOpacity
 * @param {Number} currentTime
 * @returns {Boolean}
 */ function blendTile11(tiledImage11, tile11, x11, y11, level11, levelOpacity11, currentTime11) {
        var blendTimeMillis11 = 1000 * tiledImage11.blendTime, deltaTime11, opacity11;
        if (!tile11.blendStart) tile11.blendStart = currentTime11;
        deltaTime11 = currentTime11 - tile11.blendStart;
        opacity11 = blendTimeMillis11 ? Math.min(1, deltaTime11 / blendTimeMillis11) : 1;
        if (tiledImage11.alwaysBlend) opacity11 *= levelOpacity11;
        tile11.opacity = opacity11;
        tiledImage11.lastDrawn.push(tile11);
        if (opacity11 == 1) {
            setCoverage11(tiledImage11.coverage, level11, x11, y11, true);
            tiledImage11._hasOpaqueTile = true;
        } else if (deltaTime11 < blendTimeMillis11) return true;
        return false;
    }
    /**
 * @private
 * @inner
 * Returns true if the given tile provides coverage to lower-level tiles of
 * lower resolution representing the same content. If neither x nor y is
 * given, returns true if the entire visible level provides coverage.
 *
 * Note that out-of-bounds tiles provide coverage in this sense, since
 * there's no content that they would need to cover. Tiles at non-existent
 * levels that are within the image bounds, however, do not.
 *
 * @param {Object} coverage - A '3d' dictionary [level][x][y] --> Boolean.
 * @param {Number} level - The resolution level of the tile.
 * @param {Number} x - The X position of the tile.
 * @param {Number} y - The Y position of the tile.
 * @returns {Boolean}
 */ function providesCoverage11(coverage11, level11, x11, y11) {
        var rows11, cols11, i11, j11;
        if (!coverage11[level11]) return false;
        if (x11 === undefined || y11 === undefined) {
            rows11 = coverage11[level11];
            for(i11 in rows11)if (rows11.hasOwnProperty(i11)) {
                cols11 = rows11[i11];
                for(j11 in cols11){
                    if (cols11.hasOwnProperty(j11) && !cols11[j11]) return false;
                }
            }
            return true;
        }
        return coverage11[level11][x11] === undefined || coverage11[level11][x11][y11] === undefined || coverage11[level11][x11][y11] === true;
    }
    /**
 * @private
 * @inner
 * Returns true if the given tile is completely covered by higher-level
 * tiles of higher resolution representing the same content. If neither x
 * nor y is given, returns true if the entire visible level is covered.
 *
 * @param {Object} coverage - A '3d' dictionary [level][x][y] --> Boolean.
 * @param {Number} level - The resolution level of the tile.
 * @param {Number} x - The X position of the tile.
 * @param {Number} y - The Y position of the tile.
 * @returns {Boolean}
 */ function isCovered11(coverage11, level11, x11, y11) {
        if (x11 === undefined || y11 === undefined) return providesCoverage11(coverage11, level11 + 1);
        else return providesCoverage11(coverage11, level11 + 1, 2 * x11, 2 * y11) && providesCoverage11(coverage11, level11 + 1, 2 * x11, 2 * y11 + 1) && providesCoverage11(coverage11, level11 + 1, 2 * x11 + 1, 2 * y11) && providesCoverage11(coverage11, level11 + 1, 2 * x11 + 1, 2 * y11 + 1);
    }
    /**
 * @private
 * @inner
 * Sets whether the given tile provides coverage or not.
 *
 * @param {Object} coverage - A '3d' dictionary [level][x][y] --> Boolean.
 * @param {Number} level - The resolution level of the tile.
 * @param {Number} x - The X position of the tile.
 * @param {Number} y - The Y position of the tile.
 * @param {Boolean} covers - Whether the tile provides coverage.
 */ function setCoverage11(coverage11, level11, x11, y11, covers11) {
        if (!coverage11[level11]) {
            $11.console.warn("Setting coverage for a tile before its level's coverage has been reset: %s", level11);
            return;
        }
        if (!coverage11[level11][x11]) coverage11[level11][x11] = {};
        coverage11[level11][x11][y11] = covers11;
    }
    /**
 * @private
 * @inner
 * Resets coverage information for the given level. This should be called
 * after every draw routine. Note that at the beginning of the next draw
 * routine, coverage for every visible tile should be explicitly set.
 *
 * @param {Object} coverage - A '3d' dictionary [level][x][y] --> Boolean.
 * @param {Number} level - The resolution level of tiles to completely reset.
 */ function resetCoverage11(coverage11, level11) {
        coverage11[level11] = {};
    }
    /**
 * @private
 * @inner
 * Determines whether the 'last best' tile for the area is better than the
 * tile in question.
 *
 * @param {OpenSeadragon.Tile} previousBest
 * @param {OpenSeadragon.Tile} tile
 * @returns {OpenSeadragon.Tile} The new best tile.
 */ function compareTiles11(previousBest11, tile11) {
        if (!previousBest11) return tile11;
        if (tile11.visibility > previousBest11.visibility) return tile11;
        else if (tile11.visibility == previousBest11.visibility) {
            if (tile11.squaredDistance < previousBest11.squaredDistance) return tile11;
        }
        return previousBest11;
    }
    /**
 * @private
 * @inner
 * Draws a TiledImage.
 * @param {OpenSeadragon.TiledImage} tiledImage
 * @param {OpenSeadragon.Tile[]} lastDrawn - An unordered list of Tiles drawn last frame.
 */ function drawTiles11(tiledImage11, lastDrawn11) {
        if (tiledImage11.opacity === 0 || lastDrawn11.length === 0 && !tiledImage11.placeholderFillStyle) return;
        var tile11 = lastDrawn11[0];
        var useSketch11;
        if (tile11) useSketch11 = tiledImage11.opacity < 1 || tiledImage11.compositeOperation && tiledImage11.compositeOperation !== "source-over" || !tiledImage11._isBottomItem() && tile11._hasTransparencyChannel();
        var sketchScale11;
        var sketchTranslate11;
        var zoom11 = tiledImage11.viewport.getZoom(true);
        var imageZoom11 = tiledImage11.viewportToImageZoom(zoom11);
        if (lastDrawn11.length > 1 && imageZoom11 > tiledImage11.smoothTileEdgesMinZoom && !tiledImage11.iOSDevice && tiledImage11.getRotation(true) % 360 === 0 && // TODO: support tile edge smoothing with tiled image rotation.
        $11.supportsCanvas) {
            // When zoomed in a lot (>100%) the tile edges are visible.
            // So we have to composite them at ~100% and scale them up together.
            // Note: Disabled on iOS devices per default as it causes a native crash
            useSketch11 = true;
            sketchScale11 = tile11.getScaleForEdgeSmoothing();
            sketchTranslate11 = tile11.getTranslationForEdgeSmoothing(sketchScale11, tiledImage11._drawer.getCanvasSize(false), tiledImage11._drawer.getCanvasSize(true));
        }
        var bounds11;
        if (useSketch11) {
            if (!sketchScale11) // Except when edge smoothing, we only clean the part of the
            // sketch canvas we are going to use for performance reasons.
            bounds11 = tiledImage11.viewport.viewportToViewerElementRectangle(tiledImage11.getClippedBounds(true)).getIntegerBoundingBox().times($11.pixelDensityRatio);
            tiledImage11._drawer._clear(true, bounds11);
        }
        // When scaling, we must rotate only when blending the sketch canvas to
        // avoid interpolation
        if (!sketchScale11) {
            if (tiledImage11.viewport.degrees !== 0) tiledImage11._drawer._offsetForRotation({
                degrees: tiledImage11.viewport.degrees,
                useSketch: useSketch11
            });
            else if (tiledImage11._drawer.viewer.viewport.flipped) tiledImage11._drawer._flip({});
            if (tiledImage11.getRotation(true) % 360 !== 0) tiledImage11._drawer._offsetForRotation({
                degrees: tiledImage11.getRotation(true),
                point: tiledImage11.viewport.pixelFromPointNoRotate(tiledImage11._getRotationPoint(true), true),
                useSketch: useSketch11
            });
        }
        var usedClip11 = false;
        if (tiledImage11._clip) {
            tiledImage11._drawer.saveContext(useSketch11);
            var box11 = tiledImage11.imageToViewportRectangle(tiledImage11._clip, true);
            box11 = box11.rotate(-tiledImage11.getRotation(true), tiledImage11._getRotationPoint(true));
            var clipRect11 = tiledImage11._drawer.viewportToDrawerRectangle(box11);
            if (sketchScale11) clipRect11 = clipRect11.times(sketchScale11);
            if (sketchTranslate11) clipRect11 = clipRect11.translate(sketchTranslate11);
            tiledImage11._drawer.setClip(clipRect11, useSketch11);
            usedClip11 = true;
        }
        if (tiledImage11.placeholderFillStyle && tiledImage11._hasOpaqueTile === false) {
            var placeholderRect11 = tiledImage11._drawer.viewportToDrawerRectangle(tiledImage11.getBounds(true));
            if (sketchScale11) placeholderRect11 = placeholderRect11.times(sketchScale11);
            if (sketchTranslate11) placeholderRect11 = placeholderRect11.translate(sketchTranslate11);
            var fillStyle11 = null;
            if (typeof tiledImage11.placeholderFillStyle === "function") fillStyle11 = tiledImage11.placeholderFillStyle(tiledImage11, tiledImage11._drawer.context);
            else fillStyle11 = tiledImage11.placeholderFillStyle;
            tiledImage11._drawer.drawRectangle(placeholderRect11, fillStyle11, useSketch11);
        }
        for(var i11 = lastDrawn11.length - 1; i11 >= 0; i11--){
            tile11 = lastDrawn11[i11];
            tiledImage11._drawer.drawTile(tile11, tiledImage11._drawingHandler, useSketch11, sketchScale11, sketchTranslate11);
            tile11.beingDrawn = true;
            if (tiledImage11.viewer) /**
             * <em>- Needs documentation -</em>
             *
             * @event tile-drawn
             * @memberof OpenSeadragon.Viewer
             * @type {object}
             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
             * @property {OpenSeadragon.TiledImage} tiledImage - Which TiledImage is being drawn.
             * @property {OpenSeadragon.Tile} tile
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */ tiledImage11.viewer.raiseEvent("tile-drawn", {
                tiledImage: tiledImage11,
                tile: tile11
            });
        }
        if (usedClip11) tiledImage11._drawer.restoreContext(useSketch11);
        if (!sketchScale11) {
            if (tiledImage11.getRotation(true) % 360 !== 0) tiledImage11._drawer._restoreRotationChanges(useSketch11);
            if (tiledImage11.viewport.degrees !== 0) tiledImage11._drawer._restoreRotationChanges(useSketch11);
            else if (tiledImage11._drawer.viewer.viewport.flipped) tiledImage11._drawer._flip({});
        }
        if (useSketch11) {
            if (sketchScale11) {
                if (tiledImage11.viewport.degrees !== 0) tiledImage11._drawer._offsetForRotation({
                    degrees: tiledImage11.viewport.degrees,
                    useSketch: false
                });
                if (tiledImage11.getRotation(true) % 360 !== 0) tiledImage11._drawer._offsetForRotation({
                    degrees: tiledImage11.getRotation(true),
                    point: tiledImage11.viewport.pixelFromPointNoRotate(tiledImage11._getRotationPoint(true), true),
                    useSketch: false
                });
            }
            tiledImage11._drawer.blendSketch({
                opacity: tiledImage11.opacity,
                scale: sketchScale11,
                translate: sketchTranslate11,
                compositeOperation: tiledImage11.compositeOperation,
                bounds: bounds11
            });
            if (sketchScale11) {
                if (tiledImage11.getRotation(true) % 360 !== 0) tiledImage11._drawer._restoreRotationChanges(false);
                if (tiledImage11.viewport.degrees !== 0) tiledImage11._drawer._restoreRotationChanges(false);
            }
        }
        drawDebugInfo11(tiledImage11, lastDrawn11);
    }
    /**
 * @private
 * @inner
 * Draws special debug information for a TiledImage if in debug mode.
 * @param {OpenSeadragon.TiledImage} tiledImage
 * @param {OpenSeadragon.Tile[]} lastDrawn - An unordered list of Tiles drawn last frame.
 */ function drawDebugInfo11(tiledImage11, lastDrawn11) {
        if (tiledImage11.debugMode) for(var i11 = lastDrawn11.length - 1; i11 >= 0; i11--){
            var tile11 = lastDrawn11[i11];
            try {
                tiledImage11._drawer.drawDebugInfo(tile11, lastDrawn11.length, i11, tiledImage11);
            } catch (e11) {
                $11.console.error(e11);
            }
        }
    }
})(OpenSeadragon);
/*
 * OpenSeadragon - TileCache
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    // private class
    var TileRecord11 = function(options11) {
        $11.console.assert(options11, "[TileCache.cacheTile] options is required");
        $11.console.assert(options11.tile, "[TileCache.cacheTile] options.tile is required");
        $11.console.assert(options11.tiledImage, "[TileCache.cacheTile] options.tiledImage is required");
        this.tile = options11.tile;
        this.tiledImage = options11.tiledImage;
    };
    // private class
    var ImageRecord11 = function(options11) {
        $11.console.assert(options11, "[ImageRecord] options is required");
        $11.console.assert(options11.image, "[ImageRecord] options.image is required");
        this._image = options11.image;
        this._tiles = [];
    };
    ImageRecord11.prototype = {
        destroy: function() {
            this._image = null;
            this._renderedContext = null;
            this._tiles = null;
        },
        getImage: function() {
            return this._image;
        },
        getRenderedContext: function() {
            if (!this._renderedContext) {
                var canvas11 = document.createElement("canvas");
                canvas11.width = this._image.width;
                canvas11.height = this._image.height;
                this._renderedContext = canvas11.getContext("2d");
                this._renderedContext.drawImage(this._image, 0, 0);
                //since we are caching the prerendered image on a canvas
                //allow the image to not be held in memory
                this._image = null;
            }
            return this._renderedContext;
        },
        setRenderedContext: function(renderedContext11) {
            $11.console.error("ImageRecord.setRenderedContext is deprecated. The rendered context should be created by the ImageRecord itself when calling ImageRecord.getRenderedContext.");
            this._renderedContext = renderedContext11;
        },
        addTile: function(tile11) {
            $11.console.assert(tile11, "[ImageRecord.addTile] tile is required");
            this._tiles.push(tile11);
        },
        removeTile: function(tile11) {
            for(var i11 = 0; i11 < this._tiles.length; i11++)if (this._tiles[i11] === tile11) {
                this._tiles.splice(i11, 1);
                return;
            }
            $11.console.warn("[ImageRecord.removeTile] trying to remove unknown tile", tile11);
        },
        getTileCount: function() {
            return this._tiles.length;
        }
    };
    /**
 * @class TileCache
 * @memberof OpenSeadragon
 * @classdesc Stores all the tiles displayed in a {@link OpenSeadragon.Viewer}.
 * You generally won't have to interact with the TileCache directly.
 * @param {Object} options - Configuration for this TileCache.
 * @param {Number} [options.maxImageCacheCount] - See maxImageCacheCount in
 * {@link OpenSeadragon.Options} for details.
 */ $11.TileCache = function(options11) {
        options11 = options11 || {};
        this._maxImageCacheCount = options11.maxImageCacheCount || $11.DEFAULT_SETTINGS.maxImageCacheCount;
        this._tilesLoaded = [];
        this._imagesLoaded = [];
        this._imagesLoadedCount = 0;
    };
    /** @lends OpenSeadragon.TileCache.prototype */ $11.TileCache.prototype = {
        /**
     * @returns {Number} The total number of tiles that have been loaded by
     * this TileCache.
     */ numTilesLoaded: function() {
            return this._tilesLoaded.length;
        },
        /**
     * Caches the specified tile, removing an old tile if necessary to stay under the
     * maxImageCacheCount specified on construction. Note that if multiple tiles reference
     * the same image, there may be more tiles than maxImageCacheCount; the goal is to keep
     * the number of images below that number. Note, as well, that even the number of images
     * may temporarily surpass that number, but should eventually come back down to the max specified.
     * @param {Object} options - Tile info.
     * @param {OpenSeadragon.Tile} options.tile - The tile to cache.
     * @param {String} options.tile.cacheKey - The unique key used to identify this tile in the cache.
     * @param {Image} options.image - The image of the tile to cache.
     * @param {OpenSeadragon.TiledImage} options.tiledImage - The TiledImage that owns that tile.
     * @param {Number} [options.cutoff=0] - If adding this tile goes over the cache max count, this
     * function will release an old tile. The cutoff option specifies a tile level at or below which
     * tiles will not be released.
     */ cacheTile: function(options11) {
            $11.console.assert(options11, "[TileCache.cacheTile] options is required");
            $11.console.assert(options11.tile, "[TileCache.cacheTile] options.tile is required");
            $11.console.assert(options11.tile.cacheKey, "[TileCache.cacheTile] options.tile.cacheKey is required");
            $11.console.assert(options11.tiledImage, "[TileCache.cacheTile] options.tiledImage is required");
            var cutoff11 = options11.cutoff || 0;
            var insertionIndex11 = this._tilesLoaded.length;
            var imageRecord11 = this._imagesLoaded[options11.tile.cacheKey];
            if (!imageRecord11) {
                $11.console.assert(options11.image, "[TileCache.cacheTile] options.image is required to create an ImageRecord");
                imageRecord11 = this._imagesLoaded[options11.tile.cacheKey] = new ImageRecord11({
                    image: options11.image
                });
                this._imagesLoadedCount++;
            }
            imageRecord11.addTile(options11.tile);
            options11.tile.cacheImageRecord = imageRecord11;
            // Note that just because we're unloading a tile doesn't necessarily mean
            // we're unloading an image. With repeated calls it should sort itself out, though.
            if (this._imagesLoadedCount > this._maxImageCacheCount) {
                var worstTile11 = null;
                var worstTileIndex11 = -1;
                var worstTileRecord11 = null;
                var prevTile11, worstTime11, worstLevel11, prevTime11, prevLevel11, prevTileRecord11;
                for(var i11 = this._tilesLoaded.length - 1; i11 >= 0; i11--){
                    prevTileRecord11 = this._tilesLoaded[i11];
                    prevTile11 = prevTileRecord11.tile;
                    if (prevTile11.level <= cutoff11 || prevTile11.beingDrawn) continue;
                    else if (!worstTile11) {
                        worstTile11 = prevTile11;
                        worstTileIndex11 = i11;
                        worstTileRecord11 = prevTileRecord11;
                        continue;
                    }
                    prevTime11 = prevTile11.lastTouchTime;
                    worstTime11 = worstTile11.lastTouchTime;
                    prevLevel11 = prevTile11.level;
                    worstLevel11 = worstTile11.level;
                    if (prevTime11 < worstTime11 || prevTime11 == worstTime11 && prevLevel11 > worstLevel11) {
                        worstTile11 = prevTile11;
                        worstTileIndex11 = i11;
                        worstTileRecord11 = prevTileRecord11;
                    }
                }
                if (worstTile11 && worstTileIndex11 >= 0) {
                    this._unloadTile(worstTileRecord11);
                    insertionIndex11 = worstTileIndex11;
                }
            }
            this._tilesLoaded[insertionIndex11] = new TileRecord11({
                tile: options11.tile,
                tiledImage: options11.tiledImage
            });
        },
        /**
     * Clears all tiles associated with the specified tiledImage.
     * @param {OpenSeadragon.TiledImage} tiledImage
     */ clearTilesFor: function(tiledImage11) {
            $11.console.assert(tiledImage11, "[TileCache.clearTilesFor] tiledImage is required");
            var tileRecord11;
            for(var i11 = 0; i11 < this._tilesLoaded.length; ++i11){
                tileRecord11 = this._tilesLoaded[i11];
                if (tileRecord11.tiledImage === tiledImage11) {
                    this._unloadTile(tileRecord11);
                    this._tilesLoaded.splice(i11, 1);
                    i11--;
                }
            }
        },
        // private
        getImageRecord: function(cacheKey11) {
            $11.console.assert(cacheKey11, "[TileCache.getImageRecord] cacheKey is required");
            return this._imagesLoaded[cacheKey11];
        },
        // private
        _unloadTile: function(tileRecord11) {
            $11.console.assert(tileRecord11, "[TileCache._unloadTile] tileRecord is required");
            var tile11 = tileRecord11.tile;
            var tiledImage11 = tileRecord11.tiledImage;
            tile11.unload();
            tile11.cacheImageRecord = null;
            var imageRecord11 = this._imagesLoaded[tile11.cacheKey];
            imageRecord11.removeTile(tile11);
            if (!imageRecord11.getTileCount()) {
                imageRecord11.destroy();
                delete this._imagesLoaded[tile11.cacheKey];
                this._imagesLoadedCount--;
            }
            /**
         * Triggered when a tile has just been unloaded from memory.
         *
         * @event tile-unloaded
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.TiledImage} tiledImage - The tiled image of the unloaded tile.
         * @property {OpenSeadragon.Tile} tile - The tile which has been unloaded.
         */ tiledImage11.viewer.raiseEvent("tile-unloaded", {
                tile: tile11,
                tiledImage: tiledImage11
            });
        }
    };
})(OpenSeadragon);
/*
 * OpenSeadragon - World
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ (function($11) {
    /**
 * @class World
 * @memberof OpenSeadragon
 * @extends OpenSeadragon.EventSource
 * @classdesc Keeps track of all of the tiled images in the scene.
 * @param {Object} options - World options.
 * @param {OpenSeadragon.Viewer} options.viewer - The Viewer that owns this World.
 **/ $11.World = function(options11) {
        var _this11 = this;
        $11.console.assert(options11.viewer, "[World] options.viewer is required");
        $11.EventSource.call(this);
        this.viewer = options11.viewer;
        this._items = [];
        this._needsDraw = false;
        this._autoRefigureSizes = true;
        this._needsSizesFigured = false;
        this._delegatedFigureSizes = function(event11) {
            if (_this11._autoRefigureSizes) _this11._figureSizes();
            else _this11._needsSizesFigured = true;
        };
        this._figureSizes();
    };
    $11.extend($11.World.prototype, $11.EventSource.prototype, /** @lends OpenSeadragon.World.prototype */ {
        /**
     * Add the specified item.
     * @param {OpenSeadragon.TiledImage} item - The item to add.
     * @param {Number} [options.index] - Index for the item. If not specified, goes at the top.
     * @fires OpenSeadragon.World.event:add-item
     * @fires OpenSeadragon.World.event:metrics-change
     */ addItem: function(item11, options11) {
            $11.console.assert(item11, "[World.addItem] item is required");
            $11.console.assert(item11 instanceof $11.TiledImage, "[World.addItem] only TiledImages supported at this time");
            options11 = options11 || {};
            if (options11.index !== undefined) {
                var index11 = Math.max(0, Math.min(this._items.length, options11.index));
                this._items.splice(index11, 0, item11);
            } else this._items.push(item11);
            if (this._autoRefigureSizes) this._figureSizes();
            else this._needsSizesFigured = true;
            this._needsDraw = true;
            item11.addHandler("bounds-change", this._delegatedFigureSizes);
            item11.addHandler("clip-change", this._delegatedFigureSizes);
            /**
         * Raised when an item is added to the World.
         * @event add-item
         * @memberOf OpenSeadragon.World
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the World which raised the event.
         * @property {OpenSeadragon.TiledImage} item - The item that has been added.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */ this.raiseEvent("add-item", {
                item: item11
            });
        },
        /**
     * Get the item at the specified index.
     * @param {Number} index - The item's index.
     * @returns {OpenSeadragon.TiledImage} The item at the specified index.
     */ getItemAt: function(index11) {
            $11.console.assert(index11 !== undefined, "[World.getItemAt] index is required");
            return this._items[index11];
        },
        /**
     * Get the index of the given item or -1 if not present.
     * @param {OpenSeadragon.TiledImage} item - The item.
     * @returns {Number} The index of the item or -1 if not present.
     */ getIndexOfItem: function(item11) {
            $11.console.assert(item11, "[World.getIndexOfItem] item is required");
            return $11.indexOf(this._items, item11);
        },
        /**
     * @returns {Number} The number of items used.
     */ getItemCount: function() {
            return this._items.length;
        },
        /**
     * Change the index of a item so that it appears over or under others.
     * @param {OpenSeadragon.TiledImage} item - The item to move.
     * @param {Number} index - The new index.
     * @fires OpenSeadragon.World.event:item-index-change
     */ setItemIndex: function(item11, index11) {
            $11.console.assert(item11, "[World.setItemIndex] item is required");
            $11.console.assert(index11 !== undefined, "[World.setItemIndex] index is required");
            var oldIndex11 = this.getIndexOfItem(item11);
            if (index11 >= this._items.length) throw new Error("Index bigger than number of layers.");
            if (index11 === oldIndex11 || oldIndex11 === -1) return;
            this._items.splice(oldIndex11, 1);
            this._items.splice(index11, 0, item11);
            this._needsDraw = true;
            /**
         * Raised when the order of the indexes has been changed.
         * @event item-index-change
         * @memberOf OpenSeadragon.World
         * @type {object}
         * @property {OpenSeadragon.World} eventSource - A reference to the World which raised the event.
         * @property {OpenSeadragon.TiledImage} item - The item whose index has
         * been changed
         * @property {Number} previousIndex - The previous index of the item
         * @property {Number} newIndex - The new index of the item
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */ this.raiseEvent("item-index-change", {
                item: item11,
                previousIndex: oldIndex11,
                newIndex: index11
            });
        },
        /**
     * Remove an item.
     * @param {OpenSeadragon.TiledImage} item - The item to remove.
     * @fires OpenSeadragon.World.event:remove-item
     * @fires OpenSeadragon.World.event:metrics-change
     */ removeItem: function(item11) {
            $11.console.assert(item11, "[World.removeItem] item is required");
            var index11 = $11.indexOf(this._items, item11);
            if (index11 === -1) return;
            item11.removeHandler("bounds-change", this._delegatedFigureSizes);
            item11.removeHandler("clip-change", this._delegatedFigureSizes);
            item11.destroy();
            this._items.splice(index11, 1);
            this._figureSizes();
            this._needsDraw = true;
            this._raiseRemoveItem(item11);
        },
        /**
     * Remove all items.
     * @fires OpenSeadragon.World.event:remove-item
     * @fires OpenSeadragon.World.event:metrics-change
     */ removeAll: function() {
            // We need to make sure any pending images are canceled so the world items don't get messed up
            this.viewer._cancelPendingImages();
            var item11;
            var i11;
            for(i11 = 0; i11 < this._items.length; i11++){
                item11 = this._items[i11];
                item11.removeHandler("bounds-change", this._delegatedFigureSizes);
                item11.removeHandler("clip-change", this._delegatedFigureSizes);
                item11.destroy();
            }
            var removedItems11 = this._items;
            this._items = [];
            this._figureSizes();
            this._needsDraw = true;
            for(i11 = 0; i11 < removedItems11.length; i11++){
                item11 = removedItems11[i11];
                this._raiseRemoveItem(item11);
            }
        },
        /**
     * Clears all tiles and triggers updates for all items.
     */ resetItems: function() {
            for(var i11 = 0; i11 < this._items.length; i11++)this._items[i11].reset();
        },
        /**
     * Updates (i.e. animates bounds of) all items.
     */ update: function() {
            var animated11 = false;
            for(var i11 = 0; i11 < this._items.length; i11++)animated11 = this._items[i11].update() || animated11;
            return animated11;
        },
        /**
     * Draws all items.
     */ draw: function() {
            for(var i11 = 0; i11 < this._items.length; i11++)this._items[i11].draw();
            this._needsDraw = false;
        },
        /**
     * @returns {Boolean} true if any items need updating.
     */ needsDraw: function() {
            for(var i11 = 0; i11 < this._items.length; i11++){
                if (this._items[i11].needsDraw()) return true;
            }
            return this._needsDraw;
        },
        /**
     * @returns {OpenSeadragon.Rect} The smallest rectangle that encloses all items, in viewport coordinates.
     */ getHomeBounds: function() {
            return this._homeBounds.clone();
        },
        /**
     * To facilitate zoom constraints, we keep track of the pixel density of the
     * densest item in the World (i.e. the item whose content size to viewport size
     * ratio is the highest) and save it as this "content factor".
     * @returns {Number} the number of content units per viewport unit.
     */ getContentFactor: function() {
            return this._contentFactor;
        },
        /**
     * As a performance optimization, setting this flag to false allows the bounds-change event handler
     * on tiledImages to skip calculations on the world bounds. If a lot of images are going to be positioned in
     * rapid succession, this is a good idea. When finished, setAutoRefigureSizes should be called with true
     * or the system may behave oddly.
     * @param {Boolean} [value] The value to which to set the flag.
     */ setAutoRefigureSizes: function(value11) {
            this._autoRefigureSizes = value11;
            if (value11 & this._needsSizesFigured) {
                this._figureSizes();
                this._needsSizesFigured = false;
            }
        },
        /**
     * Arranges all of the TiledImages with the specified settings.
     * @param {Object} options - Specifies how to arrange.
     * @param {Boolean} [options.immediately=false] - Whether to animate to the new arrangement.
     * @param {String} [options.layout] - See collectionLayout in {@link OpenSeadragon.Options}.
     * @param {Number} [options.rows] - See collectionRows in {@link OpenSeadragon.Options}.
     * @param {Number} [options.columns] - See collectionColumns in {@link OpenSeadragon.Options}.
     * @param {Number} [options.tileSize] - See collectionTileSize in {@link OpenSeadragon.Options}.
     * @param {Number} [options.tileMargin] - See collectionTileMargin in {@link OpenSeadragon.Options}.
     * @fires OpenSeadragon.World.event:metrics-change
     */ arrange: function(options11) {
            options11 = options11 || {};
            var immediately11 = options11.immediately || false;
            var layout11 = options11.layout || $11.DEFAULT_SETTINGS.collectionLayout;
            var rows11 = options11.rows || $11.DEFAULT_SETTINGS.collectionRows;
            var columns11 = options11.columns || $11.DEFAULT_SETTINGS.collectionColumns;
            var tileSize11 = options11.tileSize || $11.DEFAULT_SETTINGS.collectionTileSize;
            var tileMargin11 = options11.tileMargin || $11.DEFAULT_SETTINGS.collectionTileMargin;
            var increment11 = tileSize11 + tileMargin11;
            var wrap11;
            if (!options11.rows && columns11) wrap11 = columns11;
            else wrap11 = Math.ceil(this._items.length / rows11);
            var x11 = 0;
            var y11 = 0;
            var item11, box11, width11, height11, position11;
            this.setAutoRefigureSizes(false);
            for(var i11 = 0; i11 < this._items.length; i11++){
                if (i11 && i11 % wrap11 === 0) {
                    if (layout11 === "horizontal") {
                        y11 += increment11;
                        x11 = 0;
                    } else {
                        x11 += increment11;
                        y11 = 0;
                    }
                }
                item11 = this._items[i11];
                box11 = item11.getBounds();
                if (box11.width > box11.height) width11 = tileSize11;
                else width11 = tileSize11 * (box11.width / box11.height);
                height11 = width11 * (box11.height / box11.width);
                position11 = new $11.Point(x11 + (tileSize11 - width11) / 2, y11 + (tileSize11 - height11) / 2);
                item11.setPosition(position11, immediately11);
                item11.setWidth(width11, immediately11);
                if (layout11 === "horizontal") x11 += increment11;
                else y11 += increment11;
            }
            this.setAutoRefigureSizes(true);
        },
        // private
        _figureSizes: function() {
            var oldHomeBounds11 = this._homeBounds ? this._homeBounds.clone() : null;
            var oldContentSize11 = this._contentSize ? this._contentSize.clone() : null;
            var oldContentFactor11 = this._contentFactor || 0;
            if (!this._items.length) {
                this._homeBounds = new $11.Rect(0, 0, 1, 1);
                this._contentSize = new $11.Point(1, 1);
                this._contentFactor = 1;
            } else {
                var item11 = this._items[0];
                var bounds11 = item11.getBounds();
                this._contentFactor = item11.getContentSize().x / bounds11.width;
                var clippedBounds11 = item11.getClippedBounds().getBoundingBox();
                var left11 = clippedBounds11.x;
                var top11 = clippedBounds11.y;
                var right11 = clippedBounds11.x + clippedBounds11.width;
                var bottom11 = clippedBounds11.y + clippedBounds11.height;
                for(var i11 = 1; i11 < this._items.length; i11++){
                    item11 = this._items[i11];
                    bounds11 = item11.getBounds();
                    this._contentFactor = Math.max(this._contentFactor, item11.getContentSize().x / bounds11.width);
                    clippedBounds11 = item11.getClippedBounds().getBoundingBox();
                    left11 = Math.min(left11, clippedBounds11.x);
                    top11 = Math.min(top11, clippedBounds11.y);
                    right11 = Math.max(right11, clippedBounds11.x + clippedBounds11.width);
                    bottom11 = Math.max(bottom11, clippedBounds11.y + clippedBounds11.height);
                }
                this._homeBounds = new $11.Rect(left11, top11, right11 - left11, bottom11 - top11);
                this._contentSize = new $11.Point(this._homeBounds.width * this._contentFactor, this._homeBounds.height * this._contentFactor);
            }
            if (this._contentFactor !== oldContentFactor11 || !this._homeBounds.equals(oldHomeBounds11) || !this._contentSize.equals(oldContentSize11)) /**
             * Raised when the home bounds or content factor change.
             * @event metrics-change
             * @memberOf OpenSeadragon.World
             * @type {object}
             * @property {OpenSeadragon.World} eventSource - A reference to the World which raised the event.
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */ this.raiseEvent("metrics-change", {});
        },
        // private
        _raiseRemoveItem: function(item11) {
            /**
         * Raised when an item is removed.
         * @event remove-item
         * @memberOf OpenSeadragon.World
         * @type {object}
         * @property {OpenSeadragon.World} eventSource - A reference to the World which raised the event.
         * @property {OpenSeadragon.TiledImage} item - The item's underlying item.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */ this.raiseEvent("remove-item", {
                item: item11
            });
        }
    });
})(OpenSeadragon); //# sourceMappingURL=openseadragon.js.map

});

parcelRegister("6DzO8", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $iz60K = parcelRequire("iz60K");
function $4d52293a79bcab4c$var$emptyFunction() {}
function $4d52293a79bcab4c$var$emptyFunctionWithReset() {}
$4d52293a79bcab4c$var$emptyFunctionWithReset.resetWarningCache = $4d52293a79bcab4c$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $iz60K) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $4d52293a79bcab4c$var$emptyFunctionWithReset,
        resetWarningCache: $4d52293a79bcab4c$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("iz60K", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $d840288929500773$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $d840288929500773$var$ReactPropTypesSecret;

});


parcelRegister("6egII", function(module, exports) {
/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */ /* jshint unused: true, undef: true, strict: true */ (function(global, factory) {
    // universal module definition
    /* jshint strict: false */ /* globals define, module, window */ if (typeof define == "function" && define.amd) // AMD - RequireJS
    define(factory);
    else if (0, module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory();
    else // Browser globals
    global.EvEmitter = factory();
})(typeof window != "undefined" ? window : module.exports, function() {
    "use strict";
    function EvEmitter() {}
    var proto = EvEmitter.prototype;
    proto.on = function(eventName, listener) {
        if (!eventName || !listener) return;
        // set events hash
        var events = this._events = this._events || {};
        // set listeners array
        var listeners = events[eventName] = events[eventName] || [];
        // only add once
        if (listeners.indexOf(listener) == -1) listeners.push(listener);
        return this;
    };
    proto.once = function(eventName, listener) {
        if (!eventName || !listener) return;
        // add event
        this.on(eventName, listener);
        // set once flag
        // set onceEvents hash
        var onceEvents = this._onceEvents = this._onceEvents || {};
        // set onceListeners object
        var onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        // set flag
        onceListeners[listener] = true;
        return this;
    };
    proto.off = function(eventName, listener) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return;
        var index = listeners.indexOf(listener);
        if (index != -1) listeners.splice(index, 1);
        return this;
    };
    proto.emitEvent = function(eventName, args) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return;
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        var onceListeners = this._onceEvents && this._onceEvents[eventName];
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            var isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off(eventName, listener);
                // unset once flag
                delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
        }
        return this;
    };
    proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
    };
    return EvEmitter;
});

});

var $13f4c0370d7de649$exports = {};
"use strict";

$13f4c0370d7de649$exports = (parcelRequire("89wqa"));


parcelRequire("8NFma");
var $1c0f1e610963dfb8$exports = {};
"use strict";
function $1c0f1e610963dfb8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($1c0f1e610963dfb8$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$1c0f1e610963dfb8$var$checkDCE();

$1c0f1e610963dfb8$exports = (parcelRequire("23wBm"));




var $8NFma = parcelRequire("8NFma");
var $125d1ceb57662f9a$exports = {};

$125d1ceb57662f9a$exports = (parcelRequire("81tj9"));


var $2860f5f07c24e63c$export$2e2bcd8739ae039 = {
    objectIdQueryParameter: "mid",
    dev: {
        isLocal: false
    },
    api: {
        baseUrl: "https://api.dimu.org/",
        baseUrlImage: "https://mm.dimu.org/image/",
        baseUrlNkl: "https://nkl.snl.no/api/v1/search?query=",
        baseUrlSnl: "https://snl.no/api/v1/search?query=",
        baseUrlArtifact: "",
        key: "TXfNazNFTZO0P%2B2lfu9eTg",
        sort: "artifact.uniqueId",
        sortDirection: "asc",
        numberOfElements: 100
    },
    list: {
        numberOfElements: 25
    },
    categories: {
        numberOfElements: 4
    },
    sort: {
        relevance: "relevance",
        titleAsc: "title-asc",
        timeAsc: "time-asc",
        timeDesc: "time-desc",
        artistLastnameAsc: "artist-lastname-asc"
    },
    selectors: {
        numberOfHits: "#",
        category: "[c]",
        search: "[s]"
    },
    search: {
        minimumNumberOfChars: 3
    }
};


//Note: functions that access 'this' cannot be written as arrow functions

var $73b62b3ff22ff0bc$export$2e2bcd8739ae039 = {
    image: {
        getUrl: (item, size)=>{
            let dimensions = size === "max" ? "max" : size + "x" + size;
            return `${(0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.baseUrlImage}${item["artifact.defaultMediaIdentifier"]}?dimension=${dimensions}`;
        },
        getUrlDownload: (item, size)=>{
            let dimensions = size === "max" ? "max" : size + "x" + size;
            return `${(0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.baseUrlImage}${item["artifact.defaultMediaIdentifier"]}?dimension=${dimensions}&filename=${item["identifier.id"]}.jpg`;
        }
    },
    lists: {
        removeDuplicates: (array, prop)=>{
            return array.filter((obj, pos, arr)=>{
                return arr.map((mapObj)=>mapObj[prop]).indexOf(obj[prop]) === pos;
            });
        },
        shuffleArray: (array)=>{
            for(let i = array.length - 1; i > 0; i--){
                let j = Math.floor(Math.random() * (i + 1));
                [array[i], array[j]] = [
                    array[j],
                    array[i]
                ];
            }
        },
        removeTechnicFromTitle: function(array) {
            for(let i = 0; i < array.length; i++)this.removeTechnicFromTitleInItem(array[i]);
        },
        removeTechnicFromTitleInItem: (item)=>{
            let title = item["artifact.ingress.title"];
            let index = title.indexOf(" [");
            if (index > -1) {
                title = title.slice(0, index).trim();
                item["artifact.ingress.title"] = title;
            }
        },
        minAndMaxYearFromList: (array)=>{
            let min = parseInt(new Date().getFullYear());
            let max = 0;
            for(let i = 0; i < array.length; i++){
                const item = array[i];
                const year = item["artifact.ingress.production.toYear"];
                if (year < min) min = year;
                if (year > max) max = year;
            }
            return {
                min: min,
                max: max
            };
        },
        getCategoryFolderIds: (array)=>{
            let categoryFolders = [];
            for(let i = 0; i < array.length; i++){
                let item = array[i];
                if (item["artifact.type"] === "Folder" && item["artifact.pictureCount"] > 0) categoryFolders.push(item["artifact.uuid"]);
            }
            return "(" + categoryFolders.join(" OR ") + ")";
        },
        fixSearchResults: function(array, from, to) {
            let filtered = [];
            for(let i = 0; i < array.length; i++){
                let item = array[i];
                if (item["artifact.type"] === "Folder") continue;
                if (item["artifact.hasChildren"]) continue;
                if (!item["artifact.defaultMediaIdentifier"]) continue;
                this.removeTechnicFromTitleInItem(item);
                let year = item["artifact.ingress.production.toYear"];
                if (!!year && (year < from || to < year)) continue;
                filtered.push(item);
            }
            return filtered;
        },
        fixCategoryResults: function(array) {
            let filtered = [];
            for(let i = 0; i < array.length; i++){
                let item = array[i];
                if (item["artifact.hasChildren"]) continue;
                if (!item["artifact.defaultMediaIdentifier"]) continue;
                this.removeTechnicFromTitleInItem(item);
                filtered.push(item);
            }
            return filtered;
        }
    },
    objects: {
        isEmptyObject (obj) {
            return Object.keys(obj).length === 0;
        }
    },
    dom: {
        breadcrumb: {
            addLinkToSelf: ()=>{
                const currentLi = document.querySelector("nav.breadcrumb li.current");
                if (!currentLi) return;
                const text = currentLi.innerHTML;
                currentLi.innerHTML = "<a href='" + window.location.pathname + "'>" + text + "</a>";
            },
            addCategory: function(category) {
                this.removeCurrentCategory();
                const currentLi = document.querySelector("nav.breadcrumb li.current");
                if (!currentLi) return;
                const ul = currentLi.parentElement;
                const catLi = document.createElement("li");
                catLi.id = "current-category";
                catLi.className = "current";
                catLi.innerHTML = category.category;
                ul.appendChild(catLi);
            },
            removeCurrentCategory: ()=>{
                const elem = document.getElementById("current-category");
                if (!elem) return;
                elem.remove();
            }
        },
        setTitle: (props)=>{
            try {
                const title = props?.cmsData?.title ?? "";
                let producer = props?.item?.["artifact.ingress.producer"] ?? "";
                if (producer.indexOf(", ")) {
                    const split = producer.split(", ");
                    producer = split[1] + " " + split[0];
                }
                let artTitle = props?.item?.["artifact.ingress.title"] ?? "";
                if (artTitle.indexOf("[")) artTitle = artTitle.split("[")[0];
                document.title = `${title} - ${producer}: ${artTitle}`;
            } catch (error) {
                console.error(error);
            }
        }
    },
    url: {
        getParameterId: ()=>{
            var url = new URL(location.href);
            var id = url.searchParams.get((0, $2860f5f07c24e63c$export$2e2bcd8739ae039).objectIdQueryParameter);
            return id;
        },
        getUrlForItem: (item)=>{
            var id = item["identifier.id"];
            var url = new URL(location.href);
            url.searchParams.set((0, $2860f5f07c24e63c$export$2e2bcd8739ae039).objectIdQueryParameter, id);
            return "" + url;
        },
        getParameterIndex: function(items, slide, prioritizedImage) {
            const paramId = this.getParameterId();
            const id = paramId || prioritizedImage;
            if (!id) {
                this.setParameterId(items[slide]);
                return slide;
            }
            var index = -1;
            var item = items.find((elem, i)=>{
                index = i;
                return elem["identifier.id"] === id;
            });
            if (!item) {
                this.setParameterId(items[slide]);
                return slide;
            }
            this.setParameterId(item);
            return !item ? slide : index;
        },
        setParameterId: function(item) {
            if (!item) return;
            const id = item["identifier.id"];
            var url = new URL(location.href);
            url.searchParams.set((0, $2860f5f07c24e63c$export$2e2bcd8739ae039).objectIdQueryParameter, id);
            this.addParameterToShareButtons(id);
            const currentState = history.state;
            history.replaceState(currentState, null, url);
        },
        addParameterToShareButtons: (id)=>{
            const urlEncodedEqualSign = "%3d";
            const urlEncodedQuestionMark = "%3f";
            const parameter = `${urlEncodedQuestionMark}${(0, $2860f5f07c24e63c$export$2e2bcd8739ae039).objectIdQueryParameter}${urlEncodedEqualSign}${id}`;
            const links = document.querySelectorAll("[data-some-share-link]");
            if (links && links.length > 0) {
                var arr = [];
                for(var i = links.length; i--; arr.unshift(links[i])); //ie fix
                arr.forEach((item)=>{
                    let url = item.getAttribute("href");
                    const paramStart = `${urlEncodedQuestionMark}${(0, $2860f5f07c24e63c$export$2e2bcd8739ae039).objectIdQueryParameter}`;
                    const paramIndex = url.indexOf(paramStart);
                    url = paramIndex === -1 ? `${url}${parameter}` : `${url.slice(0, paramIndex)}${parameter}`;
                    item.setAttribute("href", url);
                });
            }
            const errorLinks = document.querySelectorAll("[data-report-error-link]");
            if (errorLinks && errorLinks.length > 0) {
                var errarr = [];
                for(var j = errorLinks.length; j--; errarr.unshift(errorLinks[j])); //ie fix
                errarr.forEach((item)=>{
                    let url = new URL(location.origin + item.getAttribute("href"));
                    url.searchParams.set((0, $2860f5f07c24e63c$export$2e2bcd8739ae039).objectIdQueryParameter, id);
                    item.setAttribute("href", url.href.replace(location.origin, ""));
                });
            }
        }
    }
};




var $b5af3106de28ce48$export$2e2bcd8739ae039 = {
    // https://api.dimu.org/api/solr/select?q=*&fq=identifier.owner:STO&wt=json&api.key=TXfNazNFTZO0P%2B2lfu9eTg&rows=100
    // https://api.dimu.org/api/solr/select?q=*&fq=identifier.owner:STO&wt=json&api.key=TXfNazNFTZO0P%2B2lfu9eTg&rows=100&fq=-artifact.type:Folder&fq=artifact.hasPictures:true&start=0
    getAll: (success, error, rows, start)=>{
        if ((0, $2860f5f07c24e63c$export$2e2bcd8739ae039).dev.isLocal) success((parcelRequire("6AbVD")));
        var url = `${(0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.baseUrl}api/solr/select?q=*&fq=identifier.owner:STO&fq=-artifact.type:Folder&fq=artifact.hasChildren:false&fq=artifact.hasPictures:true&wt=json&api.key=${(0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.key}&rows=${rows}&start=${start}&sort=${(0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.sort} ${(0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.sortDirection}&omitHeader=true`;
        (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).get(url).then(function(response) {
            (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).lists.removeTechnicFromTitle(response.data.response.docs);
            success(response.data.response);
        }).catch(function(ex) {
            error(ex);
        });
    },
    // https://api.dimu.org/api/solr/select?q=jean&fq=identifier.owner:STO&wt=json&api.key=TXfNazNFTZO0P%2B2lfu9eTg&rows=100&fq=-artifact.type:Folder&fq=artifact.hasPictures:true&fq=artifact.ingress.production.toYear:[1940 TO 1950]&start=0
    //}api/solr/}&fq=identifier.owner:STO&fq=-artifact.type:Folder&fq=artifact.hasPictures:true&fq=artifact.ingress.production.toYear:[${yearFrom} TO ${yearTo}]&wt=json&api.key=${
    getSearch: function(success, error, query, yearFrom, yearTo, rows, start) {
        let that = this;
        if ((0, $2860f5f07c24e63c$export$2e2bcd8739ae039).dev.isLocal) success((parcelRequire("6AbVD")));
        var url = `${(0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.baseUrl}api/solr/select?q=${encodeURIComponent(query)}&fq=identifier.owner:STO&fq=artifact.hasChildren:false&wt=json&api.key=${(0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.key}&rows=${rows}&start=${start}&omitHeader=true`;
        (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).get(url).then(function(response) {
            let json = response.data.response.docs;
            let categoryIds = (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).lists.getCategoryFolderIds(json);
            if (categoryIds.length > 2) that.getCategoryContent((catResponse)=>{
                json = json.concat(catResponse.docs);
                json = (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).lists.fixSearchResults(json, yearFrom, yearTo);
                catResponse.docs = (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).lists.removeDuplicates(json, "artifact.uuid");
                catResponse.numFound = catResponse.docs.length;
                success(catResponse);
            }, error, categoryIds, (0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.numberOfElements, 0);
            else {
                json = (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).lists.fixSearchResults(json, yearFrom, yearTo);
                response.data.response.docs = (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).lists.removeDuplicates(json, "artifact.uuid");
                response.data.response.numFound = response.data.response.docs.length;
                success(response.data.response);
            }
        }).catch(function(ex) {
            error(ex);
        });
    },
    // https://api.dimu.org/api/artifact?owner=STO&identifier=M-no0153-53&mapping=simple_json&api.key=demo
    // https://api.dimu.org/api/artifact?owner=STO&identifier=STO.K.02248&mapping=simple_json&api.key=demo
    // https://api.dimu.org/artifact/uuid/0EDBE210-A4E8-461F-A00C-B31D3EDC0FA4
    getSingle: (id, success, error)=>{
        //var url = `${Consts.api.baseUrl}/artifact?owner=STO&identifier=${id}&mapping=simple_json&api.key=${Consts.api.key}`; // old
        var url = `${(0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.baseUrl}artifact/uuid/${id}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).get(url).then(function(response) {
            success(response.data);
        }).catch(function(ex) {
            error(ex);
        });
    },
    getCategories: (success, error)=>{
        var url = `${(0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.baseUrl}api/solr/select?q=*&fq=identifier.owner:STO&fq=artifact.type:Folder&wt=json&api.key=${(0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.key}&rows=${(0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.numberOfElements}&omitHeader=true`;
        (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).get(url).then(function(response) {
            success(response.data.response);
        }).catch(function(ex) {
            error(ex);
        });
    },
    getCategoryContent: (success, error, uuid, rows, start)=>{
        var url = `${(0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.baseUrl}api/solr/select?q=*&fq=identifier.owner:STO&fq=artifact.hasPictures:true&fq=artifact.folderUids:${uuid}&rows=${rows}&start=${start}&sort=${(0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.sort} ${(0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.sortDirection}&wt=json&api.key=${(0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.key}&omitHeader=true`;
        (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).get(url).then((response)=>{
            response.data.response.numFoundOnServer = response.data.response.numFound;
            let filtered = (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).lists.fixCategoryResults(response.data.response.docs);
            response.data.response.docs = filtered;
            response.data.response.numFound = filtered.length;
            success(response.data.response);
        }).catch((ex)=>{
            error(ex);
        });
    },
    // https://api.dimu.org/artifact/uuid/B09F8E14-5304-44A8-8AB0-685FAD78975F
    getCategoryInfo: (success, error, uuid)=>{
        const url = `${(0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.baseUrl}artifact/uuid/${uuid}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).get(url).then((response)=>{
            success(response.data);
        }).catch((ex)=>{
            error(ex);
        });
    },
    getNklData: (name, success, error)=>{
        var url = `${(0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.baseUrlNkl}${name}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).get(url).then((response)=>{
            success(response.data[0]);
        }).catch((ex)=>{
            error(ex);
        });
    },
    getSnlData: (name, success, error)=>{
        var url = `${(0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.baseUrlSnl}${name}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).get(url).then((response)=>{
            success(response.data[0]);
        }).catch((ex)=>{
            error(ex);
        });
    }
};


var $af1a830b203b2f3e$export$2e2bcd8739ae039 = {
    lang: "no",
    get: function(key) {
        return this[key][this.lang];
    },
    showMoreHits: {
        no: "Vis flere treff",
        nn: "Vis fleire treff",
        en: "Show more"
    },
    hits: {
        no: "treff",
        nn: "treff",
        en: "hits"
    },
    noHits: {
        no: "Ingen treff",
        nn: "Ingen treff",
        en: "No hits"
    },
    showing: {
        no: "viser",
        nn: "visar",
        en: "showing"
    },
    showMoreCategories: {
        no: "Vis flere kategoriar",
        nn: "Vis flere kategorier",
        en: "Show more categories"
    },
    search: {
        no: "S\xf8k",
        nn: "S\xf8k",
        en: "Search"
    },
    categories: {
        no: "kategorier",
        nn: "kategorier",
        en: "categories"
    },
    period: {
        no: "periode",
        nn: "periode",
        en: "period"
    },
    // Carousel
    previous: {
        no: "Forrige",
        nn: "Forrige",
        en: "Previous"
    },
    next: {
        no: "Neste",
        nn: "Neste",
        en: "Next"
    },
    fullscreen: {
        no: "Fullskjerm",
        nn: "Fullskjerm",
        en: "Fullscreen"
    },
    download: {
        no: "Last ned",
        nn: "Last ned",
        en: "Download"
    },
    zoomIn: {
        no: "Zoom inn",
        nn: "Zoom inn",
        en: "Zoom in"
    },
    zoomOut: {
        no: "Zoom ut",
        nn: "Zoom ut",
        en: "Zoom out"
    },
    close: {
        no: "Lukk",
        nn: "Lukk",
        en: "Close"
    },
    // Filter
    choose: {
        no: "Velg",
        nn: "Velg",
        en: "Choose"
    },
    license: {
        no: "Lisens",
        nn: "Lisens",
        en: "License"
    },
    licenseOnPhoto: {
        no: "Lisens p\xe5 fotografi",
        nn: "Lisens p\xe5 fotografi",
        en: "License on photo"
    },
    copyright: {
        no: "Opphavsrett",
        nn: "Opphavsrett",
        en: "copyright"
    },
    contactOwner: {
        no: "Kontakt eier for mer informasjon",
        nn: "Kontakt eier for mer informasjon",
        en: "Contact owner for more information"
    },
    searchPlaceholderMinChars: {
        no: "Minst tre tegn",
        nn: "Minst tre teikn",
        en: "At least three characters"
    },
    series: {
        no: "Serie",
        nn: "Serie",
        en: "Series"
    }
};






var $8NFma = parcelRequire("8NFma");



var $O6tRJ = parcelRequire("O6tRJ");

parcelRequire("8NFma");

parcelRequire("O6tRJ");
const $020d228b212a9b48$var$Image = (props)=>{
    const imgSrcSmall = (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).image.getUrl(props.item, 400);
    const imgSrc = (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).image.getUrl(props.item, 800);
    const altText = props.item?.["artifact.ingress.title"] + " : " + props.item?.["artifact.ingress.producer"];
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        id: "gallery-carousel-image",
        className: "image",
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                src: imgSrc,
                alt: altText,
                style: {
                    objectFit: "contain",
                    margin: "0 0"
                }
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                src: imgSrcSmall,
                alt: "",
                style: {
                    position: "absolute",
                    visibility: "hidden"
                }
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                className: "visually-hidden",
                src: imgSrc,
                alt: "",
                style: {
                    position: "absolute",
                    opacity: 0,
                    display: "none"
                }
            })
        ]
    });
};
var $020d228b212a9b48$export$2e2bcd8739ae039 = $020d228b212a9b48$var$Image;




var $8NFma = parcelRequire("8NFma");


class $3433afd357d6a6c1$var$JwPlayer873 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
        this.state = {
            tumbnailUrl: "",
            thumbnailFinishedLoading: false
        };
        this.videoTitle = this.props.item["artifact.ingress.title"];
        this.videoProducer = this.props.item["artifact.ingress.producer"];
        this.id = this.props.item["identifier.id"];
        this.videoPlayer;
        this.videoInformation;
        this.videoPlayerId = "jw-player-873";
        this.jwPlayerOptions = {
            width: "100%",
            aspectratio: "16:9",
            file: ""
        };
        // Bind 'this' for event handlers
        this.initializeVideoPlayerAndStartVideo = this.initializeVideoPlayerAndStartVideo.bind(this);
        this.thumbnailLoadingError = this.thumbnailLoadingError.bind(this);
        this.thumbnailLoaded = this.thumbnailLoaded.bind(this);
    }
    fetchVideoFromApi() {
        if (!this.id) return;
        let url = `${(0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.baseUrl}api/artifact?owner=STO&identifier=${this.id}&mapping=simple_json&api.key=${(0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.key}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($125d1ceb57662f9a$exports))).get(url).then(this.initializeComponent.bind(this));
    }
    initializeComponent(response) {
        let hasTumbnail = response.data.images.length > 0;
        if (hasTumbnail) this.setState({
            tumbnailUrl: response.data.images[0].url
        });
        let videoObjects = $.grep(response.data.files, (file)=>{
            return file.fileType === "Video";
        });
        if (videoObjects.length === 0) return;
        // Just take the first video, should be the correct one.
        this.videoInformation = videoObjects[0];
        if (!hasTumbnail) this.initializeVideoPlayer();
    }
    componentDidMount() {
        this.fetchVideoFromApi();
    }
    componentWillUnmount() {
        if (!this.videoPlayer) return;
        this.videoPlayer.remove();
    }
    initializeVideoPlayer() {
        // Should not happen, but just return if we
        // don't have the video object or playlist URL.
        if (!this.videoInformation || !this.videoInformation.playlistUrl) return;
        this.jwPlayerOptions.file = this.videoInformation.playlistUrl;
        // This won't run if not in context of the actual web site
        // where jwplayer is loaded.
        this.videoPlayer = jwplayer(this.videoPlayerId);
        this.videoPlayer.setup(this.jwPlayerOptions);
    }
    playVideo() {
        if (!this.videoPlayer) return;
        this.videoPlayer.play();
    }
    thumbnailLoaded() {
        this.setState({
            thumbnailFinishedLoading: true
        });
    }
    thumbnailLoadingError() {
        this.initializeVideoPlayer();
    }
    initializeVideoPlayerAndStartVideo() {
        this.initializeVideoPlayer();
        this.playVideo();
    }
    render() {
        let tumbnailAltText = `${this.props.titleText}: ${this.videoTitle}. ${this.props.artistText}: ${this.videoProducer}.`;
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            id: this.videoPlayerId,
            children: this.state.tumbnailUrl ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                class: "gallery-video-tumbnail-and-play-button-wrapper",
                children: [
                    this.state.thumbnailFinishedLoading ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        class: "gallery-video-overlay",
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                            type: "button",
                            "aria-label": this.props.ariaLabelVideoPlayButtonText,
                            class: "gallery-video-play-button",
                            onClick: this.initializeVideoPlayerAndStartVideo
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                        className: "gallery-video-tumbnail-image",
                        src: this.state.tumbnailUrl,
                        alt: tumbnailAltText,
                        onError: this.thumbnailLoadingError,
                        onLoad: this.thumbnailLoaded
                    })
                ]
            }) : null
        });
    }
}
var $3433afd357d6a6c1$export$2e2bcd8739ae039 = $3433afd357d6a6c1$var$JwPlayer873;




var $8NFma = parcelRequire("8NFma");
class $e5524d3bdc5f7975$var$InformationAboutWork extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    getSnlLinkMarkup(artist) {
        return this.showSnlLink(artist) ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
            href: this.props.artistLink.url,
            children: this.props.artistLink.name
        }) : /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            children: this.props.cmsData.noInformationText
        });
    }
    showSnlLink(artist) {
        return !!this.props.artistLink && !!this.props.artistLink.url && this.props.artistLink.name === artist;
    }
    getEncyclopediaLinkHeading() {
        return this.props.encyclopediaLinkHeading !== undefined && this.props.encyclopediaLinkHeading !== "" ? this.props.encyclopediaLinkHeading : this.props.cmsData.nklText;
    }
    render() {
        let dateFrom = this.props.item["artifact.ingress.production.fromYear"];
        let dateTo = this.props.item["artifact.ingress.production.toYear"];
        let artist = this.props.item["artifact.ingress.producer"];
        let id = this.props.item["identifier.id"];
        let size = this.props.info.measureDescription;
        let title = this.props.item["artifact.ingress.title"];
        let acquisition = this.props.info.eventWrap ? this.props.info.eventWrap.acquisition : null;
        let technique = this.props.info.material ? this.props.info.material.comment : null;
        let snlLink = this.getSnlLinkMarkup(artist);
        let encyclopediaLinkHeading = this.getEncyclopediaLinkHeading();
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: "gallery-carousel-text",
            children: !this.props.apiObjectError ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                children: [
                    title && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("h2", {
                        children: [
                            title,
                            (this.props.isVersions || this.props.isSeries) && !this.props.multipleActive && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                                className: "normal",
                                children: [
                                    " ",
                                    "(",
                                    this.props.numberInSeries + 1,
                                    "/",
                                    this.props.multipleTotal,
                                    ")"
                                ]
                            }),
                            this.props.multipleActive ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                                className: "normal",
                                children: [
                                    " ",
                                    "(",
                                    this.props.slide + 1,
                                    "/",
                                    this.props.viewItems.length,
                                    ")"
                                ]
                            }) : ""
                        ]
                    }),
                    this.props.isVersions || this.props.isSeries || this.props.multipleActive ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        className: "gallery-is-multiple",
                        children: [
                            this.props.isSeries && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                    className: "gallery-series",
                                    children: "Serie"
                                })
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("a", {
                                className: "btn-link",
                                onClick: this.props.toggleVersions,
                                children: [
                                    !this.props.multipleActive && this.props.isVersions && this.props.cmsData.openVersions,
                                    this.props.multipleActive && this.props.isVersions && this.props.cmsData.endVersions,
                                    !this.props.multipleActive && this.props.isSeries && this.props.cmsData.openSeries,
                                    this.props.multipleActive && this.props.isSeries && this.props.cmsData.endSeries
                                ]
                            })
                        ]
                    }) : null,
                    artist && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                                children: [
                                    this.props.cmsData.artistText,
                                    ": "
                                ]
                            }),
                            artist
                        ]
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                                children: [
                                    this.props.cmsData.dateText,
                                    ": "
                                ]
                            }),
                            dateFrom ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
                                children: [
                                    dateFrom,
                                    " ",
                                    dateTo && dateTo != dateFrom && " - " + dateTo
                                ]
                            }) : this.props.cmsData.noDateText
                        ]
                    }),
                    technique && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                                children: [
                                    this.props.cmsData.technicText,
                                    ": "
                                ]
                            }),
                            technique
                        ]
                    }),
                    artist && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                                children: [
                                    this.props.cmsData.measureText,
                                    ": "
                                ]
                            }),
                            size
                        ]
                    }),
                    acquisition ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                                children: [
                                    this.props.cmsData.acquireText,
                                    ": "
                                ]
                            }),
                            acquisition
                        ]
                    }) : null,
                    id && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                                children: [
                                    this.props.cmsData.inventoryNrText,
                                    ": "
                                ]
                            }),
                            id
                        ]
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        className: "snl",
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                                children: [
                                    encyclopediaLinkHeading,
                                    ":"
                                ]
                            }),
                            snlLink
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h3", {
                children: this.props.cmsData.noContactText
            })
        });
    }
}
var $e5524d3bdc5f7975$export$2e2bcd8739ae039 = $e5524d3bdc5f7975$var$InformationAboutWork;




var $8NFma = parcelRequire("8NFma");
var $f8c99c41bd600645$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, $f8c99c41bd600645$exports) {
        classNames.default = classNames;
        $f8c99c41bd600645$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



/*
 * !!!Warning!!!
 * This component has been copied from ../../../../main/src/components/SocialSharing
 * If any changes are to be made in this file, it should also be made in the original
 */ 

var $8NFma = parcelRequire("8NFma");
/*
 * !!!Warning!!!
 * This component has been copied from ../../../../main/src/components/SocialSharingList
 * If any changes are to be made in this file, it should also be made in the original
 */ 
parcelRequire("8NFma");
const $e37a8cb6db68a0e6$var$GetName = ({ name: name })=>{
    if (name === "twitter") return "X/Twitter";
    else return name.charAt(0).toUpperCase() + name.slice(1);
};
const $e37a8cb6db68a0e6$var$SocialSharingList = ({ url: url, name: name })=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("li", {
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
            href: url,
            className: name.toLowerCase(),
            target: "_blank",
            children: $e37a8cb6db68a0e6$var$GetName({
                name: name
            })
        })
    });
var $e37a8cb6db68a0e6$export$2e2bcd8739ae039 = $e37a8cb6db68a0e6$var$SocialSharingList;


let $994b757034d48bc9$var$idCounter = 0;
class $994b757034d48bc9$var$SocialSharing extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
        this.state = {
            linkCssClasses: "",
            menuCssClasses: "social-sharing-list level-2",
            hideSharingText: this.props.hideSharingText || false,
            labelId: `social-sharing-label-${++$994b757034d48bc9$var$idCounter}`,
            controlsId: `social-sharing-controls-${++$994b757034d48bc9$var$idCounter}`,
            shareButtonText: "Del"
        };
        if (this.props.additionalLinkCssClasses) this.state.linkCssClasses += ` ${this.props.additionalLinkCssClasses}`;
        if (this.props.additionalMenuCssClasses) this.state.menuCssClasses += ` ${this.props.additionalMenuCssClasses}`;
    }
    sharingButtonClick(e) {
        window.stortinget.initializeSocialButton(e);
    }
    render() {
        let url = encodeURIComponent(this.props.url || "https://www.stortinget.no");
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            className: "social-sharing-container",
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                    href: "#social-sharing",
                    id: this.state.labelId,
                    type: "button",
                    className: this.state.linkCssClasses,
                    "aria-controls": this.state.controlsId,
                    "aria-expanded": "false",
                    onClick: this.sharingButtonClick,
                    children: this.state.hideSharingText ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                        className: "visuallyhidden",
                        children: this.state.shareButtonText
                    }) : this.state.shareButtonText
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("ul", {
                    id: this.state.controlsId,
                    className: this.state.menuCssClasses,
                    "aria-labelledby": this.state.labelId,
                    "data-social-selector": true,
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $e37a8cb6db68a0e6$export$2e2bcd8739ae039), {
                            url: "https://www.facebook.com/sharer.php?u=" + url,
                            name: "facebook"
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $e37a8cb6db68a0e6$export$2e2bcd8739ae039), {
                            url: "https://twitter.com/share?url=" + url,
                            name: "twitter"
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $e37a8cb6db68a0e6$export$2e2bcd8739ae039), {
                            url: "mailto:?subject=Tips%20fra%20stortinget.no&body=" + url,
                            name: "email"
                        })
                    ]
                })
            ]
        });
    }
}
var $994b757034d48bc9$export$2e2bcd8739ae039 = $994b757034d48bc9$var$SocialSharing;


class $c0366c7b311c739b$var$CarouselControls extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    render() {
        let prevSlide = this.props.prevSlide;
        let nextSlide = this.props.nextSlide;
        if (this.props.apiObjectError) prevSlide, nextSlide = [];
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            className: "gallery-carousel-navigation",
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                    type: "button",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))("gallery-carousel-prev", {
                        "gallery-carousel-hidden-button": !prevSlide[0]
                    }),
                    onClick: prevSlide[1],
                    ref: "prev",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                        className: "visuallyhidden",
                        children: (0, $af1a830b203b2f3e$export$2e2bcd8739ae039).get("previous")
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: "gallery-carousel-center-buttons",
                    children: [
                        this.props.showFullScreenButton && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                            type: "button",
                            className: "gallery-carousel-full-screen",
                            onClick: this.props.handleFullscreenClick,
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                className: "visuallyhidden",
                                children: (0, $af1a830b203b2f3e$export$2e2bcd8739ae039).get("fullscreen")
                            })
                        }),
                        this.props.showDownloadButton && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                            href: this.props.imgSrcDownload,
                            className: "button gallery-carousel-download",
                            download: true,
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                className: "visuallyhidden",
                                children: (0, $af1a830b203b2f3e$export$2e2bcd8739ae039).get("download")
                            })
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $994b757034d48bc9$export$2e2bcd8739ae039), {
                            url: window.location,
                            additionalLinkCssClasses: "gallery-carousel-share",
                            additionalMenuCssClasses: "social-sharing-list__open-downwards",
                            hideSharingText: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                    type: "button",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))("gallery-carousel-next", {
                        "gallery-carousel-hidden-button": !nextSlide[0]
                    }),
                    onClick: nextSlide[1],
                    ref: "next",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                        className: "visuallyhidden",
                        children: (0, $af1a830b203b2f3e$export$2e2bcd8739ae039).get("next")
                    })
                })
            ]
        });
    }
}
var $c0366c7b311c739b$export$2e2bcd8739ae039 = $c0366c7b311c739b$var$CarouselControls;




var $8NFma = parcelRequire("8NFma");

var $49an4 = parcelRequire("49an4");


class $9e4d0afe0acbcef7$var$OpenSeaDragonViewer extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
    }
    state = {
        isLoading: true
    };
    isLoading = ()=>{
        this.setState({
            isLoading: true
        });
    };
    render() {
        let self = this;
        let { id: id } = this.props;
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            className: "ocd-div",
            ref: (node)=>{
                this.el = node;
            },
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "openseadragon",
                    id: id
                }),
                this.state.isLoading && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                    alt: "loader",
                    className: "ocd-loader",
                    src: "/Web/FrontEndR/assets/gfx/loader-transparent.gif"
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                    type: "button",
                    className: "ocd-button ocd-button-close",
                    onClick: this.props.closeModal,
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                        className: "visuallyhidden",
                        children: (0, $af1a830b203b2f3e$export$2e2bcd8739ae039).get("close")
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: "ocd-buttons",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                            type: "button",
                            id: "prev",
                            className: "gallery-carousel-prev fullscreen ocd-arrow ocd-button-prev",
                            onClick: ()=>{
                                this.isLoading();
                            },
                            children: "Forrige"
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                            className: "ocd-center-buttons",
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                                    id: "zoom-out",
                                    className: "ocd-button ocd-button-zoom-out",
                                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                        className: "visuallyhidden",
                                        children: (0, $af1a830b203b2f3e$export$2e2bcd8739ae039).get("zoomOut")
                                    })
                                }),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                                    id: "zoom-in",
                                    className: "ocd-button ocd-button-zoom-in",
                                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                        className: "visuallyhidden",
                                        children: (0, $af1a830b203b2f3e$export$2e2bcd8739ae039).get("zoomIn")
                                    })
                                }),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $994b757034d48bc9$export$2e2bcd8739ae039), {
                                    url: window.location,
                                    additionalLinkCssClasses: "gallery-carousel-share",
                                    additionalMenuCssClasses: "social-sharing-list__open-upwards",
                                    hideSharingText: true
                                }),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                                    href: this.props.imgSrcDownload,
                                    ref: "ocdDownloadLink",
                                    className: "ocd-button ocd-button-download",
                                    download: true,
                                    role: "button",
                                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                        className: "visuallyhidden",
                                        children: "Last ned"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                            type: "button",
                            id: "next",
                            className: "gallery-carousel-next fullscreen ocd-arrow ocd-button-next",
                            onClick: ()=>{
                                this.isLoading();
                            },
                            children: "Neste"
                        })
                    ]
                })
            ]
        });
    }
    initSeaDragon() {
        let self = this;
        let { id: id } = this.props;
        self.viewer = (0, (/*@__PURE__*/$parcel$interopDefault($49an4)))({
            id: id,
            visibilityRatio: 1,
            constrainDuringPan: false,
            minZoomLevel: 0,
            maxZoomLevel: 10,
            zoomInButton: "zoom-in",
            zoomOutButton: "zoom-out",
            homeButton: "reset",
            nextButton: "next",
            previousButton: "prev",
            showNavigator: false,
            sequenceMode: true,
            tileSources: this.props.viewItems,
            useCanvas: true,
            minZoomImageRatio: 1
        });
        self.viewer.goToPage(this.props.slide);
        this.refs.ocdDownloadLink.href = this.props.viewItems[this.props.slide].downloadUrl;
        self.viewer.addHandler("page", (data)=>{
            if (!(this.props.slide == data.page)) {
                const downloadUrl = this.props.viewItems[data.page].downloadUrl;
                this.refs.ocdDownloadLink.href = downloadUrl;
                self.props.changePage(data.page);
            }
        });
        self.viewer.addHandler("open", function() {
            var tiledImage = self.viewer.world.getItemAt(0);
            if (tiledImage.getFullyLoaded()) self.setState({
                isLoading: false
            });
            else tiledImage.addOnceHandler("fully-loaded-change", function() {
                self.setState({
                    isLoading: false
                });
            });
        });
    }
}
$9e4d0afe0acbcef7$var$OpenSeaDragonViewer.defaultProps = {
    id: "ocd-viewer",
    type: "legacy-image-pyramid"
};
var $9e4d0afe0acbcef7$export$2e2bcd8739ae039 = $9e4d0afe0acbcef7$var$OpenSeaDragonViewer;




var $8NFma = parcelRequire("8NFma");



var $8NFma = parcelRequire("8NFma");

class $6b98650dbecffc99$var$License extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    addImageLicenseInformation(licenseObj) {
        if (!this.props.info.media) return;
        licenseObj.photo = this.props.info.media.pictures[this.props.multipleActiveSlide].photographer;
        if (this.props.info.media.pictures[this.props.multipleActiveSlide].licenses[0]) licenseObj.photoLicense = this.props.info.media.pictures[this.props.multipleActiveSlide].licenses[0].description;
    }
    addArtLicenseInformation(licenseObj) {
        // Art license
        if (!!this.props.info.licenses && this.props.info.licenses.length > 0) {
            const license = this.props.info.licenses[0];
            if (license.code == "pdm") {
                licenseObj.copyrightType = "pdm";
                licenseObj.copyright = "Public domain mark (CC pdm)";
                licenseObj.url = "http://creativecommons.org/publicdomain/mark/1.0/deed"; // KR
                licenseObj.img = "http://licensebuttons.net/p/mark/1.0/80x15.png";
            } else {
                licenseObj.copyrightType = "c";
                licenseObj.copyright = "Copyright";
            }
            licenseObj.persons = this.props.info.licenses[0].persons;
            if (licenseObj.persons) licenseObj.persons.forEach(function(item) {
                if (item.role.code === "49") licenseObj.person = item.name;
                if (item.role.code === "E1") licenseObj.org = item.name;
            });
        }
    }
    render() {
        let licenseObj = {};
        this.addImageLicenseInformation(licenseObj);
        this.addArtLicenseInformation(licenseObj);
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    children: [
                        (0, $af1a830b203b2f3e$export$2e2bcd8739ae039).get("license"),
                        ":",
                        " ",
                        !licenseObj.copyrightType && (0, $af1a830b203b2f3e$export$2e2bcd8739ae039).get("contactOwner"),
                        licenseObj.copyrightType == "c" ? (0, $af1a830b203b2f3e$export$2e2bcd8739ae039).get("copyright") : null,
                        licenseObj.copyrightType == "pdm" && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("a", {
                            href: licenseObj.url,
                            target: "_blank",
                            children: [
                                licenseObj.copyright,
                                " ",
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                    src: licenseObj.img,
                                    alt: licenseObj.copyright
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    children: licenseObj.person ? this.props.cmsData.copyrightOwnerText + ": " + licenseObj.person : null
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    children: licenseObj.org ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $13f4c0370d7de649$exports.Fragment), {
                        children: [
                            this.props.cmsData.copyrightManagerText + ": ",
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                                href: "http://www.bono.no",
                                target: "_blank",
                                children: "BONO"
                            })
                        ]
                    }) : null
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    children: [
                        this.props.cmsData.photoText,
                        ":",
                        " ",
                        licenseObj.photo ? !(licenseObj.photo == "Stortinget") ? licenseObj.photo + " / Stortinget" : "Stortinget" : "Stortinget",
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("br", {}),
                        licenseObj.photoLicense == "Navngivelse-Ikkekommersiell-Ingen bearbeidelse" && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $13f4c0370d7de649$exports.Fragment), {
                            children: [
                                (0, $af1a830b203b2f3e$export$2e2bcd8739ae039).get("licenseOnPhoto") + ": ",
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                                    rel: "license",
                                    href: "http://creativecommons.org/licenses/by-nc-nd/4.0/",
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                        alt: "Creative Commons License",
                                        src: "https://i.creativecommons.org/l/by-nc-nd/4.0/80x15.png"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
var $6b98650dbecffc99$export$2e2bcd8739ae039 = $6b98650dbecffc99$var$License;


class $544911c71d68ef66$var$MoreInformation extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
        this.toggleComponent = this.toggleComponent.bind(this);
        this.state = {
            componentOpen: false
        };
    }
    toggleComponent = (e)=>{
        e.preventDefault();
        const open = e.target.classList.contains("open");
        this.setState({
            componentOpen: open ? false : true
        });
    };
    render() {
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            className: "gallery-carousel-bottom",
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "big-toggler-trigger",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                        type: "button",
                        onClick: this.toggleComponent,
                        className: "reset icon-right " + (this.state.componentOpen ? " icon-zoom-out open" : " icon-zoom-in"),
                        children: this.props.cmsData.readMoreAboutItemText
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($f8c99c41bd600645$exports)))("gallery-carousel-extra", {
                        closed: !this.state.componentOpen,
                        "no-content": !this.props.info.otherInformation
                    }),
                    onClick: !this.state.componentOpen ? this.toggleComponent : ()=>({}),
                    children: [
                        this.props.info.otherInformation && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            className: "gallery-carousel-extra-fade"
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            className: "gallery-carousel-info-text",
                            children: this.props.info.otherInformation && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: this.props.info.otherInformation.replace(/(?:\r\n|\r|\\r\\n)/g, "<br />")
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            className: "gallery-carousel-info-photo " + (this.props.info.otherInformation ? "has-text" : ""),
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $6b98650dbecffc99$export$2e2bcd8739ae039), {
                                info: this.props.info,
                                multipleActiveSlide: this.props.multipleActiveSlide,
                                cmsData: this.props.cmsData
                            })
                        })
                    ]
                })
            ]
        });
    }
}
var $544911c71d68ef66$export$2e2bcd8739ae039 = $544911c71d68ef66$var$MoreInformation;


class $b174b6a2e4887561$var$Carousel extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
        this.openModal = this.openModal.bind(this);
        this._closeModal = this._closeModal.bind(this);
        this._changePage = this._changePage.bind(this);
        this.state = {
            info: {},
            imgSrc: "",
            imgSrcBigMax: "",
            imgSrcDownload: "",
            modalOpen: false,
            seaDragonInit: false,
            isMounted: false,
            artistLink: {},
            apiObjectError: false,
            isVersions: false,
            isSeries: false,
            versionsImages: [],
            multipleActive: false,
            multipleTotal: 0,
            multipleActiveSlide: 0,
            multipleArray: [],
            numberInSeries: 0,
            encyclopediaLinkHeading: ""
        };
    }
    lastItem = {};
    emptyObject = false;
    _toggleVersions = (e)=>{
        e.preventDefault();
        const isActive = !this.state.multipleActive;
        this.setState({
            multipleActive: isActive
        }, function() {
            if (isActive) {
                if (this.state.isVersions) {
                    let activeSlide = this.props.viewItems[this.props.slide];
                    const id = activeSlide["artifact.uuid"];
                    (0, $b5af3106de28ce48$export$2e2bcd8739ae039).getSingle(id, (jsonData)=>{
                        const versions = jsonData.media.pictures.map((p)=>({
                                ...activeSlide,
                                "artifact.uuid": this.props.item["artifact.uuid"],
                                "artifact.ingress.producer": this.props.item["artifact.ingress.producer"],
                                "identifier.id": this.props.item["identifier.id"],
                                "artifact.hasChildren": this.props.item["artifact.hasChildren"],
                                isSeries: false,
                                isVersions: true,
                                "artifact.defaultMediaIdentifier": p.identifier
                            }));
                        this.props.setVersions(versions);
                    }, ()=>{
                        this.setState({
                            apiObjectError: true
                        });
                    });
                } else if (this.state.isSeries) this.props.setVersions(this.state.multipleArray);
                else this.props.setVersions([]);
            } else this.props.endVersions();
        });
    };
    shouldComponentUpdate(nextProps) {
        return !nextProps.searchHasNoHits;
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        this.setState({
            apiObjectError: false
        });
        if (newProps.searchHasNoHits) newProps = this.props;
        else this._setupData(newProps);
    }
    _setupData = (newProps)=>{
        this.emptyObject = false;
        if ((0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).objects.isEmptyObject(newProps.item)) {
            this.emptyObject = true;
            this.setState({
                apiObjectError: true
            });
        }
        if (!this.emptyObject) {
            const isVersions = newProps.item["artifact.pictureCount"] > 1;
            const isSeries = newProps.item["identifier.id"].includes("-") || newProps.item["artifact.hasChildren"];
            var multipleTotal = 0;
            let multipleArray = [];
            let currentIndex = 0;
            if (isVersions) multipleTotal = newProps.item["artifact.pictureCount"];
            if (isSeries) {
                var seriesArr = [];
                var theId = newProps.item["identifier.id"];
                theId = theId.slice(0, theId.indexOf("-"));
                newProps.sourceItems.forEach(function(el) {
                    var elId = el["identifier.id"];
                    elId = elId.slice(0, elId.indexOf("-"));
                    if (elId == theId) {
                        el.isSeries = true;
                        el.isVersions = false;
                        seriesArr.push(el);
                    }
                });
                seriesArr.sort((a, b)=>{
                    let idA = a["identifier.id"];
                    let slicedA = idA.slice(idA.indexOf("-") + 1);
                    let idB = b["identifier.id"];
                    let slicedB = idB.slice(idB.indexOf("-") + 1);
                    return slicedA - slicedB;
                });
                currentIndex = (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).findIndex(seriesArr, (item)=>{
                    return item["identifier.id"] === newProps.item["identifier.id"];
                });
                multipleArray = seriesArr;
                multipleTotal = multipleArray.length;
            }
            this.setState({
                imgSrc: (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).image.getUrl(newProps.item, 800),
                imgSrcBigMax: (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).image.getUrl(newProps.item, 1200),
                imgSrcDownload: (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).image.getUrlDownload(newProps.item, "max"),
                multipleActive: newProps.multipleActive,
                isVersions: isVersions,
                isSeries: isSeries,
                multipleTotal: multipleTotal,
                multipleArray: multipleArray,
                numberInSeries: currentIndex
            });
            (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).dom.setTitle(newProps);
            if (this.props.item !== newProps.item) {
                const id = newProps.item["artifact.uuid"];
                (0, $b5af3106de28ce48$export$2e2bcd8739ae039).getSingle(id, (jsonData)=>{
                    this._setupArtist(jsonData, newProps.item);
                }, (error)=>{
                    this.setState({
                        apiObjectError: true
                    });
                });
            }
        } else {
            this.viewItems = this.props.viewItems[0] ? [
                this.props.viewItems[0]
            ] : this.viewItems;
            this.lastItem = this.props.item ? this.props.item : this.lastItem;
        }
    };
    _handleHitFromEncyclopediaApi = (firstName, lastName, artistName, artistData, json, encyclopediaLinkHeading)=>{
        var artistLink = this._getArtistLink(json, firstName, lastName, artistName);
        this.setState({
            info: artistData,
            artistLink: artistLink,
            encyclopediaLinkHeading: encyclopediaLinkHeading
        });
    };
    _handleSuccessFromNkl = (formattedName, firstName, lastName, artistName, artistData, noContactText, jsonNkl)=>{
        if (jsonNkl !== undefined) this._handleHitFromEncyclopediaApi(firstName, lastName, artistName, artistData, jsonNkl, this.props.cmsData.nklText);
        else (0, $b5af3106de28ce48$export$2e2bcd8739ae039).getSnlData(formattedName, (jsonSnl)=>{
            this._handleSuccessFromSnl(firstName, lastName, artistName, artistData, noContactText, jsonSnl);
        }, (error)=>{
            this._handleErrorFromEncyclopedia(artistData, noContactText);
        });
    };
    _handleSuccessFromSnl = (firstName, lastName, artistName, artistData, noContactText, jsonSnl)=>{
        if (jsonSnl !== undefined) this._handleHitFromEncyclopediaApi(firstName, lastName, artistName, artistData, jsonSnl, this.props.cmsData.snlText);
        else this._handleErrorFromEncyclopedia(artistData, noContactText);
    };
    _handleErrorFromEncyclopedia = (artistData, noContactText)=>{
        this.setState({
            artistLink: {
                name: noContactText,
                url: null
            },
            info: artistData
        });
    };
    _setupLinkToEncyclopedia = (formattedName, firstName, lastName, artistName, artistData, noContactText)=>{
        // Norsk kunstnerleksikon
        (0, $b5af3106de28ce48$export$2e2bcd8739ae039).getNklData(formattedName, (jsonNkl)=>this._handleSuccessFromNkl(formattedName, firstName, lastName, artistName, artistData, noContactText, jsonNkl), (error)=>this._handleErrorFromEncyclopedia(artistData, noContactText));
    };
    _setupArtist = (artistData, item)=>{
        var artistName = item["artifact.ingress.producer"];
        if (!artistName || artistName.length === 0) {
            // We won't be getting any new info
            // for this work, clear the current info.
            this.setState({
                info: {}
            });
            return;
        }
        var indexOfComma = artistName.indexOf(",");
        let formattedName = artistName;
        if (indexOfComma > -1) {
            var firstName = artistName.substr(indexOfComma + 2).trim(); // 2 is comma plus space
            var lastName = artistName.substr(0, indexOfComma).trim();
            formattedName = `${firstName} ${lastName}`;
        }
        this._setupLinkToEncyclopedia(formattedName, firstName, lastName, artistName, artistData, this.props.cmsData.noContactText);
    };
    _getArtistLink = (json, firstName, lastName, artistName)=>{
        if (!json) return;
        var url = null;
        var name = this.props.cmsData.noInformationText;
        var nameFromService = json.title.toLowerCase();
        if (nameFromService.includes(firstName.toLowerCase()) && nameFromService.includes(lastName.toLowerCase())) {
            url = json.article_url;
            name = artistName;
        }
        return {
            name: name,
            url: url
        };
    };
    openModal(e) {
        this.setState({
            modalOpen: true
        });
        if (!this.state.seaDragonInit) {
            this.ocd.initSeaDragon();
            this.setState({
                seaDragonInit: true
            });
        }
    }
    _closeModal(e) {
        this.setState({
            modalOpen: false
        });
    }
    _changePage(page) {
        this.props.changeSlide(page);
    }
    componentDidUpdate() {
        if (!this.props.searchHasNoHits) {
            if (typeof this.ocd !== "undefined") {
                if (this.ocd.viewer) {
                    this.ocd.viewer.goToPage(this.props.slide);
                    this.ocd.viewer.tileSources = this._mapSeaDragonArray(!this.emptyObject ? this.props.viewItems : this.viewItems);
                }
            }
        }
    }
    componentDidMount() {
        document.addEventListener("keyup", this._handleKeyPress.bind(this));
    }
    componentWillUnmount() {
        document.removeEventListener("keypress", this._handleKeyPress);
    }
    getCurrentWorkToDisplay() {
        let typeOfWork = this.props.item["artifact.type"];
        if (typeOfWork === "Fineart") return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $020d228b212a9b48$export$2e2bcd8739ae039), {
            item: this.props.item,
            sourceItems: this.props.sourceItems,
            apiObjectError: this.state.apiObjectError
        });
        else if (typeOfWork === "Video") return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $3433afd357d6a6c1$export$2e2bcd8739ae039), {
            item: this.props.item,
            titleText: this.props.cmsData.titleText,
            artistText: this.props.cmsData.artistText,
            ariaLabelVideoPlayButtonText: this.props.cmsData.ariaLabelVideoPlayButtonText
        });
    }
    isCurrentWorkAVideo() {
        return this.props.item["artifact.type"] !== "Video";
    }
    _mapSeaDragonArray(arr) {
        var newArr = arr.map((item, index)=>{
            return {
                type: "image",
                buildPyramid: false,
                url: (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).image.getUrlDownload(item, "max"),
                downloadUrl: (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).image.getUrlDownload(item, "max")
            };
        });
        return newArr;
    }
    _handleKeyPress(event) {
        var code = event.keyCode || event.which;
        if (code === 27 && this.state.modalOpen) this._closeModal();
    }
    render() {
        let item = this.props.item;
        if (this.emptyObject) item = this.lastItem;
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            id: "gallery-carousel",
            className: "gallery-carousel",
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: "gallery-carousel-top",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                            className: "gallery-carousel-image-wrapper",
                            children: [
                                this.getCurrentWorkToDisplay(),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $c0366c7b311c739b$export$2e2bcd8739ae039), {
                                    apiObjectError: this.state.apiObjectError,
                                    prevSlide: this.props.prevSlide,
                                    nextSlide: this.props.nextSlide,
                                    imgSrcDownload: this.state.imgSrcDownload,
                                    handleFullscreenClick: this.openModal,
                                    showDownloadButton: this.isCurrentWorkAVideo(),
                                    showFullScreenButton: this.isCurrentWorkAVideo()
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $e5524d3bdc5f7975$export$2e2bcd8739ae039), {
                            apiObjectError: this.state.apiObjectError,
                            cmsData: this.props.cmsData,
                            isVersions: this.state.isVersions,
                            isSeries: this.state.isSeries,
                            multipleActive: this.state.multipleActive,
                            numberInSeries: this.state.numberInSeries,
                            multipleTotal: this.state.multipleTotal,
                            slide: this.props.slide,
                            viewItems: this.props.viewItems,
                            item: item,
                            info: this.state.info,
                            artistLink: this.state.artistLink,
                            encyclopediaLinkHeading: this.state.encyclopediaLinkHeading,
                            toggleVersions: this._toggleVersions
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "slider-fullscreen " + (this.state.modalOpen ? "open" : "") + (this.state.searchHasNoHits ? " no-hits" : ""),
                    children: this.state.imgSrc ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9e4d0afe0acbcef7$export$2e2bcd8739ae039), {
                        image: this.state.imgSrc,
                        imgSrcBigMax: this.state.imgSrcBigMax,
                        imgSrcDownload: this.state.imgSrcDownload,
                        viewItems: this._mapSeaDragonArray(!this.emptyObject ? this.props.viewItems : this.viewItems),
                        slide: !this.emptyObject ? this.props.slide : 0,
                        closeModal: this._closeModal,
                        ref: (instance)=>{
                            this.ocd = instance;
                        },
                        changePage: this._changePage
                    }) : null
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $544911c71d68ef66$export$2e2bcd8739ae039), {
                    cmsData: this.props.cmsData,
                    info: this.state.info,
                    multipleActiveSlide: this.state.multipleActiveSlide
                })
            ]
        });
    }
}
var $b174b6a2e4887561$export$2e2bcd8739ae039 = $b174b6a2e4887561$var$Carousel;




var $8NFma = parcelRequire("8NFma");
var $b0c83d16b421d7f5$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b0c83d16b421d7f5$var$ReactIs, $b0c83d16b421d7f5$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$b0c83d16b421d7f5$exports = (parcelRequire("6DzO8"))();




var $8NFma = parcelRequire("8NFma");



var $8NFma = parcelRequire("8NFma");

class $d812be733f3baed4$var$Item extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    onClick = (e)=>{
        e.preventDefault();
        this.props.clickThumb(e, this.props.pos);
    };
    render() {
        this.props.parentHeight;
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
            onClick: this.onClick,
            href: this.props.url,
            className: "gallery-list-item",
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("figure", {
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        className: "container-inner",
                        style: {
                            height: this.props.imageHeight
                        },
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                            src: (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).image.getUrl(this.props.item, 400),
                            alt: "",
                            pos: this.props.pos,
                            style: {
                                height: this.props.imageHeight > this.props.imageWidth ? "100%" : "auto",
                                width: this.props.imageHeight <= this.props.imageWidth ? "100%" : "auto"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("figcaption", {
                        className: "gallery-list-item-text",
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                className: "item-title",
                                children: [
                                    this.props.item["artifact.ingress.title"],
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                children: this.props.item["artifact.ingress.producer"]
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                children: this.props.item["artifact.ingress.production.toYear"] ? this.props.item["artifact.ingress.production.toYear"] : this.props.noDateText
                            })
                        ]
                    })
                ]
            })
        }, this.props.item["artifact.uniqueId"]);
    }
}
var $d812be733f3baed4$export$2e2bcd8739ae039 = $d812be733f3baed4$var$Item;





var $22374b4858edafee$exports = {};
var $af5239f7b6768612$exports = {};
var $6d4bd7a05b42e19a$exports = {};
var $a4afebf11262d5c0$exports = {};

$parcel$export($a4afebf11262d5c0$exports, "linear", () => $a4afebf11262d5c0$export$45db2fc2f15997e7, (v) => $a4afebf11262d5c0$export$45db2fc2f15997e7 = v);
$parcel$export($a4afebf11262d5c0$exports, "inQuad", () => $a4afebf11262d5c0$export$418f331a90850394, (v) => $a4afebf11262d5c0$export$418f331a90850394 = v);
$parcel$export($a4afebf11262d5c0$exports, "outQuad", () => $a4afebf11262d5c0$export$f58614528ce1ca0f, (v) => $a4afebf11262d5c0$export$f58614528ce1ca0f = v);
$parcel$export($a4afebf11262d5c0$exports, "inOutQuad", () => $a4afebf11262d5c0$export$c100883bbabee3f7, (v) => $a4afebf11262d5c0$export$c100883bbabee3f7 = v);
$parcel$export($a4afebf11262d5c0$exports, "inCube", () => $a4afebf11262d5c0$export$61ec7bdc2b29cb9e, (v) => $a4afebf11262d5c0$export$61ec7bdc2b29cb9e = v);
$parcel$export($a4afebf11262d5c0$exports, "outCube", () => $a4afebf11262d5c0$export$4c2ded59ecbc5bba, (v) => $a4afebf11262d5c0$export$4c2ded59ecbc5bba = v);
$parcel$export($a4afebf11262d5c0$exports, "inOutCube", () => $a4afebf11262d5c0$export$def39dc8f7ebad6b, (v) => $a4afebf11262d5c0$export$def39dc8f7ebad6b = v);
$parcel$export($a4afebf11262d5c0$exports, "inQuart", () => $a4afebf11262d5c0$export$3d21461a505d9669, (v) => $a4afebf11262d5c0$export$3d21461a505d9669 = v);
$parcel$export($a4afebf11262d5c0$exports, "outQuart", () => $a4afebf11262d5c0$export$bb6472ca17d5d81c, (v) => $a4afebf11262d5c0$export$bb6472ca17d5d81c = v);
$parcel$export($a4afebf11262d5c0$exports, "inOutQuart", () => $a4afebf11262d5c0$export$92f5a0c2420b7723, (v) => $a4afebf11262d5c0$export$92f5a0c2420b7723 = v);
$parcel$export($a4afebf11262d5c0$exports, "inQuint", () => $a4afebf11262d5c0$export$e44277c3cd3c056, (v) => $a4afebf11262d5c0$export$e44277c3cd3c056 = v);
$parcel$export($a4afebf11262d5c0$exports, "outQuint", () => $a4afebf11262d5c0$export$c2b5994b53a2601, (v) => $a4afebf11262d5c0$export$c2b5994b53a2601 = v);
$parcel$export($a4afebf11262d5c0$exports, "inOutQuint", () => $a4afebf11262d5c0$export$b3f23f922f8fb0fb, (v) => $a4afebf11262d5c0$export$b3f23f922f8fb0fb = v);
$parcel$export($a4afebf11262d5c0$exports, "inSine", () => $a4afebf11262d5c0$export$b8b85ea21fe80b64, (v) => $a4afebf11262d5c0$export$b8b85ea21fe80b64 = v);
$parcel$export($a4afebf11262d5c0$exports, "outSine", () => $a4afebf11262d5c0$export$cef097a6f35c9b6a, (v) => $a4afebf11262d5c0$export$cef097a6f35c9b6a = v);
$parcel$export($a4afebf11262d5c0$exports, "inOutSine", () => $a4afebf11262d5c0$export$3b66c8bd42e4127c, (v) => $a4afebf11262d5c0$export$3b66c8bd42e4127c = v);
$parcel$export($a4afebf11262d5c0$exports, "inExpo", () => $a4afebf11262d5c0$export$c36e93d776b4c647, (v) => $a4afebf11262d5c0$export$c36e93d776b4c647 = v);
$parcel$export($a4afebf11262d5c0$exports, "outExpo", () => $a4afebf11262d5c0$export$658688ca915d76e1, (v) => $a4afebf11262d5c0$export$658688ca915d76e1 = v);
$parcel$export($a4afebf11262d5c0$exports, "inOutExpo", () => $a4afebf11262d5c0$export$b7a9c61e516d1823, (v) => $a4afebf11262d5c0$export$b7a9c61e516d1823 = v);
$parcel$export($a4afebf11262d5c0$exports, "inCirc", () => $a4afebf11262d5c0$export$c53de65d697180bc, (v) => $a4afebf11262d5c0$export$c53de65d697180bc = v);
$parcel$export($a4afebf11262d5c0$exports, "outCirc", () => $a4afebf11262d5c0$export$2f3c12cb6b6f5b16, (v) => $a4afebf11262d5c0$export$2f3c12cb6b6f5b16 = v);
$parcel$export($a4afebf11262d5c0$exports, "inOutCirc", () => $a4afebf11262d5c0$export$4c85969b52260a91, (v) => $a4afebf11262d5c0$export$4c85969b52260a91 = v);
$parcel$export($a4afebf11262d5c0$exports, "inBack", () => $a4afebf11262d5c0$export$e38aa6d936f277b2, (v) => $a4afebf11262d5c0$export$e38aa6d936f277b2 = v);
$parcel$export($a4afebf11262d5c0$exports, "outBack", () => $a4afebf11262d5c0$export$bcede31c95c9ee9, (v) => $a4afebf11262d5c0$export$bcede31c95c9ee9 = v);
$parcel$export($a4afebf11262d5c0$exports, "inOutBack", () => $a4afebf11262d5c0$export$cb7af22dffdedde, (v) => $a4afebf11262d5c0$export$cb7af22dffdedde = v);
$parcel$export($a4afebf11262d5c0$exports, "inBounce", () => $a4afebf11262d5c0$export$bf09a266620a0c03, (v) => $a4afebf11262d5c0$export$bf09a266620a0c03 = v);
$parcel$export($a4afebf11262d5c0$exports, "outBounce", () => $a4afebf11262d5c0$export$9138992b597e3e5c, (v) => $a4afebf11262d5c0$export$9138992b597e3e5c = v);
$parcel$export($a4afebf11262d5c0$exports, "inOutBounce", () => $a4afebf11262d5c0$export$a28277282d497a29, (v) => $a4afebf11262d5c0$export$a28277282d497a29 = v);
$parcel$export($a4afebf11262d5c0$exports, "inElastic", () => $a4afebf11262d5c0$export$e412010d8652bc3e, (v) => $a4afebf11262d5c0$export$e412010d8652bc3e = v);
$parcel$export($a4afebf11262d5c0$exports, "outElastic", () => $a4afebf11262d5c0$export$44c6bbd772ed246f, (v) => $a4afebf11262d5c0$export$44c6bbd772ed246f = v);
$parcel$export($a4afebf11262d5c0$exports, "inOutElastic", () => $a4afebf11262d5c0$export$5589b45d2ec771ca, (v) => $a4afebf11262d5c0$export$5589b45d2ec771ca = v);
$parcel$export($a4afebf11262d5c0$exports, "in-quad", () => $a4afebf11262d5c0$export$a1cddc65d22701f0, (v) => $a4afebf11262d5c0$export$a1cddc65d22701f0 = v);
$parcel$export($a4afebf11262d5c0$exports, "out-quad", () => $a4afebf11262d5c0$export$5b3551f15ae55827, (v) => $a4afebf11262d5c0$export$5b3551f15ae55827 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-out-quad", () => $a4afebf11262d5c0$export$318b9145208b55a9, (v) => $a4afebf11262d5c0$export$318b9145208b55a9 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-cube", () => $a4afebf11262d5c0$export$c72fbaca3b3e8af8, (v) => $a4afebf11262d5c0$export$c72fbaca3b3e8af8 = v);
$parcel$export($a4afebf11262d5c0$exports, "out-cube", () => $a4afebf11262d5c0$export$ebf75a969f1a2188, (v) => $a4afebf11262d5c0$export$ebf75a969f1a2188 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-out-cube", () => $a4afebf11262d5c0$export$ccfb00a026b6f7cf, (v) => $a4afebf11262d5c0$export$ccfb00a026b6f7cf = v);
$parcel$export($a4afebf11262d5c0$exports, "in-quart", () => $a4afebf11262d5c0$export$fbbe20c3eb762997, (v) => $a4afebf11262d5c0$export$fbbe20c3eb762997 = v);
$parcel$export($a4afebf11262d5c0$exports, "out-quart", () => $a4afebf11262d5c0$export$5a2d91a05069d006, (v) => $a4afebf11262d5c0$export$5a2d91a05069d006 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-out-quart", () => $a4afebf11262d5c0$export$b7fb5d0517fa47e0, (v) => $a4afebf11262d5c0$export$b7fb5d0517fa47e0 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-quint", () => $a4afebf11262d5c0$export$b6075dfe7d89188c, (v) => $a4afebf11262d5c0$export$b6075dfe7d89188c = v);
$parcel$export($a4afebf11262d5c0$exports, "out-quint", () => $a4afebf11262d5c0$export$5e281c7a013bb025, (v) => $a4afebf11262d5c0$export$5e281c7a013bb025 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-out-quint", () => $a4afebf11262d5c0$export$195fabf35383b3d4, (v) => $a4afebf11262d5c0$export$195fabf35383b3d4 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-sine", () => $a4afebf11262d5c0$export$50c99a696ec8acf7, (v) => $a4afebf11262d5c0$export$50c99a696ec8acf7 = v);
$parcel$export($a4afebf11262d5c0$exports, "out-sine", () => $a4afebf11262d5c0$export$d741d49e5c025f8c, (v) => $a4afebf11262d5c0$export$d741d49e5c025f8c = v);
$parcel$export($a4afebf11262d5c0$exports, "in-out-sine", () => $a4afebf11262d5c0$export$7f5393135ad69509, (v) => $a4afebf11262d5c0$export$7f5393135ad69509 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-expo", () => $a4afebf11262d5c0$export$a08adfe40f2aebf0, (v) => $a4afebf11262d5c0$export$a08adfe40f2aebf0 = v);
$parcel$export($a4afebf11262d5c0$exports, "out-expo", () => $a4afebf11262d5c0$export$60a8087447276f8d, (v) => $a4afebf11262d5c0$export$60a8087447276f8d = v);
$parcel$export($a4afebf11262d5c0$exports, "in-out-expo", () => $a4afebf11262d5c0$export$8f5fdd7ace16d5c0, (v) => $a4afebf11262d5c0$export$8f5fdd7ace16d5c0 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-circ", () => $a4afebf11262d5c0$export$6f0fe67bc97c1e67, (v) => $a4afebf11262d5c0$export$6f0fe67bc97c1e67 = v);
$parcel$export($a4afebf11262d5c0$exports, "out-circ", () => $a4afebf11262d5c0$export$4faaec9352662124, (v) => $a4afebf11262d5c0$export$4faaec9352662124 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-out-circ", () => $a4afebf11262d5c0$export$d6f8a8e1903140b2, (v) => $a4afebf11262d5c0$export$d6f8a8e1903140b2 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-back", () => $a4afebf11262d5c0$export$244752ea1996a3d8, (v) => $a4afebf11262d5c0$export$244752ea1996a3d8 = v);
$parcel$export($a4afebf11262d5c0$exports, "out-back", () => $a4afebf11262d5c0$export$8ae8024afddee641, (v) => $a4afebf11262d5c0$export$8ae8024afddee641 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-out-back", () => $a4afebf11262d5c0$export$912f13c58e8ecfe3, (v) => $a4afebf11262d5c0$export$912f13c58e8ecfe3 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-bounce", () => $a4afebf11262d5c0$export$d9c88faa90d08718, (v) => $a4afebf11262d5c0$export$d9c88faa90d08718 = v);
$parcel$export($a4afebf11262d5c0$exports, "out-bounce", () => $a4afebf11262d5c0$export$c98b7275ae28b699, (v) => $a4afebf11262d5c0$export$c98b7275ae28b699 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-out-bounce", () => $a4afebf11262d5c0$export$c10ec19ba8a1d71b, (v) => $a4afebf11262d5c0$export$c10ec19ba8a1d71b = v);
$parcel$export($a4afebf11262d5c0$exports, "in-elastic", () => $a4afebf11262d5c0$export$851b37f8b4636772, (v) => $a4afebf11262d5c0$export$851b37f8b4636772 = v);
$parcel$export($a4afebf11262d5c0$exports, "out-elastic", () => $a4afebf11262d5c0$export$9a9e1c182cbb2f62, (v) => $a4afebf11262d5c0$export$9a9e1c182cbb2f62 = v);
$parcel$export($a4afebf11262d5c0$exports, "in-out-elastic", () => $a4afebf11262d5c0$export$a199a95bda036e40, (v) => $a4afebf11262d5c0$export$a199a95bda036e40 = v);
// easing functions from "Tween.js"
var $a4afebf11262d5c0$export$45db2fc2f15997e7;
var $a4afebf11262d5c0$export$418f331a90850394;
var $a4afebf11262d5c0$export$f58614528ce1ca0f;
var $a4afebf11262d5c0$export$c100883bbabee3f7;
var $a4afebf11262d5c0$export$61ec7bdc2b29cb9e;
var $a4afebf11262d5c0$export$4c2ded59ecbc5bba;
var $a4afebf11262d5c0$export$def39dc8f7ebad6b;
var $a4afebf11262d5c0$export$3d21461a505d9669;
var $a4afebf11262d5c0$export$bb6472ca17d5d81c;
var $a4afebf11262d5c0$export$92f5a0c2420b7723;
var $a4afebf11262d5c0$export$e44277c3cd3c056;
var $a4afebf11262d5c0$export$c2b5994b53a2601;
var $a4afebf11262d5c0$export$b3f23f922f8fb0fb;
var $a4afebf11262d5c0$export$b8b85ea21fe80b64;
var $a4afebf11262d5c0$export$cef097a6f35c9b6a;
var $a4afebf11262d5c0$export$3b66c8bd42e4127c;
var $a4afebf11262d5c0$export$c36e93d776b4c647;
var $a4afebf11262d5c0$export$658688ca915d76e1;
var $a4afebf11262d5c0$export$b7a9c61e516d1823;
var $a4afebf11262d5c0$export$c53de65d697180bc;
var $a4afebf11262d5c0$export$2f3c12cb6b6f5b16;
var $a4afebf11262d5c0$export$4c85969b52260a91;
var $a4afebf11262d5c0$export$e38aa6d936f277b2;
var $a4afebf11262d5c0$export$bcede31c95c9ee9;
var $a4afebf11262d5c0$export$cb7af22dffdedde;
var $a4afebf11262d5c0$export$bf09a266620a0c03;
var $a4afebf11262d5c0$export$9138992b597e3e5c;
var $a4afebf11262d5c0$export$a28277282d497a29;
var $a4afebf11262d5c0$export$e412010d8652bc3e;
var $a4afebf11262d5c0$export$44c6bbd772ed246f;
var $a4afebf11262d5c0$export$5589b45d2ec771ca;
// aliases
var $a4afebf11262d5c0$export$a1cddc65d22701f0;
var $a4afebf11262d5c0$export$5b3551f15ae55827;
var $a4afebf11262d5c0$export$318b9145208b55a9;
var $a4afebf11262d5c0$export$c72fbaca3b3e8af8;
var $a4afebf11262d5c0$export$ebf75a969f1a2188;
var $a4afebf11262d5c0$export$ccfb00a026b6f7cf;
var $a4afebf11262d5c0$export$fbbe20c3eb762997;
var $a4afebf11262d5c0$export$5a2d91a05069d006;
var $a4afebf11262d5c0$export$b7fb5d0517fa47e0;
var $a4afebf11262d5c0$export$b6075dfe7d89188c;
var $a4afebf11262d5c0$export$5e281c7a013bb025;
var $a4afebf11262d5c0$export$195fabf35383b3d4;
var $a4afebf11262d5c0$export$50c99a696ec8acf7;
var $a4afebf11262d5c0$export$d741d49e5c025f8c;
var $a4afebf11262d5c0$export$7f5393135ad69509;
var $a4afebf11262d5c0$export$a08adfe40f2aebf0;
var $a4afebf11262d5c0$export$60a8087447276f8d;
var $a4afebf11262d5c0$export$8f5fdd7ace16d5c0;
var $a4afebf11262d5c0$export$6f0fe67bc97c1e67;
var $a4afebf11262d5c0$export$4faaec9352662124;
var $a4afebf11262d5c0$export$d6f8a8e1903140b2;
var $a4afebf11262d5c0$export$244752ea1996a3d8;
var $a4afebf11262d5c0$export$8ae8024afddee641;
var $a4afebf11262d5c0$export$912f13c58e8ecfe3;
var $a4afebf11262d5c0$export$d9c88faa90d08718;
var $a4afebf11262d5c0$export$c98b7275ae28b699;
var $a4afebf11262d5c0$export$c10ec19ba8a1d71b;
var $a4afebf11262d5c0$export$851b37f8b4636772;
var $a4afebf11262d5c0$export$9a9e1c182cbb2f62;
var $a4afebf11262d5c0$export$a199a95bda036e40;
$a4afebf11262d5c0$export$45db2fc2f15997e7 = function(n) {
    return n;
};
$a4afebf11262d5c0$export$418f331a90850394 = function(n) {
    return n * n;
};
$a4afebf11262d5c0$export$f58614528ce1ca0f = function(n) {
    return n * (2 - n);
};
$a4afebf11262d5c0$export$c100883bbabee3f7 = function(n) {
    n *= 2;
    if (n < 1) return 0.5 * n * n;
    return -0.5 * (--n * (n - 2) - 1);
};
$a4afebf11262d5c0$export$61ec7bdc2b29cb9e = function(n) {
    return n * n * n;
};
$a4afebf11262d5c0$export$4c2ded59ecbc5bba = function(n) {
    return --n * n * n + 1;
};
$a4afebf11262d5c0$export$def39dc8f7ebad6b = function(n) {
    n *= 2;
    if (n < 1) return 0.5 * n * n * n;
    return 0.5 * ((n -= 2) * n * n + 2);
};
$a4afebf11262d5c0$export$3d21461a505d9669 = function(n) {
    return n * n * n * n;
};
$a4afebf11262d5c0$export$bb6472ca17d5d81c = function(n) {
    return 1 - --n * n * n * n;
};
$a4afebf11262d5c0$export$92f5a0c2420b7723 = function(n) {
    n *= 2;
    if (n < 1) return 0.5 * n * n * n * n;
    return -0.5 * ((n -= 2) * n * n * n - 2);
};
$a4afebf11262d5c0$export$e44277c3cd3c056 = function(n) {
    return n * n * n * n * n;
};
$a4afebf11262d5c0$export$c2b5994b53a2601 = function(n) {
    return --n * n * n * n * n + 1;
};
$a4afebf11262d5c0$export$b3f23f922f8fb0fb = function(n) {
    n *= 2;
    if (n < 1) return 0.5 * n * n * n * n * n;
    return 0.5 * ((n -= 2) * n * n * n * n + 2);
};
$a4afebf11262d5c0$export$b8b85ea21fe80b64 = function(n) {
    return 1 - Math.cos(n * Math.PI / 2);
};
$a4afebf11262d5c0$export$cef097a6f35c9b6a = function(n) {
    return Math.sin(n * Math.PI / 2);
};
$a4afebf11262d5c0$export$3b66c8bd42e4127c = function(n) {
    return .5 * (1 - Math.cos(Math.PI * n));
};
$a4afebf11262d5c0$export$c36e93d776b4c647 = function(n) {
    return 0 == n ? 0 : Math.pow(1024, n - 1);
};
$a4afebf11262d5c0$export$658688ca915d76e1 = function(n) {
    return 1 == n ? n : 1 - Math.pow(2, -10 * n);
};
$a4afebf11262d5c0$export$b7a9c61e516d1823 = function(n) {
    if (0 == n) return 0;
    if (1 == n) return 1;
    if ((n *= 2) < 1) return .5 * Math.pow(1024, n - 1);
    return .5 * (-Math.pow(2, -10 * (n - 1)) + 2);
};
$a4afebf11262d5c0$export$c53de65d697180bc = function(n) {
    return 1 - Math.sqrt(1 - n * n);
};
$a4afebf11262d5c0$export$2f3c12cb6b6f5b16 = function(n) {
    return Math.sqrt(1 - --n * n);
};
$a4afebf11262d5c0$export$4c85969b52260a91 = function(n) {
    n *= 2;
    if (n < 1) return -0.5 * (Math.sqrt(1 - n * n) - 1);
    return 0.5 * (Math.sqrt(1 - (n -= 2) * n) + 1);
};
$a4afebf11262d5c0$export$e38aa6d936f277b2 = function(n) {
    var s = 1.70158;
    return n * n * ((s + 1) * n - s);
};
$a4afebf11262d5c0$export$bcede31c95c9ee9 = function(n) {
    var s = 1.70158;
    return --n * n * ((s + 1) * n + s) + 1;
};
$a4afebf11262d5c0$export$cb7af22dffdedde = function(n) {
    var s = 2.5949095;
    if ((n *= 2) < 1) return 0.5 * (n * n * ((s + 1) * n - s));
    return 0.5 * ((n -= 2) * n * ((s + 1) * n + s) + 2);
};
$a4afebf11262d5c0$export$bf09a266620a0c03 = function(n) {
    return 1 - $a4afebf11262d5c0$export$9138992b597e3e5c(1 - n);
};
$a4afebf11262d5c0$export$9138992b597e3e5c = function(n) {
    if (n < 1 / 2.75) return 7.5625 * n * n;
    else if (n < 2 / 2.75) return 7.5625 * (n -= 1.5 / 2.75) * n + 0.75;
    else if (n < 2.5 / 2.75) return 7.5625 * (n -= 2.25 / 2.75) * n + 0.9375;
    else return 7.5625 * (n -= 2.625 / 2.75) * n + 0.984375;
};
$a4afebf11262d5c0$export$a28277282d497a29 = function(n) {
    if (n < .5) return $a4afebf11262d5c0$export$bf09a266620a0c03(n * 2) * .5;
    return $a4afebf11262d5c0$export$9138992b597e3e5c(n * 2 - 1) * .5 + .5;
};
$a4afebf11262d5c0$export$e412010d8652bc3e = function(n) {
    var s, a = 0.1, p = 0.4;
    if (n === 0) return 0;
    if (n === 1) return 1;
    if (!a || a < 1) {
        a = 1;
        s = p / 4;
    } else s = p * Math.asin(1 / a) / (2 * Math.PI);
    return -(a * Math.pow(2, 10 * (n -= 1)) * Math.sin((n - s) * (2 * Math.PI) / p));
};
$a4afebf11262d5c0$export$44c6bbd772ed246f = function(n) {
    var s, a = 0.1, p = 0.4;
    if (n === 0) return 0;
    if (n === 1) return 1;
    if (!a || a < 1) {
        a = 1;
        s = p / 4;
    } else s = p * Math.asin(1 / a) / (2 * Math.PI);
    return a * Math.pow(2, -10 * n) * Math.sin((n - s) * (2 * Math.PI) / p) + 1;
};
$a4afebf11262d5c0$export$5589b45d2ec771ca = function(n) {
    var s, a = 0.1, p = 0.4;
    if (n === 0) return 0;
    if (n === 1) return 1;
    if (!a || a < 1) {
        a = 1;
        s = p / 4;
    } else s = p * Math.asin(1 / a) / (2 * Math.PI);
    if ((n *= 2) < 1) return -0.5 * (a * Math.pow(2, 10 * (n -= 1)) * Math.sin((n - s) * (2 * Math.PI) / p));
    return a * Math.pow(2, -10 * (n -= 1)) * Math.sin((n - s) * (2 * Math.PI) / p) * 0.5 + 1;
};
$a4afebf11262d5c0$export$a1cddc65d22701f0 = $a4afebf11262d5c0$export$418f331a90850394;
$a4afebf11262d5c0$export$5b3551f15ae55827 = $a4afebf11262d5c0$export$f58614528ce1ca0f;
$a4afebf11262d5c0$export$318b9145208b55a9 = $a4afebf11262d5c0$export$c100883bbabee3f7;
$a4afebf11262d5c0$export$c72fbaca3b3e8af8 = $a4afebf11262d5c0$export$61ec7bdc2b29cb9e;
$a4afebf11262d5c0$export$ebf75a969f1a2188 = $a4afebf11262d5c0$export$4c2ded59ecbc5bba;
$a4afebf11262d5c0$export$ccfb00a026b6f7cf = $a4afebf11262d5c0$export$def39dc8f7ebad6b;
$a4afebf11262d5c0$export$fbbe20c3eb762997 = $a4afebf11262d5c0$export$3d21461a505d9669;
$a4afebf11262d5c0$export$5a2d91a05069d006 = $a4afebf11262d5c0$export$bb6472ca17d5d81c;
$a4afebf11262d5c0$export$b7fb5d0517fa47e0 = $a4afebf11262d5c0$export$92f5a0c2420b7723;
$a4afebf11262d5c0$export$b6075dfe7d89188c = $a4afebf11262d5c0$export$e44277c3cd3c056;
$a4afebf11262d5c0$export$5e281c7a013bb025 = $a4afebf11262d5c0$export$c2b5994b53a2601;
$a4afebf11262d5c0$export$195fabf35383b3d4 = $a4afebf11262d5c0$export$b3f23f922f8fb0fb;
$a4afebf11262d5c0$export$50c99a696ec8acf7 = $a4afebf11262d5c0$export$b8b85ea21fe80b64;
$a4afebf11262d5c0$export$d741d49e5c025f8c = $a4afebf11262d5c0$export$cef097a6f35c9b6a;
$a4afebf11262d5c0$export$7f5393135ad69509 = $a4afebf11262d5c0$export$3b66c8bd42e4127c;
$a4afebf11262d5c0$export$a08adfe40f2aebf0 = $a4afebf11262d5c0$export$c36e93d776b4c647;
$a4afebf11262d5c0$export$60a8087447276f8d = $a4afebf11262d5c0$export$658688ca915d76e1;
$a4afebf11262d5c0$export$8f5fdd7ace16d5c0 = $a4afebf11262d5c0$export$b7a9c61e516d1823;
$a4afebf11262d5c0$export$6f0fe67bc97c1e67 = $a4afebf11262d5c0$export$c53de65d697180bc;
$a4afebf11262d5c0$export$4faaec9352662124 = $a4afebf11262d5c0$export$2f3c12cb6b6f5b16;
$a4afebf11262d5c0$export$d6f8a8e1903140b2 = $a4afebf11262d5c0$export$4c85969b52260a91;
$a4afebf11262d5c0$export$244752ea1996a3d8 = $a4afebf11262d5c0$export$e38aa6d936f277b2;
$a4afebf11262d5c0$export$8ae8024afddee641 = $a4afebf11262d5c0$export$bcede31c95c9ee9;
$a4afebf11262d5c0$export$912f13c58e8ecfe3 = $a4afebf11262d5c0$export$cb7af22dffdedde;
$a4afebf11262d5c0$export$d9c88faa90d08718 = $a4afebf11262d5c0$export$bf09a266620a0c03;
$a4afebf11262d5c0$export$c98b7275ae28b699 = $a4afebf11262d5c0$export$9138992b597e3e5c;
$a4afebf11262d5c0$export$c10ec19ba8a1d71b = $a4afebf11262d5c0$export$a28277282d497a29;
$a4afebf11262d5c0$export$851b37f8b4636772 = $a4afebf11262d5c0$export$e412010d8652bc3e;
$a4afebf11262d5c0$export$9a9e1c182cbb2f62 = $a4afebf11262d5c0$export$44c6bbd772ed246f;
$a4afebf11262d5c0$export$a199a95bda036e40 = $a4afebf11262d5c0$export$5589b45d2ec771ca;


var $ffb7e7103ca02b01$exports = {};
function $ffb7e7103ca02b01$var$Emitter(obj) {
    if (obj) return $ffb7e7103ca02b01$var$mixin(obj);
}
function $ffb7e7103ca02b01$var$mixin(obj) {
    for(var key in $ffb7e7103ca02b01$var$Emitter.prototype)obj[key] = $ffb7e7103ca02b01$var$Emitter.prototype[key];
    return obj;
}
$ffb7e7103ca02b01$var$Emitter.prototype.on = $ffb7e7103ca02b01$var$Emitter.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn);
    return this;
};
$ffb7e7103ca02b01$var$Emitter.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
$ffb7e7103ca02b01$var$Emitter.prototype.off = $ffb7e7103ca02b01$var$Emitter.prototype.removeListener = $ffb7e7103ca02b01$var$Emitter.prototype.removeAllListeners = $ffb7e7103ca02b01$var$Emitter.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks["$" + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks["$" + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks["$" + event];
    return this;
};
$ffb7e7103ca02b01$var$Emitter.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = [].slice.call(arguments, 1), callbacks = this._callbacks["$" + event];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
$ffb7e7103ca02b01$var$Emitter.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks["$" + event] || [];
};
$ffb7e7103ca02b01$var$Emitter.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};
$ffb7e7103ca02b01$exports = $ffb7e7103ca02b01$var$Emitter;


function $6d4bd7a05b42e19a$var$extend(obj, src) {
    for(var key in src)if (src.hasOwnProperty(key)) obj[key] = src[key];
    return obj;
}
function $6d4bd7a05b42e19a$var$Tween(obj) {
    if (!(this instanceof $6d4bd7a05b42e19a$var$Tween)) return new $6d4bd7a05b42e19a$var$Tween(obj);
    this._from = obj;
    this.ease("linear");
    this.duration(500);
}
$ffb7e7103ca02b01$exports($6d4bd7a05b42e19a$var$Tween.prototype);
$6d4bd7a05b42e19a$var$Tween.prototype.reset = function() {
    this.isArray = Object.prototype.toString.call(this._from) === "[object Array]";
    this._curr = $6d4bd7a05b42e19a$var$extend({}, this._from);
    this._done = false;
    this._start = Date.now();
    return this;
};
$6d4bd7a05b42e19a$var$Tween.prototype.to = function(obj) {
    this.reset();
    this._to = obj;
    return this;
};
$6d4bd7a05b42e19a$var$Tween.prototype.duration = function(ms) {
    this._duration = ms;
    return this;
};
$6d4bd7a05b42e19a$var$Tween.prototype.ease = function(fn) {
    fn = "function" == typeof fn ? fn : $a4afebf11262d5c0$exports[fn];
    if (!fn) throw new TypeError("invalid easing function");
    this._ease = fn;
    return this;
};
$6d4bd7a05b42e19a$var$Tween.prototype.stop = function() {
    this.stopped = true;
    this._done = true;
    this.emit("stop");
    this.emit("end");
    return this;
};
$6d4bd7a05b42e19a$var$Tween.prototype.step = function() {
    if (this._done) return;
    var duration = this._duration;
    var now = Date.now();
    var delta = now - this._start;
    var done = delta >= duration;
    if (done) {
        this._from = this._to;
        this._update(this._to);
        this._done = true;
        this.emit("end");
        return this;
    }
    var from = this._from;
    var to = this._to;
    var curr = this._curr;
    var fn = this._ease;
    var p = (now - this._start) / duration;
    var n = fn(p);
    if (this.isArray) {
        for(var i = 0; i < from.length; ++i)curr[i] = from[i] + (to[i] - from[i]) * n;
        this._update(curr);
        return this;
    }
    for(var k in from)curr[k] = from[k] + (to[k] - from[k]) * n;
    this._update(curr);
    return this;
};
$6d4bd7a05b42e19a$var$Tween.prototype.update = function(fn) {
    if (0 == arguments.length) return this.step();
    this._update = fn;
    return this;
};
$6d4bd7a05b42e19a$exports = $6d4bd7a05b42e19a$var$Tween;


var $a9334679fceb5904$exports = {};
var $d78d660f0965e541$exports = {};

var $ibaza = parcelRequire("ibaza");
// Generated by CoffeeScript 1.12.2
(function() {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) $d78d660f0965e541$exports = function() {
        return performance.now();
    };
    else if (typeof $ibaza !== "undefined" && $ibaza !== null && $ibaza.hrtime) {
        $d78d660f0965e541$exports = function() {
            return (getNanoSeconds() - nodeLoadTime) / 1e6;
        };
        hrtime = $ibaza.hrtime;
        getNanoSeconds = function() {
            var hr;
            hr = hrtime();
            return hr[0] * 1e9 + hr[1];
        };
        moduleLoadTime = getNanoSeconds();
        upTime = $ibaza.uptime() * 1e9;
        nodeLoadTime = moduleLoadTime - upTime;
    } else if (Date.now) {
        $d78d660f0965e541$exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        $d78d660f0965e541$exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call($d78d660f0965e541$exports);


var $a9334679fceb5904$var$root = typeof window === "undefined" ? $parcel$global : window, $a9334679fceb5904$var$vendors = [
    "moz",
    "webkit"
], $a9334679fceb5904$var$suffix = "AnimationFrame", $a9334679fceb5904$var$raf = $a9334679fceb5904$var$root["request" + $a9334679fceb5904$var$suffix], $a9334679fceb5904$var$caf = $a9334679fceb5904$var$root["cancel" + $a9334679fceb5904$var$suffix] || $a9334679fceb5904$var$root["cancelRequest" + $a9334679fceb5904$var$suffix];
for(var $a9334679fceb5904$var$i = 0; !$a9334679fceb5904$var$raf && $a9334679fceb5904$var$i < $a9334679fceb5904$var$vendors.length; $a9334679fceb5904$var$i++){
    $a9334679fceb5904$var$raf = $a9334679fceb5904$var$root[$a9334679fceb5904$var$vendors[$a9334679fceb5904$var$i] + "Request" + $a9334679fceb5904$var$suffix];
    $a9334679fceb5904$var$caf = $a9334679fceb5904$var$root[$a9334679fceb5904$var$vendors[$a9334679fceb5904$var$i] + "Cancel" + $a9334679fceb5904$var$suffix] || $a9334679fceb5904$var$root[$a9334679fceb5904$var$vendors[$a9334679fceb5904$var$i] + "CancelRequest" + $a9334679fceb5904$var$suffix];
}
// Some versions of FF have rAF but not cAF
if (!$a9334679fceb5904$var$raf || !$a9334679fceb5904$var$caf) {
    var $a9334679fceb5904$var$last = 0, $a9334679fceb5904$var$id = 0, $a9334679fceb5904$var$queue = [], $a9334679fceb5904$var$frameDuration = 1000 / 60;
    $a9334679fceb5904$var$raf = function(callback) {
        if ($a9334679fceb5904$var$queue.length === 0) {
            var _now = $d78d660f0965e541$exports(), next = Math.max(0, $a9334679fceb5904$var$frameDuration - (_now - $a9334679fceb5904$var$last));
            $a9334679fceb5904$var$last = next + _now;
            setTimeout(function() {
                var cp = $a9334679fceb5904$var$queue.slice(0);
                // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue
                $a9334679fceb5904$var$queue.length = 0;
                for(var i = 0; i < cp.length; i++){
                    if (!cp[i].cancelled) try {
                        cp[i].callback($a9334679fceb5904$var$last);
                    } catch (e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                }
            }, Math.round(next));
        }
        $a9334679fceb5904$var$queue.push({
            handle: ++$a9334679fceb5904$var$id,
            callback: callback,
            cancelled: false
        });
        return $a9334679fceb5904$var$id;
    };
    $a9334679fceb5904$var$caf = function(handle) {
        for(var i = 0; i < $a9334679fceb5904$var$queue.length; i++)if ($a9334679fceb5904$var$queue[i].handle === handle) $a9334679fceb5904$var$queue[i].cancelled = true;
    };
}
$a9334679fceb5904$exports = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return $a9334679fceb5904$var$raf.call($a9334679fceb5904$var$root, fn);
};
$a9334679fceb5904$exports.cancel = function() {
    $a9334679fceb5904$var$caf.apply($a9334679fceb5904$var$root, arguments);
};
$a9334679fceb5904$exports.polyfill = function(object) {
    if (!object) object = $a9334679fceb5904$var$root;
    object.requestAnimationFrame = $a9334679fceb5904$var$raf;
    object.cancelAnimationFrame = $a9334679fceb5904$var$caf;
};


function $af5239f7b6768612$var$scroll() {
    var y = window.pageYOffset || document.documentElement.scrollTop;
    var x = window.pageXOffset || document.documentElement.scrollLeft;
    return {
        top: y,
        left: x
    };
}
function $af5239f7b6768612$var$scrollTo(x, y, options) {
    options = options || {};
    // start position
    var start = $af5239f7b6768612$var$scroll();
    // setup tween
    var tween = $6d4bd7a05b42e19a$exports(start).ease(options.ease || "out-circ").to({
        top: y,
        left: x
    }).duration(options.duration || 1000);
    // scroll
    tween.update(function(o) {
        window.scrollTo(o.left | 0, o.top | 0);
    });
    // handle end
    tween.on("end", function() {
        animate = function() {};
    });
    // animate
    function animate() {
        $a9334679fceb5904$exports(animate);
        tween.update();
    }
    animate();
    return tween;
}
$af5239f7b6768612$exports = $af5239f7b6768612$var$scrollTo;


function $22374b4858edafee$var$calculateScrollOffset(elem, additionalOffset, alignment) {
    var body = document.body, html = document.documentElement;
    var elemRect = elem.getBoundingClientRect();
    var clientHeight = html.clientHeight;
    var documentHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    additionalOffset = additionalOffset || 0;
    var scrollPosition;
    if (alignment === "bottom") scrollPosition = elemRect.bottom - clientHeight;
    else if (alignment === "middle") scrollPosition = elemRect.bottom - clientHeight / 2 - elemRect.height / 2;
    else scrollPosition = elemRect.top;
    var maxScrollPosition = documentHeight - clientHeight;
    return Math.min(scrollPosition + additionalOffset + window.pageYOffset, maxScrollPosition);
}
$22374b4858edafee$exports = function(elem, options) {
    options = options || {};
    if (typeof elem === "string") elem = document.querySelector(elem);
    if (elem) return $af5239f7b6768612$exports(0, $22374b4858edafee$var$calculateScrollOffset(elem, options.offset, options.align), options);
};


function $ecd994ee38e99d01$var$getImageSizes(containerWidth, imageSizes, padding) {
    var aspectRatios = imageSizes.map((size)=>Math.min(1.33, Math.max(0.8, size.width / size.height)));
    var ratioSum = aspectRatios.reduce((total, ratio)=>total + ratio, 0);
    var imageWidths = aspectRatios.map((ratio)=>Math.floor(ratio / ratioSum * containerWidth));
    var imageHeight = Math.floor(containerWidth / ratioSum - padding);
    return imageWidths.map((width)=>({
            width: width,
            height: imageHeight
        }));
}
function $ecd994ee38e99d01$var$convertToRows(array, itemsPerRow) {
    return array.reduce((accum, item)=>{
        const lastRow = accum[accum.length - 1];
        if (lastRow && lastRow.length < itemsPerRow) {
            lastRow.push(item);
            return accum;
        } else return accum.concat([
            [
                item
            ]
        ]);
    }, []);
}
class $ecd994ee38e99d01$var$Grid extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutsideSort = this.handleClickOutsideSort.bind(this);
    }
    static defaultProps = {
        items: [],
        showingItems: []
    };
    state = {
        containerWidth: 1024,
        itemsPerRow: 4,
        isMounted: false,
        numberOfShowing: typeof this.props.gridItems !== "undefined" && this.props.gridItems.length ? this.props.gridItems.length : 0,
        sortOpen: false,
        scrollPosition: 0
    };
    componentDidMount() {
        this.updateDimensions();
        this.setState({
            isMounted: true
        });
        window.addEventListener("resize", this.updateDimensions);
        window.addEventListener("mousedown", this.handleClickOutsideSort);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
        window.addEventListener("mousedown", this.handleClickOutsideSort);
    }
    setWrapperRef(node) {
        this.wrapperRef = node;
    }
    handleClickOutsideSort(event) {
        event.stopPropagation();
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.sortOpen) this._sortToggle();
    }
    updateDimensions = ()=>{
        const containerWidth = this.container.offsetWidth;
        let itemsPerRow = 2;
        if (window.innerWidth > 1024) itemsPerRow = 5;
        else if (window.innerWidth > 768) itemsPerRow = 4;
        else if (window.innerWidth > 480) itemsPerRow = 3;
        this.setState({
            containerWidth: containerWidth,
            itemsPerRow: itemsPerRow
        });
    };
    getRows = ()=>{
        const items = this.props.gridItems;
        const { containerWidth: containerWidth, itemsPerRow: itemsPerRow } = this.state;
        if (typeof items !== "undefined" && items.length) {
            const rows = $ecd994ee38e99d01$var$convertToRows(items, itemsPerRow);
            return rows.map((row)=>{
                const adjustedContainerWidth = row.length === itemsPerRow ? containerWidth : containerWidth * row.length / itemsPerRow;
                const newImageSizes = $ecd994ee38e99d01$var$getImageSizes(adjustedContainerWidth, row.map((item)=>item.image), 20);
                return row.map((item, index)=>Object.assign({}, item, {
                        image: Object.assign({}, item.image, newImageSizes[index] || null)
                    }));
            });
        } else return [];
    };
    _clickThumb = (e, id)=>{
        this.props.clickThumb(id);
        (0, (/*@__PURE__*/$parcel$interopDefault($22374b4858edafee$exports)))("#gallery-carousel", {
            offset: -90,
            ease: "in-sine",
            duration: 300
        });
    };
    _showMore = ()=>{
        this.props.showMore();
    };
    _sortToggle = (e)=>{
        this.setState((prevState)=>({
                sortOpen: !prevState.sortOpen
            }));
    };
    _gallerySort(by) {
        this.props.sortBy(by);
    }
    componentDidUpdate() {
        if (this.props.setScrollPos) {
            document.documentElement.scrollTop = document.body.scrollTop = this.props.scrollPosition;
            this.props.scrollPosIsSet(true);
        }
    }
    render() {
        let lastHeight;
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: "gallery-list-info",
                    children: [
                        this.props.items && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h3", {
                            children: this.props.gridTitle.replace((0, $2860f5f07c24e63c$export$2e2bcd8739ae039).selectors.numberOfHits, this.props.items.length)
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                            className: "gallery-sort",
                            ref: this.setWrapperRef,
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("button", {
                                    type: "button",
                                    onClick: this._sortToggle,
                                    className: "button button-select-trigger filter-trigger on-white " + (this.state.sortOpen ? " active" : ""),
                                    "data-tab-set": "filters",
                                    "data-can-toggle-close": "true",
                                    "data-tab-toggle": "#filter-3",
                                    "aria-expanded": "false",
                                    "aria-controls": "filter-year-or-session",
                                    "data-decisions-period-filter": "true",
                                    children: [
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                                            "data-page-text": "TimePeriodText",
                                            children: [
                                                this.props.cmsData.sortText,
                                                ":"
                                            ]
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                            className: "selected",
                                            "data-selected": "true",
                                            children: this.props.sortedBy
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                    id: "gallery-sort",
                                    className: "travel-list-comittee-filter filter" + (this.state.sortOpen ? " open" : null),
                                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("fieldset", {
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("legend", {
                                                className: "visuallyhidden",
                                                children: (0, $af1a830b203b2f3e$export$2e2bcd8739ae039).get("choose")
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("ul", {
                                                className: "comittee-list",
                                                "data-comittee-list": true,
                                                children: [
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>this._gallerySort("relevance"),
                                                            "data-sort": "relevance",
                                                            children: this.props.cmsData.sortRelevanceText
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>this._gallerySort("title-asc"),
                                                            "data-sort": "title-asc",
                                                            children: this.props.cmsData.sortTitleAscText
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>this._gallerySort("time-desc"),
                                                            "data-sort": "time-desc",
                                                            children: this.props.cmsData.sortTimeDescText
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>this._gallerySort("time-asc"),
                                                            "data-sort": "time-asc",
                                                            children: this.props.cmsData.sortTimeAscText
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>this._gallerySort("artist-lastname-asc"),
                                                            "data-sort": "artist-lastname-asc",
                                                            children: this.props.cmsData.sortArtistLastnameText
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: "grid-outer",
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            className: "grid",
                            ref: (div)=>this.container = div,
                            children: this.getRows().map((items, theindex)=>items.map((item, index)=>{
                                    let lastRow = false;
                                    if (items.length !== this.state.itemsPerRow) lastRow = true;
                                    const { width: width, height: height } = this.state.isMounted ? item.image : {
                                        width: 20,
                                        height: 19
                                    };
                                    lastHeight = height;
                                    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                        className: "gallery-list",
                                        style: {
                                            width: width
                                        },
                                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $d812be733f3baed4$export$2e2bcd8739ae039), {
                                            item: item,
                                            url: (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).url.getUrlForItem(item),
                                            clickThumb: this._clickThumb,
                                            imageHeight: height,
                                            imageWidth: width,
                                            lastRow: lastRow,
                                            pos: theindex * this.state.itemsPerRow + index,
                                            noDateText: this.props.noDateText
                                        })
                                    }, theindex * this.state.itemsPerRow + index);
                                }))
                        }),
                        typeof this.props.gridItems !== "undefined" && this.props.gridItems.length && this.props.gridItems.length >= this.props.items.length ? null : /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                            className: "btn-link",
                            onClick: this._showMore,
                            type: "button",
                            children: this.props.cmsData.showMoreHitsText
                        })
                    ]
                })
            ]
        });
    }
}
var $ecd994ee38e99d01$export$2e2bcd8739ae039 = $ecd994ee38e99d01$var$Grid;



var $7c0f56d4984059c7$exports = {};
"use strict";
Object.defineProperty($7c0f56d4984059c7$exports, "__esModule", {
    value: true
});
var $7c0f56d4984059c7$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $7c0f56d4984059c7$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $8NFma = parcelRequire("8NFma");
var $7c0f56d4984059c7$var$_react2 = $7c0f56d4984059c7$var$_interopRequireDefault($8NFma);

var $7c0f56d4984059c7$var$_propTypes2 = $7c0f56d4984059c7$var$_interopRequireDefault($b0c83d16b421d7f5$exports);
var $84979cd536bb8b33$exports = {};

/*!
 * imagesLoaded v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */ (function(window1, factory) {
    "use strict";
    // universal module definition
    /*global define: false, module: false, require: false */ if (typeof define == "function" && define.amd) // AMD
    define([
        "ev-emitter/ev-emitter"
    ], function(EvEmitter) {
        return factory(window1, EvEmitter);
    });
    else if (0, $84979cd536bb8b33$exports) // CommonJS
    $84979cd536bb8b33$exports = factory(window1, (parcelRequire("6egII")));
    else // browser global
    window1.imagesLoaded = factory(window1, window1.EvEmitter);
})(typeof window !== "undefined" ? window : $84979cd536bb8b33$exports, // --------------------------  factory -------------------------- //
function factory(window1, EvEmitter) {
    "use strict";
    var $ = window1.jQuery;
    var console = window1.console;
    // -------------------------- helpers -------------------------- //
    // extend objects
    function extend(a, b) {
        for(var prop in b)a[prop] = b[prop];
        return a;
    }
    var arraySlice = Array.prototype.slice;
    // turn element or nodeList into an array
    function makeArray(obj) {
        if (Array.isArray(obj)) // use object if already an array
        return obj;
        var isArrayLike = typeof obj == "object" && typeof obj.length == "number";
        if (isArrayLike) // convert nodeList to array
        return arraySlice.call(obj);
        // array of single index
        return [
            obj
        ];
    }
    // -------------------------- imagesLoaded -------------------------- //
    /**
 * @param {Array, Element, NodeList, String} elem
 * @param {Object or Function} options - if function, use as callback
 * @param {Function} onAlways - callback function
 */ function ImagesLoaded(elem, options, onAlways) {
        // coerce ImagesLoaded() without new, to be new ImagesLoaded()
        if (!(this instanceof ImagesLoaded)) return new ImagesLoaded(elem, options, onAlways);
        // use elem as selector string
        var queryElem = elem;
        if (typeof elem == "string") queryElem = document.querySelectorAll(elem);
        // bail if bad element
        if (!queryElem) {
            console.error("Bad element for imagesLoaded " + (queryElem || elem));
            return;
        }
        this.elements = makeArray(queryElem);
        this.options = extend({}, this.options);
        // shift arguments if no options set
        if (typeof options == "function") onAlways = options;
        else extend(this.options, options);
        if (onAlways) this.on("always", onAlways);
        this.getImages();
        if ($) // add jQuery Deferred object
        this.jqDeferred = new $.Deferred();
        // HACK check async to allow time to bind listeners
        setTimeout(this.check.bind(this));
    }
    ImagesLoaded.prototype = Object.create(EvEmitter.prototype);
    ImagesLoaded.prototype.options = {};
    ImagesLoaded.prototype.getImages = function() {
        this.images = [];
        // filter & find items if we have an item selector
        this.elements.forEach(this.addElementImages, this);
    };
    /**
 * @param {Node} element
 */ ImagesLoaded.prototype.addElementImages = function(elem) {
        // filter siblings
        if (elem.nodeName == "IMG") this.addImage(elem);
        // get background image on element
        if (this.options.background === true) this.addElementBackgroundImages(elem);
        // find children
        // no non-element nodes, #143
        var nodeType = elem.nodeType;
        if (!nodeType || !elementNodeTypes[nodeType]) return;
        var childImgs = elem.querySelectorAll("img");
        // concat childElems to filterFound array
        for(var i = 0; i < childImgs.length; i++){
            var img = childImgs[i];
            this.addImage(img);
        }
        // get child background images
        if (typeof this.options.background == "string") {
            var children = elem.querySelectorAll(this.options.background);
            for(i = 0; i < children.length; i++){
                var child = children[i];
                this.addElementBackgroundImages(child);
            }
        }
    };
    var elementNodeTypes = {
        1: true,
        9: true,
        11: true
    };
    ImagesLoaded.prototype.addElementBackgroundImages = function(elem) {
        var style = getComputedStyle(elem);
        if (!style) // Firefox returns null if in a hidden iframe https://bugzil.la/548397
        return;
        // get url inside url("...")
        var reURL = /url\((['"])?(.*?)\1\)/gi;
        var matches = reURL.exec(style.backgroundImage);
        while(matches !== null){
            var url = matches && matches[2];
            if (url) this.addBackground(url, elem);
            matches = reURL.exec(style.backgroundImage);
        }
    };
    /**
 * @param {Image} img
 */ ImagesLoaded.prototype.addImage = function(img) {
        var loadingImage = new LoadingImage(img);
        this.images.push(loadingImage);
    };
    ImagesLoaded.prototype.addBackground = function(url, elem) {
        var background = new Background(url, elem);
        this.images.push(background);
    };
    ImagesLoaded.prototype.check = function() {
        var _this = this;
        this.progressedCount = 0;
        this.hasAnyBroken = false;
        // complete if no images
        if (!this.images.length) {
            this.complete();
            return;
        }
        function onProgress(image, elem, message) {
            // HACK - Chrome triggers event before object properties have changed. #83
            setTimeout(function() {
                _this.progress(image, elem, message);
            });
        }
        this.images.forEach(function(loadingImage) {
            loadingImage.once("progress", onProgress);
            loadingImage.check();
        });
    };
    ImagesLoaded.prototype.progress = function(image, elem, message) {
        this.progressedCount++;
        this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
        // progress event
        this.emitEvent("progress", [
            this,
            image,
            elem
        ]);
        if (this.jqDeferred && this.jqDeferred.notify) this.jqDeferred.notify(this, image);
        // check if completed
        if (this.progressedCount == this.images.length) this.complete();
        if (this.options.debug && console) console.log("progress: " + message, image, elem);
    };
    ImagesLoaded.prototype.complete = function() {
        var eventName = this.hasAnyBroken ? "fail" : "done";
        this.isComplete = true;
        this.emitEvent(eventName, [
            this
        ]);
        this.emitEvent("always", [
            this
        ]);
        if (this.jqDeferred) {
            var jqMethod = this.hasAnyBroken ? "reject" : "resolve";
            this.jqDeferred[jqMethod](this);
        }
    };
    // --------------------------  -------------------------- //
    function LoadingImage(img) {
        this.img = img;
    }
    LoadingImage.prototype = Object.create(EvEmitter.prototype);
    LoadingImage.prototype.check = function() {
        // If complete is true and browser supports natural sizes,
        // try to check for image status manually.
        var isComplete = this.getIsImageComplete();
        if (isComplete) {
            // report based on naturalWidth
            this.confirm(this.img.naturalWidth !== 0, "naturalWidth");
            return;
        }
        // If none of the checks above matched, simulate loading on detached element.
        this.proxyImage = new Image();
        this.proxyImage.addEventListener("load", this);
        this.proxyImage.addEventListener("error", this);
        // bind to image as well for Firefox. #191
        this.img.addEventListener("load", this);
        this.img.addEventListener("error", this);
        this.proxyImage.src = this.img.src;
    };
    LoadingImage.prototype.getIsImageComplete = function() {
        // check for non-zero, non-undefined naturalWidth
        // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
        return this.img.complete && this.img.naturalWidth;
    };
    LoadingImage.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        this.emitEvent("progress", [
            this,
            this.img,
            message
        ]);
    };
    // ----- events ----- //
    // trigger specified handler for event type
    LoadingImage.prototype.handleEvent = function(event) {
        var method = "on" + event.type;
        if (this[method]) this[method](event);
    };
    LoadingImage.prototype.onload = function() {
        this.confirm(true, "onload");
        this.unbindEvents();
    };
    LoadingImage.prototype.onerror = function() {
        this.confirm(false, "onerror");
        this.unbindEvents();
    };
    LoadingImage.prototype.unbindEvents = function() {
        this.proxyImage.removeEventListener("load", this);
        this.proxyImage.removeEventListener("error", this);
        this.img.removeEventListener("load", this);
        this.img.removeEventListener("error", this);
    };
    // -------------------------- Background -------------------------- //
    function Background(url, element) {
        this.url = url;
        this.element = element;
        this.img = new Image();
    }
    // inherit LoadingImage prototype
    Background.prototype = Object.create(LoadingImage.prototype);
    Background.prototype.check = function() {
        this.img.addEventListener("load", this);
        this.img.addEventListener("error", this);
        this.img.src = this.url;
        // check if image is already complete
        var isComplete = this.getIsImageComplete();
        if (isComplete) {
            this.confirm(this.img.naturalWidth !== 0, "naturalWidth");
            this.unbindEvents();
        }
    };
    Background.prototype.unbindEvents = function() {
        this.img.removeEventListener("load", this);
        this.img.removeEventListener("error", this);
    };
    Background.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        this.emitEvent("progress", [
            this,
            this.element,
            message
        ]);
    };
    // -------------------------- jQuery -------------------------- //
    ImagesLoaded.makeJQueryPlugin = function(jQuery) {
        jQuery = jQuery || window1.jQuery;
        if (!jQuery) return;
        // set local variable
        $ = jQuery;
        // $().imagesLoaded()
        $.fn.imagesLoaded = function(options, callback) {
            var instance = new ImagesLoaded(this, options, callback);
            return instance.jqDeferred.promise($(this));
        };
    };
    // try making plugin
    ImagesLoaded.makeJQueryPlugin();
    // --------------------------  -------------------------- //
    return ImagesLoaded;
});


var $7c0f56d4984059c7$var$_imagesloaded2 = $7c0f56d4984059c7$var$_interopRequireDefault($84979cd536bb8b33$exports);
var $e97c31e13ca7cbde$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var $e97c31e13ca7cbde$var$LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var $e97c31e13ca7cbde$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used as references for various `Number` constants. */ var $e97c31e13ca7cbde$var$INFINITY = 1 / 0, $e97c31e13ca7cbde$var$MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var $e97c31e13ca7cbde$var$argsTag = "[object Arguments]", $e97c31e13ca7cbde$var$funcTag = "[object Function]", $e97c31e13ca7cbde$var$genTag = "[object GeneratorFunction]", $e97c31e13ca7cbde$var$symbolTag = "[object Symbol]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $e97c31e13ca7cbde$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $e97c31e13ca7cbde$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var $e97c31e13ca7cbde$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/** Detect free variable `global` from Node.js. */ var $e97c31e13ca7cbde$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $e97c31e13ca7cbde$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $e97c31e13ca7cbde$var$root = $e97c31e13ca7cbde$var$freeGlobal || $e97c31e13ca7cbde$var$freeSelf || Function("return this")();
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $e97c31e13ca7cbde$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $e97c31e13ca7cbde$var$arrayIncludes(array, value) {
    var length = array ? array.length : 0;
    return !!length && $e97c31e13ca7cbde$var$baseIndexOf(array, value, 0) > -1;
}
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $e97c31e13ca7cbde$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $e97c31e13ca7cbde$var$arrayMap(array, iteratee) {
    var index = -1, length = array ? array.length : 0, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $e97c31e13ca7cbde$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e97c31e13ca7cbde$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e97c31e13ca7cbde$var$baseIndexOf(array, value, fromIndex) {
    if (value !== value) return $e97c31e13ca7cbde$var$baseFindIndex(array, $e97c31e13ca7cbde$var$baseIsNaN, fromIndex);
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $e97c31e13ca7cbde$var$baseIsNaN(value) {
    return value !== value;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $e97c31e13ca7cbde$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $e97c31e13ca7cbde$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e97c31e13ca7cbde$var$cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $e97c31e13ca7cbde$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $e97c31e13ca7cbde$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $e97c31e13ca7cbde$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $e97c31e13ca7cbde$var$arrayProto = Array.prototype, $e97c31e13ca7cbde$var$funcProto = Function.prototype, $e97c31e13ca7cbde$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $e97c31e13ca7cbde$var$coreJsData = $e97c31e13ca7cbde$var$root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var $e97c31e13ca7cbde$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($e97c31e13ca7cbde$var$coreJsData && $e97c31e13ca7cbde$var$coreJsData.keys && $e97c31e13ca7cbde$var$coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var $e97c31e13ca7cbde$var$funcToString = $e97c31e13ca7cbde$var$funcProto.toString;
/** Used to check objects for own properties. */ var $e97c31e13ca7cbde$var$hasOwnProperty = $e97c31e13ca7cbde$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e97c31e13ca7cbde$var$objectToString = $e97c31e13ca7cbde$var$objectProto.toString;
/** Used to detect if a method is native. */ var $e97c31e13ca7cbde$var$reIsNative = RegExp("^" + $e97c31e13ca7cbde$var$funcToString.call($e97c31e13ca7cbde$var$hasOwnProperty).replace($e97c31e13ca7cbde$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var $e97c31e13ca7cbde$var$Symbol = $e97c31e13ca7cbde$var$root.Symbol, $e97c31e13ca7cbde$var$getPrototype = $e97c31e13ca7cbde$var$overArg(Object.getPrototypeOf, Object), $e97c31e13ca7cbde$var$propertyIsEnumerable = $e97c31e13ca7cbde$var$objectProto.propertyIsEnumerable, $e97c31e13ca7cbde$var$splice = $e97c31e13ca7cbde$var$arrayProto.splice, $e97c31e13ca7cbde$var$spreadableSymbol = $e97c31e13ca7cbde$var$Symbol ? $e97c31e13ca7cbde$var$Symbol.isConcatSpreadable : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e97c31e13ca7cbde$var$nativeGetSymbols = Object.getOwnPropertySymbols, $e97c31e13ca7cbde$var$nativeMax = Math.max;
/* Built-in method references that are verified to be native. */ var $e97c31e13ca7cbde$var$Map = $e97c31e13ca7cbde$var$getNative($e97c31e13ca7cbde$var$root, "Map"), $e97c31e13ca7cbde$var$nativeCreate = $e97c31e13ca7cbde$var$getNative(Object, "create");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e97c31e13ca7cbde$var$Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $e97c31e13ca7cbde$var$hashClear() {
    this.__data__ = $e97c31e13ca7cbde$var$nativeCreate ? $e97c31e13ca7cbde$var$nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e97c31e13ca7cbde$var$hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e97c31e13ca7cbde$var$hashGet(key) {
    var data = this.__data__;
    if ($e97c31e13ca7cbde$var$nativeCreate) {
        var result = data[key];
        return result === $e97c31e13ca7cbde$var$HASH_UNDEFINED ? undefined : result;
    }
    return $e97c31e13ca7cbde$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e97c31e13ca7cbde$var$hashHas(key) {
    var data = this.__data__;
    return $e97c31e13ca7cbde$var$nativeCreate ? data[key] !== undefined : $e97c31e13ca7cbde$var$hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $e97c31e13ca7cbde$var$hashSet(key, value) {
    var data = this.__data__;
    data[key] = $e97c31e13ca7cbde$var$nativeCreate && value === undefined ? $e97c31e13ca7cbde$var$HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
$e97c31e13ca7cbde$var$Hash.prototype.clear = $e97c31e13ca7cbde$var$hashClear;
$e97c31e13ca7cbde$var$Hash.prototype["delete"] = $e97c31e13ca7cbde$var$hashDelete;
$e97c31e13ca7cbde$var$Hash.prototype.get = $e97c31e13ca7cbde$var$hashGet;
$e97c31e13ca7cbde$var$Hash.prototype.has = $e97c31e13ca7cbde$var$hashHas;
$e97c31e13ca7cbde$var$Hash.prototype.set = $e97c31e13ca7cbde$var$hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e97c31e13ca7cbde$var$ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $e97c31e13ca7cbde$var$listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e97c31e13ca7cbde$var$listCacheDelete(key) {
    var data = this.__data__, index = $e97c31e13ca7cbde$var$assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $e97c31e13ca7cbde$var$splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e97c31e13ca7cbde$var$listCacheGet(key) {
    var data = this.__data__, index = $e97c31e13ca7cbde$var$assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e97c31e13ca7cbde$var$listCacheHas(key) {
    return $e97c31e13ca7cbde$var$assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $e97c31e13ca7cbde$var$listCacheSet(key, value) {
    var data = this.__data__, index = $e97c31e13ca7cbde$var$assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
$e97c31e13ca7cbde$var$ListCache.prototype.clear = $e97c31e13ca7cbde$var$listCacheClear;
$e97c31e13ca7cbde$var$ListCache.prototype["delete"] = $e97c31e13ca7cbde$var$listCacheDelete;
$e97c31e13ca7cbde$var$ListCache.prototype.get = $e97c31e13ca7cbde$var$listCacheGet;
$e97c31e13ca7cbde$var$ListCache.prototype.has = $e97c31e13ca7cbde$var$listCacheHas;
$e97c31e13ca7cbde$var$ListCache.prototype.set = $e97c31e13ca7cbde$var$listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e97c31e13ca7cbde$var$MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $e97c31e13ca7cbde$var$mapCacheClear() {
    this.__data__ = {
        "hash": new $e97c31e13ca7cbde$var$Hash,
        "map": new ($e97c31e13ca7cbde$var$Map || $e97c31e13ca7cbde$var$ListCache),
        "string": new $e97c31e13ca7cbde$var$Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e97c31e13ca7cbde$var$mapCacheDelete(key) {
    return $e97c31e13ca7cbde$var$getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e97c31e13ca7cbde$var$mapCacheGet(key) {
    return $e97c31e13ca7cbde$var$getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e97c31e13ca7cbde$var$mapCacheHas(key) {
    return $e97c31e13ca7cbde$var$getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $e97c31e13ca7cbde$var$mapCacheSet(key, value) {
    $e97c31e13ca7cbde$var$getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
$e97c31e13ca7cbde$var$MapCache.prototype.clear = $e97c31e13ca7cbde$var$mapCacheClear;
$e97c31e13ca7cbde$var$MapCache.prototype["delete"] = $e97c31e13ca7cbde$var$mapCacheDelete;
$e97c31e13ca7cbde$var$MapCache.prototype.get = $e97c31e13ca7cbde$var$mapCacheGet;
$e97c31e13ca7cbde$var$MapCache.prototype.has = $e97c31e13ca7cbde$var$mapCacheHas;
$e97c31e13ca7cbde$var$MapCache.prototype.set = $e97c31e13ca7cbde$var$mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $e97c31e13ca7cbde$var$SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new $e97c31e13ca7cbde$var$MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $e97c31e13ca7cbde$var$setCacheAdd(value) {
    this.__data__.set(value, $e97c31e13ca7cbde$var$HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $e97c31e13ca7cbde$var$setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
$e97c31e13ca7cbde$var$SetCache.prototype.add = $e97c31e13ca7cbde$var$SetCache.prototype.push = $e97c31e13ca7cbde$var$setCacheAdd;
$e97c31e13ca7cbde$var$SetCache.prototype.has = $e97c31e13ca7cbde$var$setCacheHas;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $e97c31e13ca7cbde$var$arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = $e97c31e13ca7cbde$var$isArray(value) || $e97c31e13ca7cbde$var$isArguments(value) ? $e97c31e13ca7cbde$var$baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || $e97c31e13ca7cbde$var$hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || $e97c31e13ca7cbde$var$isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e97c31e13ca7cbde$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($e97c31e13ca7cbde$var$eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $e97c31e13ca7cbde$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $e97c31e13ca7cbde$var$arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $e97c31e13ca7cbde$var$arrayMap(values, $e97c31e13ca7cbde$var$baseUnary(iteratee));
    if (comparator) {
        includes = $e97c31e13ca7cbde$var$arrayIncludesWith;
        isCommon = false;
    } else if (values.length >= $e97c31e13ca7cbde$var$LARGE_ARRAY_SIZE) {
        includes = $e97c31e13ca7cbde$var$cacheHas;
        isCommon = false;
        values = new $e97c31e13ca7cbde$var$SetCache(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $e97c31e13ca7cbde$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $e97c31e13ca7cbde$var$isFlattenable);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $e97c31e13ca7cbde$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $e97c31e13ca7cbde$var$arrayPush(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $e97c31e13ca7cbde$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $e97c31e13ca7cbde$var$isArray(object) ? result : $e97c31e13ca7cbde$var$arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $e97c31e13ca7cbde$var$baseIsNative(value) {
    if (!$e97c31e13ca7cbde$var$isObject(value) || $e97c31e13ca7cbde$var$isMasked(value)) return false;
    var pattern = $e97c31e13ca7cbde$var$isFunction(value) || $e97c31e13ca7cbde$var$isHostObject(value) ? $e97c31e13ca7cbde$var$reIsNative : $e97c31e13ca7cbde$var$reIsHostCtor;
    return pattern.test($e97c31e13ca7cbde$var$toSource(value));
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e97c31e13ca7cbde$var$baseKeysIn(object) {
    if (!$e97c31e13ca7cbde$var$isObject(object)) return $e97c31e13ca7cbde$var$nativeKeysIn(object);
    var isProto = $e97c31e13ca7cbde$var$isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$e97c31e13ca7cbde$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick.
 * @returns {Object} Returns the new object.
 */ function $e97c31e13ca7cbde$var$basePick(object, props) {
    object = Object(object);
    return $e97c31e13ca7cbde$var$basePickBy(object, props, function(value, key) {
        return key in object;
    });
}
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick from.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $e97c31e13ca7cbde$var$basePickBy(object, props, predicate) {
    var index = -1, length = props.length, result = {};
    while(++index < length){
        var key = props[index], value = object[key];
        if (predicate(value, key)) result[key] = value;
    }
    return result;
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $e97c31e13ca7cbde$var$baseRest(func, start) {
    start = $e97c31e13ca7cbde$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $e97c31e13ca7cbde$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = array;
        return $e97c31e13ca7cbde$var$apply(func, this, otherArgs);
    };
}
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $e97c31e13ca7cbde$var$getAllKeysIn(object) {
    return $e97c31e13ca7cbde$var$baseGetAllKeys(object, $e97c31e13ca7cbde$var$keysIn, $e97c31e13ca7cbde$var$getSymbolsIn);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $e97c31e13ca7cbde$var$getMapData(map, key) {
    var data = map.__data__;
    return $e97c31e13ca7cbde$var$isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $e97c31e13ca7cbde$var$getNative(object, key) {
    var value = $e97c31e13ca7cbde$var$getValue(object, key);
    return $e97c31e13ca7cbde$var$baseIsNative(value) ? value : undefined;
}
/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $e97c31e13ca7cbde$var$getSymbols = $e97c31e13ca7cbde$var$nativeGetSymbols ? $e97c31e13ca7cbde$var$overArg($e97c31e13ca7cbde$var$nativeGetSymbols, Object) : $e97c31e13ca7cbde$var$stubArray;
/**
 * Creates an array of the own and inherited enumerable symbol properties
 * of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $e97c31e13ca7cbde$var$getSymbolsIn = !$e97c31e13ca7cbde$var$nativeGetSymbols ? $e97c31e13ca7cbde$var$stubArray : function(object) {
    var result = [];
    while(object){
        $e97c31e13ca7cbde$var$arrayPush(result, $e97c31e13ca7cbde$var$getSymbols(object));
        object = $e97c31e13ca7cbde$var$getPrototype(object);
    }
    return result;
};
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $e97c31e13ca7cbde$var$isFlattenable(value) {
    return $e97c31e13ca7cbde$var$isArray(value) || $e97c31e13ca7cbde$var$isArguments(value) || !!($e97c31e13ca7cbde$var$spreadableSymbol && value && value[$e97c31e13ca7cbde$var$spreadableSymbol]);
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $e97c31e13ca7cbde$var$isIndex(value, length) {
    length = length == null ? $e97c31e13ca7cbde$var$MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || $e97c31e13ca7cbde$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $e97c31e13ca7cbde$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $e97c31e13ca7cbde$var$isMasked(func) {
    return !!$e97c31e13ca7cbde$var$maskSrcKey && $e97c31e13ca7cbde$var$maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $e97c31e13ca7cbde$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $e97c31e13ca7cbde$var$objectProto;
    return value === proto;
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e97c31e13ca7cbde$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $e97c31e13ca7cbde$var$toKey(value) {
    if (typeof value == "string" || $e97c31e13ca7cbde$var$isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$e97c31e13ca7cbde$var$INFINITY ? "-0" : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $e97c31e13ca7cbde$var$toSource(func) {
    if (func != null) {
        try {
            return $e97c31e13ca7cbde$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $e97c31e13ca7cbde$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function $e97c31e13ca7cbde$var$isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return $e97c31e13ca7cbde$var$isArrayLikeObject(value) && $e97c31e13ca7cbde$var$hasOwnProperty.call(value, "callee") && (!$e97c31e13ca7cbde$var$propertyIsEnumerable.call(value, "callee") || $e97c31e13ca7cbde$var$objectToString.call(value) == $e97c31e13ca7cbde$var$argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $e97c31e13ca7cbde$var$isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $e97c31e13ca7cbde$var$isArrayLike(value) {
    return value != null && $e97c31e13ca7cbde$var$isLength(value.length) && !$e97c31e13ca7cbde$var$isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $e97c31e13ca7cbde$var$isArrayLikeObject(value) {
    return $e97c31e13ca7cbde$var$isObjectLike(value) && $e97c31e13ca7cbde$var$isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $e97c31e13ca7cbde$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $e97c31e13ca7cbde$var$isObject(value) ? $e97c31e13ca7cbde$var$objectToString.call(value) : "";
    return tag == $e97c31e13ca7cbde$var$funcTag || tag == $e97c31e13ca7cbde$var$genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $e97c31e13ca7cbde$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $e97c31e13ca7cbde$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $e97c31e13ca7cbde$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $e97c31e13ca7cbde$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $e97c31e13ca7cbde$var$isSymbol(value) {
    return typeof value == "symbol" || $e97c31e13ca7cbde$var$isObjectLike(value) && $e97c31e13ca7cbde$var$objectToString.call(value) == $e97c31e13ca7cbde$var$symbolTag;
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $e97c31e13ca7cbde$var$keysIn(object) {
    return $e97c31e13ca7cbde$var$isArrayLike(object) ? $e97c31e13ca7cbde$var$arrayLikeKeys(object, true) : $e97c31e13ca7cbde$var$baseKeysIn(object);
}
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable string keyed properties of `object` that are
 * not omitted.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [props] The property identifiers to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $e97c31e13ca7cbde$var$omit = $e97c31e13ca7cbde$var$baseRest(function(object, props) {
    if (object == null) return {};
    props = $e97c31e13ca7cbde$var$arrayMap($e97c31e13ca7cbde$var$baseFlatten(props, 1), $e97c31e13ca7cbde$var$toKey);
    return $e97c31e13ca7cbde$var$basePick(object, $e97c31e13ca7cbde$var$baseDifference($e97c31e13ca7cbde$var$getAllKeysIn(object), props));
});
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $e97c31e13ca7cbde$var$stubArray() {
    return [];
}
$e97c31e13ca7cbde$exports = $e97c31e13ca7cbde$var$omit;


var $7c0f56d4984059c7$var$_lodash2 = $7c0f56d4984059c7$var$_interopRequireDefault($e97c31e13ca7cbde$exports);
function $7c0f56d4984059c7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7c0f56d4984059c7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7c0f56d4984059c7$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $7c0f56d4984059c7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $7c0f56d4984059c7$var$ImagesLoaded = function(_Component) {
    $7c0f56d4984059c7$var$_inherits(ImagesLoaded, _Component);
    function ImagesLoaded() {
        $7c0f56d4984059c7$var$_classCallCheck(this, ImagesLoaded);
        return $7c0f56d4984059c7$var$_possibleConstructorReturn(this, (ImagesLoaded.__proto__ || Object.getPrototypeOf(ImagesLoaded)).apply(this, arguments));
    }
    $7c0f56d4984059c7$var$_createClass(ImagesLoaded, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _props = this.props, onAlways = _props.onAlways, done = _props.done, onFail = _props.onFail, onProgress = _props.onProgress, background = _props.background;
                var elemContainer = this.refs.elemContainer;
                /* Initializing imagesLoaded */ this.imagesLoaded = (0, $7c0f56d4984059c7$var$_imagesloaded2.default)(elemContainer, {
                    background: background
                });
                // add events
                this.imagesLoaded.on("always", onAlways);
                this.imagesLoaded.on("done", done);
                this.imagesLoaded.on("fail", onFail);
                this.imagesLoaded.on("progress", onProgress);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var _props2 = this.props, onAlways = _props2.onAlways, done = _props2.done, onFail = _props2.onFail, onProgress = _props2.onProgress;
                // unbinding the events
                this.imagesLoaded.off("always", onAlways);
                this.imagesLoaded.off("done", done);
                this.imagesLoaded.off("fail", onFail);
                this.imagesLoaded.off("progress", onProgress);
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                var props = (0, $7c0f56d4984059c7$var$_lodash2.default)(this.props, Object.keys($7c0f56d4984059c7$var$propTypes));
                return $7c0f56d4984059c7$var$_react2.default.createElement(this.props.elementType, $7c0f56d4984059c7$var$_extends({
                    ref: "elemContainer"
                }, props), children);
            }
        }
    ]);
    return ImagesLoaded;
}($8NFma.Component);
$7c0f56d4984059c7$exports.default = $7c0f56d4984059c7$var$ImagesLoaded;
$7c0f56d4984059c7$var$ImagesLoaded.defaultProps = {
    elementType: "div",
    className: "images-loaded-container",
    background: false
};
var $7c0f56d4984059c7$var$propTypes = {
    elementType: $7c0f56d4984059c7$var$_propTypes2.default.string,
    onAlways: $7c0f56d4984059c7$var$_propTypes2.default.func,
    done: $7c0f56d4984059c7$var$_propTypes2.default.func,
    onFail: $7c0f56d4984059c7$var$_propTypes2.default.func,
    onProgress: $7c0f56d4984059c7$var$_propTypes2.default.func,
    background: $7c0f56d4984059c7$var$_propTypes2.default.oneOfType([
        $7c0f56d4984059c7$var$_propTypes2.default.string,
        $7c0f56d4984059c7$var$_propTypes2.default.bool
    ])
};


class $a232618164564307$var$ImageMeasurer extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    static propTypes = {
        items: (0, (/*@__PURE__*/$parcel$interopDefault($b0c83d16b421d7f5$exports))).array
    };
    constructor(props){
        super(props);
        this._sortBy = this._sortBy.bind(this);
        this._setImageDimensions = this._setImageDimensions.bind(this);
    }
    state = {
        shouldRenderGrid: false,
        itemsWithDimensions: [],
        firstPage: true
    };
    items = [];
    scrollPosition = 0;
    showMoreIsClicked = false;
    _measureImagesWhenReady = ()=>{
        const imagesReady = this.items.every(function(item) {
            return item.img && item.img.complete;
        });
        if (imagesReady) this._setImageDimensions();
    };
    _clickThumb = (id)=>{
        this.props.clickThumb(id);
    };
    _sortBy = (by)=>{
        this.props.sortBy(by);
    };
    _showMore = (e)=>{
        this.props.showMore();
        // save scroll position
        this.scrollPosition = window.pageYOffset;
        this.showMoreIsClicked = true;
    };
    _scrollPosIsSet = (e)=>{
        this.showMoreIsClicked = false;
    };
    _prepareImages = (items)=>{
        return items.map((item)=>{
            return Object.assign(item.item, {
                image: {
                    src: item.img.src,
                    height: item.img.offsetHeight,
                    width: item.img.offsetWidth
                }
            });
        });
    };
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.shouldRenderGrid) this.setState({
            shouldRenderGrid: false,
            firstPage: false
        });
    }
    _setImageDimensions() {
        if (!this.state.shouldRenderGrid) this.setState({
            itemsWithDimensions: this._prepareImages(this.items.filter((item)=>{
                return !!item.img;
            })),
            shouldRenderGrid: true
        });
    }
    render() {
        let styles = {
            opacity: 0
        };
        return this.props.gridItems.length > 0 && (this.state.shouldRenderGrid ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $ecd994ee38e99d01$export$2e2bcd8739ae039), {
            items: this.props.items,
            gridItems: this.state.itemsWithDimensions,
            clickThumb: this._clickThumb,
            sortBy: this._sortBy,
            showMore: this._showMore,
            sortedBy: this.props.sortedBy,
            cmsData: this.props.cmsData,
            gridTitle: this.props.gridTitle,
            setScrollPos: this.showMoreIsClicked,
            scrollPosition: this.scrollPosition,
            scrollPosIsSet: this._scrollPosIsSet,
            noDateText: this.props.noDateText
        }) : /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            className: "gallery-loading-container",
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                    src: "/Web/FrontEndR/assets/gfx/loader.gif",
                    // src="https://cdn-images-1.medium.com/max/1600/1*9EBHIOzhE1XfMYoKz1JcsQ.gif" width="256" height="256"
                    alt: this.props.cmsData.waitAltText,
                    className: this.showMoreIsClicked ? "show-more-clicked" : null
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7c0f56d4984059c7$exports))), {
                    style: styles,
                    elementType: "div",
                    className: "gallery-loading",
                    done: this._setImageDimensions,
                    children: this.props.gridItems.map((item, index)=>{
                        let url = (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).image.getUrl(item, 400);
                        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                            alt: item["artifact.ingress.title"],
                            src: url,
                            ref: (img)=>this.items[index] = {
                                    img: img,
                                    item: item
                                }
                        }, index);
                    })
                })
            ]
        }));
    }
}
var $a232618164564307$export$2e2bcd8739ae039 = $a232618164564307$var$ImageMeasurer;




var $8NFma = parcelRequire("8NFma");






var $8NFma = parcelRequire("8NFma");
class $310261aeebd1f063$var$Category extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
    }
    _handleClick = (e)=>{
        e.preventDefault();
        this.props.clickCategory(this.props.item);
    };
    render() {
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("a", {
            href: "#",
            className: "gallery-explorer-category" + (this.props.isActiveCategory ? " selected" : ""),
            onClick: this._handleClick,
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "image",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        className: "image-inner",
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                            src: this.props.item.image,
                            alt: this.props.item.category
                        })
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "text",
                    children: this.props.item.category
                })
            ]
        });
    }
}
var $310261aeebd1f063$export$2e2bcd8739ae039 = $310261aeebd1f063$var$Category;


"use strict";
var $eb34c05e902870ae$export$126649350cd02471;
(function(PipsMode) {
    PipsMode["Range"] = "range";
    PipsMode["Steps"] = "steps";
    PipsMode["Positions"] = "positions";
    PipsMode["Count"] = "count";
    PipsMode["Values"] = "values";
})($eb34c05e902870ae$export$126649350cd02471 || ($eb34c05e902870ae$export$126649350cd02471 = {}));
var $eb34c05e902870ae$export$ab20e68cdcd7a4fc;
(function(PipsType) {
    PipsType[PipsType["None"] = -1] = "None";
    PipsType[PipsType["NoValue"] = 0] = "NoValue";
    PipsType[PipsType["LargeValue"] = 1] = "LargeValue";
    PipsType[PipsType["SmallValue"] = 2] = "SmallValue";
})($eb34c05e902870ae$export$ab20e68cdcd7a4fc || ($eb34c05e902870ae$export$ab20e68cdcd7a4fc = {}));
//region Helper Methods
function $eb34c05e902870ae$var$isValidFormatter(entry) {
    return $eb34c05e902870ae$var$isValidPartialFormatter(entry) && typeof entry.from === "function";
}
function $eb34c05e902870ae$var$isValidPartialFormatter(entry) {
    // partial formatters only need a to function and not a from function
    return typeof entry === "object" && typeof entry.to === "function";
}
function $eb34c05e902870ae$var$removeElement(el) {
    el.parentElement.removeChild(el);
}
function $eb34c05e902870ae$var$isSet(value) {
    return value !== null && value !== undefined;
}
// Bindable version
function $eb34c05e902870ae$var$preventDefault(e) {
    e.preventDefault();
}
// Removes duplicates from an array.
function $eb34c05e902870ae$var$unique(array) {
    return array.filter(function(a) {
        return !this[a] ? this[a] = true : false;
    }, {});
}
// Round a value to the closest 'to'.
function $eb34c05e902870ae$var$closest(value, to) {
    return Math.round(value / to) * to;
}
// Current position of an element relative to the document.
function $eb34c05e902870ae$var$offset(elem, orientation) {
    var rect = elem.getBoundingClientRect();
    var doc = elem.ownerDocument;
    var docElem = doc.documentElement;
    var pageOffset = $eb34c05e902870ae$var$getPageOffset(doc);
    // getBoundingClientRect contains left scroll in Chrome on Android.
    // I haven't found a feature detection that proves this. Worst case
    // scenario on mis-match: the 'tap' feature on horizontal sliders breaks.
    if (/webkit.*Chrome.*Mobile/i.test(navigator.userAgent)) pageOffset.x = 0;
    return orientation ? rect.top + pageOffset.y - docElem.clientTop : rect.left + pageOffset.x - docElem.clientLeft;
}
// Checks whether a value is numerical.
function $eb34c05e902870ae$var$isNumeric(a) {
    return typeof a === "number" && !isNaN(a) && isFinite(a);
}
// Sets a class and removes it after [duration] ms.
function $eb34c05e902870ae$var$addClassFor(element, className, duration) {
    if (duration > 0) {
        $eb34c05e902870ae$var$addClass(element, className);
        setTimeout(function() {
            $eb34c05e902870ae$var$removeClass(element, className);
        }, duration);
    }
}
// Limits a value to 0 - 100
function $eb34c05e902870ae$var$limit(a) {
    return Math.max(Math.min(a, 100), 0);
}
// Wraps a variable as an array, if it isn't one yet.
// Note that an input array is returned by reference!
function $eb34c05e902870ae$var$asArray(a) {
    return Array.isArray(a) ? a : [
        a
    ];
}
// Counts decimals
function $eb34c05e902870ae$var$countDecimals(numStr) {
    numStr = String(numStr);
    var pieces = numStr.split(".");
    return pieces.length > 1 ? pieces[1].length : 0;
}
// http://youmightnotneedjquery.com/#add_class
function $eb34c05e902870ae$var$addClass(el, className) {
    if (el.classList && !/\s/.test(className)) el.classList.add(className);
    else el.className += " " + className;
}
// http://youmightnotneedjquery.com/#remove_class
function $eb34c05e902870ae$var$removeClass(el, className) {
    if (el.classList && !/\s/.test(className)) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"), " ");
}
// https://plainjs.com/javascript/attributes/adding-removing-and-testing-for-classes-9/
function $eb34c05e902870ae$var$hasClass(el, className) {
    return el.classList ? el.classList.contains(className) : new RegExp("\\b" + className + "\\b").test(el.className);
}
// https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY#Notes
function $eb34c05e902870ae$var$getPageOffset(doc) {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (doc.compatMode || "") === "CSS1Compat";
    var x = supportPageOffset ? window.pageXOffset : isCSS1Compat ? doc.documentElement.scrollLeft : doc.body.scrollLeft;
    var y = supportPageOffset ? window.pageYOffset : isCSS1Compat ? doc.documentElement.scrollTop : doc.body.scrollTop;
    return {
        x: x,
        y: y
    };
}
// we provide a function to compute constants instead
// of accessing window.* as soon as the module needs it
// so that we do not compute anything if not needed
function $eb34c05e902870ae$var$getActions() {
    // Determine the events to bind. IE11 implements pointerEvents without
    // a prefix, which breaks compatibility with the IE10 implementation.
    return window.navigator.pointerEnabled ? {
        start: "pointerdown",
        move: "pointermove",
        end: "pointerup"
    } : window.navigator.msPointerEnabled ? {
        start: "MSPointerDown",
        move: "MSPointerMove",
        end: "MSPointerUp"
    } : {
        start: "mousedown touchstart",
        move: "mousemove touchmove",
        end: "mouseup touchend"
    };
}
// https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
// Issue #785
function $eb34c05e902870ae$var$getSupportsPassive() {
    var supportsPassive = false;
    /* eslint-disable */ try {
        var opts = Object.defineProperty({}, "passive", {
            get: function() {
                supportsPassive = true;
            }
        });
        // @ts-ignore
        window.addEventListener("test", null, opts);
    } catch (e) {}
    /* eslint-enable */ return supportsPassive;
}
function $eb34c05e902870ae$var$getSupportsTouchActionNone() {
    return window.CSS && CSS.supports && CSS.supports("touch-action", "none");
}
//endregion
//region Range Calculation
// Determine the size of a sub-range in relation to a full range.
function $eb34c05e902870ae$var$subRangeRatio(pa, pb) {
    return 100 / (pb - pa);
}
// (percentage) How many percent is this value of this range?
function $eb34c05e902870ae$var$fromPercentage(range, value, startRange) {
    return value * 100 / (range[startRange + 1] - range[startRange]);
}
// (percentage) Where is this value on this range?
function $eb34c05e902870ae$var$toPercentage(range, value) {
    return $eb34c05e902870ae$var$fromPercentage(range, range[0] < 0 ? value + Math.abs(range[0]) : value - range[0], 0);
}
// (value) How much is this percentage on this range?
function $eb34c05e902870ae$var$isPercentage(range, value) {
    return value * (range[1] - range[0]) / 100 + range[0];
}
function $eb34c05e902870ae$var$getJ(value, arr) {
    var j = 1;
    while(value >= arr[j])j += 1;
    return j;
}
// (percentage) Input a value, find where, on a scale of 0-100, it applies.
function $eb34c05e902870ae$var$toStepping(xVal, xPct, value) {
    if (value >= xVal.slice(-1)[0]) return 100;
    var j = $eb34c05e902870ae$var$getJ(value, xVal);
    var va = xVal[j - 1];
    var vb = xVal[j];
    var pa = xPct[j - 1];
    var pb = xPct[j];
    return pa + $eb34c05e902870ae$var$toPercentage([
        va,
        vb
    ], value) / $eb34c05e902870ae$var$subRangeRatio(pa, pb);
}
// (value) Input a percentage, find where it is on the specified range.
function $eb34c05e902870ae$var$fromStepping(xVal, xPct, value) {
    // There is no range group that fits 100
    if (value >= 100) return xVal.slice(-1)[0];
    var j = $eb34c05e902870ae$var$getJ(value, xPct);
    var va = xVal[j - 1];
    var vb = xVal[j];
    var pa = xPct[j - 1];
    var pb = xPct[j];
    return $eb34c05e902870ae$var$isPercentage([
        va,
        vb
    ], (value - pa) * $eb34c05e902870ae$var$subRangeRatio(pa, pb));
}
// (percentage) Get the step that applies at a certain value.
function $eb34c05e902870ae$var$getStep(xPct, xSteps, snap, value) {
    if (value === 100) return value;
    var j = $eb34c05e902870ae$var$getJ(value, xPct);
    var a = xPct[j - 1];
    var b = xPct[j];
    // If 'snap' is set, steps are used as fixed points on the slider.
    if (snap) {
        // Find the closest position, a or b.
        if (value - a > (b - a) / 2) return b;
        return a;
    }
    if (!xSteps[j - 1]) return value;
    return xPct[j - 1] + $eb34c05e902870ae$var$closest(value - xPct[j - 1], xSteps[j - 1]);
}
//endregion
//region Spectrum
var $eb34c05e902870ae$var$Spectrum = /** @class */ function() {
    function Spectrum(entry, snap, singleStep) {
        this.xPct = [];
        this.xVal = [];
        this.xSteps = [];
        this.xNumSteps = [];
        this.xHighestCompleteStep = [];
        this.xSteps = [
            singleStep || false
        ];
        this.xNumSteps = [
            false
        ];
        this.snap = snap;
        var index;
        var ordered = [];
        // Map the object keys to an array.
        Object.keys(entry).forEach(function(index) {
            ordered.push([
                $eb34c05e902870ae$var$asArray(entry[index]),
                index
            ]);
        });
        // Sort all entries by value (numeric sort).
        ordered.sort(function(a, b) {
            return a[0][0] - b[0][0];
        });
        // Convert all entries to subranges.
        for(index = 0; index < ordered.length; index++)this.handleEntryPoint(ordered[index][1], ordered[index][0]);
        // Store the actual step values.
        // xSteps is sorted in the same order as xPct and xVal.
        this.xNumSteps = this.xSteps.slice(0);
        // Convert all numeric steps to the percentage of the subrange they represent.
        for(index = 0; index < this.xNumSteps.length; index++)this.handleStepPoint(index, this.xNumSteps[index]);
    }
    Spectrum.prototype.getDistance = function(value) {
        var distances = [];
        for(var index = 0; index < this.xNumSteps.length - 1; index++)distances[index] = $eb34c05e902870ae$var$fromPercentage(this.xVal, value, index);
        return distances;
    };
    // Calculate the percentual distance over the whole scale of ranges.
    // direction: 0 = backwards / 1 = forwards
    Spectrum.prototype.getAbsoluteDistance = function(value, distances, direction) {
        var xPct_index = 0;
        // Calculate range where to start calculation
        if (value < this.xPct[this.xPct.length - 1]) while(value > this.xPct[xPct_index + 1])xPct_index++;
        else if (value === this.xPct[this.xPct.length - 1]) xPct_index = this.xPct.length - 2;
        // If looking backwards and the value is exactly at a range separator then look one range further
        if (!direction && value === this.xPct[xPct_index + 1]) xPct_index++;
        if (distances === null) distances = [];
        var start_factor;
        var rest_factor = 1;
        var rest_rel_distance = distances[xPct_index];
        var range_pct = 0;
        var rel_range_distance = 0;
        var abs_distance_counter = 0;
        var range_counter = 0;
        // Calculate what part of the start range the value is
        if (direction) start_factor = (value - this.xPct[xPct_index]) / (this.xPct[xPct_index + 1] - this.xPct[xPct_index]);
        else start_factor = (this.xPct[xPct_index + 1] - value) / (this.xPct[xPct_index + 1] - this.xPct[xPct_index]);
        // Do until the complete distance across ranges is calculated
        while(rest_rel_distance > 0){
            // Calculate the percentage of total range
            range_pct = this.xPct[xPct_index + 1 + range_counter] - this.xPct[xPct_index + range_counter];
            // Detect if the margin, padding or limit is larger then the current range and calculate
            if (distances[xPct_index + range_counter] * rest_factor + 100 - start_factor * 100 > 100) {
                // If larger then take the percentual distance of the whole range
                rel_range_distance = range_pct * start_factor;
                // Rest factor of relative percentual distance still to be calculated
                rest_factor = (rest_rel_distance - 100 * start_factor) / distances[xPct_index + range_counter];
                // Set start factor to 1 as for next range it does not apply.
                start_factor = 1;
            } else {
                // If smaller or equal then take the percentual distance of the calculate percentual part of that range
                rel_range_distance = distances[xPct_index + range_counter] * range_pct / 100 * rest_factor;
                // No rest left as the rest fits in current range
                rest_factor = 0;
            }
            if (direction) {
                abs_distance_counter = abs_distance_counter - rel_range_distance;
                // Limit range to first range when distance becomes outside of minimum range
                if (this.xPct.length + range_counter >= 1) range_counter--;
            } else {
                abs_distance_counter = abs_distance_counter + rel_range_distance;
                // Limit range to last range when distance becomes outside of maximum range
                if (this.xPct.length - range_counter >= 1) range_counter++;
            }
            // Rest of relative percentual distance still to be calculated
            rest_rel_distance = distances[xPct_index + range_counter] * rest_factor;
        }
        return value + abs_distance_counter;
    };
    Spectrum.prototype.toStepping = function(value) {
        value = $eb34c05e902870ae$var$toStepping(this.xVal, this.xPct, value);
        return value;
    };
    Spectrum.prototype.fromStepping = function(value) {
        return $eb34c05e902870ae$var$fromStepping(this.xVal, this.xPct, value);
    };
    Spectrum.prototype.getStep = function(value) {
        value = $eb34c05e902870ae$var$getStep(this.xPct, this.xSteps, this.snap, value);
        return value;
    };
    Spectrum.prototype.getDefaultStep = function(value, isDown, size) {
        var j = $eb34c05e902870ae$var$getJ(value, this.xPct);
        // When at the top or stepping down, look at the previous sub-range
        if (value === 100 || isDown && value === this.xPct[j - 1]) j = Math.max(j - 1, 1);
        return (this.xVal[j] - this.xVal[j - 1]) / size;
    };
    Spectrum.prototype.getNearbySteps = function(value) {
        var j = $eb34c05e902870ae$var$getJ(value, this.xPct);
        return {
            stepBefore: {
                startValue: this.xVal[j - 2],
                step: this.xNumSteps[j - 2],
                highestStep: this.xHighestCompleteStep[j - 2]
            },
            thisStep: {
                startValue: this.xVal[j - 1],
                step: this.xNumSteps[j - 1],
                highestStep: this.xHighestCompleteStep[j - 1]
            },
            stepAfter: {
                startValue: this.xVal[j],
                step: this.xNumSteps[j],
                highestStep: this.xHighestCompleteStep[j]
            }
        };
    };
    Spectrum.prototype.countStepDecimals = function() {
        var stepDecimals = this.xNumSteps.map($eb34c05e902870ae$var$countDecimals);
        return Math.max.apply(null, stepDecimals);
    };
    Spectrum.prototype.hasNoSize = function() {
        return this.xVal[0] === this.xVal[this.xVal.length - 1];
    };
    // Outside testing
    Spectrum.prototype.convert = function(value) {
        return this.getStep(this.toStepping(value));
    };
    Spectrum.prototype.handleEntryPoint = function(index, value) {
        var percentage;
        // Covert min/max syntax to 0 and 100.
        if (index === "min") percentage = 0;
        else if (index === "max") percentage = 100;
        else percentage = parseFloat(index);
        // Check for correct input.
        if (!$eb34c05e902870ae$var$isNumeric(percentage) || !$eb34c05e902870ae$var$isNumeric(value[0])) throw new Error("noUiSlider: 'range' value isn't numeric.");
        // Store values.
        this.xPct.push(percentage);
        this.xVal.push(value[0]);
        var value1 = Number(value[1]);
        // NaN will evaluate to false too, but to keep
        // logging clear, set step explicitly. Make sure
        // not to override the 'step' setting with false.
        if (!percentage) {
            if (!isNaN(value1)) this.xSteps[0] = value1;
        } else this.xSteps.push(isNaN(value1) ? false : value1);
        this.xHighestCompleteStep.push(0);
    };
    Spectrum.prototype.handleStepPoint = function(i, n) {
        // Ignore 'false' stepping.
        if (!n) return;
        // Step over zero-length ranges (#948);
        if (this.xVal[i] === this.xVal[i + 1]) {
            this.xSteps[i] = this.xHighestCompleteStep[i] = this.xVal[i];
            return;
        }
        // Factor to range ratio
        this.xSteps[i] = $eb34c05e902870ae$var$fromPercentage([
            this.xVal[i],
            this.xVal[i + 1]
        ], n, 0) / $eb34c05e902870ae$var$subRangeRatio(this.xPct[i], this.xPct[i + 1]);
        var totalSteps = (this.xVal[i + 1] - this.xVal[i]) / this.xNumSteps[i];
        var highestStep = Math.ceil(Number(totalSteps.toFixed(3)) - 1);
        var step = this.xVal[i] + this.xNumSteps[i] * highestStep;
        this.xHighestCompleteStep[i] = step;
    };
    return Spectrum;
}();
//endregion
//region Options
/*	Every input option is tested and parsed. This will prevent
    endless validation in internal methods. These tests are
    structured with an item for every option available. An
    option can be marked as required by setting the 'r' flag.
    The testing function is provided with three arguments:
        - The provided value for the option;
        - A reference to the options object;
        - The name for the option;

    The testing function returns false when an error is detected,
    or true when everything is OK. It can also modify the option
    object, to make sure all values can be correctly looped elsewhere. */ //region Defaults
var $eb34c05e902870ae$var$defaultFormatter = {
    to: function(value) {
        return value === undefined ? "" : value.toFixed(2);
    },
    from: Number
};
var $eb34c05e902870ae$export$c1c0562ec8379000 = {
    target: "target",
    base: "base",
    origin: "origin",
    handle: "handle",
    handleLower: "handle-lower",
    handleUpper: "handle-upper",
    touchArea: "touch-area",
    horizontal: "horizontal",
    vertical: "vertical",
    background: "background",
    connect: "connect",
    connects: "connects",
    ltr: "ltr",
    rtl: "rtl",
    textDirectionLtr: "txt-dir-ltr",
    textDirectionRtl: "txt-dir-rtl",
    draggable: "draggable",
    drag: "state-drag",
    tap: "state-tap",
    active: "active",
    tooltip: "tooltip",
    pips: "pips",
    pipsHorizontal: "pips-horizontal",
    pipsVertical: "pips-vertical",
    marker: "marker",
    markerHorizontal: "marker-horizontal",
    markerVertical: "marker-vertical",
    markerNormal: "marker-normal",
    markerLarge: "marker-large",
    markerSub: "marker-sub",
    value: "value",
    valueHorizontal: "value-horizontal",
    valueVertical: "value-vertical",
    valueNormal: "value-normal",
    valueLarge: "value-large",
    valueSub: "value-sub"
};
// Namespaces of internal event listeners
var $eb34c05e902870ae$var$INTERNAL_EVENT_NS = {
    tooltips: ".__tooltips",
    aria: ".__aria"
};
//endregion
function $eb34c05e902870ae$var$testStep(parsed, entry) {
    if (!$eb34c05e902870ae$var$isNumeric(entry)) throw new Error("noUiSlider: 'step' is not numeric.");
    // The step option can still be used to set stepping
    // for linear sliders. Overwritten if set in 'range'.
    parsed.singleStep = entry;
}
function $eb34c05e902870ae$var$testKeyboardPageMultiplier(parsed, entry) {
    if (!$eb34c05e902870ae$var$isNumeric(entry)) throw new Error("noUiSlider: 'keyboardPageMultiplier' is not numeric.");
    parsed.keyboardPageMultiplier = entry;
}
function $eb34c05e902870ae$var$testKeyboardMultiplier(parsed, entry) {
    if (!$eb34c05e902870ae$var$isNumeric(entry)) throw new Error("noUiSlider: 'keyboardMultiplier' is not numeric.");
    parsed.keyboardMultiplier = entry;
}
function $eb34c05e902870ae$var$testKeyboardDefaultStep(parsed, entry) {
    if (!$eb34c05e902870ae$var$isNumeric(entry)) throw new Error("noUiSlider: 'keyboardDefaultStep' is not numeric.");
    parsed.keyboardDefaultStep = entry;
}
function $eb34c05e902870ae$var$testRange(parsed, entry) {
    // Filter incorrect input.
    if (typeof entry !== "object" || Array.isArray(entry)) throw new Error("noUiSlider: 'range' is not an object.");
    // Catch missing start or end.
    if (entry.min === undefined || entry.max === undefined) throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
    parsed.spectrum = new $eb34c05e902870ae$var$Spectrum(entry, parsed.snap || false, parsed.singleStep);
}
function $eb34c05e902870ae$var$testStart(parsed, entry) {
    entry = $eb34c05e902870ae$var$asArray(entry);
    // Validate input. Values aren't tested, as the public .val method
    // will always provide a valid location.
    if (!Array.isArray(entry) || !entry.length) throw new Error("noUiSlider: 'start' option is incorrect.");
    // Store the number of handles.
    parsed.handles = entry.length;
    // When the slider is initialized, the .val method will
    // be called with the start options.
    parsed.start = entry;
}
function $eb34c05e902870ae$var$testSnap(parsed, entry) {
    if (typeof entry !== "boolean") throw new Error("noUiSlider: 'snap' option must be a boolean.");
    // Enforce 100% stepping within subranges.
    parsed.snap = entry;
}
function $eb34c05e902870ae$var$testAnimate(parsed, entry) {
    if (typeof entry !== "boolean") throw new Error("noUiSlider: 'animate' option must be a boolean.");
    // Enforce 100% stepping within subranges.
    parsed.animate = entry;
}
function $eb34c05e902870ae$var$testAnimationDuration(parsed, entry) {
    if (typeof entry !== "number") throw new Error("noUiSlider: 'animationDuration' option must be a number.");
    parsed.animationDuration = entry;
}
function $eb34c05e902870ae$var$testConnect(parsed, entry) {
    var connect = [
        false
    ];
    var i;
    // Map legacy options
    if (entry === "lower") entry = [
        true,
        false
    ];
    else if (entry === "upper") entry = [
        false,
        true
    ];
    // Handle boolean options
    if (entry === true || entry === false) {
        for(i = 1; i < parsed.handles; i++)connect.push(entry);
        connect.push(false);
    } else if (!Array.isArray(entry) || !entry.length || entry.length !== parsed.handles + 1) throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
    else connect = entry;
    parsed.connect = connect;
}
function $eb34c05e902870ae$var$testOrientation(parsed, entry) {
    // Set orientation to an a numerical value for easy
    // array selection.
    switch(entry){
        case "horizontal":
            parsed.ort = 0;
            break;
        case "vertical":
            parsed.ort = 1;
            break;
        default:
            throw new Error("noUiSlider: 'orientation' option is invalid.");
    }
}
function $eb34c05e902870ae$var$testMargin(parsed, entry) {
    if (!$eb34c05e902870ae$var$isNumeric(entry)) throw new Error("noUiSlider: 'margin' option must be numeric.");
    // Issue #582
    if (entry === 0) return;
    parsed.margin = parsed.spectrum.getDistance(entry);
}
function $eb34c05e902870ae$var$testLimit(parsed, entry) {
    if (!$eb34c05e902870ae$var$isNumeric(entry)) throw new Error("noUiSlider: 'limit' option must be numeric.");
    parsed.limit = parsed.spectrum.getDistance(entry);
    if (!parsed.limit || parsed.handles < 2) throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.");
}
function $eb34c05e902870ae$var$testPadding(parsed, entry) {
    var index;
    if (!$eb34c05e902870ae$var$isNumeric(entry) && !Array.isArray(entry)) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
    if (Array.isArray(entry) && !(entry.length === 2 || $eb34c05e902870ae$var$isNumeric(entry[0]) || $eb34c05e902870ae$var$isNumeric(entry[1]))) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
    if (entry === 0) return;
    if (!Array.isArray(entry)) entry = [
        entry,
        entry
    ];
    // 'getDistance' returns false for invalid values.
    parsed.padding = [
        parsed.spectrum.getDistance(entry[0]),
        parsed.spectrum.getDistance(entry[1])
    ];
    for(index = 0; index < parsed.spectrum.xNumSteps.length - 1; index++){
        // last "range" can't contain step size as it is purely an endpoint.
        if (parsed.padding[0][index] < 0 || parsed.padding[1][index] < 0) throw new Error("noUiSlider: 'padding' option must be a positive number(s).");
    }
    var totalPadding = entry[0] + entry[1];
    var firstValue = parsed.spectrum.xVal[0];
    var lastValue = parsed.spectrum.xVal[parsed.spectrum.xVal.length - 1];
    if (totalPadding / (lastValue - firstValue) > 1) throw new Error("noUiSlider: 'padding' option must not exceed 100% of the range.");
}
function $eb34c05e902870ae$var$testDirection(parsed, entry) {
    // Set direction as a numerical value for easy parsing.
    // Invert connection for RTL sliders, so that the proper
    // handles get the connect/background classes.
    switch(entry){
        case "ltr":
            parsed.dir = 0;
            break;
        case "rtl":
            parsed.dir = 1;
            break;
        default:
            throw new Error("noUiSlider: 'direction' option was not recognized.");
    }
}
function $eb34c05e902870ae$var$testBehaviour(parsed, entry) {
    // Make sure the input is a string.
    if (typeof entry !== "string") throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
    // Check if the string contains any keywords.
    // None are required.
    var tap = entry.indexOf("tap") >= 0;
    var drag = entry.indexOf("drag") >= 0;
    var fixed = entry.indexOf("fixed") >= 0;
    var snap = entry.indexOf("snap") >= 0;
    var hover = entry.indexOf("hover") >= 0;
    var unconstrained = entry.indexOf("unconstrained") >= 0;
    var dragAll = entry.indexOf("drag-all") >= 0;
    var smoothSteps = entry.indexOf("smooth-steps") >= 0;
    if (fixed) {
        if (parsed.handles !== 2) throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");
        // Use margin to enforce fixed state
        $eb34c05e902870ae$var$testMargin(parsed, parsed.start[1] - parsed.start[0]);
    }
    if (unconstrained && (parsed.margin || parsed.limit)) throw new Error("noUiSlider: 'unconstrained' behaviour cannot be used with margin or limit");
    parsed.events = {
        tap: tap || snap,
        drag: drag,
        dragAll: dragAll,
        smoothSteps: smoothSteps,
        fixed: fixed,
        snap: snap,
        hover: hover,
        unconstrained: unconstrained
    };
}
function $eb34c05e902870ae$var$testTooltips(parsed, entry) {
    if (entry === false) return;
    if (entry === true || $eb34c05e902870ae$var$isValidPartialFormatter(entry)) {
        parsed.tooltips = [];
        for(var i = 0; i < parsed.handles; i++)parsed.tooltips.push(entry);
    } else {
        entry = $eb34c05e902870ae$var$asArray(entry);
        if (entry.length !== parsed.handles) throw new Error("noUiSlider: must pass a formatter for all handles.");
        entry.forEach(function(formatter) {
            if (typeof formatter !== "boolean" && !$eb34c05e902870ae$var$isValidPartialFormatter(formatter)) throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
        });
        parsed.tooltips = entry;
    }
}
function $eb34c05e902870ae$var$testHandleAttributes(parsed, entry) {
    if (entry.length !== parsed.handles) throw new Error("noUiSlider: must pass a attributes for all handles.");
    parsed.handleAttributes = entry;
}
function $eb34c05e902870ae$var$testAriaFormat(parsed, entry) {
    if (!$eb34c05e902870ae$var$isValidPartialFormatter(entry)) throw new Error("noUiSlider: 'ariaFormat' requires 'to' method.");
    parsed.ariaFormat = entry;
}
function $eb34c05e902870ae$var$testFormat(parsed, entry) {
    if (!$eb34c05e902870ae$var$isValidFormatter(entry)) throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
    parsed.format = entry;
}
function $eb34c05e902870ae$var$testKeyboardSupport(parsed, entry) {
    if (typeof entry !== "boolean") throw new Error("noUiSlider: 'keyboardSupport' option must be a boolean.");
    parsed.keyboardSupport = entry;
}
function $eb34c05e902870ae$var$testDocumentElement(parsed, entry) {
    // This is an advanced option. Passed values are used without validation.
    parsed.documentElement = entry;
}
function $eb34c05e902870ae$var$testCssPrefix(parsed, entry) {
    if (typeof entry !== "string" && entry !== false) throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
    parsed.cssPrefix = entry;
}
function $eb34c05e902870ae$var$testCssClasses(parsed, entry) {
    if (typeof entry !== "object") throw new Error("noUiSlider: 'cssClasses' must be an object.");
    if (typeof parsed.cssPrefix === "string") {
        parsed.cssClasses = {};
        Object.keys(entry).forEach(function(key) {
            parsed.cssClasses[key] = parsed.cssPrefix + entry[key];
        });
    } else parsed.cssClasses = entry;
}
// Test all developer settings and parse to assumption-safe values.
function $eb34c05e902870ae$var$testOptions(options) {
    // To prove a fix for #537, freeze options here.
    // If the object is modified, an error will be thrown.
    // Object.freeze(options);
    var parsed = {
        margin: null,
        limit: null,
        padding: null,
        animate: true,
        animationDuration: 300,
        ariaFormat: $eb34c05e902870ae$var$defaultFormatter,
        format: $eb34c05e902870ae$var$defaultFormatter
    };
    // Tests are executed in the order they are presented here.
    var tests = {
        step: {
            r: false,
            t: $eb34c05e902870ae$var$testStep
        },
        keyboardPageMultiplier: {
            r: false,
            t: $eb34c05e902870ae$var$testKeyboardPageMultiplier
        },
        keyboardMultiplier: {
            r: false,
            t: $eb34c05e902870ae$var$testKeyboardMultiplier
        },
        keyboardDefaultStep: {
            r: false,
            t: $eb34c05e902870ae$var$testKeyboardDefaultStep
        },
        start: {
            r: true,
            t: $eb34c05e902870ae$var$testStart
        },
        connect: {
            r: true,
            t: $eb34c05e902870ae$var$testConnect
        },
        direction: {
            r: true,
            t: $eb34c05e902870ae$var$testDirection
        },
        snap: {
            r: false,
            t: $eb34c05e902870ae$var$testSnap
        },
        animate: {
            r: false,
            t: $eb34c05e902870ae$var$testAnimate
        },
        animationDuration: {
            r: false,
            t: $eb34c05e902870ae$var$testAnimationDuration
        },
        range: {
            r: true,
            t: $eb34c05e902870ae$var$testRange
        },
        orientation: {
            r: false,
            t: $eb34c05e902870ae$var$testOrientation
        },
        margin: {
            r: false,
            t: $eb34c05e902870ae$var$testMargin
        },
        limit: {
            r: false,
            t: $eb34c05e902870ae$var$testLimit
        },
        padding: {
            r: false,
            t: $eb34c05e902870ae$var$testPadding
        },
        behaviour: {
            r: true,
            t: $eb34c05e902870ae$var$testBehaviour
        },
        ariaFormat: {
            r: false,
            t: $eb34c05e902870ae$var$testAriaFormat
        },
        format: {
            r: false,
            t: $eb34c05e902870ae$var$testFormat
        },
        tooltips: {
            r: false,
            t: $eb34c05e902870ae$var$testTooltips
        },
        keyboardSupport: {
            r: true,
            t: $eb34c05e902870ae$var$testKeyboardSupport
        },
        documentElement: {
            r: false,
            t: $eb34c05e902870ae$var$testDocumentElement
        },
        cssPrefix: {
            r: true,
            t: $eb34c05e902870ae$var$testCssPrefix
        },
        cssClasses: {
            r: true,
            t: $eb34c05e902870ae$var$testCssClasses
        },
        handleAttributes: {
            r: false,
            t: $eb34c05e902870ae$var$testHandleAttributes
        }
    };
    var defaults = {
        connect: false,
        direction: "ltr",
        behaviour: "tap",
        orientation: "horizontal",
        keyboardSupport: true,
        cssPrefix: "noUi-",
        cssClasses: $eb34c05e902870ae$export$c1c0562ec8379000,
        keyboardPageMultiplier: 5,
        keyboardMultiplier: 1,
        keyboardDefaultStep: 10
    };
    // AriaFormat defaults to regular format, if any.
    if (options.format && !options.ariaFormat) options.ariaFormat = options.format;
    // Run all options through a testing mechanism to ensure correct
    // input. It should be noted that options might get modified to
    // be handled properly. E.g. wrapping integers in arrays.
    Object.keys(tests).forEach(function(name) {
        // If the option isn't set, but it is required, throw an error.
        if (!$eb34c05e902870ae$var$isSet(options[name]) && defaults[name] === undefined) {
            if (tests[name].r) throw new Error("noUiSlider: '" + name + "' is required.");
            return;
        }
        tests[name].t(parsed, !$eb34c05e902870ae$var$isSet(options[name]) ? defaults[name] : options[name]);
    });
    // Forward pips options
    parsed.pips = options.pips;
    // All recent browsers accept unprefixed transform.
    // We need -ms- for IE9 and -webkit- for older Android;
    // Assume use of -webkit- if unprefixed and -ms- are not supported.
    // https://caniuse.com/#feat=transforms2d
    var d = document.createElement("div");
    var msPrefix = d.style.msTransform !== undefined;
    var noPrefix = d.style.transform !== undefined;
    parsed.transformRule = noPrefix ? "transform" : msPrefix ? "msTransform" : "webkitTransform";
    // Pips don't move, so we can place them using left/top.
    var styles = [
        [
            "left",
            "top"
        ],
        [
            "right",
            "bottom"
        ]
    ];
    parsed.style = styles[parsed.dir][parsed.ort];
    return parsed;
}
//endregion
function $eb34c05e902870ae$var$scope(target, options, originalOptions) {
    var actions = $eb34c05e902870ae$var$getActions();
    var supportsTouchActionNone = $eb34c05e902870ae$var$getSupportsTouchActionNone();
    var supportsPassive = supportsTouchActionNone && $eb34c05e902870ae$var$getSupportsPassive();
    // All variables local to 'scope' are prefixed with 'scope_'
    // Slider DOM Nodes
    var scope_Target = target;
    var scope_Base;
    var scope_Handles;
    var scope_Connects;
    var scope_Pips;
    var scope_Tooltips;
    // Slider state values
    var scope_Spectrum = options.spectrum;
    var scope_Values = [];
    var scope_Locations = [];
    var scope_HandleNumbers = [];
    var scope_ActiveHandlesCount = 0;
    var scope_Events = {};
    // Document Nodes
    var scope_Document = target.ownerDocument;
    var scope_DocumentElement = options.documentElement || scope_Document.documentElement;
    var scope_Body = scope_Document.body;
    // For horizontal sliders in standard ltr documents,
    // make .noUi-origin overflow to the left so the document doesn't scroll.
    var scope_DirOffset = scope_Document.dir === "rtl" || options.ort === 1 ? 0 : 100;
    // Creates a node, adds it to target, returns the new node.
    function addNodeTo(addTarget, className) {
        var div = scope_Document.createElement("div");
        if (className) $eb34c05e902870ae$var$addClass(div, className);
        addTarget.appendChild(div);
        return div;
    }
    // Append a origin to the base
    function addOrigin(base, handleNumber) {
        var origin = addNodeTo(base, options.cssClasses.origin);
        var handle = addNodeTo(origin, options.cssClasses.handle);
        addNodeTo(handle, options.cssClasses.touchArea);
        handle.setAttribute("data-handle", String(handleNumber));
        if (options.keyboardSupport) {
            // https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex
            // 0 = focusable and reachable
            handle.setAttribute("tabindex", "0");
            handle.addEventListener("keydown", function(event) {
                return eventKeydown(event, handleNumber);
            });
        }
        if (options.handleAttributes !== undefined) {
            var attributes_1 = options.handleAttributes[handleNumber];
            Object.keys(attributes_1).forEach(function(attribute) {
                handle.setAttribute(attribute, attributes_1[attribute]);
            });
        }
        handle.setAttribute("role", "slider");
        handle.setAttribute("aria-orientation", options.ort ? "vertical" : "horizontal");
        if (handleNumber === 0) $eb34c05e902870ae$var$addClass(handle, options.cssClasses.handleLower);
        else if (handleNumber === options.handles - 1) $eb34c05e902870ae$var$addClass(handle, options.cssClasses.handleUpper);
        origin.handle = handle;
        return origin;
    }
    // Insert nodes for connect elements
    function addConnect(base, add) {
        if (!add) return false;
        return addNodeTo(base, options.cssClasses.connect);
    }
    // Add handles to the slider base.
    function addElements(connectOptions, base) {
        var connectBase = addNodeTo(base, options.cssClasses.connects);
        scope_Handles = [];
        scope_Connects = [];
        scope_Connects.push(addConnect(connectBase, connectOptions[0]));
        // [::::O====O====O====]
        // connectOptions = [0, 1, 1, 1]
        for(var i = 0; i < options.handles; i++){
            // Keep a list of all added handles.
            scope_Handles.push(addOrigin(base, i));
            scope_HandleNumbers[i] = i;
            scope_Connects.push(addConnect(connectBase, connectOptions[i + 1]));
        }
    }
    // Initialize a single slider.
    function addSlider(addTarget) {
        // Apply classes and data to the target.
        $eb34c05e902870ae$var$addClass(addTarget, options.cssClasses.target);
        if (options.dir === 0) $eb34c05e902870ae$var$addClass(addTarget, options.cssClasses.ltr);
        else $eb34c05e902870ae$var$addClass(addTarget, options.cssClasses.rtl);
        if (options.ort === 0) $eb34c05e902870ae$var$addClass(addTarget, options.cssClasses.horizontal);
        else $eb34c05e902870ae$var$addClass(addTarget, options.cssClasses.vertical);
        var textDirection = getComputedStyle(addTarget).direction;
        if (textDirection === "rtl") $eb34c05e902870ae$var$addClass(addTarget, options.cssClasses.textDirectionRtl);
        else $eb34c05e902870ae$var$addClass(addTarget, options.cssClasses.textDirectionLtr);
        return addNodeTo(addTarget, options.cssClasses.base);
    }
    function addTooltip(handle, handleNumber) {
        if (!options.tooltips || !options.tooltips[handleNumber]) return false;
        return addNodeTo(handle.firstChild, options.cssClasses.tooltip);
    }
    function isSliderDisabled() {
        return scope_Target.hasAttribute("disabled");
    }
    // Disable the slider dragging if any handle is disabled
    function isHandleDisabled(handleNumber) {
        var handleOrigin = scope_Handles[handleNumber];
        return handleOrigin.hasAttribute("disabled");
    }
    function disable(handleNumber) {
        if (handleNumber !== null && handleNumber !== undefined) {
            scope_Handles[handleNumber].setAttribute("disabled", "");
            scope_Handles[handleNumber].handle.removeAttribute("tabindex");
        } else {
            scope_Target.setAttribute("disabled", "");
            scope_Handles.forEach(function(handle) {
                handle.handle.removeAttribute("tabindex");
            });
        }
    }
    function enable(handleNumber) {
        if (handleNumber !== null && handleNumber !== undefined) {
            scope_Handles[handleNumber].removeAttribute("disabled");
            scope_Handles[handleNumber].handle.setAttribute("tabindex", "0");
        } else {
            scope_Target.removeAttribute("disabled");
            scope_Handles.forEach(function(handle) {
                handle.removeAttribute("disabled");
                handle.handle.setAttribute("tabindex", "0");
            });
        }
    }
    function removeTooltips() {
        if (scope_Tooltips) {
            removeEvent("update" + $eb34c05e902870ae$var$INTERNAL_EVENT_NS.tooltips);
            scope_Tooltips.forEach(function(tooltip) {
                if (tooltip) $eb34c05e902870ae$var$removeElement(tooltip);
            });
            scope_Tooltips = null;
        }
    }
    // The tooltips option is a shorthand for using the 'update' event.
    function tooltips() {
        removeTooltips();
        // Tooltips are added with options.tooltips in original order.
        scope_Tooltips = scope_Handles.map(addTooltip);
        bindEvent("update" + $eb34c05e902870ae$var$INTERNAL_EVENT_NS.tooltips, function(values, handleNumber, unencoded) {
            if (!scope_Tooltips || !options.tooltips) return;
            if (scope_Tooltips[handleNumber] === false) return;
            var formattedValue = values[handleNumber];
            if (options.tooltips[handleNumber] !== true) formattedValue = options.tooltips[handleNumber].to(unencoded[handleNumber]);
            scope_Tooltips[handleNumber].innerHTML = formattedValue;
        });
    }
    function aria() {
        removeEvent("update" + $eb34c05e902870ae$var$INTERNAL_EVENT_NS.aria);
        bindEvent("update" + $eb34c05e902870ae$var$INTERNAL_EVENT_NS.aria, function(values, handleNumber, unencoded, tap, positions) {
            // Update Aria Values for all handles, as a change in one changes min and max values for the next.
            scope_HandleNumbers.forEach(function(index) {
                var handle = scope_Handles[index];
                var min = checkHandlePosition(scope_Locations, index, 0, true, true, true);
                var max = checkHandlePosition(scope_Locations, index, 100, true, true, true);
                var now = positions[index];
                // Formatted value for display
                var text = String(options.ariaFormat.to(unencoded[index]));
                // Map to slider range values
                min = scope_Spectrum.fromStepping(min).toFixed(1);
                max = scope_Spectrum.fromStepping(max).toFixed(1);
                now = scope_Spectrum.fromStepping(now).toFixed(1);
                handle.children[0].setAttribute("aria-valuemin", min);
                handle.children[0].setAttribute("aria-valuemax", max);
                handle.children[0].setAttribute("aria-valuenow", now);
                handle.children[0].setAttribute("aria-valuetext", text);
            });
        });
    }
    function getGroup(pips) {
        // Use the range.
        if (pips.mode === $eb34c05e902870ae$export$126649350cd02471.Range || pips.mode === $eb34c05e902870ae$export$126649350cd02471.Steps) return scope_Spectrum.xVal;
        if (pips.mode === $eb34c05e902870ae$export$126649350cd02471.Count) {
            if (pips.values < 2) throw new Error("noUiSlider: 'values' (>= 2) required for mode 'count'.");
            // Divide 0 - 100 in 'count' parts.
            var interval = pips.values - 1;
            var spread = 100 / interval;
            var values = [];
            // List these parts and have them handled as 'positions'.
            while(interval--)values[interval] = interval * spread;
            values.push(100);
            return mapToRange(values, pips.stepped);
        }
        if (pips.mode === $eb34c05e902870ae$export$126649350cd02471.Positions) // Map all percentages to on-range values.
        return mapToRange(pips.values, pips.stepped);
        if (pips.mode === $eb34c05e902870ae$export$126649350cd02471.Values) {
            // If the value must be stepped, it needs to be converted to a percentage first.
            if (pips.stepped) return pips.values.map(function(value) {
                // Convert to percentage, apply step, return to value.
                return scope_Spectrum.fromStepping(scope_Spectrum.getStep(scope_Spectrum.toStepping(value)));
            });
            // Otherwise, we can simply use the values.
            return pips.values;
        }
        return []; // pips.mode = never
    }
    function mapToRange(values, stepped) {
        return values.map(function(value) {
            return scope_Spectrum.fromStepping(stepped ? scope_Spectrum.getStep(value) : value);
        });
    }
    function generateSpread(pips) {
        function safeIncrement(value, increment) {
            // Avoid floating point variance by dropping the smallest decimal places.
            return Number((value + increment).toFixed(7));
        }
        var group = getGroup(pips);
        var indexes = {};
        var firstInRange = scope_Spectrum.xVal[0];
        var lastInRange = scope_Spectrum.xVal[scope_Spectrum.xVal.length - 1];
        var ignoreFirst = false;
        var ignoreLast = false;
        var prevPct = 0;
        // Create a copy of the group, sort it and filter away all duplicates.
        group = $eb34c05e902870ae$var$unique(group.slice().sort(function(a, b) {
            return a - b;
        }));
        // Make sure the range starts with the first element.
        if (group[0] !== firstInRange) {
            group.unshift(firstInRange);
            ignoreFirst = true;
        }
        // Likewise for the last one.
        if (group[group.length - 1] !== lastInRange) {
            group.push(lastInRange);
            ignoreLast = true;
        }
        group.forEach(function(current, index) {
            // Get the current step and the lower + upper positions.
            var step;
            var i;
            var q;
            var low = current;
            var high = group[index + 1];
            var newPct;
            var pctDifference;
            var pctPos;
            var type;
            var steps;
            var realSteps;
            var stepSize;
            var isSteps = pips.mode === $eb34c05e902870ae$export$126649350cd02471.Steps;
            // When using 'steps' mode, use the provided steps.
            // Otherwise, we'll step on to the next subrange.
            if (isSteps) step = scope_Spectrum.xNumSteps[index];
            // Default to a 'full' step.
            if (!step) step = high - low;
            // If high is undefined we are at the last subrange. Make sure it iterates once (#1088)
            if (high === undefined) high = low;
            // Make sure step isn't 0, which would cause an infinite loop (#654)
            step = Math.max(step, 0.0000001);
            // Find all steps in the subrange.
            for(i = low; i <= high; i = safeIncrement(i, step)){
                // Get the percentage value for the current step,
                // calculate the size for the subrange.
                newPct = scope_Spectrum.toStepping(i);
                pctDifference = newPct - prevPct;
                steps = pctDifference / (pips.density || 1);
                realSteps = Math.round(steps);
                // This ratio represents the amount of percentage-space a point indicates.
                // For a density 1 the points/percentage = 1. For density 2, that percentage needs to be re-divided.
                // Round the percentage offset to an even number, then divide by two
                // to spread the offset on both sides of the range.
                stepSize = pctDifference / realSteps;
                // Divide all points evenly, adding the correct number to this subrange.
                // Run up to <= so that 100% gets a point, event if ignoreLast is set.
                for(q = 1; q <= realSteps; q += 1){
                    // The ratio between the rounded value and the actual size might be ~1% off.
                    // Correct the percentage offset by the number of points
                    // per subrange. density = 1 will result in 100 points on the
                    // full range, 2 for 50, 4 for 25, etc.
                    pctPos = prevPct + q * stepSize;
                    indexes[pctPos.toFixed(5)] = [
                        scope_Spectrum.fromStepping(pctPos),
                        0
                    ];
                }
                // Determine the point type.
                type = group.indexOf(i) > -1 ? $eb34c05e902870ae$export$ab20e68cdcd7a4fc.LargeValue : isSteps ? $eb34c05e902870ae$export$ab20e68cdcd7a4fc.SmallValue : $eb34c05e902870ae$export$ab20e68cdcd7a4fc.NoValue;
                // Enforce the 'ignoreFirst' option by overwriting the type for 0.
                if (!index && ignoreFirst && i !== high) type = 0;
                if (!(i === high && ignoreLast)) // Mark the 'type' of this point. 0 = plain, 1 = real value, 2 = step value.
                indexes[newPct.toFixed(5)] = [
                    i,
                    type
                ];
                // Update the percentage count.
                prevPct = newPct;
            }
        });
        return indexes;
    }
    function addMarking(spread, filterFunc, formatter) {
        var _a, _b;
        var element = scope_Document.createElement("div");
        var valueSizeClasses = (_a = {}, _a[$eb34c05e902870ae$export$ab20e68cdcd7a4fc.None] = "", _a[$eb34c05e902870ae$export$ab20e68cdcd7a4fc.NoValue] = options.cssClasses.valueNormal, _a[$eb34c05e902870ae$export$ab20e68cdcd7a4fc.LargeValue] = options.cssClasses.valueLarge, _a[$eb34c05e902870ae$export$ab20e68cdcd7a4fc.SmallValue] = options.cssClasses.valueSub, _a);
        var markerSizeClasses = (_b = {}, _b[$eb34c05e902870ae$export$ab20e68cdcd7a4fc.None] = "", _b[$eb34c05e902870ae$export$ab20e68cdcd7a4fc.NoValue] = options.cssClasses.markerNormal, _b[$eb34c05e902870ae$export$ab20e68cdcd7a4fc.LargeValue] = options.cssClasses.markerLarge, _b[$eb34c05e902870ae$export$ab20e68cdcd7a4fc.SmallValue] = options.cssClasses.markerSub, _b);
        var valueOrientationClasses = [
            options.cssClasses.valueHorizontal,
            options.cssClasses.valueVertical
        ];
        var markerOrientationClasses = [
            options.cssClasses.markerHorizontal,
            options.cssClasses.markerVertical
        ];
        $eb34c05e902870ae$var$addClass(element, options.cssClasses.pips);
        $eb34c05e902870ae$var$addClass(element, options.ort === 0 ? options.cssClasses.pipsHorizontal : options.cssClasses.pipsVertical);
        function getClasses(type, source) {
            var a = source === options.cssClasses.value;
            var orientationClasses = a ? valueOrientationClasses : markerOrientationClasses;
            var sizeClasses = a ? valueSizeClasses : markerSizeClasses;
            return source + " " + orientationClasses[options.ort] + " " + sizeClasses[type];
        }
        function addSpread(offset, value, type) {
            // Apply the filter function, if it is set.
            type = filterFunc ? filterFunc(value, type) : type;
            if (type === $eb34c05e902870ae$export$ab20e68cdcd7a4fc.None) return;
            // Add a marker for every point
            var node = addNodeTo(element, false);
            node.className = getClasses(type, options.cssClasses.marker);
            node.style[options.style] = offset + "%";
            // Values are only appended for points marked '1' or '2'.
            if (type > $eb34c05e902870ae$export$ab20e68cdcd7a4fc.NoValue) {
                node = addNodeTo(element, false);
                node.className = getClasses(type, options.cssClasses.value);
                node.setAttribute("data-value", String(value));
                node.style[options.style] = offset + "%";
                node.innerHTML = String(formatter.to(value));
            }
        }
        // Append all points.
        Object.keys(spread).forEach(function(offset) {
            addSpread(offset, spread[offset][0], spread[offset][1]);
        });
        return element;
    }
    function removePips() {
        if (scope_Pips) {
            $eb34c05e902870ae$var$removeElement(scope_Pips);
            scope_Pips = null;
        }
    }
    function pips(pips) {
        // Fix #669
        removePips();
        var spread = generateSpread(pips);
        var filter = pips.filter;
        var format = pips.format || {
            to: function(value) {
                return String(Math.round(value));
            }
        };
        scope_Pips = scope_Target.appendChild(addMarking(spread, filter, format));
        return scope_Pips;
    }
    // Shorthand for base dimensions.
    function baseSize() {
        var rect = scope_Base.getBoundingClientRect();
        var alt = "offset" + [
            "Width",
            "Height"
        ][options.ort];
        return options.ort === 0 ? rect.width || scope_Base[alt] : rect.height || scope_Base[alt];
    }
    // Handler for attaching events trough a proxy.
    function attachEvent(events, element, callback, data) {
        // This function can be used to 'filter' events to the slider.
        // element is a node, not a nodeList
        var method = function(event) {
            var e = fixEvent(event, data.pageOffset, data.target || element);
            // fixEvent returns false if this event has a different target
            // when handling (multi-) touch events;
            if (!e) return false;
            // doNotReject is passed by all end events to make sure released touches
            // are not rejected, leaving the slider "stuck" to the cursor;
            if (isSliderDisabled() && !data.doNotReject) return false;
            // Stop if an active 'tap' transition is taking place.
            if ($eb34c05e902870ae$var$hasClass(scope_Target, options.cssClasses.tap) && !data.doNotReject) return false;
            // Ignore right or middle clicks on start #454
            if (events === actions.start && e.buttons !== undefined && e.buttons > 1) return false;
            // Ignore right or middle clicks on start #454
            if (data.hover && e.buttons) return false;
            // 'supportsPassive' is only true if a browser also supports touch-action: none in CSS.
            // iOS safari does not, so it doesn't get to benefit from passive scrolling. iOS does support
            // touch-action: manipulation, but that allows panning, which breaks
            // sliders after zooming/on non-responsive pages.
            // See: https://bugs.webkit.org/show_bug.cgi?id=133112
            if (!supportsPassive) e.preventDefault();
            e.calcPoint = e.points[options.ort];
            // Call the event handler with the event [ and additional data ].
            callback(e, data);
            return;
        };
        var methods = [];
        // Bind a closure on the target for every event type.
        events.split(" ").forEach(function(eventName) {
            element.addEventListener(eventName, method, supportsPassive ? {
                passive: true
            } : false);
            methods.push([
                eventName,
                method
            ]);
        });
        return methods;
    }
    // Provide a clean event with standardized offset values.
    function fixEvent(e, pageOffset, eventTarget) {
        // Filter the event to register the type, which can be
        // touch, mouse or pointer. Offset changes need to be
        // made on an event specific basis.
        var touch = e.type.indexOf("touch") === 0;
        var mouse = e.type.indexOf("mouse") === 0;
        var pointer = e.type.indexOf("pointer") === 0;
        var x = 0;
        var y = 0;
        // IE10 implemented pointer events with a prefix;
        if (e.type.indexOf("MSPointer") === 0) pointer = true;
        // Erroneous events seem to be passed in occasionally on iOS/iPadOS after user finishes interacting with
        // the slider. They appear to be of type MouseEvent, yet they don't have usual properties set. Ignore
        // events that have no touches or buttons associated with them. (#1057, #1079, #1095)
        if (e.type === "mousedown" && !e.buttons && !e.touches) return false;
        // The only thing one handle should be concerned about is the touches that originated on top of it.
        if (touch) {
            // Returns true if a touch originated on the target.
            var isTouchOnTarget = function(checkTouch) {
                var target = checkTouch.target;
                return target === eventTarget || eventTarget.contains(target) || e.composed && e.composedPath().shift() === eventTarget;
            };
            // In the case of touchstart events, we need to make sure there is still no more than one
            // touch on the target so we look amongst all touches.
            if (e.type === "touchstart") {
                var targetTouches = Array.prototype.filter.call(e.touches, isTouchOnTarget);
                // Do not support more than one touch per handle.
                if (targetTouches.length > 1) return false;
                x = targetTouches[0].pageX;
                y = targetTouches[0].pageY;
            } else {
                // In the other cases, find on changedTouches is enough.
                var targetTouch = Array.prototype.find.call(e.changedTouches, isTouchOnTarget);
                // Cancel if the target touch has not moved.
                if (!targetTouch) return false;
                x = targetTouch.pageX;
                y = targetTouch.pageY;
            }
        }
        pageOffset = pageOffset || $eb34c05e902870ae$var$getPageOffset(scope_Document);
        if (mouse || pointer) {
            x = e.clientX + pageOffset.x;
            y = e.clientY + pageOffset.y;
        }
        e.pageOffset = pageOffset;
        e.points = [
            x,
            y
        ];
        e.cursor = mouse || pointer; // Fix #435
        return e;
    }
    // Translate a coordinate in the document to a percentage on the slider
    function calcPointToPercentage(calcPoint) {
        var location = calcPoint - $eb34c05e902870ae$var$offset(scope_Base, options.ort);
        var proposal = location * 100 / baseSize();
        // Clamp proposal between 0% and 100%
        // Out-of-bound coordinates may occur when .noUi-base pseudo-elements
        // are used (e.g. contained handles feature)
        proposal = $eb34c05e902870ae$var$limit(proposal);
        return options.dir ? 100 - proposal : proposal;
    }
    // Find handle closest to a certain percentage on the slider
    function getClosestHandle(clickedPosition) {
        var smallestDifference = 100;
        var handleNumber = false;
        scope_Handles.forEach(function(handle, index) {
            // Disabled handles are ignored
            if (isHandleDisabled(index)) return;
            var handlePosition = scope_Locations[index];
            var differenceWithThisHandle = Math.abs(handlePosition - clickedPosition);
            // Initial state
            var clickAtEdge = differenceWithThisHandle === 100 && smallestDifference === 100;
            // Difference with this handle is smaller than the previously checked handle
            var isCloser = differenceWithThisHandle < smallestDifference;
            var isCloserAfter = differenceWithThisHandle <= smallestDifference && clickedPosition > handlePosition;
            if (isCloser || isCloserAfter || clickAtEdge) {
                handleNumber = index;
                smallestDifference = differenceWithThisHandle;
            }
        });
        return handleNumber;
    }
    // Fire 'end' when a mouse or pen leaves the document.
    function documentLeave(event, data) {
        if (event.type === "mouseout" && event.target.nodeName === "HTML" && event.relatedTarget === null) eventEnd(event, data);
    }
    // Handle movement on document for handle and range drag.
    function eventMove(event, data) {
        // Fix #498
        // Check value of .buttons in 'start' to work around a bug in IE10 mobile (data.buttonsProperty).
        // https://connect.microsoft.com/IE/feedback/details/927005/mobile-ie10-windows-phone-buttons-property-of-pointermove-event-always-zero
        // IE9 has .buttons and .which zero on mousemove.
        // Firefox breaks the spec MDN defines.
        if (navigator.appVersion.indexOf("MSIE 9") === -1 && event.buttons === 0 && data.buttonsProperty !== 0) return eventEnd(event, data);
        // Check if we are moving up or down
        var movement = (options.dir ? -1 : 1) * (event.calcPoint - data.startCalcPoint);
        // Convert the movement into a percentage of the slider width/height
        var proposal = movement * 100 / data.baseSize;
        moveHandles(movement > 0, proposal, data.locations, data.handleNumbers, data.connect);
    }
    // Unbind move events on document, call callbacks.
    function eventEnd(event, data) {
        // The handle is no longer active, so remove the class.
        if (data.handle) {
            $eb34c05e902870ae$var$removeClass(data.handle, options.cssClasses.active);
            scope_ActiveHandlesCount -= 1;
        }
        // Unbind the move and end events, which are added on 'start'.
        data.listeners.forEach(function(c) {
            scope_DocumentElement.removeEventListener(c[0], c[1]);
        });
        if (scope_ActiveHandlesCount === 0) {
            // Remove dragging class.
            $eb34c05e902870ae$var$removeClass(scope_Target, options.cssClasses.drag);
            setZindex();
            // Remove cursor styles and text-selection events bound to the body.
            if (event.cursor) {
                scope_Body.style.cursor = "";
                scope_Body.removeEventListener("selectstart", $eb34c05e902870ae$var$preventDefault);
            }
        }
        if (options.events.smoothSteps) {
            data.handleNumbers.forEach(function(handleNumber) {
                setHandle(handleNumber, scope_Locations[handleNumber], true, true, false, false);
            });
            data.handleNumbers.forEach(function(handleNumber) {
                fireEvent("update", handleNumber);
            });
        }
        data.handleNumbers.forEach(function(handleNumber) {
            fireEvent("change", handleNumber);
            fireEvent("set", handleNumber);
            fireEvent("end", handleNumber);
        });
    }
    // Bind move events on document.
    function eventStart(event, data) {
        // Ignore event if any handle is disabled
        if (data.handleNumbers.some(isHandleDisabled)) return;
        var handle;
        if (data.handleNumbers.length === 1) {
            var handleOrigin = scope_Handles[data.handleNumbers[0]];
            handle = handleOrigin.children[0];
            scope_ActiveHandlesCount += 1;
            // Mark the handle as 'active' so it can be styled.
            $eb34c05e902870ae$var$addClass(handle, options.cssClasses.active);
        }
        // A drag should never propagate up to the 'tap' event.
        event.stopPropagation();
        // Record the event listeners.
        var listeners = [];
        // Attach the move and end events.
        var moveEvent = attachEvent(actions.move, scope_DocumentElement, eventMove, {
            // The event target has changed so we need to propagate the original one so that we keep
            // relying on it to extract target touches.
            target: event.target,
            handle: handle,
            connect: data.connect,
            listeners: listeners,
            startCalcPoint: event.calcPoint,
            baseSize: baseSize(),
            pageOffset: event.pageOffset,
            handleNumbers: data.handleNumbers,
            buttonsProperty: event.buttons,
            locations: scope_Locations.slice()
        });
        var endEvent = attachEvent(actions.end, scope_DocumentElement, eventEnd, {
            target: event.target,
            handle: handle,
            listeners: listeners,
            doNotReject: true,
            handleNumbers: data.handleNumbers
        });
        var outEvent = attachEvent("mouseout", scope_DocumentElement, documentLeave, {
            target: event.target,
            handle: handle,
            listeners: listeners,
            doNotReject: true,
            handleNumbers: data.handleNumbers
        });
        // We want to make sure we pushed the listeners in the listener list rather than creating
        // a new one as it has already been passed to the event handlers.
        listeners.push.apply(listeners, moveEvent.concat(endEvent, outEvent));
        // Text selection isn't an issue on touch devices,
        // so adding cursor styles can be skipped.
        if (event.cursor) {
            // Prevent the 'I' cursor and extend the range-drag cursor.
            scope_Body.style.cursor = getComputedStyle(event.target).cursor;
            // Mark the target with a dragging state.
            if (scope_Handles.length > 1) $eb34c05e902870ae$var$addClass(scope_Target, options.cssClasses.drag);
            // Prevent text selection when dragging the handles.
            // In noUiSlider <= 9.2.0, this was handled by calling preventDefault on mouse/touch start/move,
            // which is scroll blocking. The selectstart event is supported by FireFox starting from version 52,
            // meaning the only holdout is iOS Safari. This doesn't matter: text selection isn't triggered there.
            // The 'cursor' flag is false.
            // See: http://caniuse.com/#search=selectstart
            scope_Body.addEventListener("selectstart", $eb34c05e902870ae$var$preventDefault, false);
        }
        data.handleNumbers.forEach(function(handleNumber) {
            fireEvent("start", handleNumber);
        });
    }
    // Move closest handle to tapped location.
    function eventTap(event) {
        // The tap event shouldn't propagate up
        event.stopPropagation();
        var proposal = calcPointToPercentage(event.calcPoint);
        var handleNumber = getClosestHandle(proposal);
        // Tackle the case that all handles are 'disabled'.
        if (handleNumber === false) return;
        // Flag the slider as it is now in a transitional state.
        // Transition takes a configurable amount of ms (default 300). Re-enable the slider after that.
        if (!options.events.snap) $eb34c05e902870ae$var$addClassFor(scope_Target, options.cssClasses.tap, options.animationDuration);
        setHandle(handleNumber, proposal, true, true);
        setZindex();
        fireEvent("slide", handleNumber, true);
        fireEvent("update", handleNumber, true);
        if (!options.events.snap) {
            fireEvent("change", handleNumber, true);
            fireEvent("set", handleNumber, true);
        } else eventStart(event, {
            handleNumbers: [
                handleNumber
            ]
        });
    }
    // Fires a 'hover' event for a hovered mouse/pen position.
    function eventHover(event) {
        var proposal = calcPointToPercentage(event.calcPoint);
        var to = scope_Spectrum.getStep(proposal);
        var value = scope_Spectrum.fromStepping(to);
        Object.keys(scope_Events).forEach(function(targetEvent) {
            if ("hover" === targetEvent.split(".")[0]) scope_Events[targetEvent].forEach(function(callback) {
                callback.call(scope_Self, value);
            });
        });
    }
    // Handles keydown on focused handles
    // Don't move the document when pressing arrow keys on focused handles
    function eventKeydown(event, handleNumber) {
        if (isSliderDisabled() || isHandleDisabled(handleNumber)) return false;
        var horizontalKeys = [
            "Left",
            "Right"
        ];
        var verticalKeys = [
            "Down",
            "Up"
        ];
        var largeStepKeys = [
            "PageDown",
            "PageUp"
        ];
        var edgeKeys = [
            "Home",
            "End"
        ];
        if (options.dir && !options.ort) // On an right-to-left slider, the left and right keys act inverted
        horizontalKeys.reverse();
        else if (options.ort && !options.dir) {
            // On a top-to-bottom slider, the up and down keys act inverted
            verticalKeys.reverse();
            largeStepKeys.reverse();
        }
        // Strip "Arrow" for IE compatibility. https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
        var key = event.key.replace("Arrow", "");
        var isLargeDown = key === largeStepKeys[0];
        var isLargeUp = key === largeStepKeys[1];
        var isDown = key === verticalKeys[0] || key === horizontalKeys[0] || isLargeDown;
        var isUp = key === verticalKeys[1] || key === horizontalKeys[1] || isLargeUp;
        var isMin = key === edgeKeys[0];
        var isMax = key === edgeKeys[1];
        if (!isDown && !isUp && !isMin && !isMax) return true;
        event.preventDefault();
        var to;
        if (isUp || isDown) {
            var direction = isDown ? 0 : 1;
            var steps = getNextStepsForHandle(handleNumber);
            var step = steps[direction];
            // At the edge of a slider, do nothing
            if (step === null) return false;
            // No step set, use the default of 10% of the sub-range
            if (step === false) step = scope_Spectrum.getDefaultStep(scope_Locations[handleNumber], isDown, options.keyboardDefaultStep);
            if (isLargeUp || isLargeDown) step *= options.keyboardPageMultiplier;
            else step *= options.keyboardMultiplier;
            // Step over zero-length ranges (#948);
            step = Math.max(step, 0.0000001);
            // Decrement for down steps
            step = (isDown ? -1 : 1) * step;
            to = scope_Values[handleNumber] + step;
        } else if (isMax) // End key
        to = options.spectrum.xVal[options.spectrum.xVal.length - 1];
        else // Home key
        to = options.spectrum.xVal[0];
        setHandle(handleNumber, scope_Spectrum.toStepping(to), true, true);
        fireEvent("slide", handleNumber);
        fireEvent("update", handleNumber);
        fireEvent("change", handleNumber);
        fireEvent("set", handleNumber);
        return false;
    }
    // Attach events to several slider parts.
    function bindSliderEvents(behaviour) {
        // Attach the standard drag event to the handles.
        if (!behaviour.fixed) scope_Handles.forEach(function(handle, index) {
            // These events are only bound to the visual handle
            // element, not the 'real' origin element.
            attachEvent(actions.start, handle.children[0], eventStart, {
                handleNumbers: [
                    index
                ]
            });
        });
        // Attach the tap event to the slider base.
        if (behaviour.tap) attachEvent(actions.start, scope_Base, eventTap, {});
        // Fire hover events
        if (behaviour.hover) attachEvent(actions.move, scope_Base, eventHover, {
            hover: true
        });
        // Make the range draggable.
        if (behaviour.drag) scope_Connects.forEach(function(connect, index) {
            if (connect === false || index === 0 || index === scope_Connects.length - 1) return;
            var handleBefore = scope_Handles[index - 1];
            var handleAfter = scope_Handles[index];
            var eventHolders = [
                connect
            ];
            var handlesToDrag = [
                handleBefore,
                handleAfter
            ];
            var handleNumbersToDrag = [
                index - 1,
                index
            ];
            $eb34c05e902870ae$var$addClass(connect, options.cssClasses.draggable);
            // When the range is fixed, the entire range can
            // be dragged by the handles. The handle in the first
            // origin will propagate the start event upward,
            // but it needs to be bound manually on the other.
            if (behaviour.fixed) {
                eventHolders.push(handleBefore.children[0]);
                eventHolders.push(handleAfter.children[0]);
            }
            if (behaviour.dragAll) {
                handlesToDrag = scope_Handles;
                handleNumbersToDrag = scope_HandleNumbers;
            }
            eventHolders.forEach(function(eventHolder) {
                attachEvent(actions.start, eventHolder, eventStart, {
                    handles: handlesToDrag,
                    handleNumbers: handleNumbersToDrag,
                    connect: connect
                });
            });
        });
    }
    // Attach an event to this slider, possibly including a namespace
    function bindEvent(namespacedEvent, callback) {
        scope_Events[namespacedEvent] = scope_Events[namespacedEvent] || [];
        scope_Events[namespacedEvent].push(callback);
        // If the event bound is 'update,' fire it immediately for all handles.
        if (namespacedEvent.split(".")[0] === "update") scope_Handles.forEach(function(a, index) {
            fireEvent("update", index);
        });
    }
    function isInternalNamespace(namespace) {
        return namespace === $eb34c05e902870ae$var$INTERNAL_EVENT_NS.aria || namespace === $eb34c05e902870ae$var$INTERNAL_EVENT_NS.tooltips;
    }
    // Undo attachment of event
    function removeEvent(namespacedEvent) {
        var event = namespacedEvent && namespacedEvent.split(".")[0];
        var namespace = event ? namespacedEvent.substring(event.length) : namespacedEvent;
        Object.keys(scope_Events).forEach(function(bind) {
            var tEvent = bind.split(".")[0];
            var tNamespace = bind.substring(tEvent.length);
            if ((!event || event === tEvent) && (!namespace || namespace === tNamespace)) // only delete protected internal event if intentional
            {
                if (!isInternalNamespace(tNamespace) || namespace === tNamespace) delete scope_Events[bind];
            }
        });
    }
    // External event handling
    function fireEvent(eventName, handleNumber, tap) {
        Object.keys(scope_Events).forEach(function(targetEvent) {
            var eventType = targetEvent.split(".")[0];
            if (eventName === eventType) scope_Events[targetEvent].forEach(function(callback) {
                callback.call(// Use the slider public API as the scope ('this')
                scope_Self, // Return values as array, so arg_1[arg_2] is always valid.
                scope_Values.map(options.format.to), // Handle index, 0 or 1
                handleNumber, // Un-formatted slider values
                scope_Values.slice(), // Event is fired by tap, true or false
                tap || false, // Left offset of the handle, in relation to the slider
                scope_Locations.slice(), // add the slider public API to an accessible parameter when this is unavailable
                scope_Self);
            });
        });
    }
    // Split out the handle positioning logic so the Move event can use it, too
    function checkHandlePosition(reference, handleNumber, to, lookBackward, lookForward, getValue, smoothSteps) {
        var distance;
        // For sliders with multiple handles, limit movement to the other handle.
        // Apply the margin option by adding it to the handle positions.
        if (scope_Handles.length > 1 && !options.events.unconstrained) {
            if (lookBackward && handleNumber > 0) {
                distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber - 1], options.margin, false);
                to = Math.max(to, distance);
            }
            if (lookForward && handleNumber < scope_Handles.length - 1) {
                distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber + 1], options.margin, true);
                to = Math.min(to, distance);
            }
        }
        // The limit option has the opposite effect, limiting handles to a
        // maximum distance from another. Limit must be > 0, as otherwise
        // handles would be unmovable.
        if (scope_Handles.length > 1 && options.limit) {
            if (lookBackward && handleNumber > 0) {
                distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber - 1], options.limit, false);
                to = Math.min(to, distance);
            }
            if (lookForward && handleNumber < scope_Handles.length - 1) {
                distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber + 1], options.limit, true);
                to = Math.max(to, distance);
            }
        }
        // The padding option keeps the handles a certain distance from the
        // edges of the slider. Padding must be > 0.
        if (options.padding) {
            if (handleNumber === 0) {
                distance = scope_Spectrum.getAbsoluteDistance(0, options.padding[0], false);
                to = Math.max(to, distance);
            }
            if (handleNumber === scope_Handles.length - 1) {
                distance = scope_Spectrum.getAbsoluteDistance(100, options.padding[1], true);
                to = Math.min(to, distance);
            }
        }
        if (!smoothSteps) to = scope_Spectrum.getStep(to);
        // Limit percentage to the 0 - 100 range
        to = $eb34c05e902870ae$var$limit(to);
        // Return false if handle can't move
        if (to === reference[handleNumber] && !getValue) return false;
        return to;
    }
    // Uses slider orientation to create CSS rules. a = base value;
    function inRuleOrder(v, a) {
        var o = options.ort;
        return (o ? a : v) + ", " + (o ? v : a);
    }
    // Moves handle(s) by a percentage
    // (bool, % to move, [% where handle started, ...], [index in scope_Handles, ...])
    function moveHandles(upward, proposal, locations, handleNumbers, connect) {
        var proposals = locations.slice();
        // Store first handle now, so we still have it in case handleNumbers is reversed
        var firstHandle = handleNumbers[0];
        var smoothSteps = options.events.smoothSteps;
        var b = [
            !upward,
            upward
        ];
        var f = [
            upward,
            !upward
        ];
        // Copy handleNumbers so we don't change the dataset
        handleNumbers = handleNumbers.slice();
        // Check to see which handle is 'leading'.
        // If that one can't move the second can't either.
        if (upward) handleNumbers.reverse();
        // Step 1: get the maximum percentage that any of the handles can move
        if (handleNumbers.length > 1) handleNumbers.forEach(function(handleNumber, o) {
            var to = checkHandlePosition(proposals, handleNumber, proposals[handleNumber] + proposal, b[o], f[o], false, smoothSteps);
            // Stop if one of the handles can't move.
            if (to === false) proposal = 0;
            else {
                proposal = to - proposals[handleNumber];
                proposals[handleNumber] = to;
            }
        });
        else b = f = [
            true
        ];
        var state = false;
        // Step 2: Try to set the handles with the found percentage
        handleNumbers.forEach(function(handleNumber, o) {
            state = setHandle(handleNumber, locations[handleNumber] + proposal, b[o], f[o], false, smoothSteps) || state;
        });
        // Step 3: If a handle moved, fire events
        if (state) {
            handleNumbers.forEach(function(handleNumber) {
                fireEvent("update", handleNumber);
                fireEvent("slide", handleNumber);
            });
            // If target is a connect, then fire drag event
            if (connect != undefined) fireEvent("drag", firstHandle);
        }
    }
    // Takes a base value and an offset. This offset is used for the connect bar size.
    // In the initial design for this feature, the origin element was 1% wide.
    // Unfortunately, a rounding bug in Chrome makes it impossible to implement this feature
    // in this manner: https://bugs.chromium.org/p/chromium/issues/detail?id=798223
    function transformDirection(a, b) {
        return options.dir ? 100 - a - b : a;
    }
    // Updates scope_Locations and scope_Values, updates visual state
    function updateHandlePosition(handleNumber, to) {
        // Update locations.
        scope_Locations[handleNumber] = to;
        // Convert the value to the slider stepping/range.
        scope_Values[handleNumber] = scope_Spectrum.fromStepping(to);
        var translation = transformDirection(to, 0) - scope_DirOffset;
        var translateRule = "translate(" + inRuleOrder(translation + "%", "0") + ")";
        scope_Handles[handleNumber].style[options.transformRule] = translateRule;
        updateConnect(handleNumber);
        updateConnect(handleNumber + 1);
    }
    // Handles before the slider middle are stacked later = higher,
    // Handles after the middle later is lower
    // [[7] [8] .......... | .......... [5] [4]
    function setZindex() {
        scope_HandleNumbers.forEach(function(handleNumber) {
            var dir = scope_Locations[handleNumber] > 50 ? -1 : 1;
            var zIndex = 3 + (scope_Handles.length + dir * handleNumber);
            scope_Handles[handleNumber].style.zIndex = String(zIndex);
        });
    }
    // Test suggested values and apply margin, step.
    // if exactInput is true, don't run checkHandlePosition, then the handle can be placed in between steps (#436)
    function setHandle(handleNumber, to, lookBackward, lookForward, exactInput, smoothSteps) {
        if (!exactInput) to = checkHandlePosition(scope_Locations, handleNumber, to, lookBackward, lookForward, false, smoothSteps);
        if (to === false) return false;
        updateHandlePosition(handleNumber, to);
        return true;
    }
    // Updates style attribute for connect nodes
    function updateConnect(index) {
        // Skip connects set to false
        if (!scope_Connects[index]) return;
        var l = 0;
        var h = 100;
        if (index !== 0) l = scope_Locations[index - 1];
        if (index !== scope_Connects.length - 1) h = scope_Locations[index];
        // We use two rules:
        // 'translate' to change the left/top offset;
        // 'scale' to change the width of the element;
        // As the element has a width of 100%, a translation of 100% is equal to 100% of the parent (.noUi-base)
        var connectWidth = h - l;
        var translateRule = "translate(" + inRuleOrder(transformDirection(l, connectWidth) + "%", "0") + ")";
        var scaleRule = "scale(" + inRuleOrder(connectWidth / 100, "1") + ")";
        scope_Connects[index].style[options.transformRule] = translateRule + " " + scaleRule;
    }
    // Parses value passed to .set method. Returns current value if not parse-able.
    function resolveToValue(to, handleNumber) {
        // Setting with null indicates an 'ignore'.
        // Inputting 'false' is invalid.
        if (to === null || to === false || to === undefined) return scope_Locations[handleNumber];
        // If a formatted number was passed, attempt to decode it.
        if (typeof to === "number") to = String(to);
        to = options.format.from(to);
        if (to !== false) to = scope_Spectrum.toStepping(to);
        // If parsing the number failed, use the current value.
        if (to === false || isNaN(to)) return scope_Locations[handleNumber];
        return to;
    }
    // Set the slider value.
    function valueSet(input, fireSetEvent, exactInput) {
        var values = $eb34c05e902870ae$var$asArray(input);
        var isInit = scope_Locations[0] === undefined;
        // Event fires by default
        fireSetEvent = fireSetEvent === undefined ? true : fireSetEvent;
        // Animation is optional.
        // Make sure the initial values were set before using animated placement.
        if (options.animate && !isInit) $eb34c05e902870ae$var$addClassFor(scope_Target, options.cssClasses.tap, options.animationDuration);
        // First pass, without lookAhead but with lookBackward. Values are set from left to right.
        scope_HandleNumbers.forEach(function(handleNumber) {
            setHandle(handleNumber, resolveToValue(values[handleNumber], handleNumber), true, false, exactInput);
        });
        var i = scope_HandleNumbers.length === 1 ? 0 : 1;
        // Spread handles evenly across the slider if the range has no size (min=max)
        if (isInit && scope_Spectrum.hasNoSize()) {
            exactInput = true;
            scope_Locations[0] = 0;
            if (scope_HandleNumbers.length > 1) {
                var space_1 = 100 / (scope_HandleNumbers.length - 1);
                scope_HandleNumbers.forEach(function(handleNumber) {
                    scope_Locations[handleNumber] = handleNumber * space_1;
                });
            }
        }
        // Secondary passes. Now that all base values are set, apply constraints.
        // Iterate all handles to ensure constraints are applied for the entire slider (Issue #1009)
        for(; i < scope_HandleNumbers.length; ++i)scope_HandleNumbers.forEach(function(handleNumber) {
            setHandle(handleNumber, scope_Locations[handleNumber], true, true, exactInput);
        });
        setZindex();
        scope_HandleNumbers.forEach(function(handleNumber) {
            fireEvent("update", handleNumber);
            // Fire the event only for handles that received a new value, as per #579
            if (values[handleNumber] !== null && fireSetEvent) fireEvent("set", handleNumber);
        });
    }
    // Reset slider to initial values
    function valueReset(fireSetEvent) {
        valueSet(options.start, fireSetEvent);
    }
    // Set value for a single handle
    function valueSetHandle(handleNumber, value, fireSetEvent, exactInput) {
        // Ensure numeric input
        handleNumber = Number(handleNumber);
        if (!(handleNumber >= 0 && handleNumber < scope_HandleNumbers.length)) throw new Error("noUiSlider: invalid handle number, got: " + handleNumber);
        // Look both backward and forward, since we don't want this handle to "push" other handles (#960);
        // The exactInput argument can be used to ignore slider stepping (#436)
        setHandle(handleNumber, resolveToValue(value, handleNumber), true, true, exactInput);
        fireEvent("update", handleNumber);
        if (fireSetEvent) fireEvent("set", handleNumber);
    }
    // Get the slider value.
    function valueGet(unencoded) {
        if (unencoded === void 0) unencoded = false;
        if (unencoded) // return a copy of the raw values
        return scope_Values.length === 1 ? scope_Values[0] : scope_Values.slice(0);
        var values = scope_Values.map(options.format.to);
        // If only one handle is used, return a single value.
        if (values.length === 1) return values[0];
        return values;
    }
    // Removes classes from the root and empties it.
    function destroy() {
        // remove protected internal listeners
        removeEvent($eb34c05e902870ae$var$INTERNAL_EVENT_NS.aria);
        removeEvent($eb34c05e902870ae$var$INTERNAL_EVENT_NS.tooltips);
        Object.keys(options.cssClasses).forEach(function(key) {
            $eb34c05e902870ae$var$removeClass(scope_Target, options.cssClasses[key]);
        });
        while(scope_Target.firstChild)scope_Target.removeChild(scope_Target.firstChild);
        delete scope_Target.noUiSlider;
    }
    function getNextStepsForHandle(handleNumber) {
        var location = scope_Locations[handleNumber];
        var nearbySteps = scope_Spectrum.getNearbySteps(location);
        var value = scope_Values[handleNumber];
        var increment = nearbySteps.thisStep.step;
        var decrement = null;
        // If snapped, directly use defined step value
        if (options.snap) return [
            value - nearbySteps.stepBefore.startValue || null,
            nearbySteps.stepAfter.startValue - value || null
        ];
        // If the next value in this step moves into the next step,
        // the increment is the start of the next step - the current value
        if (increment !== false) {
            if (value + increment > nearbySteps.stepAfter.startValue) increment = nearbySteps.stepAfter.startValue - value;
        }
        // If the value is beyond the starting point
        if (value > nearbySteps.thisStep.startValue) decrement = nearbySteps.thisStep.step;
        else if (nearbySteps.stepBefore.step === false) decrement = false;
        else decrement = value - nearbySteps.stepBefore.highestStep;
        // Now, if at the slider edges, there is no in/decrement
        if (location === 100) increment = null;
        else if (location === 0) decrement = null;
        // As per #391, the comparison for the decrement step can have some rounding issues.
        var stepDecimals = scope_Spectrum.countStepDecimals();
        // Round per #391
        if (increment !== null && increment !== false) increment = Number(increment.toFixed(stepDecimals));
        if (decrement !== null && decrement !== false) decrement = Number(decrement.toFixed(stepDecimals));
        return [
            decrement,
            increment
        ];
    }
    // Get the current step size for the slider.
    function getNextSteps() {
        return scope_HandleNumbers.map(getNextStepsForHandle);
    }
    // Updatable: margin, limit, padding, step, range, animate, snap
    function updateOptions(optionsToUpdate, fireSetEvent) {
        // Spectrum is created using the range, snap, direction and step options.
        // 'snap' and 'step' can be updated.
        // If 'snap' and 'step' are not passed, they should remain unchanged.
        var v = valueGet();
        var updateAble = [
            "margin",
            "limit",
            "padding",
            "range",
            "animate",
            "snap",
            "step",
            "format",
            "pips",
            "tooltips"
        ];
        // Only change options that we're actually passed to update.
        updateAble.forEach(function(name) {
            // Check for undefined. null removes the value.
            if (optionsToUpdate[name] !== undefined) originalOptions[name] = optionsToUpdate[name];
        });
        var newOptions = $eb34c05e902870ae$var$testOptions(originalOptions);
        // Load new options into the slider state
        updateAble.forEach(function(name) {
            if (optionsToUpdate[name] !== undefined) options[name] = newOptions[name];
        });
        scope_Spectrum = newOptions.spectrum;
        // Limit, margin and padding depend on the spectrum but are stored outside of it. (#677)
        options.margin = newOptions.margin;
        options.limit = newOptions.limit;
        options.padding = newOptions.padding;
        // Update pips, removes existing.
        if (options.pips) pips(options.pips);
        else removePips();
        // Update tooltips, removes existing.
        if (options.tooltips) tooltips();
        else removeTooltips();
        // Invalidate the current positioning so valueSet forces an update.
        scope_Locations = [];
        valueSet($eb34c05e902870ae$var$isSet(optionsToUpdate.start) ? optionsToUpdate.start : v, fireSetEvent);
    }
    // Initialization steps
    function setupSlider() {
        // Create the base element, initialize HTML and set classes.
        // Add handles and connect elements.
        scope_Base = addSlider(scope_Target);
        addElements(options.connect, scope_Base);
        // Attach user events.
        bindSliderEvents(options.events);
        // Use the public value method to set the start values.
        valueSet(options.start);
        if (options.pips) pips(options.pips);
        if (options.tooltips) tooltips();
        aria();
    }
    setupSlider();
    var scope_Self = {
        destroy: destroy,
        steps: getNextSteps,
        on: bindEvent,
        off: removeEvent,
        get: valueGet,
        set: valueSet,
        setHandle: valueSetHandle,
        reset: valueReset,
        disable: disable,
        enable: enable,
        // Exposed for unit testing, don't use this in your application.
        __moveHandles: function(upward, proposal, handleNumbers) {
            moveHandles(upward, proposal, scope_Locations, handleNumbers);
        },
        options: originalOptions,
        updateOptions: updateOptions,
        target: scope_Target,
        removePips: removePips,
        removeTooltips: removeTooltips,
        getPositions: function() {
            return scope_Locations.slice();
        },
        getTooltips: function() {
            return scope_Tooltips;
        },
        getOrigins: function() {
            return scope_Handles;
        },
        pips: pips
    };
    return scope_Self;
}
// Run the standard initializer
function $eb34c05e902870ae$export$185802fd694ee1f5(target, originalOptions) {
    if (!target || !target.nodeName) throw new Error("noUiSlider: create requires a single element, got: " + target);
    // Throw an error if the slider was already initialized.
    if (target.noUiSlider) throw new Error("noUiSlider: Slider was already initialized.");
    // Test the options and create the slider environment;
    var options = $eb34c05e902870ae$var$testOptions(originalOptions);
    var api = $eb34c05e902870ae$var$scope(target, options, originalOptions);
    target.noUiSlider = api;
    return api;
}
var $eb34c05e902870ae$export$2e2bcd8739ae039 = {
    // Exposed for unit testing, don't use this in your application.
    __spectrum: $eb34c05e902870ae$var$Spectrum,
    // A reference to the default classes, allows global changes.
    // Use the cssClasses option for changes to one slider.
    cssClasses: $eb34c05e902870ae$export$c1c0562ec8379000,
    create: $eb34c05e902870ae$export$185802fd694ee1f5
};


var $a4adf245921ae341$exports = {};
(function(factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else // Node/CommonJS
    $a4adf245921ae341$exports = factory();
})(function() {
    "use strict";
    var FormatOptions = [
        "decimals",
        "thousand",
        "mark",
        "prefix",
        "suffix",
        "encoder",
        "decoder",
        "negativeBefore",
        "negative",
        "edit",
        "undo"
    ];
    // General
    // Reverse a string
    function strReverse(a) {
        return a.split("").reverse().join("");
    }
    // Check if a string starts with a specified prefix.
    function strStartsWith(input, match) {
        return input.substring(0, match.length) === match;
    }
    // Check is a string ends in a specified suffix.
    function strEndsWith(input, match) {
        return input.slice(-1 * match.length) === match;
    }
    // Throw an error if formatting options are incompatible.
    function throwEqualError(F, a, b) {
        if ((F[a] || F[b]) && F[a] === F[b]) throw new Error(a);
    }
    // Check if a number is finite and not NaN
    function isValidNumber(input) {
        return typeof input === "number" && isFinite(input);
    }
    // Provide rounding-accurate toFixed method.
    // Borrowed: http://stackoverflow.com/a/21323330/775265
    function toFixed(value, exp) {
        value = value.toString().split("e");
        value = Math.round(+(value[0] + "e" + (value[1] ? +value[1] + exp : exp)));
        value = value.toString().split("e");
        return (+(value[0] + "e" + (value[1] ? +value[1] - exp : -exp))).toFixed(exp);
    }
    // Formatting
    // Accept a number as input, output formatted string.
    function formatTo(decimals, thousand, mark, prefix, suffix, encoder, decoder, negativeBefore, negative, edit, undo, input) {
        var originalInput = input, inputIsNegative, inputPieces, inputBase, inputDecimals = "", output = "";
        // Apply user encoder to the input.
        // Expected outcome: number.
        if (encoder) input = encoder(input);
        // Stop if no valid number was provided, the number is infinite or NaN.
        if (!isValidNumber(input)) return false;
        // Rounding away decimals might cause a value of -0
        // when using very small ranges. Remove those cases.
        if (decimals !== false && parseFloat(input.toFixed(decimals)) === 0) input = 0;
        // Formatting is done on absolute numbers,
        // decorated by an optional negative symbol.
        if (input < 0) {
            inputIsNegative = true;
            input = Math.abs(input);
        }
        // Reduce the number of decimals to the specified option.
        if (decimals !== false) input = toFixed(input, decimals);
        // Transform the number into a string, so it can be split.
        input = input.toString();
        // Break the number on the decimal separator.
        if (input.indexOf(".") !== -1) {
            inputPieces = input.split(".");
            inputBase = inputPieces[0];
            if (mark) inputDecimals = mark + inputPieces[1];
        } else // If it isn't split, the entire number will do.
        inputBase = input;
        // Group numbers in sets of three.
        if (thousand) {
            inputBase = strReverse(inputBase).match(/.{1,3}/g);
            inputBase = strReverse(inputBase.join(strReverse(thousand)));
        }
        // If the number is negative, prefix with negation symbol.
        if (inputIsNegative && negativeBefore) output += negativeBefore;
        // Prefix the number
        if (prefix) output += prefix;
        // Normal negative option comes after the prefix. Defaults to '-'.
        if (inputIsNegative && negative) output += negative;
        // Append the actual number.
        output += inputBase;
        output += inputDecimals;
        // Apply the suffix.
        if (suffix) output += suffix;
        // Run the output through a user-specified post-formatter.
        if (edit) output = edit(output, originalInput);
        // All done.
        return output;
    }
    // Accept a sting as input, output decoded number.
    function formatFrom(decimals, thousand, mark, prefix, suffix, encoder, decoder, negativeBefore, negative, edit, undo, input) {
        var originalInput = input, inputIsNegative, output = "";
        // User defined pre-decoder. Result must be a non empty string.
        if (undo) input = undo(input);
        // Test the input. Can't be empty.
        if (!input || typeof input !== "string") return false;
        // If the string starts with the negativeBefore value: remove it.
        // Remember is was there, the number is negative.
        if (negativeBefore && strStartsWith(input, negativeBefore)) {
            input = input.replace(negativeBefore, "");
            inputIsNegative = true;
        }
        // Repeat the same procedure for the prefix.
        if (prefix && strStartsWith(input, prefix)) input = input.replace(prefix, "");
        // And again for negative.
        if (negative && strStartsWith(input, negative)) {
            input = input.replace(negative, "");
            inputIsNegative = true;
        }
        // Remove the suffix.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/slice
        if (suffix && strEndsWith(input, suffix)) input = input.slice(0, -1 * suffix.length);
        // Remove the thousand grouping.
        if (thousand) input = input.split(thousand).join("");
        // Set the decimal separator back to period.
        if (mark) input = input.replace(mark, ".");
        // Prepend the negative symbol.
        if (inputIsNegative) output += "-";
        // Add the number
        output += input;
        // Trim all non-numeric characters (allow '.' and '-');
        output = output.replace(/[^0-9\.\-.]/g, "");
        // The value contains no parse-able number.
        if (output === "") return false;
        // Covert to number.
        output = Number(output);
        // Run the user-specified post-decoder.
        if (decoder) output = decoder(output);
        // Check is the output is valid, otherwise: return false.
        if (!isValidNumber(output)) return false;
        return output;
    }
    // Framework
    // Validate formatting options
    function validate(inputOptions) {
        var i, optionName, optionValue, filteredOptions = {};
        if (inputOptions["suffix"] === undefined) inputOptions["suffix"] = inputOptions["postfix"];
        for(i = 0; i < FormatOptions.length; i += 1){
            optionName = FormatOptions[i];
            optionValue = inputOptions[optionName];
            if (optionValue === undefined) {
                // Only default if negativeBefore isn't set.
                if (optionName === "negative" && !filteredOptions.negativeBefore) filteredOptions[optionName] = "-";
                else if (optionName === "mark" && filteredOptions.thousand !== ".") filteredOptions[optionName] = ".";
                else filteredOptions[optionName] = false;
            // Floating points in JS are stable up to 7 decimals.
            } else if (optionName === "decimals") {
                if (optionValue >= 0 && optionValue < 8) filteredOptions[optionName] = optionValue;
                else throw new Error(optionName);
            // These options, when provided, must be functions.
            } else if (optionName === "encoder" || optionName === "decoder" || optionName === "edit" || optionName === "undo") {
                if (typeof optionValue === "function") filteredOptions[optionName] = optionValue;
                else throw new Error(optionName);
            // Other options are strings.
            } else {
                if (typeof optionValue === "string") filteredOptions[optionName] = optionValue;
                else throw new Error(optionName);
            }
        }
        // Some values can't be extracted from a
        // string if certain combinations are present.
        throwEqualError(filteredOptions, "mark", "thousand");
        throwEqualError(filteredOptions, "prefix", "negative");
        throwEqualError(filteredOptions, "prefix", "negativeBefore");
        return filteredOptions;
    }
    // Pass all options as function arguments
    function passAll(options, method, input) {
        var i, args = [];
        // Add all options in order of FormatOptions
        for(i = 0; i < FormatOptions.length; i += 1)args.push(options[FormatOptions[i]]);
        // Append the input, then call the method, presenting all
        // options as arguments.
        args.push(input);
        return method.apply("", args);
    }
    function wNumb(options) {
        if (!(this instanceof wNumb)) return new wNumb(options);
        if (typeof options !== "object") return;
        options = validate(options);
        // Call 'formatTo' with proper arguments.
        this.to = function(input) {
            return passAll(options, formatTo, input);
        };
        // Call 'formatFrom' with proper arguments.
        this.from = function(input) {
            return passAll(options, formatFrom, input);
        };
    }
    return wNumb;
});



var $O6tRJ = parcelRequire("O6tRJ");

class $39c378db5b87f4a4$var$Explorer extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
        this.state = {
            componentOpen: true,
            tabOpen: 0,
            showingCategories: (0, $2860f5f07c24e63c$export$2e2bcd8739ae039).categories.numberOfElements,
            activeCategory: null,
            categories: [],
            apiErrorCategories: false,
            isDirty: false
        };
        this.focusRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createRef();
        this.focusRef.current = {
            focus: -1
        };
    }
    theRange = null;
    _initSlider() {
        this.theRange = document.getElementById("gallery-explore-year-range");
        (0, $eb34c05e902870ae$export$2e2bcd8739ae039).create(this.theRange, {
            start: [
                this.props.minMax.min,
                this.props.minMax.max
            ],
            behaviour: "tap-drag",
            tooltips: true,
            connect: true,
            format: (0, (/*@__PURE__*/$parcel$interopDefault($a4adf245921ae341$exports)))({
                decimals: 0
            }),
            range: {
                min: this.props.minMax.min,
                max: this.props.minMax.max
            }
        });
        // Accessibility
        var handleLower = this.theRange.querySelector(".noUi-handle-lower");
        var handleUpper = this.theRange.querySelector(".noUi-handle-upper");
        var self = this;
        handleLower.addEventListener("keydown", function(e) {
            var value = Number(self.theRange.noUiSlider.get()[0]);
            if (e.which === 37) self.theRange.noUiSlider.set([
                value - 10,
                null
            ]);
            if (e.which === 39) self.theRange.noUiSlider.set([
                value + 10,
                null
            ]);
        });
        handleUpper.addEventListener("keydown", function(e) {
            var value = Number(self.theRange.noUiSlider.get()[1]);
            if (e.which === 37) self.theRange.noUiSlider.set([
                null,
                value - 10
            ]);
            if (e.which === 39) self.theRange.noUiSlider.set([
                null,
                value + 10
            ]);
        });
    }
    _resetList = ()=>{
        this.setState({
            activeCategory: null
        });
        this.props.resetList();
    };
    _toggleTab = (e)=>{
        const element = e.target.parentElement;
        const activeTab = Array.from(element.parentNode.children).indexOf(element);
        this.setState({
            tabOpen: activeTab
        });
        activeTab == 0 && !element.classList.contains("selected") && this._resetList();
        this.props.toggleTab(activeTab);
        e.preventDefault();
    };
    _showMoreCats = ()=>{
        this.focusRef.current.focus = document.getElementsByClassName("gallery-explorer-category").length;
        this.setState({
            showingCategories: this.state.categories.length
        });
    };
    _showLessCats = ()=>{
        this.focusRef.current.focus = 0;
        this.setState({
            showingCategories: (0, $2860f5f07c24e63c$export$2e2bcd8739ae039).categories.numberOfElements
        });
    };
    _search = ()=>{
        const searchQuery = document.getElementById("gallery-explorer-input-search").value;
        if (searchQuery.length < (0, $2860f5f07c24e63c$export$2e2bcd8739ae039).search.minimumNumberOfChars) return false;
        this.props.search(searchQuery, this.theRange.noUiSlider.get()[0], this.theRange.noUiSlider.get()[1], (0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.numberOfElements, 0);
        this.setState({
            isDirty: true
        });
    };
    _clickCategory = (category)=>{
        if (this.state.activeCategory && category.category === this.state.activeCategory.category) category = null;
        this.setState({
            activeCategory: category
        });
        this.props.clickCategory(category, (0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.numberOfElements, 0);
    };
    _toggleComponent = (e)=>{
        const open = e.target.classList.contains("open");
        this.setState({
            componentOpen: open ? false : true
        });
    };
    _getCategories = ()=>{
        (0, $b5af3106de28ce48$export$2e2bcd8739ae039).getCategories((jsonData)=>{
            let categories = jsonData.docs.map((item)=>{
                return {
                    image: (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).image.getUrl(item, 400),
                    category: item["artifact.ingress.title"],
                    id: item["artifact.uuid"],
                    mediaIdentifier: item["artifact.defaultMediaIdentifier"]
                };
            });
            categories = (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).sortBy(categories, [
                "category",
                "asc"
            ]);
            this.setState({
                categories: categories
            });
        }, (error)=>{
            this.setState({
                apiErrorCategories: true
            });
            return null;
        });
    };
    _resetSearch = ()=>{
        document.getElementById("gallery-explorer-input-search").value = "";
        this.theRange.noUiSlider.set([
            this.props.minMax.min,
            this.props.minMax.max
        ]);
        this.setState({
            isDirty: false
        });
        this._resetList();
    };
    _enterPressed(event) {
        var code = event.keyCode || event.which;
        if (code === 13) {
            event.preventDefault();
            this._search();
            return false;
        }
    }
    UNSAFE_componentWillMount() {
        this._getCategories();
    }
    componentDidMount() {
        this._initSlider();
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            activeCategory: nextProps.activeCategory,
            tabOpen: nextProps.activeTab
        });
    }
    UNSAFE_componentWillUpdate(nextProps) {
        const minMax = nextProps.minMax;
        const currentMinMax = this.theRange.noUiSlider.get();
        if (minMax.min === currentMinMax[0] && minMax.max === currentMinMax[1]) return;
        this.theRange.noUiSlider.updateOptions({
            range: nextProps.minMax
        });
    }
    componentDidUpdate() {
        const focus = this.focusRef?.current?.focus;
        if (focus > -1) {
            var elements = document.getElementsByClassName("gallery-explorer-category");
            if (elements && elements.length > focus) elements[focus].focus();
            this.focusRef.current.focus = -1;
        }
    }
    render() {
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "big-toggler-trigger",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                        type: "button",
                        onClick: this._toggleComponent,
                        className: "reset icon-right" + (this.state.componentOpen ? " icon-zoom-out open" : " icon-zoom-in"),
                        children: this.props.cmsData.exploreText
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    className: "gallery-explorer" + (this.state.componentOpen ? " open" : ""),
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("ul", {
                            className: "tabs",
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                                        href: "#",
                                        className: this.state.tabOpen == 0 ? "selected" : null,
                                        onClick: this._toggleTab,
                                        children: this.props.cmsData.categoriesText
                                    })
                                }),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("a", {
                                        href: "#",
                                        className: this.state.tabOpen == 1 ? "selected" : null,
                                        onClick: this._toggleTab,
                                        children: this.props.cmsData.searchText
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                            className: "gallery-explorer-content",
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                    className: "gallery-explorer-cat" + (this.state.tabOpen == 0 ? " active" : null),
                                    children: this.state.apiErrorCategories ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h3", {
                                        children: this.props.cmsData.noContactText
                                    }) : /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                className: "gallery-explorer-categories",
                                                children: this.state.categories.map((cat, index)=>{
                                                    if (index >= this.state.showingCategories) return null;
                                                    else {
                                                        let isActive = this.state.activeCategory && this.state.activeCategory.category === cat.category;
                                                        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $310261aeebd1f063$export$2e2bcd8739ae039), {
                                                            clickCategory: this._clickCategory,
                                                            isActiveCategory: isActive,
                                                            item: cat
                                                        }, index);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                children: [
                                                    this.state.showingCategories < this.state.categories.length ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                                                        className: "btn-link",
                                                        onClick: this._showMoreCats,
                                                        children: this.props.cmsData.showMoreCategoriesText
                                                    }) : null,
                                                    this.state.showingCategories === this.state.categories.length ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                                                        className: "btn-link",
                                                        onClick: this._showLessCats,
                                                        children: this.props.cmsData.showLessCategoriesText
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                    className: "gallery-explorer-search form-area" + (this.state.tabOpen == 1 ? " active" : null),
                                    children: [
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                            className: "row",
                                            children: [
                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                    className: "small-12 medium-5 columns",
                                                    children: [
                                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("label", {
                                                            htmlFor: "gallery-explorer-input-search",
                                                            className: "label-fullwidth",
                                                            children: this.props.cmsData.searchText
                                                        }),
                                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                                                            placeholder: (0, $af1a830b203b2f3e$export$2e2bcd8739ae039).get("searchPlaceholderMinChars"),
                                                            type: "text",
                                                            id: "gallery-explorer-input-search",
                                                            onKeyPress: this._enterPressed.bind(this)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                    className: "small-12 medium-5 columns",
                                                    children: [
                                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("label", {
                                                            className: "label-fullwidth",
                                                            children: this.props.cmsData.periodText
                                                        }),
                                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                            id: "gallery-explore-year-range"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                    className: "small-12 medium-2 gallery-explorer-button-wrapper columns",
                                                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("input", {
                                                        type: "button",
                                                        className: "button submit",
                                                        value: this.props.cmsData.searchButtonText,
                                                        onClick: this._search
                                                    })
                                                })
                                            ]
                                        }),
                                        this.state.isDirty && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                            className: "row",
                                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                className: "small-12 medium-6 columns",
                                                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                                                    className: "btn-link",
                                                    onClick: this._resetSearch,
                                                    children: this.props.cmsData.resetSearchText
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
var $39c378db5b87f4a4$export$2e2bcd8739ae039 = $39c378db5b87f4a4$var$Explorer;




var $8NFma = parcelRequire("8NFma");

class $f33a69850a5ce02d$var$CategoryInfo extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
        this.state = {
            componentOpen: false,
            folderText: null
        };
    }
    UNSAFE_componentWillMount() {
        (0, $b5af3106de28ce48$export$2e2bcd8739ae039).getCategoryInfo((jsonData)=>{
            const text = jsonData.folder.description ? jsonData.folder.description : this.props.cmsData.noInformationText;
            this.setState({
                folderText: text
            });
        }, (error)=>{
            this.setState({
                folderText: this.props.cmsData.noContactText
            });
            console.error(error);
        }, this.props.category.id);
    }
    _toggleComponent = (e)=>{
        const open = e.target.classList.contains("open");
        this.setState({
            componentOpen: !open
        });
    };
    render() {
        var folderText = this.state.folderText;
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: "row page-section section-gallery-category-info",
            id: "gallery-category-info",
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: "large-12 columns",
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        className: "big-toggler-trigger",
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                            type: "button",
                            onClick: this._toggleComponent,
                            className: "reset icon-right " + (this.state.componentOpen ? " icon-zoom-out open" : " icon-zoom-in"),
                            children: this.props.cmsData.buttonCategoryText
                        })
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        className: "gallery-category-info" + (this.state.componentOpen ? " open" : " closed"),
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                className: "gallery-category-info-fade"
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                className: "gallery-category-info-text",
                                children: folderText && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: folderText.replace(/(?:\r\n|\r|\\r\\n)/g, "<br />")
                                    }
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
}
var $f33a69850a5ce02d$export$2e2bcd8739ae039 = $f33a69850a5ce02d$var$CategoryInfo;


var $fa959c863eba98ce$exports = {};
var $fa959c863eba98ce$var$sortBy, $fa959c863eba98ce$var$sort;
/**
 * Return a comparator function
 * @param  {String} property The key to sort by
 * @return {Function}        Returns the comparator function
 */ $fa959c863eba98ce$var$sort = function sort(property) {
    var sortOrder = 1, fn;
    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    fn = function fn(a, b) {
        var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
    };
    return fn;
};
/**
 * Return a comparator function that sorts by multiple keys
 * @return {Function} Returns the comparator function
 */ $fa959c863eba98ce$var$sortBy = function sortBy() {
    var props = arguments, fn;
    fn = function fn(obj1, obj2) {
        var numberOfProperties = props.length, result = 0, i = 0;
        /* try getting a different result from 0 (equal)
         * as long as we have extra properties to compare
         */ while(result === 0 && i < numberOfProperties){
            result = $fa959c863eba98ce$var$sort(props[i])(obj1, obj2);
            i++;
        }
        return result;
    };
    return fn;
};
$fa959c863eba98ce$exports = $fa959c863eba98ce$var$sortBy;



var $O6tRJ = parcelRequire("O6tRJ");

class $180698882f1a5b17$var$Nettgalleri extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    constructor(props){
        super(props);
        this.tempList = [];
        (0, $af1a830b203b2f3e$export$2e2bcd8739ae039).lang = window.cmsData.configs.lang;
        (0, $2860f5f07c24e63c$export$2e2bcd8739ae039).list.numberOfElements = window.cmsData.configs.listNumberOfElements;
        (0, $2860f5f07c24e63c$export$2e2bcd8739ae039).categories.numberOfElements = window.cmsData.configs.categoriesNumberOfElements;
        (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).dom.breadcrumb.addLinkToSelf();
        this.state = {
            sourceItems: [],
            viewItems: [],
            slide: 0,
            cmsData: window.cmsData,
            itemsPerRow: 4,
            numberOfShowing: (0, $2860f5f07c24e63c$export$2e2bcd8739ae039).list.numberOfElements,
            gridItems: [],
            sortedBy: "relevance",
            apiSearchError: false,
            apiAllError: false,
            apiCategoryContentError: false,
            searchHasNoHits: false,
            title: window.cmsData.title,
            gridTitle: window.cmsData.showsHitsText,
            minAndMaxYear: {
                min: 0,
                max: parseInt(new Date().getFullYear())
            },
            currentCategory: null,
            activeTab: 0,
            oldViewItems: [],
            oldSlide: 0,
            oldGridItems: [],
            isSeries: false,
            multipleActive: false
        };
    }
    _changeActiveItem = (slide)=>{
        (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).url.setParameterId(this.state.viewItems[slide]);
        this.setState({
            slide: slide
        });
    };
    _setVersions = (newArr, historyNavigation = false)=>{
        // Series
        if (newArr[0].isSeries) {
            let activeIndex = (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).findIndex(newArr, (item)=>{
                return item["identifier.id"] === this.state.viewItems[this.state.slide]["identifier.id"];
            });
            this.setState({
                oldViewItems: this.state.viewItems,
                oldSlide: this.state.slide,
                viewItems: newArr,
                isSeries: true,
                slide: activeIndex,
                multipleActive: true,
                oldGridItems: this.state.gridItems,
                gridItems: newArr,
                oldGridTitle: this.state.cmsData.showsHitsText,
                gridTitle: this.state.cmsData.seriesHitsText
            });
        } else this.setState({
            oldViewItems: this.state.viewItems,
            oldSlide: this.state.slide,
            viewItems: newArr,
            isSeries: false,
            slide: 0,
            multipleActive: true,
            oldGridItems: this.state.gridItems,
            gridItems: newArr,
            oldGridTitle: this.state.cmsData.showsHitsText,
            gridTitle: this.state.cmsData.versionsHitsText
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($22374b4858edafee$exports)))("#gallery-grid", {
            offset: -190,
            ease: "in-sine",
            duration: 300
        });
    };
    _endVersions = ()=>{
        this.setState({
            viewItems: this.state.oldViewItems,
            slide: this.state.oldSlide,
            multipleActive: false,
            isSeries: false,
            gridItems: this.state.oldGridItems,
            gridTitle: this.state.cmsData.showsHitsText
        });
    };
    _clickThumb = (slide)=>{
        this._changeActiveItem(slide);
        history.pushState({
            activeSlide: slide,
            type: "clickThumb"
        }, null, document.location.href);
    };
    _clickCategory = (category, rows, start, historyNavigation = false)=>{
        this._resetList();
        this.setState({
            activeCategory: category
        });
        if (!category) {
            if (!historyNavigation) history.pushState({
                cat: "",
                type: "resetCategory"
            }, null, document.location.href);
        } else {
            this._getCategoryContentData(category, rows, start);
            if (!historyNavigation) history.pushState({
                cat: category,
                type: "clickCategory"
            }, null, document.location.href);
        }
    };
    _toggleTab = (tab)=>{
        this.setState({
            activeTab: tab
        });
    };
    _getCategoryContentData = (category, rows, start)=>{
        (0, $b5af3106de28ce48$export$2e2bcd8739ae039).getCategoryContent((jsonData)=>{
            this.tempList = this.tempList.concat(jsonData.docs);
            if (Number(jsonData.numFoundOnServer) > 0 && this.tempList.length < jsonData.numFoundOnServer || this.tempList.length < jsonData.numFound) this._getCategoryContentData(category, rows, this.tempList.length);
            else {
                this.tempList = this._mappedArrayForSorting(this.tempList).sort((0, (/*@__PURE__*/$parcel$interopDefault($fa959c863eba98ce$exports)))("title"));
                (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).url.setParameterId(this.tempList[0]);
                this.setState({
                    viewItems: this.tempList,
                    gridItems: this.tempList.slice(0, this.state.numberOfShowing),
                    slide: 0,
                    sortedBy: "title-asc",
                    title: `${this.state.cmsData.title} \u{2013} ${category.category}`,
                    gridTitle: this.state.cmsData.categoriesHitsText.replace((0, $2860f5f07c24e63c$export$2e2bcd8739ae039).selectors.category, category.category),
                    currentCategory: category
                });
                (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).dom.breadcrumb.addCategory(category);
                this.tempList = [];
                setTimeout(()=>{
                    (0, (/*@__PURE__*/$parcel$interopDefault($22374b4858edafee$exports)))("#gallery-category-info", {
                        offset: -80,
                        ease: "in-sine",
                        duration: 300
                    });
                }, 200);
            }
        }, (error)=>{
            this.setState({
                apiCategoryContentError: true
            });
        }, category.id, rows, start);
    };
    _resetList = ()=>{
        this.setState({
            viewItems: this.state.sourceItems,
            gridItems: this.state.sourceItems.slice(0, this.state.numberOfShowing),
            slide: 0,
            sortedBy: "relevance",
            title: this.state.cmsData.title,
            searchHasNoHits: false,
            gridTitle: this.state.cmsData.showsHitsText,
            currentCategory: null,
            multipleActive: false,
            isSeries: false
        });
        (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).url.setParameterId(this.state.sourceItems[0]);
        (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).dom.breadcrumb.removeCurrentCategory();
    };
    _showMore = ()=>{
        const incrementBy = (0, $2860f5f07c24e63c$export$2e2bcd8739ae039).list.numberOfElements;
        const newCount = this.state.numberOfShowing + incrementBy;
        const listLength = this.state.viewItems.length;
        if (newCount <= listLength) this.setState({
            numberOfShowing: newCount
        });
        else this.setState({
            numberOfShowing: this.state.gridItems.length
        });
        this.setState({
            gridItems: this.state.viewItems.slice(0, newCount)
        });
    };
    _mappedArrayForSorting = (array)=>{
        return array.map(function(item) {
            if (!!item["artifact.ingress.title"] && !item.title) item.title = item["artifact.ingress.title"];
            item.year = item["artifact.ingress.production.toYear"];
            item.artistLastName = item["artifact.ingress.producer"];
            return item;
        });
    };
    _translateSortedBy = (key)=>{
        const data = this.state.cmsData;
        switch(key){
            case (0, $2860f5f07c24e63c$export$2e2bcd8739ae039).sort.relevance:
                return data.sortRelevanceText;
            case (0, $2860f5f07c24e63c$export$2e2bcd8739ae039).sort.titleAsc:
                return data.sortTitleAscText;
            case (0, $2860f5f07c24e63c$export$2e2bcd8739ae039).sort.timeAsc:
                return data.sortTimeAscText;
            case (0, $2860f5f07c24e63c$export$2e2bcd8739ae039).sort.timeDesc:
                return data.sortTimeDescText;
            case (0, $2860f5f07c24e63c$export$2e2bcd8739ae039).sort.artistLastnameAsc:
                return data.sortArtistLastnameText;
            default:
                return data.sortRelevanceText;
        }
    };
    _sortBy = (by)=>{
        let sortedArr = [];
        sortedArr = this._mappedArrayForSorting(this.state.viewItems);
        if (by == "relevance") (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).lists.shuffleArray(sortedArr);
        if (by == "title-asc") sortedArr.sort((0, (/*@__PURE__*/$parcel$interopDefault($fa959c863eba98ce$exports)))("title"));
        if (by == "title-desc") sortedArr.sort((0, (/*@__PURE__*/$parcel$interopDefault($fa959c863eba98ce$exports)))("-title"));
        if (by == "time-desc") sortedArr = (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).orderBy(sortedArr, [
            (data)=>{
                if (data["year"] === null) data["year"] = "";
                return data["year"] || "";
            }
        ], [
            "desc"
        ]);
        if (by == "time-asc") sortedArr = (0, (/*@__PURE__*/$parcel$interopDefault($O6tRJ))).orderBy(sortedArr, [
            (data)=>{
                if (data["year"] === null) data["year"] = "";
                return data["year"];
            }
        ], [
            "asc"
        ]);
        if (by == "artist-lastname-asc") sortedArr.sort((0, (/*@__PURE__*/$parcel$interopDefault($fa959c863eba98ce$exports)))("artistLastName"));
        this.setState({
            viewItems: sortedArr,
            gridItems: sortedArr.slice(0, this.state.numberOfShowing),
            sortedBy: by,
            slide: 0
        });
    };
    _search = (query, yearFrom, yearTo, rows, start, historyNavigation = false)=>{
        this._resetList();
        (0, $b5af3106de28ce48$export$2e2bcd8739ae039).getSearch((jsonData)=>{
            this.tempList = this.tempList.concat(jsonData.docs);
            if (this.tempList.length < jsonData.numFound) this._search(query, yearFrom, yearTo, rows, this.tempList.length, true);
            else {
                if (this.tempList.length > 0) (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).url.setParameterId(this.tempList[0]);
                const hasNoHits = this.tempList.length === 0;
                this.setState({
                    viewItems: this.tempList,
                    gridItems: this.tempList,
                    slide: 0,
                    sortedBy: "relevance",
                    searchHasNoHits: hasNoHits,
                    gridTitle: hasNoHits ? this.state.cmsData.searchNoHitsText.replace((0, $2860f5f07c24e63c$export$2e2bcd8739ae039).selectors.search, query) : this.state.cmsData.searchHitsText.replace((0, $2860f5f07c24e63c$export$2e2bcd8739ae039).selectors.search, query)
                });
                this.tempList = [];
                setTimeout(()=>{
                    (0, (/*@__PURE__*/$parcel$interopDefault($22374b4858edafee$exports)))("#gallery-grid", {
                        offset: -90,
                        ease: "in-sine",
                        duration: 300
                    });
                }, 200);
            }
        }, (error)=>{
            this.setState({
                apiSearchError: true,
                searchHasNoHits: false
            });
        }, query, yearFrom, yearTo, rows, start);
        this.setState({
            activeTab: 1
        });
        if (!historyNavigation) history.pushState({
            search: {
                query: query,
                sliderMin: yearFrom,
                sliderMax: yearTo
            },
            type: "search"
        }, null, document.location.href);
    };
    _getAllData = (rows, start)=>{
        (0, $b5af3106de28ce48$export$2e2bcd8739ae039).getAll((jsonData)=>{
            this.tempList = this.tempList.concat(jsonData.docs);
            if (this.tempList.length < jsonData.numFound) this._getAllData(rows, this.tempList.length);
            else {
                (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).lists.shuffleArray(this.tempList);
                const minMaxYear = (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).lists.minAndMaxYearFromList(this.tempList);
                var parameterSlide = (0, $73b62b3ff22ff0bc$export$2e2bcd8739ae039).url.getParameterIndex(this.tempList, this.state.slide, this.state.cmsData.prioritizedImage);
                this.setState({
                    sourceItems: this.tempList,
                    viewItems: this.tempList,
                    gridItems: this.tempList.slice(0, this.state.numberOfShowing),
                    slide: parameterSlide,
                    gridTitle: this.state.cmsData.showsHitsText,
                    minAndMaxYear: minMaxYear
                });
                this.tempList = [];
            }
        }, (error)=>{
            console.error(error);
            this.setState({
                apiAllError: true
            });
        }, rows, start);
    };
    UNSAFE_componentWillMount() {
        this._getAllData((0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.numberOfElements, 0);
    }
    componentDidMount() {
        const self = this;
        window.onpopstate = function(event) {
            // back to initial load
            if (!history.state) {
                self._clickCategory(null, (0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.numberOfElements, 0, true);
                self.setState({
                    activeTab: 0
                });
            } else {
                if (history.state.type == "clickCategory") {
                    const category = history.state.cat;
                    self.setState({
                        activeTab: 0
                    });
                    self._clickCategory(category, (0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.numberOfElements, 0, true);
                }
                if (history.state.type == "resetCategory") {
                    self._clickCategory(null, (0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.numberOfElements, 0, true);
                    self.setState({
                        activeTab: 0
                    });
                }
                if (history.state.type == "search") {
                    const query = history.state.search.query;
                    const sliderMin = history.state.search.sliderMin;
                    const sliderMax = history.state.search.sliderMax;
                    self._search(query, sliderMin, sliderMax, (0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.numberOfElements, 0, true);
                    self.setState({
                        activeTab: 1
                    });
                    document.getElementById("gallery-explorer-input-search").value = query;
                }
                if (history.state.type == "clickThumb") history.back();
                else self._clickCategory(null, (0, $2860f5f07c24e63c$export$2e2bcd8739ae039).api.numberOfElements, 0, true);
            }
        };
    }
    render() {
        const { slide: slide } = this.state;
        const goPrevSlide = this._changeActiveItem.bind(this, slide - 1);
        const goNextSlide = this._changeActiveItem.bind(this, slide + 1);
        let versionsActive = this.state.multipleActive && !this.state.isSeries;
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        className: "large-8 columns",
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                className: "page-title",
                                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h1", {
                                    children: this.state.title
                                })
                            }),
                            this.state.cmsData.ingress && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                className: "article-excerpt",
                                dangerouslySetInnerHTML: {
                                    __html: this.state.cmsData.ingress
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "row page-section section-gallery-carousel",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        className: "large-12 columns",
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $b174b6a2e4887561$export$2e2bcd8739ae039), {
                            item: this.state.viewItems[slide] || {},
                            viewItems: this.state.viewItems,
                            sourceItems: this.state.sourceItems,
                            slide: slide,
                            prevSlide: [
                                slide > 0,
                                goPrevSlide
                            ],
                            nextSlide: [
                                slide < this.state.viewItems.length - 1,
                                goNextSlide
                            ],
                            changeSlide: this._changeActiveItem,
                            cmsData: this.state.cmsData,
                            searchHasNoHits: this.state.searchHasNoHits,
                            multipleActive: this.state.multipleActive,
                            setVersions: this._setVersions,
                            endVersions: this._endVersions
                        })
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "row page-section section-gallery-explorer",
                    id: "gallery-explorer",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        className: "large-12 columns",
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $39c378db5b87f4a4$export$2e2bcd8739ae039), {
                            items: this.state.sourceItems,
                            search: this._search,
                            clickCategory: this._clickCategory,
                            resetList: this._resetList,
                            cmsData: this.state.cmsData,
                            activeCategory: this.state.currentCategory,
                            activeTab: this.state.activeTab,
                            toggleTab: this._toggleTab,
                            apiCategoryContentError: this.state.apiCategoryContentError,
                            minMax: this.state.minAndMaxYear
                        })
                    })
                }),
                this.state.currentCategory && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $f33a69850a5ce02d$export$2e2bcd8739ae039), {
                    category: this.state.currentCategory,
                    cmsData: this.state.cmsData
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "row page-section section-gallery-grid",
                    id: "gallery-grid",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        className: "large-12 columns",
                        children: this.state.apiSearchError || this.state.apiAllError || this.state.apiCategoryContentError ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h3", {
                            children: this.state.cmsData.noContactText
                        }) : /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                            children: [
                                !!this.state.viewItems.length && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $a232618164564307$export$2e2bcd8739ae039), {
                                    items: this.state.viewItems,
                                    gridItems: this.state.gridItems,
                                    updateSlider: this._setActive,
                                    clickThumb: this._clickThumb,
                                    sortBy: this._sortBy,
                                    showMore: this._showMore,
                                    sortedBy: this._translateSortedBy(this.state.sortedBy),
                                    cmsData: this.state.cmsData,
                                    gridTitle: this.state.gridTitle,
                                    noDateText: this.state.cmsData.noDateText
                                }),
                                !this.state.viewItems.length && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                    className: "gallery-list-info",
                                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h3", {
                                        children: this.state.searchHasNoHits ? this.state.gridTitle : this.state.cmsData.noHitsText
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    className: "row page-section",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        className: "large-8 columns",
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: this.state.cmsData.bottomText
                            }
                        })
                    })
                })
            ]
        });
    }
}
var $180698882f1a5b17$export$2e2bcd8739ae039 = $180698882f1a5b17$var$Nettgalleri;


var $059f25ab365a3ce2$var$mountNode = document.getElementById("nettgalleri-app");
(0, (/*@__PURE__*/$parcel$interopDefault($1c0f1e610963dfb8$exports))).render(/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $180698882f1a5b17$export$2e2bcd8739ae039), {}), $059f25ab365a3ce2$var$mountNode);

})();
//# sourceMappingURL=nettgalleri.js.map
